/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//d17h9cyp9eegq8.cloudfront.net/prod-builds/48.0.0/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 272);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(279);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__combineActions__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAction__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createActions__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createCurriedAction__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handleAction__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handleActions__ = __webpack_require__(360);
/* unused harmony reexport combineActions */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__createAction__["a"]; });
/* unused harmony reexport createActions */
/* unused harmony reexport createCurriedAction */
/* unused harmony reexport handleAction */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__handleActions__["a"]; });








/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(285)();
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSection__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentSection__ = __webpack_require__(411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__ContentSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientAttribution__ = __webpack_require__(207);
/* unused harmony reexport BrandAttribution */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__ClientAttribution__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(62);
/* unused harmony reexport Modal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModerationCard__ = __webpack_require__(508);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__ModerationCard__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_4__ModerationCard__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_4__ModerationCard__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Common__ = __webpack_require__(30);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Common__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__Common__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__Common__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Common__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__Common__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__Common__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__Common__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_5__Common__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_5__Common__["k"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Card__ = __webpack_require__(132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeatureBanner__ = __webpack_require__(532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__FeatureBanner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CollectionItemTransitionProvider__ = __webpack_require__(533);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__CollectionItemTransitionProvider__["a"]; });


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeIrrelevantSSCObservation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return createModels; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ugc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Product__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModerationState__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Observation__ = __webpack_require__(45);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__Product__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Review__ = __webpack_require__(397);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__Review__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Response__ = __webpack_require__(398);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__Response__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Image__ = __webpack_require__(399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Video__ = __webpack_require__(400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__Video__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Question__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__Question__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Answer__ = __webpack_require__(401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__Answer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WhyDidYouBuy__ = __webpack_require__(402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__WhyDidYouBuy__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__Observation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__ModerationState__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__Ugc__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__Ugc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ClientSpecificQuestion__ = __webpack_require__(185);
/* unused harmony reexport ClientSpecificQuestion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Catalog__ = __webpack_require__(58);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_12__Catalog__["a"]; });
// we want to remove the SSC observation
// when a ugc does not have service comments
var removeIrrelevantSSCObservation=function removeIrrelevantSSCObservation(datum){if(!datum.ugc.service_comments){datum.pwr_observations=datum.pwr_observations.filter(function(code){return code!==__WEBPACK_IMPORTED_MODULE_3__Observation__["a" /* default */].ShowServiceComment;});}return datum;};var createModels=function createModels(data,observationsMap){var datum=removeIrrelevantSSCObservation(Array.isArray(data)?data[0]:data);// not all UGC types are returned with subject_ids
datum.ugc.subject_id=datum.subject.subject_id;var ugc=__WEBPACK_IMPORTED_MODULE_0__Ugc__["a" /* default */].createWithData(datum);var ugcId=__WEBPACK_IMPORTED_MODULE_0__Ugc__["a" /* default */].getId(ugc);var subject=__WEBPACK_IMPORTED_MODULE_1__Product__["a" /* default */].createWithData(datum);//TODO create object in saga
var subjectId=datum.subject.subject_id;var moderationState=observationsMap!=null?__WEBPACK_IMPORTED_MODULE_2__ModerationState__["a" /* default */].create(observationsMap,datum):null;return{ugc:ugc,ugcId:ugcId,subject:subject,subjectId:subjectId,moderationState:moderationState};};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(343);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var getTimezoneOffsetInMilliseconds = __webpack_require__(484)
var isDate = __webpack_require__(86)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
    } else {
      var fullTime = timestamp + time
      var fullTimeDate = new Date(fullTime)

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime)
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate)
      if (offsetDiff > 0) {
        offset += offsetDiff
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkIfResponseIsOK;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_errors__ = __webpack_require__(36);
function checkIfResponseIsOK(response){if(!response.ok){var status=response.status,statusText=response.statusText;return Promise.reject(status<500?new __WEBPACK_IMPORTED_MODULE_0_lib_errors__["a" /* ClientError */](statusText,status):new __WEBPACK_IMPORTED_MODULE_0_lib_errors__["d" /* ServerError */](statusText,status));}return response;}

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getEndpointUrl;
var url=__webpack_require__(177);function ensureTrailingSlash(path){if(path.substr(-1)!=='/'){return path+'/';}return path;}function ensureLeadingSlash(path){if(path.charAt(0)!=='/'){return'/'+path;}return path;}function stripTrailingSlash(path){if(path.substr(-1)==='/'){return path.substr(0,path.length-1);}return path;}var HOST=ensureTrailingSlash(Object({"NODE_ENV":"production","PUBLIC_URL":"//d17h9cyp9eegq8.cloudfront.net/prod-builds/48.0.0","REACT_APP_WEGLOT_API_KEY":"wg_3a3c94e641aaf99979e9565c889eccd91","REACT_APP_BUILD_ENV":"prod","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_IMAGE":"visual-answers-image","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_VIDEO":"visual-answers-video"}).REACT_APP_MODERATION_SERVICE||'');function getEndpointUrl(pathname){return url.resolve(HOST,stripTrailingSlash(ensureLeadingSlash(pathname)));}if(false){Object.assign(getEndpointUrl,{ensureTrailingSlash:ensureTrailingSlash});}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Pending */
/* unused harmony export Complete */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncValues; });
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}// export const Pending = Symbol('@async-value/pending');
// export const Complete = Symbol('@async-value/complete');
var Pending='@async-value/pending';var Complete='@async-value/complete';var AsyncValues=function AsyncValues(){_classCallCheck(this,AsyncValues);};AsyncValues.Pending=Pending;AsyncValues.Complete=Complete;/* harmony default export */ __webpack_exports__["b"] = (AsyncValues);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["d"]; });
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* unused harmony reexport spawn */
/* unused harmony reexport join */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["i"]; });
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__ = __webpack_require__(339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["b"]; });
/* unused harmony reexport throttle */




/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_errors__ = __webpack_require__(36);
/* harmony default export */ __webpack_exports__["a"] = (function(promiseFn){return function(){return promiseFn.apply(undefined,arguments).catch(function(err){return Promise.reject(__WEBPACK_IMPORTED_MODULE_0_lib_errors__["e" /* default */].isHttpError(err)?err:new __WEBPACK_IMPORTED_MODULE_0_lib_errors__["c" /* NetworkingError */]());});};});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(312);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(159);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(318);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(320);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(322);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(105);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(326);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(328);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(330);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(331);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(332);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserGeneratedTextHighlighter; });
/* harmony export (immutable) */ __webpack_exports__["b"] = UserGeneratedTextContainer;
/* harmony export (immutable) */ __webpack_exports__["c"] = stripWarningTags;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer_scss__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tokenizer=/(<WARNING>.+?<\/WARNING>)/g;var capturer=/<WARNING>(.+?)<\/WARNING>/;var Warning=function Warning(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer_scss___default.a.userGeneratedTextWarning},props.text);};var DefaultUserGeneratedTextSpanProps={className:__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer_scss___default.a.userGeneratedText+' lh-copy'};var UserGeneratedText=function UserGeneratedText(props){var dataKey=props['data-key'],text=props.text;var spanProps=dataKey==null?DefaultUserGeneratedTextSpanProps:Object.assign({},DefaultUserGeneratedTextSpanProps,{'data-key':dataKey});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',spanProps,text);};var UserGeneratedTextHighlighter=function(_React$Component){_inherits(UserGeneratedTextHighlighter,_React$Component);function UserGeneratedTextHighlighter(){_classCallCheck(this,UserGeneratedTextHighlighter);return _possibleConstructorReturn(this,(UserGeneratedTextHighlighter.__proto__||Object.getPrototypeOf(UserGeneratedTextHighlighter)).apply(this,arguments));}_createClass(UserGeneratedTextHighlighter,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer_scss___default.a.userGeneratedTextHighlighter},this.props.children);}}]);return UserGeneratedTextHighlighter;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function UserGeneratedTextContainer(_ref){var text=_ref.text,dataKey=_ref['data-key'];var wrappedText=text.split(tokenizer).map(function(token,index){var match=capturer.exec(token);return match!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warning,{key:token+'-'+index,text:match[1]}):token;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UserGeneratedText,{'data-key':dataKey,text:wrappedText});}function stripWarningTags(str){return str.replace(/<\/*WARNING>+/g,'');}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientContext; });
/* harmony export (immutable) */ __webpack_exports__["b"] = RequireClientSelection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_async_value__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientSelectMenu__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clientsActions__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__catalogActions__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ClientFromUrl__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__saga__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducer__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}Object(__WEBPACK_IMPORTED_MODULE_11_store__["c" /* injectSaga */])(__WEBPACK_IMPORTED_MODULE_9__saga__["a" /* default */]);Object(__WEBPACK_IMPORTED_MODULE_11_store__["b" /* injectReducer */])(__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* default */]);// $FlowFixMe
var ClientContext=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);var ClientProvider=function(_React$Component){_inherits(ClientProvider,_React$Component);function ClientProvider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientProvider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientProvider.__proto__||Object.getPrototypeOf(ClientProvider)).call.apply(_ref,[this].concat(args))),_this),_this.state={clientProps:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientProvider,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.clients){this.props.fetchClients(this.props.clientId);}}},{key:'render',value:function render(){var _props=this.props,clients=_props.clients,children=_props.children;if(!Array.isArray(clients)){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],{message:'Fetching available Merchant Groups...'});}if(clients instanceof Error){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],{message:'Could not load Merchant Groups'});}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClientContext.Provider,{value:this.state.clientProps},children);}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps){var clientId=nextProps.clientId,catalogId=nextProps.catalogId,userProfiles=nextProps.userProfiles,expertUserProfiles=nextProps.expertUserProfiles,alertConfigs=nextProps.alertConfigs,properties=nextProps.properties,catalogs=nextProps.catalogs,clients=nextProps.clients,selectClientCatalog=nextProps.selectClientCatalog;var clientProps=nextProps.clientId!=null?{clientId:clientId,catalogId:catalogId,userProfiles:userProfiles,expertUserProfiles:expertUserProfiles,alertConfigs:alertConfigs,properties:properties,catalogs:catalogs,clients:clients,selectClientCatalog:selectClientCatalog}:null;return{clientProps:clientProps};}}]);return ClientProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function RequireClientSelection(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'pt2 center',style:{width:'30rem'}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h2',{className:'normal sans-serif f4 gray mb2'},'Select a Merchant Group to Continue'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ClientSelectMenu__["a" /* default */],{hideButton:true}));}var ConnectedClientProvider=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){var clientId=state.clients.currentClient;var properties=__WEBPACK_IMPORTED_MODULE_4_lib_async_value__["b" /* default */].Pending;if(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"].isMap(state.clientProperties)){properties=state.clientProperties;}else if(state.clientProperties instanceof Error){properties=state.clientProperties;}return{clientId:clientId,properties:properties,catalogId:state.clientCatalogs.currentCatalog,userProfiles:state.clientUserProfiles,expertUserProfiles:state.clientExpertUserProfiles,alertConfigs:state.clientModerationAlertConfig,catalogs:state.clientCatalogs.catalogs,clients:state.clients.clients};},{fetchClients:__WEBPACK_IMPORTED_MODULE_6__clientsActions__["a" /* fetchClients */],selectClientCatalog:__WEBPACK_IMPORTED_MODULE_7__catalogActions__["b" /* selectClientCatalog */]})(ClientProvider);/* harmony default export */ __webpack_exports__["c"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ClientFromUrl__["a" /* default */],null,function(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ConnectedClientProvider,props);});});

/***/ }),
/* 21 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateObservations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updateSiteStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return receiveSiteStatusUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return commitSiteStatusUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return commitObservationsUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return requestObservationsUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return receiveObservationsUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return requestAddResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return receiveAddResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return requestDeleteResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return receiveDeleteResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return requestEditResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return receiveEditResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateUgc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return removeUgc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models__ = __webpack_require__(5);
var addItem=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CORE_DATA_ADD_ITEM',function(payload){return payload;});var addItems=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CORE_DATA_ADD_ITEMS',function(payload){return payload;});var observationsPayloadCreator=function observationsPayloadCreator(payload){return payload;};var updateObservations=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_OBSERVATIONS',function(payload){return payload;},// $FlowFixMe
function(_,meta){return meta;});var updateSiteStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@coreData/update-site-status',function(payload){return payload;},function(_,meta){return meta;});var receiveSiteStatusUpdate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@coreData/receive-site-status',// $FlowFixMe
function(payload){return payload;},function(_,ugcId){return ugcId;});var commitSiteStatusUpdate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@coreData/commit-site-status',function(payload){return payload;},function(_,meta){return meta;});var commitObservationsUpdate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('COMMIT_OBSERVATION_UPDATE',observationsPayloadCreator,function(_,clientId){return clientId;});var requestObservationsUpdate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REQUEST_OBSERVATIONS_UPDATE',function(payload,_){return payload;},function(_,context){return context;});var receiveObservationsUpdate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_OBSERVATIONS_UPDATE',function(payload){return payload;},function(_,ugcId){return ugcId;});var requestAddResponse=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ADD_RESPONSE_REQUEST',function(payload){return payload;},function(_,parent_ugc_id){return parent_ugc_id;});var receiveAddResponse=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ADD_RESPONSE',function(payload){return payload;},function(_,parent_ugc_id){return parent_ugc_id;});var requestDeleteResponse=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('DELETE_RESPONSE_REQUEST',function(payload){return payload;},function(_,parent_ugc_id){return parent_ugc_id;});var receiveDeleteResponse=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('DELETE_RESPONSE',function(payload){return payload;},function(_,parent_ugc_id){return parent_ugc_id;});var requestEditResponse=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('EDIT_RESPONSE_REQUEST',function(payload){return payload;},function(_,parent_ugc_id){return parent_ugc_id;});var receiveEditResponse=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('EDIT_RESPONSE',// $FlowFixMe Error: redux-actions requires another parameter
function(payload){return payload;},function(_,parent_ugc_id){return parent_ugc_id;});var updateUgc=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc/update-ugc',function(payload){return payload;},function(_,ugcId){return ugcId;});var removeUgc=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc/remove-ugc',function(payload){return payload;});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return injectReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return injectSaga; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__saga__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
var sagaMiddleware=Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["a" /* default */])();var loggerMiddleware=Object(__WEBPACK_IMPORTED_MODULE_2_redux_logger__["createLogger"])({collapsed:true,stateTransformer:function stateTransformer(state){var newState={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.keys(state)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var i=_step.value;if(__WEBPACK_IMPORTED_MODULE_5_immutable__["Iterable"].isIterable(state[i])){newState[i]=state[i].toJS();}else{newState[i]=state[i];}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return newState;}});var enhancers=[Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(sagaMiddleware)];if(false){enhancers.push(applyMiddleware(loggerMiddleware));}if(window.devToolsExtension){enhancers.push(window.devToolsExtension());}var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_4__reducer__["a" /* createReducer */])(),__WEBPACK_IMPORTED_MODULE_4__reducer__["b" /* initialState */],__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */].apply(undefined,enhancers));store.asyncReducers={};sagaMiddleware.run(__WEBPACK_IMPORTED_MODULE_3__saga__["a" /* default */]);var injectReducer=function injectReducer(){var reducers=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};store.asyncReducers=Object.assign({},store.asyncReducers,reducers);store.replaceReducer(Object(__WEBPACK_IMPORTED_MODULE_4__reducer__["a" /* createReducer */])(store.asyncReducers));};var injectSaga=function injectSaga(saga){sagaMiddleware.run(saga);};/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectObservationMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boundedDelay; });
var selectToken=function selectToken(_ref){var auth=_ref.auth;return auth.token;};var selectObservationMap=function selectObservationMap(_ref2){var observationsMap=_ref2.appConfig.observationsMap;return observationsMap;};var boundedDelay=function boundedDelay(elapsed){var limit=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1000;return Math.max(Math.abs(Date.now()-elapsed-limit),0);};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(579);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchForm__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_forms_config__ = __webpack_require__(240);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__config_forms_config__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__config_forms_config__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__config_forms_config__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__config_forms_config__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__config_forms_config__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__config_forms_config__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__config_forms_config__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__config_forms_config__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__config_forms_config__["j"]; });


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receiveAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return regenerateToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
var login=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('LOGIN_REQUEST',function(payload){return payload;});var logout=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('LOGOUT');var receiveAuth=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('LOGIN_RESPONSE',function(payload){return payload;});var regenerateToken=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REGENERATE',function(clientId){return clientId;});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(181);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CoreDataState; });
/* unused harmony export processItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coreDataActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_async_value__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_async_value__ = __webpack_require__(12);
var _handleActions;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultCoreDataRecordShape={ugcs:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),subjects:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),moderationStates:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),observationRequestStatus:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),responseRequestStatus:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),deleteResponseRequestStatus:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),subjectIdByUgcId:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),pendingSiteStatus:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()};var CoreDataState=function(_Record){_inherits(CoreDataState,_Record);function CoreDataState(){_classCallCheck(this,CoreDataState);return _possibleConstructorReturn(this,(CoreDataState.__proto__||Object.getPrototypeOf(CoreDataState)).apply(this,arguments));}_createClass(CoreDataState,null,[{key:'getTheThings',value:function getTheThings(state){var ugcId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:-1;var ugc=state.getIn(['ugcs',ugcId]);var moderationState=state.getIn(['moderationStates',ugcId]);var subjectId=state.getIn(['subjectIdByUgcId',ugcId]);var subject=subjectId?state.getIn(['subjects',subjectId]):undefined;var observationRequestStatus=state.getIn(['observationRequestStatus',ugcId]);var responseRequestStatus=state.getIn(['responseRequestStatus',ugcId]);var deleteResponseRequestStatus=state.getIn(['deleteResponseRequestStatus',ugcId]);var pendingSiteStatus=state.getIn(['pendingSiteStatus',ugcId]);if(!ugc||!moderationState||!subject)return undefined;return{ugc:ugc,moderationState:moderationState,subject:subject,observationRequestStatus:observationRequestStatus,responseRequestStatus:responseRequestStatus,deleteResponseRequestStatus:deleteResponseRequestStatus,pendingSiteStatus:pendingSiteStatus};}},{key:'removeUgc',value:function removeUgc(state,ugcId){var remove=function remove(collection){return collection.remove(ugcId);};var ugcs=state.ugcs,moderationStates=state.moderationStates,observationRequestStatus=state.observationRequestStatus,subjectIdByUgcId=state.subjectIdByUgcId,deleteResponseRequestStatus=state.deleteResponseRequestStatus,responseRequestStatus=state.responseRequestStatus,pendingSiteStatus=state.pendingSiteStatus;return state.merge({ugcs:remove(ugcs),moderationStates:remove(moderationStates),observationRequestStatus:remove(observationRequestStatus),subjectIdByUgcId:remove(subjectIdByUgcId),deleteResponseRequestStatus:remove(deleteResponseRequestStatus),responseRequestStatus:remove(responseRequestStatus),pendingSiteStatus:remove(pendingSiteStatus)});}}]);return CoreDataState;}(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Record"])(defaultCoreDataRecordShape));var defaultCoreDataState=new CoreDataState();function processItem(payload){var _createModels=Object(__WEBPACK_IMPORTED_MODULE_2_models__["n" /* createModels */])(payload.data,payload.observationsMap),ugc=_createModels.ugc,subject=_createModels.subject,moderationState=_createModels.moderationState,ugcId=_createModels.ugcId,subjectId=_createModels.subjectId;return[[['ugcs',ugcId],ugc],[['subjects',subjectId],subject],[['moderationStates',ugcId],moderationState],[['subjectIdByUgcId',ugcId],subjectId]];}/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["a" /* addItem */].toString(),function(state,action){var setInArgumentList=processItem(action.payload);return state.withMutations(function(state){setInArgumentList.forEach(function(args){return state.setIn.apply(state,_toConsumableArray(args));});});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["b" /* addItems */].toString(),function(state,action){var _action$payload=action.payload,observationsMap=_action$payload.observationsMap,items=_action$payload.data.items;var setInArgumentList=items.reduce(function(acc,item){return acc.concat(processItem({data:item,observationsMap:observationsMap}));},[]);return state.withMutations(function(state){setInArgumentList.forEach(function(args){return state.setIn.apply(state,_toConsumableArray(args));});});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["q" /* updateUgc */].toString(),function(state,action){var propsOrUpdater=action.payload,ugcId=action.meta;var updateFn=typeof propsOrUpdater==='function'?propsOrUpdater:function(ugc){return ugc.merge(propsOrUpdater);};return state.updateIn(['ugcs',ugcId],updateFn);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["j" /* removeUgc */].toString(),function(state,action){var ugcId=action.payload;return CoreDataState.removeUgc(state,ugcId);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["o" /* updateObservations */].toString(),function(state,action){return state.setIn(['moderationStates',action.payload.getUGCId()],action.payload);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["c" /* commitObservationsUpdate */].toString(),function(state,action){return state.withMutations(function(state){var ugcId=action.payload.getUGCId();state.setIn(['moderationStates',ugcId],action.payload);state.deleteIn(['observationRequestStatus',ugcId]);var published=__WEBPACK_IMPORTED_MODULE_2_models__["d" /* ModerationState */].isSavedPublished(action.payload,action.meta);state.setIn(['ugcs',ugcId,'published'],published);});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["p" /* updateSiteStatus */].toString(),function(state,action){var moderationState=action.payload.moderationState;var ugcId=moderationState.getUGCId();return state.setIn(['pendingSiteStatus',ugcId],__WEBPACK_IMPORTED_MODULE_5__lib_async_value__["a" /* AsyncValues */].Pending);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["i" /* receiveSiteStatusUpdate */].toString(),function(state,action){var error=action.error,payload=action.payload,ugcId=action.meta;return error===true?state.setIn(['pendingSiteStatus',ugcId],payload):state.removeIn(['pendingSiteStatus',ugcId]);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["d" /* commitSiteStatusUpdate */].toString(),function(state,action){var ugcId=action.meta;return state.removeIn(['pendingSiteStatus',ugcId]);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["n" /* requestObservationsUpdate */].toString(),function(state,action){return state.setIn(['observationRequestStatus',action.payload.getUGCId()],'pending');}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["h" /* receiveObservationsUpdate */].toString(),{next:function next(state,action){return state.setIn(['observationRequestStatus',action.payload],'complete');},throw:function _throw(state,action){return state.setIn(['observationRequestStatus',action.meta],action.payload);}}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["k" /* requestAddResponse */].toString(),function(state,action){return state.setIn(['responseRequestStatus',action.meta],'pending');}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["e" /* receiveAddResponse */].toString(),{next:function next(state,action){var parentUgcId=action.meta,childUgc=action.payload;return state.updateIn(['ugcs',parentUgcId,'ugc_related_content'],function(v){return v.push(childUgc);}).deleteIn(['responseRequestStatus',parentUgcId]);},throw:function _throw(state,action){return state.setIn(['responseRequestStatus',action.meta],action.payload);}}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["l" /* requestDeleteResponse */].toString(),function(state,action){return state.setIn(['deleteResponseRequestStatus',action.meta],'pending');}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["f" /* receiveDeleteResponse */].toString(),function(state,action){var parentUgcId=action.meta,payload=action.payload;if(action.error===true){return state.setIn(['deleteResponseRequestStatus',parentUgcId],payload);}// simulate deletion by removing the merchant response
return state.updateIn(['ugcs',parentUgcId,'ugc_related_content'],function(v){var index=v.findIndex(function(ugc){return ugc.ugctype==='MerchantResponse';});return index>-1?v.remove(index):v;}).deleteIn(['deleteResponseRequestStatus',parentUgcId]);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["m" /* requestEditResponse */].toString(),function(state,action){return state.setIn(['responseRequestStatus',action.meta],'pending');}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__coreDataActions__["g" /* receiveEditResponse */].toString(),{next:function next(state,action){var parentUgcId=action.meta,updatedChildUgc=action.payload;return state.updateIn(['ugcs',parentUgcId,'ugc_related_content'],function(v){return v.map(function(ugc){return ugc.ugc_id===updatedChildUgc.ugc_id?updatedChildUgc:ugc;});}).deleteIn(['responseRequestStatus',parentUgcId]);},throw:function _throw(state,action){return state.setIn(['responseRequestStatus',action.meta],action.payload);}}),_handleActions),defaultCoreDataState));

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CloseIcon__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__CloseIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__Loader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ObservationButton__ = __webpack_require__(421);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__ObservationButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmitButton__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__SubmitButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmptyCard__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__EmptyCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Breadcrumbs__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__Breadcrumbs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Select__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__Select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ResponseTextBox__ = __webpack_require__(456);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__ResponseTextBox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AutoHide__ = __webpack_require__(458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__AutoHide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ButtonGroup__ = __webpack_require__(460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__ButtonGroup__["a"]; });
/* unused harmony namespace reexport */


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["j"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["g"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* harmony export (immutable) */ __webpack_exports__["h"] = race;
/* harmony export (immutable) */ __webpack_exports__["d"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["f"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["e"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["i"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(18);


var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

var _interopRequireWildcard = __webpack_require__(63);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_VisibleCellRange = exports.bpfrpt_proptype_Alignment = exports.bpfrpt_proptype_OverscanIndicesGetter = exports.bpfrpt_proptype_OverscanIndices = exports.bpfrpt_proptype_OverscanIndicesGetterParams = exports.bpfrpt_proptype_RenderedSection = exports.bpfrpt_proptype_ScrollbarPresenceChange = exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_NoContentRenderer = exports.bpfrpt_proptype_CellSize = exports.bpfrpt_proptype_CellSizeGetter = exports.bpfrpt_proptype_CellRangeRenderer = exports.bpfrpt_proptype_CellRangeRendererParams = exports.bpfrpt_proptype_StyleCache = exports.bpfrpt_proptype_CellCache = exports.bpfrpt_proptype_CellRenderer = exports.bpfrpt_proptype_CellRendererParams = exports.bpfrpt_proptype_CellPosition = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _ScalingCellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(126));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var bpfrpt_proptype_CellPosition =  true ? null : {
  "columnIndex": _propTypes["default"].number.isRequired,
  "rowIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_CellPosition = bpfrpt_proptype_CellPosition;
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  "columnIndex": _propTypes["default"].number.isRequired,
  "isScrolling": _propTypes["default"].bool.isRequired,
  "isVisible": _propTypes["default"].bool.isRequired,
  "key": _propTypes["default"].string.isRequired,
  "parent": _propTypes["default"].object.isRequired,
  "rowIndex": _propTypes["default"].number.isRequired,
  "style": _propTypes["default"].object.isRequired
};
exports.bpfrpt_proptype_CellRendererParams = bpfrpt_proptype_CellRendererParams;
var bpfrpt_proptype_CellRenderer =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_CellRenderer = bpfrpt_proptype_CellRenderer;
var bpfrpt_proptype_CellCache =  true ? null : _propTypes["default"].objectOf(_propTypes["default"].node.isRequired);
exports.bpfrpt_proptype_CellCache = bpfrpt_proptype_CellCache;
var bpfrpt_proptype_StyleCache =  true ? null : _propTypes["default"].objectOf(_propTypes["default"].object.isRequired);
exports.bpfrpt_proptype_StyleCache = bpfrpt_proptype_StyleCache;
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : {
  "cellCache": _propTypes["default"].objectOf(_propTypes["default"].node.isRequired).isRequired,
  "cellRenderer": _propTypes["default"].func.isRequired,
  "columnSizeAndPositionManager": function columnSizeAndPositionManager() {
    return (typeof _ScalingCellSizeAndPositionManager["default"] === "function" ? _propTypes["default"].instanceOf(_ScalingCellSizeAndPositionManager["default"]).isRequired : _propTypes["default"].any.isRequired).apply(this, arguments);
  },
  "columnStartIndex": _propTypes["default"].number.isRequired,
  "columnStopIndex": _propTypes["default"].number.isRequired,
  "deferredMeasurementCache": _propTypes["default"].object,
  "horizontalOffsetAdjustment": _propTypes["default"].number.isRequired,
  "isScrolling": _propTypes["default"].bool.isRequired,
  "isScrollingOptOut": _propTypes["default"].bool.isRequired,
  "parent": _propTypes["default"].object.isRequired,
  "rowSizeAndPositionManager": function rowSizeAndPositionManager() {
    return (typeof _ScalingCellSizeAndPositionManager["default"] === "function" ? _propTypes["default"].instanceOf(_ScalingCellSizeAndPositionManager["default"]).isRequired : _propTypes["default"].any.isRequired).apply(this, arguments);
  },
  "rowStartIndex": _propTypes["default"].number.isRequired,
  "rowStopIndex": _propTypes["default"].number.isRequired,
  "scrollLeft": _propTypes["default"].number.isRequired,
  "scrollTop": _propTypes["default"].number.isRequired,
  "styleCache": _propTypes["default"].objectOf(_propTypes["default"].object.isRequired).isRequired,
  "verticalOffsetAdjustment": _propTypes["default"].number.isRequired,
  "visibleColumnIndices": _propTypes["default"].object.isRequired,
  "visibleRowIndices": _propTypes["default"].object.isRequired
};
exports.bpfrpt_proptype_CellRangeRendererParams = bpfrpt_proptype_CellRangeRendererParams;
var bpfrpt_proptype_CellRangeRenderer =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_CellRangeRenderer = bpfrpt_proptype_CellRangeRenderer;
var bpfrpt_proptype_CellSizeGetter =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_CellSizeGetter = bpfrpt_proptype_CellSizeGetter;
var bpfrpt_proptype_CellSize =  true ? null : _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].number]);
exports.bpfrpt_proptype_CellSize = bpfrpt_proptype_CellSize;
var bpfrpt_proptype_NoContentRenderer =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_NoContentRenderer = bpfrpt_proptype_NoContentRenderer;
var bpfrpt_proptype_Scroll =  true ? null : {
  "clientHeight": _propTypes["default"].number.isRequired,
  "clientWidth": _propTypes["default"].number.isRequired,
  "scrollHeight": _propTypes["default"].number.isRequired,
  "scrollLeft": _propTypes["default"].number.isRequired,
  "scrollTop": _propTypes["default"].number.isRequired,
  "scrollWidth": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : {
  "horizontal": _propTypes["default"].bool.isRequired,
  "vertical": _propTypes["default"].bool.isRequired,
  "size": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_ScrollbarPresenceChange = bpfrpt_proptype_ScrollbarPresenceChange;
var bpfrpt_proptype_RenderedSection =  true ? null : {
  "columnOverscanStartIndex": _propTypes["default"].number.isRequired,
  "columnOverscanStopIndex": _propTypes["default"].number.isRequired,
  "columnStartIndex": _propTypes["default"].number.isRequired,
  "columnStopIndex": _propTypes["default"].number.isRequired,
  "rowOverscanStartIndex": _propTypes["default"].number.isRequired,
  "rowOverscanStopIndex": _propTypes["default"].number.isRequired,
  "rowStartIndex": _propTypes["default"].number.isRequired,
  "rowStopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_RenderedSection = bpfrpt_proptype_RenderedSection;
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  "direction": _propTypes["default"].oneOf(["horizontal", "vertical"]).isRequired,
  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  "scrollDirection": _propTypes["default"].oneOf([-1, 1]).isRequired,
  // Number of rows or columns in the current axis
  "cellCount": _propTypes["default"].number.isRequired,
  // Maximum number of cells to over-render in either direction
  "overscanCellsCount": _propTypes["default"].number.isRequired,
  // Begin of range of visible cells
  "startIndex": _propTypes["default"].number.isRequired,
  // End of range of visible cells
  "stopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_OverscanIndicesGetterParams = bpfrpt_proptype_OverscanIndicesGetterParams;
var bpfrpt_proptype_OverscanIndices =  true ? null : {
  "overscanStartIndex": _propTypes["default"].number.isRequired,
  "overscanStopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_OverscanIndices = bpfrpt_proptype_OverscanIndices;
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_OverscanIndicesGetter = bpfrpt_proptype_OverscanIndicesGetter;
var bpfrpt_proptype_Alignment =  true ? null : _propTypes["default"].oneOf(["auto", "end", "start", "center"]);
exports.bpfrpt_proptype_Alignment = bpfrpt_proptype_Alignment;
var bpfrpt_proptype_VisibleCellRange =  true ? null : {
  "start": _propTypes["default"].number,
  "stop": _propTypes["default"].number
};
exports.bpfrpt_proptype_VisibleCellRange = bpfrpt_proptype_VisibleCellRange;

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(165);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(43);
/* unused harmony reexport END */
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(74);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(167);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(18);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["j"]; });
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(33);
/* unused harmony reexport detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(340);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Errors__ = __webpack_require__(178);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Errors__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Errors__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Errors__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Errors__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Errors__["e"]; });


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(191);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arrayFind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return asArray; });
var toArray = function toArray(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; ++i) {
    ret[i] = a[i];
  }
  return ret;
};

var arrayFind = function arrayFind(array, search) {
  return array.filter(function (a) {
    return a === search;
  })[0];
};

var asArray = function asArray(a) {
  return Array.isArray(a) ? a : [a];
};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthContext; });
/* harmony export (immutable) */ __webpack_exports__["b"] = redirectToAuthService;
/* harmony export (immutable) */ __webpack_exports__["d"] = withAuthError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthState__ = __webpack_require__(120);
// $FlowFixMe
var AuthContext=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](new __WEBPACK_IMPORTED_MODULE_1__AuthState__["a" /* default */]());function redirectToAuthService(){var authServiceUrl='https://'+(""||'')+'auth.powerreviews.com';var currentHref=encodeURIComponent(window.location.href);window.location.replace(authServiceUrl+'?continue_to='+currentHref);}function withAuthError(fn){return function(){return fn.apply(undefined,arguments).catch(function(err){if(err.status&&err.status===401){redirectToAuthService();}throw err;});};}var useAuth=function useAuth(){// $FlowIssue
return __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](AuthContext);};

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(316);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(164);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = _callee;
/* unused harmony export publicationDecisionSaga */
/* harmony export (immutable) */ __webpack_exports__["a"] = addItemTask;
/* harmony export (immutable) */ __webpack_exports__["b"] = addItemsTask;
/* unused harmony export postObservationsSaga */
/* unused harmony export respondTask */
/* unused harmony export deleteResponseTask */
/* unused harmony export editResponseTask */
/* unused harmony export responseSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coreDataActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SagaUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lib_async_value__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__coreDataApi__ = __webpack_require__(81);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(_callee),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(publicationDecisionSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(siteStatusSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addItemTask),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addItemsTask),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postObservationsSaga),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(respondTask),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteResponseTask),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(editResponseTask),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(responseSaga);// import Ugc from 'models/Ugc';
function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(responseSaga);case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["n" /* requestObservationsUpdate */],postObservationsSaga);case 4:_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["o" /* updateObservations */],publicationDecisionSaga);case 6:_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["p" /* updateSiteStatus */],siteStatusSaga);case 8:case'end':return _context.stop();}}},_marked,this);}function publicationDecisionSaga(action){var moderationState,_action$meta,clientId,ugctype,ugcClientId,ugcId,token,observations,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function publicationDecisionSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(action.meta==null)){_context2.next=2;break;}return _context2.abrupt('return');case 2:moderationState=action.payload,_action$meta=action.meta,clientId=_action$meta.clientId,ugctype=_action$meta.ugctype,ugcClientId=_action$meta.ugcClientId;ugcId=moderationState.getUGCId();_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["o" /* updateObservations */])(__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].setCurrentPublished(moderationState,__WEBPACK_IMPORTED_MODULE_8_lib_async_value__["b" /* default */].Pending)));case 6:_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["c" /* selectToken */]);case 8:token=_context2.sent;observations=getObservationsForPublication(moderationState,clientId,ugcId);_context2.prev=10;_context2.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_9__coreDataApi__["d" /* publicationDecision */],token,{clientId:clientId,ugcClientId:ugcClientId,ugctype:ugctype,observations:observations});case 13:response=_context2.sent;_context2.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["o" /* updateObservations */])(__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].setCurrentPublished(moderationState,response)));case 16:_context2.next=22;break;case 18:_context2.prev=18;_context2.t0=_context2['catch'](10);_context2.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["o" /* updateObservations */])(__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].setCurrentPublished(moderationState,_context2.t0)));case 22:case'end':return _context2.stop();}}},_marked2,this,[[10,18]]);}// when a user changes the site status we first check if simply removing an override
// will satisfy the desired publication status
// if it does we post the observations
// if it does NOT we add the override ant then post the observations
function siteStatusSaga(action){var _action$payload,moderationState,desiredPublished,meta,clientId,ugcId,moderationStateWithoutOverrides,observationToAdd,hasNoOverrides,nextModerationState,_ref,error,payload,token,currentPublished,_nextModerationState,_ref2,_error,_payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function siteStatusSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_action$payload=action.payload,moderationState=_action$payload.moderationState,desiredPublished=_action$payload.desiredPublished,meta=action.meta,clientId=action.meta.clientId;ugcId=moderationState.getUGCId();// there should only be one publication override
moderationStateWithoutOverrides=__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].clearPublicationOverrides(moderationState,clientId);observationToAdd=desiredPublished?__WEBPACK_IMPORTED_MODULE_5_models__["e" /* Observation */].PublicationOverrideCode:__WEBPACK_IMPORTED_MODULE_5_models__["e" /* Observation */].NotForPublicationOverrideCode;hasNoOverrides=moderationStateWithoutOverrides===moderationState;// there were no overrides so we need to check if simply removing the override
// satifies the desired publication status
// if it does post the update
// if it does NOT add the override and post the update
_context3.prev=5;if(!hasNoOverrides){_context3.next=23;break;}nextModerationState=moderationStateWithoutOverrides.withMutations(function(s){__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].setObservation(s,clientId,observationToAdd);__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].applyClientModeration(s,clientId);__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].setCurrentPublished(s,desiredPublished);});_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["n" /* requestObservationsUpdate */])(nextModerationState,clientId));case 10:_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["h" /* receiveObservationsUpdate */]);case 12:_ref=_context3.sent;error=_ref.error;payload=_ref.payload;if(error){_context3.next=20;break;}_context3.next=18;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["d" /* commitSiteStatusUpdate */])(desiredPublished,ugcId));case 18:_context3.next=21;break;case 20:throw payload;case 21:_context3.next=43;break;case 23:_context3.next=25;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["c" /* selectToken */]);case 25:token=_context3.sent;_context3.next=28;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_9__coreDataApi__["d" /* publicationDecision */],token,Object.assign({},meta,{observations:getObservationsForPublication(moderationStateWithoutOverrides,clientId,ugcId)}));case 28:currentPublished=_context3.sent;_nextModerationState=moderationStateWithoutOverrides.withMutations(function(s){if(currentPublished!==desiredPublished){__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].setObservation(s,clientId,observationToAdd);}__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].applyClientModeration(s,clientId);__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].setCurrentPublished(s,desiredPublished);});_context3.next=32;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["n" /* requestObservationsUpdate */])(_nextModerationState,clientId));case 32:_context3.next=34;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["h" /* receiveObservationsUpdate */]);case 34:_ref2=_context3.sent;_error=_ref2.error;_payload=_ref2.payload;if(_error){_context3.next=42;break;}_context3.next=40;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["d" /* commitSiteStatusUpdate */])(desiredPublished,ugcId));case 40:_context3.next=43;break;case 42:throw _payload;case 43:_context3.next=53;break;case 45:_context3.prev=45;_context3.t0=_context3['catch'](5);_context3.next=49;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["i" /* receiveSiteStatusUpdate */])(_context3.t0,ugcId));case 49:_context3.next=51;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */],2000);case 51:_context3.next=53;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["i" /* receiveSiteStatusUpdate */])(null,ugcId));case 53:case'end':return _context3.stop();}}},_marked3,this,[[5,45]]);}function addItemTask(payload){var data,observationsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addItemTask$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:data=Array.isArray(payload.data)?payload.data[0]:payload.data;if(!(!data||!data.ugc)){_context4.next=3;break;}return _context4.abrupt('return',-1);case 3:_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["b" /* selectObservationMap */]);case 5:observationsMap=_context4.sent;_context4.next=8;return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["a" /* addItem */])(Object.assign({},payload,{observationsMap:observationsMap})));case 8:return _context4.abrupt('return',__WEBPACK_IMPORTED_MODULE_5_models__["j" /* UGC */].getIdFromData(data));case 9:case'end':return _context4.stop();}}},_marked4,this);}function addItemsTask(payload){var data,observationsMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addItemsTask$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:data=payload.data;if(!(data.items.length===0)){_context5.next=3;break;}return _context5.abrupt('return',data);case 3:_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["b" /* selectObservationMap */]);case 5:observationsMap=_context5.sent;_context5.next=8;return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["b" /* addItems */])(Object.assign({},payload,{observationsMap:observationsMap})));case 8:return _context5.abrupt('return',Object.assign({},data,{items:data.items.map(function(item){return __WEBPACK_IMPORTED_MODULE_5_models__["j" /* UGC */].getIdFromData(item);})}));case 9:case'end':return _context5.stop();}}},_marked5,this);}function postObservationsSaga(action,responseDelay,commitDelay){var moderationState,clientId,ugcId,token,observationData,ts,delayForResponse,delayForCommit,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postObservationsSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:moderationState=action.payload,clientId=action.meta;ugcId=moderationState.getUGCId();_context6.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["c" /* selectToken */]);case 4:token=_context6.sent;if(clientId){_context6.next=9;break;}_context6.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["h" /* receiveObservationsUpdate */])(// $FlowIssue
new Error('A valid Client Id is required to submit observations'),ugcId));case 8:return _context6.abrupt('return');case 9:observationData=__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].createRequestPayload(moderationState,clientId);ts=Date.now();delayForResponse=typeof responseDelay==='number'?responseDelay:Object(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["a" /* boundedDelay */])(ts);delayForCommit=typeof commitDelay==='number'?commitDelay:1000;_context6.prev=13;_context6.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_9__coreDataApi__["b" /* postObservations */],token,{ugcId:ugcId,body:observationData,clientId:clientId});case 16:response=_context6.sent;_context6.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */],delayForResponse);case 19:_context6.next=21;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["h" /* receiveObservationsUpdate */])(ugcId));case 21:_context6.next=23;return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["c" /* commitObservationsUpdate */])(__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].commitObservationBlobs(moderationState,clientId,response),clientId));case 23:_context6.next=25;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */],delayForCommit);case 25:_context6.next=34;break;case 27:_context6.prev=27;_context6.t0=_context6['catch'](13);console.log(_context6.t0);_context6.next=32;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */],delayForResponse);case 32:_context6.next=34;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["h" /* receiveObservationsUpdate */])(_context6.t0,ugcId));case 34:case'end':return _context6.stop();}}},_marked6,this,[[13,27]]);}function respondTask(action){var payload,token,startTs,actionToPut,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function respondTask$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:payload=action.payload;_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["c" /* selectToken */]);case 3:token=_context7.sent;startTs=Date.now();actionToPut=void 0;_context7.prev=6;_context7.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_9__coreDataApi__["c" /* postResponse */],token,payload);case 9:response=_context7.sent;actionToPut=Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["e" /* receiveAddResponse */])(__WEBPACK_IMPORTED_MODULE_5_models__["j" /* UGC */].createWithData({ugc:response}),payload.parent_ugc_id);_context7.next=17;break;case 13:_context7.prev=13;_context7.t0=_context7['catch'](6);console.error(_context7.t0);actionToPut=Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["e" /* receiveAddResponse */])(_context7.t0,payload.parent_ugc_id);case 17:_context7.prev=17;_context7.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */],Object(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["a" /* boundedDelay */])(startTs));case 20:_context7.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(actionToPut);case 22:return _context7.finish(17);case 23:case'end':return _context7.stop();}}},_marked7,this,[[6,13,17,23]]);}function deleteResponseTask(action){var payload,meta,token,startTs,actionToPut;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteResponseTask$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:payload=action.payload,meta=action.meta;_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["c" /* selectToken */]);case 3:token=_context8.sent;startTs=Date.now();actionToPut=void 0;_context8.prev=6;_context8.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_9__coreDataApi__["a" /* deleteUgc */],token,payload);case 9:actionToPut=Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["f" /* receiveDeleteResponse */])(payload,meta);_context8.next=16;break;case 12:_context8.prev=12;_context8.t0=_context8['catch'](6);console.error(_context8.t0);actionToPut=Object(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["f" /* receiveDeleteResponse */])(_context8.t0,meta);case 16:_context8.prev=16;_context8.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */],Object(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["a" /* boundedDelay */])(startTs));case 19:_context8.next=21;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(actionToPut);case 21:return _context8.finish(16);case 22:case'end':return _context8.stop();}}},_marked8,this,[[6,12,16,22]]);}function editResponseTask(action){var payload,parent_ugc_id,token,startTs,actionArgs,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function editResponseTask$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:payload=action.payload,parent_ugc_id=action.meta;_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["c" /* selectToken */]);case 3:token=_context9.sent;startTs=Date.now();actionArgs=[];_context9.prev=6;_context9.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_9__coreDataApi__["e" /* updateResponse */],token,payload);case 9:response=_context9.sent;actionArgs=[__WEBPACK_IMPORTED_MODULE_5_models__["j" /* UGC */].createWithData({ugc:response}),parent_ugc_id];_context9.next=17;break;case 13:_context9.prev=13;_context9.t0=_context9['catch'](6);console.error(_context9.t0);actionArgs=[_context9.t0,parent_ugc_id];case 17:_context9.prev=17;_context9.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */],Object(__WEBPACK_IMPORTED_MODULE_6__SagaUtils__["a" /* boundedDelay */])(startTs));case 20:_context9.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["g" /* receiveEditResponse */].apply(undefined,_toConsumableArray(actionArgs)));case 22:return _context9.finish(17);case 23:case'end':return _context9.stop();}}},_marked9,this,[[6,13,17,23]]);}function responseSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function responseSaga$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["k" /* requestAddResponse */],respondTask);case 2:_context10.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["l" /* requestDeleteResponse */],deleteResponseTask);case 4:_context10.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4__coreDataActions__["m" /* requestEditResponse */],editResponseTask);case 6:case'end':return _context10.stop();}}},_marked10,this);}function getObservationsForPublication(moderationState,clientId,ugcId){return Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["Seq"])([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].getCurrentObservations(moderationState,1).values()),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5_models__["d" /* ModerationState */].getCurrentObservations(moderationState,clientId).values()))).filter(__WEBPACK_IMPORTED_MODULE_5_models__["e" /* Observation */].isSelected).map(function(_ref3){var selected=_ref3.selected,rest=_objectWithoutProperties(_ref3,['selected']);return Object.assign({},rest,{client_id:rest.client_id||clientId,ugc_id:ugcId});}).toArray();}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}// Extending ObservationBlob type
//
// Destructuring type annotations isn't supported in babel-eslint
// due to lack of support in babylon@6.x.x (https://github.com/babel/babel-eslint/issues/443)
// We ignore the type def, and use flow comment type def syntax
// we also instruct prettier to ignore this line since it strips flow comments type, shit
/* eslint-disable */// prettier-ignore
/* eslint-enable */var Observation=function(){function Observation(data){_classCallCheck(this,Observation);this.observation_id='';this.observation_type_code='';this.catalog_id=-1;this.client_id=-1;this.ugc_id=-1;this.user_data={user_id:-1,name:'',email:''};this.observation_data={comments:''};this.created_date='';this.updated_date='';this.selected=false;this.custom_observation=false;var _=this;_.name=data.name;_.ugc_id=data.ugc_id||-1;_.observation_type_code=data.observation_type_code;_.observation_id=data.observation_id;_.catalog_id=data.catalog_id;_.client_id=data.client_id;_.user_data=data.user_data;_.observation_data=data.observation_data;_.created_date=data.created_date;_.updated_date=data.updated_date;_.selected=data.selected;_.custom_observation=data.custom_observation||false;}_createClass(Observation,[{key:'equals',value:function equals(other){return this.name===other.name&&this.ugc_id===other.ugc_id&&this.observation_type_code===other.observation_type_code&&this.selected===other.selected&&this.client_id===other.client_id&&this.catalog_id===other.catalog_id;}},{key:'isSelected',value:function isSelected(){return this.selected;}}],[{key:'createWithData',value:function createWithData(data){var selected=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return new Observation(Object.assign({},data,{selected:selected}));}},{key:'select',value:function select(observation){return new Observation(Object.assign({},observation,{selected:true}));}},{key:'deselect',value:function deselect(observation){return new Observation(Object.assign({},observation,{selected:false}));}},{key:'toggle',value:function toggle(observation){return new Observation(Object.assign({},observation,{selected:!observation.selected}));}},{key:'isSelected',value:function isSelected(observation){return observation.selected;}},{key:'wasMadeByPowerReviews',value:function wasMadeByPowerReviews(observation){var _observation$client_i=observation.client_id,client_id=_observation$client_i===undefined?null:_observation$client_i;return Number(client_id)===1;}},{key:'wasMadeByClient',value:function wasMadeByClient(observation){return!Observation.wasMadeByPowerReviews(observation);}},{key:'addComments',value:function addComments(observation,comments){return new Observation(Object.assign({},observation,{observation_data:{comments:comments}}));}// special observations
}]);return Observation;}();Observation.Contradict='CC';Observation.RetailComp='CR';Observation.Copyright='CV';Observation.Duplicate='DC';Observation.Fraud='FRD';Observation.Legal='LC';Observation.Irrelevant='NR';Observation.PII='PII';Observation.Profane='PIM';Observation.Price='PR';Observation.SafetyAlert='SA';Observation.SafetyConcern='SC';Observation.Test='TST';Observation.Url='URL';Observation.Web='WEB';Observation.ForeignLang='FL';Observation.Underage='US';Observation.CSAlert='CS';Observation.ClientEscalated='CE';Observation.PowerModerationCode='PM';Observation.SecondOpinionCode='SO';Observation.ClientModerationCode='CM';Observation.LegacyRejectedCode='LR';Observation.ConsumerFlaggedCode='CF';Observation.EscalatedWordList='EWL';Observation.MissingDeviceData='MDD';Observation.ImportRejected='IR';Observation.ImportApproved='IA';Observation.PublicationOverrideCode='PO';Observation.NotForPublicationOverrideCode='NPO';Observation.ShowServiceComment='SSC';Observation.BrandEngaged='BE';Observation.ConsumerNotifiedOfRejection='CNR';Observation.MetaObservationTypeCodes=new __WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"]([Observation.PowerModerationCode,Observation.SecondOpinionCode,Observation.ClientModerationCode,Observation.EscalatedWordList,Observation.MissingDeviceData,Observation.ImportRejected,Observation.ImportApproved,Observation.PublicationOverrideCode,Observation.NotForPublicationOverrideCode,Observation.BrandEngaged,Observation.ConsumerNotifiedOfRejection]);Observation.SortOrder=[Observation.Contradict,Observation.RetailComp,Observation.Copyright,Observation.Duplicate,Observation.Underage,Observation.Fraud,Observation.Legal,Observation.Irrelevant,Observation.PII,Observation.Profane,Observation.Price,Observation.SafetyAlert,Observation.SafetyConcern,Observation.Test,Observation.Url,Observation.Web,Observation.ForeignLang,Observation.CSAlert,Observation.ClientEscalated];Observation.SortOrderMap=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(Observation.SortOrder.reduce(function(acc,code,index){acc[code]=index;return acc;},{}));Observation.comparator=function(lhs,rhs){var defaultSortOrder=Observation.SortOrderMap.count();var lhsOrder=Observation.SortOrderMap.get(typeof lhs==='string'?lhs:lhs.observation_type_code,defaultSortOrder);var rhsOrder=Observation.SortOrderMap.get(typeof rhs==='string'?rhs:rhs.observation_type_code,defaultSortOrder);return lhsOrder-rhsOrder;};Observation.EnumerableMetaObservationTypeCodes=new __WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"]([Observation.ConsumerFlaggedCode,Observation.LegacyRejectedCode]);Observation.IsEditableObservationTypeCode=function(code){return Observation.MetaObservationTypeCodes.has(code)===false&&Observation.EnumerableMetaObservationTypeCodes.has(code)===false;};Observation.IsEditableObservation=function(ob){return Observation.IsEditableObservationTypeCode(ob.observation_type_code);};Observation.IsEnumerableObservationTypeCode=function(code){return Observation.MetaObservationTypeCodes.has(code)===false;};Observation.IsEnumerableObservation=function(ob){return Observation.IsEnumerableObservationTypeCode(ob.observation_type_code);};/* harmony default export */ __webpack_exports__["a"] = (Observation);

/***/ }),
/* 46 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(485)
var getISOWeek = __webpack_require__(488)
var getISOYear = __webpack_require__(202)
var parse = __webpack_require__(9)
var isValid = __webpack_require__(491)
var enLocale = __webpack_require__(203)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchClients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return storeClients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return showClientMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hideClientMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
var fetchClients=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/fetch',function(clientId){return clientId;});var storeClients=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/store',function(payload){return payload;});var selectClient=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/select',// $FlowIssue
function(payload){return payload;});var showClientMenu=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/show-menu');var hideClientMenu=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/hide-menu');

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_errors__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HandleError=function(_React$PureComponent){_inherits(HandleError,_React$PureComponent);function HandleError(){_classCallCheck(this,HandleError);return _possibleConstructorReturn(this,(HandleError.__proto__||Object.getPrototypeOf(HandleError)).apply(this,arguments));}_createClass(HandleError,[{key:'render',value:function render(){var _props=this.props,requestStatus=_props.requestStatus,children=_props.children,render=_props.render;if(requestStatus==='complete'){return typeof render==='function'?render():children;}if(requestStatus==='pending'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["k" /* Loader */],{size:'10em',thickness:'0.9em'}));}if(__WEBPACK_IMPORTED_MODULE_1_lib_errors__["e" /* default */].isNetworkingError(requestStatus)){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */],{title:'Network Error',message:'You seem to have lost your connection'});}if(__WEBPACK_IMPORTED_MODULE_1_lib_errors__["e" /* default */].isServerError(requestStatus)){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */].Title,null,'Looks like the service is down.'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */].Message,null,'Contact',' ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('a',{href:'mailto:support@powerreviews.com'},'support@powerreviews.com'),' ','and let us know.'));}console.error('Unknown application error: ',requestStatus);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */].Title,null,'Application Error'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */].Message,null,'Contact',' ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('a',{href:'mailto:support@powerreviews.com'},'support@powerreviews.com'),' ','and let us know.'));}}]);return HandleError;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (HandleError);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return pageId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return variantId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return locale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return productName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return brand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return rating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return reviewIncludesResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isUpdatedReview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return questionIncludesAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return questionHasVisualAnswers; });
/* unused harmony export reviewerType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return author; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return reviewHeadline; });
/* unused harmony export questionType */
/* unused harmony export answerType */
/* unused harmony export answerStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ugcId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return codesIncluded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return codesExcluded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return statusIncluded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return statusExcluded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return siteStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return native; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return catalog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return merchantUserEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return merchantUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return commentsKeyword; });
/* unused harmony export questionKeyword */
/* unused harmony export answerKeyword */
/* unused harmony export contentDisclosureCodes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deviceId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return sortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return startDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return endDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clientId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return ugcTypeFieldName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return setReadonlyUgcType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return createUgcId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return mediaUgcType; });
var pageId={name:'page_id',label:'Page ID',type:'text'};var variantId={name:'variant_id',label:'Variant ID',type:'text'};var locale={name:'locale',label:'Locale',type:'text'};var productName={name:'product_name',label:'Product Name',type:'text'};var brand={name:'brand',label:'Brand',type:'text'};var category={name:'category',label:'Category',type:'text'};var rating={name:'between_star_rating',label:'Star Rating',type:'RatingRange',defaultValue:[1,5]};var reviewIncludesResponse={name:'includes_response',label:'Includes Response',type:'select',options:[{label:'Yes',value:'true'},{label:'No',value:'false'}],placeholder:'Any'};var isUpdatedReview={name:'is_new_ugc',label:'Updated Review',type:'select',options:[{label:'Yes',value:'true'},{label:'No',value:'false'}],placeholder:'Any'};var questionIncludesAnswer={name:'includes_answer',label:'Has Answer',type:'select',options:[{label:'Yes',value:'true'},{label:'No',value:'false'}],placeholder:'Any'};var questionHasVisualAnswers={name:'includes_answer_media',label:'Has Visual Answer',type:'select',options:[{label:'Yes',value:'true'},{label:'No',value:'false'}],placeholder:'Any'};var reviewerType={name:'reviewer_type',label:'Reviewer Type',type:'multiselect',options:[{label:'Staff Expert',value:'staff_expert'},{label:'Staff Reviewer',value:'staff_reviewer'},{label:'Verified Buyer',value:'verified_buyer'},{label:'Verified Reviewer',value:'verified_reviewer'}],placeholder:'Any Type'};var author={name:'author',label:'Author',type:'text'};var reviewHeadline={name:'headline',label:'Headline',type:'text'};var questionType={name:'question_type',label:'Question Type',type:'multiselect',placeholder:'Any Type',options:[]};var answerType={name:'answer_type',label:'Answer Type',type:'multiselect',placeholder:'Any Type',options:[]};var answerStatus={name:'answer_status',label:'Answer Status',type:'multiselect',placeholder:'Any Status',options:[]};var ugcId={name:'ugc_id',label:'UGC ID',type:'text'};var codesIncluded={name:'included_observations',label:'Observations Included',type:'multiselect',options:[],placeholder:'Any Code'};var codesExcluded={name:'excluded_observations',label:'Observations Excluded',type:'multiselect',options:[]};var statusIncluded={name:'included_status',label:'Status Included',type:'multiselect',options:[],placeholder:'Any Status'};var statusExcluded={name:'excluded_status',label:'Status Excluded',type:'multiselect',options:[]};var siteStatus={name:'published',label:'Site Status',type:'select',options:[{label:'Published',value:'true'},{label:'Unpublished',value:'false'}],placeholder:'Any Status'};var native={name:'native',label:'Native',type:'select',options:[{label:'Only Native UGC',value:'true'},{label:'Only Syndicated UGC',value:'false'}],placeholder:'All UGC'};var catalog={name:'catalog_id',label:'Catalog',type:'select',options:[],placeholder:'Any Catalog'};var merchantUserEmail={name:'merchant_email',label:'Merchant User Email',type:'text'};var merchantUserId={name:'merchant_user_id',label:'Merchant User ID',type:'text'};var commentsKeyword={name:'comments_keywords',label:'Comments Keyword',type:'text'};var questionKeyword={name:'question_keyword',label:'Question Keyword',type:'text'};var answerKeyword={name:'answer_keyword',label:'Answer Keyword',type:'text'};var contentDisclosureCodes={name:'disclosure_codes',label:'Content Disclosure Codes',type:'multiselect',options:[{label:'Sampling',value:'sampling'},{label:'Sweepstakes',value:'sweepstakes'}],placeholder:'Any Disclosure Code'};var deviceId={name:'device_id',label:'Device ID',type:'text'};var sortBy={name:'sort_order',label:'Sort Options',type:'select',options:[{label:'Newest to oldest',value:'desc'},{label:'Oldest to newest',value:'asc'}],defaultValue:'desc'};var startDate={name:'start_date',type:'date'};var endDate={name:'end_date',type:'date'};var clientId={name:'client_id',label:'client_id',type:'text'};var ugcTypeFieldName='ugc_type';var setReadonlyUgcType=function setReadonlyUgcType(){for(var _len=arguments.length,ugctypes=Array(_len),_key=0;_key<_len;_key++){ugctypes[_key]=arguments[_key];}return{name:ugcTypeFieldName,label:'UGC Type',type:'hidden',defaultValue:ugctypes.join(' ')};};var createUgcId=function createUgcId(label){return Object.assign({},ugcId,{label:label+' ID'});};var mediaUgcType={name:ugcTypeFieldName,label:'UGC Type',type:'select',options:[{label:'Image',value:'Image'},{label:'Video',value:'Video'}],placeholder:'Any'};// need to do something about media ugc type to work with new endpoint

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(626),
    getValue = __webpack_require__(629);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(284);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_NAMESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPE_DELIMITER; });
var DEFAULT_NAMESPACE = '/';
var ACTION_TYPE_DELIMITER = '||';

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if (typeof value !== 'object' || value === null) return false;
  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Catalog__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getUgcArchetype__ = __webpack_require__(375);
var Ugcs={createWithData:function createWithData(data){var ugc=data.ugc,_data$ugc=data.ugc,ugctype=_data$ugc.ugctype,ugc_related_content=_data$ugc.ugc_related_content,catalog=_data$ugc.catalog;// assumption is that Ugcs will only be nested one level
var ugc_archetype=Object(__WEBPACK_IMPORTED_MODULE_3__getUgcArchetype__["a" /* default */])(ugctype);var arg=Object.assign({},ugc,{ugc_archetype:ugc_archetype,catalog:Boolean(catalog)?new __WEBPACK_IMPORTED_MODULE_1__Catalog__["a" /* default */](catalog):__WEBPACK_IMPORTED_MODULE_1__Catalog__["a" /* default */].Empty,ugc_related_content:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(!ugc_related_content?[]:ugc_related_content.map(function(relatedUgc){var relatedUgcWithDescendants=Object.assign({},relatedUgc,{ugc_related_content:ugc_related_content.filter(function(u){return u.parent_ugc_id&&u.parent_ugc_id===relatedUgc.ugc_id;})});return Ugcs.createWithData({ugc:relatedUgcWithDescendants});}))});switch(ugc_archetype){case'Review':return __WEBPACK_IMPORTED_MODULE_2____["i" /* Review */].createWithData(arg);case'Image':return __WEBPACK_IMPORTED_MODULE_2____["c" /* Image */].createWithData(arg);case'Video':return __WEBPACK_IMPORTED_MODULE_2____["l" /* Video */].createWithData(arg);case'Question':return __WEBPACK_IMPORTED_MODULE_2____["g" /* Question */].createWithData(arg);case'Answer':return __WEBPACK_IMPORTED_MODULE_2____["a" /* Answer */].createWithData(arg);case'WDYB':return __WEBPACK_IMPORTED_MODULE_2____["m" /* WhyDidYouBuy */].createWithData(Object.assign({},ugc,{ugc_archetype:ugc_archetype}));case'MerchantResponse':return __WEBPACK_IMPORTED_MODULE_2____["h" /* Response */].createWithData(arg);default:{throw new Error('Unsupported ugctype: '+ugctype+'.');}}},getIdFromData:function getIdFromData(data){var _data$ugc2=data.ugc;_data$ugc2=_data$ugc2===undefined?{ugc_id:null}:_data$ugc2;var ugc_id=_data$ugc2.ugc_id;if(!ugc_id){throw new Error('ugc_id is undefined');}return ugc_id;},getId:function getId(record){return record.get('ugc_id');},getSubjectId:function getSubjectId(record){return record.get('subject_id');},getRelatedItemByType:function getRelatedItemByType(record,type){return record.get('ugc_related_content').find(function(ugc){return ugc.ugctype===type;});},getRelatedItemsByType:function getRelatedItemsByType(record,type){return record.get('ugc_related_content').filter(function(ugc){return ugc.ugctype===type;});},getMerchantResponse:function getMerchantResponse(record){return Ugcs.getRelatedItemByType(record,'MerchantResponse');},getBrandResponse:function getBrandResponse(record){return Ugcs.getRelatedItemByType(record,'BrandMerchantResponse');},hasResponses:function hasResponses(record){return Ugcs.getBrandResponse(record)||Ugcs.getMerchantResponse(record);},hasBrandResponseOrAnswer:function hasBrandResponseOrAnswer(record){return Boolean(record.get('ugc_related_content').find(function(_ref){var ugctype=_ref.ugctype;return ugctype==='BrandAnswer'||ugctype==='BrandMerchantResponse';}));}};/* harmony default export */ __webpack_exports__["a"] = (Ugcs);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultCatalogRecord={id:null,name:'',logo_url:'',group_id:null,group_name:null};var Catalog=function(_Record){_inherits(Catalog,_Record);function Catalog(){_classCallCheck(this,Catalog);return _possibleConstructorReturn(this,(Catalog.__proto__||Object.getPrototypeOf(Catalog)).apply(this,arguments));}return Catalog;}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(defaultCatalogRecord));Catalog.Empty=new Catalog();/* harmony default export */ __webpack_exports__["a"] = (Catalog);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PwrCloudinary__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PwrCloudinary__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__PwrCloudinary__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__PwrCloudinary__["c"]; });


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(79),
    getRawTag = __webpack_require__(384),
    objectToString = __webpack_require__(385);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalPortal__ = __webpack_require__(462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ModalPortal__["a"]; });


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(82)["default"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(191);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabHook__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__focusMerge__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__focusInside__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__focusIsHidden__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__setFocus__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_all_affected__ = __webpack_require__(127);
/* unused harmony reexport tabHook */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__focusInside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__focusIsHidden__["a"]; });
/* unused harmony reexport focusMerge */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__focusMerge__["b"]; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__constants__; });
/* unused harmony reexport getAllAffectedNodes */










/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_4__setFocus__["a" /* default */]);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UgcLinkButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
// $FlowFixMe
var UgcLinkContext=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();// do not render anything if linker is not a function
function Consumer(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UgcLinkContext.Consumer,props,function(val){return typeof val==='function'?props.children(val):null;});}/* harmony default export */ __webpack_exports__["b"] = ({Provider:UgcLinkContext.Provider,Consumer:Consumer});var UgcLinkButton=function UgcLinkButton(props){var defaultStyles=' tc db w-100 ba b--black-025 white no-underline br1 brandon button-reset input-reset f5 lh-title ph3 pv2 dim pointer mt2';return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('a',{href:props.href,target:'_blank',className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(defaultStyles,{'bg-black':props.darkerButton===true,'secondary-btn-gray':props.darkerButton!==true}),rel:'noopener noreferrer','data-test':'ugc-link-button'},props.label);};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentSection_scss__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentSection_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContentSection_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_format__);
var AuthorInfo=function AuthorInfo(props){var _props$ugc=props.ugc,created_date=_props$ugc.created_date,author=_props$ugc.author,location=_props$ugc.location;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:__WEBPACK_IMPORTED_MODULE_3__ContentSection_scss___default.a.contentSectionMeta,'data-translate':true},'Submitted on',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'data-key':'created_date'},formatDate(created_date)),Boolean(author)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,' ','by ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UserGeneratedTextContainer__["b" /* default */],{'data-key':'author',text:author})),Boolean(location)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,' ','from',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UserGeneratedTextContainer__["b" /* default */],{'data-key':'location',text:location})));};AuthorInfo.propTypes={ugc:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired};function formatDate(isoDateString){return __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_4_date_fns_parse___default()(isoDateString),'M/DD/YYYY h:mm A');}/* harmony default export */ __webpack_exports__["a"] = (AuthorInfo);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PwrUgcMetaInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClientUgcMetaInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PwrMediaUgcMetaInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientMediaUgcMetaInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AttributeList__ = __webpack_require__(204);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var META_FIELDS={device_id:'Device ID',locale:'Locale',source:'Source'};var PWR_META_FIELDS=Object.assign({subject_id:'Subject ID'},META_FIELDS);var CLIENT_META_FIELDS=Object.assign({email:'User Email',merchant_user_id:'User ID'},META_FIELDS);var generateItems=function generateItems(config,model){return Object.keys(config).reduce(function(items,key){var label=config[key];var value=model[key]||'-';items.push({key:label,label:label,// $$FlowFixMe
value:value});return items;},[]);};var mediaUgcMetaInfo=function mediaUgcMetaInfo(config,props){var model=props.model,parentModel=props.parentModel;// parent UGC is guaranteed to have
var items=generateItems(config,parentModel);var _generateItems=generateItems({ugc_id:model.ugctype+' ID'},props.model),_generateItems2=_slicedToArray(_generateItems,1),ugcId=_generateItems2[0];var _generateItems3=generateItems({ugc_id:parentModel.ugctype+' ID'},parentModel),_generateItems4=_slicedToArray(_generateItems3,1),parentUgcId=_generateItems4[0];items.splice(1,0,ugcId,parentUgcId);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__AttributeList__["a" /* default */],{items:items,className:'mh4 mv3'});};var PwrUgcMetaInfo=function PwrUgcMetaInfo(props){var items=generateItems(PWR_META_FIELDS,props.model);var _generateItems5=generateItems({ugc_id:'UGC ID'},props.model),_generateItems6=_slicedToArray(_generateItems5,1),ugcId=_generateItems6[0];items.splice(1,0,ugcId);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__AttributeList__["a" /* default */],{items:items,className:'mh4 mv3'});};var ClientUgcMetaInfo=function ClientUgcMetaInfo(props){var items=generateItems(CLIENT_META_FIELDS,props.model);var _generateItems7=generateItems({ugc_id:props.model.ugctype+' ID'},props.model),_generateItems8=_slicedToArray(_generateItems7,1),ugcId=_generateItems8[0];items.splice(1,0,ugcId);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__AttributeList__["a" /* default */],{items:items,className:'mh4 mv3'});};var PwrMediaUgcMetaInfo=function PwrMediaUgcMetaInfo(props){return mediaUgcMetaInfo(PWR_META_FIELDS,props);};var ClientMediaUgcMetaInfo=function ClientMediaUgcMetaInfo(props){return mediaUgcMetaInfo(CLIENT_META_FIELDS,props);};

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Icon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArticleContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Article; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ContentSection_UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthorInfo__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaViewer__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QAComponents_scss__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QAComponents_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__QAComponents_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_context_content_card_context__ = __webpack_require__(102);
var Icon=function Icon(_ref){var ugctype=_ref.ugctype;var char=ugctype==='WDYB'||ugctype==='Answer'?'A':ugctype.charAt(0);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('abbr',{className:'QA-Icon bg-dark-gray white'},char);};var ArticleContainer=function ArticleContainer(props){var ugctype=props.ugctype,main=props.main,aside=props.aside;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',{className:'QA-Article'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'QA-Article__LeftAside mr3 pt1'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{ugctype:ugctype})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'QA-Article__Main'},main),aside&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'QA-Article__RightAside'},aside));};var Article=function Article(props){var ugc=props.ugc,aside=props.aside;var _useContentCard=Object(__WEBPACK_IMPORTED_MODULE_5_context_content_card_context__["c" /* useContentCard */])(),isClientCard=_useContentCard.isClientCard;var text=ugc.ugc_archetype==='Question'?ugc.question:ugc.answer;var main=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h1',{className:'mt0 mb1 QA-Text'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_ContentSection_UserGeneratedTextContainer__["b" /* default */],{'data-key':ugc.ugctype.toLowerCase(),text:text})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__AuthorInfo__["a" /* AuthorInfo */],{ugc:ugc}),isClientCard&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mv2',key:'media'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MediaViewer__["a" /* default */],{ugcs:ugc.getMedia(),hideUgcLink:true})));return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ArticleContainer,{ugctype:ugc.ugc_archetype,main:main,aside:aside});};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ErrorAlert; });
/* unused harmony export SuccessAlert */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Alert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ErrorAlert=function ErrorAlert(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'tc pa2 f6 mb4 br1',style:{color:'#C23030',backgroundColor:'#FFDDDD'}},props.children);};var SuccessAlert=function SuccessAlert(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'tc pa2 f6 mb4 br1',style:{backgroundColor:'#d3e3be'}},props.children);};var Alert=function Alert(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'tc pa2 f6 mb4 br1 white bg-black-60'},props.children);};

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RemoteResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FileSystemResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloudResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ResourceTypes; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var RemoteResource=function(){function RemoteResource(props){_classCallCheck(this,RemoteResource);this.accessType=props.accessType;this.resourceType=props.resourceType;this.url=props.url;}_createClass(RemoteResource,[{key:'serialize',value:function serialize(captionMap){if(this.accessType==='upload'){throw new Error('Only Youtube RemoteResource type may be persisted to the document store.');}return{url:this.url,resource_type:this.resourceType,caption:captionMap.get(this.id)};}},{key:'id',get:function get(){return this.url;}}]);return RemoteResource;}();var FileSystemResource=function(){function FileSystemResource(file){_classCallCheck(this,FileSystemResource);this.file=file;}_createClass(FileSystemResource,[{key:'id',get:function get(){return this.file.name;}},{key:'resourceType',get:function get(){return this.file.type.split('/').shift();}}]);return FileSystemResource;}();var CloudResource=function(){function CloudResource(id,props){var accessType=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'upload';_classCallCheck(this,CloudResource);this.$id=id;this.public_id=props.public_id;this.resource_type=props.resource_type;this.url=props.secure_url||props.url;this.delete_token=props.delete_token;this.access_type=accessType;}_createClass(CloudResource,[{key:'serialize',value:function serialize(captionMap){return{url:this.url,resource_type:this.resource_type,caption:captionMap.get(this.id),public_id:this.public_id};}},{key:'id',get:function get(){return this.$id;}},{key:'resourceType',get:function get(){return this.resource_type;}}]);return CloudResource;}();var ResourceTypes=function(){function ResourceTypes(){_classCallCheck(this,ResourceTypes);}_createClass(ResourceTypes,null,[{key:'isUploadable',value:function isUploadable(res){if(res instanceof FileSystemResource){return true;}else if(res instanceof RemoteResource&&res.accessType==='upload'){return true;}return false;}},{key:'getUploadProps',value:function getUploadProps(res){var file=res.file||res.url||null;if(file===null){throw new Error('');}return[file,res.resourceType];}},{key:'isSerializable',value:function isSerializable(res){if(res instanceof RemoteResource&&res.accessType==='upload'){return false;}return typeof res.serialize==='function';}}]);return ResourceTypes;}();

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(280);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(18);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'function';
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof Map !== 'undefined' && value instanceof Map;
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestAppConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receiveAppConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return signalAppReady; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return signalAppNotReady; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
var requestAppConfig=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('APP_CONFIG_REQUEST',function(token){return token;});var receiveAppConfig=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('APP_CONFIG_RESPONSE',function(payload){return payload;});var signalAppReady=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('APP_READY');var signalAppNotReady=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('APP_NOT_READY');

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(180),
    upperFirst = __webpack_require__(390);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(28);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return postObservations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return postResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteUgc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return publicationDecision; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
var postObservations=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function postObservation(token,props){var ugcId=props.ugcId,body=props.body,_props$clientId=props.clientId,clientId=_props$clientId===undefined?1:_props$clientId;var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/moderate/content/ugc/'+ugcId+'?client_id='+clientId);var fetchOptions={method:'POST',headers:{'Content-type':'application/json',Authorization:token},body:JSON.stringify(body)};return fetch(fetchUrl,fetchOptions).then(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */]).then(function(response){return response.json();});});var postResponse=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function postResponse(token,obj){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/moderate/content/respond');var fetchOptions={method:'POST',headers:{'Content-type':'application/json',Authorization:token},body:JSON.stringify(obj)};return fetch(fetchUrl,fetchOptions).then(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */]).then(function(response){return response.json();});});var updateResponse=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function(token,payload){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/moderate/content/'+payload.ugc_id);var fetchOptions={method:'PUT',headers:{'Content-type':'application/json',Authorization:token},body:JSON.stringify(payload)};return fetch(fetchUrl,fetchOptions).then(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */]).then(function(response){return response.json();});});var deleteUgc=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function(token,ugcId){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/moderate/content/'+ugcId);var fetchOptions={method:'DELETE',headers:{'Content-type':'application/json',Authorization:token}};return fetch(fetchUrl,fetchOptions).then(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */]);});var publicationDecision=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function(token,_ref){var clientId=_ref.clientId,ugcClientId=_ref.ugcClientId,ugctype=_ref.ugctype,observations=_ref.observations;var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/publication/decision?client_id='+clientId+'&ugc_client_id='+ugcClientId+'&ugc_type='+ugctype);var fetchOptions={method:'POST',headers:{'Content-type':'application/json',Authorization:token},body:JSON.stringify(observations)};return fetch(fetchUrl,fetchOptions).then(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */]).then(function(response){return response.json();});});

/***/ }),
/* 82 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_GROUP", function() { return FOCUS_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_DISABLED", function() { return FOCUS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_ALLOW", function() { return FOCUS_ALLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_AUTO", function() { return FOCUS_AUTO; });
var FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = 'data-autofocus-inside';

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deferAction;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inlineProp; });
function deferAction(action) {
  // Hidding setImmediate from Webpack to avoid inserting polyfill
  var setImmediate = window.setImmediate;

  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}
var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ContentSection":"ContentSection","contentSection":"ContentSection","ContentSection__content-type-badge":"ContentSection__content-type-badge","contentSectionContentTypeBadge":"ContentSection__content-type-badge","ContentSection__content-type-badge__label":"ContentSection__content-type-badge__label","contentSectionContentTypeBadgeLabel":"ContentSection__content-type-badge__label","ContentSection__content-type-badge__text":"ContentSection__content-type-badge__text","contentSectionContentTypeBadgeText":"ContentSection__content-type-badge__text","ContentSection__content-type-badge__text__--hidden":"ContentSection__content-type-badge__text__--hidden","contentSectionContentTypeBadgeTextHidden":"ContentSection__content-type-badge__text__--hidden","ContentSection__header":"ContentSection__header","contentSectionHeader":"ContentSection__header","ContentSection__meta":"ContentSection__meta","contentSectionMeta":"ContentSection__meta","ContentSection__review-meta":"ContentSection__review-meta","contentSectionReviewMeta":"ContentSection__review-meta","ContentSection__badges":"ContentSection__badges","contentSectionBadges":"ContentSection__badges","ContentSection__related-media-content-list":"ContentSection__related-media-content-list","contentSectionRelatedMediaContentList":"ContentSection__related-media-content-list","ContentSection__related-media-content-list-item":"ContentSection__related-media-content-list-item","contentSectionRelatedMediaContentListItem":"ContentSection__related-media-content-list-item","ContentSection__related-media-content-thumbnail":"ContentSection__related-media-content-thumbnail","contentSectionRelatedMediaContentThumbnail":"ContentSection__related-media-content-thumbnail","ContentSection__related-media-content-options":"ContentSection__related-media-content-options","contentSectionRelatedMediaContentOptions":"ContentSection__related-media-content-options","ContentSection__error-message":"ContentSection__error-message","contentSectionErrorMessage":"ContentSection__error-message"};

/***/ }),
/* 86 */
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createCollapsedBlockWithContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetaInfoToggle__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var CollapsedBlock=function CollapsedBlock(props){var label=props.label,onClick=props.onClick,_props$open=props.open,open=_props$open===undefined?false:_props$open,children=props.children;var containerClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()({mb0:!open,mb4:open});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:containerClassName},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__MetaInfoToggle__["a" /* default */],{onClick:onClick,label:label}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{hidden:!open},children));};var createCollapsedBlockWithContent=function createCollapsedBlockWithContent(label,children){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CollapsedBlock,{label:label,open:props.open,onClick:props.onClick},children);};};/* harmony default export */ __webpack_exports__["a"] = (CollapsedBlock);

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"c-overlay":"c-overlay","cOverlay":"c-overlay","c-overlay--visible":"c-overlay--visible","cOverlayVisible":"c-overlay--visible","c-overlay--fullpage":"c-overlay--fullpage","cOverlayFullpage":"c-overlay--fullpage","c-overlay--transparent":"c-overlay--transparent","cOverlayTransparent":"c-overlay--transparent","c-overlay--dismissable":"c-overlay--dismissable","cOverlayDismissable":"c-overlay--dismissable","ActionAside":"ActionAside","actionAside":"ActionAside","ActionAside__aside":"ActionAside__aside","actionAsideAside":"ActionAside__aside","ActionAside__section":"ActionAside__section","actionAsideSection":"ActionAside__section","ActionAside__section__heading":"ActionAside__section__heading","actionAsideSectionHeading":"ActionAside__section__heading","ActionAside__section__custom-observation-header":"ActionAside__section__custom-observation-header","actionAsideSectionCustomObservationHeader":"ActionAside__section__custom-observation-header","ActionAside__section__merchant-name-subheader":"ActionAside__section__merchant-name-subheader","actionAsideSectionMerchantNameSubheader":"ActionAside__section__merchant-name-subheader","ActionAside__second-opinion-button":"ActionAside__second-opinion-button","actionAsideSecondOpinionButton":"ActionAside__second-opinion-button","ActionAside__moderator-info":"ActionAside__moderator-info","actionAsideModeratorInfo":"ActionAside__moderator-info","ActionAside__moderator-comments":"ActionAside__moderator-comments","actionAsideModeratorComments":"ActionAside__moderator-comments","ActionAside__hr":"ActionAside__hr","actionAsideHr":"ActionAside__hr"};

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObservationBadge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoObservationsBadge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PwrModerationTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObservationTimestamp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomObservationIcon__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ObservationBadges_scss__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ObservationBadges_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ObservationBadges_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_format__);
var badgeClassName='bg-moon-gray mid-gray ph2 dib f6 mb1 mr1 br1 pv1 ObservationBadge flex items-center';var ObservationBadge=function ObservationBadge(_ref){var name=_ref.name,customObservation=_ref.customObservation;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:badgeClassName},customObservation&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__CustomObservationIcon__["a" /* CustomObservationIcon */],{className:'mr1'}),name);};var NoObservationsBadge=function NoObservationsBadge(){var copy=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'No Observations';return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'gray pv1 ph2 dib f6 br1 mb2 bg-black-05'},copy);};var PwrModerationTime=function PwrModerationTime(_ref2){var moderationState=_ref2.moderationState;var pwrModeratedObservation=__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].getSavedObservations(moderationState,1).get(__WEBPACK_IMPORTED_MODULE_1_models__["e" /* Observation */].PowerModerationCode);return pwrModeratedObservation!=null?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ObservationTimestamp,{observation:pwrModeratedObservation,showUserInfo:true}):null;};var ObservationTimestamp=function ObservationTimestamp(_ref3){var observation=_ref3.observation,showUserInfo=_ref3.showUserInfo,recent=_ref3.recent;var userInfo=showUserInfo&&observation.user_data.name?['by ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('b',{key:'username'},observation.user_data.name)]:null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'f6 db gray mb1'},recent===true&&'Last ','Moderated ',userInfo,' on',' ',__WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(observation.created_date,'M/DD/YYYY h:mm A'));};var ObservationBadges=function ObservationBadges(_ref4){var moderationState=_ref4.moderationState;var el=__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].getSavedObservations(moderationState,1).filter(__WEBPACK_IMPORTED_MODULE_1_models__["e" /* Observation */].IsEditableObservation).map(function(_ref5){var name=_ref5.name,custom_observation=_ref5.custom_observation;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{key:name,className:badgeClassName},custom_observation&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__CustomObservationIcon__["a" /* CustomObservationIcon */],{className:'mr1'}),name);}).toArray();return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mv2 ObservationBadges flex flex-wrap'},el.length?el:NoObservationsBadge());};/* harmony default export */ __webpack_exports__["e"] = (ObservationBadges);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = LRUCache

// This will be a proper iterable 'Map' in engines that support it,
// or a fakey-fake PseudoMap in older versions.
var Map = __webpack_require__(545)
var util = __webpack_require__(547)

// A linked list to keep track of recently-used-ness
var Yallist = __webpack_require__(551)

// use symbols if possible, otherwise just _props
var hasSymbol = typeof Symbol === 'function' && Object({"NODE_ENV":"production","PUBLIC_URL":"//d17h9cyp9eegq8.cloudfront.net/prod-builds/48.0.0","REACT_APP_WEGLOT_API_KEY":"wg_3a3c94e641aaf99979e9565c889eccd91","REACT_APP_BUILD_ENV":"prod","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_IMAGE":"visual-answers-image","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_VIDEO":"visual-answers-video"})._nodeLRUCacheForceNoSymbol !== '1'
var makeSymbol
if (hasSymbol) {
  makeSymbol = function (key) {
    return Symbol(key)
  }
} else {
  makeSymbol = function (key) {
    return '_' + key
  }
}

var MAX = makeSymbol('max')
var LENGTH = makeSymbol('length')
var LENGTH_CALCULATOR = makeSymbol('lengthCalculator')
var ALLOW_STALE = makeSymbol('allowStale')
var MAX_AGE = makeSymbol('maxAge')
var DISPOSE = makeSymbol('dispose')
var NO_DISPOSE_ON_SET = makeSymbol('noDisposeOnSet')
var LRU_LIST = makeSymbol('lruList')
var CACHE = makeSymbol('cache')

function naiveLength () { return 1 }

// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
function LRUCache (options) {
  if (!(this instanceof LRUCache)) {
    return new LRUCache(options)
  }

  if (typeof options === 'number') {
    options = { max: options }
  }

  if (!options) {
    options = {}
  }

  var max = this[MAX] = options.max
  // Kind of weird to have a default max of Infinity, but oh well.
  if (!max ||
      !(typeof max === 'number') ||
      max <= 0) {
    this[MAX] = Infinity
  }

  var lc = options.length || naiveLength
  if (typeof lc !== 'function') {
    lc = naiveLength
  }
  this[LENGTH_CALCULATOR] = lc

  this[ALLOW_STALE] = options.stale || false
  this[MAX_AGE] = options.maxAge || 0
  this[DISPOSE] = options.dispose
  this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false
  this.reset()
}

// resize the cache when the max changes.
Object.defineProperty(LRUCache.prototype, 'max', {
  set: function (mL) {
    if (!mL || !(typeof mL === 'number') || mL <= 0) {
      mL = Infinity
    }
    this[MAX] = mL
    trim(this)
  },
  get: function () {
    return this[MAX]
  },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'allowStale', {
  set: function (allowStale) {
    this[ALLOW_STALE] = !!allowStale
  },
  get: function () {
    return this[ALLOW_STALE]
  },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'maxAge', {
  set: function (mA) {
    if (!mA || !(typeof mA === 'number') || mA < 0) {
      mA = 0
    }
    this[MAX_AGE] = mA
    trim(this)
  },
  get: function () {
    return this[MAX_AGE]
  },
  enumerable: true
})

// resize the cache when the lengthCalculator changes.
Object.defineProperty(LRUCache.prototype, 'lengthCalculator', {
  set: function (lC) {
    if (typeof lC !== 'function') {
      lC = naiveLength
    }
    if (lC !== this[LENGTH_CALCULATOR]) {
      this[LENGTH_CALCULATOR] = lC
      this[LENGTH] = 0
      this[LRU_LIST].forEach(function (hit) {
        hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key)
        this[LENGTH] += hit.length
      }, this)
    }
    trim(this)
  },
  get: function () { return this[LENGTH_CALCULATOR] },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'length', {
  get: function () { return this[LENGTH] },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'itemCount', {
  get: function () { return this[LRU_LIST].length },
  enumerable: true
})

LRUCache.prototype.rforEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this[LRU_LIST].tail; walker !== null;) {
    var prev = walker.prev
    forEachStep(this, fn, walker, thisp)
    walker = prev
  }
}

function forEachStep (self, fn, node, thisp) {
  var hit = node.value
  if (isStale(self, hit)) {
    del(self, node)
    if (!self[ALLOW_STALE]) {
      hit = undefined
    }
  }
  if (hit) {
    fn.call(thisp, hit.value, hit.key, self)
  }
}

LRUCache.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this[LRU_LIST].head; walker !== null;) {
    var next = walker.next
    forEachStep(this, fn, walker, thisp)
    walker = next
  }
}

LRUCache.prototype.keys = function () {
  return this[LRU_LIST].toArray().map(function (k) {
    return k.key
  }, this)
}

LRUCache.prototype.values = function () {
  return this[LRU_LIST].toArray().map(function (k) {
    return k.value
  }, this)
}

LRUCache.prototype.reset = function () {
  if (this[DISPOSE] &&
      this[LRU_LIST] &&
      this[LRU_LIST].length) {
    this[LRU_LIST].forEach(function (hit) {
      this[DISPOSE](hit.key, hit.value)
    }, this)
  }

  this[CACHE] = new Map() // hash of items by key
  this[LRU_LIST] = new Yallist() // list of items in order of use recency
  this[LENGTH] = 0 // length of items in the list
}

LRUCache.prototype.dump = function () {
  return this[LRU_LIST].map(function (hit) {
    if (!isStale(this, hit)) {
      return {
        k: hit.key,
        v: hit.value,
        e: hit.now + (hit.maxAge || 0)
      }
    }
  }, this).toArray().filter(function (h) {
    return h
  })
}

LRUCache.prototype.dumpLru = function () {
  return this[LRU_LIST]
}

/* istanbul ignore next */
LRUCache.prototype.inspect = function (n, opts) {
  var str = 'LRUCache {'
  var extras = false

  var as = this[ALLOW_STALE]
  if (as) {
    str += '\n  allowStale: true'
    extras = true
  }

  var max = this[MAX]
  if (max && max !== Infinity) {
    if (extras) {
      str += ','
    }
    str += '\n  max: ' + util.inspect(max, opts)
    extras = true
  }

  var maxAge = this[MAX_AGE]
  if (maxAge) {
    if (extras) {
      str += ','
    }
    str += '\n  maxAge: ' + util.inspect(maxAge, opts)
    extras = true
  }

  var lc = this[LENGTH_CALCULATOR]
  if (lc && lc !== naiveLength) {
    if (extras) {
      str += ','
    }
    str += '\n  length: ' + util.inspect(this[LENGTH], opts)
    extras = true
  }

  var didFirst = false
  this[LRU_LIST].forEach(function (item) {
    if (didFirst) {
      str += ',\n  '
    } else {
      if (extras) {
        str += ',\n'
      }
      didFirst = true
      str += '\n  '
    }
    var key = util.inspect(item.key).split('\n').join('\n  ')
    var val = { value: item.value }
    if (item.maxAge !== maxAge) {
      val.maxAge = item.maxAge
    }
    if (lc !== naiveLength) {
      val.length = item.length
    }
    if (isStale(this, item)) {
      val.stale = true
    }

    val = util.inspect(val, opts).split('\n').join('\n  ')
    str += key + ' => ' + val
  })

  if (didFirst || extras) {
    str += '\n'
  }
  str += '}'

  return str
}

LRUCache.prototype.set = function (key, value, maxAge) {
  maxAge = maxAge || this[MAX_AGE]

  var now = maxAge ? Date.now() : 0
  var len = this[LENGTH_CALCULATOR](value, key)

  if (this[CACHE].has(key)) {
    if (len > this[MAX]) {
      del(this, this[CACHE].get(key))
      return false
    }

    var node = this[CACHE].get(key)
    var item = node.value

    // dispose of the old one before overwriting
    // split out into 2 ifs for better coverage tracking
    if (this[DISPOSE]) {
      if (!this[NO_DISPOSE_ON_SET]) {
        this[DISPOSE](key, item.value)
      }
    }

    item.now = now
    item.maxAge = maxAge
    item.value = value
    this[LENGTH] += len - item.length
    item.length = len
    this.get(key)
    trim(this)
    return true
  }

  var hit = new Entry(key, value, len, now, maxAge)

  // oversized objects fall out of cache automatically.
  if (hit.length > this[MAX]) {
    if (this[DISPOSE]) {
      this[DISPOSE](key, value)
    }
    return false
  }

  this[LENGTH] += hit.length
  this[LRU_LIST].unshift(hit)
  this[CACHE].set(key, this[LRU_LIST].head)
  trim(this)
  return true
}

LRUCache.prototype.has = function (key) {
  if (!this[CACHE].has(key)) return false
  var hit = this[CACHE].get(key).value
  if (isStale(this, hit)) {
    return false
  }
  return true
}

LRUCache.prototype.get = function (key) {
  return get(this, key, true)
}

LRUCache.prototype.peek = function (key) {
  return get(this, key, false)
}

LRUCache.prototype.pop = function () {
  var node = this[LRU_LIST].tail
  if (!node) return null
  del(this, node)
  return node.value
}

LRUCache.prototype.del = function (key) {
  del(this, this[CACHE].get(key))
}

LRUCache.prototype.load = function (arr) {
  // reset the cache
  this.reset()

  var now = Date.now()
  // A previous serialized cache has the most recent items first
  for (var l = arr.length - 1; l >= 0; l--) {
    var hit = arr[l]
    var expiresAt = hit.e || 0
    if (expiresAt === 0) {
      // the item was created without expiration in a non aged cache
      this.set(hit.k, hit.v)
    } else {
      var maxAge = expiresAt - now
      // dont add already expired items
      if (maxAge > 0) {
        this.set(hit.k, hit.v, maxAge)
      }
    }
  }
}

LRUCache.prototype.prune = function () {
  var self = this
  this[CACHE].forEach(function (value, key) {
    get(self, key, false)
  })
}

function get (self, key, doUse) {
  var node = self[CACHE].get(key)
  if (node) {
    var hit = node.value
    if (isStale(self, hit)) {
      del(self, node)
      if (!self[ALLOW_STALE]) hit = undefined
    } else {
      if (doUse) {
        self[LRU_LIST].unshiftNode(node)
      }
    }
    if (hit) hit = hit.value
  }
  return hit
}

function isStale (self, hit) {
  if (!hit || (!hit.maxAge && !self[MAX_AGE])) {
    return false
  }
  var stale = false
  var diff = Date.now() - hit.now
  if (hit.maxAge) {
    stale = diff > hit.maxAge
  } else {
    stale = self[MAX_AGE] && (diff > self[MAX_AGE])
  }
  return stale
}

function trim (self) {
  if (self[LENGTH] > self[MAX]) {
    for (var walker = self[LRU_LIST].tail;
      self[LENGTH] > self[MAX] && walker !== null;) {
      // We know that we're about to delete this one, and also
      // what the next least recently used key will be, so just
      // go ahead and set it now.
      var prev = walker.prev
      del(self, walker)
      walker = prev
    }
  }
}

function del (self, node) {
  if (node) {
    var hit = node.value
    if (self[DISPOSE]) {
      self[DISPOSE](hit.key, hit.value)
    }
    self[LENGTH] -= hit.length
    self[CACHE].delete(hit.key)
    self[LRU_LIST].removeNode(node)
  }
}

// classy, since V8 prefers predictable objects.
function Entry (key, value, length, now, maxAge) {
  this.key = key
  this.value = value
  this.length = length
  this.now = now
  this.maxAge = maxAge || 0
}


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Viewport__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Nav__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Switch__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startCase__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_components_UserMenu__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_components_HelpMenu__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_client_ClientSelectMenu__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_client_ClientProvider__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicationErrorMessage=function ApplicationErrorMessage(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components__["i" /* EmptyCard */],{title:'Something went wrong!',message:'Try reloading the page. If this error persists, contact PowerReviews Support.'});};var getBreadcrumbs=function getBreadcrumbs(pathname,label,routes){return pathname.split('/').map(function(pathname,index,array){var name=__WEBPACK_IMPORTED_MODULE_5_lodash_startCase___default()(pathname);if(index===1){name=label;}else if(index===2){var matchingDefinedRoute=routes.filter(function(route){return route.path===pathname;})[0];name=matchingDefinedRoute&&matchingDefinedRoute.label||__WEBPACK_IMPORTED_MODULE_5_lodash_startCase___default()(pathname);}return{name:name,path:array.slice(0,index+1).join('/')};});};var LandingPage=function(_React$Component){_inherits(LandingPage,_React$Component);function LandingPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LandingPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LandingPage.__proto__||Object.getPrototypeOf(LandingPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={error:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LandingPage,[{key:'componentDidCatch',value:function componentDidCatch(error){this.setState({error:error});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,match=_props.match,label=_props.label,username=_props.username;var _props2=this.props,routes=_props2.routes,landingRoute=_props2.landingRoute;var clientContext=this.context;var showClientMenu=Boolean(this.context);if(this.state.error){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ApplicationErrorMessage,null);}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Viewport__["c" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Nav__["a" /* default */],Object.assign({contextLabel:label,contextRoutes:routes,match:_this2.props.match},props));}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Viewport__["b" /* Main */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Viewport__["a" /* Header */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components__["b" /* Breadcrumbs */],{routes:getBreadcrumbs(props.location.pathname,label,routes)});}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex flex-row items-center'},showClientMenu&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_containers_client_ClientSelectMenu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_pages_components_UserMenu__["a" /* default */],{username:username}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_pages_components_HelpMenu__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Switch__["a" /* default */],null,landingRoute&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */],{exact:true,from:match.url,to:match.url+'/'+landingRoute}),routes.map(function(route,index){var _route$exact=route.exact,exact=_route$exact===undefined?false:_route$exact,path=route.path,label=route.label,component=route.component,render=route.render,_route$clientContextR=route.clientContextRequired,clientContextRequired=_route$clientContextR===undefined?true:_route$clientContextR;var routeRenderProp=function(){if(clientContextRequired&&clientContext==null){return{component:__WEBPACK_IMPORTED_MODULE_10_containers_client_ClientProvider__["b" /* RequireClientSelection */]};}return typeof render==='function'?{render:render}:{component:component};}();return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],Object.assign({key:index,exact:exact,path:match.url+'/'+path,label:label},routeRenderProp));}))));}}]);return LandingPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LandingPage.contextType=__WEBPACK_IMPORTED_MODULE_10_containers_client_ClientProvider__["a" /* ClientContext */];/* harmony default export */ __webpack_exports__["a"] = (LandingPage);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClickOutside = function (_Component) {
  _inherits(ClickOutside, _Component);

  function ClickOutside(props) {
    _classCallCheck(this, ClickOutside);

    var _this = _possibleConstructorReturn(this, (ClickOutside.__proto__ || Object.getPrototypeOf(ClickOutside)).call(this, props));

    _this.handle = function (e) {
      if (e.type === 'touchend') _this.isTouch = true;
      if (e.type === 'click' && _this.isTouch) return;
      var onClickOutside = _this.props.onClickOutside;

      var el = _this.container;
      if (el && !el.contains(e.target)) onClickOutside(e);
    };

    _this.getContainer = _this.getContainer.bind(_this);
    _this.isTouch = false;
    return _this;
  }

  _createClass(ClickOutside, [{
    key: 'getContainer',
    value: function getContainer(ref) {
      this.container = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onClickOutside = _props.onClickOutside,
          props = _objectWithoutProperties(_props, ['children', 'onClickOutside']);

      return _react2.default.createElement(
        'div',
        _extends({}, props, { ref: this.getContainer }),
        children
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('touchend', this.handle, true);
      document.addEventListener('click', this.handle, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('touchend', this.handle, true);
      document.removeEventListener('click', this.handle, true);
    }
  }]);

  return ClickOutside;
}(_react.Component);

ClickOutside.propTypes = {
  onClickOutside: _propTypes2.default.func.isRequired
};
exports.default = ClickOutside;

/***/ }),
/* 93 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nativeSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return networkSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ugcSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
var _search=function _search(url){return Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function search(token,query){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])(url);var fetchOptions={method:'POST',headers:{'Content-type':'application/json',Authorization:token},body:JSON.stringify(query)};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();});});};var _ugcSearch=function _ugcSearch(url){return Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function search(token,query){var params=new URLSearchParams(query);var clientId=params.get('client_id');var comments=params.get('comments_keywords');var endDate=params.get('end_date').slice(0,10);var startDate=params.get('start_date').slice(0,10);params.append('from_date',startDate);params.append('to_date',endDate);params.append('max_page_results',100);if(comments!=null){params.append('comments',params.get('comments_keywords'));params.delete('comments_keywords');}params.delete('sort_order');params.delete('start_date');params.delete('end_date');params.delete('client_id');var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])(url+'/'+clientId+'?'+params.toString());var fetchOptions={method:'GET',headers:{'Content-type':'application/json',Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();});});};var nativeSearch=_search('/cdm/ugc/search');var networkSearch=_search('/cdm/ugc/search/network');var ugcSearch=_ugcSearch('/cdm/ugc/search');

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestSearchResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return navigateSearchResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receiveSearchResults; });
/* unused harmony export initForm */
/* unused harmony export updateForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return submitSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
var requestSearchResults=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@search/request',function(payload){return payload;});var navigateSearchResults=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@search/navigate',function(payload){return payload;});var receiveSearchResults=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@search/receive',function(results,totalPages){return{items:results,totalPages:totalPages};});var initForm=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@search/form/init',function(payload){return payload;});var updateForm=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@search/form/update',function(payload){return payload;});var clearSearch=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@search/clear');var submitSearch=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@search/submit',function(query){return query;});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_errors__ = __webpack_require__(36);
var HandleRequestError=function HandleRequestError(props){var children=props.children,requestStatus=props.requestStatus,match=props.match,render=props.render;return requestStatus instanceof __WEBPACK_IMPORTED_MODULE_0_lib_errors__["b" /* HttpError */]&&match(requestStatus)?render(requestStatus):children;};/* harmony default export */ __webpack_exports__["a"] = (HandleRequestError);

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(616),
    listCacheDelete = __webpack_require__(617),
    listCacheGet = __webpack_require__(618),
    listCacheHas = __webpack_require__(619),
    listCacheSet = __webpack_require__(620);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(137);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(638);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return requestAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return receiveAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearChangeStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearAssignment; });
/* harmony export (immutable) */ __webpack_exports__["d"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_async_value__ = __webpack_require__(12);
var DEFAULT_STATE=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();var requestAssignment=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc-assignment/request',function(payload){return payload;});var receiveAssignment=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc-assignment/response',function(payload){return payload;},function(_,ugcId){return ugcId;});var clearChangeStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc-assignment/clear-pending',function(ugcId){return ugcId;});var clearAssignment=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc-assignment/clear',function(ugcId){return ugcId;});function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:DEFAULT_STATE;var action=arguments[1];switch(action.type){case requestAssignment.toString():{var _ref=action,_ref$payload=_ref.payload,_ugcId=_ref$payload.ugcId,_assigned_to=_ref$payload.profileId;return state.set(_ugcId,{changeStatus:__WEBPACK_IMPORTED_MODULE_2_lib_async_value__["b" /* default */].Pending,assigned_to:_assigned_to});}case receiveAssignment.toString():{var _ref2=action,error=_ref2.error,_ugcId2=_ref2.meta;var nextValue=error?{changeStatus:action.payload}:{};return state.set(_ugcId2,nextValue);}case clearChangeStatus.toString():{var _ref3=action,_ugcId3=_ref3.payload;return state.set(_ugcId3,Object.assign({},state.get(_ugcId3),{changeStatus:null}));}case clearAssignment.toString():{var _ref4=action,_ugcId4=_ref4.payload;return state.remove(_ugcId4);}default:return state;}}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = useContentCard;
/* harmony export (immutable) */ __webpack_exports__["b"] = PwrContentCardProvider;
/* harmony export (immutable) */ __webpack_exports__["a"] = ClientContentCardProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ContentCardContext=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();function useContentCard(){var context=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ContentCardContext);if(!context){throw new Error('useContentCard must be used within a Provider');}return{isPwrCard:context==='pwr',isClientCard:context==='client'};}function PwrContentCardProvider(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentCardContext.Provider,Object.assign({value:'pwr'},props));}function ClientContentCardProvider(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentCardContext.Provider,Object.assign({value:'client'},props));}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(106);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(18);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_identity__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_isNull__ = __webpack_require__(347);




function createAction(type, payloadCreator, metaCreator) {
  if (payloadCreator === void 0) {
    payloadCreator = __WEBPACK_IMPORTED_MODULE_2__utils_identity__["a" /* default */];
  }

  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(payloadCreator) || Object(__WEBPACK_IMPORTED_MODULE_3__utils_isNull__["a" /* default */])(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');
  var finalPayloadCreator = Object(__WEBPACK_IMPORTED_MODULE_3__utils_isNull__["a" /* default */])(payloadCreator) || payloadCreator === __WEBPACK_IMPORTED_MODULE_2__utils_identity__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__utils_identity__["a" /* default */] : function (head) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return head instanceof Error ? head : payloadCreator.apply(void 0, [head].concat(args));
  };
  var hasMeta = Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(metaCreator);
  var typeString = type.toString();

  var actionCreator = function actionCreator() {
    var payload = finalPayloadCreator.apply(void 0, arguments);
    var action = {
      type: type
    };

    if (payload instanceof Error) {
      action.error = true;
    }

    if (payload !== undefined) {
      action.payload = payload;
    }

    if (hasMeta) {
      action.meta = metaCreator.apply(void 0, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return typeString;
  };

  return actionCreator;
}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value;
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isMap__ = __webpack_require__(76);

function ownKeys(object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isMap__["a" /* default */])(object)) {
    // We are using loose transforms in babel. Here we are trying to convert an
    // interable to an array. Loose mode expects everything to already be an
    // array. The problem is that our eslint rules encourage us to prefer
    // spread over Array.from.
    //
    // Instead of disabling loose mode we simply disable the warning.
    // eslint-disable-next-line unicorn/prefer-spread
    return Array.from(object.keys());
  }

  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSelected; });
/* unused harmony export setSelected */
/* unused harmony export getState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var BUILD_ENV_PREFIX=""||'';var COOKIE_NAME=BUILD_ENV_PREFIX+'current_merchant_group_id';var COOKIE_DOMAIN= false?'':'powerreviews.com';// cleanup after migrating from localStorage to cookie
localStorage.removeItem('MerchantGroup.Selected');var getSelected=function getSelected(){var item=__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(COOKIE_NAME);return item!=null?+item:null;};var setSelected=function setSelected(val){if(val==null)return;__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(COOKIE_NAME,val,{domain:COOKIE_DOMAIN,expires:30,sameSite:'strict'});};var getState=function getState(){return{currentClient:getSelected()};};/* harmony default export */ __webpack_exports__["a"] = ({getSelected:getSelected,setSelected:setSelected,getState:getState});

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SessionTokenStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var USER_SERVICE_TOKEN_NAME='user_service_token1';// const USER_SERVICE_TOKEN_DOMAIN = 'powerreviews.com';
// we migrate to this approach
var SessionTokenStorage={getToken:function getToken(){return window.sessionStorage.getItem('user_token')||undefined;},setToken:function setToken(value){window.sessionStorage.setItem('user_token',value);},clearToken:function clearToken(){return window.sessionStorage.removeItem('user_token');}};// this is a hack to enable session storage cookie managment in local development
// this hack will stop working once we stop setting the user_service_token1 cookie
// TOD
if(window.location.hostname==='local.powerreviews.com'){var tokenFromSessionStorage=SessionTokenStorage.getToken();if(tokenFromSessionStorage==='%USER_TOKEN%'){var valueFromCookie=__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(USER_SERVICE_TOKEN_NAME);if(valueFromCookie!=null){window.sessionStorage.setItem('user_token',valueFromCookie);// Cookie.remove(USER_SERVICE_TOKEN_NAME, {
//   domain: USER_SERVICE_TOKEN_DOMAIN,
//   path: '/',
// });
}}}/* harmony default export */ __webpack_exports__["a"] = (SessionTokenStorage);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_pwr_cloudinary__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_startCase__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Catalog__ = __webpack_require__(58);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultProductRecordShape={subject_id:null,subject_type:null,name:'Unknown Product',description:'',category_name:'',page_id:null,page_id_variant:null,product_id:null,product_url:null,product_image_url:{raw:'',thumbnail:'',small:'',medium:'',large:'',full:''},locale:'en_US',brand_name:'',merchant:__WEBPACK_IMPORTED_MODULE_3__Catalog__["a" /* default */].Empty,associated_products:[]};var ProductRecord=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(defaultProductRecordShape);var defaultUrlSet=__WEBPACK_IMPORTED_MODULE_1_lib_pwr_cloudinary__["a" /* default */].fetchUrlSet('');var stripTrailingColon=function stripTrailingColon(category_name){return category_name.replace(/:$/g,'');};var Product=function(_ProductRecord){_inherits(Product,_ProductRecord);function Product(props){_classCallCheck(this,Product);return _possibleConstructorReturn(this,(Product.__proto__||Object.getPrototypeOf(Product)).call(this,Object.assign({product_image_url:defaultUrlSet},props,{category_name:props&&typeof props.category_name==='string'?stripTrailingColon(props.category_name):''})));}_createClass(Product,null,[{key:'createWithData',value:function createWithData(data){if(!data.subject){throw new TypeError('Invalid argument');}if(__WEBPACK_IMPORTED_MODULE_2_lodash_startCase___default()(data.subject.subject_type)!=='Product'){throw new TypeError('Invalid subject_type:'+data.subject.subject_type+', expects "Product"');}var _data$subject=data.subject,_data$subject$product=_data$subject.product_url,product_url=_data$subject$product===undefined?'':_data$subject$product,_data$subject$product2=_data$subject.product_image_url,product_image_url=_data$subject$product2===undefined?'':_data$subject$product2,merchant=_data$subject.merchant;var _data$subject$associa=data.subject.associated_products,associated_products=_data$subject$associa===undefined?[]:_data$subject$associa;// $FlowFixMe
return new Product(Object.assign({},data.subject,{product_url:product_url==='nullnull'?'':product_url,product_image_url:__WEBPACK_IMPORTED_MODULE_1_lib_pwr_cloudinary__["a" /* default */].fetchUrlSet(product_image_url.replace('nullnull','')),catalog:new __WEBPACK_IMPORTED_MODULE_3__Catalog__["a" /* default */](merchant),associated_products:associated_products}));}}]);return Product;}(ProductRecord);/* harmony default export */ __webpack_exports__["a"] = (Product);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(382);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppConfigState */
/* unused harmony export createObservationCodeByClientIdMap */
/* unused harmony export flattenAppConfigResponseToObservationMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appConfigActions__ = __webpack_require__(77);
var _handleActions;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultAppConfigRecordShape={observationsMap:new __WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"](),observationCodeByClientIdMap:new __WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"](),requestStatus:null,sagaReady:false};var AppConfigState=function(_Record){_inherits(AppConfigState,_Record);function AppConfigState(){_classCallCheck(this,AppConfigState);return _possibleConstructorReturn(this,(AppConfigState.__proto__||Object.getPrototypeOf(AppConfigState)).apply(this,arguments));}return AppConfigState;}(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])(defaultAppConfigRecordShape));var defaultAppConfigState=new AppConfigState();/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__appConfigActions__["d" /* signalAppReady */].toString(),function(state,action){return state.set('sagaReady',true);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__appConfigActions__["c" /* signalAppNotReady */].toString(),function(state,action){return state.set('sagaReady',false);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__appConfigActions__["b" /* requestAppConfig */].toString(),function(state,action){return state.set('requestStatus','pending');}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__appConfigActions__["a" /* receiveAppConfig */].toString(),{next:function next(state,action){var observationsMap=flattenAppConfigResponseToObservationMap(action.payload);var observationCodeByClientIdMap=createObservationCodeByClientIdMap(action.payload);return state.merge({requestStatus:'complete',observationsMap:observationsMap,observationCodeByClientIdMap:observationCodeByClientIdMap});},throw:function _throw(state,action){return state.set('requestStatus',action.payload);}}),_handleActions),defaultAppConfigState));var createObservationCodeByClientIdMap=function createObservationCodeByClientIdMap(response){var newObservationsArray=[];// $FlowFixMe
Object.keys(response).forEach(function(keyAsClientId){var observationGroup=response[keyAsClientId];var clientObservationCodeList=[];observationGroup.map(function(_ref){var observation_type_code=_ref.observation_type_code,name=_ref.name;return clientObservationCodeList.push(observation_type_code);});return newObservationsArray.push([keyAsClientId,clientObservationCodeList]);});return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])(newObservationsArray);};var flattenAppConfigResponseToObservationMap=function flattenAppConfigResponseToObservationMap(response){var global=response.global,custom=_objectWithoutProperties(response,['global']);var mapObervationTypeToMapEntry=function mapObervationTypeToMapEntry(observation){var observationCode=observation.observation_type_code;var observationType=__WEBPACK_IMPORTED_MODULE_1_models__["e" /* Observation */].createWithData(observation);return[observationCode,observationType];};var sortedGlobalObservationTypeEntries=global.sort(__WEBPACK_IMPORTED_MODULE_1_models__["e" /* Observation */].comparator).map(mapObervationTypeToMapEntry);var allObservationTypeEntries=[].concat(_toConsumableArray(sortedGlobalObservationTypeEntries));Object.keys(custom).forEach(function(keyAsClientId){var customObservationTypesForClientId=custom[keyAsClientId];customObservationTypesForClientId.forEach(function(t){var entry=mapObervationTypeToMapEntry(t);allObservationTypeEntries.push(entry);});});return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])(allObservationTypeEntries);};

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authActions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthState__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__AuthState__["a"]; });
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__authActions__["a" /* login */].toString(),function(state,action){return state.set('requestStatus','pending');}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__authActions__["d" /* regenerateToken */].toString(),function(state,action){return state.set('requestStatus','pending');}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__authActions__["b" /* logout */].toString(),function(state,action){return new __WEBPACK_IMPORTED_MODULE_2__AuthState__["a" /* default */]();}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__authActions__["c" /* receiveAuth */].toString(),{next:function next(state,action){return __WEBPACK_IMPORTED_MODULE_2__AuthState__["a" /* default */].createFromPayload(action.payload);},throw:function _throw(state,action){return new __WEBPACK_IMPORTED_MODULE_2__AuthState__["a" /* default */]({requestStatus:action.payload});}}),_handleActions),new __WEBPACK_IMPORTED_MODULE_2__AuthState__["a" /* default */]()));

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authActions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__normalizeModerationPaths__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultAccess={app:false,moderate:false,secondOpinion:false,search:false,channels:false,reviews:false,qa:false,socialcollection:false};var defaultRole={queueModerator:false,reviewModerator:false,qaModerator:false,moderationAdmin:false,brandEngage:false,admin:false,internal:false};var RoleRecord=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(defaultRole);var AccessRecord=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(defaultAccess);var SOCIAL_ANSWERS_PROGRAMS=['AdminQuestionQueue',// QuestionQueueController
'AnswerBoxModeratorLevelTwo',// ProductAnswersModerator
'AnswerBoxModerator2LevelTwo',// ModeratorCommon?
'ExpertUserQuestionQueue'];var socialCollectionHasAccessPath='/socialcollection';function createRoleFromProgramGroups(programGroups){var set=new __WEBPACK_IMPORTED_MODULE_0_immutable__["Set"](Object.keys(programGroups));var queueModerator=set.has('PowerReviewsModerator');var reviewModerator=set.has('ReviewModeratorLevelTwo');var qaModerator=SOCIAL_ANSWERS_PROGRAMS.reduce(function(flag,programName){return flag||set.has(programName);},false);var brandEngage=set.has('BrandEngage');var moderationAdmin=set.has('PowerReviewsModerationAdmin');var admin=moderationAdmin&&reviewModerator&&qaModerator;var internal=queueModerator||moderationAdmin;return new RoleRecord({queueModerator:queueModerator,reviewModerator:reviewModerator,qaModerator:qaModerator,moderationAdmin:moderationAdmin,admin:admin,internal:internal,brandEngage:brandEngage});}function createAccessFromRole(apps,role){var reviews=apps.has('Reviews');var qa=apps.has('QA');var moderate=apps.has('Moderation');var app=reviews||qa||moderate;var secondOpinion=role.moderationAdmin;var search=role.reviewModerator||role.qaModerator;var channels=role.reviewModerator||role.qaModerator||role.brandEngage;var socialcollection=apps.get('SocialCollection')===socialCollectionHasAccessPath;var props={app:app,moderate:moderate,secondOpinion:secondOpinion,search:search,channels:channels,reviews:reviews,qa:qa,socialcollection:socialcollection};return new AccessRecord(props);}var defaultAuthRecord={requestStatus:null,name:'',email:'',token:'',profile_id:null,loggedIn:false,access:new AccessRecord(),role:new RoleRecord(),programGroups:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),apps:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])()};var AuthState=function(_Record){_inherits(AuthState,_Record);function AuthState(){_classCallCheck(this,AuthState);return _possibleConstructorReturn(this,(AuthState.__proto__||Object.getPrototypeOf(AuthState)).apply(this,arguments));}_createClass(AuthState,[{key:'needsLogin',value:function needsLogin(){return!this.isLoggedIn()&&!this.hasToken();}},{key:'needsTokenRefresh',value:function needsTokenRefresh(){return!this.isLoggedIn()&&this.hasToken();}},{key:'isLoggedIn',value:function isLoggedIn(){return this.loggedIn;}},{key:'hasToken',value:function hasToken(){return Boolean(this.token);}},{key:'getUserName',value:function getUserName(){return this.name;}},{key:'getToken',value:function getToken(){return this.token;}},{key:'isPowerReviewsModerator',value:function isPowerReviewsModerator(){return this.programGroups.has('PowerReviewsModerator');}},{key:'isStandardModerator',value:function isStandardModerator(){return this.isPowerReviewsModerator()&&this.isAdmin()===false&&this.isBrandEngageClient()===false;}},{key:'isQAEnabled',value:function isQAEnabled(){var _this2=this;return SOCIAL_ANSWERS_PROGRAMS.reduce(function(flag,programName){return flag||_this2.programGroups.has(programName);},false);}},{key:'isBrandEngageClient',value:function isBrandEngageClient(){return this.programGroups.has('BrandEngage');}},{key:'isInternal',value:function isInternal(){return this.isAdmin()||this.isPowerReviewsModerator();}},{key:'isAdmin',value:function isAdmin(){return this.programGroups.has('PowerReviewsModerationAdmin');}},{key:'isRunAsMode',value:function isRunAsMode(){return Boolean(__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('run_as'));}}],[{key:'getUserInfo',value:function getUserInfo(state){return{username:state.name,email:state.email,role:state.role,access:state.access};}},{key:'createFromPayload',value:function createFromPayload(payload){var program_groups=payload.program_groups,name=payload.name,email=payload.email,_apps=payload.apps,token=payload.token,profile_id=payload.profile_id;var apps=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(Object(__WEBPACK_IMPORTED_MODULE_3__normalizeModerationPaths__["a" /* default */])(_apps).map(function(_ref){var label=_ref.label,href=_ref.href;return[label,href];}));return new AuthState().withMutations(function(s){var programGroups=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(program_groups);var role=createRoleFromProgramGroups(program_groups);var access=createAccessFromRole(apps,role);s.merge({name:name,apps:apps,email:email,token:token,programGroups:programGroups,requestStatus:'complete',loggedIn:true,role:role,access:access,profile_id:profile_id});});}},{key:'createWithExistingToken',value:function createWithExistingToken(token){return new AuthState({token:token});}}]);return AuthState;}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(defaultAuthRecord));/* harmony default export */ __webpack_exports__["a"] = (AuthState);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mountCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return unmountCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requestChannelContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receiveChannelContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
var mountCollection=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('MOUNT_CHANNEL_COLLECTION',function(channelName){return channelName;});var unmountCollection=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UNMOUNT_CHANNEL_COLLECTION',function(channelName){return channelName;});var requestChannelContent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REQUEST_CHANNEL_CONTENT',function(apiMethod,channelName,endDateTime){return{apiMethod:apiMethod,channelName:channelName,endDateTime:endDateTime};});var receiveChannelContent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_CHANNEL_CONTENT',function(channelName,items){return items;},function(channelName,items){return channelName;});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAttributes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Common_StarRating__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_startCase__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaViewer__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Icons_Badges__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuthorInfo__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContentSection_scss__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContentSection_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ContentSection_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReviewSection_scss__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReviewSection_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ReviewSection_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AttributeList__ = __webpack_require__(204);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getTagAttributes(tags){var sep=', ';var out=[];if(!tags)return[];tags.forEach(function(tag){var all=[];var label=tag.label,_tag$selected=tag.selected,selected=_tag$selected===undefined?[]:_tag$selected,_tag$user_added=tag.user_added,user_added=_tag$user_added===undefined?[]:_tag$user_added;selected.forEach(function(v){return all.push(sep,v);});user_added.forEach(function(v){return all.push(sep,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer__["b" /* default */],{key:v,text:v}));});all.shift();if(all.length>0){out.push({key:label,label:label,value:all});}});return out;}function getClientSpecificQuestionAttributes(csqs){var attributes=[];if(!csqs)return attributes;var visibleCsqs=csqs.filter(function(_ref){var hidden=_ref.hidden;return hidden===false;});var hiddenCsqs=csqs.filter(function(_ref2){var hidden=_ref2.hidden;return hidden===true;});var questionToAttributeItem=function questionToAttributeItem(csq){var label=csq.label,selected=csq.selected,userAdded=csq.userAdded;var sep=', ';var value=[];selected.forEach(function(s){value.push(sep,s);});userAdded.forEach(function(s){value.push(sep,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer__["b" /* default */],{key:s,text:s}));});value.shift();attributes.push({key:label,label:label,value:value});};visibleCsqs.forEach(questionToAttributeItem);if(hiddenCsqs.size){attributes.push('Hidden Questions');hiddenCsqs.forEach(questionToAttributeItem);}return attributes;}function getAttributes(ugc,options){var tags=ugc.tags,service_comments=ugc.service_comments,clientSpecificQuestions=ugc.clientSpecificQuestions,bottom_line=ugc.bottom_line;var isClientCard=options.program==='client';var clientSpecificQuestionsForCardType=isClientCard?clientSpecificQuestions:clientSpecificQuestions.filter(function(_ref3){var hidden=_ref3.hidden;return hidden===false;});var attributes=[].concat(_toConsumableArray(getTagAttributes(tags)),_toConsumableArray(getClientSpecificQuestionAttributes(clientSpecificQuestionsForCardType)));if(bottom_line!=null){var bottomLineItem={key:'bottom_line',label:'Would Recommend to a Friend',value:bottom_line===true?'Yes':'No'};attributes.push(bottomLineItem);}if(isClientCard&&service_comments){var serviceCommentItem={key:'service_comments',label:'Service Comments',value:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer__["b" /* default */],{text:service_comments})};var indexOfFirstGroupLabel=attributes.findIndex(function(v){return typeof v==='string';});// If MSQs are being grouped, service comments should appear before any groups
if(indexOfFirstGroupLabel>-1){attributes.splice(indexOfFirstGroupLabel,0,serviceCommentItem);}else{attributes.push(serviceCommentItem);}}return attributes;}var ReviewSection={Header:function Header(props){var ugc=props.ugc,_props$ugc=props.ugc,rating=_props$ugc.rating,review_headline=_props$ugc.review_headline,reviewer_type=_props$ugc.reviewer_type;var reviewerType=ugc.source==='email'?'verified_buyer':reviewer_type;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex flex-row items-center justify-between mb2'},typeof rating==='number'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex items-stretch ReviewSection__h1'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_Common_StarRating__["a" /* default */],{rating:rating}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'ba b--moon-gray br1 flex items-center lh-solid f6 mid-gray justify-center ReviewSection__h1 ReviewSection__w1','data-key':'rating'},rating)),renderReviewBadge(reviewerType)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h2',{className:__WEBPACK_IMPORTED_MODULE_7__ContentSection_scss__["contentSectionHeader"]},review_headline&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer__["b" /* default */],{'data-key':'review_headline',text:review_headline})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__AuthorInfo__["a" /* default */],{ugc:ugc}));},Content:function Content(props){var review_comments=props.ugc.review_comments;return review_comments?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:__WEBPACK_IMPORTED_MODULE_8__ReviewSection_scss___default.a.reviewSectionComments+' ma4 mt0'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer__["b" /* default */],{'data-key':'review_comments',text:review_comments})):null;},getRelatedContent:function getRelatedContent(ugc,options){var program=options.program;var showRelatedMedia=program==='client'||program==='brand';var attributes=getAttributes(ugc,options);var relatedContent=[];if(attributes.length){relatedContent.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{key:'attributes',className:'ma4 mt0'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__AttributeList__["a" /* default */],{items:attributes})));}if(showRelatedMedia){var mediaUgcs=ugc.getMedia();if(mediaUgcs.size){relatedContent.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ma4',key:'media'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MediaViewer__["a" /* default */],{ugcs:ugc.getMedia(),hideUgcLink:program!=='client'})));}}return relatedContent;}};function renderReviewBadge(type){var IconComponent=void 0;if(type==='verified_buyer'){IconComponent=__WEBPACK_IMPORTED_MODULE_5_components_Icons_Badges__["c" /* VerifiedBuyer */];}else if(type==='verified_reviewer'){IconComponent=__WEBPACK_IMPORTED_MODULE_5_components_Icons_Badges__["d" /* VerifiedReviewer */];}else if(type==='staff_reviewer'){IconComponent=__WEBPACK_IMPORTED_MODULE_5_components_Icons_Badges__["b" /* StaffReviewer */];}else if(type==='staff_expert'){IconComponent=__WEBPACK_IMPORTED_MODULE_5_components_Icons_Badges__["a" /* ExpertReviewer */];}return IconComponent?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_8__ReviewSection_scss___default.a.reviewSectionBadge},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconComponent,{className:__WEBPACK_IMPORTED_MODULE_8__ReviewSection_scss___default.a.reviewSectionBadgeIcon}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_8__ReviewSection_scss___default.a.reviewSectionBadgeLabel},__WEBPACK_IMPORTED_MODULE_3_lodash_startCase___default()(type))):null;}/* harmony default export */ __webpack_exports__["a"] = (ReviewSection);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(82)["default"];
var assertThisInitialized = __webpack_require__(46);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 124 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(192);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(443));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(64));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(38));

var _CellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(445));

var _maxElementSize = __webpack_require__(446);

var _types = __webpack_require__(34);

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager =
/*#__PURE__*/
function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === void 0 ? (0, _maxElementSize.getMaxElementSize)() : _ref$maxScrollSize,
        params = (0, _objectWithoutProperties2["default"])(_ref, ["maxScrollSize"]);
    (0, _classCallCheck2["default"])(this, ScalingCellSizeAndPositionManager);
    (0, _defineProperty2["default"])(this, "_cellSizeAndPositionManager", void 0);
    (0, _defineProperty2["default"])(this, "_maxScrollSize", void 0);
    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager["default"](params);
    this._maxScrollSize = maxScrollSize;
  }

  (0, _createClass2["default"])(ScalingCellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;
      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;
      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });
      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;
      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);
  return ScalingCellSizeAndPositionManager;
}();

exports["default"] = ScalingCellSizeAndPositionManager;

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(39);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var filterNested = function filterNested(nodes) {
  var l = nodes.length;
  for (var i = 0; i < l; i += 1) {
    var _loop = function _loop(j) {
      if (i !== j) {
        if (nodes[i].contains(nodes[j])) {
          return {
            v: filterNested(nodes.filter(function (x) {
              return x !== nodes[j];
            }))
          };
        }
      }
    };

    for (var j = 0; j < l; j += 1) {
      var _ret = _loop(j);

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  }
  return nodes;
};

var getTopParent = function getTopParent(node) {
  return node.parentNode ? getTopParent(node.parentNode) : node;
};

var getAllAffectedNodes = function getAllAffectedNodes(node) {
  var nodes = Object(__WEBPACK_IMPORTED_MODULE_1__array__["b" /* asArray */])(node);
  return nodes.filter(Boolean).reduce(function (acc, currentNode) {
    var group = currentNode.getAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_GROUP"]);
    acc.push.apply(acc, group ? filterNested(Object(__WEBPACK_IMPORTED_MODULE_1__array__["c" /* toArray */])(getTopParent(currentNode).querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_GROUP"] + '="' + group + '"]:not([' + __WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_DISABLED"] + '="disabled"])'))) : [currentNode]);
    return acc;
  }, []);
};

/* harmony default export */ __webpack_exports__["a"] = (getAllAffectedNodes);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(489)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SectionSeperator=function SectionSeperator(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'b--none bg-light-gray ma0 pa0',style:{height:'2px'}});};/* harmony default export */ __webpack_exports__["a"] = (SectionSeperator);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionAside_scss__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionAside_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ActionAside_scss__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var ActionAsideSection=function ActionAsideSection(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__ActionAside_scss__["actionAsideSection"]},props.heading&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:__WEBPACK_IMPORTED_MODULE_1__ActionAside_scss__["actionAsideSectionHeading"]},props.heading),props.children);};var ActionAsideSectionFirst=function ActionAsideSectionFirst(props){var children=props.children,rest=_objectWithoutProperties(props,['children']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ActionAsideSection,rest,props.children,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('hr',{className:__WEBPACK_IMPORTED_MODULE_1__ActionAside_scss__["actionAsideHr"]}));};ActionAsideSection.First=ActionAsideSectionFirst;/* harmony default export */ __webpack_exports__["a"] = (ActionAsideSection);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var Card=function Card(props){var _props$className=props.className,propClassName=_props$className===undefined?'':_props$className,children=props.children,_props$verticalSpacin=props.verticalSpacing,verticalSpacing=_props$verticalSpacin===undefined?4:_props$verticalSpacin,rest=_objectWithoutProperties(props,['className','children','verticalSpacing']);var className='mv'+verticalSpacing+' bg-white br1 '+propClassName;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',Object.assign({className:className},rest,{style:{boxShadow:'0 2px 2px 0 rgba(0,0,0,.24)'}}),children);};/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchClientCatalog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return storeClientCatalog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectClientCatalog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
// profiles
var fetchClientCatalog=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/catalog/fetch',function(clientId){return clientId;});var storeClientCatalog=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/catalog/store',function(payload){return payload;},function(_,clientId){return clientId;});var selectClientCatalog=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/catalog/select',function(catalogId){return catalogId;});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchModerationAlertConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return storeModerationAlertConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestModerationAlertUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receiveModerationAlertUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearModerationAlertUpdateStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
var fetchModerationAlertConfig=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/moderation-alerts/fetch',function(clientId){return clientId;});var storeModerationAlertConfig=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/moderation-alerts/store',function(payload){return payload;},function(_,clientId){return clientId;});var requestModerationAlertUpdate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/moderation-alerts/update/request',function(payload){return payload;},function(_,meta){return meta;});var receiveModerationAlertUpdate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/moderation-alerts/update/response',function(payload){return payload;},function(_,meta){return meta;});var clearModerationAlertUpdateStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/moderation-alerts/update/clear',function(payload){return payload;});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requestContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receiveContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateCurrentUgcId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receivePreviousUgcIdUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestPreviousUgcIdUpdate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
var requestContent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('MODERATE_CONTENT_REQUEST',function(payload){return payload;});var receiveContent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('MODERATE_CONTENT_RESPONSE',function(payload){return payload;});var updateCurrentUgcId=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UPDATE_CURRENT_UGC_ID',function(payload){return payload;});var receivePreviousUgcIdUpdate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_PREVIOUS_UGC_ID_UPDATE',function(payload){return payload;});var requestPreviousUgcIdUpdate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REQUEST_PREVIOUS_UGC_ID_UPDATE');

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mountSecondOpinion */
/* unused harmony export unmountSecondOpinion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receiveContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
var mountSecondOpinion=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('MOUNT_SECOND_OPINION',function(payload){return payload;});var unmountSecondOpinion=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('UNMOUNT_SECOND_OPINION');var requestContent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SECOND_OPINION_CONTENT_REQUEST',function(payload){return payload;});var receiveContent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('SECOND_OPINION_CONTENT_RESPONSE',function(payload){return payload;});

/***/ }),
/* 137 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var getDaysInMonth = __webpack_require__(237)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ducks_coreDataReducer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ContentSection_ReviewResponse__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_client_ClientProvider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ducks_auth_context__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_client_UgcAssignmentContainer__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_client_UgcSiteStatus__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_client_UgcFeaturedMedia__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_ContentSection_future___ = __webpack_require__(682);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultLocale='en_US';var ClientCard=function(_React$Component){_inherits(ClientCard,_React$Component);function ClientCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientCard.__proto__||Object.getPrototypeOf(ClientCard)).call.apply(_ref,[this].concat(args))),_this),_this.state={pendingResponse:'',isEditingResponse:false},_this.actions=Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({updateObservations:__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["o" /* updateObservations */],updateSiteStatus:__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["p" /* updateSiteStatus */],requestObservationsUpdate:__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["n" /* requestObservationsUpdate */],requestAddResponse:__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["k" /* requestAddResponse */],requestDeleteResponse:__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["l" /* requestDeleteResponse */],requestEditResponse:__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["m" /* requestEditResponse */]},_this.props.dispatch),_this.addResponse=function(){var ugc=_this.props.datum.ugc;var subject=_this.props.datum.subject;var isEdittingMerchantResponse=ugc.ugc_archetype==='Review'&&_this.state.isEditingResponse;var addPayload={parent_ugc_id:ugc.ugc_id,subject_id:subject.subject_id,catalog_id:subject.merchant.id,text:_this.state.pendingResponse,ugc_type:ugc.ugc_archetype==='Review'?'MerchantResponse':'Answer',locale:defaultLocale};if(isEdittingMerchantResponse){// $FlowFixMe
var merchantResponse=__WEBPACK_IMPORTED_MODULE_6_models__["j" /* UGC */].getMerchantResponse(ugc);var editPayload=Object.assign({},addPayload,{ugc_id:merchantResponse.ugc_id});_this.actions.requestEditResponse(editPayload,ugc.ugc_id);}else{_this.actions.requestAddResponse(addPayload,ugc.ugc_id);}},_this.editMerchantResponse=function(){// $FlowFixMe
var ugc=_this.props.datum.ugc;var merchantResponse=__WEBPACK_IMPORTED_MODULE_6_models__["j" /* UGC */].getMerchantResponse(ugc);_this.setState({isEditingResponse:true,pendingResponse:merchantResponse.text});},_this.deleteMerchantResponse=function(){// $FlowFixMe
var ugc=_this.props.datum.ugc;var merchantResponse=__WEBPACK_IMPORTED_MODULE_6_models__["j" /* UGC */].getMerchantResponse(ugc);global.confirm('Delete Response?')&&_this.actions.requestDeleteResponse(merchantResponse.ugc_id,ugc.ugc_id);},_this.handlePendingResponseChange=function(value){_this.setState(function(prevState){return{pendingResponse:value,isEditingResponse:prevState.isEditingResponse&&!value?false:prevState.isEditingResponse};});},_this.getTextBoxProps=function(){var responseRequestStatus=_this.props.datum.responseRequestStatus;return{onSubmit:_this.addResponse,onChange:_this.handlePendingResponseChange,value:_this.state.pendingResponse,status:responseRequestStatus};},_this.renderTextBox=function(){var _this$props$datum=_this.props.datum,ugc=_this$props$datum.ugc,ugc_archetype=_this$props$datum.ugc.ugc_archetype;var isEditingResponse=_this.state.isEditingResponse;var el=null;if(ugc_archetype==='Review'){// render textbox is there is no merchant response
// or the current is being editted
// $FlowFixMe
var reviewHasNoMerchantResponse=!__WEBPACK_IMPORTED_MODULE_6_models__["j" /* UGC */].getMerchantResponse(ugc);var isUpdatedReview=ugc.old_ugc_id!==null?true:false;var shouldEnableMerchantResponse=(isEditingResponse||reviewHasNoMerchantResponse)&&!isUpdatedReview;el=shouldEnableMerchantResponse?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MerchantResponseTextBox,_this.getTextBoxProps()):null;}return el?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ma4'},el):el;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientCard,[{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){// clear responseStates after success status
var _props$datum=this.props.datum,deleteResponseRequestStatus=_props$datum.deleteResponseRequestStatus,responseRequestStatus=_props$datum.responseRequestStatus;var _nextProps$datum=nextProps.datum,nextDeleteResponseRequestStatus=_nextProps$datum.deleteResponseRequestStatus,nextResponseRequestStatus=_nextProps$datum.responseRequestStatus;// clear pendingResponse after new response is added
if(responseRequestStatus!==nextResponseRequestStatus&&responseRequestStatus&&!nextResponseRequestStatus){this.setState({pendingResponse:'',isEditingResponse:false});}if(deleteResponseRequestStatus!==nextDeleteResponseRequestStatus&&deleteResponseRequestStatus&&!nextDeleteResponseRequestStatus){//this.setState()
}}},{key:'beforeMetaContent',value:function beforeMetaContent(datum,isEditingResponse){var ugc=datum.ugc,deleteResponseRequestStatus=datum.deleteResponseRequestStatus;var fragments=[];if(ugc instanceof __WEBPACK_IMPORTED_MODULE_6_models__["i" /* Review */]){var brandResponse=ugc.getBrandResponse();var merchantResponse=ugc.getMerchantResponse();var showMerchantResponse=isEditingResponse===false;if(merchantResponse&&showMerchantResponse){fragments.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex pa4',key:'merchant-response',style:{opacity:deleteResponseRequestStatus==='pending'?0.3:1}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex-auto'},deleteResponseRequestStatus instanceof Error&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'tc ph2 pv1 f6 mv1 dib br1',style:{color:'#C23030',backgroundColor:'#FFDDDD'}},'Could not delete response'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_ContentSection_ReviewResponse__["a" /* SimpleResponse */],{ugc:merchantResponse})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex-none'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["d" /* ButtonGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](EditResponseButton,{onClick:this.editMerchantResponse},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](EditResponseButton,{onClick:this.deleteMerchantResponse},'Delete')))));}if(brandResponse){fragments.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'pa4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_ContentSection_ReviewResponse__["a" /* SimpleResponse */],{key:'brand-response',ugc:brandResponse})));}}return fragments.length?fragments:null;}},{key:'render',value:function render(){var _this2=this;var _props$datum2=this.props.datum,ugc=_props$datum2.ugc,moderationState=_props$datum2.moderationState,subject=_props$datum2.subject,submitStatus=_props$datum2.observationRequestStatus,pendingSiteStatus=_props$datum2.pendingSiteStatus;var ENABLE_UGC_EDITING='ENABLE_UGC_EDITING';return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_ducks_auth_context__["a" /* AuthContext */].Consumer,null,function(authState){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_containers_client_ClientProvider__["a" /* ClientContext */].Consumer,null,function(_ref2){var clientId=_ref2.clientId,userProfiles=_ref2.userProfiles,expertUserProfiles=_ref2.expertUserProfiles,properties=_ref2.properties;var isNativeContent=subject.merchant.group_id===clientId;var userProfilesForAssignment=function(){if(ugc.ugctype==='Review')return userProfiles;if(ugc.ugctype==='Question')return expertUserProfiles;return undefined;}();var showUgcAssignment=function(){if(!Array.isArray(userProfilesForAssignment))return false;if(ugc.ugctype==='Review'){return isNativeContent;}else if(ugc.ugctype==='Question'){return authState.isQAEnabled()&&isNativeContent;}return false;}();var allowMedia=__WEBPACK_IMPORTED_MODULE_13_immutable__["Map"].isMap(properties)?properties.get('ENABLE_VISUAL_ANSWERS',false):false;var isMedia=ugc.ugctype==='Image'||ugc.ugctype==='Video';var enableFeaturedMedia=__WEBPACK_IMPORTED_MODULE_13_immutable__["Map"].isMap(properties)?properties.get('ENABLE_MEDIA_FEATURED_FLAG',false):false;var isFeaturedMedia=isMedia&&ugc.featured===true;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["f" /* ClientModerationCard */],{product:subject,moderationState:moderationState,ugc:ugc,clientId:clientId,onChange:_this2.actions.updateObservations,onSiteStatusChange:_this2.actions.updateSiteStatus,status:submitStatus,onSubmit:_this2.actions.requestObservationsUpdate,authToken:authState.getToken(),shouldEnableUgcEditing:__WEBPACK_IMPORTED_MODULE_13_immutable__["Map"].isMap(properties)?properties.get(ENABLE_UGC_EDITING,false):false},ugc.ugc_archetype==='Answer'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["f" /* ClientModerationCard */].ContentSection,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_components_ContentSection_future___["b" /* AnswerSection */],{ugc:ugc,subject:subject,locale:defaultLocale,allowMedia:allowMedia})),ugc.ugc_archetype==='Question'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["f" /* ClientModerationCard */].ContentSection,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_components_ContentSection_future___["c" /* QuestionSection */],{ugc:ugc,subject:subject,locale:defaultLocale,allowMedia:allowMedia},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_components_ContentSection_future___["a" /* AddAnswer */],{questionId:ugc.ugc_id,subject:subject,locale:defaultLocale,allowMedia:allowMedia,onSubmit:function onSubmit(newAnswer){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["q" /* updateUgc */])(function(ugc){return ugc.updateIn(['ugc_related_content'],function(v){return v.push(newAnswer);});},ugc.ugc_id));}}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["f" /* ClientModerationCard */].Aside,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_containers_client_UgcSiteStatus__["a" /* default */],{published:pendingSiteStatus||ugc.published,onChange:function onChange(desiredPublished){return _this2.actions.updateSiteStatus({moderationState:moderationState,desiredPublished:desiredPublished},{clientId:clientId,ugctype:ugc.ugctype,ugcClientId:subject.merchant.group_id});}}),isMedia&&enableFeaturedMedia&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_containers_client_UgcFeaturedMedia__["a" /* UgcFeaturedMedia */],{ugc_id:ugc.ugc_id,ugc_type:ugc.ugctype,featured:isFeaturedMedia,onSubmit:function onSubmit(res){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["q" /* updateUgc */])(res,ugc.ugc_id));}})),showUgcAssignment&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["f" /* ClientModerationCard */].Aside,{label:'Assign to a Team member'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_containers_client_UgcAssignmentContainer__["a" /* default */],{userProfiles:userProfilesForAssignment,ugc:ugc,clientId:clientId})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["f" /* ClientModerationCard */].BeforeMeta,null,_this2.beforeMetaContent(_this2.props.datum,_this2.state.isEditingResponse)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["f" /* ClientModerationCard */].AfterMeta,null,_this2.renderTextBox()));});});}}]);return ClientCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ClientCard);function MerchantResponseTextBox(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["o" /* ResponseTextBox */],Object.assign({placeholder:'Add a response to this review...',buttonLabel:'Add Response'},props));}function EditResponseButton(props){var className=__WEBPACK_IMPORTED_MODULE_7_classnames___default()('button-reset bg-animate pointer br1 blue hover-dark-blue ph3 pv2 lh-solid hover-shadow bg-white');return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',Object.assign({type:'button',className:className},props));}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ContentSection_CollapsedBlock__ = __webpack_require__(87);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentSection=function(_React$Component){_inherits(ContentSection,_React$Component);function ContentSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContentSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContentSection.__proto__||Object.getPrototypeOf(ContentSection)).call.apply(_ref,[this].concat(args))),_this),_this.state={metaExpanded:false},_this.toggleMeta=function(){_this.setState(function(prevState){return{metaExpanded:!prevState.metaExpanded};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContentSection,[{key:'render',value:function render(){var _this2=this;var children=__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(this.props.children,function(el){if(el&&el.type===ContentSection.Meta){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_ContentSection_CollapsedBlock__["a" /* default */],{label:el.props.label||'Meta Info',open:_this2.state.metaExpanded,onClick:_this2.toggleMeta},el.props.children);}return el;});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',null,children);}}]);return ContentSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContentSection.Header=function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('header',null,props.children);};ContentSection.Section=function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',{className:'ma4'},props.children);};ContentSection.Divider=function(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('hr',{className:'bt b--solid b--light-gray'});};ContentSection.Meta=function(props){return null;};

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MediaUploadControl__ = __webpack_require__(688);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__MediaUploadControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CaptionTextarea__ = __webpack_require__(696);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__CaptionTextarea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useMediaUpload__ = __webpack_require__(698);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__useMediaUpload__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__useMediaUpload__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__useMediaUpload__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaThumbnail__ = __webpack_require__(699);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__MediaThumbnail__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__MediaThumbnail__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResourceTypes__ = __webpack_require__(72);
/* unused harmony namespace reexport */


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return openAnswerEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return editAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return editAnswerSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteAnswerSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
var openAnswerEditor=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc/answer/begin-edit',function(ugcId){return ugcId;});var editAnswer=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc/answer/edit',function(payload){return payload;});var editAnswerSync=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc/answer/sync',function(payload){return payload;},function(_,payload){return payload;});var deleteAnswer=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc/answer/delete',function(payload){return payload;});var deleteAnswerSync=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc/answer/delete-sync',function(payload){return payload;},function(_,payload){return payload;});var resetView=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@ugc/answer/cancel-edit',function(ugcId){return ugcId;});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requestChannelStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestBrandEngageChannelStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receiveChannelStats; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
// Channel Stats
var requestChannelStats=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@channels/CHANNEL_STATS_REQUEST',function(payload){return payload;});var requestBrandEngageChannelStats=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@channels/CHANNEL_STATS_BRAND_REQUEST',function(payload){return payload;});var receiveChannelStats=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@channels/CHANNEL_STATS_RESPONSE',function(channelStats,meta){return channelStats;},function(channelStats,meta){return meta;});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return requestBrandEngageAddResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receiveBrandEngageAddResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return requestBrandEngageSearchResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receiveBrandEngageSearchResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return requestBrandEngageDismissContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receiveBrandEngageDismissContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeDismissedItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
var requestBrandEngageAddResponse=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ADD_BRAND_ENGAGE_RESPONSE_REQUEST',function(payload){return payload;},function(_,parent_ugc_id){return parent_ugc_id;});var receiveBrandEngageAddResponse=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ADD__BRAND_ENGAGE_RESPONSE',function(payload){return payload;},function(_,parent_ugc_id){return parent_ugc_id;});var requestBrandEngageSearchResults=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REQUEST_BRAND_ENGAGE_SEARCH',function(payload){return payload;});var receiveBrandEngageSearchResults=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_BRAND_ENGAGE_SEARCH',function(payload){return payload;},function(_,meta){return meta;});var requestBrandEngageDismissContent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REQUEST_BRAND_ENGAGE_DISMISS',function(payload){return payload;},function(_,ugc_id){return ugc_id;});var receiveBrandEngageDismissContent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('RECEIVE_BRAND_ENGAGE_DISMISS',function(payload){return payload;},function(_,ugc_id){return ugc_id;});var removeDismissedItem=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('REMOVE_BRAND_ENGAGE_DISMISSED_CONTENT',function(payload){return payload;});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requestClientQueueContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receiveClientQueueContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receiveClientQueueError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
var requestClientQueueContent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLIENT_QUEUE_CONTENT_REQUEST',function(payload){return payload;});var receiveClientQueueContent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLIENT_QUEUE_CONTENT_RESPONSE',function(payload){return payload;});var receiveClientQueueError=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLIENT_QUEUE_CONTENT_ERROR',function(payload){return payload;});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(275);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(148);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(288);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(301);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(300);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(294);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(158);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(104);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(42);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(161);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(107);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(321)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(166);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(74);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(18);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value.length === 0;
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value.toString();
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'string';
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value === null || value === undefined;
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_to_camel_case__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_to_camel_case___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_to_camel_case__);

var namespacer = '/';
/* harmony default export */ __webpack_exports__["a"] = (function (type) {
  return type.indexOf(namespacer) === -1 ? __WEBPACK_IMPORTED_MODULE_0_to_camel_case___default()(type) : type.split(namespacer).map(__WEBPACK_IMPORTED_MODULE_0_to_camel_case___default.a).join(namespacer);
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ownKeys__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get__ = __webpack_require__(174);



/* harmony default export */ __webpack_exports__["a"] = (function (predicate) {
  return function flatten(map, _temp, partialFlatMap, partialFlatActionType) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$namespace = _ref.namespace,
        namespace = _ref$namespace === void 0 ? __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_NAMESPACE */] : _ref$namespace,
        prefix = _ref.prefix;

    if (partialFlatMap === void 0) {
      partialFlatMap = {};
    }

    if (partialFlatActionType === void 0) {
      partialFlatActionType = '';
    }

    function connectNamespace(type) {
      var _ref2;

      if (!partialFlatActionType) return type;
      var types = type.toString().split(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPE_DELIMITER */]);
      var partials = partialFlatActionType.split(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPE_DELIMITER */]);
      return (_ref2 = []).concat.apply(_ref2, partials.map(function (p) {
        return types.map(function (t) {
          return "" + p + namespace + t;
        });
      })).join(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPE_DELIMITER */]);
    }

    function connectPrefix(type) {
      if (partialFlatActionType || !prefix || prefix && new RegExp("^" + prefix + namespace).test(type)) {
        return type;
      }

      return "" + prefix + namespace + type;
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__ownKeys__["a" /* default */])(map).forEach(function (type) {
      var nextNamespace = connectPrefix(connectNamespace(type));
      var mapValue = Object(__WEBPACK_IMPORTED_MODULE_2__get__["a" /* default */])(type, map);

      if (predicate(mapValue)) {
        flatten(mapValue, {
          namespace: namespace,
          prefix: prefix
        }, partialFlatMap, nextNamespace);
      } else {
        partialFlatMap[nextNamespace] = mapValue;
      }
    });
    return partialFlatMap;
  };
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isMap__ = __webpack_require__(76);

function get(key, x) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__isMap__["a" /* default */])(x) ? x.get(key) : x[key];
}

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_identity__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_isNil__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_isUndefined__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_toString__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(55);








function handleAction(type, reducer, defaultState) {
  if (reducer === void 0) {
    reducer = __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */];
  }

  var types = Object(__WEBPACK_IMPORTED_MODULE_6__utils_toString__["a" /* default */])(type).split(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* ACTION_TYPE_DELIMITER */]);
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(!Object(__WEBPACK_IMPORTED_MODULE_5__utils_isUndefined__["a" /* default */])(defaultState), "defaultState for reducer handling " + types.join(', ') + " should be defined");
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(reducer) || Object(__WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__["a" /* default */])(reducer), 'Expected reducer to be a function or object with next and throw reducers');

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_isNil__["a" /* default */])(aReducer) ? __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */] : aReducer;
  }),
      nextReducer = _ref[0],
      throwReducer = _ref[1];

  return function (state, action) {
    if (state === void 0) {
      state = defaultState;
    }

    var actionType = action.type;

    if (!actionType || types.indexOf(Object(__WEBPACK_IMPORTED_MODULE_6__utils_toString__["a" /* default */])(actionType)) === -1) {
      return state;
    }

    return (action.error === true ? throwReducer : nextReducer)(state, action);
  };
}

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enterRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return exitRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
// The goal is to keep sagas and callbacks local to route
// When we enter a route we send associated sagas
// When we exit a route w
var enterRoute=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('ENTER_ROUTE',function(payload){return payload;});var exitRoute=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('EXIT_ROUTE');

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(366);
var util = __webpack_require__(367);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(368);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HttpError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ServerError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NetworkingError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error__ = __webpack_require__(371);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HttpError=function(_ExtendableError){_inherits(HttpError,_ExtendableError);function HttpError(message,status){_classCallCheck(this,HttpError);var _this=_possibleConstructorReturn(this,(HttpError.__proto__||Object.getPrototypeOf(HttpError)).call(this,message));_this.status=status;return _this;}return HttpError;}(__WEBPACK_IMPORTED_MODULE_0_es6_error__["a" /* default */]);var ClientError=function(_HttpError){_inherits(ClientError,_HttpError);function ClientError(){_classCallCheck(this,ClientError);return _possibleConstructorReturn(this,(ClientError.__proto__||Object.getPrototypeOf(ClientError)).apply(this,arguments));}return ClientError;}(HttpError);var ServerError=function(_HttpError2){_inherits(ServerError,_HttpError2);function ServerError(){_classCallCheck(this,ServerError);return _possibleConstructorReturn(this,(ServerError.__proto__||Object.getPrototypeOf(ServerError)).apply(this,arguments));}return ServerError;}(HttpError);var NetworkingError=function(_ExtendableError2){_inherits(NetworkingError,_ExtendableError2);function NetworkingError(){var message=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'Connection Error';_classCallCheck(this,NetworkingError);return _possibleConstructorReturn(this,(NetworkingError.__proto__||Object.getPrototypeOf(NetworkingError)).call(this,message));}return NetworkingError;}(__WEBPACK_IMPORTED_MODULE_0_es6_error__["a" /* default */]);/* harmony default export */ __webpack_exports__["e"] = ({isHttpError:function isHttpError(err){return err instanceof HttpError;},isClientError:function isClientError(err){return err instanceof ClientError;},isServerError:function isServerError(err){return err instanceof ServerError;},isNetworkingError:function isNetworkingError(err){return err instanceof NetworkingError;}});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isYoutubeVideo;
/* harmony export (immutable) */ __webpack_exports__["b"] = getYoutubeVideoID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Transform__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Resource__ = __webpack_require__(377);
function url(res){var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var accessType=res.accessType,resourceType=res.resourceType,_res$publicId=res.publicId,publicId=_res$publicId===undefined?'portal-no-product-image_ttlfpi.svg':_res$publicId;var basePathName='//res.cloudinary.com/powerreviews/'+resourceType+'/'+accessType;if(!config){return basePathName+'/'+publicId;}var params=Object(__WEBPACK_IMPORTED_MODULE_0__Transform__["a" /* mapConfigToTransform */])(config);return basePathName+'/'+params+'/'+publicId;}function urlSet(res){var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var defaultOptions={quality:'auto',format:'auto',default_image:'portal-no-product-image_ttlfpi.svg'};var accessType=res.accessType;return{raw:accessType==='youtube'?'//www.youtube.com/embed/'+res.publicId// ? '//www.youtube.com/watch?v=' + res.publicId
:url(res),thumbnail:url(res,Object.assign({},defaultOptions,{width:100,height:100,crop:'thumb'})),small:url(res,Object.assign({},defaultOptions,{width:175,height:175,crop:'lpad'})),medium:url(res,Object.assign({},defaultOptions,{width:300,height:300,crop:'lpad'})),large:url(res,Object.assign({},defaultOptions,{width:'auto',height:500})),full:url(res,Object.assign({},defaultOptions,{width:'auto',height:768}))};}function isYoutubeVideo(url){return __WEBPACK_IMPORTED_MODULE_1__Resource__["a" /* YoutubeRegex */].test(url);}function getYoutubeVideoID(url){if(!isYoutubeVideo(url))return null;return url.split(__WEBPACK_IMPORTED_MODULE_1__Resource__["a" /* YoutubeRegex */]).pop();}/* harmony default export */ __webpack_exports__["a"] = ({url:url,urlSet:urlSet,libraryUrlSet:function libraryUrlSet(url){var res=Object(__WEBPACK_IMPORTED_MODULE_1__Resource__["c" /* createUploadedImageResource */])(url);return urlSet(res);},fetchUrlSet:function fetchUrlSet(url){var res=Object(__WEBPACK_IMPORTED_MODULE_1__Resource__["b" /* createProductImageResource */])(url?url:'http://httpstat.us/404');return urlSet(res);},libraryVideoUrlSet:function libraryVideoUrlSet(url){var res=Object(__WEBPACK_IMPORTED_MODULE_1__Resource__["d" /* createUploadedVideoResource */])(url);return urlSet(res);},youtubeUrlSet:function youtubeUrlSet(url){var res=Object(__WEBPACK_IMPORTED_MODULE_1__Resource__["e" /* createYoutubeVideoResource */])(url);return urlSet(res);},isYoutubeVideo:isYoutubeVideo,getYoutubeVideoID:getYoutubeVideoID});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(378),
    deburr = __webpack_require__(379),
    words = __webpack_require__(386);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(60),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observation__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_async_value__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import PublicationStance from './PublicationStance';
var defaultModerationStateShape={ugcId:0,provisionedObservationTypeCodes:new Set(),savedObservations:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](),currentObservations:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](),observationTypes:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](),savedPublished:null,currentPublished:null};var EMPTY_OBSERVATION_DATA={};var EMPTY_MAP=new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"]();var PowerReviewsClientId=1;var PowerReviewsModerationContext=PowerReviewsClientId;var ModerationState=function(_Record){_inherits(ModerationState,_Record);function ModerationState(){_classCallCheck(this,ModerationState);return _possibleConstructorReturn(this,(ModerationState.__proto__||Object.getPrototypeOf(ModerationState)).apply(this,arguments));}_createClass(ModerationState,[{key:'getId',value:function getId(){return this.getUGCId();}},{key:'getUGCId',value:function getUGCId(){return this.get('ugcId');}}],[{key:'create',value:function create(observationTypes,payload){var _payload$existing_obs=payload.existing_observations,existing_observations=_payload$existing_obs===undefined?[]:_payload$existing_obs,_payload$pwr_observat=payload.pwr_observations,pwr_observations=_payload$pwr_observat===undefined?[]:_payload$pwr_observat,_payload$custom_obser=payload.custom_observations,custom_observations=_payload$custom_obser===undefined?[]:_payload$custom_obser,_payload$ugc=payload.ugc,published=_payload$ugc.published,ugc_id=_payload$ugc.ugc_id;var savedObservations=new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"]().withMutations(function(mp){existing_observations.forEach(function(item){var observation_type_code=item.observation_type_code,client_id=item.client_id;var observationType=observationTypes.get(observation_type_code);if(observationType&&client_id){var ob=__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].createWithData(Object.assign({},item,{name:observationType.name}),true);mp.has(client_id)?mp.setIn([client_id,observation_type_code],ob):mp.set(client_id,new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](_defineProperty({},observation_type_code,ob)));}});});var provisionedObservationTypeCodes=new Set([].concat(_toConsumableArray(pwr_observations),_toConsumableArray(custom_observations)));var currentObservations=savedObservations;return new ModerationState({savedObservations:savedObservations,currentObservations:currentObservations,provisionedObservationTypeCodes:provisionedObservationTypeCodes,observationTypes:observationTypes,ugcId:ugc_id,savedPublished:published,currentPublished:published});}},{key:'setObservation',value:function setObservation(state,context,observation_type_code){var observation_data=arguments.length>3&&arguments[3]!==undefined?arguments[3]:EMPTY_OBSERVATION_DATA;var observationType=state.observationTypes.get(observation_type_code);if(!state.currentObservations.has(context)){state.setIn(['currentObservations',context],EMPTY_MAP);}if(observationType){// we should try restoring saved observations
var _savedObservations=ModerationState.getSavedObservations(state,context);var observationToSet=_savedObservations.has(observation_type_code)?_savedObservations.get(observation_type_code):__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].createWithData(Object.assign({},observationType,{observation_data:observation_data}),true);var currentObservationsHasContext=state.currentObservations.has(context);return currentObservationsHasContext?state.setIn(['currentObservations',context,observation_type_code],observationToSet):state.setIn(['currentObservations',context],new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](_defineProperty({},observation_type_code,observationToSet)));}return state;}},{key:'removeObservation',value:function removeObservation(state,context,observation_type_code){return state.deleteIn(['currentObservations',context,observation_type_code]);}},{key:'toggleObservation',value:function toggleObservation(state,context,observation_type_code){var action=state.hasIn(['currentObservations',context,observation_type_code])?ModerationState.removeObservation:ModerationState.setObservation;return action(state,context,observation_type_code);}},{key:'applyPowerModeration',value:function applyPowerModeration(state){return state.withMutations(function(st){ModerationState.setObservation(st,PowerReviewsModerationContext,__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].PowerModerationCode);// moderation service breaks from convention and throws an error if SO
// is included
ModerationState.removeObservation(st,PowerReviewsModerationContext,__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].SecondOpinionCode);});}},{key:'applyClientModeration',value:function applyClientModeration(state,context){return ModerationState.setObservation(state,context,__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].ClientModerationCode);}},{key:'applySecondOpinion',value:function applySecondOpinion(state,comments){return ModerationState.setObservation(state,PowerReviewsModerationContext,__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].SecondOpinionCode,{comments:comments});}},{key:'createRequestPayload',value:function createRequestPayload(state,context){var mapToPayloadItem=function mapToPayloadItem(ob){return{observation_type_code:ob.observation_type_code,observation_data:ob.observation_data||{},client_id:context};};var items=state.getIn(['currentObservations',context]);return items?items.map(mapToPayloadItem).toArray():[];}},{key:'commitObservationBlobs',value:function commitObservationBlobs(state,context,payload){var entries=payload.reduce(function(acc,item){var observation_type_code=item.observation_type_code,client_id=item.client_id;if(client_id!==context){return acc;}var observationType=state.observationTypes.get(observation_type_code);if(observationType){var ob=__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].createWithData(Object.assign({},item,{name:observationType.name}),true);acc.push([observation_type_code,ob]);}return acc;},[]);var savedObservationsForContext=new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](entries);return state.withMutations(function(it){it.set('savedPublished',it.currentPublished);it.setIn(['savedObservations',context],savedObservationsForContext);it.setIn(['currentObservations',context],savedObservationsForContext);});}},{key:'isPowerReviewsModerated',value:function isPowerReviewsModerated(state){return state.hasIn(['savedObservations',PowerReviewsModerationContext,__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].PowerModerationCode]);}},{key:'isClientModerated',value:function isClientModerated(state,context){return state.hasIn(['savedObservations',context,__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].ClientModerationCode]);}},{key:'hasSecondOpinion',value:function hasSecondOpinion(state){return state.hasIn(['savedObservations',PowerReviewsModerationContext,__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].SecondOpinionCode]);}},{key:'needsSecondOpinion',value:function needsSecondOpinion(state){var isPowerReviewsModerated=ModerationState.isPowerReviewsModerated(state);var hasSecondOpinion=ModerationState.hasSecondOpinion(state);return!isPowerReviewsModerated&&hasSecondOpinion;}},{key:'getActionableObservations',value:function getActionableObservations(state,context){var provisioned=state.provisionedObservationTypeCodes;var currentObservations=ModerationState.getCurrentObservations(state,context);return state.observationTypes.reduce(function(acc,observationType){var code=observationType.observation_type_code;var observation=currentObservations.has(code)?currentObservations.get(code):observationType;// we should not show SSC in PWR moderation under any condition
if(code===__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].ShowServiceComment&&context===PowerReviewsModerationContext){return acc;}var shouldAdd=true;shouldAdd=shouldAdd&&provisioned.has(code);shouldAdd=shouldAdd&&__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].IsEditableObservationTypeCode(code);if(shouldAdd){acc.push(observation);}return acc;},[]);}},{key:'getSavedActionableObservations',value:function getSavedActionableObservations(state,context){var provisioned=state.provisionedObservationTypeCodes;var savedObservations=ModerationState.getSavedObservations(state,context);return state.observationTypes.valueSeq().map(function(observation){return savedObservations.has(observation.observation_type_code)?savedObservations.get(observation.observation_type_code):observation;}).filter(function(_ref3){var observation_type_code=_ref3.observation_type_code;return provisioned.has(observation_type_code);}).filter(__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].IsEditableObservation).toArray();}},{key:'getSavedObservations',value:function getSavedObservations(state,context){return state.savedObservations.get(context,EMPTY_MAP);}},{key:'getCurrentObservations',value:function getCurrentObservations(state,context){return state.currentObservations.get(context,EMPTY_MAP);}},{key:'isEqual',value:function isEqual(state,context){// moderation status has changed when existing != current
var saved=ModerationState.getSavedObservations(state,context);var current=ModerationState.getCurrentObservations(state,context);if(saved.size!==current.size){return false;}// $FlowFixMe
return saved.equals(current);}},{key:'isModified',value:function isModified(state,context){return ModerationState.isEqual(state,context)===false;}},{key:'clearPublicationOverrides',value:function clearPublicationOverrides(state,context){return state.withMutations(function(st){ModerationState.removeObservation(st,context,__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].PublicationOverrideCode);ModerationState.removeObservation(st,context,__WEBPACK_IMPORTED_MODULE_1__Observation__["a" /* default */].NotForPublicationOverrideCode);});}},{key:'isSavedPublished',value:function isSavedPublished(state,context){return state.savedPublished;}},{key:'isCurrentPublished',value:function isCurrentPublished(state,context){return state.currentPublished;}},{key:'setCurrentPublished',value:function setCurrentPublished(state,v){return state.set('currentPublished',v);}}]);return ModerationState;}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(defaultModerationStateShape));ModerationState.PowerReviewsModerationContext=PowerReviewsModerationContext;/* harmony default export */ __webpack_exports__["a"] = (ModerationState);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function cleanTagValue(selected,choices){var choiceSet=new __WEBPACK_IMPORTED_MODULE_0_immutable__["Set"](choices);var selectedChoices=[];var userAdded=[];selected.forEach(function(selectedChoice){var isUserAdded=!choiceSet.has(selectedChoice);if(isUserAdded){userAdded.push(selectedChoice);}else{selectedChoices.push(selectedChoice);}});return{selected:selectedChoices,userAdded:userAdded};}var ClientSpecificQuestion=function(){function ClientSpecificQuestion(label,selected,userAdded,hidden){_classCallCheck(this,ClientSpecificQuestion);this.label=label;this.selected=selected;this.userAdded=userAdded;this.hidden=hidden;}_createClass(ClientSpecificQuestion,null,[{key:'create',value:function create(csqObject){var type=csqObject.type,_id=csqObject.id,_label=csqObject.label,value=csqObject.value,_csqObject$do_not_dis=csqObject.do_not_display,hidden=_csqObject$do_not_dis===undefined?false:_csqObject$do_not_dis;var label=_label||_id;var selected=[];var userAdded=[];if(type==='sub_rating'&&typeof value==='number'){selected.push(String(value));}else if(type==='text'&&Array.isArray(value)){var _selected;(_selected=selected).push.apply(_selected,_toConsumableArray(value));}else if(type==='text'&&typeof value==='string'){selected.push(value);}else if(type==='tag'&&!Array.isArray(value)&&(typeof value==='undefined'?'undefined':_typeof(value))==='object'){var cleanedValue=cleanTagValue(value.selected,value.choices);selected=cleanedValue.selected;userAdded=cleanedValue.userAdded;}return new ClientSpecificQuestion(label,selected,userAdded,hidden);}}]);return ClientSpecificQuestion;}();/* harmony default export */ __webpack_exports__["a"] = (ClientSpecificQuestion);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmptyList__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuestionRecord=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({ugc_id:null,subject_id:null,ugctype:'Question',ugc_archetype:'Question',created_date:'',updated_date:'',published:null,assigned_to:null,assigned_by:null,assignment_created_date:null,assignment_updated_date:null,merchant_user_id:'',author:'',location:'',question:'',email:'',source:'',ip_address:'',device_id:'',question_type:'',question_category_type:'',locale:'',ugc_related_content:__WEBPACK_IMPORTED_MODULE_1__EmptyList__["a" /* default */]});var Question=function(_QuestionRecord){_inherits(Question,_QuestionRecord);function Question(){_classCallCheck(this,Question);return _possibleConstructorReturn(this,(Question.__proto__||Object.getPrototypeOf(Question)).apply(this,arguments));}_createClass(Question,[{key:'getAnswers',value:function getAnswers(){return this.ugc_related_content.filter(function(ugc){return ugc.ugc_archetype==='Answer';});}},{key:'getMedia',value:function getMedia(){var _this2=this;return this.ugc_related_content.filter(function(ugc){return ugc.ugctype==='Image'||ugc.ugctype==='Video';}).filter(function(ugc){return ugc.parent_ugc_id===_this2.ugc_id;});}}],[{key:'createWithData',value:function createWithData(data){return new Question(Object.assign({},data));}}]);return Question;}(QuestionRecord);/* harmony default export */ __webpack_exports__["a"] = (Question);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MediaViewer__ = __webpack_require__(415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MediaViewer__["a"]; });


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var CloseIcon=function CloseIcon(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},style=_ref.style,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 298.7 298.5',enableBackground:'new 0 0 298.7 298.5',preserveAspectRatio:'xMidYMid',style:style,className:className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{fill:'currentColor',fillRule:'evenodd',clipRule:'evenodd',d:'M185.3,149.3L295.6,39c3.9-3.8,3.9-10.2,0-14.1L273.6,2.9 c-3.8-3.9-10.2-3.9-14.1,0L149.2,113.2L38.9,2.9C35.1-1,28.7-1,24.8,2.9L2.9,24.8C-1,28.7-1,35.1,2.8,39l110.3,110.3L2.9,259.5 c-3.9,3.8-3.9,10.2,0,14.1l21.8,21.9c3.9,3.9,10.3,3.9,14.2,0l110.2-110.2l110.2,110.2c3.8,3.9,10.2,3.9,14.1,0l21.9-21.9 c3.9-3.8,3.9-10.2,0-14.1L185.3,149.3z'}));};CloseIcon.propTypes={style:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,className:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};CloseIcon.defaultProps={style:null,className:''};/* harmony default export */ __webpack_exports__["a"] = (CloseIcon);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader_scss__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Loader_scss__);
var Loader=function Loader(_ref){var size=_ref.size,fallbackText=_ref.fallbackText,thickness=_ref.thickness,animationDuration=_ref.duration;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__Loader_scss___default.a.loader,style:{width:size,height:size,borderWidth:thickness,animationDuration:animationDuration}});};/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncCreatable", function() { return AsyncCreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creatable", function() { return CreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Value", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuRenderer", function() { return menuRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultArrowRenderer", function() { return arrowRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultClearRenderer", function() { return clearRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFilterOptions", function() { return filterOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["default"] = (Select$1);


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(82)["default"];
var toPrimitive = __webpack_require__(436);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 192 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["clsx"] = clsx;
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["default"] = (clsx);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultOverscanIndicesGetter;
exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = void 0;

var _types = __webpack_require__(34);

var SCROLL_DIRECTION_BACKWARD = -1;
exports.SCROLL_DIRECTION_BACKWARD = SCROLL_DIRECTION_BACKWARD;
var SCROLL_DIRECTION_FORWARD = 1;
exports.SCROLL_DIRECTION_FORWARD = SCROLL_DIRECTION_FORWARD;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
exports.SCROLL_DIRECTION_HORIZONTAL = SCROLL_DIRECTION_HORIZONTAL;
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

exports.SCROLL_DIRECTION_VERTICAL = SCROLL_DIRECTION_VERTICAL;

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultCellRangeRenderer;

var _types = __webpack_require__(34);

/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;
  var renderedCells = []; // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.

  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = "".concat(rowIndex, "-").concat(columnIndex);
      var style = void 0; // Cache style objects so shallow-compare doesn't re-render unnecessarily.

      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };
          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };
      var renderedCell = void 0; // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028

      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key]; // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;
        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

var _interopRequireWildcard = __webpack_require__(63);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_RenderedRows = exports.bpfrpt_proptype_RowRenderer = exports.bpfrpt_proptype_RowRendererParams = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var bpfrpt_proptype_RowRendererParams =  true ? null : {
  "index": _propTypes["default"].number.isRequired,
  "isScrolling": _propTypes["default"].bool.isRequired,
  "isVisible": _propTypes["default"].bool.isRequired,
  "key": _propTypes["default"].string.isRequired,
  "parent": _propTypes["default"].object.isRequired,
  "style": _propTypes["default"].object.isRequired
};
exports.bpfrpt_proptype_RowRendererParams = bpfrpt_proptype_RowRendererParams;
var bpfrpt_proptype_RowRenderer =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_RowRenderer = bpfrpt_proptype_RowRenderer;
var bpfrpt_proptype_RenderedRows =  true ? null : {
  "overscanStartIndex": _propTypes["default"].number.isRequired,
  "overscanStopIndex": _propTypes["default"].number.isRequired,
  "startIndex": _propTypes["default"].number.isRequired,
  "stopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_RenderedRows = bpfrpt_proptype_RenderedRows;
var bpfrpt_proptype_Scroll =  true ? null : {
  "clientHeight": _propTypes["default"].number.isRequired,
  "scrollHeight": _propTypes["default"].number.isRequired,
  "scrollTop": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var Button=function Button(props){var _className=props.className,_props$disabled=props.disabled,disabled=_props$disabled===undefined?undefined:_props$disabled,rest=_objectWithoutProperties(props,['className','disabled']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Btn,{disabled:disabled,render:function render(_ref){var getClassNames=_ref.getClassNames;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',Object.assign({disabled:disabled,className:getClassNames(_className)},rest));}});};Button.Primary=function(props){var _className=props.className,rest=_objectWithoutProperties(props,['className']);var className=__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('bg-blue white',_className);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,Object.assign({className:className},rest));};Button.Ghost=function(props){var _className=props.className,rest=_objectWithoutProperties(props,['className']);var className=__WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default()('bg-white blue b--moon-gray',_className,{'b--black-025':false});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,Object.assign({className:className},rest));};var Btn=function(_React$Component){_inherits(Btn,_React$Component);function Btn(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,Btn);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=Btn.__proto__||Object.getPrototypeOf(Btn)).call.apply(_ref2,[this].concat(args))),_this),_this.getClassNames=function(){for(var _len2=arguments.length,classNameArgs=Array(_len2),_key2=0;_key2<_len2;_key2++){classNameArgs[_key2]=arguments[_key2];}return __WEBPACK_IMPORTED_MODULE_1_classnames_dedupe___default.a.apply(undefined,['ba b--black-025 mid-gray bg-moon-gray br1 brandon button-reset input-reset f4 lh-title ph3 pv2'].concat(classNameArgs,[{'o-50 not-allowed':_this.props.disabled===true,'dim pointer':_this.props.disabled!==true}]));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Btn,[{key:'render',value:function render(){return this.props.render({getClassNames:this.getClassNames});}}]);return Btn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(192);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newFocus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFocusabledIn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_all_affected__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(39);





var findAutoFocused = function findAutoFocused(autoFocusables) {
  return function (node) {
    return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
  };
};

var isGuard = function isGuard(node) {
  return node && node.dataset && node.dataset.focusGuard;
};
var notAGuard = function notAGuard(node) {
  return !isGuard(node);
};

var newFocus = function newFocus(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];
  var isOnGuard = isGuard(activeElement);

  // focus is inside
  if (innerNodes.indexOf(activeElement) >= 0) {
    return undefined;
  }

  var activeIndex = outerNodes.indexOf(activeElement);
  var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
  var lastNodeInside = innerNodes.indexOf(lastNode);
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);

  var returnFirstNode = Object(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["b" /* pickFocusable */])(innerNodes, 0);
  var returnLastNode = Object(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["b" /* pickFocusable */])(innerNodes, cnt - 1);

  // new focus
  if (activeIndex === -1 || lastNodeInside === -1) {
    return innerNodes.indexOf(autoFocused && autoFocused.length ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["a" /* default */])(autoFocused) : Object(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["a" /* default */])(innerNodes));
  }
  // old focus
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  // first element
  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnLastNode;
  }
  // last element
  if (activeIndex >= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnFirstNode;
  }
  // jump out, but not on the guard
  if (indexDiff && Math.abs(indexDiff) > 1) {
    return lastNodeInside;
  }
  // focus above lock
  if (activeIndex <= firstNodeIndex) {
    return returnLastNode;
  }
  // focus below lock
  if (activeIndex > lastNodeIndex) {
    return returnFirstNode;
  }
  // index is inside tab order, but outside Lock
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  // do nothing
  return undefined;
};

var getTopCommonParent = function getTopCommonParent(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* asArray */])(baseActiveElement);
  var leftEntries = Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* asArray */])(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = null;
  leftEntries.filter(Boolean).forEach(function (entry) {
    topCommon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["b" /* getCommonParent */])(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function (subEntry) {
      var common = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["b" /* getCommonParent */])(activeElement, subEntry);
      if (common) {
        if (!topCommon || common.contains(topCommon)) {
          topCommon = common;
        } else {
          topCommon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["b" /* getCommonParent */])(common, topCommon);
        }
      }
    });
  });
  return topCommon;
};

var allParentAutofocusables = function allParentAutofocusables(entries) {
  return entries.reduce(function (acc, node) {
    return acc.concat(Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["d" /* parentAutofocusables */])(node));
  }, []);
};

var reorderNodes = function reorderNodes(srcNodes, dstNodes) {
  var remap = new Map();
  // no Set(dstNodes) for IE11 :(
  dstNodes.forEach(function (entity) {
    return remap.set(entity.node, entity);
  });
  // remap to dstNodes
  return srcNodes.map(function (node) {
    return remap.get(node);
  }).filter(Boolean);
};

var getFocusabledIn = function getFocusabledIn(topNode) {
  var entries = Object(__WEBPACK_IMPORTED_MODULE_2__utils_all_affected__["a" /* default */])(topNode).filter(notAGuard);
  var commonParent = getTopCommonParent(topNode, topNode, entries);
  var outerNodes = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c" /* getTabbableNodes */])([commonParent], true);
  var innerElements = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c" /* getTabbableNodes */])(entries).filter(function (_ref) {
    var node = _ref.node;
    return notAGuard(node);
  }).map(function (_ref2) {
    var node = _ref2.node;
    return node;
  });

  return outerNodes.map(function (_ref3) {
    var node = _ref3.node,
        index = _ref3.index;
    return {
      node: node,
      index: index,
      lockItem: innerElements.indexOf(node) >= 0,
      guard: isGuard(node)
    };
  });
};

var getFocusMerge = function getFocusMerge(topNode, lastNode) {
  var activeElement = document && document.activeElement;
  var entries = Object(__WEBPACK_IMPORTED_MODULE_2__utils_all_affected__["a" /* default */])(topNode).filter(notAGuard);

  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);

  var innerElements = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c" /* getTabbableNodes */])(entries).filter(function (_ref4) {
    var node = _ref4.node;
    return notAGuard(node);
  });

  if (!innerElements[0]) {
    innerElements = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["a" /* getAllTabbableNodes */])(entries).filter(function (_ref5) {
      var node = _ref5.node;
      return notAGuard(node);
    });
    if (!innerElements[0]) {
      return undefined;
    }
  }

  var outerNodes = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c" /* getTabbableNodes */])([commonParent]).map(function (_ref6) {
    var node = _ref6.node;
    return node;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  var innerNodes = orderedInnerElements.map(function (_ref7) {
    var node = _ref7.node;
    return node;
  });

  var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter(findAutoFocused(allParentAutofocusables(entries))));

  if (newId === undefined) {
    return newId;
  }
  return orderedInnerElements[newId];
};

/* harmony default export */ __webpack_exports__["a"] = (getFocusMerge);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hiddenGuard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);


var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};

var InFocusGuard = function InFocusGuard(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};

InFocusGuard.propTypes =  false ? {
  children: PropTypes.node
} : {};
InFocusGuard.defaultProps = {
  children: null
};
/* unused harmony default export */ var _unused_webpack_default_export = (InFocusGuard);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var startOfISOWeek = __webpack_require__(129)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(492)
var buildFormatLocale = __webpack_require__(493)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AttributeList_scss__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AttributeList_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AttributeList_scss__);
var AttributeList=function AttributeList(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('table',{className:__WEBPACK_IMPORTED_MODULE_1__AttributeList_scss___default.a.attributeList+' '+(props.className||'')},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tbody',null,props.items.map(function(item){if(typeof item==='string'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',{key:item},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__AttributeList_scss___default.a.attributeListDivider},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_1__AttributeList_scss___default.a.attributeListDividerLabel,'data-translate':true},item))));}var key=item.key,label=item.label,value=item.value;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',{key:key},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:__WEBPACK_IMPORTED_MODULE_1__AttributeList_scss___default.a.attributeListName,'data-translate':true},label),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:__WEBPACK_IMPORTED_MODULE_1__AttributeList_scss___default.a.attributeListValue,'data-key':key},value));})));};/* harmony default export */ __webpack_exports__["a"] = (AttributeList);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QAItemIcon; });
/* unused harmony export QAItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnswerSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QuestionSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthorInfo__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_UgcLinkContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QASection_scss__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QASection_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__QASection_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QAItemIcon=function QAItemIcon(_ref){var ugctype=_ref.ugctype;var char=ugctype==='WDYB'||ugctype==='Answer'?'A':ugctype.charAt(0);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('abbr',{className:__WEBPACK_IMPORTED_MODULE_5__QASection_scss__["qaSectionIcon"]},char);};var QAItem=function QAItem(props){var ugc=props.ugc,_props$mute=props.mute,mute=_props$mute===undefined?false:_props$mute,_props$className=props.className,className=_props$className===undefined?'':_props$className,_props$showModQuestio=props.showModQuestionButton,showModQuestionButton=_props$showModQuestio===undefined?false:_props$showModQuestio,_props$verticalHeader=props.verticalHeaderAlignment,verticalHeaderAlignment=_props$verticalHeader===undefined?'mb2':_props$verticalHeader;var text=ugc.ugc_archetype==='Question'?ugc.question:ugc.answer;var style=mute===true?{opacity:0.4}:null;var headingClassName=__WEBPACK_IMPORTED_MODULE_3_classnames___default()('ma0 lh-solid',verticalHeaderAlignment);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex flex-row items-top '+className,style:style},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](QAItemIcon,{ugctype:ugc.ugc_archetype}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_5__QASection_scss__["qaSectionContent"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h2',{className:headingClassName},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer__["b" /* default */],{'data-key':ugc.ugctype.toLowerCase(),text:text})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__AuthorInfo__["a" /* default */],{ugc:ugc}),showModQuestionButton&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_containers_UgcLinkContext__["b" /* default */].Consumer,null,function(linkFn){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'dib'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_containers_UgcLinkContext__["a" /* UgcLinkButton */],{href:linkFn(ugc),label:'Moderate',darkerButton:true}));})));};var AnswerSection={Header:function Header(props){var ugc=props.ugc;var parentUgc=ugc.getQuestion();var shouldShowModButton=props.options.program==='brand'?false:true;return parentUgc?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](QAItem,{ugc:parentUgc,mute:true,showModQuestionButton:shouldShowModButton}):null;},Content:function Content(props){var ugc=props.ugc;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ma4 mt0'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](QAItem,{ugc:ugc}));},getRelatedContent:function getRelatedContent(props,options){return null;}};// $FlowFixMe
var QuestionContent=function(_React$PureComponent){_inherits(QuestionContent,_React$PureComponent);function QuestionContent(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,QuestionContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=QuestionContent.__proto__||Object.getPrototypeOf(QuestionContent)).call.apply(_ref2,[this].concat(args))),_this),_this.state={expanded:false},_this.toggle=function(){_this.setState(function(prevState){return{expanded:!prevState.expanded};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QuestionContent,[{key:'render',value:function render(){var program=this.props.options.program;var expanded=this.state.expanded;if(program==='pwr')return null;var question=this.props.ugc;var answers=question.ugc_related_content.filter(function(ugc){return ugc&&ugc.ugc_archetype==='Answer';});var toggleButtonClassName='outline-transparent input-reset button-reset lh-solid pointer flex flex-row bg-transparent b--none blue db w-100 tl ph4 pv3';return answers.size?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'bt bw1 b--light-gray pv1'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{type:'button',className:toggleButtonClassName,onClick:this.toggle},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'db'},answers.size+' Other Answer'+(answers.size>1?'s':'')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i',{className:'fa fa-chevron-down','aria-hidden':'true',style:{marginLeft:'auto'}})),expanded&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'xma4'},answers.map(function(ugc,index){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'answer-container mv3',key:index},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](QAItem,{ugc:ugc,key:ugc.ugc_id,className:'mh4',verticalHeaderAlignment:'mb1'}),program==='client'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_containers_UgcLinkContext__["b" /* default */].Consumer,null,function(linkFn){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mh5 dib'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_containers_UgcLinkContext__["a" /* UgcLinkButton */],{href:linkFn(ugc),label:'Moderate'}));}));}))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'bt bw1 b--light-gray pv1'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'lh-solid mh4 pv3 moon-gray f5'},'No Other Answers'));}}]);return QuestionContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);var QuestionSection={Header:function Header(props){var ugc=props.ugc;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](QAItem,{ugc:ugc});},Content:QuestionContent,getRelatedContent:function getRelatedContent(props,options){return null;}};

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MediaSection__caption":"MediaSection__caption","mediaSectionCaption":"MediaSection__caption","MediaSection__caption__label":"MediaSection__caption__label","mediaSectionCaptionLabel":"MediaSection__caption__label","MediaSection__caption__text":"MediaSection__caption__text","mediaSectionCaptionText":"MediaSection__caption__text","MediaSection__image":"MediaSection__image","mediaSectionImage":"MediaSection__image","MediaSection__native-video":"MediaSection__native-video","mediaSectionNativeVideo":"MediaSection__native-video"};

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClientAttribution__ = __webpack_require__(507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ClientAttribution__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ClientAttribution__["b"]; });


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PowerReviewsModerationCard__ = __webpack_require__(509);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__PowerReviewsModerationCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KeyboardHelper__ = __webpack_require__(522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__KeyboardHelper__["a"]; });


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icons_Bell__ = __webpack_require__(510);
var CardAlert=function CardAlert(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mh4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gray ph3 center br2 flex items-center',style:{fontFamily:'BrandonText',backgroundColor:'#FDF8E6'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Icons_Bell__["a" /* default */],{style:{borderRadius:'50%',border:'1px solid orange'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ml3'},children)));};/* harmony default export */ __webpack_exports__["a"] = (CardAlert);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomObservationIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CustomObservationIcon=function CustomObservationIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",width:"14",height:"14",viewBox:"0 0 24 24",fill:"currentColor",className:props.className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M0 0h24v24H0z",fill:"none"}));};

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AsideAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsideAlert_scss__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsideAlert_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AsideAlert_scss__);
function AsideAlert(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__AsideAlert_scss___default.a.AsideAlert},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-exclamation-circle '+__WEBPACK_IMPORTED_MODULE_1__AsideAlert_scss___default.a.asideAlertIcon,'aria-hidden':'true'}),' ',props.children);}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CustomObservationInfoTooltip":"CustomObservationInfoTooltip","customObservationInfoTooltip":"CustomObservationInfoTooltip","CustomObservationInfoTooltip__text":"CustomObservationInfoTooltip__text","customObservationInfoTooltipText":"CustomObservationInfoTooltip__text"};

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_errors__ = __webpack_require__(36);
var apiFetch=function apiFetch(url,options){return fetch(Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])(url),options).then(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */]).catch(function(err){return Promise.reject(__WEBPACK_IMPORTED_MODULE_2_lib_errors__["e" /* default */].isHttpError(err)?err:new __WEBPACK_IMPORTED_MODULE_2_lib_errors__["c" /* NetworkingError */]());});};/* harmony default export */ __webpack_exports__["a"] = (apiFetch);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClientSelectMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downshift__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tiny_virtual_list__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clientsActions__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_match_sorter__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lib_async_value__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var itemToString=function itemToString(item){return item?item.merchant_group_name:'';};var remToPixels=function remToPixels(multiplier){return multiplier*0.82*16;};var ClientSelectMenu=function(_React$Component){_inherits(ClientSelectMenu,_React$Component);function ClientSelectMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientSelectMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientSelectMenu.__proto__||Object.getPrototypeOf(ClientSelectMenu)).call.apply(_ref,[this].concat(args))),_this),_this.state={items:_this.props.allItems,inputValue:'',highlightedIndex:null},_this.handleStateChange=function(changes,downshiftState){if(changes.hasOwnProperty('isOpen')){_this.setState({items:_this.props.allItems,inputValue:'',highlightedIndex:null});}else if(changes.hasOwnProperty('inputValue')){var _inputValue=changes.inputValue;_this.setState({items:_this.getItems(_this.props.allItems,_inputValue),inputValue:_inputValue,highlightedIndex:0});}else if(changes.hasOwnProperty('highlightedIndex')){_this.setState({highlightedIndex:changes.highlightedIndex});}},_this.handleChange=function(selectedItem,downshiftState){_this.setState({items:_this.props.allItems,inputValue:''});_this.props.selectClient(selectedItem.merchant_group_id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientSelectMenu,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.allItems!==this.props.allItems&&Array.isArray(nextProps.allItems)){this.setState({items:nextProps.allItems});}}},{key:'getItems',value:function getItems(items,inputValue){if(inputValue!=null&&typeof inputValue==='string'){return Object(__WEBPACK_IMPORTED_MODULE_6_match_sorter__["a" /* default */])(items,inputValue,{keys:['merchant_group_name',{maxRanking:__WEBPACK_IMPORTED_MODULE_6_match_sorter__["a" /* default */].rankings.CASE_SENSITIVE_EQUAL,key:'merchant_group_id'}]});}return items;}},{key:'render',value:function render(){var _props=this.props,isLoading=_props.isLoading,selectedItem=_props.selectedItem,hidden=_props.hidden,disabled=_props.disabled,hideButton=_props.hideButton;if(hidden||isLoading||!this.state.items)return null;var itemHeight=remToPixels(2.5);var searchFormHeight=remToPixels(2.5+2);var menuHeight=remToPixels(2+2.5*10);var virtualListHeight=menuHeight-searchFormHeight;var items=this.state.items;var toggleClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('button-reset pointer cb nowrap lh-solid pv2 ph0 ml3 bg-animate bn br2 outline-0 bg-transparent gray','ClientSelectMenu__toggle',{'hover-blue':disabled!==true});var menuClassName='list pl0 pv0 ma0 bg-white ba0 b--moon-gray br2 nt1 z-999 absolute w5 overflow-hidden';var menuStyle={top:hideButton?0:'3rem',boxShadow:'0 0 1px hsla(0,0%,7%,.3), 0 10px 25px -4px hsla(0,0%,7%,.4)',width:hideButton?'30rem':'24rem',height:items.length?menuHeight:3*itemHeight};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_downshift__["a" /* default */],{itemToString:itemToString,items:items,itemCount:items.length,onStateChange:this.handleStateChange,onChange:this.handleChange,inputValue:this.state.inputValue,selectedItem:selectedItem,highlightedIndex:this.state.highlightedIndex,isOpen:hideButton===true?true:undefined,id:'client-select'},function(_ref2){var getInputProps=_ref2.getInputProps,getLabelProps=_ref2.getLabelProps,getButtonProps=_ref2.getButtonProps,getItemProps=_ref2.getItemProps,toggleMenu=_ref2.toggleMenu,isOpen=_ref2.isOpen,selectedItem=_ref2.selectedItem,highlightedIndex=_ref2.highlightedIndex,itemToString=_ref2.itemToString;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'relative ClientSelectMenu',id:'client-select-menu'},hideButton===true?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',Object.assign({className:toggleClassName,onClick:toggleMenu,type:'button',disabled:disabled},getButtonProps({onBlur:function onBlur(e){return e.preventDefault();}})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClientIcon,{className:'v-mid mr2',style:{height:'1.35rem',width:'1.35rem'}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',Object.assign({className:'v-mid mr2 truncate mw5-l mw4 dib ClientSelectMenu__label'},getLabelProps()),selectedItem?selectedItem.merchant_group_name:''),disabled!==true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i',{className:'fa v-mid fa-angle-down','aria-hidden':'true',style:{fontSize:'1.8rem',transform:'scaleX(0.9)'}})),isOpen&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:menuClassName,style:menuStyle},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('form',{className:'pa3 relative'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',Object.assign({type:'text',className:'w-100 input-reset ba b--light-gray db db pl2 pr4 ClientSelectMenu__input',style:{height:itemHeight}},getInputProps({autoFocus:true,placeholder:hideButton?'Type to Search...':undefined}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i',{className:'fa fa-search absolute dib silver','aria-hidden':'true',style:{top:'50%',right:'1.7rem',transform:'translateY(-50%)'}})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'absolute right-0 left-0 bottom-0 overflow-hidden b--light-gray bt bt1',style:{top:searchFormHeight}},items.length?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_tiny_virtual_list__["a" /* default */],{width:'100%',scrollToIndex:highlightedIndex||0,scrollToAlignment:'auto',height:items.length<5?items.length*itemHeight:virtualListHeight,itemCount:items.length,itemSize:itemHeight,renderItem:function renderItem(_ref3){var index=_ref3.index,style=_ref3.style;var item=items[index];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',Object.assign({className:getItemClassName({highlighted:highlightedIndex===index,selected:selectedItem===items[index]}),style:Object.assign({height:itemHeight},style),key:item.merchant_group_id},getItemProps({item:item,index:index})),item.merchant_group_name);}}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'db tc gray',style:{height:itemHeight,lineHeight:itemHeight+'px'}},'No results'))));});}}]);return ClientSelectMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){var _state$clients=state.clients,clients=_state$clients.clients,selected=_state$clients.currentClient,showMenu=_state$clients.showMenu;var disabled=isMenuDisabled(selected,clients);var hidden=showMenu===false||!Array.isArray(clients)||ownProps.hideButton!==true&&selected==null;return{isLoading:clients===__WEBPACK_IMPORTED_MODULE_7_lib_async_value__["b" /* default */].Pending,allItems:clients,disabled:disabled,selectedItem:Array.isArray(clients)?clients.find(function(i){return i.merchant_group_id===selected;}):null,hidden:hidden};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,{selectClient:__WEBPACK_IMPORTED_MODULE_5__clientsActions__["c" /* selectClient */]})(ClientSelectMenu));function isMenuDisabled(selected,clients){if(selected!=null&&Array.isArray(clients)&&clients.length===1){return true;}return undefined;}function getItemClassName(_ref4){var highlighted=_ref4.highlighted,selected=_ref4.selected;return __WEBPACK_IMPORTED_MODULE_2_classnames___default()('button-reset b--none db mv0 ph3 bg-animate gray over-bg-near-white  hover-mid-gray tl w-100 truncate',{'bg-white':highlighted===false,'bg-near-white mid-gray':highlighted===true,b:selected===true});}function ClientIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 360 360'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'currentColor',d:'M328.1 68.4h-14.8V53.6h-29.6v14.8H247V24H113.8v44.4H76.3V53.6H46.7v14.8H31.9C15.6 68.4 2.3 81.7 2.3 98v207.3c0 16.3 13.3 29.6 29.6 29.6h296.2c16.3 0 29.6-13.3 29.6-29.6V98c0-16.3-13.3-29.6-29.6-29.6zM143.4 53.6h74v14.8h-74V53.6zm184.7 251.7H31.9v.1V98h296.2v207.3z'}));}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchClientUserProfiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return storeClientUserProfiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchClientExpertUserProfiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return storeClientExportUserProfiles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
var createFetchAction=function createFetchAction(resourceType){return Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/'+resourceType+'/fetch',function(clientId){return clientId;});};var createStoreAction=function createStoreAction(resourceType){return Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/'+resourceType+'/store',function(payload){return payload;},function(_,clientId){return clientId;});};// profiles
var fetchClientUserProfiles=createFetchAction('profiles');var storeClientUserProfiles=createStoreAction('profiles');// export user profiles
var fetchClientExpertUserProfiles=createFetchAction('expertProfiles');var storeClientExportUserProfiles=createStoreAction('expertProfiles');

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchClientProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return storeClientProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);
var fetchClientProperties=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/properties/fetch',function(clientId){return clientId;});var storeClientProperties=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('@client/properties/store',function(payload){return payload;},function(_,clientId){return clientId;});

/***/ }),
/* 217 */
/***/ (function(module, exports) {



/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = determineNextClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_async_value__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clientsActions__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__storage__ = __webpack_require__(113);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultState=Object.assign({clients:undefined,currentClient:undefined,showMenu:true},__WEBPACK_IMPORTED_MODULE_3__storage__["a" /* default */].getState());var clientsReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__clientsActions__["c" /* selectClient */].toString(),function(state,action){return Object.assign({},state,{currentClient:action.payload});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__clientsActions__["a" /* fetchClients */].toString(),function(state,action){return Object.assign({},state,{clients:__WEBPACK_IMPORTED_MODULE_1_lib_async_value__["b" /* default */].Pending});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__clientsActions__["e" /* storeClients */].toString(),{next:function next(state,action){return Object.assign({},state,{clients:action.payload});},throw:function _throw(state,action){return Object.assign({},state,{clients:action.payload});}}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__clientsActions__["d" /* showClientMenu */].toString(),function(state){return Object.assign({},state,{showMenu:true});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__clientsActions__["b" /* hideClientMenu */].toString(),function(state){return Object.assign({},state,{showMenu:false});}),_handleActions),defaultState);function determineNextClient(clients,currentClient){var nextClient=currentClient;if(clients.length===0){nextClient=null;}else if(clients.length===1){nextClient=clients[0].merchant_group_id;}else if(nextClient!=null){var indexOfClient=clients.find(function(_ref){var merchant_group_id=_ref.merchant_group_id;return merchant_group_id===nextClient;});if(!indexOfClient){nextClient=null;}}return{currentClient:typeof nextClient==='string'?+nextClient:nextClient,clients:clients};}/* harmony default export */ __webpack_exports__["a"] = (clientsReducer);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmptyModerationAlertConfigRecord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alertConfigActions__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_async_value__ = __webpack_require__(12);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var EmptyClientConfig={channel:'',client_id:-1,batch:false,recipients:[]};// record include config and changeStatus
var ModerationAlertConfigRecord=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Record"])({changeStatus:null,config:EmptyClientConfig});var EmptyClientChannelConfigMap=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();var EmptyModerationAlertConfigRecord=ModerationAlertConfigRecord();/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__alertConfigActions__["b" /* fetchModerationAlertConfig */].toString(),function(state,action){return __WEBPACK_IMPORTED_MODULE_3_lib_async_value__["b" /* default */].Pending;}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__alertConfigActions__["e" /* storeModerationAlertConfig */].toString(),function(state,action){var payload=action.payload,error=action.error;if(error){return payload;}return Array.isArray(payload)&&payload.length>0?Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(payload.map(function(config){return[config.channel,ModerationAlertConfigRecord({config:config})];})):EmptyClientChannelConfigMap;}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__alertConfigActions__["d" /* requestModerationAlertUpdate */].toString(),function(state,action){var channel=action.meta.channel;if(state instanceof __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]){return state.setIn([channel,'changeStatus'],__WEBPACK_IMPORTED_MODULE_3_lib_async_value__["b" /* default */].Pending);}return state;}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__alertConfigActions__["c" /* receiveModerationAlertUpdate */].toString(),function(state,action){var payload=action.payload,channel=action.meta.channel,error=action.error;if(state instanceof __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]){if(error===true){return state.setIn([channel],ModerationAlertConfigRecord({changeStatus:payload}));}return state.setIn([channel],ModerationAlertConfigRecord({changeStatus:__WEBPACK_IMPORTED_MODULE_3_lib_async_value__["b" /* default */].Complete,config:payload}));}return state;}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__alertConfigActions__["a" /* clearModerationAlertUpdateStatus */].toString(),function(state,action){var channel=action.payload.channel;if(state instanceof __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]){return state.setIn([channel,'changeStatus'],null);}return state;}),_handleActions),null));

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_async_value__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catalogActions__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultState={catalogs:undefined,currentCatalog:undefined};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__catalogActions__["a" /* fetchClientCatalog */].toString(),function(state,action){return Object.assign({},state,{currentCatalog:undefined,catalogs:__WEBPACK_IMPORTED_MODULE_1_lib_async_value__["b" /* default */].Pending});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__catalogActions__["c" /* storeClientCatalog */].toString(),function(state,action){return Object.assign({},state,{catalogs:action.error===true?action.payload:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(action.payload)});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__catalogActions__["b" /* selectClientCatalog */].toString(),function(state,action){return Object.assign({},state,{currentCatalog:action.payload});}),_handleActions),defaultState));

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */].PageNotFound}));});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmptyQueueMessage__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentResponse=function(_React$PureComponent){_inherits(ContentResponse,_React$PureComponent);function ContentResponse(){_classCallCheck(this,ContentResponse);return _possibleConstructorReturn(this,(ContentResponse.__proto__||Object.getPrototypeOf(ContentResponse)).apply(this,arguments));}_createClass(ContentResponse,[{key:'render',value:function render(){var _props=this.props,ugcId=_props.ugcId,requestContent=_props.requestContent,moderationState=_props.moderationState,children=_props.children;if(ugcId===-1){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__EmptyQueueMessage__["a" /* default */],{title:'There is no content in your Queue.',label:'Refresh',onClick:requestContent});}if(!moderationState){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__EmptyQueueMessage__["a" /* default */],{title:'Could not Load content',label:'Retry',onClick:requestContent});}return children;}}]);return ContentResponse;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (ContentResponse);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModerateState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_today__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_today___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_is_today__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__moderateActions__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_coreDataActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_moderation_moderate_moderateStorage__ = __webpack_require__(225);
var _handleActions;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultModerateRecordShape={savedCompletedCount:{},completedCount:0,ugcId:null,contentRequestStatus:null,previousUgcId:null,updatePreviousContentRequestStatus:null};var ModerateState=function(_Record){_inherits(ModerateState,_Record);function ModerateState(){_classCallCheck(this,ModerateState);return _possibleConstructorReturn(this,(ModerateState.__proto__||Object.getPrototypeOf(ModerateState)).apply(this,arguments));}_createClass(ModerateState,[{key:'getSavedCount',value:function getSavedCount(){var _savedCompletedCount=this.savedCompletedCount,date=_savedCompletedCount.date,_savedCompletedCount$=_savedCompletedCount.count,savedCount=_savedCompletedCount$===undefined?0:_savedCompletedCount$;return __WEBPACK_IMPORTED_MODULE_2_date_fns_is_today___default()(date)?savedCount:0;}},{key:'getCompletedCount',value:function getCompletedCount(){return this.getSavedCount()+this.completedCount;}}],[{key:'createWithCompletedCount',value:function createWithCompletedCount(obj){return new ModerateState({savedCompletedCount:obj});}}]);return ModerateState;}(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(defaultModerateRecordShape));var defaultState=ModerateState.createWithCompletedCount(__WEBPACK_IMPORTED_MODULE_6_pages_moderation_moderate_moderateStorage__["a" /* default */].getTodayCount());/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_4__moderateActions__["c" /* requestContent */].toString(),function(state,action){return state.set('contentRequestStatus','pending');}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_4__moderateActions__["a" /* receiveContent */].toString(),{next:function next(state,action){return state.merge({ugcId:action.payload.ugc_id,contentRequestStatus:'complete'});},throw:function _throw(state,action){return state.set('contentRequestStatus',action.payload);}}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_4__moderateActions__["e" /* updateCurrentUgcId */].toString(),function(state,action){return state.set('ugcId',action.payload);}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_4__moderateActions__["d" /* requestPreviousUgcIdUpdate */].toString(),function(state,action){return state.set('updatePreviousContentRequestStatus','pending');}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_4__moderateActions__["b" /* receivePreviousUgcIdUpdate */].toString(),function(state,action){return action.payload!==state.previousUgcId?state.merge({previousUgcId:action.payload,updatePreviousContentRequestStatus:'complete'}):state;}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_5_ducks_coreDataActions__["c" /* commitObservationsUpdate */].toString(),function(state,action){var committedModerationState=action.payload;var completedCount=__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].isPowerReviewsModerated(committedModerationState)&&action.payload.ugcId!==state.previousUgcId?state.completedCount+1:state.completedCount;return state.merge({completedCount:completedCount});}),_handleActions),defaultState));

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(128)

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_today__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_today___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_is_today__);
var key='PowerReviewsModeration.CompletedCount';var defaultObject={};var getTodayCount=function getTodayCount(){var _ref=JSON.parse(global.localStorage.getItem(key))||defaultObject,_ref$date=_ref.date,date=_ref$date===undefined?Date.now():_ref$date,v=_ref.count;return{date:date,count:Boolean(v)&&__WEBPACK_IMPORTED_MODULE_0_date_fns_is_today___default()(date)?Number(v)||0:0};};var saveTodayCount=function saveTodayCount(count){try{var objToSet={date:Date.now(),count:count};global.localStorage.setItem(key,JSON.stringify(objToSet));}catch(err){console.error(err);}};var __exports__={getTodayCount:getTodayCount,saveTodayCount:saveTodayCount};/* harmony default export */ __webpack_exports__["a"] = (__exports__);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
var createGetContent=function createGetContent(pathName){return Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function getContent(token){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/moderate/'+pathName);var fetchOptions={headers:{Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){if(response.status===204){return[];}return response.json();}).then(function(json){return Array.isArray(json)?json:[json];}).catch(function(error){console.error('Error while calling getContent: ',error);});});};/* harmony default export */ __webpack_exports__["a"] = (createGetContent);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clientsActions__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HideClientSelectMenu=function(_React$Component){_inherits(HideClientSelectMenu,_React$Component);function HideClientSelectMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HideClientSelectMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HideClientSelectMenu.__proto__||Object.getPrototypeOf(HideClientSelectMenu)).call.apply(_ref,[this].concat(args))),_this),_this.state={isMounted:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HideClientSelectMenu,[{key:'componentDidMount',value:function componentDidMount(){this.props.hide();this.setState({isMounted:true});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.show();}},{key:'render',value:function render(){return this.state.isMounted?this.props.children:null;}}]);return HideClientSelectMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null,{show:__WEBPACK_IMPORTED_MODULE_1__clientsActions__["d" /* showClientMenu */],hide:__WEBPACK_IMPORTED_MODULE_1__clientsActions__["b" /* hideClientMenu */]})(HideClientSelectMenu));

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_click_outside__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Menu=function(_React$Component){_inherits(Menu,_React$Component);function Menu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Menu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Menu.__proto__||Object.getPrototypeOf(Menu)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:false},_this.handleClickOutside=function(){_this.setState({isOpen:false});},_this.open=function(){_this.setState({isOpen:true});},_this.getIconProps=function(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _className=props.className||'';var _style=props.style||{};return Object.assign({},props,{className:'v-mid mr2 '+_className||'',style:Object.assign({height:'1.35rem',width:'1.35rem'},_style)});},_this.getItemProps=function(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return Object.assign({},props,{role:'menuitem',tabIndex:0,className:'link db ph3 v-mid bg-animate hover-bg-near-white gray hover-mid-gray '+(props.className||''),style:{height:'2.5rem',lineHeight:'2.5rem'}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Menu,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.button&&this.list){this.list.style.minWidth=this.button.offsetWidth+'px';}}},{key:'render',value:function render(){var _this2=this;var isOpen=this.state.isOpen;var menuButtonCls=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('button-reset pointer cb nowrap lh-solid pv2 ph0 ml3 bg-animate bn br2 outline-0','bg-transparent gray hover-blue');var label=this.props.label;var icon=typeof this.props.renderIcon==='function'?this.props.renderIcon({isOpen:isOpen,getProps:this.getIconProps}):null;var items=this.props.renderItems({isOpen:isOpen,getProps:this.getItemProps});var listClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('list pl0 pv2 ma0 bg-white ba0 b--moon-gray br2 nt1 z-999 absolute',{'right-0':this.props.justify==='right','left-0':this.props.justify==='left'});var menuStyle={visibility:isOpen?'visible':'hidden',top:'3rem',right:'0',boxShadow:'0 0 1px hsla(0,0%,7%,.3), 0 10px 25px -4px hsla(0,0%,7%,.4)'};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'relative',id:this.props.id||''},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_click_outside___default.a,{onClickOutside:this.handleClickOutside},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{className:menuButtonCls,ref:function ref(_ref2){return _this2.button=_ref2;},type:'button',onClick:this.open,onFocus:this.open},icon,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'v-mid mr2','data-translate':this.props.id==='help-menu'?true:false},label),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i',{className:'fa v-mid fa-angle-down','aria-hidden':'true',style:{fontSize:'1.8rem',transform:'scaleX(0.9)'}})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('ul',{role:'menu','aria-haspopup':'true',tabIndex:'-1',className:listClassName,style:menuStyle,ref:function ref(_ref3){return _this2.list=_ref3;},'data-translate':true},items.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('li',{key:item.key},item);}))));}}]);return Menu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_search__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__ = __webpack_require__(26);
var label='Native Reviews';var ReviewSearch=function ReviewSearch(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_search__["a" /* default */],Object.assign({label:label,primaryFieldsets:__WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__["h" /* ReviewFieldsets */].primaryFieldsets,extraFieldsets:__WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__["h" /* ReviewFieldsets */].extraFieldsets},props));};ReviewSearch.label=label;/* harmony default export */ __webpack_exports__["a"] = (ReviewSearch);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(137),
    isArrayLike = __webpack_require__(231),
    isIndex = __webpack_require__(234),
    isObject = __webpack_require__(93);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(232),
    isLength = __webpack_require__(233);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(60),
    isObject = __webpack_require__(93);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(589);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFieldEmptyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isFieldEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fieldDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return serializeField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deserializeField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_date__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_is_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_parse__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var VALUE_SEPERATOR=' ';var rangeEmptyValue=[1,5];var getFieldEmptyValue=function getFieldEmptyValue(type){if(type==='select'||type==='multiselect'){return undefined;}if(type==='RatingRange'){return rangeEmptyValue;}if(type==='date'){return null;}return'';};var isFieldEmpty=function isFieldEmpty(type,value){var emptyValue=getFieldEmptyValue(type);return value===emptyValue;};var fieldDefault=function fieldDefault(type,value){// if value is false return empty value
if(value===null||typeof value==='undefined'){return getFieldEmptyValue(type);}return value;};var serializeField=function serializeField(type,value){if(type==='select'&&(typeof value==='undefined'?'undefined':_typeof(value))==='object'){return value.value;}if(type==='multiselect'&&Array.isArray(value)){return value.map(function(v){return serializeField('select',v);}).join(VALUE_SEPERATOR);}if(type==='RatingRange'&&Array.isArray(value)){return value.join('-');}if(type==='number'){return Number(value);}if(type==='date'&&__WEBPACK_IMPORTED_MODULE_0_date_fns_is_date___default()(value)){return __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(value,'YYYY-MM-DD');}return value;};var deserializeField=function deserializeField(type,value){if(type==='select'){return value.trim();}if(type==='RatingRange'){var v=value.split('-');return v.length<2?v.concat(v):v.slice(0,2);}if(type==='multiselect'){return value.split(VALUE_SEPERATOR);}if(type==='date'){return __WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default()(value);}};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(138)

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductOptionsFieldset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ReviewFieldsets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pwrDistroReviewFieldsets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PwrDistroMediaFieldsets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PwrDistroQuestionFieldsets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PwrDistroAnswerFieldsets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NetworkReviewFieldsets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MediaFieldsets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return QuestionFieldsets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NetworkQuestionFieldsets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnswerFieldsets; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fields_config__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Icons_ProductTag__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Icons_FiveStarsEmpty__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_MediaPlaceholder__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icons_QA__ = __webpack_require__(605);
var ProductOptionsFieldset={legend:'Product Options',Icon:__WEBPACK_IMPORTED_MODULE_1_components_Icons_ProductTag__["a" /* default */],fields:[__WEBPACK_IMPORTED_MODULE_0__fields_config__["r" /* pageId */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["s" /* productName */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["b" /* brand */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["d" /* category */]]};var ReviewFieldsets={primaryFieldsets:[ProductOptionsFieldset,{legend:'Review Options',Icon:__WEBPACK_IMPORTED_MODULE_2_components_Icons_FiveStarsEmpty__["a" /* default */],fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["y" /* setReadonlyUgcType */])('Review'),Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["i" /* createUgcId */])('Review'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["v" /* rating */],// reviewerType,
// statusIncluded,
// statusExcluded,
__WEBPACK_IMPORTED_MODULE_0__fields_config__["g" /* codesIncluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["f" /* codesExcluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["x" /* reviewIncludesResponse */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["l" /* isUpdatedReview */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["z" /* siteStatus */]]}],extraFieldsets:[{fields:[// merchants,
__WEBPACK_IMPORTED_MODULE_0__fields_config__["a" /* author */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["w" /* reviewHeadline */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["c" /* catalog */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["o" /* merchantUserEmail */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["h" /* commentsKeyword */],// contentDisclosureCodes,
__WEBPACK_IMPORTED_MODULE_0__fields_config__["j" /* deviceId */]]}]};var pwrDistroReviewFieldsets={primaryFieldsets:[{fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["i" /* createUgcId */])('Review'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["q" /* native */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["r" /* pageId */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["G" /* variantId */]]}],extraFieldsets:[{fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["y" /* setReadonlyUgcType */])('Review'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["v" /* rating */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["a" /* author */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["w" /* reviewHeadline */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["h" /* commentsKeyword */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["m" /* locale */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["o" /* merchantUserEmail */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["p" /* merchantUserId */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["j" /* deviceId */]]}]};var PwrDistroMediaFieldsets={primaryFieldsets:[{fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["i" /* createUgcId */])('Media'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["n" /* mediaUgcType */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["r" /* pageId */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["G" /* variantId */]]}],extraFieldsets:[{fields:[__WEBPACK_IMPORTED_MODULE_0__fields_config__["v" /* rating */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["a" /* author */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["w" /* reviewHeadline */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["h" /* commentsKeyword */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["m" /* locale */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["q" /* native */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["o" /* merchantUserEmail */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["p" /* merchantUserId */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["j" /* deviceId */]]}]};var PwrDistroQuestionFieldsets={primaryFieldsets:[{fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["i" /* createUgcId */])('Question'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["q" /* native */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["r" /* pageId */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["G" /* variantId */]]}],extraFieldsets:[{fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["y" /* setReadonlyUgcType */])('Question'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["m" /* locale */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["o" /* merchantUserEmail */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["p" /* merchantUserId */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["j" /* deviceId */]]}]};var PwrDistroAnswerFieldsets={primaryFieldsets:[{fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["i" /* createUgcId */])('Answer'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["q" /* native */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["r" /* pageId */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["G" /* variantId */]]}],extraFieldsets:[{fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["y" /* setReadonlyUgcType */])('Answer'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["m" /* locale */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["o" /* merchantUserEmail */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["p" /* merchantUserId */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["j" /* deviceId */]]}]};var NetworkReviewFieldsets={primaryFieldsets:[Object.assign({},ProductOptionsFieldset,{fields:[{name:'page_id',label:'Page ID',type:'text',style:{flexBasis:'100%'},attributes:{required:true}}]}),{legend:'Review Options',Icon:__WEBPACK_IMPORTED_MODULE_2_components_Icons_FiveStarsEmpty__["a" /* default */],fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["y" /* setReadonlyUgcType */])('Review'),Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["i" /* createUgcId */])('Review'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["v" /* rating */],// reviewerType,
__WEBPACK_IMPORTED_MODULE_0__fields_config__["g" /* codesIncluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["f" /* codesExcluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["a" /* author */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["w" /* reviewHeadline */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["z" /* siteStatus */]]}]};var MediaFieldsets={primaryFieldsets:[ProductOptionsFieldset,{legend:'Media Options',Icon:__WEBPACK_IMPORTED_MODULE_3_components_Icons_MediaPlaceholder__["a" /* default */],fields:[// reviewerType,
Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["i" /* createUgcId */])('Media'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["n" /* mediaUgcType */],// statusIncluded,
// statusExcluded,
__WEBPACK_IMPORTED_MODULE_0__fields_config__["g" /* codesIncluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["f" /* codesExcluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["z" /* siteStatus */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["c" /* catalog */]]}]// extraFieldsets: [
//   {
//     fields: [
//       // merchants,
//       // merchantUserEmail,
//       // commentsKeyword,
//       //contentDisclosureCodes,
//       // deviceId,
//     ],
//   },
// ],
};var QuestionFieldsets={primaryFieldsets:[ProductOptionsFieldset,{legend:'Question Options',Icon:__WEBPACK_IMPORTED_MODULE_4_components_Icons_QA__["b" /* Question */],fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["y" /* setReadonlyUgcType */])('Question'),Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["i" /* createUgcId */])('Question'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["z" /* siteStatus */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["u" /* questionIncludesAnswer */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["t" /* questionHasVisualAnswers */],// questionType,
// answerStatus,
// statusIncluded,
// statusExcluded,
__WEBPACK_IMPORTED_MODULE_0__fields_config__["g" /* codesIncluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["f" /* codesExcluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["c" /* catalog */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["o" /* merchantUserEmail */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["j" /* deviceId */]]}]// extraFieldsets: [
//   {
//     fields: [
//       // questionKeyword,
//       // contentDisclosureCodes,
//     ],
//   },
// ],
};var NetworkQuestionFieldsets={primaryFieldsets:[Object.assign({},ProductOptionsFieldset,{fields:[{name:'page_id',label:'Page ID',type:'text',style:{flexBasis:'100%'},attributes:{required:true}}]}),{legend:'Question Options',Icon:__WEBPACK_IMPORTED_MODULE_4_components_Icons_QA__["b" /* Question */],fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["y" /* setReadonlyUgcType */])('Question'),Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["i" /* createUgcId */])('Question'),__WEBPACK_IMPORTED_MODULE_0__fields_config__["g" /* codesIncluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["f" /* codesExcluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["z" /* siteStatus */]]}]};var AnswerFieldsets={primaryFieldsets:[ProductOptionsFieldset,{legend:'Answer Options',Icon:__WEBPACK_IMPORTED_MODULE_4_components_Icons_QA__["a" /* Answer */],fields:[Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["y" /* setReadonlyUgcType */])('Answer'),Object(__WEBPACK_IMPORTED_MODULE_0__fields_config__["i" /* createUgcId */])('Answer'),// answerType,
// statusIncluded,
// statusExcluded,
__WEBPACK_IMPORTED_MODULE_0__fields_config__["g" /* codesIncluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["f" /* codesExcluded */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["z" /* siteStatus */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["c" /* catalog */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["o" /* merchantUserEmail */],__WEBPACK_IMPORTED_MODULE_0__fields_config__["j" /* deviceId */]]}]// extraFieldsets: [
//   {
//     fields: [
//       // questionKeyword,
//       merchantUserEmail,
//       // contentDisclosureCodes,
//       deviceId,
//     ],
//   },
// ],
};

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isSearching;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__searchActions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_async_value__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultState={pages:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),queries:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),currentPage:1,totalPages:null};/* harmony default export */ __webpack_exports__["a"] = ({search:Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__searchActions__["e" /* submitSearch */].toString(),function(state,action){var baseQuery=action.payload;var currentPage=1;return{pages:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])().set(currentPage,__WEBPACK_IMPORTED_MODULE_2_lib_async_value__["b" /* default */].Pending),queries:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])().set(currentPage,baseQuery),currentPage:currentPage,totalPages:null};}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__searchActions__["a" /* clearSearch */].toString(),function(){return defaultState;}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__searchActions__["d" /* requestSearchResults */].toString(),function(state,action){var _action$payload=action.payload,currentPage=_action$payload.page,query=_action$payload.query;return Object.assign({},state,{currentPage:currentPage,pages:state.pages.set(currentPage,__WEBPACK_IMPORTED_MODULE_2_lib_async_value__["b" /* default */].Pending),queries:state.queries.set(currentPage,query)});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__searchActions__["b" /* navigateSearchResults */].toString(),function(state,action){var _action$payload2=action.payload,currentPage=_action$payload2.page,query=_action$payload2.query;return Object.assign({},state,{currentPage:currentPage,pages:state.pages.has(currentPage)?state.pages:state.pages.set(currentPage,__WEBPACK_IMPORTED_MODULE_2_lib_async_value__["b" /* default */].Pending),queries:state.queries.set(currentPage,query)});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__searchActions__["c" /* receiveSearchResults */].toString(),function(state,action){var _action$payload3=action.payload,items=_action$payload3.items,totalPages=_action$payload3.totalPages;var currentPage=state.currentPage,pages=state.pages;return Object.assign({},state,{pages:pages.set(currentPage,items),totalPages:totalPages!=null?totalPages:state.totalPages});}),_handleActions),defaultState)});function isSearching(state){return state!==defaultState;}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(630),
    mapCacheDelete = __webpack_require__(637),
    mapCacheGet = __webpack_require__(639),
    mapCacheHas = __webpack_require__(640),
    mapCacheSet = __webpack_require__(641);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(642),
    arraySome = __webpack_require__(645),
    cacheHas = __webpack_require__(646);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(28),
    stubFalse = __webpack_require__(663);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)(module)))

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(664),
    baseUnary = __webpack_require__(665),
    nodeUtil = __webpack_require__(666);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = SimpleResponse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentSection_AuthorInfo__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserGeneratedTextContainer__ = __webpack_require__(17);
function Response(props){var model=props.model,_props$model=props.model,text=_props$model.text,ugctype=_props$model.ugctype;var title=getTitle(ugctype);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',{className:'mv3'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('header',{className:'bt b1 bw1 pt3 b--light-gray ph4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'ma0 f4'},title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ContentSection_AuthorInfo__["a" /* default */],{ugc:model})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'mh4 mv0'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__UserGeneratedTextContainer__["b" /* default */],{text:text})));}function SimpleResponse(props){var ugc=props.ugc,_props$ugc=props.ugc,text=_props$ugc.text,ugctype=_props$ugc.ugctype;var title=getTitle(ugctype);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('header',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'ma0'},title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ContentSection_AuthorInfo__["a" /* default */],{ugc:ugc})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'mb0'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__UserGeneratedTextContainer__["b" /* default */],{text:text})));}function getTitle(ugctype){if(ugctype==='MerchantResponse')return'Merchant Response';if(ugctype==='BrandMerchantResponse')return'Brand Response';return ugctype;}

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ugcAssignmentReducer__ = __webpack_require__(101);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({assignments:__WEBPACK_IMPORTED_MODULE_1__ugcAssignmentReducer__["a" /* DEFAULT_STATE */],requestAssignment:function requestAssignment(){}}));

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnswerArticle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditAnswer__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_answer_editing_AnswerEditingContext__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_alerts__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QAComponents__ = __webpack_require__(70);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function renderErrorMessage(err,action){if(typeof err.status==='number'&&err.status===403){return'You do not have the necessary permissions to make this change.';}return'An error occurred while '+action+' the answer.';}var Component=function(_React$Component){_inherits(Component,_React$Component);function Component(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Component);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Component.__proto__||Object.getPrototypeOf(Component)).call.apply(_ref,[this].concat(args))),_this),_this.handleStartEdit=function(){_this.props.onStartEdit(_this.props.ugc.ugc_id);},_this.handleCancelEdit=function(){_this.props.onCancelEdit(_this.props.ugc.ugc_id);},_this.handleSubmitEdit=function(_ref2){var answer_media=_ref2.answer_media,deleted_media=_ref2.deleted_media,text=_ref2.text;var _this$props=_this.props,ugc=_this$props.ugc,viewContext=_this$props.viewContext,parentUgcId=_this$props.parentUgcId,subject=_this$props.subject,locale=_this$props.locale;_this.props.onSubmitEdit({text:text,answer_media:answer_media,deleted_media:deleted_media,ugc_id:ugc.ugc_id,target:viewContext,ugc_type:'Answer',parent_ugc_id:parentUgcId,subject_id:subject.subject_id,catalog_id:subject.merchant.id,locale:locale});},_this.handleDelete=function(){if(window.confirm('Delete answer?')){var _this$props2=_this.props,_ugc=_this$props2.ugc,_viewContext=_this$props2.viewContext,_parentUgcId=_this$props2.parentUgcId,_subject=_this$props2.subject,_locale=_this$props2.locale;_this.props.onDelete({ugc_id:_ugc.ugc_id,target:_viewContext,ugc_type:'Answer',parent_ugc_id:_parentUgcId,subject_id:_subject.subject_id,catalog_id:_subject.merchant.id,locale:_locale});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Component,[{key:'render',value:function render(){var _props=this.props,ugc=_props.ugc,displayState=_props.displayState,requestStatus=_props.requestStatus,allowMedia=_props.allowMedia;if(displayState==='edit'){var isLoading=requestStatus==='pending';var error=requestStatus instanceof Error?renderErrorMessage(requestStatus,'editing'):null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__EditAnswer__["a" /* EditAnswer */],{ugc:ugc,isLoading:isLoading,error:error,onSubmit:this.handleSubmitEdit,onCancel:this.handleCancelEdit,allowMedia:allowMedia});}var aside=ugc.expert?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mt2'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["d" /* ButtonGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{onClick:this.handleStartEdit},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{onClick:this.handleDelete},' Delete '))):null;if(displayState==='view'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__QAComponents__["a" /* Article */],{ugc:ugc,aside:aside});}else if(displayState==='delete'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{style:{opacity:requestStatus==='pending'?0.4:1,pointerEvents:requestStatus==='pending'?'none':'auto'}},requestStatus instanceof Error&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_alerts__["b" /* ErrorAlert */],null,renderErrorMessage(requestStatus,'deleting')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__QAComponents__["a" /* Article */],{ugc:ugc,aside:aside}));}return null;}}]);return Component;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var AnswerArticle=function AnswerArticle(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_containers_answer_editing_AnswerEditingContext__["a" /* AnswerEditingContext */].Consumer,null,function(value){var state=value.state,onStartEdit=value.onStartEdit,onCancelEdit=value.onCancelEdit,onSubmitEdit=value.onSubmitEdit,onDelete=value.onDelete;var _state$get=state.get(props.ugc.ugc_id,{}),_state$get$type=_state$get.type,type=_state$get$type===undefined?'view':_state$get$type,requestStatus=_state$get.requestStatus;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component,Object.assign({},props,{displayState:type,requestStatus:requestStatus,onStartEdit:onStartEdit,onCancelEdit:onCancelEdit,onSubmitEdit:onSubmitEdit,onDelete:onDelete}));});};

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var XIcon=function XIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({viewBox:"0 0 40 40","aria-hidden":"true"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M 10,10 L 30,30 M 30,10 L 10,30"}));};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

// This file replaces `index.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.

if (false) {
  // All bundlers will remove this block in production bundle
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    throw new Error(
      'React Native does not have a built-in secure random generator. ' +
      'If you don’t need unpredictable IDs, you can use `nanoid/non-secure`. ' +
      'For secure ID install `expo-random` locally and use `nanoid/async`.'
    )
  }
  if (typeof self === 'undefined' || (!self.crypto && !self.msCrypto)) {
    throw new Error(
      'Your browser does not have secure random generator. ' +
      'If you don’t need unpredictable IDs, you can use nanoid/non-secure.'
    )
  }
}

var crypto = self.crypto || self.msCrypto

// This alphabet uses a-z A-Z 0-9 _- symbols.
// Symbols are generated for smaller size.
// -_zyxwvutsrqponmlkjihgfedcba9876543210ZYXWVUTSRQPONMLKJIHGFEDCBA
var url = '-_'
// Loop from 36 to 0 (from z to a and 9 to 0 in Base36).
var i = 36
while (i--) {
  // 36 is radix. Number.prototype.toString(36) returns number
  // in Base36 representation. Base36 is like hex, but it uses 0–9 and a-z.
  url += i.toString(36)
}
// Loop from 36 to 10 (from Z to A in Base36).
i = 36
while (i-- - 10) {
  url += i.toString(36).toUpperCase()
}

module.exports = function (size) {
  var id = ''
  var bytes = crypto.getRandomValues(new Uint8Array(size || 21))
  i = size || 21

  // Compact alternative for `for (var i = 0; i < size; i++)`
  while (i--) {
    // We can’t use bytes bigger than the alphabet. 63 is 00111111 bitmask.
    // This mask reduces random byte 0-255 to 0-63 values.
    // There is no need in `|| ''` and `* 1.6` hacks in here,
    // because bitmask trim bytes exact to alphabet size.
    id += url[bytes[i] & 63]
  }
  return id
}


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var isIE =  !!document.documentElement.currentStyle ;
var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'font-style', 'tab-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'box-sizing'];
var computedStyleCache = {};
var hiddenTextarea =  document.createElement('textarea');

var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
};

{
  hiddenTextarea.setAttribute('tab-index', '-1');
  hiddenTextarea.setAttribute('aria-hidden', 'true');
  forceHiddenStyles(hiddenTextarea);
}

function calculateNodeHeight(uiTextNode, uid, useCache, minRows, maxRows) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (minRows === void 0) {
    minRows = null;
  }

  if (maxRows === void 0) {
    maxRows = null;
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var nodeStyling = calculateNodeStyling(uiTextNode, uid, useCache);

  if (nodeStyling === null) {
    return null;
  }

  var paddingSize = nodeStyling.paddingSize,
      borderSize = nodeStyling.borderSize,
      boxSizing = nodeStyling.boxSizing,
      sizingStyle = nodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content

  Object.keys(sizingStyle).forEach(function (key) {
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
  var minHeight = -Infinity;
  var maxHeight = Infinity;
  var height = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  } // measure height of a textarea with a single row


  hiddenTextarea.value = 'x';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize; // Stores the value's rows count rendered in `hiddenTextarea`,
  // regardless if `maxRows` or `minRows` props are passed

  var valueRowCount = Math.floor(height / singleRowHeight);

  if (minRows !== null) {
    minHeight = singleRowHeight * minRows;

    if (boxSizing === 'border-box') {
      minHeight = minHeight + paddingSize + borderSize;
    }

    height = Math.max(minHeight, height);
  }

  if (maxRows !== null) {
    maxHeight = singleRowHeight * maxRows;

    if (boxSizing === 'border-box') {
      maxHeight = maxHeight + paddingSize + borderSize;
    }

    height = Math.min(maxHeight, height);
  }

  var rowCount = Math.floor(height / singleRowHeight);
  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    rowCount: rowCount,
    valueRowCount: valueRowCount
  };
}

function calculateNodeStyling(node, uid, useCache) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (useCache && computedStyleCache[uid]) {
    return computedStyleCache[uid];
  }

  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
    obj[name] = style.getPropertyValue(name);
    return obj;
  }, {});
  var boxSizing = sizingStyle['box-sizing']; // probably node is detached from DOM, can't read computed dimensions

  if (boxSizing === '') {
    return null;
  } // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths


  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache) {
    computedStyleCache[uid] = nodeInfo;
  }

  return nodeInfo;
}

var purgeCache = function purgeCache(uid) {
  delete computedStyleCache[uid];
};

var noop = function noop() {};

var uid = 0;

var TextareaAutosize =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TextareaAutosize, _React$Component);

  function TextareaAutosize(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this._onRef = function (node) {
      _this._ref = node;
      var inputRef = _this.props.inputRef;

      if (typeof inputRef === 'function') {
        inputRef(node);
        return;
      }

      inputRef.current = node;
    };

    _this._onChange = function (event) {
      if (!_this._controlled) {
        _this._resizeComponent();
      }

      _this.props.onChange(event, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    };

    _this._resizeComponent = function (callback) {
      if (callback === void 0) {
        callback = noop;
      }

      var nodeHeight = calculateNodeHeight(_this._ref, _this._uid, _this.props.useCacheForDOMMeasurements, _this.props.minRows, _this.props.maxRows);

      if (nodeHeight === null) {
        callback();
        return;
      }

      var height = nodeHeight.height,
          minHeight = nodeHeight.minHeight,
          maxHeight = nodeHeight.maxHeight,
          rowCount = nodeHeight.rowCount,
          valueRowCount = nodeHeight.valueRowCount;
      _this.rowCount = rowCount;
      _this.valueRowCount = valueRowCount;

      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
        _this.setState({
          height: height,
          minHeight: minHeight,
          maxHeight: maxHeight
        }, callback);

        return;
      }

      callback();
    };

    _this.state = {
      height: props.style && props.style.height || 0,
      minHeight: -Infinity,
      maxHeight: Infinity
    };
    _this._uid = uid++;
    _this._controlled = props.value !== undefined;
    _this._resizeLock = false;
    return _this;
  }

  var _proto = TextareaAutosize.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        _inputRef = _this$props.inputRef,
        _maxRows = _this$props.maxRows,
        _minRows = _this$props.minRows,
        _onHeightChange = _this$props.onHeightChange,
        _useCacheForDOMMeasurements = _this$props.useCacheForDOMMeasurements,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["inputRef", "maxRows", "minRows", "onHeightChange", "useCacheForDOMMeasurements"]);

    props.style = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props.style, {
      height: this.state.height
    });
    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);

    if (maxHeight < this.state.height) {
      props.style.overflow = 'hidden';
    }

    return Object(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"])("textarea", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      onChange: this._onChange,
      ref: this._onRef
    }));
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._resizeComponent(); // Working around Firefox bug which runs resize listeners even when other JS is running at the same moment
    // causing competing rerenders (due to setState in the listener) in React.
    // More can be found here - facebook/react#6324


    this._resizeListener = function () {
      if (_this2._resizeLock) {
        return;
      }

      _this2._resizeLock = true;

      _this2._resizeComponent(function () {
        _this2._resizeLock = false;
      });
    };

    window.addEventListener('resize', this._resizeListener);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this._resizeComponent();
    }

    if (this.state.height !== prevState.height) {
      this.props.onHeightChange(this.state.height, this);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this._resizeListener);
    purgeCache(this._uid);
  };

  return TextareaAutosize;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

TextareaAutosize.defaultProps = {
  inputRef: noop,
  onChange: noop,
  onHeightChange: noop,
  useCacheForDOMMeasurements: false
};
 false ? TextareaAutosize.propTypes = {
  inputRef: oneOfType([func, shape({
    current: any
  })]),
  maxRows: number,
  minRows: number,
  onChange: func,
  onHeightChange: func,
  style: object,
  useCacheForDOMMeasurements: bool,
  value: string
} : void 0;

/* harmony default export */ __webpack_exports__["a"] = (TextareaAutosize);


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return upload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteByToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_errors__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceTypes__ = __webpack_require__(72);
var CLOUD='//api.cloudinary.com/v1_1/powerreviews';var IMAGE_UPLOAD_PRESET="visual-answers-image";var VIDEO_UPLOAD_PRESET="visual-answers-video";// $$FlowFixMe
var UPLOAD_FOLDER="prod"+'/visual-answers';function getUploadPreset(resourceType){if(resourceType==='image'){return IMAGE_UPLOAD_PRESET;}else if(resourceType==='video'){return VIDEO_UPLOAD_PRESET;}else{throw new Error('Unknown resource type: \''+resourceType+'\'');}}var upload=function upload(file,resourceType){if(!IMAGE_UPLOAD_PRESET||!VIDEO_UPLOAD_PRESET||!UPLOAD_FOLDER){throw new Error('Environment is not configured');}var body=new FormData();// $$FlowFixMe
body.append('upload_preset',getUploadPreset(resourceType));body.append('file',file);body.append('resource_type',resourceType);body.append('folder',UPLOAD_FOLDER);return fetch(CLOUD+'/auto/upload',{method:'POST',body:body}).then(__WEBPACK_IMPORTED_MODULE_0_api_checkIfResponseIsOK__["a" /* default */]).then(function(response){return response.json();}).catch(function(err){return Promise.reject(__WEBPACK_IMPORTED_MODULE_1_lib_errors__["e" /* default */].isHttpError(err)?err:new __WEBPACK_IMPORTED_MODULE_1_lib_errors__["c" /* NetworkingError */]());});};var deleteByToken=function deleteByToken(token){var body=new FormData();body.append('token',token);return fetch(CLOUD+'/delete_by_token',{method:'POST',body:body}).then(__WEBPACK_IMPORTED_MODULE_0_api_checkIfResponseIsOK__["a" /* default */]).catch(function(err){});};

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnswerTextarea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_textarea_autosize__ = __webpack_require__(252);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// $$FlowIssue
var AnswerTextarea=Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function AnswerTextarea(props,ref){var rows=props.rows,style=props.style,rest=_objectWithoutProperties(props,['rows','style']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_textarea_autosize__["a" /* default */],Object.assign({minRows:props.rows||2,className:'form-control mb3',style:Object.assign({resize:'none'},style)},rest,{ref:ref}));});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = nanoid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nanoid__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nanoid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nanoid__);
function nanoid(prefix){return(prefix||'pr')+'-'+__WEBPACK_IMPORTED_MODULE_0_nanoid___default()();}

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StaticProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnswerEditingContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__answerEditingReducer__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__answerEditingSaga__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__answerEditingActions__ = __webpack_require__(143);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var REDUCER_NAME='answerEditing';Object(__WEBPACK_IMPORTED_MODULE_4_store__["c" /* injectSaga */])(__WEBPACK_IMPORTED_MODULE_2__answerEditingSaga__["a" /* saga */]);Object(__WEBPACK_IMPORTED_MODULE_4_store__["b" /* injectReducer */])(_defineProperty({},REDUCER_NAME,__WEBPACK_IMPORTED_MODULE_1__answerEditingReducer__["b" /* reducer */]));var defaultContextValue={state:__WEBPACK_IMPORTED_MODULE_1__answerEditingReducer__["a" /* defaultState */]};// $FlowIssue
var Context=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](defaultContextValue);var StaticProvider=function(_React$Component){_inherits(StaticProvider,_React$Component);function StaticProvider(){_classCallCheck(this,StaticProvider);return _possibleConstructorReturn(this,(StaticProvider.__proto__||Object.getPrototypeOf(StaticProvider)).apply(this,arguments));}_createClass(StaticProvider,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Context.Provider,{value:this.props},this.props.children);}}]);return StaticProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{state:state[REDUCER_NAME]};};var AnswerEditingContext={Provider:Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,{onDelete:__WEBPACK_IMPORTED_MODULE_5__answerEditingActions__["a" /* deleteAnswer */],onStartEdit:__WEBPACK_IMPORTED_MODULE_5__answerEditingActions__["e" /* openAnswerEditor */],onCancelEdit:__WEBPACK_IMPORTED_MODULE_5__answerEditingActions__["f" /* resetView */],onSubmitEdit:__WEBPACK_IMPORTED_MODULE_5__answerEditingActions__["c" /* editAnswer */]})(StaticProvider),StaticProvider:StaticProvider,Consumer:Context.Consumer};

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Instructs analytics.js to use the name `ga`.
window.GoogleAnalyticsObject='ga';// Creates an initial ga() function.
// The queued commands will be executed once analytics.js loads.
window.ga=window.ga||function(){(window.ga.q=window.ga.q||[]).push(arguments);};// alias global for brevity
var ga=window.ga;// Sets the time (as an integer) this tag was executed.
// Used for timing hits.
ga.l=+new Date();// Creates a default tracker with automatic cookie domain configuration.
ga('create','UA-237328-21',{cookieName:'prga',// re-use dashboard ga cookie
cookieDomain:'auto'});var Analytics={pageview:function pageview(page){ga('send',{hitType:'pageview',page:page});},event:function event(props){ga('send',Object.assign({hitType:'event'},props));},timing:function timing(props){ga('send',Object.assign({hitType:'timing'},props));},exception:function exception(props){ga('send',Object.assign({hitType:'exception'},props));},setPageTitle:function setPageTitle(title){ga('set','page',{title:title});},setUserId:function setUserId(userId){ga('set','userId',userId);}};/* harmony default export */ __webpack_exports__["a"] = (Analytics);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_search__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchForm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchForm_config_fields_config__ = __webpack_require__(51);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UGCTYPENAME=__WEBPACK_IMPORTED_MODULE_3__SearchForm_config_fields_config__["n" /* mediaUgcType */].name;var MediaSearch=function(_React$PureComponent){_inherits(MediaSearch,_React$PureComponent);function MediaSearch(){_classCallCheck(this,MediaSearch);return _possibleConstructorReturn(this,(MediaSearch.__proto__||Object.getPrototypeOf(MediaSearch)).apply(this,arguments));}_createClass(MediaSearch,[{key:'patchUgcType',value:function patchUgcType(val){return!val.get(UGCTYPENAME)?val.set(UGCTYPENAME,'Image Video'):val;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_search__["a" /* default */],Object.assign({label:MediaSearch.label,primaryFieldsets:__WEBPACK_IMPORTED_MODULE_2__SearchForm__["b" /* MediaFieldsets */].primaryFieldsets,extraFieldsets:__WEBPACK_IMPORTED_MODULE_2__SearchForm__["b" /* MediaFieldsets */].extraFieldsets,onSubmit:this.patchUgcType},this.props));}}]);return MediaSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);MediaSearch.label='Images & Video';/* harmony default export */ __webpack_exports__["a"] = (MediaSearch);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_search__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchForm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_content_search__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NetworkSearchCopy__ = __webpack_require__(260);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var label='Network Reviews';var NetworkReviewSearch=function NetworkReviewSearch(props){var hideCopy=props.hideCopy,rest=_objectWithoutProperties(props,['hideCopy']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_search__["a" /* default */],Object.assign({label:label,primaryFieldsets:__WEBPACK_IMPORTED_MODULE_2__SearchForm__["c" /* NetworkReviewFieldsets */].primaryFieldsets,extraFieldsets:__WEBPACK_IMPORTED_MODULE_2__SearchForm__["c" /* NetworkReviewFieldsets */].extraFieldsets,method:__WEBPACK_IMPORTED_MODULE_3_api_content_search__["b" /* networkSearch */],copy:hideCopy?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__NetworkSearchCopy__["a" /* default */],null)},rest));};NetworkReviewSearch.label=label;/* harmony default export */ __webpack_exports__["a"] = (NetworkReviewSearch);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__network_icon_png__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__network_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__network_icon_png__);
var SyndicationCopy=function SyndicationCopy(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["j" /* FeatureBanner */],{heading:'Syndication enables UGC sharing from brands to retailers',copy:'On average, Syndication provides 58% of retailer\u2019s reviews, leading to\nhigher impression and conversion rates on product pages.',iconUrl:__WEBPACK_IMPORTED_MODULE_2__network_icon_png___default.a});};/* harmony default export */ __webpack_exports__["a"] = (SyndicationCopy);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NetworkQuestions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_search__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_content_search__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NetworkSearchCopy__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchForm_config_forms_config__ = __webpack_require__(240);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var primaryFieldsets=__WEBPACK_IMPORTED_MODULE_4__SearchForm_config_forms_config__["c" /* NetworkQuestionFieldsets */].primaryFieldsets;var label='Network Questions';function NetworkQuestions(props){var hideCopy=props.hideCopy,rest=_objectWithoutProperties(props,['hideCopy']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_search__["a" /* default */],Object.assign({label:label,primaryFieldsets:primaryFieldsets,method:__WEBPACK_IMPORTED_MODULE_2_api_content_search__["b" /* networkSearch */],copy:hideCopy?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NetworkSearchCopy__["a" /* default */],null)},rest));}NetworkQuestions.label=label;

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_search__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchForm__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuestionSearch=function(_React$PureComponent){_inherits(QuestionSearch,_React$PureComponent);function QuestionSearch(){_classCallCheck(this,QuestionSearch);return _possibleConstructorReturn(this,(QuestionSearch.__proto__||Object.getPrototypeOf(QuestionSearch)).apply(this,arguments));}_createClass(QuestionSearch,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_search__["a" /* default */],Object.assign({label:QuestionSearch.label,primaryFieldsets:__WEBPACK_IMPORTED_MODULE_2__SearchForm__["g" /* QuestionFieldsets */].primaryFieldsets,extraFieldsets:__WEBPACK_IMPORTED_MODULE_2__SearchForm__["g" /* QuestionFieldsets */].extraFieldsets},this.props));}}]);return QuestionSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);QuestionSearch.label='Native Questions';/* harmony default export */ __webpack_exports__["a"] = (QuestionSearch);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_search__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchForm__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnswerSearch=function(_React$PureComponent){_inherits(AnswerSearch,_React$PureComponent);function AnswerSearch(){_classCallCheck(this,AnswerSearch);return _possibleConstructorReturn(this,(AnswerSearch.__proto__||Object.getPrototypeOf(AnswerSearch)).apply(this,arguments));}_createClass(AnswerSearch,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_search__["a" /* default */],Object.assign({label:AnswerSearch.label,primaryFieldsets:__WEBPACK_IMPORTED_MODULE_2__SearchForm__["a" /* AnswerFieldsets */].primaryFieldsets,extraFieldsets:__WEBPACK_IMPORTED_MODULE_2__SearchForm__["a" /* AnswerFieldsets */].extraFieldsets},this.props));}}]);return AnswerSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);AnswerSearch.label='Answers';/* harmony default export */ __webpack_exports__["a"] = (AnswerSearch);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReviewSearch__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaSearch__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QuestionSearch__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnswerSearch__ = __webpack_require__(710);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ReviewSearch__["a"]; });
/* unused harmony reexport MediaSearch */
/* unused harmony reexport QuestionSearch */
/* unused harmony reexport AnswerSearch */


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UgcAssignmentContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ugcAssignmentSaga__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ugcAssignmentReducer__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UgcAssignmentContext__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var REDUCER_NAME='ugcAssignment';Object(__WEBPACK_IMPORTED_MODULE_3_store__["c" /* injectSaga */])(__WEBPACK_IMPORTED_MODULE_1__ugcAssignmentSaga__["a" /* default */]);Object(__WEBPACK_IMPORTED_MODULE_3_store__["b" /* injectReducer */])(_defineProperty({},REDUCER_NAME,__WEBPACK_IMPORTED_MODULE_2__ugcAssignmentReducer__["d" /* default */]));var UgcAssignmentContext=__WEBPACK_IMPORTED_MODULE_4__UgcAssignmentContext__["a" /* default */];var UgcAssignmentProvider=function(_React$Component){_inherits(UgcAssignmentProvider,_React$Component);function UgcAssignmentProvider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UgcAssignmentProvider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UgcAssignmentProvider.__proto__||Object.getPrototypeOf(UgcAssignmentProvider)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UgcAssignmentProvider,[{key:'render',value:function render(){if(!this.state)return null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__UgcAssignmentContext__["a" /* default */].Provider,{value:this.state},this.props.children);}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps){return{assignments:nextProps.ugcAssignment,requestAssignment:nextProps.requestAssignment};}}]);return UgcAssignmentProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{ugcAssignment:state[REDUCER_NAME]};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,{requestAssignment:__WEBPACK_IMPORTED_MODULE_2__ugcAssignmentReducer__["f" /* requestAssignment */]})(UgcAssignmentProvider));

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Channels */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChannelAlert__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_client_alertConfigActions__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_client_ClientProvider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChannelListContainer__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChannelInfo__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lib_async_value__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_channels_ChannelList__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_client_alertConfigReducer__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ducks_auth_context__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__saga__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__reducer__ = __webpack_require__(742);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// inject channel sagas
Object(__WEBPACK_IMPORTED_MODULE_14_store__["c" /* injectSaga */])(__WEBPACK_IMPORTED_MODULE_15__saga__["a" /* default */]);Object(__WEBPACK_IMPORTED_MODULE_14_store__["b" /* injectReducer */])(__WEBPACK_IMPORTED_MODULE_16__reducer__["a" /* default */]);var Channels=function(_React$PureComponent){_inherits(Channels,_React$PureComponent);function Channels(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Channels);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Channels.__proto__||Object.getPrototypeOf(Channels)).call.apply(_ref,[this].concat(args))),_this),_this.state={activeChannel:null},_this.showAlertManager=function(channel){_this.setState({activeChannel:channel});},_this.closeAlertManager=function(){_this.setState({activeChannel:null});},_this.handleAlertManagerSubmit=function(updatedConfig,clientId){var activeChannel=_this.state.activeChannel;if(!activeChannel)return;_this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_containers_client_alertConfigActions__["d" /* requestModerationAlertUpdate */])(Object.assign({},updatedConfig,{channel:activeChannel.name,client_id:+clientId}),{clientId:+clientId,channel:activeChannel.name}));},_this.renderAlertManager=function(_ref2){var _ref2$clientProps=_ref2.clientProps,userProfiles=_ref2$clientProps.userProfiles,expertUserProfiles=_ref2$clientProps.expertUserProfiles,clientId=_ref2$clientProps.clientId,alertConfigs=_ref2$clientProps.alertConfigs,auth=_ref2.auth;var activeChannel=_this.state.activeChannel;if(!activeChannel||!clientId)return null;var isAssignedChannel=activeChannel.name==='AssignedQnA'||activeChannel.name==='AssignedReview';var userProfilesForChannel=isAssignedChannel?[// This ensures that the logged in user can subscribe themselves to alerts
{email:auth.email,name:auth.name,profile_id:auth.profile_id}]:userProfiles;if(!Array.isArray(userProfilesForChannel))return null;var _ref3=alertConfigs instanceof __WEBPACK_IMPORTED_MODULE_7_immutable__["Map"]?alertConfigs.get(activeChannel.name,__WEBPACK_IMPORTED_MODULE_11_containers_client_alertConfigReducer__["a" /* EmptyModerationAlertConfigRecord */]):__WEBPACK_IMPORTED_MODULE_11_containers_client_alertConfigReducer__["a" /* EmptyModerationAlertConfigRecord */],currentAlertConfig=_ref3.config,changeStatus=_ref3.changeStatus;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ChannelAlert__["a" /* default */],{title:activeChannel.label// $FlowFixMe better record typing
,onSubmit:function onSubmit(config){return _this.handleAlertManagerSubmit(config,clientId);},onClose:_this.closeAlertManager,userProfiles:userProfilesForChannel,currentAlertConfig:currentAlertConfig,changeStatus:changeStatus});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Channels,[{key:'render',value:function render(){var _this2=this;var _props=this.props,ugctype=_props.ugctype,routerProps=_objectWithoutProperties(_props,['ugctype']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_ducks_auth_context__["a" /* AuthContext */].Consumer,null,function(auth){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_containers_client_ClientProvider__["a" /* ClientContext */].Consumer,null,function(clientProps){if(!clientProps)return null;var userProfiles=clientProps.userProfiles,clientId=clientProps.clientId,properties=clientProps.properties,catalogs=clientProps.catalogs;var canManageAlerts=Array.isArray(userProfiles);var props=Object.assign({},routerProps,canManageAlerts===true&&{onChannelSelect:_this2.showAlertManager});if(properties===__WEBPACK_IMPORTED_MODULE_8_lib_async_value__["b" /* default */].Pending||catalogs===__WEBPACK_IMPORTED_MODULE_8_lib_async_value__["b" /* default */].Pending){return routerProps.match.isExact===true?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PendingChannelList,null):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_components__["i" /* EmptyCard */],{message:'Loading Channels...'});}if(properties instanceof __WEBPACK_IMPORTED_MODULE_7_immutable__["Map"]&&catalogs instanceof __WEBPACK_IMPORTED_MODULE_7_immutable__["List"]){var allChannels=getRelevantChannels(properties,catalogs,ugctype);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ChannelListContainer__["a" /* default */],Object.assign({},props,{profileId:auth.profile_id,channels:allChannels,clientId:clientId,properties:properties})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{'data-translate':'true'},_this2.renderAlertManager({clientProps:clientProps,auth:auth})));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_components__["i" /* EmptyCard */],{message:'An Error occurred while loading your channels.'});});});}}]);return Channels;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);function getModerationChannels(ugcType){return __WEBPACK_IMPORTED_MODULE_6__ChannelInfo__["b" /* DefaultModerationChannels */].reduce(function(acc,channelName){if(__WEBPACK_IMPORTED_MODULE_6__ChannelInfo__["d" /* channelByName */].hasOwnProperty(channelName)){var channel=__WEBPACK_IMPORTED_MODULE_6__ChannelInfo__["d" /* channelByName */][channelName];if(channel.ugctype===ugcType){acc.push(channel);}}return acc;},[]);}function getBrandEngageChannels(brandEngageType,ugcType){var brandChannelNames=brandEngageType==='brand'?__WEBPACK_IMPORTED_MODULE_6__ChannelInfo__["a" /* BrandChannelNames */]:brandEngageType==='retailer'?__WEBPACK_IMPORTED_MODULE_6__ChannelInfo__["c" /* RetailerChannelNames */]:[];return brandChannelNames.reduce(function(acc,channelName){if(__WEBPACK_IMPORTED_MODULE_6__ChannelInfo__["d" /* channelByName */].hasOwnProperty(channelName)){var channel=__WEBPACK_IMPORTED_MODULE_6__ChannelInfo__["d" /* channelByName */][channelName];if(channel.ugctype===ugcType&&channel.type==='brand_engage'){acc.push(channel);}}return acc;},[]);}function getRelevantChannels(properties,catalogs,ugctype){var brandEngageType=properties.get('BRAND_ENGAGE_TYPE');var showDefaultModerationChannels=properties.get('SHOW_CLIENT_MODERATION_CHANNELS');var isBrand=brandEngageType==='brand';if(isBrand&&showDefaultModerationChannels===false){return getBrandEngageChannels(brandEngageType,ugctype);}var l2AutoApproveLevel=properties.get('LEVEL2_AUTO_APPROVE_LEVEL');var clientModerationRequired=typeof l2AutoApproveLevel==='number'&&l2AutoApproveLevel>0;var hasSocialCollection=catalogs.filter(function(catalog){return catalog.social_collection_property_id;}).size>0;var moderationChannels=getModerationChannels(ugctype);if(clientModerationRequired&&ugctype===__WEBPACK_IMPORTED_MODULE_6__ChannelInfo__["d" /* channelByName */].AwaitingClientModeration.ugctype){moderationChannels.push(__WEBPACK_IMPORTED_MODULE_6__ChannelInfo__["d" /* channelByName */].AwaitingClientModeration);}if(hasSocialCollection&&ugctype===__WEBPACK_IMPORTED_MODULE_6__ChannelInfo__["d" /* channelByName */].SocialCollection.ugctype){moderationChannels.push(__WEBPACK_IMPORTED_MODULE_6__ChannelInfo__["d" /* channelByName */].SocialCollection);}return[].concat(_toConsumableArray(moderationChannels),_toConsumableArray(getBrandEngageChannels(brandEngageType,ugctype)));}function PendingChannelList(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_containers_channels_ChannelList__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_containers_channels_ChannelList__["a" /* default */].ItemPending,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_containers_channels_ChannelList__["a" /* default */].ItemPending,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_containers_channels_ChannelList__["a" /* default */].ItemPending,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_containers_channels_ChannelList__["a" /* default */].ItemPending,null));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])()(Channels));

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChannelList_scss__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChannelList_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChannelList_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_random__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_random__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(4);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChannelCount=function(_React$PureComponent){_inherits(ChannelCount,_React$PureComponent);function ChannelCount(){_classCallCheck(this,ChannelCount);return _possibleConstructorReturn(this,(ChannelCount.__proto__||Object.getPrototypeOf(ChannelCount)).apply(this,arguments));}_createClass(ChannelCount,[{key:'render',value:function render(){var _props=this.props,count=_props.count,_props$ugctype=_props.ugctype,ugctype=_props$ugctype===undefined?'Item':_props$ugctype;var countText=void 0;var label=ugctype+'s';if(count==null){countText=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_2__ChannelList_scss___default.a.channelListCountLoader},'\xA0');label=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_2__ChannelList_scss___default.a.channelListCountLoader,style:{paddingLeft:'2.2em'}},'\xA0');}else if(typeof count==='number'){countText=count;label=count===1?ugctype:label;}else{countText='x';}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'pv2 bg-light-gray nowrap'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'db f3 tc b lh-solid brandon tracked-tight Channel__count'},countText),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'f6 gray db tc tracked-tight'},label));}}]);return ChannelCount;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);var ListItemLayout=function ListItemLayout(props){var _React$Children$toArr=__WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(props.children),_React$Children$toArr2=_slicedToArray(_React$Children$toArr,3),count=_React$Children$toArr2[0],main=_React$Children$toArr2[1],controls=_React$Children$toArr2[2];var _props$pt=props.pt,pt=_props$pt===undefined?3:_props$pt,_props$pb=props.pb,pb=_props$pb===undefined?3:_props$pb,_props$bb=props.bb,bb=_props$bb===undefined?true:_props$bb;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex items-center w-100 ChannelList__item b--moon-gray pt'+pt+' pb'+pb+' '+(bb?'bb':'')},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex-none ChannelList__item__count'},count),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex-auto mh3'},main),controls&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex-none'},controls));};var ListItem=function(_React$Component){_inherits(ListItem,_React$Component);function ListItem(){_classCallCheck(this,ListItem);return _possibleConstructorReturn(this,(ListItem.__proto__||Object.getPrototypeOf(ListItem)).apply(this,arguments));}_createClass(ListItem,[{key:'componentDidMount',value:function componentDidMount(){this.props.requestChannelStats(this.props.channelName);}},{key:'render',value:function render(){var _props2=this.props,label=_props2.label,description=_props2.description,path=_props2.path,count=_props2.count,children=_props2.children,hasWorklist=_props2.hasWorklist,ugctype=_props2.ugctype;var listItemProps=hasWorklist===true?{pb:0,bb:false}:null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ListItemLayout,listItemProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ChannelCount,{count:count,ugctype:ugctype}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'mt0 mb0'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:path,className:'no-underline Channel__label'},label)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'gray Channel__description'},description)),children);}}]);return ListItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var WorkListItem=function(_React$Component2){_inherits(WorkListItem,_React$Component2);function WorkListItem(){_classCallCheck(this,WorkListItem);return _possibleConstructorReturn(this,(WorkListItem.__proto__||Object.getPrototypeOf(WorkListItem)).apply(this,arguments));}_createClass(WorkListItem,[{key:'componentDidMount',value:function componentDidMount(){this.props.requestChannelStats(this.props.channelName);}},{key:'render',value:function render(){var _props3=this.props,description=_props3.description,path=_props3.path,count=_props3.count;var countText=typeof count==='number'?count:count instanceof Error?'?':__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_2__ChannelList_scss___default.a.channelListCountLoader,style:{lineHeight:0.6}},'\xA0');return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ListItemLayout,{pt:2},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{style:{width:'2.2em'}},' '),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex items-center'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'db f3 tc b brandon tracked-tight bg-light-gray nowrap mr3 br-pill lh-solid pv1',style:{width:50,fontSize:'1.4rem'}},countText),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'mt0 mb0'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:path,className:'no-underline Channel__label'},'Worklist')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'gray Channel__description'},description))));}}]);return WorkListItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ListItemPending=function ListItemPending(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ListItemLayout,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ChannelCount,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mt0 mb1 bg-light-blue h1',style:{width:__WEBPACK_IMPORTED_MODULE_3_lodash_random___default()(15,30)+'%'}},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'bg-light-gray mt2 h1',style:{width:__WEBPACK_IMPORTED_MODULE_3_lodash_random___default()(50,70)+'%'}},'\xA0')));};var List=function List(props){var children=props.children,header=props.header;if(__WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children)===0){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components__["i" /* EmptyCard */],{title:'No Channels',message:'Seems like your channels have not been configured, contact PowerReviews Support for help.'});}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',{className:'mb4'},header&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('header',{className:'gray'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h1',{className:'mt0 mb3 gray normal f5 sans-serif'},header)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components__["e" /* Card */],{verticalSpacing:0},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'pv3'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mh4 ChannelList','data-translate':true},children))));};List.Item=ListItem;List.WorkListItem=WorkListItem;List.ItemPending=ListItemPending;/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return channelByName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultModerationChannels; });
/* harmony export (immutable) */ __webpack_exports__["h"] = isModerationChannel;
/* harmony export (immutable) */ __webpack_exports__["f"] = isBrandEngageChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = isBrandEngageBrandChannel;
/* harmony export (immutable) */ __webpack_exports__["g"] = isBrandEngageRetailerChannel;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrandChannelNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RetailerChannelNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_kebabCase__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_kebabCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_kebabCase__);
// Reference
// https://github.com/powerreviews/pwr-commons/blob/master/pwr-commons-core/src/main/java/com/powerreviews/commons/core/enumeration/Channel.java
var moderationChannels={SafetyAlert:{label:'Safety Alerts',description:'Reviews moderated by PowerReviews that contain an important safety issue from the past 30 days.',type:'moderation',ugctype:'Review',contentUgctype:'Review'},SafetyConcern:{label:'Safety Concerns',description:'Reviews moderated by PowerReviews that contain a safety concern from the past 30 days.',type:'moderation',ugctype:'Review',contentUgctype:'Review'},SafetyAlertQuestion:{label:'Safety Alerts',description:'Questions moderated by PowerReviews that contain an important safety issue from the past 30 days.',type:'moderation',ugctype:'Question',contentUgctype:'Question'},SafetyConcernQuestion:{label:'Safety Concerns',description:'Questions moderated by PowerReviews that contain a safety concern from the past 30 days.',type:'moderation',ugctype:'Question',contentUgctype:'Question'},CustomerServiceIssue:{label:'Customer Service Issue',description:'Reviews moderated by PowerReviews that contain a customer service issue from the past 30 days.',type:'moderation',ugctype:'Review',contentUgctype:'Review'},AwaitingClientModeration:{label:'Awaiting Moderation',description:'All reviews moderated by PowerReviews that your team has not moderated from the past 30 days.',type:'moderation',ugctype:'Review',contentUgctype:'Review',worklist:'Reviews from the Awaiting Moderation Channel that have not been responded to or moderated by your team.'},EscalatedReview:{label:'Escalated Reviews',description:'All reviews that contain words included in your escalated words list, and reviews that are escalated internally from the past 30 days.',type:'moderation',ugctype:'Review',contentUgctype:'Review',worklist:'Reviews from the Escalated Reviews Channel that have not been responded to or moderated by your team.'},WebIssue:{label:'Web Issue',description:'Reviews moderated by PowerReviews that describe a web issue from the past 30 days.',type:'moderation',ugctype:'Review',contentUgctype:'Review'},LegalConcern:{label:'Legal Concern',description:'Reviews moderated by PowerReviews that contain a legal concern from the past 30 days.',type:'moderation',ugctype:'Review',contentUgctype:'Review'},LowRated:{label:'Low Rated',description:'All reviews that contain a low star rating from the past 30 days.',type:'moderation',ugctype:'Review',contentUgctype:'Review',worklist:'Reviews from the Low Rated Channel that have not been responded to or moderated by your team.'},SocialCollection:{label:'Social Collection',description:'Images and Videos collected and approved through Social Collection content streams.',type:'moderation',ugctype:'Review',contentUgctype:'Review',worklist:'Images and Videos from the Social Collection Channel that have not been moderated by your team.'},UnansweredQuestion:{label:'Unanswered Questions',description:'All questions awaiting an answer from the past 30 days.',type:'moderation',ugctype:'Question',contentUgctype:'Question',worklist:'Questions from the Unanswered Questions Channel that have not been answered, moderated by your team, or assigned to another team member.'},AssignedQnA:{label:'Assigned Questions',description:'Questions that have been assigned to you.',type:'moderation',ugctype:'Question',contentUgctype:'Question'},AssignedReview:{label:'Assigned Reviews',description:'Reviews that have been assigned to you.',type:'moderation',ugctype:'Review',contentUgctype:'Review'},UpdatedReview:{label:'Updated Reviews',description:'Reviews updated by your customers in the past 30 days.',type:'moderation',ugctype:'Review',contentUgctype:'Review',worklist:'Reviews from the Updated Reviews Channel that have not been moderated by your team.'}};var brandEngageBrandChannels={NoBrandAnswer:{label:'Questions Without Brand Answers',description:'Questions you haven’t answered about your brand’s products from your retailers.',type:'brand_engage',brandEngageType:'brand',ugctype:'Question',contentUgctype:'Question',brandEngageBrandActionable:true},LowRatedWithNoResponse:{label:'Reviews With Low Ratings from Retailer Partners',description:'Reviews that contain ratings less than 3 stars.',type:'brand_engage',brandEngageType:'brand',ugctype:'Review',contentUgctype:'Review',brandEngageBrandActionable:true},BrandEngageResponse:{label:'Your Review Responses',description:"Responses to your brand's reviews that you submitted to your retailers.",type:'brand_engage',brandEngageType:'brand',ugctype:'Review',contentUgctype:'Response'},BrandEngageAnswer:{label:'Your Answers',description:'Answers to your brand’s questions that you submitted to your retailers.',type:'brand_engage',brandEngageType:'brand',ugctype:'Question',contentUgctype:'Answer'}};var brandEngageRetailerChannels={RetailerBrandEngageAnswer:{label:'Brand Question Answers',description:'Answers your brand partners submitted to customer questions.',type:'brand_engage',brandEngageType:'retailer',ugctype:'Question',contentUgctype:'Answer'},RetailerBrandEngageResponse:{label:'Brand Review Responses',description:'Review responses your brand partners submitted to customer reviews.',type:'brand_engage',brandEngageType:'retailer',ugctype:'Review',contentUgctype:'Response'}};var channelInfoByName=Object.assign({},moderationChannels,brandEngageBrandChannels,brandEngageRetailerChannels);var channelByName=Object.keys(channelInfoByName).reduce(function(acc,name){var info=channelInfoByName[name];acc[name]=Object.assign({name:name,slug:info.slug?info.slug:__WEBPACK_IMPORTED_MODULE_0_lodash_kebabCase___default()(info.label)},info);return acc;},{});var DefaultModerationChannels=['SafetyAlert','SafetyConcern','CustomerServiceIssue','EscalatedReview','WebIssue','LegalConcern','UnansweredQuestion','AssignedQnA','LowRated','AssignedReview','SafetyAlertQuestion','SafetyConcernQuestion','UpdatedReview'];function isModerationChannel(ch){return ch.type==='moderation';}function isBrandEngageChannel(ch){return ch.type==='brand_engage';}function isBrandEngageBrandChannel(ch){return isBrandEngageChannel(ch)&&ch.brandEngageType==='brand';}function isBrandEngageRetailerChannel(ch){return isBrandEngageChannel(ch)&&ch.brandEngageType==='retailer';}var BrandChannelNames=Object.keys(brandEngageBrandChannels);var RetailerChannelNames=Object.keys(brandEngageRetailerChannels);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoItemsMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RequestErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
var NoItemsMessage=function NoItemsMessage(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],{title:'No Content',message:'This channel does not have any content'});};var RequestErrorMessage=function RequestErrorMessage(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],{title:'This channel couldn\'t load.',message:'An Error occurred while fetching content. If this error persists, contact PowerReviews Support.'});};

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__removePIIFromUgc__ = __webpack_require__(734);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var brandEngageSearch=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function brandEngageSearch(token,_ref){var clientId=_ref.clientId,channelName=_ref.channelName,brandEngageType=_ref.brandEngageType;var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/brand-engage/'+brandEngageType+'/client/'+clientId+'/channel/'+channelName);var fetchOptions={headers:{Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();}).then(function(response){return Array.isArray(response)?brandEngageType==='brand'?response.map(brandTransformations):response.map(moveCatalogToUgc):response;});});/* harmony default export */ __webpack_exports__["a"] = (brandEngageSearch);function brandTransformations(item){return removePIIFromUgc(moveCatalogToUgc(item));}function removePIIFromUgc(item){return Object.assign({},item,{ugc:Object(__WEBPACK_IMPORTED_MODULE_3__removePIIFromUgc__["a" /* default */])(item.ugc)});}function moveCatalogToUgc(item){var brand_catalog=item.brand_catalog,rest=_objectWithoutProperties(item,['brand_catalog']);var catalog={id:brand_catalog.catalog_id,name:brand_catalog.name,group_id:brand_catalog.merchant_group.merchant_group_id,group_name:brand_catalog.merchant_group.name};return Object.assign({},item,{ugc:Object.assign({},rest.ugc,{catalog:catalog})});}

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Card__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_SocialCollectionLandingPage_jpg__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_SocialCollectionLandingPage_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_SocialCollectionLandingPage_jpg__);
var GetAccess=function GetAccess(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ph6 pv4 flex flex-column items-center'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img',{className:'w-75',src:__WEBPACK_IMPORTED_MODULE_2_assets_SocialCollectionLandingPage_jpg___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h1',{className:'tc b mt3 mb2 brandon',style:{fontSize:24}},'Your brand advocates are posting. Capture their content.'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'tc fw1 mv2 lh-copy gray',style:{fontSize:16}},'Social Collection enables you to collect and display the images and videos your customers are posting of your products on Instagram.'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('a',{className:'link mv2',style:{fontSize:16},target:'_',href:'https://www.powerreviews.com/software-products/social-suite/'},'Learn More')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'pa4 flex flex-column items-center bg-light-gray'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h2',{className:'b mv2 brandon',style:{fontSize:20}},'Interested in Getting Started?'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'fw1 mv2 gray',style:{fontSize:16}},'Talk to your Client Success Director today to enable Social Collection for your account.')));};/* harmony default export */ __webpack_exports__["a"] = (GetAccess);

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(273);
module.exports = __webpack_require__(278);


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(274).enable();
  window.Promise = __webpack_require__(276);
}

// fetch() polyfill for making API calls.
__webpack_require__(277);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(103);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(147);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(147);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 277 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_logout__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pwr_brandon_text__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pwr_brandon_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pwr_brandon_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scss_tachyons_css__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scss_tachyons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__scss_tachyons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_scss__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_font_awesome_css_font_awesome_css__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pwr_ui_css_dist_modules_buttons_css__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pwr_ui_css_dist_modules_buttons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pwr_ui_css_dist_modules_buttons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pwr_ui_css_dist_modules_forms_css__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pwr_ui_css_dist_modules_forms_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pwr_ui_css_dist_modules_forms_css__);
function render(){__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{exact:true,path:'/logout',component:__WEBPACK_IMPORTED_MODULE_5_pages_logout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_6_pages__["a" /* default */]})))),document.getElementById('root'));}function main(){global.version="48.0.0";render();}main();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(103),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(103),r=__webpack_require__(281);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(282);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(104);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(286);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(151);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(310);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(157);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(297);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(295);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(154);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(299);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(303);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21), __webpack_require__(302)(module)))

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(155);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(156);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(157);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(158);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(311);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(104);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(105);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(105);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(319);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(106);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(159);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(323);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(325);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(163);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(327);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(106);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(329);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(107);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(163);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(107);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(333);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(161);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(165);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(43);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(43);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(18);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["b"] = takeLatest;
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__io__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(167);



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["f" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["f" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["f" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(18);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* unused harmony reexport is */
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(33);
/* unused harmony reexport asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(166);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = main;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ducks_authActions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ducks_routeActions__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_appConfigSaga__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_appConfigActions__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ducks_authSaga__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ducks_coreDataSaga__ = __webpack_require__(44);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(routeListener),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(startUpData),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(appSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(main);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var matchSuccessfulLogin=function matchSuccessfulLogin(action){return action.type===__WEBPACK_IMPORTED_MODULE_2_ducks_authActions__["c" /* receiveAuth */].toString()&&Boolean(action.error)===false;};function routeListener(){var task,_ref,_ref$payload,saga,_ref$payload$sagaArgs,sagaArgs,cb;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function routeListener$(_context){while(1){switch(_context.prev=_context.next){case 0:task=void 0;case 1:if(false){_context.next=23;break;}_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3_ducks_routeActions__["a" /* enterRoute */]);case 4:_ref=_context.sent;_ref$payload=_ref.payload;saga=_ref$payload.saga;_ref$payload$sagaArgs=_ref$payload.sagaArgs;sagaArgs=_ref$payload$sagaArgs===undefined?[]:_ref$payload$sagaArgs;cb=_ref$payload.cb;if(!saga){_context.next=21;break;}_context.next=13;return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */].apply(undefined,[saga].concat(_toConsumableArray(sagaArgs)));case 13:task=_context.sent;if(!cb){_context.next=17;break;}_context.next=17;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(cb);case 17:_context.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3_ducks_routeActions__["b" /* exitRoute */]);case 19:_context.next=21;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* cancel */])(task);case 21:_context.next=1;break;case 23:case'end':return _context.stop();}}},_marked,this);}function startUpData(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function startUpData$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(__WEBPACK_IMPORTED_MODULE_4_ducks_appConfigSaga__["a" /* default */]);case 2:case'end':return _context2.stop();}}},_marked2,this);}// start Saga will toggle
function appSaga(){var startUpTask,routeListenerTask;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function appSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(false){_context3.next=19;break;}_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* take */])(matchSuccessfulLogin);case 3:_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(startUpData);case 5:startUpTask=_context3.sent;_context3.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(routeListener);case 8:routeListenerTask=_context3.sent;_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_ducks_appConfigActions__["d" /* signalAppReady */])());case 11:_context3.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_2_ducks_authActions__["b" /* logout */]);case 13:_context3.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_ducks_appConfigActions__["c" /* signalAppNotReady */])());case 15:_context3.next=17;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* cancel */])(startUpTask,routeListenerTask);case 17:_context3.next=0;break;case 19:case'end':return _context3.stop();}}},_marked3,this);}function main(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function main$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(__WEBPACK_IMPORTED_MODULE_6_ducks_authSaga__["a" /* default */]);case 2:_context4.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(appSaga);case 4:_context4.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(__WEBPACK_IMPORTED_MODULE_7_ducks_coreDataSaga__["c" /* default */]);case 6:case'end':return _context4.stop();}}},_marked4,this);}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(344);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isSymbol__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_isEmpty__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_toString__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_isString__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(55);








function isValidActionType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_1__utils_isFunction__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_2__utils_isSymbol__["a" /* default */])(type);
}

function isValidActionTypes(types) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_isEmpty__["a" /* default */])(types)) {
    return false;
  }

  return types.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = new Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
  var combinedActionType = actionsTypes.map(__WEBPACK_IMPORTED_MODULE_4__utils_toString__["a" /* default */]).join(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* ACTION_TYPE_DELIMITER */]);
  return {
    toString: function toString() {
      return combinedActionType;
    }
  };
}

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'symbol' || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Symbol]';
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value === null;
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isPlainObject__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isFunction__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_identity__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_isArray__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_isString__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_isNil__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_getLastElement__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_camelCase__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_flattenActionMap__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_unflattenActionCreators__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__createAction__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(55);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















function createActions(actionMap) {
  for (var _len = arguments.length, identityActions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    identityActions[_key - 1] = arguments[_key];
  }

  var options = Object(__WEBPACK_IMPORTED_MODULE_1__utils_isPlainObject__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_getLastElement__["a" /* default */])(identityActions)) ? identityActions.pop() : {};
  __WEBPACK_IMPORTED_MODULE_0_invariant___default()(identityActions.every(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */]) && (Object(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */])(actionMap) || Object(__WEBPACK_IMPORTED_MODULE_1__utils_isPlainObject__["a" /* default */])(actionMap)), 'Expected optional object followed by string action types');

  if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_isString__["a" /* default */])(actionMap)) {
    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions), options);
  }

  return _objectSpread({}, actionCreatorsFromActionMap(actionMap, options), actionCreatorsFromIdentityActions(identityActions, options));
}

function actionCreatorsFromActionMap(actionMap, options) {
  var flatActionMap = Object(__WEBPACK_IMPORTED_MODULE_10__utils_flattenActionMap__["a" /* default */])(actionMap, options);
  var flatActionCreators = actionMapToActionCreators(flatActionMap);
  return Object(__WEBPACK_IMPORTED_MODULE_11__utils_unflattenActionCreators__["a" /* default */])(flatActionCreators, options);
}

function actionMapToActionCreators(actionMap, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      prefix = _ref.prefix,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? __WEBPACK_IMPORTED_MODULE_13__constants__["b" /* DEFAULT_NAMESPACE */] : _ref$namespace;

  function isValidActionMapValue(actionMapValue) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_isFunction__["a" /* default */])(actionMapValue) || Object(__WEBPACK_IMPORTED_MODULE_6__utils_isNil__["a" /* default */])(actionMapValue)) {
      return true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_isArray__["a" /* default */])(actionMapValue)) {
      var _actionMapValue$ = actionMapValue[0],
          payload = _actionMapValue$ === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */] : _actionMapValue$,
          meta = actionMapValue[1];
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_isFunction__["a" /* default */])(payload) && Object(__WEBPACK_IMPORTED_MODULE_2__utils_isFunction__["a" /* default */])(meta);
    }

    return false;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__["a" /* default */])(Object.keys(actionMap), function (partialActionCreators, type) {
    var _objectSpread2;

    var actionMapValue = actionMap[type];
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ("functions for " + type));
    var prefixedType = prefix ? "" + prefix + namespace + type : type;
    var actionCreator = Object(__WEBPACK_IMPORTED_MODULE_4__utils_isArray__["a" /* default */])(actionMapValue) ? __WEBPACK_IMPORTED_MODULE_12__createAction__["a" /* default */].apply(void 0, [prefixedType].concat(actionMapValue)) : Object(__WEBPACK_IMPORTED_MODULE_12__createAction__["a" /* default */])(prefixedType, actionMapValue);
    return _objectSpread({}, partialActionCreators, (_objectSpread2 = {}, _objectSpread2[type] = actionCreator, _objectSpread2));
  });
}

function actionCreatorsFromIdentityActions(identityActions, options) {
  var actionMap = Object(__WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__["a" /* default */])(identityActions, function (partialActionMap, type) {
    var _objectSpread3;

    return _objectSpread({}, partialActionMap, (_objectSpread3 = {}, _objectSpread3[type] = __WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* default */], _objectSpread3));
  });
  var actionCreators = actionMapToActionCreators(actionMap, options);
  return Object(__WEBPACK_IMPORTED_MODULE_9__utils_arrayToObject__["a" /* default */])(Object.keys(actionCreators), function (partialActionCreators, type) {
    var _objectSpread4;

    return _objectSpread({}, partialActionCreators, (_objectSpread4 = {}, _objectSpread4[Object(__WEBPACK_IMPORTED_MODULE_8__utils_camelCase__["a" /* default */])(type)] = actionCreators[type], _objectSpread4));
  });
}

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return Array.isArray(value);
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array) {
  return array[array.length - 1];
});

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {


var space = __webpack_require__(352)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {


var clean = __webpack_require__(353)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ }),
/* 353 */
/***/ (function(module, exports) {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flattenWhenNode__ = __webpack_require__(173);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__flattenWhenNode__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */]));

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unflattenActionCreators;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isEmpty__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__camelCase__ = __webpack_require__(172);



function unflattenActionCreators(flatActionCreators, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_NAMESPACE */] : _ref$namespace,
      prefix = _ref.prefix;

  function unflatten(flatActionType, partialNestedActionCreators, partialFlatActionTypePath) {
    var nextNamespace = Object(__WEBPACK_IMPORTED_MODULE_2__camelCase__["a" /* default */])(partialFlatActionTypePath.shift());

    if (Object(__WEBPACK_IMPORTED_MODULE_1__isEmpty__["a" /* default */])(partialFlatActionTypePath)) {
      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
    } else {
      if (!partialNestedActionCreators[nextNamespace]) {
        partialNestedActionCreators[nextNamespace] = {};
      }

      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
    }
  }

  var nestedActionCreators = {};
  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
    var unprefixedType = prefix ? type.replace("" + prefix + namespace, '') : type;
    return unflatten(type, nestedActionCreators, unprefixedType.split(namespace));
  });
  return nestedActionCreators;
}

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_just_curry_it__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_just_curry_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_just_curry_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAction__ = __webpack_require__(109);


/* unused harmony default export */ var _unused_webpack_default_export = (function (type, payloadCreator) {
  return __WEBPACK_IMPORTED_MODULE_0_just_curry_it___default()(Object(__WEBPACK_IMPORTED_MODULE_1__createAction__["a" /* default */])(type, payloadCreator), payloadCreator.length);
});

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = curry;

/*
  function add(a, b, c) {
    return a + b + c;
  }
  curry(add)(1)(2)(3); // 6
  curry(add)(1)(2)(2); // 5
  curry(add)(2)(4, 3); // 9

  function add(...args) {
    return args.reduce((sum, n) => sum + n, 0)
  }
  var curryAdd4 = curry(add, 4)
  curryAdd4(1)(2, 3)(4); // 10

  function converter(ratio, input) {
    return (input*ratio).toFixed(1);
  }
  const curriedConverter = curry(converter)
  const milesToKm = curriedConverter(1.62);
  milesToKm(35); // 56.7
  milesToKm(10); // 16.2
*/

function curry(fn, arity) {
  return function curried() {
    if (arity == null) {
      arity = fn.length;
    }
    var args = [].slice.call(arguments);
    if (args.length >= arity) {
      return fn.apply(this, args);
    } else {
      return function() {
        return curried.apply(this, args.concat([].slice.call(arguments)));
      };
    }
  };
}


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value === undefined;
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduce_reducers__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_isMap__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ownKeys__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_flattenReducerMap__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handleAction__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_get__ = __webpack_require__(174);








function handleActions(handlers, defaultState, options) {
  if (options === void 0) {
    options = {};
  }

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_2__utils_isPlainObject__["a" /* default */])(handlers) || Object(__WEBPACK_IMPORTED_MODULE_3__utils_isMap__["a" /* default */])(handlers), 'Expected handlers to be a plain object.');
  var flattenedReducerMap = Object(__WEBPACK_IMPORTED_MODULE_5__utils_flattenReducerMap__["a" /* default */])(handlers, options);
  var reducers = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownKeys__["a" /* default */])(flattenedReducerMap).map(function (type) {
    return Object(__WEBPACK_IMPORTED_MODULE_6__handleAction__["a" /* default */])(type, Object(__WEBPACK_IMPORTED_MODULE_7__utils_get__["a" /* default */])(type, flattenedReducerMap), defaultState);
  });
  var reducer = __WEBPACK_IMPORTED_MODULE_0_reduce_reducers__["a" /* default */].apply(void 0, reducers.concat([defaultState]));
  return function (state, action) {
    if (state === void 0) {
      state = defaultState;
    }

    return reducer(state, action);
  };
}

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var initialState = typeof args[args.length - 1] !== 'function' && args.pop();
  var reducers = args;

  if (typeof initialState === 'undefined') {
    throw new TypeError('The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.');
  }

  return function (prevState, value) {
    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    var prevStateIsUndefined = typeof prevState === 'undefined';
    var valueIsUndefined = typeof value === 'undefined';

    if (prevStateIsUndefined && valueIsUndefined && initialState) {
      return initialState;
    }

    return reducers.reduce(function (newState, reducer) {
      return reducer.apply(undefined, [newState, value].concat(args));
    }, prevStateIsUndefined && !valueIsUndefined && initialState ? initialState : prevState);
  };
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMap__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flattenWhenNode__ = __webpack_require__(173);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__flattenWhenNode__["a" /* default */])(function (node) {
  return (Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(node) || Object(__WEBPACK_IMPORTED_MODULE_1__isMap__["a" /* default */])(node)) && !Object(__WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__["a" /* default */])(node);
}));

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasGeneratorInterface;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownKeys__ = __webpack_require__(111);

function hasGeneratorInterface(handler) {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_0__ownKeys__["a" /* default */])(handler);
  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
    return ownKey === 'next' || ownKey === 'throw';
  });
  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
}

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = appConfigSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_getAppConfig__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__appConfigActions__ = __webpack_require__(77);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(appConfigSaga);function appConfigSaga(){var _ref,token,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function appConfigSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3__appConfigActions__["b" /* requestAppConfig */]);case 2:_ref=_context.sent;token=_ref.payload;_context.prev=4;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1_api_getAppConfig__["a" /* default */],token);case 7:data=_context.sent;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__appConfigActions__["a" /* receiveAppConfig */])(data));case 10:_context.next=16;break;case 12:_context.prev=12;_context.t0=_context['catch'](4);_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__appConfigActions__["a" /* receiveAppConfig */])(_context.t0));case 16:case'end':return _context.stop();}}},_marked,this,[[4,12]]);}

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
var getAppConfig=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function _getAppConfig(token){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/getAppConfig');var fetchOptions={headers:{Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();});});/* harmony default export */ __webpack_exports__["a"] = (getAppConfig);

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)(module), __webpack_require__(21)))

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(369);
exports.encode = exports.stringify = __webpack_require__(370);


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

/* harmony default export */ __webpack_exports__["a"] = (ExtendableError);


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = authSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_auth_login__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_auth_regenerate__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authActions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lib_errors__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_client_storage__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_api_auth_TokenUtils__ = __webpack_require__(115);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loginSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(regenerateDaemon),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(listenForAuthenicationErrors),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(authSaga);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var getToken=__WEBPACK_IMPORTED_MODULE_8_api_auth_TokenUtils__["a" /* default */].getToken,setToken=__WEBPACK_IMPORTED_MODULE_8_api_auth_TokenUtils__["a" /* default */].setToken,clearToken=__WEBPACK_IMPORTED_MODULE_8_api_auth_TokenUtils__["a" /* default */].clearToken;function loginSaga(action){var _action$payload,username,password,_ref,token,expiration,rest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loginSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,username=_action$payload.username,password=_action$payload.password;_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_api_auth_login__["a" /* default */],username,password,Object(__WEBPACK_IMPORTED_MODULE_7_containers_client_storage__["b" /* getSelected */])());case 4:_ref=_context.sent;token=_ref.token;expiration=_ref.expiration;rest=_objectWithoutProperties(_ref,['token','expiration']);_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(setToken,token,expiration);case 10:_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */],500);case 12:_context.next=14;return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_5__authActions__["c" /* receiveAuth */])(Object.assign({username:username,password:password,token:token},rest)));case 14:_context.next=22;break;case 16:_context.prev=16;_context.t0=_context['catch'](1);_context.next=20;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */],500);case 20:_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__authActions__["c" /* receiveAuth */])(_context.t0));case 22:case'end':return _context.stop();}}},_marked,this,[[1,16]]);}function regenerateDaemon(){var interval,_ref2,action,existingToken,clientId,_ref3,token,expiration,rest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function regenerateDaemon$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:interval=0.75*1800*1000;case 1:if(false){_context2.next=34;break;}_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* race */])({action:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_5__authActions__["d" /* regenerateToken */]),interval:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */],interval)// 0.75 * expiration
});case 4:_ref2=_context2.sent;action=_ref2.action;_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(getToken);case 8:existingToken=_context2.sent;clientId=action&&typeof action.payload==='number'?action.payload:Object(__WEBPACK_IMPORTED_MODULE_7_containers_client_storage__["b" /* getSelected */])();_context2.prev=10;_context2.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4_api_auth_regenerate__["a" /* default */],existingToken,clientId);case 13:_ref3=_context2.sent;token=_ref3.token;expiration=_ref3.expiration;rest=_objectWithoutProperties(_ref3,['token','expiration']);_context2.next=19;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(setToken,token,expiration);case 19:_context2.next=21;return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_5__authActions__["c" /* receiveAuth */])(Object.assign({token:token},rest)));case 21:interval=Math.floor(0.75*expiration*1000);_context2.next=32;break;case 24:_context2.prev=24;_context2.t0=_context2['catch'](10);_context2.next=28;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(clearToken);case 28:_context2.next=30;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__authActions__["c" /* receiveAuth */])(_context2.t0));case 30:_context2.next=32;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_5__authActions__["a" /* login */]);case 32:_context2.next=1;break;case 34:case'end':return _context2.stop();}}},_marked2,this,[[10,24]]);}// only listen for errors when user is login
var match401Error=function match401Error(action){if(action.error===true&&__WEBPACK_IMPORTED_MODULE_6_lib_errors__["e" /* default */].isClientError(action.payload)){if(action.payload.status===401){return true;}}return false;};function listenForAuthenicationErrors(){var _ref4,error,_ref5,error401;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function listenForAuthenicationErrors$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(false){_context3.next=16;break;}_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_5__authActions__["c" /* receiveAuth */]);case 3:_ref4=_context3.sent;error=_ref4.error;if(!(error===true)){_context3.next=7;break;}return _context3.abrupt('continue',0);case 7:_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* race */])({error401:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(match401Error),logout:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_5__authActions__["b" /* logout */])});case 9:_ref5=_context3.sent;error401=_ref5.error401;if(!error401){_context3.next=14;break;}_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__authActions__["b" /* logout */])());case 14:_context3.next=0;break;case 16:case'end':return _context3.stop();}}},_marked3,this);}function authSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function authSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5__authActions__["a" /* login */],loginSaga);case 2:_context4.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5__authActions__["b" /* logout */],clearToken);case 4:_context4.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* fork */])(listenForAuthenicationErrors);case 6:_context4.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* fork */])(regenerateDaemon);case 8:case'end':return _context4.stop();}}},_marked4,this);}

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
var login=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function login(username,password,clientId){var body={username:username,password:password};if(typeof clientId==='number'){body.merchant_group_id=clientId;}var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/login');var fetchOptions={method:'POST',headers:{'Content-type':'application/json'},body:JSON.stringify(body)};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();}).catch(function(err){if(err.status<500){if(err.status===400){err.message='Username/Password required.';}if(err.status===401){err.message='Incorrect Username/Password.';}}return Promise.reject(err);});});/* harmony default export */ __webpack_exports__["a"] = (login);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
var regenerate=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function regenerateToken(token,clientId){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/regenerate')+(typeof clientId==='number'?'?merchantGroupId='+clientId:'');var fetchOptions={method:'GET',headers:{'Content-type':'application/json',Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();});});/* harmony default export */ __webpack_exports__["a"] = (regenerate);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUgcArchetype;
function getUgcArchetype(ugctype){switch(ugctype){case'Review':case'MediaFirst':return'Review';case'Question':case'SeededQuestion':return'Question';case'Answer':case'BrandAnswer':case'SeededAnswer':return'Answer';case'BrandMerchantResponse':case'MerchantResponse':return'MerchantResponse';default:return ugctype;}}

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapConfigValueToTransformValue */
/* harmony export (immutable) */ __webpack_exports__["a"] = mapConfigToTransform;
var TransformParameterByName={crop:'c_',default_image:'d_',format:'f_',fetch_format:'f_',flags:'fl_',width:'w_',height:'h_',quality:'q_',background:'b_'};function mapConfigValueToTransformValue(name,value){return Array.isArray(value)?name+value.join('.'):name+value;}function mapConfigToTransform(config){var p=[];Object.keys(config).forEach(function(configKey){var parameterName=TransformParameterByName[configKey];var configValue=config[configKey];if(parameterName&&configValue){p.push(mapConfigValueToTransformValue(parameterName,configValue));}});return p.sort().join(',');}

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createUploadedImageResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createUploadedVideoResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createProductImageResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YoutubeRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createYoutubeVideoResource; });
var UploadedResourceRegex=/(https?:)?\/\/(res.cloudinary.com\/powerreviews|media.powerreviews.com)\/(image|video)\/upload\/(v[0-9]{10,}\/){0,1}/g;var SupportedImageFileTypesRegex=/\.(jpg|jpe|jpeg|jpc|jp2|j2k|wdp|jxr|hdp|png|gif|webp|bmp|tif|tiff)$/g;var SupportedVideoFileTypesRegex=/\.(mp4|webm|flv|mov|ogv|3gp|3g2|wmv|mpeg|flv|mkv|avi)$/g;var parseUploadedUrl=function parseUploadedUrl(url){var p=url.split(UploadedResourceRegex).pop();//TODO
return p.replace(SupportedImageFileTypesRegex,'').replace(SupportedVideoFileTypesRegex,'');};var escapeFetchUrl=function escapeFetchUrl(url){return url.replace(/\?/g,'%3F');};var createUploadedImageResource=function createUploadedImageResource(url){var publicId=parseUploadedUrl(url);return{accessType:'upload',resourceType:'image',publicId:publicId};};var createUploadedVideoResource=function createUploadedVideoResource(url){var publicId=parseUploadedUrl(url);return{accessType:'upload',resourceType:'video',publicId:publicId};};var createProductImageResource=function createProductImageResource(url){return{accessType:'fetch',resourceType:'image',publicId:escapeFetchUrl(url)};};var YoutubeRegex=/(youtube.com\/(v\/|watch\?v=)|(youtu\.be\/))/i;var createYoutubeVideoResource=function createYoutubeVideoResource(url){var publicId=url.split(YoutubeRegex).pop();return{accessType:'youtube',resourceType:'image',publicId:publicId};};

/***/ }),
/* 378 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(380),
    toString = __webpack_require__(117);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(381);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(79),
    arrayMap = __webpack_require__(383),
    isArray = __webpack_require__(80),
    isSymbol = __webpack_require__(182);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 383 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(79);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(387),
    hasUnicodeWord = __webpack_require__(388),
    toString = __webpack_require__(117),
    unicodeWords = __webpack_require__(389);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(391);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(392),
    hasUnicode = __webpack_require__(183),
    stringToArray = __webpack_require__(394),
    toString = __webpack_require__(117);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(393);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(395),
    hasUnicode = __webpack_require__(183),
    unicodeToArray = __webpack_require__(396);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 395 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmptyList__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientSpecificQuestion__ = __webpack_require__(185);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultReviewRecord={assigned_to:null,assigned_by:null,editable:false,ugc_id:null,subject_id:null,ugctype:'Review',ugc_archetype:'Review',created_date:null,updated_date:null,author:'',location:'',old_ugc_id:null,new_ugc_id:null,merchant_user_id:'',review_headline:'',review_comments:'',service_comments:'',ugc_edit_request_date:'',email:'',reviewer_type:'',email_confirm_status:'',source:'',helpful_votes:null,not_helpful_votes:null,rating:null,ip_address:'',device_id:'',review_content:'',tags:__WEBPACK_IMPORTED_MODULE_1__EmptyList__["a" /* default */],clientSpecificQuestions:__WEBPACK_IMPORTED_MODULE_1__EmptyList__["a" /* default */],catalog_response:[],review_responses:__WEBPACK_IMPORTED_MODULE_1__EmptyList__["a" /* default */],ugc_related_content:__WEBPACK_IMPORTED_MODULE_1__EmptyList__["a" /* default */],locale:'',published:null,bottom_line:null};var ReviewRecord=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(defaultReviewRecord);var mapTagLabelToSortIndex=function mapTagLabelToSortIndex(label){var k=label.toLowerCase().replace(' ','');switch(k){case'pros':return 0;case'cons':return 1;case'bestuses':return 2;case'bottomline':return 3;default:return 4;}};var tagComparator=function tagComparator(lhs,rhs){var lLabel=mapTagLabelToSortIndex(lhs.label);var rLabel=mapTagLabelToSortIndex(rhs.label);return lLabel-rLabel;};var Review=function(_ReviewRecord){_inherits(Review,_ReviewRecord);function Review(){_classCallCheck(this,Review);return _possibleConstructorReturn(this,(Review.__proto__||Object.getPrototypeOf(Review)).apply(this,arguments));}_createClass(Review,[{key:'getResponseByType',value:function getResponseByType(type){return this.ugc_related_content.find(function(ugc){return ugc.ugctype===type;});}},{key:'getMerchantResponse',value:function getMerchantResponse(){return this.getResponseByType('MerchantResponse');}},{key:'getBrandResponse',value:function getBrandResponse(){return this.getResponseByType('BrandMerchantResponse');}},{key:'hasResponses',value:function hasResponses(){return this.getMerchantResponse()||this.getBrandResponse();}},{key:'getMedia',value:function getMedia(){return this.ugc_related_content.filter(function(ugc){return ugc.ugctype==='Image'||ugc.ugctype==='Video';});}}],[{key:'createWithData',value:function createWithData(data){var init={};if(data.tags&&Array.isArray(data.tags)){init.tags=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(data.tags.sort().sort(tagComparator));}if(data.client_specific_question&&Array.isArray(data.client_specific_question)){init.clientSpecificQuestions=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(data.client_specific_question.map(__WEBPACK_IMPORTED_MODULE_2__ClientSpecificQuestion__["a" /* default */].create));}return new Review(Object.assign({},data,init));}}]);return Review;}(ReviewRecord);/* harmony default export */ __webpack_exports__["a"] = (Review);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmptyList__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Catalog__ = __webpack_require__(58);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultResponse={ugc_id:'',ugctype:'',ugc_archetype:'',created_date:'',updated_date:'',published:null,author:'',location:'',text:'',email:'',expert:true,source:'',ip_address:'',device_id:'',locale:'',ugc_related_content:__WEBPACK_IMPORTED_MODULE_1__EmptyList__["a" /* default */],catalog:__WEBPACK_IMPORTED_MODULE_2__Catalog__["a" /* default */].Empty};var ResponseRecord=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(defaultResponse);var Response=function(_ResponseRecord){_inherits(Response,_ResponseRecord);function Response(){_classCallCheck(this,Response);return _possibleConstructorReturn(this,(Response.__proto__||Object.getPrototypeOf(Response)).apply(this,arguments));}_createClass(Response,null,[{key:'createWithData',value:function createWithData(data){return new Response(Object.assign({},data,{text:data.text?data.text:data.value||''}));}}]);return Response;}(ResponseRecord);/* harmony default export */ __webpack_exports__["a"] = (Response);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmptyList__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_pwr_cloudinary__ = __webpack_require__(59);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var stripProtocol=function stripProtocol(url){return url.replace(/http(s)?:/,'');};var ImageRecord=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({ugc_id:null,parent_ugc_id:null,ugctype:'Image',ugcsubtype:null,ugc_archetype:'',subject_id:null,created_date:null,updated_date:null,author:'',location:'',email:'',email_confirm_status:'',source:'',ip_address:'',device_id:'',url:'',urlSet:{},thumbnail_url:'',caption:'',locale:'',published:null,ugc_related_content:__WEBPACK_IMPORTED_MODULE_1__EmptyList__["a" /* default */],featured:false});var Image=function(_ImageRecord){_inherits(Image,_ImageRecord);function Image(){_classCallCheck(this,Image);return _possibleConstructorReturn(this,(Image.__proto__||Object.getPrototypeOf(Image)).apply(this,arguments));}_createClass(Image,[{key:'getReview',value:function getReview(){return this.ugc_related_content.find(function(ugc){return ugc.ugc_archetype==='Review';});}}],[{key:'createWithData',value:function createWithData(data){var url=stripProtocol(data.url||data.thumbnail_url||'');var urlSet=__WEBPACK_IMPORTED_MODULE_2_lib_pwr_cloudinary__["a" /* default */].libraryUrlSet(url);return new Image(Object.assign({},data,{url:url,urlSet:urlSet}));}}]);return Image;}(ImageRecord);/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmptyList__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_pwr_cloudinary__ = __webpack_require__(59);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoRecord=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({ugc_id:null,parent_ugc_id:null,subject_id:null,ugctype:'Video',ugcsubtype:null,ugc_archetype:'',author:'',email:'',source_type:null,created_date:'',updated_date:'',published:null,url:'',urlSet:{},thumbnail_url:'',caption:'',ugc_related_content:__WEBPACK_IMPORTED_MODULE_1__EmptyList__["a" /* default */],locale:'',accessType:null,featured:false});var Video=function(_VideoRecord){_inherits(Video,_VideoRecord);function Video(){_classCallCheck(this,Video);return _possibleConstructorReturn(this,(Video.__proto__||Object.getPrototypeOf(Video)).apply(this,arguments));}_createClass(Video,[{key:'getReview',value:function getReview(){return this.ugc_related_content.find(function(ugc){return ugc.ugc_archetype==='Review';});}}],[{key:'createWithData',value:function createWithData(data){var rawUrl=data.url||'';var accessType=__WEBPACK_IMPORTED_MODULE_2_lib_pwr_cloudinary__["a" /* default */].isYoutubeVideo(rawUrl)?'youtube':'upload';var urlSet=accessType==='youtube'?__WEBPACK_IMPORTED_MODULE_2_lib_pwr_cloudinary__["a" /* default */].youtubeUrlSet(rawUrl):__WEBPACK_IMPORTED_MODULE_2_lib_pwr_cloudinary__["a" /* default */].libraryVideoUrlSet(rawUrl);return new Video(Object.assign({},data,{urlSet:urlSet,accessType:accessType}));}}]);return Video;}(VideoRecord);/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmptyList__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Catalog__ = __webpack_require__(58);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnswerRecord=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({ugc_id:'',subject_id:null,ugctype:'',ugc_archetype:'',created_date:'',updated_date:'',author:'',location:'',answer:'',email:'',merchant_user_id:'',answerer_type:'',source:'',ip_address:'',device_id:'',locale:'',published:null,ugc_related_content:__WEBPACK_IMPORTED_MODULE_1__EmptyList__["a" /* default */],catalog:__WEBPACK_IMPORTED_MODULE_2__Catalog__["a" /* default */].Empty,expert:false});var Answer=function(_AnswerRecord){_inherits(Answer,_AnswerRecord);function Answer(){_classCallCheck(this,Answer);return _possibleConstructorReturn(this,(Answer.__proto__||Object.getPrototypeOf(Answer)).apply(this,arguments));}_createClass(Answer,[{key:'getQuestion',value:function getQuestion(){return this.ugc_related_content.find(function(ugc){return ugc.ugc_archetype==='Question';});}},{key:'getMedia',value:function getMedia(){var _this2=this;return this.ugc_related_content.filter(function(ugc){return ugc.ugctype==='Image'||ugc.ugctype==='Video';}).filter(function(ugc){return ugc.parent_ugc_id===_this2.ugc_id;});}}],[{key:'createWithData',value:function createWithData(data){return new Answer(Object.assign({},data,{answer:data.answer||data.text||'',ugc_archetype:data.ugc_archetype||'Answer'}));}}]);return Answer;}(AnswerRecord);/* harmony default export */ __webpack_exports__["a"] = (Answer);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Question__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmptyList__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WDYBRecord=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({ugc_id:'',subject_id:null,ugctype:'WDYB',ugc_archetype:'',created_date:'',updated_date:'',published:null,author:'',location:'',answer:'',email:'',answerer_type:'',source:'',ip_address:'',device_id:'',locale:'',ugc_related_content:__WEBPACK_IMPORTED_MODULE_2__EmptyList__["a" /* default */]});var WhyDidYouBuy=function(_WDYBRecord){_inherits(WhyDidYouBuy,_WDYBRecord);function WhyDidYouBuy(){_classCallCheck(this,WhyDidYouBuy);return _possibleConstructorReturn(this,(WhyDidYouBuy.__proto__||Object.getPrototypeOf(WhyDidYouBuy)).apply(this,arguments));}_createClass(WhyDidYouBuy,[{key:'getQuestion',value:function getQuestion(){return this.ugc_related_content.find(function(ugc){return ugc.ugctype==='Question';});}}],[{key:'createWithData',value:function createWithData(data){return new WhyDidYouBuy(Object.assign({},data,{ugc_related_content:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([new __WEBPACK_IMPORTED_MODULE_1__Question__["a" /* default */]({created_date:data.created_date,question:'Why Did You Buy?'})])}));}}]);return WhyDidYouBuy;}(WDYBRecord);/* harmony default export */ __webpack_exports__["a"] = (WhyDidYouBuy);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ducks_coreDataReducer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ducks_appConfigReducer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ducks_authReducer__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_channels_ducks_channelContentReducer__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_api_auth_TokenUtils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ducks_authActions__ = __webpack_require__(27);
var initialState={auth:__WEBPACK_IMPORTED_MODULE_3_ducks_authReducer__["a" /* AuthState */].createWithExistingToken(__WEBPACK_IMPORTED_MODULE_5_api_auth_TokenUtils__["a" /* default */].getToken())};var createReducer=function createReducer(){var reducers=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var appReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(Object.assign({auth:__WEBPACK_IMPORTED_MODULE_3_ducks_authReducer__["b" /* default */],appConfig:__WEBPACK_IMPORTED_MODULE_2_ducks_appConfigReducer__["a" /* default */],coreData:__WEBPACK_IMPORTED_MODULE_1_ducks_coreDataReducer__["b" /* default */],channelContent:__WEBPACK_IMPORTED_MODULE_4_containers_channels_ducks_channelContentReducer__["a" /* default */]},reducers));// the rootReducer resets application state when a user's session ends
var rootReducer=function rootReducer(state,action){if(action.type===__WEBPACK_IMPORTED_MODULE_6_ducks_authActions__["b" /* logout */].toString()){state=initialState;}return appReducer(state,action);};return rootReducer;};

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tx;
// we need to transform devmoderation links to localhost when developing locally
var MODERATION_URL_REGEX=/^(https?:)?\/\/(dev|qa)?moderation\.powerreviews\.com\/#/;function tx(apps){return apps.map(function(app){return Object.assign({},app,{href:app.href.replace(MODERATION_URL_REGEX,'')});});}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channelContentActions__ = __webpack_require__(121);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultState=new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"]();// onMountCollection
// sets channel as pending content request
var onMountCollection=function onMountCollection(state,action){return state.set(action.payload,'pending');};// onUnmountCollection
var onUnmountCollection=function onUnmountCollection(state,action){return state.remove(action.payload);};// onRequestCollection
var onRequestCollection=function onRequestCollection(state,action){var key=action.payload.channelName;var val='pending';return state.set(key,val);};// onReceiveCollection
var onReceiveCollection=function onReceiveCollection(state,action){var items=action.payload,channelName=action.meta;return state.set(channelName,items);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__channelContentActions__["a" /* mountCollection */].toString(),onMountCollection),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__channelContentActions__["d" /* unmountCollection */].toString(),onUnmountCollection),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__channelContentActions__["c" /* requestChannelContent */].toString(),onRequestCollection),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_2__channelContentActions__["b" /* receiveChannelContent */].toString(),onReceiveCollection),_handleActions),defaultState));

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logout__ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Logout__["a"]; });


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Logout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_authActions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logoutApi__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_api_auth_TokenUtils__ = __webpack_require__(115);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Logout=function(_React$Component){_inherits(Logout,_React$Component);function Logout(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Logout);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Logout.__proto__||Object.getPrototypeOf(Logout)).call.apply(_ref,[this].concat(args))),_this),_this.state={redirect:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Logout,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;// clear session
var token=__WEBPACK_IMPORTED_MODULE_6_api_auth_TokenUtils__["a" /* default */].getToken();if(token){Object(__WEBPACK_IMPORTED_MODULE_5__logoutApi__["a" /* logout */])(token);}this.props.logout();this.redirectTimeout=setTimeout(function(){_this2.setState({redirect:true});},2000);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.redirectTimeout);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],{modal:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */].Title,null,'You have been logged out.'),this.state.redirect&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:'/'}));}}]);return Logout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null,{logout:__WEBPACK_IMPORTED_MODULE_4_ducks_authActions__["b" /* logout */]})(Logout));

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSection__ = __webpack_require__(409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductSection__["a"]; });


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductSection_scss__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSection=function(_React$PureComponent){_inherits(ProductSection,_React$PureComponent);function ProductSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductSection.__proto__||Object.getPrototypeOf(ProductSection)).call.apply(_ref,[this].concat(args))),_this),_this.state={expanded:false},_this.toggleDetails=function(scrollIntoView){_this.scrollCollapsedContentIntoView=scrollIntoView===true;_this.setState(function(prevState){return{expanded:!prevState.expanded};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductSection,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){// scroll collapsed content into view when expanding
if(prevState.expanded!==this.state.expanded&&this.state.expanded===true){this.scrollCollapsedContentIntoView&&this.collapsedContent&&this.collapsedContent.scrollIntoView();}}},{key:'renderAttributes',value:function renderAttributes(props){var _props$model=props.model,merchant=_props$model.merchant,brand_name=_props$model.brand_name,category_name=_props$model.category_name,merchantName=props.merchantName,brandName=props.brandName,categoryName=props.categoryName;var listItems=[{value:merchantName===true?merchant.name||merchant.id:null,label:'Merchant',dataKey:'merchant_name'},{value:brandName===true?brand_name:null,label:'Brand',dataKey:'brand_name'},{value:categoryName===true?category_name:null,label:'Category',dataKey:'category_name'}].map(function(props){var value=props.value,label=props.label,dataKey=props.dataKey;return Boolean(value)?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionPropsListItem,key:label},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionPropsListItemLabel},label+': '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'data-key':dataKey,className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionPropsListItemText,'data-translate':false},value)):null;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionPropsList,'data-translate':true},listItems);}},{key:'render',value:function render(){var _this2=this;var _props$model2=this.props.model,product_name=_props$model2.name,product_url=_props$model2.product_url,product_image_url=_props$model2.product_image_url.thumbnail,brand_name=_props$model2.brand_name,product_description=_props$model2.description,page_id=_props$model2.page_id,page_id_variant=_props$model2.page_id_variant,associated_products=_props$model2.associated_products;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSection,ref:function ref(c){return _this2.collapsedContent=c;}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionInfo},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionImage,src:product_image_url,alt:product_name,width:'60',height:'60'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionProps},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionTitle+' '+(Boolean(product_url)?__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionTitleLinked:'')},product_url?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:product_url,target:'_blank','data-key':'product_name'},product_name):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'data-key':'product_name'},product_name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionDetailsToggle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionDetailsToggleButton,type:'button',onClick:this.toggleDetails,'data-translate':true},'Product Info\xA0\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-chevron-down','aria-hidden':'true'})))),this.renderAttributes(this.props))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionDetails,hidden:!this.state.expanded},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionDescriptionTitle,'data-key':'product_name'},product_name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionDescription,'data-key':'product_description'},product_description),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionMetaTable},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,Boolean(brand_name)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionMetaTableCell,'data-translate':true},'Brand'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionMetaTableCell,'data-key':'brand_name'},brand_name)),page_id&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionMetaTableCell,'data-translate':true},'Page ID'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionMetaTableCell,'data-key':'page_id'},page_id)),page_id_variant&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionMetaTableCell,'data-translate':true},'Page ID Variant'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionMetaTableCell,'data-key':'page_id_variant'},page_id_variant)))),associated_products.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionAssociated},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionDescriptionTitle,'data-translate':true},'Associated Products (',associated_products.length,')'),associated_products.map(function(ap){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:ap.page_id,className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionAssociatedItem},ap.product_image_url&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:ap.product_image_url,alt:ap.product_name,width:'40',height:'40',className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionAssociatedImage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'data-key':'product_name'},ap.product_name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_2__ProductSection_scss___default.a.productSectionAssociatedPageId},'Page ID: ',ap.page_id)));}))));}}]);return ProductSection;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);ProductSection.propTypes={model:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3__models__["f" /* Product */]),merchantName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,brandName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,categoryName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool};ProductSection.defaultProps={merchantName:false,brandName:false,categoryName:false};/* harmony default export */ __webpack_exports__["a"] = (ProductSection);

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ProductSection":"ProductSection","productSection":"ProductSection","ProductSection__info":"ProductSection__info","productSectionInfo":"ProductSection__info","ProductSection__image":"ProductSection__image","productSectionImage":"ProductSection__image","ProductSection__props":"ProductSection__props","productSectionProps":"ProductSection__props","ProductSection__title":"ProductSection__title","productSectionTitle":"ProductSection__title","ProductSection__title--linked":"ProductSection__title--linked","productSectionTitleLinked":"ProductSection__title--linked","ProductSection__details-toggle-button":"ProductSection__details-toggle-button","productSectionDetailsToggleButton":"ProductSection__details-toggle-button","c-button--active":"c-button--active","cButtonActive":"c-button--active","ProductSection__details":"ProductSection__details","productSectionDetails":"ProductSection__details","ProductSection__description-title":"ProductSection__description-title","productSectionDescriptionTitle":"ProductSection__description-title","ProductSection__description":"ProductSection__description","productSectionDescription":"ProductSection__description","ProductSection__props-list":"ProductSection__props-list","productSectionPropsList":"ProductSection__props-list","ProductSection__props-list-item":"ProductSection__props-list-item","productSectionPropsListItem":"ProductSection__props-list-item","ProductSection__props-list-item-label":"ProductSection__props-list-item-label","productSectionPropsListItemLabel":"ProductSection__props-list-item-label","ProductSection__props-list-item-text":"ProductSection__props-list-item-text","productSectionPropsListItemText":"ProductSection__props-list-item-text","ProductSection__meta-table":"ProductSection__meta-table","productSectionMetaTable":"ProductSection__meta-table","ProductSection__meta-table__cell":"ProductSection__meta-table__cell","productSectionMetaTableCell":"ProductSection__meta-table__cell","ProductSection__associated":"ProductSection__associated","productSectionAssociated":"ProductSection__associated","ProductSection__associated-item":"ProductSection__associated-item","productSectionAssociatedItem":"ProductSection__associated-item","ProductSection__associated-image":"ProductSection__associated-image","productSectionAssociatedImage":"ProductSection__associated-image","ProductSection__associated-page-id":"ProductSection__associated-page-id","productSectionAssociatedPageId":"ProductSection__associated-page-id"};

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentSection__ = __webpack_require__(412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ContentSection__["a"]; });


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReviewSection__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResponseSection__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QASection__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaSection__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SocialCollectionSection__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UgcMetaInfo__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CollapsedBlock__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContentSection_scss__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContentSection_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ContentSection_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var blockWhiteSpace={margin:'2em'};var SOCIAL_COLLECTION_SUBTYPE='SocialCollection';var ErrorContent=function ErrorContent(_ref){var message=_ref.message;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',{className:__WEBPACK_IMPORTED_MODULE_8__ContentSection_scss__["contentSection"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{style:blockWhiteSpace},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_8__ContentSection_scss__["contentSectionErrorMessage"]},message)));};var ContentTypeBadge=function ContentTypeBadge(_ref2){var ugctype=_ref2.ugctype,visible=_ref2.visible;return visible===true?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_8__ContentSection_scss___default.a.contentSectionContentTypeBadge},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_8__ContentSection_scss___default.a.contentSectionContentTypeBadgeLabel},'Content Type:'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_8__ContentSection_scss___default.a.contentSectionContentTypeBadgeText,'data-key':'ugctype'},ugctype)):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{'data-key':'ugctype','aria-hidden':'true',className:__WEBPACK_IMPORTED_MODULE_8__ContentSection_scss___default.a.contentSectionContentTypeBadgeTextHidden},ugctype);};// TODO view types
var ContentSection=function(_React$PureComponent){_inherits(ContentSection,_React$PureComponent);function ContentSection(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,ContentSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=ContentSection.__proto__||Object.getPrototypeOf(ContentSection)).call.apply(_ref3,[this].concat(args))),_this),_this.state={metaExpanded:false},_this.toggleMeta=function(scrollIntoView){_this.scrollCollapsedContentIntoView=scrollIntoView===true;_this.setState(function(prevState){return{metaExpanded:!prevState.metaExpanded};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContentSection,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){// scroll collapsed content into view when expanding
if(prevState.metaExpanded!==this.state.metaExpanded&&this.state.metaExpanded===true){this.scrollCollapsedContentIntoView&&this.collapsedContent&&this.collapsedContent.scrollIntoView();}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,ugc=_props.model,_props$program=_props.program,program=_props$program===undefined?'client':_props$program;var metaExpanded=this.state.metaExpanded;var ComponentToRender=void 0;switch(ugc.ugc_archetype){case'Review':ComponentToRender=__WEBPACK_IMPORTED_MODULE_1__ReviewSection__["a" /* default */];break;case'BrandMerchantResponse':case'MerchantResponse':ComponentToRender=__WEBPACK_IMPORTED_MODULE_2__ResponseSection__["a" /* default */];break;case'Question':ComponentToRender=__WEBPACK_IMPORTED_MODULE_3__QASection__["c" /* QuestionSection */];break;case'BrandAnswer':case'Answer':case'WDYB':ComponentToRender=__WEBPACK_IMPORTED_MODULE_3__QASection__["a" /* AnswerSection */];break;case'Image':ComponentToRender=ugc.ugcsubtype===SOCIAL_COLLECTION_SUBTYPE?__WEBPACK_IMPORTED_MODULE_5__SocialCollectionSection__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_4__MediaSection__["a" /* ImageSection */];break;case'Video':ComponentToRender=ugc.ugcsubtype===SOCIAL_COLLECTION_SUBTYPE?__WEBPACK_IMPORTED_MODULE_5__SocialCollectionSection__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_4__MediaSection__["b" /* VideoSection */];break;default:return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorContent,{message:'Could not render UGC #'+ugc.ugc_id+' of type: "'+ugc.ugctype+'"'});}var _ref4=ComponentToRender,Header=_ref4.Header,Content=_ref4.Content,getRelatedContent=_ref4.getRelatedContent,provideCollapsedContent=_ref4.provideCollapsedContent;var options={program:program};var relatedContent=getRelatedContent(ugc,options);var isStandardModerationView=program==='pwr';var collapsedContent=void 0;if(provideCollapsedContent){collapsedContent=provideCollapsedContent(ugc,options,{onClick:this.toggleMeta,open:metaExpanded});}var MetaInfoComponent=isStandardModerationView===true?__WEBPACK_IMPORTED_MODULE_6__UgcMetaInfo__["d" /* PwrUgcMetaInfo */]:__WEBPACK_IMPORTED_MODULE_6__UgcMetaInfo__["b" /* ClientUgcMetaInfo */];if(!collapsedContent){collapsedContent=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__CollapsedBlock__["a" /* default */],{label:'Meta Info',open:metaExpanded,onClick:this.toggleMeta},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MetaInfoComponent,{model:ugc,expanded:metaExpanded}));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',{className:__WEBPACK_IMPORTED_MODULE_8__ContentSection_scss__["contentSection"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('header',{className:'mv3 mh4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ContentTypeBadge,{ugctype:ugc.ugctype,visible:isStandardModerationView===true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,{ugc:ugc,options:options})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,{ugc:ugc,options:options}),relatedContent&&relatedContent.map(function(rc){return rc;}),this.props.children,this.props.hideMeta===true?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{ref:function ref(c){return _this2.collapsedContent=c;}},collapsedContent));}}]);return ContentSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (ContentSection);

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"UserGeneratedText__warning":"UserGeneratedText__warning","userGeneratedTextWarning":"UserGeneratedText__warning","UserGeneratedTextHighlighter":"UserGeneratedTextHighlighter","userGeneratedTextHighlighter":"UserGeneratedTextHighlighter","UserGeneratedText":"UserGeneratedText","userGeneratedText":"UserGeneratedText"};

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ACTIVE_COLOR='#f59331';var INACTIVE_COLOR='#ddd';var getFills=function getFills(){var rating=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var fills=Array(~~rating).fill('url(#Gradient100)');if(fills.length<5){var value=Number((rating-fills.length).toFixed(1))*100;fills.push('url(#Gradient'+value+')');while(fills.length<5){fills.push('url(#Gradient0)');}}return fills;};var StarRating=function(_React$PureComponent){_inherits(StarRating,_React$PureComponent);function StarRating(){_classCallCheck(this,StarRating);return _possibleConstructorReturn(this,(StarRating.__proto__||Object.getPrototypeOf(StarRating)).apply(this,arguments));}_createClass(StarRating,[{key:'renderGroups',value:function renderGroups(){var rating=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;return getFills(rating).map(function(fill,index){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('g',{stroke:'none',strokeWidth:'1',fill:'none',fillRule:'evenodd',transform:'translate('+20*index+')',key:index},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('rect',{fill:fill,width:'18.3333333',height:'18.3333333',rx:'2'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('polygon',{fill:'#FFFFFF',points:'9.16666667 12.9166667 4.75827727 15.2342941 5.60020473 10.3254804 2.03374279 6.84903921 6.96247197 6.13285294 9.16666667 1.66666667 11.3708614 6.13285294 16.2995905 6.84903921 12.7331286 10.3254804 13.5750561 15.2342941'}));});}},{key:'renderGradient',value:function renderGradient(stop){var id='Gradient'+stop;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:id,key:id},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:INACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:stop+'%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:stop+'%',stopColor:INACTIVE_COLOR,stopOpacity:'1'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'100%',stopColor:INACTIVE_COLOR}));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'dib relative user-select-none'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('canvas',{className:'db h-100 visibility-hidden',height:'18',width:'101'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',{viewBox:'0 0 101 18',className:'h-100 w-100 absolute left-0 top-0',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('defs',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:'Gradient0'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:INACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'10%',stopColor:INACTIVE_COLOR})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:'Gradient10'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'10%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'10%',stopColor:INACTIVE_COLOR,stopOpacity:'1'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'100%',stopColor:INACTIVE_COLOR})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:'Gradient20'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'20%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'20%',stopColor:INACTIVE_COLOR,stopOpacity:'1'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'100%',stopColor:INACTIVE_COLOR})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:'Gradient30'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'30%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'30%',stopColor:INACTIVE_COLOR,stopOpacity:'1'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'100%',stopColor:INACTIVE_COLOR})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:'Gradient40'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'40%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'40%',stopColor:INACTIVE_COLOR,stopOpacity:'1'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'100%',stopColor:INACTIVE_COLOR})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:'Gradient50'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'50%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'50%',stopColor:INACTIVE_COLOR,stopOpacity:'1'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'100%',stopColor:INACTIVE_COLOR})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:'Gradient60'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'60%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'60%',stopColor:INACTIVE_COLOR,stopOpacity:'1'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'100%',stopColor:INACTIVE_COLOR})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:'Gradient70'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'70%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'70%',stopColor:INACTIVE_COLOR,stopOpacity:'1'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'100%',stopColor:INACTIVE_COLOR})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:'Gradient80'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'80%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'80%',stopColor:INACTIVE_COLOR,stopOpacity:'1'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'100%',stopColor:INACTIVE_COLOR})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:'Gradient90'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'90%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'90%',stopColor:INACTIVE_COLOR,stopOpacity:'1'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'100%',stopColor:INACTIVE_COLOR})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('linearGradient',{id:'Gradient100'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'0%',stopColor:ACTIVE_COLOR}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('stop',{offset:'100%',stopColor:ACTIVE_COLOR}))),this.renderGroups(this.props.rating)));}}]);return StarRating;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (StarRating);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaViewerModal__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaViewer_scss__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaViewer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MediaViewer_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ContentSection_UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_UgcLinkContext__ = __webpack_require__(67);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PlayIcon=function PlayIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 300 300',className:__WEBPACK_IMPORTED_MODULE_4__MediaViewer_scss___default.a.mediaViewerListItemButtonPlayIcon},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#fff',fillOpacity:'0.7',stroke:'#fff',strokeWidth:'3',d:'M46.4 283.6c-2.3 0-4.7-.6-6.8-1.8-4.2-2.4-6.7-6.9-6.7-11.7V30.9c0-4.8 2.6-9.3 6.7-11.7 4.2-2.4 9.3-2.4 13.5 0l208.6 119.6c4.2 2.4 6.8 6.9 6.8 11.7s-2.6 9.3-6.8 11.7L53.1 281.8c-2.1 1.2-4.4 1.8-6.7 1.8z'}));};var MediaViewer=function(_React$Component){_inherits(MediaViewer,_React$Component);function MediaViewer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MediaViewer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MediaViewer.__proto__||Object.getPrototypeOf(MediaViewer)).call.apply(_ref,[this].concat(args))),_this),_this.state={modalIsOpen:false,selectedItemIndex:-1},_this.expandImage=function(e){_this.setState({modalIsOpen:true,selectedItemIndex:parseInt(e.currentTarget.getAttribute('data-item-index'),10)});},_this.closeModal=function(){_this.setState({modalIsOpen:false,selectedItemIndex:-1});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MediaViewer,[{key:'render',value:function render(){var _this2=this;var ugcs=this.props.ugcs;if(ugcs.size===0){return null;}var _state=this.state,modalIsOpen=_state.modalIsOpen,selectedItemIndex=_state.selectedItemIndex;var selectedUgc=ugcs.get(parseInt(selectedItemIndex,10));var items=ugcs.map(function(ugc,i){var ugctype=ugc.ugctype,urlSet=ugc.urlSet,caption=ugc.caption;var src='';if(ugctype==='Image'){src=urlSet.thumbnail;}else if(ugctype==='Video'){src=urlSet.thumbnail;}var listItemClassName=__WEBPACK_IMPORTED_MODULE_4__MediaViewer_scss___default.a.mediaViewerListItem;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('li',{className:listItemClassName,key:i,'aria-label':caption&&Object(__WEBPACK_IMPORTED_MODULE_5_components_ContentSection_UserGeneratedTextContainer__["c" /* stripWarningTags */])(caption)},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{type:'button',className:__WEBPACK_IMPORTED_MODULE_4__MediaViewer_scss___default.a.mediaViewerListItemButton,onClick:_this2.expandImage,'data-item-index':i},ugctype==='Video'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PlayIcon,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img',{src:src,alt:'',className:__WEBPACK_IMPORTED_MODULE_4__MediaViewer_scss___default.a.mediaViewerThumbnail})),_this2.props.hideUgcLink!==true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_containers_UgcLinkContext__["b" /* default */].Consumer,null,function(linker){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_containers_UgcLinkContext__["a" /* UgcLinkButton */],{href:linker(ugc),label:'Moderate'});}));});var shouldRenderModal=modalIsOpen===true&&selectedUgc!=null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('ul',{className:__WEBPACK_IMPORTED_MODULE_4__MediaViewer_scss___default.a.mediaViewerList},items),shouldRenderModal&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MediaViewerModal__["a" /* default */],{selectedUgc:selectedUgc,onClose:this.closeModal}));}}]);return MediaViewer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MediaViewer.Modal=__WEBPACK_IMPORTED_MODULE_3__MediaViewerModal__["a" /* default */];MediaViewer.propTypes={ugcs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])};/* harmony default export */ __webpack_exports__["a"] = (MediaViewer);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MediaViewerModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cleanCaption__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaViewerModal_scss__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaViewerModal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MediaViewerModal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Modal__ = __webpack_require__(62);
// $FlowFixMe
var CloseIcon=function CloseIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',{viewBox:'9.5 9.5 21 21',className:__WEBPACK_IMPORTED_MODULE_2__MediaViewerModal_scss___default.a.mediaViewerModalCloseButtonIcon,'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('g',{stroke:'#fff',className:'CloseIcon__group'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{d:'M15 15l10 10M25 15L15 25'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('circle',{cx:'20',cy:'20',r:'10',fill:'none'})));};function MediaViewerModal(props){var renderMedia=function renderMedia(){var ugc=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var ugctype=ugc.ugctype,urlSet=ugc.urlSet,caption=ugc.caption;if(ugctype==='Image'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img',{src:urlSet.full,alt:caption&&Object(__WEBPACK_IMPORTED_MODULE_1__cleanCaption__["a" /* default */])(caption)});}var accessType=ugc.accessType;if(accessType==='upload'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('video',{autoPlay:true,controls:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('source',{src:urlSet.raw,type:'video/mp4'}));}else if(accessType==='youtube'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_2__MediaViewerModal_scss___default.a.mediaViewerModalContentWrapVideoEmbedWrap},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('iframe',{src:urlSet.raw,title:'Youtube embed'}));}return null;};var selectedUgc=props.selectedUgc,onClose=props.onClose;if(!selectedUgc){return null;}var caption=selectedUgc.caption;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_Modal__["a" /* ModalPortal */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_2__MediaViewerModal_scss___default.a.mediaViewerModal,onKeyDown:function onKeyDown(_ref){var key=_ref.key;if(key==='Escape'){onClose();}}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_2__MediaViewerModal_scss___default.a.mediaViewerModalContent,role:'dialog','aria-modal':'true'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_2__MediaViewerModal_scss___default.a.mediaViewerModalContentWrap},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{type:'button',className:__WEBPACK_IMPORTED_MODULE_2__MediaViewerModal_scss___default.a.mediaViewerModalContentWrapCloseButton,onClick:onClose,'aria-label':'Close Modal'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CloseIcon,null)),renderMedia(selectedUgc),caption&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_2__MediaViewerModal_scss___default.a.mediaViewerModalContentWrapCaption},Object(__WEBPACK_IMPORTED_MODULE_1__cleanCaption__["a" /* default */])(caption))))));}

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cleanCaption=function cleanCaption(caption){return caption.replace(/<\/?WARNING>/g,'');};/* harmony default export */ __webpack_exports__["a"] = (cleanCaption);

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"c-overlay":"c-overlay","cOverlay":"c-overlay","MediaViewerModal":"MediaViewerModal","mediaViewerModal":"MediaViewerModal","c-overlay--visible":"c-overlay--visible","cOverlayVisible":"c-overlay--visible","c-overlay--fullpage":"c-overlay--fullpage","cOverlayFullpage":"c-overlay--fullpage","c-overlay--transparent":"c-overlay--transparent","cOverlayTransparent":"c-overlay--transparent","c-overlay--dismissable":"c-overlay--dismissable","cOverlayDismissable":"c-overlay--dismissable","MediaViewerModal__content":"MediaViewerModal__content","mediaViewerModalContent":"MediaViewerModal__content","MediaViewerModal__content__wrap":"MediaViewerModal__content__wrap","mediaViewerModalContentWrap":"MediaViewerModal__content__wrap","MediaViewerModal__content__wrap__close-button":"MediaViewerModal__content__wrap__close-button","mediaViewerModalContentWrapCloseButton":"MediaViewerModal__content__wrap__close-button","CloseIcon__group":"CloseIcon__group","closeIconGroup":"CloseIcon__group","MediaViewerModal__content__wrap__caption":"MediaViewerModal__content__wrap__caption","mediaViewerModalContentWrapCaption":"MediaViewerModal__content__wrap__caption","MediaViewerModal__content__wrap__video-embed-wrap":"MediaViewerModal__content__wrap__video-embed-wrap","mediaViewerModalContentWrapVideoEmbedWrap":"MediaViewerModal__content__wrap__video-embed-wrap","MediaViewerModal__navigation-button":"MediaViewerModal__navigation-button","mediaViewerModalNavigationButton":"MediaViewerModal__navigation-button"};

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Common__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal_scss__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Modal_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalHeader=function ModalHeader(props){var children=props.children,onCloseClick=props.onCloseClick;var heading=typeof children==='string'?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h2',{className:'brandon f3 ma0 lh-solid'},children):children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'bb b--moon-gray pa3 warm-gray'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex flex-row items-center'},heading,typeof onCloseClick==='function'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{type:'button',onClick:onCloseClick,className:'input-reset b--none bg-transparent grow-large hover-blue link pa1 pointer',style:{marginLeft:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Common__["e" /* CloseIcon */],{className:'w1 h1 db blue'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_3__Modal_scss___default.a.modalExitBtn},'Close modal'))));};var ModalBody=function ModalBody(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'overflow-auto'},props.children);};var ModalFooter=function ModalFooter(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'pa3 bt b--moon-gray warm-gray'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex items-center'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{style:{marginLeft:'auto'}},props.children)));};var Modal=function(_React$PureComponent){_inherits(Modal,_React$PureComponent);function Modal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Modal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Modal.__proto__||Object.getPrototypeOf(Modal)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false},_this.close=function(){_this.setState({open:false});},_this.handleKeydown=function(e){if(e.which===27){e.stopPropagation();e.preventDefault();_this.close();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Modal,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window.requestAnimationFrame(function(){return _this2.setState({open:true});});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this3=this;// if we are closing the modal
if(prevState.open===true&&this.state.open===false){if(typeof this.props.onClose==='function'){this.showTimeout=window.setTimeout(// $FlowFixMe
function(){return requestAnimationFrame(_this3.props.onClose);},301);}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.clearTimeout(this.showTimeout);}},{key:'render',value:function render(){var _this4=this;// apply onClose to header
var children=__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(this.props.children,function(child){if(child&&child.type===ModalHeader){// $FlowFixMe
return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child,{onCloseClick:_this4.close});}return child;});var overlayClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('fixed left-0 right-0 bottom-0 top-0 bg-black-60 flex flex-row items-center justify-around z-max',__WEBPACK_IMPORTED_MODULE_3__Modal_scss___default.a.modal,_defineProperty({},__WEBPACK_IMPORTED_MODULE_3__Modal_scss___default.a.modalOpen,this.state.open===true));var contentClassName=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('ba b--light-gray bg-white shadow-4 relative flex flex-column',__WEBPACK_IMPORTED_MODULE_3__Modal_scss___default.a.modalContent,_defineProperty({},__WEBPACK_IMPORTED_MODULE_3__Modal_scss___default.a.modalContentOpen,this.state.open===true));return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:overlayClassName,tabIndex:'0',onKeyDownCapture:this.handleKeydown,ref:function ref(c){return c&&c.focus();},role:'dialog'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:contentClassName,style:{maxHeight:'80vh',maxWidth:'56em'}},children));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);Modal.Header=ModalHeader;Modal.Body=ModalBody;Modal.Footer=ModalFooter;/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Loader","loader":"Loader","load8":"load8"};

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ObservationButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ObservationButton_scss__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ObservationButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ObservationButton_scss__);
function ObservationButton(props){var _onClick=props.onClick,name=props.name,existing=props.existing,observation_type_code=props.observation_type_code,_props$className=props.className,className=_props$className===undefined?'':_props$className;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:__WEBPACK_IMPORTED_MODULE_2__ObservationButton_scss__["observationButton"]+' '+(existing===true?__WEBPACK_IMPORTED_MODULE_2__ObservationButton_scss__["observationButtonActive"]:__WEBPACK_IMPORTED_MODULE_2__ObservationButton_scss__["observationButtonInactive"])+' '+className,onClick:function onClick(){return _onClick(observation_type_code);},type:'button','data-code':observation_type_code},name);}ObservationButton.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,existing:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,observation_type_code:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,className:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ObservationButton":"ObservationButton","observationButton":"ObservationButton","c-button--active":"c-button--active","cButtonActive":"c-button--active","ObservationButton--active":"ObservationButton--active","observationButtonActive":"ObservationButton--active","ObservationButton--inactive":"ObservationButton--inactive","observationButtonInactive":"ObservationButton--inactive"};

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubmitButton_scss__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubmitButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SubmitButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var noop=function noop(){};var SubmitButton=function SubmitButton(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},_ref$onClick=_ref.onClick,onClick=_ref$onClick===undefined?noop:_ref$onClick,label=_ref.label,pending=_ref.pending,_ref$style=_ref.style,style=_ref$style===undefined?null:_ref$style,disabled=_ref.disabled,_ref$className=_ref.className,className=_ref$className===undefined?'':_ref$className;var buttonClassName=__WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__SubmitButton_scss___default.a.submitButton,_defineProperty({},__WEBPACK_IMPORTED_MODULE_2__SubmitButton_scss___default.a.submitButtonDisabled,disabled===true),className);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:buttonClassName,onClick:pending?noop:onClick,type:'button',style:style,disabled:disabled},pending?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["g" /* Loader */],{size:'1.5em',thickness:'0.15em'}):label);};// TODO muted button
SubmitButton.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,pending:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,label:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,style:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,disabled:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool};SubmitButton.defaultProps={disabled:false};/* harmony default export */ __webpack_exports__["a"] = (SubmitButton);

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SubmitButton":"SubmitButton","submitButton":"SubmitButton","c-button--active":"c-button--active","cButtonActive":"c-button--active"};

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EmptyCard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmptyCard_scss__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmptyCard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EmptyCard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var Title=function Title(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__EmptyCard_scss___default.a.emptyCardTitle},children);};var Message=function Message(_ref2){var children=_ref2.children;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__EmptyCard_scss___default.a.emptyCardMessage},children);};function EmptyCard(props){var _classnames;var children=props.children,title=props.title,message=props.message,modal=props.modal;var className=__WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__EmptyCard_scss___default.a.emptyCard,(_classnames={},_defineProperty(_classnames,__WEBPACK_IMPORTED_MODULE_2__EmptyCard_scss___default.a.emptyCardModal,modal===true),_defineProperty(_classnames,__WEBPACK_IMPORTED_MODULE_2__EmptyCard_scss___default.a.emptyCardInline,modal!==true),_classnames));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'overflow-hidden'},children?children:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,title&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,null,title),message&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Message,null,message))));}EmptyCard.propTypes={title:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,message:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,modal:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool};EmptyCard.Title=Title;EmptyCard.Message=Message;EmptyCard.Unauthorized=function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EmptyCard,Object.assign({title:'Unauthorized',message:'You do not have access to this resource.'},props));};EmptyCard.PageNotFound=function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EmptyCard,Object.assign({title:'Page Not Found',message:'This page might have moved.'},props));};

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"o-modal":"o-modal","oModal":"o-modal","EmptyCard--modal":"EmptyCard--modal","emptyCardModal":"EmptyCard--modal","c-card":"c-card","cCard":"c-card","c-card__body":"c-card__body","cCardBody":"c-card__body","o-modal--ghost":"o-modal--ghost","oModalGhost":"o-modal--ghost","c-heading":"c-heading","cHeading":"c-heading","o-modal--full":"o-modal--full","oModalFull":"o-modal--full","c-card__footer":"c-card__footer","cCardFooter":"c-card__footer","EmptyCard":"EmptyCard","emptyCard":"EmptyCard","EmptyCard--inline":"EmptyCard--inline","emptyCardInline":"EmptyCard--inline","EmptyCard__title":"EmptyCard__title","emptyCardTitle":"EmptyCard__title","EmptyCard__message":"EmptyCard__message","emptyCardMessage":"EmptyCard__message"};

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_startCase__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Breadcrumbs_css__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Breadcrumbs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Breadcrumbs_css__);
var Breadcrumbs=function Breadcrumbs(_ref){var routes=_ref.routes,_ref$className=_ref.className,className=_ref$className===undefined?'':_ref$className;var crumbs=routes.filter(function(route){return!!route.path;}).map(function(route,index,arr){var path=route.path,_route$name=route.name,name=_route$name===undefined?__WEBPACK_IMPORTED_MODULE_2_lodash_startCase___default()(path):_route$name;var isFirstItem=index===0;var isLastItem=index===arr.length-1;var linkClassName=__WEBPACK_IMPORTED_MODULE_4_classnames___default()('dark-gray no-underline',{b:isFirstItem,normal:!isFirstItem});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'dib pa0',key:name},isLastItem?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:linkClassName},name):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{className:linkClassName+' Breadcrumbs__link',to:path},name)));});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'Breadcrumbs brandon dark-gray f3 '+className,'data-translate':true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ol',{className:'db ma0 pa0 list'},crumbs));};Breadcrumbs.propTypes={routes:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Breadcrumbs);

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Breadcrumbs__link":"Breadcrumbs__link","breadcrumbsLink":"Breadcrumbs__link"};

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_virtualized_select__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_virtualized_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_virtualized_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Select_scss__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Select_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Select_scss__);
var Select=function Select(props){var clearable=props.multi&&props.multi===true;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_select__["default"],Object.assign({clearable:clearable},props));};var VirtualizedSelect=function VirtualizedSelect(props){var clearable=props.multi&&props.multi===true;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_virtualized_select___default.a,Object.assign({clearable:clearable},props));};Select.Virtualized=VirtualizedSelect;/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _VirtualizedSelect = __webpack_require__(432);

var _VirtualizedSelect2 = _interopRequireDefault(_VirtualizedSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VirtualizedSelect2.default;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _VirtualizedSelect = __webpack_require__(433);

var _VirtualizedSelect2 = _interopRequireDefault(_VirtualizedSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VirtualizedSelect2.default;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(190);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _AutoSizer = __webpack_require__(434);

var _AutoSizer2 = _interopRequireDefault(_AutoSizer);

var _List = __webpack_require__(438);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Import directly to avoid Webpack bundling the parts of react-virtualized that we are not using


var VirtualizedSelect = function (_Component) {
  _inherits(VirtualizedSelect, _Component);

  function VirtualizedSelect(props, context) {
    _classCallCheck(this, VirtualizedSelect);

    var _this = _possibleConstructorReturn(this, (VirtualizedSelect.__proto__ || Object.getPrototypeOf(VirtualizedSelect)).call(this, props, context));

    _this._renderMenu = _this._renderMenu.bind(_this);
    _this._optionRenderer = _this._optionRenderer.bind(_this);
    _this._setListRef = _this._setListRef.bind(_this);
    _this._setSelectRef = _this._setSelectRef.bind(_this);
    return _this;
  }

  /** See List#recomputeRowHeights */


  _createClass(VirtualizedSelect, [{
    key: 'recomputeOptionHeights',
    value: function recomputeOptionHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this._listRef) {
        this._listRef.recomputeRowHeights(index);
      }
    }

    /** See Select#focus (in react-select) */

  }, {
    key: 'focus',
    value: function focus() {
      if (this._selectRef) {
        return this._selectRef.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var SelectComponent = this._getSelectComponent();

      return _react2.default.createElement(SelectComponent, _extends({}, this.props, {
        ref: this._setSelectRef,
        menuRenderer: this._renderMenu,
        menuStyle: { overflow: 'hidden' }
      }));
    }

    // See https://github.com/JedWatson/react-select/#effeciently-rendering-large-lists-with-windowing

  }, {
    key: '_renderMenu',
    value: function _renderMenu(_ref) {
      var _this2 = this;

      var focusedOption = _ref.focusedOption,
          focusOption = _ref.focusOption,
          labelKey = _ref.labelKey,
          onSelect = _ref.onSelect,
          options = _ref.options,
          selectValue = _ref.selectValue,
          valueArray = _ref.valueArray,
          valueKey = _ref.valueKey;
      var _props = this.props,
          listProps = _props.listProps,
          optionRenderer = _props.optionRenderer;

      var focusedOptionIndex = options.indexOf(focusedOption);
      var height = this._calculateListHeight({ options: options });
      var innerRowRenderer = optionRenderer || this._optionRenderer;

      // react-select 1.0.0-rc2 passes duplicate `onSelect` and `selectValue` props to `menuRenderer`
      // The `Creatable` HOC only overrides `onSelect` which breaks an edge-case
      // In order to support creating items via clicking on the placeholder option,
      // We need to ensure that the specified `onSelect` handle is the one we use.
      // See issue #33

      function wrappedRowRenderer(_ref2) {
        var index = _ref2.index,
            key = _ref2.key,
            style = _ref2.style;

        var option = options[index];

        return innerRowRenderer({
          focusedOption: focusedOption,
          focusedOptionIndex: focusedOptionIndex,
          focusOption: focusOption,
          key: key,
          labelKey: labelKey,
          onSelect: onSelect,
          option: option,
          optionIndex: index,
          options: options,
          selectValue: onSelect,
          style: style,
          valueArray: valueArray,
          valueKey: valueKey
        });
      }

      return _react2.default.createElement(
        _AutoSizer2.default,
        { disableHeight: true },
        function (_ref3) {
          var width = _ref3.width;
          return _react2.default.createElement(_List2.default, _extends({
            className: 'VirtualSelectGrid',
            height: height,
            ref: _this2._setListRef,
            rowCount: options.length,
            rowHeight: function rowHeight(_ref4) {
              var index = _ref4.index;
              return _this2._getOptionHeight({
                option: options[index]
              });
            },
            rowRenderer: wrappedRowRenderer,
            scrollToIndex: focusedOptionIndex,
            width: width
          }, listProps));
        }
      );
    }
  }, {
    key: '_calculateListHeight',
    value: function _calculateListHeight(_ref5) {
      var options = _ref5.options;
      var maxHeight = this.props.maxHeight;


      var height = 0;

      for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
        var option = options[optionIndex];

        height += this._getOptionHeight({ option: option });

        if (height > maxHeight) {
          return maxHeight;
        }
      }

      return height;
    }
  }, {
    key: '_getOptionHeight',
    value: function _getOptionHeight(_ref6) {
      var option = _ref6.option;
      var optionHeight = this.props.optionHeight;


      return optionHeight instanceof Function ? optionHeight({ option: option }) : optionHeight;
    }
  }, {
    key: '_getSelectComponent',
    value: function _getSelectComponent() {
      var _props2 = this.props,
          async = _props2.async,
          selectComponent = _props2.selectComponent;


      if (selectComponent) {
        return selectComponent;
      } else if (async) {
        return _reactSelect2.default.Async;
      } else {
        return _reactSelect2.default;
      }
    }
  }, {
    key: '_optionRenderer',
    value: function _optionRenderer(_ref7) {
      var focusedOption = _ref7.focusedOption,
          focusOption = _ref7.focusOption,
          key = _ref7.key,
          labelKey = _ref7.labelKey,
          option = _ref7.option,
          selectValue = _ref7.selectValue,
          style = _ref7.style,
          valueArray = _ref7.valueArray;

      var className = ['VirtualizedSelectOption'];

      if (option === focusedOption) {
        className.push('VirtualizedSelectFocusedOption');
      }

      if (option.disabled) {
        className.push('VirtualizedSelectDisabledOption');
      }

      if (valueArray && valueArray.indexOf(option) >= 0) {
        className.push('VirtualizedSelectSelectedOption');
      }

      if (option.className) {
        className.push(option.className);
      }

      var events = option.disabled ? {} : {
        onClick: function onClick() {
          return selectValue(option);
        },
        onMouseEnter: function onMouseEnter() {
          return focusOption(option);
        }
      };

      return _react2.default.createElement(
        'div',
        _extends({
          className: className.join(' '),
          key: key,
          style: style,
          title: option.title
        }, events),
        option[labelKey]
      );
    }
  }, {
    key: '_setListRef',
    value: function _setListRef(ref) {
      this._listRef = ref;
    }
  }, {
    key: '_setSelectRef',
    value: function _setSelectRef(ref) {
      this._selectRef = ref;
    }
  }]);

  return VirtualizedSelect;
}(_react.Component);

VirtualizedSelect.propTypes = {
  async: _propTypes2.default.bool,
  listProps: _propTypes2.default.object,
  maxHeight: _propTypes2.default.number,
  optionHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  optionRenderer: _propTypes2.default.func,
  selectComponent: _propTypes2.default.func
};
VirtualizedSelect.defaultProps = {
  async: false,
  maxHeight: 200,
  optionHeight: 35
};
exports.default = VirtualizedSelect;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AutoSizer["default"];
  }
});
Object.defineProperty(exports, "AutoSizer", {
  enumerable: true,
  get: function get() {
    return _AutoSizer["default"];
  }
});

var _AutoSizer = _interopRequireDefault(__webpack_require__(435));

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

var _interopRequireWildcard = __webpack_require__(63);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(64));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(123));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(124));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(46));

var _inherits2 = _interopRequireDefault(__webpack_require__(125));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(38));

var React = _interopRequireWildcard(__webpack_require__(0));

var _detectElementResize = _interopRequireDefault(__webpack_require__(437));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AutoSizer = (_temp = _class =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(AutoSizer, _React$Component);

  function AutoSizer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, AutoSizer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AutoSizer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_parentNode", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_autoSizer", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_window", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_detectElementResize", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onResize", function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;

      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.
        var height = _this._parentNode.offsetHeight || 0;
        var width = _this._parentNode.offsetWidth || 0;
        var win = _this._window || window;
        var style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: height - paddingTop - paddingBottom,
            width: width - paddingLeft - paddingRight
          });

          onResize({
            height: height,
            width: width
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setRef", function (autoSizer) {
      _this._autoSizer = autoSizer;
    });
    return _this;
  }

  (0, _createClass2["default"])(AutoSizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView; // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41

        this._detectElementResize = (0, _detectElementResize["default"])(nonce, this._window);

        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disableHeight = _this$props2.disableHeight,
          disableWidth = _this$props2.disableWidth,
          style = _this$props2.style;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width; // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = {
        overflow: 'visible'
      };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }
      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */


      return React.createElement("div", {
        className: className,
        ref: this._setRef,
        style: _objectSpread({}, outerStyle, {}, style)
      }, children(childParams));
    }
  }]);
  return AutoSizer;
}(React.Component), (0, _defineProperty2["default"])(_class, "propTypes",  true ? null : {
  /** Function responsible for rendering children.*/
  "children": _propTypes["default"].func.isRequired,

  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  "className": _propTypes["default"].string,

  /** Default height to use for initial render; useful for SSR */
  "defaultHeight": _propTypes["default"].number,

  /** Default width to use for initial render; useful for SSR */
  "defaultWidth": _propTypes["default"].number,

  /** Disable dynamic :height property */
  "disableHeight": _propTypes["default"].bool.isRequired,

  /** Disable dynamic :width property */
  "disableWidth": _propTypes["default"].bool.isRequired,

  /** Nonce of the inlined stylesheet for Content Security Policy */
  "nonce": _propTypes["default"].string,

  /** Callback to be invoked on-resize */
  "onResize": _propTypes["default"].func.isRequired,

  /** Optional inline style */
  "style": _propTypes["default"].object
}), _temp);
exports["default"] = AutoSizer;
(0, _defineProperty2["default"])(AutoSizer, "defaultProps", {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
});

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(82)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createDetectElementResize;

/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/
function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;

  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };

      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);

      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }

      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;

          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };
    /* Detect CSS Animations support to detect element display/re-attach */


    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');

      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;

        var elementStyle = _window.getComputedStyle(element);

        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }

        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var resizeTriggersHtml = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';

        if (window.trustedTypes) {
          var staticPolicy = trustedTypes.createPolicy('react-virtualized-auto-sizer', {
            createHTML: function createHTML() {
              return resizeTriggersHtml;
            }
          });
          element.__resizeTriggers__.innerHTML = staticPolicy.createHTML('');
        } else {
          element.__resizeTriggers__.innerHTML = resizeTriggersHtml;
        }

        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);
        /* Listen for a css animation to detect element display/re-attach */

        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };

          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }

      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);

      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);

        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);

          element.__resizeTriggers__.__animationListener__ = null;
        }

        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {// Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List["default"];
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function get() {
    return _List["default"];
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_RowRendererParams", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_RowRendererParams;
  }
});

var _List = _interopRequireDefault(__webpack_require__(439));

var _types = __webpack_require__(196);

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

var _interopRequireWildcard = __webpack_require__(63);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(47));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(64));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(123));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(124));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(46));

var _inherits2 = _interopRequireDefault(__webpack_require__(125));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(38));

var _Grid = _interopRequireWildcard(__webpack_require__(440));

var React = _interopRequireWildcard(__webpack_require__(0));

var _clsx = _interopRequireDefault(__webpack_require__(193));

var _types = __webpack_require__(196);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _class, _temp;

var List = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(List, _React$PureComponent);

  function List() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(List)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "Grid", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellRenderer", function (_ref) {
      var parent = _ref.parent,
          rowIndex = _ref.rowIndex,
          style = _ref.style,
          isScrolling = _ref.isScrolling,
          isVisible = _ref.isVisible,
          key = _ref.key;
      var rowRenderer = _this.props.rowRenderer; // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');

      if (widthDescriptor && widthDescriptor.writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setRef", function (ref) {
      _this.Grid = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function (_ref2) {
      var clientHeight = _ref2.clientHeight,
          scrollHeight = _ref2.scrollHeight,
          scrollTop = _ref2.scrollTop;
      var onScroll = _this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSectionRendered", function (_ref3) {
      var rowOverscanStartIndex = _ref3.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref3.rowOverscanStopIndex,
          rowStartIndex = _ref3.rowStartIndex,
          rowStopIndex = _ref3.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(List, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref4) {
      var alignment = _ref4.alignment,
          index = _ref4.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$columnIndex = _ref6.columnIndex,
          columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex,
          _ref6$rowIndex = _ref6.rowIndex,
          rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          noRowsRenderer = _this$props.noRowsRenderer,
          scrollToIndex = _this$props.scrollToIndex,
          width = _this$props.width;
      var classNames = (0, _clsx["default"])('ReactVirtualized__List', className);
      return React.createElement(_Grid["default"], (0, _extends2["default"])({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);
  return List;
}(React.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes",  true ? null : {
  "aria-label": _propTypes["default"].string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  "autoHeight": _propTypes["default"].bool.isRequired,

  /** Optional CSS class name */
  "className": _propTypes["default"].string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  "estimatedRowSize": _propTypes["default"].number.isRequired,

  /** Height constraint for list (determines how many actual rows are rendered) */
  "height": _propTypes["default"].number.isRequired,

  /** Optional renderer to be used in place of rows when rowCount is 0 */
  "noRowsRenderer": function noRowsRenderer() {
    return (typeof _Grid.bpfrpt_proptype_NoContentRenderer === "function" ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired : _Grid.bpfrpt_proptype_NoContentRenderer : _propTypes["default"].shape(_Grid.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },

  /** Callback invoked with information about the slice of rows that were just rendered.  */
  "onRowsRendered": _propTypes["default"].func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  "onScroll": _propTypes["default"].func.isRequired,

  /** See Grid#overscanIndicesGetter */
  "overscanIndicesGetter": function overscanIndicesGetter() {
    return (typeof _Grid.bpfrpt_proptype_OverscanIndicesGetter === "function" ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _Grid.bpfrpt_proptype_OverscanIndicesGetter : _propTypes["default"].shape(_Grid.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  "overscanRowCount": _propTypes["default"].number.isRequired,

  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  "rowHeight": function rowHeight() {
    return (typeof _Grid.bpfrpt_proptype_CellSize === "function" ? _Grid.bpfrpt_proptype_CellSize.isRequired ? _Grid.bpfrpt_proptype_CellSize.isRequired : _Grid.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_Grid.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Responsible for rendering a row given an index; ({ index: number }): node */
  "rowRenderer": function rowRenderer() {
    return (typeof _types.bpfrpt_proptype_RowRenderer === "function" ? _types.bpfrpt_proptype_RowRenderer.isRequired ? _types.bpfrpt_proptype_RowRenderer.isRequired : _types.bpfrpt_proptype_RowRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
  },

  /** Number of rows in list. */
  "rowCount": _propTypes["default"].number.isRequired,

  /** See Grid#scrollToAlignment */
  "scrollToAlignment": function scrollToAlignment() {
    return (typeof _Grid.bpfrpt_proptype_Alignment === "function" ? _Grid.bpfrpt_proptype_Alignment.isRequired ? _Grid.bpfrpt_proptype_Alignment.isRequired : _Grid.bpfrpt_proptype_Alignment : _propTypes["default"].shape(_Grid.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToIndex": _propTypes["default"].number.isRequired,

  /** Vertical offset. */
  "scrollTop": _propTypes["default"].number,

  /** Optional inline style */
  "style": _propTypes["default"].object.isRequired,

  /** Tab index for focus */
  "tabIndex": _propTypes["default"].number,

  /** Width of list */
  "width": _propTypes["default"].number.isRequired
}), _temp);
exports["default"] = List;
(0, _defineProperty2["default"])(List, "defaultProps", {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grid["default"];
  }
});
Object.defineProperty(exports, "Grid", {
  enumerable: true,
  get: function get() {
    return _Grid["default"];
  }
});
Object.defineProperty(exports, "accessibilityOverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return _accessibilityOverscanIndicesGetter["default"];
  }
});
Object.defineProperty(exports, "defaultCellRangeRenderer", {
  enumerable: true,
  get: function get() {
    return _defaultCellRangeRenderer["default"];
  }
});
Object.defineProperty(exports, "defaultOverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return _defaultOverscanIndicesGetter["default"];
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_NoContentRenderer", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_NoContentRenderer;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_Alignment", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_Alignment;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellPosition", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_CellPosition;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellSize", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_CellSize;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_OverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_OverscanIndicesGetter;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_RenderedSection", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_RenderedSection;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellRendererParams", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_CellRendererParams;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_Scroll", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_Scroll;
  }
});

var _Grid = _interopRequireDefault(__webpack_require__(441));

var _accessibilityOverscanIndicesGetter = _interopRequireDefault(__webpack_require__(454));

var _defaultCellRangeRenderer = _interopRequireDefault(__webpack_require__(195));

var _defaultOverscanIndicesGetter = _interopRequireDefault(__webpack_require__(194));

var _types = __webpack_require__(34);

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

var _interopRequireWildcard = __webpack_require__(63);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(47));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(64));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(123));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(124));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(46));

var _inherits2 = _interopRequireDefault(__webpack_require__(125));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(38));

var React = _interopRequireWildcard(__webpack_require__(0));

var _clsx = _interopRequireDefault(__webpack_require__(193));

var _calculateSizeAndPositionDataAndUpdateScrollOffset = _interopRequireDefault(__webpack_require__(442));

var _ScalingCellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(126));

var _createCallbackMemoizer = _interopRequireDefault(__webpack_require__(447));

var _defaultOverscanIndicesGetter = _interopRequireWildcard(__webpack_require__(194));

var _updateScrollIndexHelper = _interopRequireDefault(__webpack_require__(448));

var _defaultCellRangeRenderer = _interopRequireDefault(__webpack_require__(195));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(449));

var _reactLifecyclesCompat = __webpack_require__(451);

var _requestAnimationTimeout = __webpack_require__(452);

var _types = __webpack_require__(34);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = DEFAULT_SCROLLING_RESET_TIME_INTERVAL;
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Grid);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Grid).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onGridRenderedMemoizer", (0, _createCallbackMemoizer["default"])());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScrollMemoizer", (0, _createCallbackMemoizer["default"])(false));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_deferredInvalidateColumnIndex", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_deferredInvalidateRowIndex", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_recomputeScrollLeftFlag", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_recomputeScrollTopFlag", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_horizontalScrollBarSize", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_verticalScrollBarSize", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_scrollbarPresenceChanged", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_scrollingContainer", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_childrenToDisplay", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStartIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStopIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStartIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStopIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedColumnStartIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedColumnStopIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedRowStartIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedRowStopIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initialScrollTop", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initialScrollLeft", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_disablePointerEventsTimeoutId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_styleCache", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellCache", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_debounceScrollEndedCallback", function () {
      _this._disablePointerEventsTimeoutId = null; // isScrolling is used to determine if we reset styleCache

      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_invokeOnGridRenderedHelper", function () {
      var onSectionRendered = _this.props.onSectionRendered;

      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    });
    var columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager["default"]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager["default"]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });
    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,
        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollDirectionVertical: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }

    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }

    return _this;
  }
  /**
   * Gets offsets for a given cell and alignment.
   */


  (0, _createClass2["default"])(Grid, [{
    key: "getOffsetForCell",
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = _objectSpread({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }
    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: "getTotalRowsHeight",
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: "getTotalColumnsWidth",
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: "handleScrollEvent",
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      this._debounceScrollEnded();

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          autoWidth = _this$props.autoWidth,
          height = _this$props.height,
          width = _this$props.width;
      var instanceProps = this.state.instanceProps; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          rowCount = _this$props2.rowCount;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;

      var _this$props3 = this.props,
          scrollToColumn = _this$props3.scrollToColumn,
          scrollToRow = _this$props3.scrollToRow;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex); // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.

      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow); // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.

      this._styleCache = {};
      this._cellCache = {};
      this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */

  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;
      var props = this.props; // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.

      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(_objectSpread({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(_objectSpread({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          getScrollbarSize = _this$props4.getScrollbarSize,
          height = _this$props4.height,
          scrollLeft = _this$props4.scrollLeft,
          scrollToColumn = _this$props4.scrollToColumn,
          scrollTop = _this$props4.scrollTop,
          scrollToRow = _this$props4.scrollToRow,
          width = _this$props4.width;
      var instanceProps = this.state.instanceProps; // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.


      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = _objectSpread({}, prevState, {
            needToResetStyleCache: false
          });

          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      } // refs don't work in `react-test-renderer`


      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }

        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      } // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.


      var sizeIsBiggerThanZero = height > 0 && width > 0;

      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }

      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      } // Update onRowsRendered callback


      this._invokeOnGridRenderedHelper(); // Initialize onScroll callback


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props5 = this.props,
          autoHeight = _this$props5.autoHeight,
          autoWidth = _this$props5.autoWidth,
          columnCount = _this$props5.columnCount,
          height = _this$props5.height,
          rowCount = _this$props5.rowCount,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToColumn = _this$props5.scrollToColumn,
          scrollToRow = _this$props5.scrollToRow,
          width = _this$props5.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
          scrollTop = _this$state.scrollTop,
          instanceProps = _this$state.instanceProps; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218


      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.


      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0; // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?

      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;

        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        (0, _updateScrollIndexHelper["default"])({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;

        this._updateScrollTopForScrollToRow(this.props);
      } else {
        (0, _updateScrollIndexHelper["default"])({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnGridRenderedHelper(); // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners


      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
      }
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoContainerWidth = _this$props6.autoContainerWidth,
          autoHeight = _this$props6.autoHeight,
          autoWidth = _this$props6.autoWidth,
          className = _this$props6.className,
          containerProps = _this$props6.containerProps,
          containerRole = _this$props6.containerRole,
          containerStyle = _this$props6.containerStyle,
          height = _this$props6.height,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          role = _this$props6.role,
          style = _this$props6.style,
          tabIndex = _this$props6.tabIndex,
          width = _this$props6.width;
      var _this$state2 = this.state,
          instanceProps = _this$state2.instanceProps,
          needToResetStyleCache = _this$state2.needToResetStyleCache;

      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      } // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset


      if (!this.state.isScrolling) {
        this._resetStyleCache();
      } // calculate children to render here


      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize(); // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      } // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23


      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      var childrenToDisplay = this._childrenToDisplay;
      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
      return React.createElement("div", (0, _extends2["default"])({
        ref: this._setScrollingContainerRef
      }, containerProps, {
        "aria-label": this.props['aria-label'],
        "aria-readonly": this.props['aria-readonly'],
        className: (0, _clsx["default"])('ReactVirtualized__Grid', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: _objectSpread({}, gridStyle, {}, style),
        tabIndex: tabIndex
      }), childrenToDisplay.length > 0 && React.createElement("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: containerRole,
        style: _objectSpread({
          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
          height: totalRowsHeight,
          maxWidth: totalColumnsWidth,
          maxHeight: totalRowsHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }, containerStyle)
      }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: "_calculateChildrenToRender",
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;
      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = []; // Render only enough columns and rows to cover the visible area of the grid.

      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });
        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        }); // Store for _invokeOnGridRenderedHelper()

        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;
        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });
        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        }); // Store for _invokeOnGridRenderedHelper()

        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex; // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.

        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          } // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).


          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        }); // update the indices

        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_debounceScrollEnded",
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._disablePointerEventsTimeoutId) {
        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = (0, _requestAnimationTimeout.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_handleInvalidatedGridSize",

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
      }
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = false;
        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",

    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: "_resetStyleCache",
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut; // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {}; // Copy over the visible cell styles so avoid unnecessary re-render.

      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = "".concat(rowIndex, "-").concat(columnIndex);
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0; // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        Object.assign(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps; // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;

      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });
      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      } // If scrolling is controlled outside this component, clear cache when scrolling stops


      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        Object.assign(newState, {
          isScrolling: false
        });
      }

      var maybeStateA;
      var maybeStateB;
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });
      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow; // getting scrollBarSize (moved from componentWillMount)

      instanceProps.scrollbarSize = nextProps.getScrollbarSize();

      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;
      return _objectSpread({}, newState, {}, maybeStateA, {}, maybeStateB);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",

    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }

      return {};
    }
  }, {
    key: "_wrapSizeGetter",
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;

      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }

      return {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;

      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }

      return {};
    }
  }]);
  return Grid;
}(React.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes",  true ? null : {
  "aria-label": _propTypes["default"].string.isRequired,
  "aria-readonly": _propTypes["default"].bool,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  "autoContainerWidth": _propTypes["default"].bool.isRequired,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  "autoHeight": _propTypes["default"].bool.isRequired,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  "autoWidth": _propTypes["default"].bool.isRequired,

  /** Responsible for rendering a cell given an row and column index.  */
  "cellRenderer": function cellRenderer() {
    return (typeof _types.bpfrpt_proptype_CellRenderer === "function" ? _types.bpfrpt_proptype_CellRenderer.isRequired ? _types.bpfrpt_proptype_CellRenderer.isRequired : _types.bpfrpt_proptype_CellRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
  },

  /** Responsible for rendering a group of cells given their index ranges.  */
  "cellRangeRenderer": function cellRangeRenderer() {
    return (typeof _types.bpfrpt_proptype_CellRangeRenderer === "function" ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired : _types.bpfrpt_proptype_CellRangeRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
  },

  /** Optional custom CSS class name to attach to root Grid element.  */
  "className": _propTypes["default"].string,

  /** Number of columns in grid.  */
  "columnCount": _propTypes["default"].number.isRequired,

  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  "columnWidth": function columnWidth() {
    return (typeof _types.bpfrpt_proptype_CellSize === "function" ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Unfiltered props for the Grid container. */
  "containerProps": _propTypes["default"].object,

  /** ARIA role for the cell-container.  */
  "containerRole": _propTypes["default"].string.isRequired,

  /** Optional inline style applied to inner cell-container */
  "containerStyle": _propTypes["default"].object.isRequired,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  "deferredMeasurementCache": _propTypes["default"].object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  "estimatedColumnSize": _propTypes["default"].number.isRequired,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  "estimatedRowSize": _propTypes["default"].number.isRequired,

  /** Exposed for testing purposes only.  */
  "getScrollbarSize": _propTypes["default"].func.isRequired,

  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  "height": _propTypes["default"].number.isRequired,

  /** Optional custom id to attach to root Grid element.  */
  "id": _propTypes["default"].string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  "isScrolling": _propTypes["default"].bool,

  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   */
  "isScrollingOptOut": _propTypes["default"].bool.isRequired,

  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  "noContentRenderer": function noContentRenderer() {
    return (typeof _types.bpfrpt_proptype_NoContentRenderer === "function" ? _types.bpfrpt_proptype_NoContentRenderer.isRequired ? _types.bpfrpt_proptype_NoContentRenderer.isRequired : _types.bpfrpt_proptype_NoContentRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  "onScroll": _propTypes["default"].func.isRequired,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  "onScrollbarPresenceChange": _propTypes["default"].func.isRequired,

  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  "onSectionRendered": _propTypes["default"].func.isRequired,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  "overscanColumnCount": _propTypes["default"].number.isRequired,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  "overscanIndicesGetter": function overscanIndicesGetter() {
    return (typeof _types.bpfrpt_proptype_OverscanIndicesGetter === "function" ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _types.bpfrpt_proptype_OverscanIndicesGetter : _propTypes["default"].shape(_types.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  "overscanRowCount": _propTypes["default"].number.isRequired,

  /** ARIA role for the grid element.  */
  "role": _propTypes["default"].string.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  "rowHeight": function rowHeight() {
    return (typeof _types.bpfrpt_proptype_CellSize === "function" ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Number of rows in grid.  */
  "rowCount": _propTypes["default"].number.isRequired,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  "scrollingResetTimeInterval": _propTypes["default"].number.isRequired,

  /** Horizontal offset. */
  "scrollLeft": _propTypes["default"].number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  "scrollToAlignment": function scrollToAlignment() {
    return (typeof _types.bpfrpt_proptype_Alignment === "function" ? _types.bpfrpt_proptype_Alignment.isRequired ? _types.bpfrpt_proptype_Alignment.isRequired : _types.bpfrpt_proptype_Alignment : _propTypes["default"].shape(_types.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },

  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToColumn": _propTypes["default"].number.isRequired,

  /** Vertical offset. */
  "scrollTop": _propTypes["default"].number,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToRow": _propTypes["default"].number.isRequired,

  /** Optional inline style */
  "style": _propTypes["default"].object.isRequired,

  /** Tab index for focus */
  "tabIndex": _propTypes["default"].number,

  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  "width": _propTypes["default"].number.isRequired
}), _temp);
(0, _defineProperty2["default"])(Grid, "defaultProps", {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: _defaultCellRangeRenderer["default"],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: _scrollbarSize["default"],
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: _defaultOverscanIndicesGetter["default"],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
});
(0, _reactLifecyclesCompat.polyfill)(Grid);
var _default = Grid;
exports["default"] = _default;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateSizeAndPositionDataAndUpdateScrollOffset;

/**
 * Helper method that determines when to recalculate row or column metadata.
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps); // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.

    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(444);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 444 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(64));

var _createClass2 = _interopRequireDefault(__webpack_require__(65));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(38));

var _types = __webpack_require__(34);

/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager =
/*#__PURE__*/
function () {
  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
  // Used in deferred mode to track which cells have been queued for measurement.
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;
    (0, _classCallCheck2["default"])(this, CellSizeAndPositionManager);
    (0, _defineProperty2["default"])(this, "_cellSizeAndPositionData", {});
    (0, _defineProperty2["default"])(this, "_lastMeasuredIndex", -1);
    (0, _defineProperty2["default"])(this, "_lastBatchedIndex", -1);
    (0, _defineProperty2["default"])(this, "_cellCount", void 0);
    (0, _defineProperty2["default"])(this, "_cellSizeGetter", void 0);
    (0, _defineProperty2["default"])(this, "_estimatedCellSize", void 0);
    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  (0, _createClass2["default"])(CellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: "configure",
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;
      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var size = this._cellSizeGetter({
            index: i
          }); // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.


          if (size === undefined || isNaN(size)) {
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
          } else if (size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: 0
            };
            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: size
            };
            offset += size;
            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;

        case 'end':
          idealOffset = minOffset;
          break;

        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;

        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;
      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;

      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;
      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;
        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: "_binarySearch",
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "_exponentialSearch",
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: "_findNearestCell",
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error("Invalid offset ".concat(offset, " specified"));
      } // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.


      offset = Math.max(0, offset);
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);
  return CellSizeAndPositionManager;
}();

exports["default"] = CellSizeAndPositionManager;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaxElementSize = void 0;
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }

  return DEFAULT_MAX_ELEMENT_SIZE;
};

exports.getMaxElementSize = getMaxElementSize;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createCallbackMemoizer;

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var cachedIndices = {};
  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;
    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];
      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });
    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = updateScrollIndexHelper;

var _ScalingCellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(126));

var _types = __webpack_require__(34);

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize; // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.

  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex); // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = scrollbarSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__canUseDOM__ = __webpack_require__(450);

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (__WEBPACK_IMPORTED_MODULE_0__canUseDOM__["a" /* default */]) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(19);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_AnimationTimeoutId = exports.requestAnimationTimeout = exports.cancelAnimationTimeout = void 0;

var _animationFrame = __webpack_require__(453);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var bpfrpt_proptype_AnimationTimeoutId =  true ? null : {
  "id": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_AnimationTimeoutId = bpfrpt_proptype_AnimationTimeoutId;

var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return (0, _animationFrame.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */


exports.cancelAnimationTimeout = cancelAnimationTimeout;

var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start; // wait for end of processing current event handler, because event handler may be long

  Promise.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = (0, _animationFrame.raf)(timeout);
    }
  };

  var frame = {
    id: (0, _animationFrame.raf)(timeout)
  };
  return frame;
};

exports.requestAnimationTimeout = requestAnimationTimeout;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.caf = exports.raf = void 0;
// Properly handle server-side rendering.
var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
} // requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/


var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
exports.raf = raf;
var caf = cancel;
exports.caf = caf;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultOverscanIndicesGetter;
exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = void 0;

var _types = __webpack_require__(34);

var SCROLL_DIRECTION_BACKWARD = -1;
exports.SCROLL_DIRECTION_BACKWARD = SCROLL_DIRECTION_BACKWARD;
var SCROLL_DIRECTION_FORWARD = 1;
exports.SCROLL_DIRECTION_FORWARD = SCROLL_DIRECTION_FORWARD;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
exports.SCROLL_DIRECTION_HORIZONTAL = SCROLL_DIRECTION_HORIZONTAL;
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

exports.SCROLL_DIRECTION_VERTICAL = SCROLL_DIRECTION_VERTICAL;

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;
  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Select":"Select","select":"Select","is-disabled":"is-disabled","isDisabled":"is-disabled","Select-arrow-zone":"Select-arrow-zone","selectArrowZone":"Select-arrow-zone","Select-control":"Select-control","selectControl":"Select-control","is-searchable":"is-searchable","isSearchable":"is-searchable","is-open":"is-open","isOpen":"is-open","is-focused":"is-focused","isFocused":"is-focused","Select-arrow":"Select-arrow","selectArrow":"Select-arrow","has-value":"has-value","hasValue":"has-value","is-clearable":"is-clearable","isClearable":"is-clearable","Select--single":"Select--single","selectSingle":"Select--single","Select-value":"Select-value","selectValue":"Select-value","Select-value-label":"Select-value-label","selectValueLabel":"Select-value-label","is-pseudo-focused":"is-pseudo-focused","isPseudoFocused":"is-pseudo-focused","Select-input":"Select-input","selectInput":"Select-input","Select--rtl":"Select--rtl","selectRtl":"Select--rtl","Select-placeholder":"Select-placeholder","selectPlaceholder":"Select-placeholder","Select-loading-zone":"Select-loading-zone","selectLoadingZone":"Select-loading-zone","Select-loading":"Select-loading","selectLoading":"Select-loading","Select-animation-spin":"Select-animation-spin","selectAnimationSpin":"Select-animation-spin","Select-clear-zone":"Select-clear-zone","selectClearZone":"Select-clear-zone","Select-animation-fadeIn":"Select-animation-fadeIn","selectAnimationFadeIn":"Select-animation-fadeIn","Select-clear":"Select-clear","selectClear":"Select-clear","Select--multi":"Select--multi","selectMulti":"Select--multi","Select-multi-value-wrapper":"Select-multi-value-wrapper","selectMultiValueWrapper":"Select-multi-value-wrapper","Select-aria-only":"Select-aria-only","selectAriaOnly":"Select-aria-only","Select-menu-outer":"Select-menu-outer","selectMenuOuter":"Select-menu-outer","Select-menu":"Select-menu","selectMenu":"Select-menu","Select-option":"Select-option","selectOption":"Select-option","is-selected":"is-selected","isSelected":"is-selected","Select-noresults":"Select-noresults","selectNoresults":"Select-noresults","Select-value-icon":"Select-value-icon","selectValueIcon":"Select-value-icon","ReactVirtualized__Table__headerRow":"ReactVirtualized__Table__headerRow","reactVirtualizedTableHeaderRow":"ReactVirtualized__Table__headerRow","ReactVirtualized__Table__row":"ReactVirtualized__Table__row","reactVirtualizedTableRow":"ReactVirtualized__Table__row","ReactVirtualized__Table__headerTruncatedText":"ReactVirtualized__Table__headerTruncatedText","reactVirtualizedTableHeaderTruncatedText":"ReactVirtualized__Table__headerTruncatedText","ReactVirtualized__Table__headerColumn":"ReactVirtualized__Table__headerColumn","reactVirtualizedTableHeaderColumn":"ReactVirtualized__Table__headerColumn","ReactVirtualized__Table__rowColumn":"ReactVirtualized__Table__rowColumn","reactVirtualizedTableRowColumn":"ReactVirtualized__Table__rowColumn","ReactVirtualized__Table__sortableHeaderColumn":"ReactVirtualized__Table__sortableHeaderColumn","reactVirtualizedTableSortableHeaderColumn":"ReactVirtualized__Table__sortableHeaderColumn","ReactVirtualized__Table__sortableHeaderIconContainer":"ReactVirtualized__Table__sortableHeaderIconContainer","reactVirtualizedTableSortableHeaderIconContainer":"ReactVirtualized__Table__sortableHeaderIconContainer","ReactVirtualized__Table__sortableHeaderIcon":"ReactVirtualized__Table__sortableHeaderIcon","reactVirtualizedTableSortableHeaderIcon":"ReactVirtualized__Table__sortableHeaderIcon","VirtualSelectGrid":"VirtualSelectGrid","virtualSelectGrid":"VirtualSelectGrid","VirtualizedSelectOption":"VirtualizedSelectOption","virtualizedSelectOption":"VirtualizedSelectOption","VirtualizedSelectFocusedOption":"VirtualizedSelectFocusedOption","virtualizedSelectFocusedOption":"VirtualizedSelectFocusedOption","VirtualizedSelectDisabledOption":"VirtualizedSelectDisabledOption","virtualizedSelectDisabledOption":"VirtualizedSelectDisabledOption","VirtualizedSelectSelectedOption":"VirtualizedSelectSelectedOption","virtualizedSelectSelectedOption":"VirtualizedSelectSelectedOption"};

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResponseTextBox=function(_React$PureComponent){_inherits(ResponseTextBox,_React$PureComponent);function ResponseTextBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ResponseTextBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ResponseTextBox.__proto__||Object.getPrototypeOf(ResponseTextBox)).call.apply(_ref,[this].concat(args))),_this),_this.handleFocus=function(){_this.el&&_this.el.classList.add(__WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss__["responseTextBoxFocused"]);},_this.handleBlur=function(){if(!_this.hasValue()&&_this.el){_this.el.classList.remove(__WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss__["responseTextBoxFocused"]);_this.restoreOriginalHeight();_this.props.onCancel&&_this.props.onCancel();}},_this.handleSubmit=function(){_this.props.onSubmit&&_this.props.onSubmit(_this.props.value);},_this.handleCancel=function(){if(_this.props.onChange&&_this.el){_this.el.classList.remove(__WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss__["responseTextBoxFocused"]);_this.restoreOriginalHeight();_this.props.onChange('');}_this.props.onCancel&&_this.props.onCancel();},_this.clear=function(){// we should maybe remove this
// this is called from a parent component to reset the textbox
_this.handleCancel();},_this.handleChange=function(e){if(!_this.textArea)return;_this.adjustHeight();if(_this.props.onChange){_this.props.onChange(e.currentTarget.value);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ResponseTextBox,[{key:'hasValue',value:function hasValue(){return Boolean(typeof this.props.value==='string'&&this.props.value.trim());}},{key:'adjustHeight',value:function adjustHeight(){if(!this.textArea)return;if(this.textArea.scrollHeight>this.textArea.clientHeight){this.textArea.style.height=+this.textArea.scrollHeight+'px';}}},{key:'restoreOriginalHeight',value:function restoreOriginalHeight(){if(this.originalHeight&&this.textArea){this.textArea.style.height=this.originalHeight+'px';}}},{key:'componentDidMount',value:function componentDidMount(){if(this.textArea){this.originalHeight=this.textArea.scrollHeight;if(this.hasValue()){this.handleFocus();this.adjustHeight();}}}},{key:'renderErrorMessage',value:function renderErrorMessage(err){if(typeof err.status==='number'&&err.status===403){return'You do not have the necessary permissions to make this change.';}return'An error occurred while posting your response.';}},{key:'render',value:function render(){var _this2=this;var _props=this.props,value=_props.value,status=_props.status,buttonLabel=_props.buttonLabel,rest=_objectWithoutProperties(_props,['value','status','buttonLabel']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss__["responseTextBox"],onFocus:this.handleFocus,onBlur:this.handleBlur,ref:function ref(c){return _this2.el=c;},'data-translate':true},status==='pending'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss__["responseTextBoxOverlay"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss__["responseTextBoxLoader"]})),status instanceof Error&&value&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss__["responseTextBoxAlert"]},this.renderErrorMessage(status)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('textarea',Object.assign({},rest,{value:value,ref:function ref(c){return _this2.textArea=c;},className:__WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss__["responseTextBoxTextarea"],onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__ResponseTextBox_scss__["responseTextBoxButtonGroup"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["d" /* ButtonGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{onClick:this.handleCancel},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{disabled:!this.hasValue(),onClick:this.handleSubmit},status instanceof Error?'Retry':buttonLabel))));}}]);return ResponseTextBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);ResponseTextBox.defaultProps={value:'',rows:1,placeholder:'Add a response...',buttonLabel:'Submit'};/* harmony default export */ __webpack_exports__["a"] = (ResponseTextBox);

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"o-field":"o-field","oField":"o-field","c-field":"c-field","cField":"c-field","c-icon":"c-icon","cIcon":"c-icon","ResponseTextBox__textarea":"ResponseTextBox__textarea","responseTextBoxTextarea":"ResponseTextBox__textarea","o-field--icon-right":"o-field--icon-right","oFieldIconRight":"o-field--icon-right","o-field--icon-left":"o-field--icon-left","oFieldIconLeft":"o-field--icon-left","c-fieldset":"c-fieldset","cFieldset":"c-fieldset","c-list":"c-list","cList":"c-list","c-fieldset__legend":"c-fieldset__legend","cFieldsetLegend":"c-fieldset__legend","c-label":"c-label","cLabel":"c-label","c-field--label":"c-field--label","cFieldLabel":"c-field--label","c-field--error":"c-field--error","cFieldError":"c-field--error","c-field--success":"c-field--success","cFieldSuccess":"c-field--success","c-field--choice":"c-field--choice","cFieldChoice":"c-field--choice","c-fieldset--disabled":"c-fieldset--disabled","cFieldsetDisabled":"c-fieldset--disabled","c-field--disabled":"c-field--disabled","cFieldDisabled":"c-field--disabled","ResponseTextBox":"ResponseTextBox","responseTextBox":"ResponseTextBox","ResponseTextBox__button-group":"ResponseTextBox__button-group","responseTextBoxButtonGroup":"ResponseTextBox__button-group","ResponseTextBox__overlay":"ResponseTextBox__overlay","responseTextBoxOverlay":"ResponseTextBox__overlay","ResponseTextBox__loader":"ResponseTextBox__loader","responseTextBoxLoader":"ResponseTextBox__loader","load8":"load8","ResponseTextBox__alert":"ResponseTextBox__alert","responseTextBoxAlert":"ResponseTextBox__alert","ResponseTextBox--focused":"ResponseTextBox--focused","responseTextBoxFocused":"ResponseTextBox--focused"};

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoHide=function(_React$PureComponent){_inherits(AutoHide,_React$PureComponent);function AutoHide(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AutoHide);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AutoHide.__proto__||Object.getPrototypeOf(AutoHide)).call.apply(_ref,[this].concat(args))),_this),_this.timeout=null,_this.state={show:true},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AutoHide,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.timeout=setTimeout(function(){return _this2.setState({show:false});},this.props.delay);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.timeout&&clearTimeout(this.timeout);}},{key:'render',value:function render(){return this.state.show?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,this.props.children):null;}}]);return AutoHide;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);AutoHide.defaultProps={delay:1000};/* harmony default export */ __webpack_exports__["a"] = (AutoHide);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var classNames = (function () {
		// don't inherit from Object so we can skip hasOwnProperty check later
		// http://stackoverflow.com/questions/15518328/creating-js-object-with-object-createnull#answer-21079232
		function StorageObject() {}
		StorageObject.prototype = Object.create(null);

		function _parseArray (resultSet, array) {
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				_parse(resultSet, array[i]);
			}
		}

		var hasOwn = {}.hasOwnProperty;

		function _parseNumber (resultSet, num) {
			resultSet[num] = true;
		}

		function _parseObject (resultSet, object) {
			if (object.toString !== Object.prototype.toString && !object.toString.toString().includes('[native code]')) {
				resultSet[object.toString()] = true;
				return;
			}

			for (var k in object) {
				if (hasOwn.call(object, k)) {
					// set value to false instead of deleting it to avoid changing object structure
					// https://www.smashingmagazine.com/2012/11/writing-fast-memory-efficient-javascript/#de-referencing-misconceptions
					resultSet[k] = !!object[k];
				}
			}
		}

		var SPACE = /\s+/;
		function _parseString (resultSet, str) {
			var array = str.split(SPACE);
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				resultSet[array[i]] = true;
			}
		}

		function _parse (resultSet, arg) {
			if (!arg) return;
			var argType = typeof arg;

			// 'foo bar'
			if (argType === 'string') {
				_parseString(resultSet, arg);

			// ['foo', 'bar', ...]
			} else if (Array.isArray(arg)) {
				_parseArray(resultSet, arg);

			// { 'foo': true, ... }
			} else if (argType === 'object') {
				_parseObject(resultSet, arg);

			// '130'
			} else if (argType === 'number') {
				_parseNumber(resultSet, arg);
			}
		}

		function _classNames () {
			// don't leak arguments
			// https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
			var len = arguments.length;
			var args = Array(len);
			for (var i = 0; i < len; i++) {
				args[i] = arguments[i];
			}

			var classSet = new StorageObject();
			_parseArray(classSet, args);

			var list = [];

			for (var k in classSet) {
				if (classSet[k]) {
					list.push(k)
				}
			}

			return list.join(' ');
		}

		return _classNames;
	})();

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ButtonGroup=function ButtonGroup(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'br1 ButtonGroup',style:{boxShadow:'0 1px 0 0 rgba(0, 0, 0, 0.125)',marginBottom:1}},__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children,function(child,index){if(!child)return null;var className=Boolean(child.props.className)?child.props.className:'button-reset bg-animate pointer br1 ba blue hover-dark-blue ph3 pv2 lh-solid hover-shadow bg-white';if(index===0){return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child,{style:{borderTopRightRadius:0,borderBottomRightRadius:0,borderRight:0},className:className});}if(index===__WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children)-1){return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child,{style:{borderTopLeftRadius:0,borderBottomLeftRadius:0},className:className});}return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child,{style:{borderRadius:0,borderRight:0,borderLeft:0},className:className});}));};

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal","modal":"Modal","Modal--open":"Modal--open","modalOpen":"Modal--open","Modal__Content":"Modal__Content","modalContent":"Modal__Content","Modal__Content--open":"Modal__Content--open","modalContentOpen":"Modal__Content--open","Modal__ExitBtn":"Modal__ExitBtn","modalExitBtn":"Modal__ExitBtn"};

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalPortal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_focus_lock__ = __webpack_require__(463);
var ModalPortal=function ModalPortal(_ref){var children=_ref.children;var modalRoot=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(document.createElement('div'));Object(__WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"])(function(){var root=modalRoot.current;document.body&&document.body.appendChild(root);return function(){return root.remove();};},[]);return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_focus_lock__["a" /* default */],null,children),modalRoot.current);};

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Lock__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoFocusInside__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MoveFocusInside__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FreeFocusInside__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FocusGuard__ = __webpack_require__(201);
/* unused harmony reexport AutoFocusInside */
/* unused harmony reexport MoveFocusInside */
/* unused harmony reexport FreeFocusInside */
/* unused harmony reexport InFocusGuard */






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Lock__["a" /* default */]);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_focus_lock__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Trap__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FocusGuard__ = __webpack_require__(201);










var RenderChildren = function RenderChildren(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", null, children);
};

RenderChildren.propTypes =  false ? {
  children: PropTypes.node.isRequired
} : {};
var Fragment = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment : RenderChildren;
var emptyArray = [];

var FocusLock =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(FocusLock, _Component);

  function FocusLock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      observed: undefined
    });

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onActivation", function () {
      _this.originalFocusedElement = _this.originalFocusedElement || document && document.activeElement;

      if (_this.state.observed && _this.props.onActivation) {
        _this.props.onActivation(_this.state.observed);
      }

      _this.isActive = true;
    });

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onDeactivation", function () {
      _this.isActive = false;

      if (_this.props.returnFocus && _this.originalFocusedElement && _this.originalFocusedElement.focus) {
        _this.originalFocusedElement.focus();

        _this.originalFocusedElement = null;
      }

      if (_this.props.onDeactivation) {
        _this.props.onDeactivation(_this.state.observed);
      }
    });

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onFocus", function (event) {
      if (_this.isActive) {
        Object(__WEBPACK_IMPORTED_MODULE_7__Trap__["c" /* onFocus */])(event);
      }
    });

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onBlur", __WEBPACK_IMPORTED_MODULE_7__Trap__["b" /* onBlur */]);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setObserveNode", function (observed) {
      if (_this.state.observed !== observed) {
        _this.setState({
          observed: observed
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "isActive", false);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "originalFocusedElement", null);

    return _this;
  }

  var _proto = FocusLock.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        noFocusGuards = _this$props.noFocusGuards,
        persistentFocus = _this$props.persistentFocus,
        autoFocus = _this$props.autoFocus,
        allowTextSelection = _this$props.allowTextSelection,
        group = _this$props.group,
        className = _this$props.className,
        whiteList = _this$props.whiteList,
        _this$props$shards = _this$props.shards,
        shards = _this$props$shards === void 0 ? emptyArray : _this$props$shards,
        _this$props$as = _this$props.as,
        Container = _this$props$as === void 0 ? 'div' : _this$props$as,
        _this$props$lockProps = _this$props.lockProps,
        containerProps = _this$props$lockProps === void 0 ? {} : _this$props$lockProps;
    var observed = this.state.observed;

    if (false) {
      if (typeof allowTextSelection !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('React-Focus-Lock: allowTextSelection is deprecated and enabled by default');
      }
    }

    var lockProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()((_extends2 = {}, _extends2[__WEBPACK_IMPORTED_MODULE_6_focus_lock__["a" /* constants */].FOCUS_DISABLED] = disabled && 'disabled', _extends2[__WEBPACK_IMPORTED_MODULE_6_focus_lock__["a" /* constants */].FOCUS_GROUP] = group, _extends2), containerProps);

    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Fragment, null, hasLeadingGuards && [__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      key: "guard-first",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: __WEBPACK_IMPORTED_MODULE_8__FocusGuard__["a" /* hiddenGuard */]
    }), // nearest focus guard
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 1,
      style: __WEBPACK_IMPORTED_MODULE_8__FocusGuard__["a" /* hiddenGuard */]
    })], __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Container, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      ref: this.setObserveNode
    }, lockProps, {
      className: className,
      onBlur: this.onBlur,
      onFocus: this.onFocus
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Trap__["a" /* default */], {
      observed: observed,
      disabled: disabled,
      persistentFocus: persistentFocus,
      autoFocus: autoFocus,
      whiteList: whiteList,
      shards: shards,
      onActivation: this.onActivation,
      onDeactivation: this.onDeactivation
    }), children), hasTailingGuards && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: __WEBPACK_IMPORTED_MODULE_8__FocusGuard__["a" /* hiddenGuard */]
    }));
  };

  return FocusLock;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FocusLock.propTypes =  false ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  returnFocus: PropTypes.bool,
  noFocusGuards: PropTypes.bool,
  allowTextSelection: PropTypes.bool,
  autoFocus: PropTypes.bool,
  persistentFocus: PropTypes.bool,
  group: PropTypes.string,
  className: PropTypes.string,
  whiteList: PropTypes.func,
  shards: PropTypes.arrayOf(PropTypes.any),
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  lockProps: PropTypes.object,
  onActivation: PropTypes.func,
  onDeactivation: PropTypes.func
} : {};
FocusLock.defaultProps = {
  disabled: false,
  returnFocus: false,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (FocusLock);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
  attach: function attach() {},
  detach: function detach() {}
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isVisible */
/* unused harmony export notHiddenInput */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCommonParent; });
/* unused harmony export filterFocusable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTabbableNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllTabbableNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parentAutofocusables; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabOrder__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabUtils__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(39);




var isElementHidden = function isElementHidden(computedStyle) {
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};

var isVisible = function isVisible(node) {
  return !node || node === document || node.nodeType === Node.DOCUMENT_NODE || !isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode);
};

var notHiddenInput = function notHiddenInput(node) {
  return !((node.tagName === 'INPUT' || node.tagName === 'BUTTON') && (node.type === 'hidden' || node.disabled));
};

var getParents = function getParents(node) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  parents.push(node);
  if (node.parentNode) {
    getParents(node.parentNode, parents);
  }
  return parents;
};

var getCommonParent = function getCommonParent(nodea, nodeb) {
  var parentsA = getParents(nodea);
  var parentsB = getParents(nodeb);

  for (var i = 0; i < parentsA.length; i += 1) {
    var currentParent = parentsA[i];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};

var filterFocusable = function filterFocusable(nodes) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__array__["c" /* toArray */])(nodes).filter(function (node) {
    return isVisible(node);
  }).filter(function (node) {
    return notHiddenInput(node);
  });
};

var getTabbableNodes = function getTabbableNodes(topNodes, withGuards) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__tabOrder__["a" /* orderByTabIndex */])(filterFocusable(Object(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["a" /* getFocusables */])(topNodes, withGuards)), true, withGuards);
};

var getAllTabbableNodes = function getAllTabbableNodes(topNodes) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__tabOrder__["a" /* orderByTabIndex */])(filterFocusable(Object(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["a" /* getFocusables */])(topNodes)), false);
};

var parentAutofocusables = function parentAutofocusables(topNode) {
  return filterFocusable(Object(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["b" /* getParentAutofocusables */])(topNode));
};

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tabSort */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderByTabIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(39);


var tabSort = function tabSort(a, b) {
  var tabDiff = a.tabIndex - b.tabIndex;
  var indexDiff = a.index - b.index;

  if (tabDiff) {
    if (!a.tabIndex) return 1;
    if (!b.tabIndex) return -1;
  }

  return tabDiff || indexDiff;
};

var orderByTabIndex = function orderByTabIndex(nodes, filterNegative, keepGuards) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__array__["c" /* toArray */])(nodes).map(function (node, index) {
    return {
      node: node,
      index: index,
      tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
    };
  }).filter(function (data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFocusables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getParentAutofocusables; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabbables__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(83);




var queryTabbables = __WEBPACK_IMPORTED_MODULE_0__tabbables__["a" /* default */].join(',');
var queryGuardTabbables = queryTabbables + ', [data-focus-guard]';

var getFocusables = function getFocusables(parents, withGuards) {
  return parents.reduce(function (acc, parent) {
    return acc.concat(
    // add all tabbables inside
    Object(__WEBPACK_IMPORTED_MODULE_1__array__["c" /* toArray */])(parent.querySelectorAll(withGuards ? queryGuardTabbables : queryTabbables)),
    // add if node is tabble itself
    parent.parentNode ? Object(__WEBPACK_IMPORTED_MODULE_1__array__["c" /* toArray */])(parent.parentNode.querySelectorAll(__WEBPACK_IMPORTED_MODULE_0__tabbables__["a" /* default */].join(','))).filter(function (node) {
      return node === parent;
    }) : []);
  }, []);
};

var getParentAutofocusables = function getParentAutofocusables(parent) {
  var parentFocus = parent.querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_2__constants__["FOCUS_AUTO"] + ']');
  return Object(__WEBPACK_IMPORTED_MODULE_1__array__["c" /* toArray */])(parentFocus).map(function (node) {
    return getFocusables([node]);
  }).reduce(function (acc, nodes) {
    return acc.concat(nodes);
  }, []);
};

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]']);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pickFocusable; });
var isRadio = function isRadio(node) {
  return node.tagName === 'INPUT' && node.type === 'radio';
};

var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(isRadio).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};

var pickFirstFocus = function pickFirstFocus(nodes) {
  if (nodes[0] && nodes.length > 1) {
    if (isRadio(nodes[0]) && nodes[0].name) {
      return findSelectedRadio(nodes[0], nodes);
    }
  }
  return nodes[0];
};

var pickFocusable = function pickFocusable(nodes, index) {
  if (nodes.length > 1) {
    if (isRadio(nodes[index]) && nodes[index].name) {
      return nodes.indexOf(findSelectedRadio(nodes[index], nodes));
    }
  }
  return index;
};

/* harmony default export */ __webpack_exports__["a"] = (pickFirstFocus);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_all_affected__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(39);



var focusInFrame = function focusInFrame(frame) {
  return frame === document.activeElement;
};

var focusInsideIframe = function focusInsideIframe(topNode) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayFind */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["c" /* toArray */])(topNode.querySelectorAll('iframe')), focusInFrame);
};

var focusInside = function focusInside(topNode) {
  var activeElement = document && document.activeElement;

  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_all_affected__["a" /* default */])(topNode).reduce(function (result, node) {
    return result || node.contains(activeElement) || focusInsideIframe(node);
  }, false);
};

/* harmony default export */ __webpack_exports__["a"] = (focusInside);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(83);



var focusIsHidden = function focusIsHidden() {
  return document && Object(__WEBPACK_IMPORTED_MODULE_0__utils_array__["c" /* toArray */])(document.querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_1__constants__["FOCUS_ALLOW"] + ']')).some(function (node) {
    return node.contains(document.activeElement);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (focusIsHidden);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export focusOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__focusMerge__ = __webpack_require__(199);


var focusOn = function focusOn(target) {
  target.focus();
  if (target.contentWindow) {
    target.contentWindow.focus();
  }
};

var guardCount = 0;
var lockDisabled = false;

/* harmony default export */ __webpack_exports__["a"] = (function (topNode, lastNode) {
  var focusable = Object(__WEBPACK_IMPORTED_MODULE_0__focusMerge__["a" /* default */])(topNode, lastNode);

  if (lockDisabled) {
    return;
  }

  if (focusable) {
    if (guardCount > 2) {
      // eslint-disable-next-line no-console
      console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
      lockDisabled = true;
      setTimeout(function () {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node);
    guardCount--;
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onBlur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onFocus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_clientside_effect__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_lock__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(84);






var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || Object(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["d" /* focusIsHidden */])();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;

  do {
    var item = allNodes[i];

    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }

      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);

  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}

var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus,
        shards = _lastActiveTrap.shards;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));

      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutsideWindow || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(Object(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["c" /* focusInside */])(workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              activeElement.blur();
              document.body.focus();
            } else {
              result = Object(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["b" /* default */])(workingArea, lastActiveFocus);
              lastPortaledElement = {};
            }
          }

          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }

      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = Object(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["e" /* getFocusabledIn */])(workingArea);
        var focusedItem = allNodes.find(function (_ref) {
          var node = _ref.node;
          return node === newActiveElement;
        });

        if (focusedItem) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
                node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          var focusedIndex = allNodes.indexOf(focusedItem);
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = function onBlur() {
  return Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* deferAction */])(activateTrap);
};
var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

var FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus
  }, children);
};

FocusTrap.propTypes =  false ? {
  children: PropTypes.node.isRequired
} : {};

var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = true;
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap, true);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap, true);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  }).slice(-1)[0];
}

function handleStateChangeOnClient(trap) {
  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.onActivation === lastTrap.onActivation;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    activateTrap(true);
    Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* deferAction */])(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_clientside_effect__["a" /* default */])(reducePropsToState, handleStateChangeOnClient)(FocusWatcher));

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (false) {
    if (typeof reducePropsToState !== 'function') {
      throw new Error('Expected reducePropsToState to be a function.');
    }

    if (typeof handleStateChangeOnClient !== 'function') {
      throw new Error('Expected handleStateChangeOnClient to be a function.');
    }
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (false) {
      if (typeof WrappedComponent !== 'function') {
        throw new Error('Expected WrappedComponent to be a React component.');
      }
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (withSideEffect);


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(477);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(478);


function _toPropertyKey(arg) {
  var key = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(200);

function _toPrimitive(input, hint) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_lock__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(84);






var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4__util__["b" /* inlineProp */])(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["a" /* constants */].FOCUS_AUTO, !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes =  false ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
} : {};
AutoFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* unused harmony default export */ var _unused_webpack_default_export = (AutoFocusInside);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_focus_lock__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(84);









var MoveFocusInside =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(MoveFocusInside, _Component);

  function MoveFocusInside() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setObserveNode", function (ref) {
      _this.observed = ref;

      _this.moveFocus();
    });

    return _this;
  }

  var _proto = MoveFocusInside.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.moveFocus();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.disabled && !this.props.disabled) {
      this.moveFocus();
    }
  };

  _proto.moveFocus = function moveFocus() {
    var observed = this.observed;

    if (!this.props.disabled && observed) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_6_focus_lock__["c" /* focusInside */])(observed)) {
        Object(__WEBPACK_IMPORTED_MODULE_6_focus_lock__["b" /* default */])(observed, null);
      }
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        className = _this$props.className;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7__util__["b" /* inlineProp */])(__WEBPACK_IMPORTED_MODULE_6_focus_lock__["a" /* constants */].FOCUS_AUTO, !disabled), {
      ref: this.setObserveNode,
      className: className
    }), children);
  };

  return MoveFocusInside;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(MoveFocusInside, "defaultProps", {
  disabled: false,
  className: undefined
});


MoveFocusInside.propTypes =  false ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
} : {};

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_lock__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(84);






var FreeFocusInside = function FreeFocusInside(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4__util__["b" /* inlineProp */])(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["a" /* constants */].FOCUS_ALLOW, true), {
    className: className
  }), children);
};

FreeFocusInside.propTypes =  false ? {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
} : {};
FreeFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* unused harmony default export */ var _unused_webpack_default_export = (FreeFocusInside);

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"c-overlay":"c-overlay","cOverlay":"c-overlay","c-overlay--visible":"c-overlay--visible","cOverlayVisible":"c-overlay--visible","c-overlay--fullpage":"c-overlay--fullpage","cOverlayFullpage":"c-overlay--fullpage","c-overlay--transparent":"c-overlay--transparent","cOverlayTransparent":"c-overlay--transparent","c-overlay--dismissable":"c-overlay--dismissable","cOverlayDismissable":"c-overlay--dismissable","c-tooltip":"c-tooltip","cTooltip":"c-tooltip","MediaViewer__list-item--captioned":"MediaViewer__list-item--captioned","mediaViewerListItemCaptioned":"MediaViewer__list-item--captioned","MediaViewer__tooltip":"MediaViewer__tooltip","mediaViewerTooltip":"MediaViewer__tooltip","c-tooltip--top":"c-tooltip--top","cTooltipTop":"c-tooltip--top","c-tooltip--right":"c-tooltip--right","cTooltipRight":"c-tooltip--right","c-tooltip--bottom":"c-tooltip--bottom","cTooltipBottom":"c-tooltip--bottom","c-tooltip--left":"c-tooltip--left","cTooltipLeft":"c-tooltip--left","c-badge":"c-badge","cBadge":"c-badge","c-badge--ghost":"c-badge--ghost","cBadgeGhost":"c-badge--ghost","c-badge--rounded":"c-badge--rounded","cBadgeRounded":"c-badge--rounded","c-badge--brand":"c-badge--brand","cBadgeBrand":"c-badge--brand","c-badge--info":"c-badge--info","cBadgeInfo":"c-badge--info","c-badge--warning":"c-badge--warning","cBadgeWarning":"c-badge--warning","c-badge--success":"c-badge--success","cBadgeSuccess":"c-badge--success","c-badge--error":"c-badge--error","cBadgeError":"c-badge--error","MediaViewer__list":"MediaViewer__list","mediaViewerList":"MediaViewer__list","MediaViewer__list-item":"MediaViewer__list-item","mediaViewerListItem":"MediaViewer__list-item","MediaViewer__list-item__button":"MediaViewer__list-item__button","mediaViewerListItemButton":"MediaViewer__list-item__button","MediaViewer__list-item__button__play-icon":"MediaViewer__list-item__button__play-icon","mediaViewerListItemButtonPlayIcon":"MediaViewer__list-item__button__play-icon","MediaViewer__thumbnail":"MediaViewer__thumbnail","mediaViewerThumbnail":"MediaViewer__thumbnail"};

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VerifiedBuyer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VerifiedReviewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StaffReviewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpertReviewer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var VerifiedBuyer=function VerifiedBuyer(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({viewBox:'0 0 500 500'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('circle',{fill:'#8CC541',cx:'250.9',cy:'250',r:'250'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#FFF',d:'M264.2 101.9h-23.6c-3.7 0-6.7 3-6.7 6.7v29.2c-35.1 7.1-57.4 30.7-57.4 61.1 0 16.3 6.3 29.7 19.1 40.9 10.5 9.1 25.7 17.1 48 25 27.4 10.1 38.5 20.1 38.5 34.7 0 7.5-3.4 14.1-9.8 18.9-7 5.3-17.2 8.2-28.7 8.2-18 0-36.7-5-51.3-13.9-1.1-.6-2.3-1-3.5-1-.7 0-1.4.1-2.1.4-1.9.6-3.4 2-4.1 3.9l-9.1 23.1c-1.2 3-.1 6.3 2.6 8.1 13.3 8.6 34.3 14.6 55.1 16v28.4c0 3.7 3 6.7 6.7 6.7h23.9c3.7 0 6.7-3 6.7-6.7v-30.2c17.5-3.6 32.2-11.2 42.8-22.2 11.1-11.5 17.2-26.4 17.2-41.9 0-16.9-5.5-30.7-16.7-42.3-10.2-10.5-25-19.1-46.6-27.1-17.6-6.6-27.8-11.5-34.1-16.6-6.1-4.8-8.6-9.6-8.6-16.5 0-10.6 8.8-23 33.6-23 23.6 0 38.5 7.7 44.8 11 1 .5 2 .7 3.1.7.8 0 1.5-.1 2.3-.4 1.8-.6 3.2-2 3.9-3.7l9.5-22.7c1.3-3.2 0-6.9-3-8.5-13.5-7.2-28.5-11.3-45.9-12.5v-27.1c0-3.7-2.9-6.7-6.6-6.7z'}));};var VerifiedReviewer=function VerifiedReviewer(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({viewBox:'0 0 500 500'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('title',null,'Verified Reviewer'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('circle',{fill:'#75C6B8',cx:'250',cy:'250',r:'250'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#FFF',d:'M395.1 166.5L368.7 140c-3.6-3.6-8-5.4-13.2-5.4-5.2 0-9.6 1.8-13.2 5.4L214.8 267.7l-57.1-57.3c-3.6-3.6-8-5.4-13.2-5.4-5.2 0-9.6 1.8-13.2 5.4l-26.4 26.4c-3.6 3.6-5.4 8-5.4 13.2 0 5.2 1.8 9.6 5.4 13.2l70.3 70.3 26.4 26.4c3.6 3.6 8 5.4 13.2 5.4 5.2 0 9.6-1.8 13.2-5.4l26.4-26.4L395 192.9c3.6-3.6 5.4-8 5.4-13.2.2-5.2-1.7-9.6-5.3-13.2z'}));};var StaffReviewer=function StaffReviewer(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 500 500'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('title',null,'Staff Reviewer'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('circle',{fill:'#FAB718',cx:'250',cy:'250',r:'250'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#FFF',d:'M204 293.6c1.4 10.2 4.3 17.7 8.5 22.8 7.7 9.1 20.9 13.7 39.6 13.7 11.2 0 20.3-1.2 27.3-3.6 13.2-4.6 19.9-13.2 19.9-25.8 0-7.3-3.2-13-9.7-17-6.5-3.9-16.8-7.4-30.9-10.4l-24.1-5.3c-23.7-5.2-39.9-10.9-48.7-17-15-10.3-22.5-26.3-22.5-48.1 0-19.9 7.3-36.4 22-49.6 14.7-13.2 36.2-19.8 64.6-19.8 23.7 0 43.9 6.2 60.7 18.6 16.7 12.4 25.5 30.4 26.3 54.1h-44.6c-.8-13.4-6.8-22.9-17.9-28.5-7.4-3.7-16.6-5.6-27.7-5.6-12.3 0-22.1 2.4-29.4 7.2-7.3 4.8-11 11.6-11 20.2 0 7.9 3.6 13.9 10.8 17.8 4.6 2.6 14.5 5.7 29.5 9.2l39 9.2c17.1 4 29.9 9.4 38.4 16.1 13.2 10.5 19.9 25.6 19.9 45.4 0 20.3-7.9 37.2-23.5 50.6-15.7 13.4-37.9 20.1-66.5 20.1-29.3 0-52.3-6.6-69-19.8-16.8-13.2-25.1-31.4-25.1-54.5H204z'}));};var ExpertReviewer=function ExpertReviewer(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 500 500'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('title',null,'Expert Reviewer'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('circle',{fill:'#54C7E6',cx:'250',cy:'250',r:'250'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#FFF',d:'M334.9 179.3H217.3v47.2h108v38.6h-108v57.2h123.1v40H171.9V140h163v39.3z'}));};

/***/ }),
/* 484 */
/***/ (function(module, exports) {

var MILLISECONDS_IN_MINUTE = 60000

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime())
  var baseTimezoneOffset = date.getTimezoneOffset()
  date.setSeconds(0, 0)
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var startOfYear = __webpack_require__(486)
var differenceInCalendarDays = __webpack_require__(487)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(128)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var startOfISOWeek = __webpack_require__(129)
var startOfISOYear = __webpack_require__(490)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(202)
var startOfISOWeek = __webpack_require__(129)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(86)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),
/* 492 */
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(494)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),
/* 494 */
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ReviewSection__Comments":"ReviewSection__Comments","reviewSectionComments":"ReviewSection__Comments","ReviewSection__badge__label":"ReviewSection__badge__label","reviewSectionBadgeLabel":"ReviewSection__badge__label","ReviewSection__badge__icon":"ReviewSection__badge__icon","reviewSectionBadgeIcon":"ReviewSection__badge__icon","ReviewSection__h1":"ReviewSection__h1","reviewSectionH1":"ReviewSection__h1","ReviewSection__w1":"ReviewSection__w1","reviewSectionW1":"ReviewSection__w1"};

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AttributeList":"AttributeList","attributeList":"AttributeList","AttributeList__name":"AttributeList__name","attributeListName":"AttributeList__name","AttributeList__value":"AttributeList__value","attributeListValue":"AttributeList__value","AttributeList__divider":"AttributeList__divider","attributeListDivider":"AttributeList__divider","AttributeList__divider__label":"AttributeList__divider__label","attributeListDividerLabel":"AttributeList__divider__label"};

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UgcMetaInfo__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthorInfo__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReviewSection__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CollapsedBlock__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Ugc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ContentSection_UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_UgcLinkContext__ = __webpack_require__(67);
var provideCollapsedContent=function provideCollapsedContent(ugc,options,collapsedContentProps){var parentUgc=__WEBPACK_IMPORTED_MODULE_5__models_Ugc__["a" /* default */].getRelatedItemByType(ugc,'Review');if(!parentUgc/* || options.program === 'client'*/){return null;}var onClick=collapsedContentProps.onClick,open=collapsedContentProps.open;var MetaInfoComponent=options.program==='pwr'?__WEBPACK_IMPORTED_MODULE_1__UgcMetaInfo__["c" /* PwrMediaUgcMetaInfo */]:__WEBPACK_IMPORTED_MODULE_1__UgcMetaInfo__["a" /* ClientMediaUgcMetaInfo */];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__CollapsedBlock__["a" /* default */],{label:'Original Review',open:open,onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mh4 mv3'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ReviewSection__["a" /* default */].Header,{ugc:parentUgc,options:options})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ReviewSection__["a" /* default */].Content,{ugc:parentUgc,options:options}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MetaInfoComponent,{key:'review-embed-attr',model:ugc,parentModel:parentUgc}),options.program==='client'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_containers_UgcLinkContext__["b" /* default */].Consumer,null,function(linker){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mh4 dib'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_containers_UgcLinkContext__["a" /* UgcLinkButton */],{href:linker(parentUgc),label:'View Original Review'}));}));};var ResponseSection={Header:function Header(props){return null;},Content:function Content(_ref){var ugc=_ref.ugc;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mb4 mh4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'mb0 f3'},ugc.catalog.group_name+' Response'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__AuthorInfo__["a" /* default */],{ugc:ugc}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_ContentSection_UserGeneratedTextContainer__["b" /* default */],{text:ugc.text})));},getRelatedContent:function getRelatedContent(ugc,option){return null;},provideCollapsedContent:provideCollapsedContent};/* harmony default export */ __webpack_exports__["a"] = (ResponseSection);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var defaultLabel='Meta Info';var toggleButtonClassName='outline-transparent input-reset button-reset lh-solid pointer flex flex-row bg-transparent b--none blue db w-100 tl ph4 pv3 ContentSection__meta-toggle';var MetaInfoToggle=function MetaInfoToggle(_ref){var onClick=_ref.onClick,_ref$label=_ref.label,label=_ref$label===undefined?defaultLabel:_ref$label;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'bt bw1 b--light-gray pv1'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{className:toggleButtonClassName,type:'button',onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'db','data-translate':true},label),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i',{className:'fa fa-chevron-down','aria-hidden':'true',style:{marginLeft:'auto'}})));};/* harmony default export */ __webpack_exports__["a"] = (MetaInfoToggle);

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"QASection":"QASection","qaSection":"QASection","QASection__content":"QASection__content","qaSectionContent":"QASection__content","QASection__content__heading":"QASection__content__heading","qaSectionContentHeading":"QASection__content__heading","QASection__icon":"QASection__icon","qaSectionIcon":"QASection__icon"};

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VideoSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthorInfo__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReviewSection__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UgcMetaInfo__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CollapsedBlock__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_UgcLinkContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MediaSection_scss__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MediaSection_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MediaSection_scss__);
var Header=function Header(props){var ugc=props.ugc,program=props.options.program;var parentUgc=ugc.getReview();var isAttachment=Boolean(parentUgc);if(isAttachment===false){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__AuthorInfo__["a" /* default */],{ugc:ugc});}return program==='pwr'?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__AuthorInfo__["a" /* default */],{ugc:ugc});};var getRelatedContent=function getRelatedContent(ugc,options){var caption=ugc.caption;if(!caption){return null;}return[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'dt center mv4 ph4',key:'caption'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('strong',{className:__WEBPACK_IMPORTED_MODULE_7__MediaSection_scss___default.a.mediaSectionCaptionLabel},'Caption:'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_7__MediaSection_scss___default.a.mediaSectionCaptionText},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__UserGeneratedTextContainer__["b" /* default */],{'data-key':'caption',text:caption})))];};var provideCollapsedContent=function provideCollapsedContent(ugc,options,collapsedContentProps){var parentUgc=ugc.getReview();if(!parentUgc/* || options.program === 'client'*/){return null;}var onClick=collapsedContentProps.onClick,open=collapsedContentProps.open;var MetaInfoComponent=options.program==='pwr'?__WEBPACK_IMPORTED_MODULE_3__UgcMetaInfo__["c" /* PwrMediaUgcMetaInfo */]:__WEBPACK_IMPORTED_MODULE_3__UgcMetaInfo__["a" /* ClientMediaUgcMetaInfo */];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__CollapsedBlock__["a" /* default */],{label:'Original Review',open:open,onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mh4 mv3'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ReviewSection__["a" /* default */].Header,{ugc:parentUgc,options:options})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ReviewSection__["a" /* default */].Content,{ugc:parentUgc,options:options}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MetaInfoComponent,{key:'review-embed-attr',model:ugc,parentModel:parentUgc}),options.program==='client'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_containers_UgcLinkContext__["b" /* default */].Consumer,null,function(linker){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mh4 dib'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_containers_UgcLinkContext__["a" /* UgcLinkButton */],{href:linker(parentUgc),label:'View Original Review'}));}));};var ImageSection={Header:Header,getRelatedContent:getRelatedContent,provideCollapsedContent:provideCollapsedContent,Content:function Content(props){var _ref=props.ugc,urlSet=_ref.urlSet,caption=_ref.caption;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ma4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img',{src:urlSet.large,alt:caption,className:__WEBPACK_IMPORTED_MODULE_7__MediaSection_scss___default.a.mediaSectionImage}));}};var VideoSection={Header:Header,getRelatedContent:getRelatedContent,provideCollapsedContent:provideCollapsedContent,Content:function Content(props){var _ref2=props.ugc,urlSet=_ref2.urlSet,accessType=_ref2.accessType;if(accessType==='upload'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ma4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('video',{height:'auto',width:'100%',controls:true,className:__WEBPACK_IMPORTED_MODULE_7__MediaSection_scss___default.a.mediaSectionNativeVideo},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('source',{src:urlSet.raw,type:'video/mp4'})));}else if(accessType==='youtube'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ma4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('iframe',{height:'auto',width:'100%',src:urlSet.raw,style:{border:0,minHeight:360},title:'Youtube embed'}));}return null;}};

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SocialCollectionSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons_InstagramLogo__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaSection_scss__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaSection_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MediaSection_scss__);
var Header=function Header(){return null;};var getRelatedContent=function getRelatedContent(ugc,options){var caption=ugc.caption,author=ugc.author,created_date=ugc.created_date;if(!caption){return null;}return[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mv4 ph4 flex',key:'caption2'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_Icons_InstagramLogo__["a" /* default */],{className:'w2 h2 mr2 mv1 flex-none'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex flex-column'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('strong',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__UserGeneratedTextContainer__["b" /* default */],{'data-key':'author',text:author})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'gray'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__UserGeneratedTextContainer__["b" /* default */],{'data-key':'caption',text:caption})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('small',{'data-key':'created_date',className:'lh-copy silver'},formatDate(created_date))))];};var provideCollapsedContent=function provideCollapsedContent(ugc,options,collapsedContentProps){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null);};var SocialCollectionSection={Header:Header,getRelatedContent:getRelatedContent,provideCollapsedContent:provideCollapsedContent,Content:function Content(props){var _props$ugc=props.ugc,urlSet=_props$ugc.urlSet,caption=_props$ugc.caption,ugc_archetype=_props$ugc.ugc_archetype;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ma4'},ugc_archetype==='Video'?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('video',{height:'auto',width:'100%',controls:true,className:__WEBPACK_IMPORTED_MODULE_4__MediaSection_scss___default.a.mediaSectionNativeVideo},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('source',{src:urlSet.raw,type:'video/mp4'})):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img',{src:urlSet.large,alt:caption,className:__WEBPACK_IMPORTED_MODULE_4__MediaSection_scss___default.a.mediaSectionImage}));}};function formatDate(isoDateString){return __WEBPACK_IMPORTED_MODULE_1_date_fns_distance_in_words_strict___default()(new Date().toISOString(),isoDateString,{addSuffix:true});}/* harmony default export */ __webpack_exports__["a"] = (SocialCollectionSection);

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(503)
var parse = __webpack_require__(9)
var differenceInSeconds = __webpack_require__(504)
var enLocale = __webpack_require__(203)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var unit
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = mathPartial(seconds / 60) - offset
  var hours, days, months, years

  if (options.unit) {
    unit = String(options.unit)
  } else {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60)
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR)
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

module.exports = distanceInWordsStrict


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareDesc


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(505)

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var InstagramLogo=function InstagramLogo(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 256 256'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#0A0A08',d:'M128 23.1c34.2 0 38.2.1 51.7.7 12.5.6 19.3 2.7 23.8 4.4 6 2.3 10.2 5.1 14.7 9.6s7.3 8.7 9.6 14.7c1.8 4.5 3.8 11.3 4.4 23.8.6 13.5.7 17.5.7 51.7s-.1 38.2-.7 51.7c-.6 12.5-2.7 19.3-4.4 23.8-2.3 6-5.1 10.2-9.6 14.7s-8.7 7.3-14.7 9.6c-4.5 1.8-11.3 3.8-23.8 4.4-13.5.6-17.5.7-51.7.7s-38.2-.1-51.7-.7c-12.5-.6-19.3-2.7-23.8-4.4-6-2.3-10.2-5.1-14.7-9.6s-7.3-8.7-9.6-14.7c-1.8-4.5-3.8-11.3-4.4-23.8-.6-13.5-.7-17.5-.7-51.7s.1-38.2.7-51.7c.6-12.5 2.7-19.3 4.4-23.8 2.3-6 5.1-10.2 9.6-14.7s8.7-7.3 14.7-9.6c4.5-1.8 11.3-3.8 23.8-4.4 13.5-.6 17.5-.7 51.7-.7M128 0C93.2 0 88.9.1 75.2.8c-13.6.6-22.9 2.8-31 5.9-8.4 3.3-15.6 7.6-22.7 14.8S10 35.7 6.7 44.2C3.5 52.3 1.4 61.6.8 75.3.1 88.9 0 93.2 0 128s.1 39.1.8 52.8c.6 13.6 2.8 22.9 5.9 31.1 3.3 8.4 7.6 15.6 14.8 22.7 7.1 7.1 14.3 11.5 22.7 14.8 8.1 3.2 17.4 5.3 31.1 5.9 13.7.6 18 .8 52.8.8s39.1-.1 52.8-.8c13.6-.6 22.9-2.8 31.1-5.9 8.4-3.3 15.6-7.6 22.7-14.8 7.1-7.1 11.5-14.3 14.8-22.7 3.2-8.1 5.3-17.4 5.9-31.1.6-13.7.8-18 .8-52.8s-.1-39.1-.8-52.8c-.6-13.6-2.8-22.9-5.9-31.1-3.3-8.4-7.6-15.6-14.8-22.7S220.3 10 211.8 6.7c-8.1-3.2-17.4-5.3-31.1-5.9C167.1.1 162.8 0 128 0zm0 62.3c-36.3 0-65.7 29.4-65.7 65.7s29.4 65.7 65.7 65.7 65.7-29.4 65.7-65.7-29.4-65.7-65.7-65.7zm0 108.4c-23.6 0-42.7-19.1-42.7-42.7s19.1-42.7 42.7-42.7 42.7 19.1 42.7 42.7-19.1 42.7-42.7 42.7zm83.7-111c0 8.5-6.9 15.4-15.4 15.4S181 68.2 181 59.7s6.9-15.4 15.4-15.4 15.3 6.9 15.3 15.4z'}));};/* harmony default export */ __webpack_exports__["a"] = (InstagramLogo);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BrandAttribution;
/* harmony export (immutable) */ __webpack_exports__["b"] = RetailerAttribution;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IMAGE_HOST='//'+(""||'')+'images.powerreviews.com';var ClientAttribution=function(_React$PureComponent){_inherits(ClientAttribution,_React$PureComponent);function ClientAttribution(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientAttribution);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientAttribution.__proto__||Object.getPrototypeOf(ClientAttribution)).call.apply(_ref,[this].concat(args))),_this),_this.showDefaultBrandImage=function(){if(_this.brandImage){_this.brandImage.src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientAttribution,[{key:'render',value:function render(){var _this2=this;var imageStyle={maxWidth:'60px',height:'auto'};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex bg-white items-center pa3'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img',{style:imageStyle,src:IMAGE_HOST+'/images_merchants/logos/'+this.props.clientId+'_logo_large.png',alt:this.props.clientName,ref:function ref(c){return _this2.brandImage=c;},onError:this.showDefaultBrandImage})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ml2'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'f6 gray arial'},this.props.copy),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'f5 b brandon'},this.props.clientName?this.props.clientName:'PowerReviews Network')));}}]);return ClientAttribution;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);function BrandAttribution(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClientAttribution,{clientId:props.clientId,clientName:props.clientName,copy:getUgcTypeLabel(props.ugctype)+' from'});}function RetailerAttribution(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClientAttribution,{clientId:props.clientId,clientName:props.clientName,copy:props.ugctype+' Source'});}/*
 * We present friendlier ugctype labels by mapping
 * BrandAnswer & BrandMerchantResponse to Answer & Response respectively
 */function getUgcTypeLabel(ugctype){if(ugctype==='BrandAnswer'){return'Answer';}else if(ugctype==='BrandMerchantResponse'){return'Response';}else{return ugctype;}}

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PowerReviewsModerationCard__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__PowerReviewsModerationCard__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__PowerReviewsModerationCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientModerationCard__ = __webpack_require__(524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ClientModerationCard__["a"]; });
/* unused harmony reexport ClientModerationCardSection */


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_CardAlert__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PowerReviewsModerationCard_scss__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PowerReviewsModerationCard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PowerReviewsModerationCard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SectionSeparator__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActionAsideUnmoderated__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ActionAsideModerated__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ActionAsideSecondOpinion__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SecondOpinionCard__ = __webpack_require__(517);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isPowerReviewsModerated=__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].isPowerReviewsModerated,getActionableObservations=__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].getActionableObservations;var renderObservationButtons=function renderObservationButtons(observations,onClick){var selectedCount=0;var standardObservations=observations.filter(function(o){return o.custom_observation===false;});var customObservations=observations.filter(function(o){return o.custom_observation===true;});var standardObservationButtonsObject=createObservationButtons(standardObservations,onClick,selectedCount);var standardObservationButtons=standardObservationButtonsObject.buttons;var customObservationButtonsObject=createObservationButtons(customObservations,onClick,selectedCount);var customObservationButtons=customObservationButtonsObject.buttons;var totalSelectedCount=standardObservationButtonsObject.selectedCount+customObservationButtonsObject.selectedCount;return{totalSelectedCount:totalSelectedCount,standardObservationButtons:standardObservationButtons,customObservationButtons:customObservationButtons};};function createObservationButtons(observations,onClick,selectedCount){var observationButtons=observations.map(function(ob){var name=ob.name,observation_type_code=ob.observation_type_code;var existing=__WEBPACK_IMPORTED_MODULE_1_models__["e" /* Observation */].isSelected(ob);if(existing){selectedCount+=1;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Common__["h" /* ObservationButton */],{key:observation_type_code,name:name,observation_type_code:observation_type_code,onClick:onClick,existing:existing});});return{selectedCount:selectedCount,buttons:observationButtons};}var PowerReviewsModerationCard=function(_React$PureComponent){_inherits(PowerReviewsModerationCard,_React$PureComponent);function PowerReviewsModerationCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PowerReviewsModerationCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PowerReviewsModerationCard.__proto__||Object.getPrototypeOf(PowerReviewsModerationCard)).call.apply(_ref,[this].concat(args))),_this),_this.state={showSecondOpinionCard:false,escalationReason:''},_this.handleObservationChange=function(observation_type_code){var _this$props=_this.props,currentState=_this$props.moderationState,onChange=_this$props.onChange;var nextState=__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].toggleObservation(currentState,__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].PowerReviewsModerationContext,observation_type_code);onChange&&onChange(nextState);},_this.handleEscalationReasonChange=function(escalationReason){_this.setState({escalationReason:escalationReason});},_this.handleSubmit=function(){var _this$props2=_this.props,moderationState=_this$props2.moderationState,onSubmit=_this$props2.onSubmit;var _this$state=_this.state,escalationReason=_this$state.escalationReason,showSecondOpinionCard=_this$state.showSecondOpinionCard;var stateToSubmit=showSecondOpinionCard===true?__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].applySecondOpinion(moderationState,escalationReason):__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].applyPowerModeration(moderationState);_this.setState({showSecondOpinionCard:false},function(){onSubmit(stateToSubmit,__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].PowerReviewsModerationContext);});},_this.toggleSecondOpinionCard=function(){return _this.setState(function(prevState){return{showSecondOpinionCard:!prevState.showSecondOpinionCard};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PowerReviewsModerationCard,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.moderationState.getId()!==this.props.moderationState.getId()){this.setState({showSecondOpinionCard:false,escalationReason:''});}}},{key:'renderActionAside',value:function renderActionAside(props){var moderationState=props.moderationState,status=props.status,product=props.product,ugc=props.ugc;var isPwrModerated=isPowerReviewsModerated(moderationState);var secondOpinionRequired=__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].needsSecondOpinion(moderationState);var observations=getActionableObservations(moderationState,__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].PowerReviewsModerationContext);var merchantName=product.merchant.group_name;var _renderObservationBut=renderObservationButtons(observations,this.handleObservationChange),standardObservationButtons=_renderObservationBut.standardObservationButtons,customObservationButtons=_renderObservationBut.customObservationButtons,selectedCount=_renderObservationBut.totalSelectedCount;var actionAside=void 0;var pending=status==='pending';if(secondOpinionRequired){actionAside=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ActionAsideSecondOpinion__["a" /* default */],{pending:pending,onSubmit:this.handleSubmit,moderationState:moderationState,standardObservationButtons:standardObservationButtons,customObservationButtons:customObservationButtons,merchantName:merchantName});}else if(isPwrModerated){actionAside=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ActionAsideModerated__["a" /* default */],{pending:pending,onSubmit:this.handleSubmit,moderationState:moderationState,standardObservationButtons:standardObservationButtons,customObservationButtons:customObservationButtons,merchantName:merchantName});}else{actionAside=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ActionAsideUnmoderated__["a" /* default */],{pending:pending,selectedCount:selectedCount,ugcType:ugc.ugctype,onSubmit:this.handleSubmit,onSecondOpinionClick:this.toggleSecondOpinionCard,standardObservationButtons:standardObservationButtons,customObservationButtons:customObservationButtons,merchantName:merchantName});}return actionAside;}},{key:'toggleSubjectDetails',value:function toggleSubjectDetails(cb){if(this.productSection){this.productSection.toggleDetails(true);typeof cb==='function'&&cb();}}},{key:'toggleMeta',value:function toggleMeta(cb){if(this.contentSection){this.contentSection.toggleMeta(true);typeof cb==='function'&&cb();}}},{key:'showSecondOpinionCard',value:function showSecondOpinionCard(cb){if(this.state.showSecondOpinionCard===false){typeof cb==='function'&&cb();this.setState({showSecondOpinionCard:true});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,moderationState=_props.moderationState,product=_props.product,ugc=_props.ugc,status=_props.status;var isUpdatedUgc=ugc.old_ugc_id?true:false;var observations=getActionableObservations(moderationState,__WEBPACK_IMPORTED_MODULE_1_models__["d" /* ModerationState */].PowerReviewsModerationContext);var ugcId=moderationState.getUGCId();var pending=status==='pending';// TODO: we shouldn't need this if we trust action aside
if(this.state.showSecondOpinionCard){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_5__PowerReviewsModerationCard_scss__["powerModerationCard"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__SecondOpinionCard__["a" /* default */],{key:'em-'+ugcId,observations:observations,onObserve:this.handleObservationChange,onSubmit:this.handleSubmit,onClose:this.toggleSecondOpinionCard,reason:this.state.escalationReason,onReasonChange:this.handleEscalationReasonChange}));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_5__PowerReviewsModerationCard_scss__["powerModerationCard"]},pending===true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_5__PowerReviewsModerationCard_scss__["powerModerationCardOverlay"]}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_5__PowerReviewsModerationCard_scss__["powerModerationCardMain"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["n" /* ProductSection */],{model:product,key:product.subject_id,merchantName:true,brandName:true,ref:function ref(c){return _this2.productSection=c;}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mb4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__SectionSeparator__["a" /* default */],null)),isUpdatedUgc&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Common_CardAlert__["a" /* default */],null,'This review is an update to a previous review.'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["h" /* ContentSection */],{key:'cc-'+ugcId,model:ugc,program:'pwr',ref:function ref(c){return _this2.contentSection=c;}})),this.renderActionAside(this.props));}}]);return PowerReviewsModerationCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (PowerReviewsModerationCard);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Bell=function Bell(_ref){var style=_ref.style,width=_ref.width;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{width:"30px",height:"30px",viewBox:"0 0 40 40",version:"1.1",style:style},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"notifications",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"Growler-Notifications",transform:"translate(-100.000000, -729.000000)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"max-cha-width",transform:"translate(80.000000, 689.000000)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"Group-3"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"Icons/Tertiary/Alert",transform:"translate(20.000000, 40.000000)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"Page-1"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M20,0 C31.0457407,0 40,8.95425926 40,20 C40,31.0457407 31.0457407,40 20,40 C8.95425926,40 0,31.0457407 0,20 C0,8.95425926 8.95425926,0 20,0",id:"Fill-1",fill:"#EAEAE9"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M19.7530926,12.7160556 C19.7530926,12.7160556 25.6790185,12.9629074 25.6790185,18.6419815 L25.6790185,23.2099444 L26.5432778,25.3086481 L12.592537,25.3086481 L13.8271667,22.4692037 L13.8271667,17.5308704 C13.8271667,17.5308704 15.1851296,12.7160556 19.7530926,12.7160556",id:"Fill-3",fill:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M19.8117037,29.7242037 C20.9061481,29.7242037 21.7935556,28.8367963 21.7935556,27.7423519 L17.8298519,27.7423519 C17.8298519,28.8367963 18.7172593,29.7242037 19.8117037,29.7242037",id:"Fill-5",fill:"#757575"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M14.3296296,24.7211481 L14.857037,24.2063333 L14.857037,18.8239259 C14.857037,16.0920741 17.0798148,13.8691111 19.8116667,13.8691111 C22.5435185,13.8691111 24.7662963,16.0920741 24.7662963,18.8239259 L24.7662963,24.1955926 L25.3035185,24.7211481 L14.3296296,24.7211481 Z M20.7977778,11.9657778 L20.7977778,10.875963 C20.7977778,10.340037 20.3633333,9.90540741 19.8272222,9.90540741 C19.2911111,9.90540741 18.8564815,10.340037 18.8564815,10.875963 L18.8564815,11.9607778 C15.4831481,12.4292963 12.8751852,15.3244815 12.8751852,18.8239259 L12.8751852,23.3711481 L12.6457407,23.5946667 C11.707963,24.5081852 11.8290741,25.2920741 11.9848148,25.6772593 C12.1087037,25.983 12.5392593,26.6972593 13.8757407,26.703 L25.7572222,26.703 C27.087963,26.703 27.5224074,25.9868889 27.6472222,25.680037 C27.8040741,25.2939259 27.9268519,24.5102222 26.9883333,23.5967037 L26.7483333,23.3615185 L26.7483333,18.8239259 C26.7483333,15.3342963 24.1557407,12.4467037 20.7977778,11.9657778 Z",id:"Fill-7",fill:"#757575"}))))))));};/* harmony default export */ __webpack_exports__["a"] = (Bell);

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"c-overlay":"c-overlay","cOverlay":"c-overlay","PowerModerationCard__overlay":"PowerModerationCard__overlay","powerModerationCardOverlay":"PowerModerationCard__overlay","c-overlay--visible":"c-overlay--visible","cOverlayVisible":"c-overlay--visible","c-overlay--fullpage":"c-overlay--fullpage","cOverlayFullpage":"c-overlay--fullpage","c-overlay--transparent":"c-overlay--transparent","cOverlayTransparent":"c-overlay--transparent","c-overlay--dismissable":"c-overlay--dismissable","cOverlayDismissable":"c-overlay--dismissable","PowerModerationCard":"PowerModerationCard","powerModerationCard":"PowerModerationCard","PowerModerationCard__main":"PowerModerationCard__main","powerModerationCardMain":"PowerModerationCard__main","PowerModerationCard__aside":"PowerModerationCard__aside","powerModerationCardAside":"PowerModerationCard__aside","PowerModerationCard__aside__aside":"PowerModerationCard__aside__aside","powerModerationCardAsideAside":"PowerModerationCard__aside__aside","PowerModerationCard__section":"PowerModerationCard__section","powerModerationCardSection":"PowerModerationCard__section","PowerModerationCard__section__heading":"PowerModerationCard__section__heading","powerModerationCardSectionHeading":"PowerModerationCard__section__heading","PowerModerationCard__second-opinion-button":"PowerModerationCard__second-opinion-button","powerModerationCardSecondOpinionButton":"PowerModerationCard__second-opinion-button","PowerModerationCard__observation-data-user-info":"PowerModerationCard__observation-data-user-info","powerModerationCardObservationDataUserInfo":"PowerModerationCard__observation-data-user-info","PowerModerationCard__observation-data-comments":"PowerModerationCard__observation-data-comments","powerModerationCardObservationDataComments":"PowerModerationCard__observation-data-comments","PowerModerationCard__hr":"PowerModerationCard__hr","powerModerationCardHr":"PowerModerationCard__hr"};

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionAside_scss__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionAside_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ActionAside_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActionAsideSection__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_models__ = __webpack_require__(5);
var ActionAsideUnmoderated=function ActionAsideUnmoderated(props){var _props$pending=props.pending,pending=_props$pending===undefined?false:_props$pending,onSubmit=props.onSubmit,onSecondOpinionClick=props.onSecondOpinionClick,selectedCount=props.selectedCount,standardObservationButtons=props.standardObservationButtons,customObservationButtons=props.customObservationButtons,merchantName=props.merchantName;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_2__ActionAside_scss__["actionAside"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ActionAsideSection__["a" /* default */].First,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Common__["k" /* SubmitButton */],{pending:pending,onClick:onSubmit,label:selectedCount===0?'No Comment, Next':'Done, Next',className:'w-100'})),customObservationButtons.length>0&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ActionAsideSection__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:__WEBPACK_IMPORTED_MODULE_2__ActionAside_scss__["actionAsideSectionCustomObservationHeader"]},'Custom Observations for:'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:__WEBPACK_IMPORTED_MODULE_2__ActionAside_scss__["actionAsideSectionMerchantNameSubheader"]},merchantName),customObservationButtons),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ActionAsideSection__["a" /* default */],{heading:'Standard Observations'},standardObservationButtons),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ActionAsideSection__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Common__["h" /* ObservationButton */],{onClick:onSecondOpinionClick,name:'Get a Second Opinion',observation_type_code:__WEBPACK_IMPORTED_MODULE_4_models__["e" /* Observation */].SecondOpinionCode,className:__WEBPACK_IMPORTED_MODULE_2__ActionAside_scss__["actionAsideSecondOpinionButton"]})));};/* harmony default export */ __webpack_exports__["a"] = (ActionAsideUnmoderated);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ObservationBadges__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActionAsideSection__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActionAside_scss__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActionAside_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ActionAside_scss__);
var ActionAsideModerated=function ActionAsideModerated(props){var pending=props.pending,onSubmit=props.onSubmit,standardObservationButtons=props.standardObservationButtons,customObservationButtons=props.customObservationButtons,moderationState=props.moderationState,merchantName=props.merchantName;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_5__ActionAside_scss__["actionAside"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ActionAsideSection__["a" /* default */].First,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Common__["k" /* SubmitButton */],{pending:pending,onClick:onSubmit,label:'Save',disabled:!__WEBPACK_IMPORTED_MODULE_2__models__["d" /* ModerationState */].isModified(moderationState,1),className:'w-100'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ActionAsideSection__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ObservationBadges__["d" /* PwrModerationTime */],{moderationState:moderationState}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ObservationBadges__["e" /* default */],{moderationState:moderationState})),customObservationButtons.length>0&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ActionAsideSection__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:__WEBPACK_IMPORTED_MODULE_5__ActionAside_scss__["actionAsideSectionCustomObservationHeader"]},'Custom Observations for:'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:__WEBPACK_IMPORTED_MODULE_5__ActionAside_scss__["actionAsideSectionMerchantNameSubheader"]},merchantName),customObservationButtons),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ActionAsideSection__["a" /* default */],{heading:'Standard Observations'},standardObservationButtons));};/* harmony default export */ __webpack_exports__["a"] = (ActionAsideModerated);

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ObservationBadge--bg-no-observations":"ObservationBadge--bg-no-observations","observationBadgeBgNoObservations":"ObservationBadge--bg-no-observations"};

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsideAlert__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActionAside_scss__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActionAside_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ActionAside_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActionAsideSection__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ObservationBadges__ = __webpack_require__(89);
var getSecondOpinionObservation=function getSecondOpinionObservation(state){var pwrObservations=state.savedObservations.get(1);return pwrObservations?pwrObservations.get(__WEBPACK_IMPORTED_MODULE_3__models__["e" /* Observation */].SecondOpinionCode):undefined;};var ActionAsideSecondOpinion=function ActionAsideSecondOpinion(props){var pending=props.pending,onSubmit=props.onSubmit,standardObservationButtons=props.standardObservationButtons,customObservationButtons=props.customObservationButtons,moderationState=props.moderationState,merchantName=props.merchantName;var secondOpinionObservation=getSecondOpinionObservation(moderationState);var buttonLabel=__WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].isModified(moderationState,1)?'Update':'Dismiss';return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_4__ActionAside_scss__["actionAside"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ActionAsideSection__["a" /* default */].First,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__AsideAlert__["a" /* default */],{style:{marginBottom:'0.825em'}},'Second Opinion Needed'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Common__["k" /* SubmitButton */],{pending:pending,onClick:onSubmit,label:buttonLabel,className:'w-100'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ActionAsideSection__["a" /* default */],null,secondOpinionObservation&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ObservationBadges__["c" /* ObservationTimestamp */],{observation:secondOpinionObservation,showUserInfo:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ObservationBadges__["e" /* default */],{moderationState:moderationState}),secondOpinionObservation&&secondOpinionObservation.observation_data.comments&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_4__ActionAside_scss__["actionAsideModeratorComments"]},'"',secondOpinionObservation.observation_data.comments,'"')),customObservationButtons.length>0&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ActionAsideSection__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:__WEBPACK_IMPORTED_MODULE_4__ActionAside_scss__["actionAsideSectionCustomObservationHeader"]},'Custom Observations for:'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:__WEBPACK_IMPORTED_MODULE_4__ActionAside_scss__["actionAsideSectionMerchantNameSubheader"]},merchantName),customObservationButtons),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ActionAsideSection__["a" /* default */],{heading:'Standard Observations'},standardObservationButtons));};/* harmony default export */ __webpack_exports__["a"] = (ActionAsideSecondOpinion);

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"c-alerts":"c-alerts","cAlerts":"c-alerts","c-alerts--topleft":"c-alerts--topleft","cAlertsTopleft":"c-alerts--topleft","c-alerts--topright":"c-alerts--topright","cAlertsTopright":"c-alerts--topright","c-alerts--bottomleft":"c-alerts--bottomleft","cAlertsBottomleft":"c-alerts--bottomleft","c-alerts--bottomright":"c-alerts--bottomright","cAlertsBottomright":"c-alerts--bottomright","c-alert":"c-alert","cAlert":"c-alert","c-alert--brand":"c-alert--brand","cAlertBrand":"c-alert--brand","c-alert--info":"c-alert--info","cAlertInfo":"c-alert--info","c-alert--warning":"c-alert--warning","cAlertWarning":"c-alert--warning","c-alert--success":"c-alert--success","cAlertSuccess":"c-alert--success","c-alert--error":"c-alert--error","cAlertError":"c-alert--error","AsideAlert":"AsideAlert","asideAlert":"AsideAlert","AsideAlert__icon":"AsideAlert__icon","asideAlertIcon":"AsideAlert__icon"};

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blaze_scss_components_cards_scss__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blaze_scss_components_cards_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_blaze_scss_components_cards_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blaze_scss_utilities_boxing_scss__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blaze_scss_utilities_boxing_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_blaze_scss_utilities_boxing_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blaze_scss_components_headings_scss__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blaze_scss_components_headings_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_blaze_scss_components_headings_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SecondOpinionCard_scss__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SecondOpinionCard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SecondOpinionCard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Common__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SecondOpinionCard=function(_React$PureComponent){_inherits(SecondOpinionCard,_React$PureComponent);function SecondOpinionCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SecondOpinionCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SecondOpinionCard.__proto__||Object.getPrototypeOf(SecondOpinionCard)).call.apply(_ref,[this].concat(args))),_this),_this.handleObserve=function(code){return _this.props.onObserve(code);},_this.handleChange=function(e){_this.props.onReasonChange(e.currentTarget.value);},_this.handleKeydown=function(e){if(e.keyCode===27&&e.defaultPrevented===false){// amazing, the absence of these breaks youtube embeds
e.preventDefault();e.stopPropagation();_this.props.onClose();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SecondOpinionCard,[{key:'renderButtons',value:function renderButtons(observations,handler){var buttons=observations.map(function(ob,index){var name=ob.name,observation_type_code=ob.observation_type_code;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Common__["h" /* ObservationButton */],{key:observation_type_code,name:name,existing:ob.isSelected(),observation_type_code:observation_type_code,onClick:handler});});return buttons;}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('keydown',this.handleKeydown);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keydown',this.handleKeydown);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_5__SecondOpinionCard_scss__["secondOpinionCard"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_blaze_scss_components_cards_scss__["cCard"]+' '+__WEBPACK_IMPORTED_MODULE_3_blaze_scss_utilities_boxing_scss__["uWindowBoxLarge"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:__WEBPACK_IMPORTED_MODULE_5__SecondOpinionCard_scss__["secondOpinionCardHeader"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:__WEBPACK_IMPORTED_MODULE_5__SecondOpinionCard_scss__["secondOpinionCardHeading"]},'Get A Second Opinion'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'f4 gray'},'Tell us why you\u2019d like to get a second opinion on this piece of content.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:this.props.onClose},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Common__["e" /* CloseIcon */],{className:__WEBPACK_IMPORTED_MODULE_5__SecondOpinionCard_scss__["secondOpinionCardCloseIcon"]})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_blaze_scss_components_cards_scss__["cCardBody"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:__WEBPACK_IMPORTED_MODULE_4_blaze_scss_components_headings_scss__["cHeading"]+' brandon f4 db fw6'},'What did you observe?'),this.renderButtons(this.props.observations,this.handleObserve),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'second-opinion-reason',className:__WEBPACK_IMPORTED_MODULE_4_blaze_scss_components_headings_scss__["cHeading"]+' brandon f4 db fw6'},'Why are you unsure?'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{id:'second-opinion-reason',className:__WEBPACK_IMPORTED_MODULE_5__SecondOpinionCard_scss__["secondOpinionCardTextarea"],value:this.props.reason,onChange:this.handleChange,autoFocus:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_blaze_scss_components_cards_scss__["cCardFooter"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Common__["k" /* SubmitButton */],{label:'Request 2nd Opinion',onClick:this.props.onSubmit,style:{width:'auto'}}))));}}]);return SecondOpinionCard;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);SecondOpinionCard.propTypes={reason:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,observations:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(Array),onReasonChange:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,onObserve:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired};SecondOpinionCard.defaultProps={reason:''};/* harmony default export */ __webpack_exports__["a"] = (SecondOpinionCard);

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"c-card":"c-card","cCard":"c-card","o-image":"o-image","oImage":"o-image","c-card__header":"c-card__header","cCardHeader":"c-card__header","c-heading":"c-heading","cHeading":"c-heading","c-card__item":"c-card__item","cCardItem":"c-card__item","c-card__body":"c-card__body","cCardBody":"c-card__body","c-card__footer":"c-card__footer","cCardFooter":"c-card__footer","c-card__footer--block":"c-card__footer--block","cCardFooterBlock":"c-card__footer--block","c-input-group":"c-input-group","cInputGroup":"c-input-group","c-button":"c-button","cButton":"c-button","c-card--accordion":"c-card--accordion","cCardAccordion":"c-card--accordion","c-card--menu":"c-card--menu","cCardMenu":"c-card--menu","c-card--grouped":"c-card--grouped","cCardGrouped":"c-card--grouped","c-card__divider":"c-card__divider","cCardDivider":"c-card__divider","c-card__item--divider":"c-card__item--divider","cCardItemDivider":"c-card__item--divider","c-card__item--brand":"c-card__item--brand","cCardItemBrand":"c-card__item--brand","c-card__item--info":"c-card__item--info","cCardItemInfo":"c-card__item--info","c-card__item--warning":"c-card__item--warning","cCardItemWarning":"c-card__item--warning","c-card__item--success":"c-card__item--success","cCardItemSuccess":"c-card__item--success","c-card__item--error":"c-card__item--error","cCardItemError":"c-card__item--error","c-card__item--disabled":"c-card__item--disabled","cCardItemDisabled":"c-card__item--disabled","c-card__item--active":"c-card__item--active","cCardItemActive":"c-card__item--active"};

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"u-no-overflow":"u-no-overflow","uNoOverflow":"u-no-overflow","u-letter-box--super":"u-letter-box--super","uLetterBoxSuper":"u-letter-box--super","u-letter-box--xlarge":"u-letter-box--xlarge","uLetterBoxXlarge":"u-letter-box--xlarge","u-letter-box--large":"u-letter-box--large","uLetterBoxLarge":"u-letter-box--large","u-letter-box--medium":"u-letter-box--medium","uLetterBoxMedium":"u-letter-box--medium","u-letter-box--small":"u-letter-box--small","uLetterBoxSmall":"u-letter-box--small","u-letter-box--xsmall":"u-letter-box--xsmall","uLetterBoxXsmall":"u-letter-box--xsmall","u-letter-box--tiny":"u-letter-box--tiny","uLetterBoxTiny":"u-letter-box--tiny","u-letter-box--none":"u-letter-box--none","uLetterBoxNone":"u-letter-box--none","u-pillar-box--super":"u-pillar-box--super","uPillarBoxSuper":"u-pillar-box--super","u-pillar-box--xlarge":"u-pillar-box--xlarge","uPillarBoxXlarge":"u-pillar-box--xlarge","u-pillar-box--large":"u-pillar-box--large","uPillarBoxLarge":"u-pillar-box--large","u-pillar-box--medium":"u-pillar-box--medium","uPillarBoxMedium":"u-pillar-box--medium","u-pillar-box--small":"u-pillar-box--small","uPillarBoxSmall":"u-pillar-box--small","u-pillar-box--xsmall":"u-pillar-box--xsmall","uPillarBoxXsmall":"u-pillar-box--xsmall","u-pillar-box--tiny":"u-pillar-box--tiny","uPillarBoxTiny":"u-pillar-box--tiny","u-pillar-box--none":"u-pillar-box--none","uPillarBoxNone":"u-pillar-box--none","u-window-box--super":"u-window-box--super","uWindowBoxSuper":"u-window-box--super","u-window-box--xlarge":"u-window-box--xlarge","uWindowBoxXlarge":"u-window-box--xlarge","u-window-box--large":"u-window-box--large","uWindowBoxLarge":"u-window-box--large","u-window-box--medium":"u-window-box--medium","uWindowBoxMedium":"u-window-box--medium","u-window-box--small":"u-window-box--small","uWindowBoxSmall":"u-window-box--small","u-window-box--xsmall":"u-window-box--xsmall","uWindowBoxXsmall":"u-window-box--xsmall","u-window-box--tiny":"u-window-box--tiny","uWindowBoxTiny":"u-window-box--tiny","u-window-box--none":"u-window-box--none","uWindowBoxNone":"u-window-box--none"};

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"c-heading":"c-heading","cHeading":"c-heading","c-heading__sub":"c-heading__sub","cHeadingSub":"c-heading__sub"};

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"o-field":"o-field","oField":"o-field","c-field":"c-field","cField":"c-field","c-icon":"c-icon","cIcon":"c-icon","SecondOpinionCard__textarea":"SecondOpinionCard__textarea","secondOpinionCardTextarea":"SecondOpinionCard__textarea","o-field--icon-right":"o-field--icon-right","oFieldIconRight":"o-field--icon-right","o-field--icon-left":"o-field--icon-left","oFieldIconLeft":"o-field--icon-left","c-fieldset":"c-fieldset","cFieldset":"c-fieldset","c-list":"c-list","cList":"c-list","c-fieldset__legend":"c-fieldset__legend","cFieldsetLegend":"c-fieldset__legend","c-label":"c-label","cLabel":"c-label","c-field--label":"c-field--label","cFieldLabel":"c-field--label","c-field--error":"c-field--error","cFieldError":"c-field--error","c-field--success":"c-field--success","cFieldSuccess":"c-field--success","c-field--choice":"c-field--choice","cFieldChoice":"c-field--choice","c-fieldset--disabled":"c-fieldset--disabled","cFieldsetDisabled":"c-fieldset--disabled","c-field--disabled":"c-field--disabled","cFieldDisabled":"c-field--disabled","SecondOpinionCard":"SecondOpinionCard","secondOpinionCard":"SecondOpinionCard","SecondOpinionCard__header":"SecondOpinionCard__header","secondOpinionCardHeader":"SecondOpinionCard__header","SecondOpinionCard__heading":"SecondOpinionCard__heading","secondOpinionCardHeading":"SecondOpinionCard__heading","SecondOpinionCard__sub-heading":"SecondOpinionCard__sub-heading","secondOpinionCardSubHeading":"SecondOpinionCard__sub-heading","SecondOpinionCard__close-icon":"SecondOpinionCard__close-icon","secondOpinionCardCloseIcon":"SecondOpinionCard__close-icon"};

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KeyboardHelperMenu__ = __webpack_require__(523);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var swallowEvent=function swallowEvent(e){e.preventDefault();e.stopPropagation();};var MENU_ITEMS=[['p','Toggle Product Details'],['m','Toggle Meta Info'],[['Shift','s'],'Second Opinion'],[['Shift','Enter'],'Submit']];var elementAcceptsKeyboardInput=function elementAcceptsKeyboardInput(el){if(!el){return false;}var tagName=el.tagName;if(tagName==='TEXTAREA')return true;if(tagName==='INPUT')return true;return false;};var KeyboardHelper=function(_React$PureComponent){_inherits(KeyboardHelper,_React$PureComponent);function KeyboardHelper(){var _ref;var _temp,_this,_ret;_classCallCheck(this,KeyboardHelper);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=KeyboardHelper.__proto__||Object.getPrototypeOf(KeyboardHelper)).call.apply(_ref,[this].concat(args))),_this),_this.state={showHelp:false},_this.handleKeydown=function(e){if(e.defaultPrevented===true||_this.state.showHelp===true){return;}var shouldProcessEvent=elementAcceptsKeyboardInput(document.activeElement)===true?false:true;// we should ignore the second opinion text key presses
// yes this is a bit hacky
if(shouldProcessEvent){// p
if(e.which===80){swallowEvent(e);_this.pwrModerationCard&&_this.pwrModerationCard.toggleSubjectDetails();}// m
if(e.which===77){swallowEvent(e);_this.pwrModerationCard&&_this.pwrModerationCard.toggleMeta();}// shift + s
if(e.which===83&&e.shiftKey===true){swallowEvent(e);_this.pwrModerationCard&&_this.pwrModerationCard.showSecondOpinionCard();}// shift + /
if(e.which===191&&e.shiftKey===true){swallowEvent(e);_this.showHelp();}}// shift + enter
if(e.which===13&&e.shiftKey===true){swallowEvent(e);_this.pwrModerationCard&&_this.pwrModerationCard.handleSubmit();}},_this.showHelp=function(){return _this.setState({showHelp:true});},_this.hideHelp=function(){return _this.setState({showHelp:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(KeyboardHelper,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('keydown',this.handleKeydown);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keydown',this.handleKeydown);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,this.state.showHelp&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__KeyboardHelperMenu__["a" /* default */],{onClose:this.hideHelp,items:MENU_ITEMS}),this.props.children&&__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](this.props.children,{ref:function ref(c){return _this2.pwrModerationCard=c;}}));}}]);return KeyboardHelper;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (KeyboardHelper);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Modal__ = __webpack_require__(62);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KBD=function KBD(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('kbd',{className:'fw9 bg-light-gray ph2 pv1 br1 ml1 ba b--moon-gray',style:{boxShadow:'inset 0 -1px #aaa'}},props.children);};var KeyboardShortcutsMenu=function(_React$PureComponent){_inherits(KeyboardShortcutsMenu,_React$PureComponent);function KeyboardShortcutsMenu(){_classCallCheck(this,KeyboardShortcutsMenu);return _possibleConstructorReturn(this,(KeyboardShortcutsMenu.__proto__||Object.getPrototypeOf(KeyboardShortcutsMenu)).apply(this,arguments));}_createClass(KeyboardShortcutsMenu,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Modal__["b" /* default */],{onClose:this.props.onClose},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Modal__["b" /* default */].Header,null,'Keyboard shortcuts'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Modal__["b" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('table',{className:'collapse dark-gray ma4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tbody',null,this.props.items.map(function(item){var _item=_slicedToArray(item,2),keys=_item[0],action=_item[1];var kbds=Array.isArray(keys)?keys.map(function(k){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](KBD,{key:k},k);}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](KBD,null,keys);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',{key:action},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:'tr pa2'},kbds),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:'pa2'},action));})))));}}]);return KeyboardShortcutsMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (KeyboardShortcutsMenu);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClientModerationCardSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_CardAlert__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClientAttribution__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientModerationCard_scss__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientModerationCard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ClientModerationCard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SectionSeparator__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ObservationBadges__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CustomObservationInfoTooltip__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__collectionDiff__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ModerationCard_ClientModerationCard_RequestReviewModal__ = __webpack_require__(529);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function renderBlocks(children){return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children,function(child){return child?[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__SectionSeparator__["a" /* default */],null),child]:null;});}var ClientModerationCardSection=function ClientModerationCardSection(_ref){var children=_ref.children,last=_ref.last,first=_ref.first,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()('pa4 b--moon-gray bw1 mv0'+(className?' '+className:''),{bt:first!==true})},children);};var ClientModerationCard=function(_React$Component){_inherits(ClientModerationCard,_React$Component);function ClientModerationCard(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,ClientModerationCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=ClientModerationCard.__proto__||Object.getPrototypeOf(ClientModerationCard)).call.apply(_ref2,[this].concat(args))),_this),_this.state={showRequestReviewModal:false,requestReviewResponseMessage:'',reviewUpdateSuccessful:null,reviewRequestDate:_this.props.ugc.ugc_edit_request_date?_this.props.ugc.ugc_edit_request_date:null,reviewUpdateRequestPending:false},_this.handleObservationChange=function(options){var _this$props=_this.props,currentState=_this$props.moderationState,clientId=_this$props.clientId,onChange=_this$props.onChange,product=_this$props.product;var currentSelectedCodes=__WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].getActionableObservations(currentState,clientId).filter(__WEBPACK_IMPORTED_MODULE_3__models__["e" /* Observation */].isSelected).map(function(o){return o.observation_type_code;});var pendingSelectedCodes=options.map(function(v){return v.value;});var _collectionDiff=Object(__WEBPACK_IMPORTED_MODULE_9__collectionDiff__["a" /* default */])(currentSelectedCodes,pendingSelectedCodes),added=_collectionDiff.added,deleted=_collectionDiff.deleted;var nextModerationState=currentState.withMutations(function(state){added.forEach(function(code){return __WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].setObservation(state,clientId,code);});deleted.forEach(function(code){return __WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].removeObservation(state,clientId,code);});});onChange&&onChange(nextModerationState,{clientId:clientId,ugcClientId:product.merchant.group_id,ugctype:_this.props.ugc.ugctype});},_this.handleSiteStatusChange=function(option){var desiredPublished=option.value;var _this$props2=_this.props,moderationState=_this$props2.moderationState,onSiteStatusChange=_this$props2.onSiteStatusChange,product=_this$props2.product;onSiteStatusChange&&onSiteStatusChange({moderationState:moderationState,desiredPublished:desiredPublished},{clientId:_this.props.clientId,ugcClientId:product.merchant.group_id,ugctype:_this.props.ugc.ugctype});},_this.handleModerationStateSubmit=function(){var _this$props3=_this.props,onSubmit=_this$props3.onSubmit,moderationState=_this$props3.moderationState,clientId=_this$props3.clientId;var stateToSubmit=__WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].applyClientModeration(moderationState,clientId);onSubmit(stateToSubmit,clientId);},_this.toggleRequestReviewModal=function(){return _this.setState(function(prevState){return{showRequestReviewModal:!prevState.showRequestReviewModal};});},_this.sendReviewUpdateRequest=function(){_this.toggleRequestReviewModal();},_this.handleReviewUpdateRequest=function(requestText){var _this$props4=_this.props,ugc=_this$props4.ugc,clientId=_this$props4.clientId,token=_this$props4.authToken;var body={client_id:clientId,ugc_id:ugc.ugc_id,request_text:requestText};_this.setState({reviewUpdateRequestPending:true});Object(__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["j" /* requestReviewUpdateHandler */])(token,body).then(function(response){_this.setState({reviewUpdateRequestPending:false});if(response.code>=200&&response.code<300){_this.setState({reviewUpdateSuccessful:true,reviewRequestDate:response.responseBody.updated_date});}else{_this.setState({reviewUpdateSuccessful:false,requestReviewResponseMessage:response.message});}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientModerationCard,[{key:'render',value:function render(){var _props=this.props,moderationState=_props.moderationState,product=_props.product,ugc=_props.ugc,status=_props.status,clientId=_props.clientId,shouldEnableUgcEditing=_props.shouldEnableUgcEditing,children=_props.children;var reviewRequestDate=this.state.reviewRequestDate;var ugcId=moderationState.getUGCId();var subjectCatalog=product.merchant;var isSyndicated=subjectCatalog.group_id!==clientId;var pending=status==='pending';var moderationStateHasNotChanged=__WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].isEqual(moderationState,clientId);var cmObservation=Object(__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["d" /* getCMObservation */])(moderationState,clientId);var isClientModerated=cmObservation!=null;var lastClientObservation=isClientModerated?Object(__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["f" /* getLatestClientObservation */])(moderationState,clientId):undefined;var pmObservation=__WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].getSavedObservations(moderationState,__WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].PowerReviewsModerationContext).get(__WEBPACK_IMPORTED_MODULE_3__models__["e" /* Observation */].PowerModerationCode);var fraudObservation=__WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].getSavedObservations(moderationState,__WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].PowerReviewsModerationContext).get(__WEBPACK_IMPORTED_MODULE_3__models__["e" /* Observation */].Fraud);var observations=__WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].getActionableObservations(moderationState,clientId);var savedClientObservations=Object(__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["e" /* getClientObservationLabels */])(moderationState,clientId);var powerReviewsObservations=Object(__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["h" /* getPwrObservationsLabels */])(moderationState);var prObservationsWithCustomObservation=powerReviewsObservations.filter(function(o){return o.custom_observation===true;});var observationSelectOptions=observations.map(__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["i" /* mapObservationToOption */]);var observationSelectValue=observations.filter(__WEBPACK_IMPORTED_MODULE_3__models__["e" /* Observation */].isSelected).map(__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["i" /* mapObservationToOption */]);var isBrandContent=ugc.catalog&&ugc.catalog!==__WEBPACK_IMPORTED_MODULE_3__models__["b" /* Catalog */].Empty&&ugc.catalog.group_id!==this.props.clientId;var beforeMeta=[];var afterMeta=[];var asideContent=[];var contentSection=null;var editable=ugc.editable,old_ugc_id=ugc.old_ugc_id,new_ugc_id=ugc.new_ugc_id;var formattedRequestDate=reviewRequestDate?new Date(reviewRequestDate).toDateString():'';var shouldDisableRequestButton=reviewRequestDate||editable===false?true:false;var isOldUgc=new_ugc_id?true:false;var isNewUgc=old_ugc_id?true:false;var isNativeContent=clientId===product.merchant.group_id;isSyndicated&&asideContent.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClientModerationCardSection,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ClientAttribution__["b" /* RetailerAttribution */],{clientId:subjectCatalog.group_id,clientName:subjectCatalog.name,ugctype:ugc.ugctype})));isBrandContent&&asideContent.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClientModerationCardSection,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ClientAttribution__["a" /* BrandAttribution */],{clientId:ugc.catalog.group_id,clientName:ugc.catalog.name,ugctype:ugc.ugctype})));__WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children,function(child){if(child&&child.type===ClientModerationCard.BeforeMeta){beforeMeta.push(child);}else if(child&&child.type===ClientModerationCard.Aside){asideContent.push(child);}else if(child&&child.type===ClientModerationCard.ContentSection){contentSection=child;}else{afterMeta.push(child);}});var isCurrentPublished=__WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].isCurrentPublished(moderationState,clientId);var isSavedPublished=__WEBPACK_IMPORTED_MODULE_3__models__["d" /* ModerationState */].isSavedPublished(moderationState,clientId);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_5__ClientModerationCard_scss__["clientModerationCard"]},pending&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_5__ClientModerationCard_scss__["clientModerationCardOverlay"]}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_5__ClientModerationCard_scss__["clientModerationCardMain"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["n" /* ProductSection */],{model:product,key:product.subject_id,brandName:true,categoryName:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mb4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__SectionSeparator__["a" /* default */],null)),isOldUgc&&isNativeContent&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Common_CardAlert__["a" /* default */],null,'This review has been updated.',' ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('a',{href:Object(__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["g" /* getLinkedNativeUgcByIdUrl */])(new_ugc_id,clientId),target:'_blank'},'Read Updated Review')),isNewUgc&&isNativeContent&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Common_CardAlert__["a" /* default */],null,'This is an update to a previous review.',' ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('a',{href:Object(__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["g" /* getLinkedNativeUgcByIdUrl */])(old_ugc_id,clientId),target:'_blank'},'Read Original')),contentSection?contentSection:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["h" /* ContentSection */],{key:'cc-'+ugcId,model:ugc,program:'client'},beforeMeta),afterMeta),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_5__ClientModerationCard_scss__["clientModerationCardAside"],'data-translate':true},__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(asideContent,function(el,index){return index===0?__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](el,{first:true}):el;}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClientModerationCardSection,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'dark-gray ma0 mb1 brandon'},'PowerReviews Observations',prObservationsWithCustomObservation.length>0&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__CustomObservationInfoTooltip__["a" /* CustomObservationInfoTooltip */],null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["b" /* PowerReviewsObservationBadges */],{pmObservation:pmObservation,fraudObservation:fraudObservation,observations:powerReviewsObservations}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('br',null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'dark-gray ma0 mb1 brandon'},'Add Observations'),lastClientObservation?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ObservationBadges__["c" /* ObservationTimestamp */],{observation:lastClientObservation,showUserInfo:true,recent:true}):Object(__WEBPACK_IMPORTED_MODULE_7__ObservationBadges__["a" /* NoObservationsBadge */])('Not Reviewed by Your Team'),isClientModerated&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["a" /* ClientObservationBadges */],{isClientModerated:isClientModerated,observations:savedClientObservations}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["q" /* Select */],{name:'observations',options:observationSelectOptions,value:observationSelectValue,onChange:this.handleObservationChange,autoSize:false,multi:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mv2'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["r" /* SubmitButton */],{label:'Save Observations',pending:pending,onClick:this.handleModerationStateSubmit,disabled:moderationStateHasNotChanged&&isClientModerated,className:'f5 o-80 ph3 w-100'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ModerationCard_ClientModerationCard_utils_js__["c" /* SiteStatusChangeNotice */],{isCurrentPublished:isCurrentPublished,isSavedPublished:isSavedPublished,observationsHaveChanged:!moderationStateHasNotChanged}))),editable&&shouldEnableUgcEditing&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClientModerationCardSection,{className:'bn'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',{className:'center tc mt0 mh',style:{fontFamily:'BrandonText'}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'w-100 left-0'},reviewRequestDate&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'gray dib tc mb2 w-100'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'mb0'},'Update Requested on: ',formattedRequestDate)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{onClick:this.toggleRequestReviewModal,className:' '+(shouldDisableRequestButton?'o-40':'pointer')+' f5 o-80 ph3 blue bg-white w-100 br2 pv3 ph3 bn',disabled:shouldDisableRequestButton},'Request Review Update'))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ModerationCard_ClientModerationCard_RequestReviewModal__["a" /* default */],{isVisible:this.state.showRequestReviewModal,handleVisibilityToggle:this.toggleRequestReviewModal,userName:ugc.author,userEmail:ugc.email,requestReviewUpdate:this.handleReviewUpdateRequest,requestReviewResponseMessage:this.state.requestReviewResponseMessage,reviewUpdateSuccessful:this.state.reviewUpdateSuccessful,requestPending:this.state.reviewUpdateRequestPending}))));}}]);return ClientModerationCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ClientModerationCard.defaultProps={product:new __WEBPACK_IMPORTED_MODULE_3__models__["f" /* Product */]()};ClientModerationCard.BeforeMeta=function(props){return renderBlocks(props.children);};ClientModerationCard.AfterMeta=function(props){return renderBlocks(props.children);};ClientModerationCard.Aside=function(_ref3){var label=_ref3.label,children=_ref3.children,first=_ref3.first;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClientModerationCardSection,{first:first},label&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'dark-gray ma0 mb2 brandon'},label),children);};ClientModerationCard.ContentSection=function(props){return props.children;};/* harmony default export */ __webpack_exports__["a"] = (ClientModerationCard);

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"c-overlay":"c-overlay","cOverlay":"c-overlay","ClientModerationCard__overlay":"ClientModerationCard__overlay","clientModerationCardOverlay":"ClientModerationCard__overlay","c-overlay--visible":"c-overlay--visible","cOverlayVisible":"c-overlay--visible","c-overlay--fullpage":"c-overlay--fullpage","cOverlayFullpage":"c-overlay--fullpage","c-overlay--transparent":"c-overlay--transparent","cOverlayTransparent":"c-overlay--transparent","c-overlay--dismissable":"c-overlay--dismissable","cOverlayDismissable":"c-overlay--dismissable","o-field":"o-field","oField":"o-field","c-field":"c-field","cField":"c-field","c-icon":"c-icon","cIcon":"c-icon","ClientModerationCard__response-field":"ClientModerationCard__response-field","clientModerationCardResponseField":"ClientModerationCard__response-field","ClientModerationCard__notes-field":"ClientModerationCard__notes-field","clientModerationCardNotesField":"ClientModerationCard__notes-field","ClientModerationCard__observations-field":"ClientModerationCard__observations-field","clientModerationCardObservationsField":"ClientModerationCard__observations-field","o-field--icon-right":"o-field--icon-right","oFieldIconRight":"o-field--icon-right","o-field--icon-left":"o-field--icon-left","oFieldIconLeft":"o-field--icon-left","c-fieldset":"c-fieldset","cFieldset":"c-fieldset","c-list":"c-list","cList":"c-list","c-fieldset__legend":"c-fieldset__legend","cFieldsetLegend":"c-fieldset__legend","c-label":"c-label","cLabel":"c-label","c-field--label":"c-field--label","cFieldLabel":"c-field--label","c-field--error":"c-field--error","cFieldError":"c-field--error","c-field--success":"c-field--success","cFieldSuccess":"c-field--success","c-field--choice":"c-field--choice","cFieldChoice":"c-field--choice","c-fieldset--disabled":"c-fieldset--disabled","cFieldsetDisabled":"c-fieldset--disabled","c-field--disabled":"c-field--disabled","cFieldDisabled":"c-field--disabled","ClientModerationCard":"ClientModerationCard","clientModerationCard":"ClientModerationCard","ClientModerationCard__main":"ClientModerationCard__main","clientModerationCardMain":"ClientModerationCard__main","ClientModerationCard__aside":"ClientModerationCard__aside","clientModerationCardAside":"ClientModerationCard__aside","ClientModerationCard__aside__aside":"ClientModerationCard__aside__aside","clientModerationCardAsideAside":"ClientModerationCard__aside__aside","ClientModerationCard__section":"ClientModerationCard__section","clientModerationCardSection":"ClientModerationCard__section","ClientModerationCard__section__heading":"ClientModerationCard__section__heading","clientModerationCardSectionHeading":"ClientModerationCard__section__heading","ClientModerationCard__aside-button":"ClientModerationCard__aside-button","clientModerationCardAsideButton":"ClientModerationCard__aside-button","c-button--active":"c-button--active","cButtonActive":"c-button--active","c-badge":"c-badge","cBadge":"c-badge","c-badge--observation":"c-badge--observation","cBadgeObservation":"c-badge--observation"};

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomObservationInfoTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CustomObservationIcon__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomObservationInfoTooltip_scss__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomObservationInfoTooltip_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CustomObservationInfoTooltip_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var CustomObservationInfoTooltip=function CustomObservationInfoTooltip(){var tooltipClassname=__WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__CustomObservationInfoTooltip_scss__["customObservationInfoTooltip"],'relative dib');var tooltipTextClassname=__WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__CustomObservationInfoTooltip_scss__["customObservationInfoTooltipText"],'bg-white br3 z-1 absolute o-0');return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:tooltipClassname},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',{xmlns:'http://www.w3.org/2000/svg',width:'15',height:'15',viewBox:'0 0 24 24','aria-describedby':'custom-observation-tooltip-text'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{d:'M0 0h24v24H0z',fill:'none'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{d:'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:tooltipTextClassname,id:'custom-observation-tooltip-text',role:'tooltip'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'gray normal f6'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'mt0 mb1'},'The observations below were flagged by the team at Power Reviews.'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'mv0 mb1'},'Observations with the ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__CustomObservationIcon__["a" /* CustomObservationIcon */],{className:'v-mid'}),' ','icon are custom observations specific to your organization.'))));};

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var identity=function identity(v){return v;};function diff(a,b){var iteratee=arguments.length>2&&arguments[2]!==undefined?arguments[2]:identity;var set=new Set(a.map(iteratee));return b.reduce(function(acc,v){var vv=iteratee(v);if(!set.has(vv)){acc.push(vv);}return acc;},[]);}/* harmony default export */ __webpack_exports__["a"] = (function(current,next){var iteratee=arguments.length>2&&arguments[2]!==undefined?arguments[2]:identity;return{added:diff(current,next),deleted:diff(next,current)};});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return requestReviewUpdateHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLinkedNativeUgcByIdUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return mapObservationToOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SiteStatusChangeNotice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PowerReviewsObservationBadges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientObservationBadges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPwrObservationsLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getClientObservationLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCMObservation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getLatestClientObservation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AsideAlert__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ObservationBadges__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__(5);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// For UGC Editing
var requestReviewUpdateHandler=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(token,body){var fetchOptions,response,json;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:fetchOptions={method:'POST',headers:{'Content-type':'application/json',Authorization:token},body:JSON.stringify(body)};_context.next=3;return fetch('/request-ugc-edit',fetchOptions);case 3:response=_context.sent;_context.next=6;return response.json();case 6:json=_context.sent;return _context.abrupt('return',{code:response.status,responseBody:json,message:response.status===200?response.statusText:json.message,response:response});case 8:case'end':return _context.stop();}}},_callee,this);}));return function requestReviewUpdateHandler(_x,_x2){return _ref.apply(this,arguments);};}();var getLinkedNativeUgcByIdUrl=function getLinkedNativeUgcByIdUrl(linkedUgcId,clientId){return'/#/reviews/native-reviews/results?ugc_id='+linkedUgcId+'&client_id='+clientId;};var mapObservationToOption=function mapObservationToOption(ob){var label=ob.name,value=ob.observation_type_code;return{label:label,value:value};};var SiteStatusChangeNotice=function SiteStatusChangeNotice(_ref2){var isCurrentPublished=_ref2.isCurrentPublished,isSavedPublished=_ref2.isSavedPublished,observationsHaveChanged=_ref2.observationsHaveChanged;var className='tc f6 db gray mv1';if(typeof isCurrentPublished!=='boolean')return null;if(isCurrentPublished===true&&isSavedPublished===false){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:className},'Content will be Published.');}if(isCurrentPublished===false&&isSavedPublished===true){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:className},'Content will be Unpublished.');}if(observationsHaveChanged){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:className},'Content will remain ',isCurrentPublished?'Published':'Unpublished','.');}return null;};var PowerReviewsObservationBadges=function PowerReviewsObservationBadges(props){var pmObservation=props.pmObservation,fraudObservation=props.fraudObservation,observations=props.observations;if(!pmObservation){return fraudObservation?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AsideAlert__["a" /* default */],null,'Flagged as Fraudulent by PowerReviews'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AsideAlert__["a" /* default */],null,'Unmoderated by PowerReviews');}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mv1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ObservationBadges__["c" /* ObservationTimestamp */],{observation:pmObservation}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex flex-wrap'},observations.length?observations.map(function(_ref3){var name=_ref3.name,custom_observation=_ref3.custom_observation;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ObservationBadges__["b" /* ObservationBadge */],{name:name,key:name,customObservation:custom_observation});}):Object(__WEBPACK_IMPORTED_MODULE_3__ObservationBadges__["a" /* NoObservationsBadge */])('No PowerReviews Observations')));};var ClientObservationBadges=function ClientObservationBadges(props){var observations=props.observations;return observations.length?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex flex-wrap'},observations.map(function(_ref4){var custom_observation=_ref4.custom_observation,name=_ref4.name;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ObservationBadges__["b" /* ObservationBadge */],{name:name,customObservation:custom_observation,key:name});})):Object(__WEBPACK_IMPORTED_MODULE_3__ObservationBadges__["a" /* NoObservationsBadge */])();};var getPwrObservationsLabels=function getPwrObservationsLabels(state){return __WEBPACK_IMPORTED_MODULE_4__models__["d" /* ModerationState */].getSavedObservations(state,1).valueSeq().filter(__WEBPACK_IMPORTED_MODULE_4__models__["e" /* Observation */].isSelected).filter(__WEBPACK_IMPORTED_MODULE_4__models__["e" /* Observation */].IsEnumerableObservation).toArray();};var getClientObservationLabels=function getClientObservationLabels(state,context){return __WEBPACK_IMPORTED_MODULE_4__models__["d" /* ModerationState */].getSavedObservations(state,context).valueSeq().filter(__WEBPACK_IMPORTED_MODULE_4__models__["e" /* Observation */].isSelected).filter(function(_ref5){var c=_ref5.observation_type_code;return c!==__WEBPACK_IMPORTED_MODULE_4__models__["e" /* Observation */].ClientModerationCode;}).toArray();};var getCMObservation=function getCMObservation(state,context){return __WEBPACK_IMPORTED_MODULE_4__models__["d" /* ModerationState */].getSavedObservations(state,context).get(__WEBPACK_IMPORTED_MODULE_4__models__["e" /* Observation */].ClientModerationCode);};var getLatestClientObservation=function getLatestClientObservation(state,context){return __WEBPACK_IMPORTED_MODULE_4__models__["d" /* ModerationState */].getSavedObservations(state,context).valueSeq().filter(__WEBPACK_IMPORTED_MODULE_4__models__["e" /* Observation */].isSelected).reduce(function(newestObservation,observation){return newestObservation.updated_date>observation.updated_date?newestObservation:observation;});};

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentSection_UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_CloseIcon__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SuccessCheckmark__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RequestReviewModal_scss__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RequestReviewModal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RequestReviewModal_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RequestReviewModal=function(_Component){_inherits(RequestReviewModal,_Component);function RequestReviewModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RequestReviewModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RequestReviewModal.__proto__||Object.getPrototypeOf(RequestReviewModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={reviewRequestMessage:'',reviewRequestErrorMessage:''},_this.handleChange=function(e){_this.setState({reviewRequestMessage:e.target.value});},_this.handleRequest=function(e){_this.props.requestReviewUpdate(_this.state.reviewRequestMessage);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RequestReviewModal,[{key:'render',value:function render(){var _props=this.props,handleVisibilityToggle=_props.handleVisibilityToggle,userName=_props.userName,userEmail=_props.userEmail,reviewUpdateSuccessful=_props.reviewUpdateSuccessful,requestReviewResponseMessage=_props.requestReviewResponseMessage,requestPending=_props.requestPending,isVisible=_props.isVisible;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'RequestReviewModal bg-white gray pv3 pl4 pb4 pr4 pv4 w-90 fixed br1',style:{display:isVisible===true?'block':'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relative pv2 ph3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:handleVisibilityToggle,className:'bg-transparent bn gray pointer absolute',style:{right:'-15px',top:'-5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Common_CloseIcon__["a" /* default */],{style:{width:'15px'}})),reviewUpdateSuccessful?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SuccessView,{handleVisibilityToggle:handleVisibilityToggle,userEmail:userEmail}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RequestReviewFormHeader,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'request-review-update-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f4'},'Ask this reviewer to write an updated review on this product. The new review will appear on your site with their original review below it.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('address',{className:'f4 dib fs-normal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fw7 mid-gray'},'Sending to:'),' ',Object(__WEBPACK_IMPORTED_MODULE_2__ContentSection_UserGeneratedTextContainer__["c" /* stripWarningTags */])(userName),' (',userEmail,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'request-text',className:'fw7 f4 mb0 db mt3 mid-gray'},'Remind the reviewer why you are asking for an updated review'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'(Minimum 50 characters; maximum 2000)'),requestReviewResponseMessage&&!reviewUpdateSuccessful&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorMessage,{errorText:prettifyMinimumLengthErrorIfExists(requestReviewResponseMessage)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{id:'request-text',value:this.state.reviewRequestMessage,onChange:this.handleChange,className:'w-100 mt3 mb4',style:{height:'150px',resize:'none'},maxLength:'1000'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["r" /* SubmitButton */],{label:'Send Request',className:'f5 pa3',style:{minWidth:'93px'},onClick:this.handleRequest,pending:requestPending,disabled:requestPending}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'gray'},'*This request can only be made once. After you send this request, the feature will no longer be available.'))))));}}]);return RequestReviewModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RequestReviewModal);var RequestReviewFormHeader=function RequestReviewFormHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'flex items-center justify-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'mv0 mid-gray'},'Request Updated Review'));};var SuccessView=function SuccessView(_ref2){var handleVisibilityToggle=_ref2.handleVisibilityToggle,userEmail=_ref2.userEmail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'tc mt5 pt4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SuccessCheckmark__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'mid-gray'},'Your request has been sent.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The request was sent to ',userEmail,'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["r" /* SubmitButton */],{label:'I\'m Done',className:'f4',style:{minWidth:'130px',minHeight:'45px'},onClick:handleVisibilityToggle}));};var prettifyMinimumLengthErrorIfExists=function prettifyMinimumLengthErrorIfExists(errorText){return errorText.includes('minimum length')?'Your message is too short. Please enter a minimum of 50 characters.':errorText;};var ErrorMessage=function ErrorMessage(_ref3){var errorText=_ref3.errorText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f4 mt2 dark-red mb0',style:{backgroundColor:'#f05e2442',color:'#dd3232',borderRadius:'2px',padding:'1em',fontSize:'12px'}},errorText);};

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SuccessCheckmark=function SuccessCheckmark(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:"64px",height:"64px",viewBox:"0 0 64 64",version:"1.1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("linearGradient",{x1:"52.525052%",y1:"100%",x2:"52.525052%",y2:"0%",id:"linearGradient-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{stopColor:"#8AC734",offset:"0%"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{stopColor:"#94DA31",offset:"100%"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Shopify-Onboarding-Pages",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"014-install-complete-copy-3",transform:"translate(-480.000000, -120.000000)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Verified",transform:"translate(480.000000, 120.000000)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{id:"Oval",fill:"url(#linearGradient-1)",cx:"31.6824647",cy:"32.3316212",r:"31.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{id:"Path-181",stroke:"#FFFFFF",strokeWidth:"2",strokeLinecap:"square",points:"18.1571568 32.8726335 26.2903553 41.0058321 44.6932669 22.6029205"})))));};/* harmony default export */ __webpack_exports__["a"] = (SuccessCheckmark);

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"RequestReviewModal":"RequestReviewModal","requestReviewModal":"RequestReviewModal"};

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var PageCopy=function PageCopy(_ref){var iconUrl=_ref.iconUrl,heading=_ref.heading,copy=_ref.copy,rest=_objectWithoutProperties(_ref,['iconUrl','heading','copy']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["e" /* Card */],Object.assign({className:'pa4 flex flex-row items-center'},rest),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img',{src:iconUrl,height:'80',alt:'','aria-hidden':'true',className:'mr3'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,heading&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'f3 brandon dark-gray mt0 mb2 pb1 lh-solid'},heading),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'mv0 gray lh-copy'},copy)));};/* harmony default export */ __webpack_exports__["a"] = (PageCopy);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollectionItemTranisitionProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_spring__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollectionItemTransitionProvider_scss__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollectionItemTransitionProvider_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CollectionItemTransitionProvider_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CollectionItemTranisitionProvider=function(_React$PureComponent){_inherits(CollectionItemTranisitionProvider,_React$PureComponent);function CollectionItemTranisitionProvider(){_classCallCheck(this,CollectionItemTranisitionProvider);return _possibleConstructorReturn(this,(CollectionItemTranisitionProvider.__proto__||Object.getPrototypeOf(CollectionItemTranisitionProvider)).apply(this,arguments));}_createClass(CollectionItemTranisitionProvider,[{key:'render',value:function render(){var _props=this.props,items=_props.items,itemKey=_props.itemKey,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'Collection'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_spring__["a" /* Transition */],{native:true,items:items,keys:itemKey,initial:{opacity:1,height:'auto',scale:1},leave:{opacity:0,height:0,scale:0}},items.map(function(item,index){return function(_ref){var opacity=_ref.opacity,height=_ref.height,scale=_ref.scale;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_spring__["b" /* animated */].div,{style:{opacity:opacity,height:height,transformOrigin:'50% 0',transform:scale.interpolate(function(v){return'scale('+v+')';}),// Ensure that the observation select menus are not clipped
// using relative positioning and decrementing z-index
// https://stackoverflow.com/questions/16687023/bug-with-transform-scale-and-overflow-hidden-in-chrome
position:'relative',zIndex:10+items.length-index},className:'Collection__ItemWrapper'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'Collection__Item'},children(item)));};})));}}]);return CollectionItemTranisitionProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Spring */
/* unused harmony export Keyframes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Transition; });
/* unused harmony export Trail */
/* unused harmony export Parallax */
/* unused harmony export ParallaxLayer */
/* unused harmony export Animation */
/* unused harmony export SpringAnimation */
/* unused harmony export AnimatedValue */
/* unused harmony export config */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return extendedAnimated; });
/* unused harmony export controller */
/* unused harmony export interpolate */
/* unused harmony export Globals */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var bugfixes = undefined;
var applyAnimatedValues = undefined;
var colorNames = [];
var requestFrame = function requestFrame(cb) {
  return global.requestAnimationFrame(cb);
};
var cancelFrame = function cancelFrame(cb) {
  return global.cancelAnimationFrame(cb);
};
var interpolation = undefined;
var now = function now() {
  return Date.now();
};
var defaultElement = undefined;
var injectApplyAnimatedValues = function injectApplyAnimatedValues(fn, transform) {
  return applyAnimatedValues = {
    fn: fn,
    transform: transform
  };
};
var injectColorNames = function injectColorNames(names) {
  return colorNames = names;
};
var injectBugfixes = function injectBugfixes(fn) {
  return bugfixes = fn;
};
var injectInterpolation = function injectInterpolation(cls) {
  return interpolation = cls;
};
var injectFrame = function injectFrame(raf, caf) {
  var _ref;

  return _ref = [raf, caf], requestFrame = _ref[0], cancelFrame = _ref[1], _ref;
};
var injectNow = function injectNow(nowFn) {
  return now = nowFn;
};
var injectDefaultElement = function injectDefaultElement(el) {
  return defaultElement = el;
};

var Globals = /*#__PURE__*/Object.freeze({
  get bugfixes () { return bugfixes; },
  get applyAnimatedValues () { return applyAnimatedValues; },
  get colorNames () { return colorNames; },
  get requestFrame () { return requestFrame; },
  get cancelFrame () { return cancelFrame; },
  get interpolation () { return interpolation; },
  get now () { return now; },
  get defaultElement () { return defaultElement; },
  injectApplyAnimatedValues: injectApplyAnimatedValues,
  injectColorNames: injectColorNames,
  injectBugfixes: injectBugfixes,
  injectInterpolation: injectInterpolation,
  injectFrame: injectFrame,
  injectNow: injectNow,
  injectDefaultElement: injectDefaultElement
});

var colors = {
  transparent: 0x00000000,
  // http://www.w3.org/TR/css3-color/#svg-color
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff
};

var linear = function linear(t) {
  return t;
};

var Interpolation =
/*#__PURE__*/
function () {
  function Interpolation() {}

  Interpolation.create = function create(config) {
    if (typeof config === 'function') return config;
    if (interpolation && config.output && typeof config.output[0] === 'string') return interpolation(config);
    var outputRange = config.output;
    var inputRange = config.range;
    var easing = config.easing || linear;
    var extrapolateLeft = 'extend';
    var map = config.map;

    if (config.extrapolateLeft !== undefined) {
      extrapolateLeft = config.extrapolateLeft;
    } else if (config.extrapolate !== undefined) {
      extrapolateLeft = config.extrapolate;
    }

    var extrapolateRight = 'extend';

    if (config.extrapolateRight !== undefined) {
      extrapolateRight = config.extrapolateRight;
    } else if (config.extrapolate !== undefined) {
      extrapolateRight = config.extrapolate;
    }

    return function (input) {
      var range = findRange(input, inputRange);
      return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, map);
    };
  };

  return Interpolation;
}();

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  var result = map ? map(input) : input; // Extrapolate

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') {
      return result;
    } else if (extrapolateLeft === 'clamp') {
      result = inputMin;
    }
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') {
      return result;
    } else if (extrapolateRight === 'clamp') {
      result = inputMax;
    }
  }

  if (outputMin === outputMax) return outputMin;

  if (inputMin === inputMax) {
    if (input <= inputMin) return outputMin;
    return outputMax;
  } // Input Range


  if (inputMin === -Infinity) {
    result = -result;
  } else if (inputMax === Infinity) {
    result = result - inputMin;
  } else {
    result = (result - inputMin) / (inputMax - inputMin);
  } // Easing


  result = easing(result); // Output Range

  if (outputMin === -Infinity) {
    result = -result;
  } else if (outputMax === Infinity) {
    result = result + outputMin;
  } else {
    result = result * (outputMax - outputMin) + outputMin;
  }

  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) {
    if (inputRange[i] >= input) break;
  }

  return i - 1;
}

// const INTEGER = '[-+]?\\d+';
var NUMBER = '[-+]?\\d*\\.?\\d+';
var PERCENTAGE = NUMBER + '%';

function call() {
  return '\\(\\s*(' + Array.prototype.slice.call(arguments).join(')\\s*,\\s*(') + ')\\s*\\)';
}

var rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
var rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;

/*
https://github.com/react-community/normalize-css-color

BSD 3-Clause License

Copyright (c) 2016, React Community
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

* Neither the name of the copyright holder nor the names of its
  contributors may be used to endorse or promote products derived from
  this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
function normalizeColor(color) {
  var match;

  if (typeof color === 'number') {
    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
  } // Ordered based on occurrences on Facebook codebase


  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
  if (colors.hasOwnProperty(color)) return colors[color];

  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    0x000000ff) >>> // a
    0;
  }

  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }

  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    'ff', // a
    16) >>> 0;
  } // https://drafts.csswg.org/css-color-4/#hex-notation


  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
  }

  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | 0x000000ff) >>> // a
    0;
  }

  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | parse1(match[4])) >>> // a
    0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function hslToRgb(h, s, l) {
  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  var p = 2 * l - q;
  var r = hue2rgb(p, q, h + 1 / 3);
  var g = hue2rgb(p, q, h);
  var b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  var int = parseInt(str, 10);
  if (int < 0) return 0;
  if (int > 255) return 255;
  return int;
}

function parse360(str) {
  var int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}

function parse1(str) {
  var num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  var int = parseFloat(str);
  if (int < 0) return 0;
  if (int > 100) return 1;
  return int / 100;
}

function colorToRgba(input) {
  var int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  var r = (int32Color & 0xff000000) >>> 24;
  var g = (int32Color & 0x00ff0000) >>> 16;
  var b = (int32Color & 0x0000ff00) >>> 8;
  var a = (int32Color & 0x000000ff) / 255;
  return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
} // Problem: https://github.com/animatedjs/animated/pull/102
// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662


var stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g; // Covers rgb, rgba, hsl, hsla
// Taken from https://gist.github.com/olmokramer/82ccce673f86db7cda5e

var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi; // Covers color names (transparent, blue, etc.)

var colorNamesRegex = new RegExp("(" + Object.keys(colors).join('|') + ")", 'g');
/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *   rgba(123, 42, 99, 0.36)           // colors
 *   -45deg                            // values with units
 *   0 2px 2px 0px rgba(0, 0, 0, 0.12) // box shadows
 */

function createInterpolation(config) {
  // Replace colors with rgba
  var outputRange = config.output.map(function (rangeValue) {
    return rangeValue.replace(colorRegex, colorToRgba);
  }).map(function (rangeValue) {
    return rangeValue.replace(colorNamesRegex, colorToRgba);
  }); // ->
  // [
  //   [0, 50],
  //   [100, 150],
  //   [200, 250],
  //   [0, 0.5],
  // ]

  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
    return [];
  });
  outputRange.forEach(function (value) {
    value.match(stringShapeRegex).forEach(function (number, i) {
      return outputRanges[i].push(+number);
    });
  });
  var interpolations = outputRange[0].match(stringShapeRegex).map(function (value, i) {
    return Interpolation.create(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, config, {
      output: outputRanges[i]
    }));
  });
  var shouldRound = /^rgb/.test(outputRange[0]);
  return function (input) {
    var i = 0;
    return outputRange[0] // 'rgba(0, 100, 200, 0)'
    // ->
    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
    .replace(stringShapeRegex, function () {
      return interpolations[i++](input);
    }) // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
    // round the opacity (4th column).
    .replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, function (_, p1, p2, p3, p4) {
      return "rgba(" + Math.round(p1) + ", " + Math.round(p2) + ", " + Math.round(p3) + ", " + p4 + ")";
    });
  };
}

var Animated =
/*#__PURE__*/
function () {
  function Animated() {}

  var _proto = Animated.prototype;

  _proto.__attach = function __attach() {};

  _proto.__detach = function __detach() {};

  _proto.__getValue = function __getValue() {};

  _proto.__getAnimatedValue = function __getAnimatedValue() {
    return this.__getValue();
  };

  _proto.__addChild = function __addChild(child) {};

  _proto.__removeChild = function __removeChild(child) {};

  _proto.__getChildren = function __getChildren() {
    return [];
  };

  return Animated;
}();

var AnimatedTracking =
/*#__PURE__*/
function (_Animated) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AnimatedTracking, _Animated);

  function AnimatedTracking(value, parent, animationClass, animationConfig, callback) {
    var _this;

    _this = _Animated.call(this) || this;
    _this.update = throttle(function () {
      _this._value.animate(new _this._animationClass(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this._animationConfig, {
        to: _this._animationConfig.to.__getValue()
      })), _this._callback);
    }, 1000 / 30);
    _this._value = value;
    _this._parent = parent;
    _this._animationClass = animationClass;
    _this._animationConfig = animationConfig;
    _this._callback = callback;

    _this.__attach();

    return _this;
  }

  var _proto = AnimatedTracking.prototype;

  _proto.__getValue = function __getValue() {
    return this._parent.__getValue();
  };

  _proto.__attach = function __attach() {
    this._parent.__addChild(this);
  };

  _proto.__detach = function __detach() {
    this._parent.__removeChild(this);
  };

  return AnimatedTracking;
}(Animated);

function throttle(func, wait) {
  var timeout = null;
  var previous = 0;

  var later = function later() {
    return func(previous = Date.now(), timeout = null);
  };

  return function () {
    var now = Date.now();
    var remaining = wait - (now - previous);

    if (remaining <= 0 || remaining > wait) {
      if (timeout) void (clearTimeout(timeout), timeout = null);
      func(previous = now);
    } else if (!timeout) timeout = setTimeout(later, remaining);
  };
}

var AnimatedWithChildren =
/*#__PURE__*/
function (_Animated) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AnimatedWithChildren, _Animated);

  function AnimatedWithChildren() {
    var _this;

    _this = _Animated.call(this) || this;
    _this._children = [];
    return _this;
  }

  var _proto = AnimatedWithChildren.prototype;

  _proto.__addChild = function __addChild(child) {
    if (this._children.length === 0) this.__attach();

    this._children.push(child);
  };

  _proto.__removeChild = function __removeChild(child) {
    var index = this._children.indexOf(child);

    if (index === -1) {
      if (false) {
        console.warn("Trying to remove a child that doesn't exist");
      }

      return;
    }

    this._children.splice(index, 1);

    if (this._children.length === 0) this.__detach();
  };

  _proto.__getChildren = function __getChildren() {
    return this._children;
  };

  return AnimatedWithChildren;
}(Animated);

var AnimatedInterpolation =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AnimatedInterpolation, _AnimatedWithChildren);

  function AnimatedInterpolation(parents, config) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    _this._parents = parents._values ? parents._values : Array.isArray(parents) ? parents : [parents];
    _this._interpolation = Interpolation.create(config);
    return _this;
  }

  var _proto = AnimatedInterpolation.prototype;

  _proto.__getValue = function __getValue() {
    return this._interpolation.apply(this, this._parents.map(function (value) {
      return value.__getValue();
    }));
  };

  _proto.__attach = function __attach() {
    for (var i = 0; i < this._parents.length; ++i) {
      if (this._parents[i] instanceof Animated) this._parents[i].__addChild(this);
    }
  };

  _proto.__detach = function __detach() {
    for (var i = 0; i < this._parents.length; ++i) {
      if (this._parents[i] instanceof Animated) this._parents[i].__removeChild(this);
    }
  };

  _proto.__update = function __update(config) {
    this._interpolation = Interpolation.create(config);
    return this;
  };

  _proto.interpolate = function interpolate(config) {
    return new AnimatedInterpolation(this, config);
  };

  return AnimatedInterpolation;
}(AnimatedWithChildren);
var interpolate$1 = function interpolate(parents, config) {
  return new AnimatedInterpolation(parents, config);
};

var _uniqueId = 0;
/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an Animated.Value is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */

function findAnimatedStyles(node, styles) {
  if (typeof node.update === 'function') styles.add(node);else node.__getChildren().forEach(function (child) {
    return findAnimatedStyles(child, styles);
  });
}
/**
 * Standard value for driving animations.  One `Animated.Value` can drive
 * multiple properties in a synchronized fashion, but can only be driven by one
 * mechanism at a time.  Using a new mechanism (e.g. starting a new animation,
 * or calling `setValue`) will stop any previous ones.
 */


var AnimatedValue =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AnimatedValue, _AnimatedWithChildren);

  function AnimatedValue(_value) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;

    _this._updateValue = function (value) {
      _this._value = value;

      _this._flush();

      for (var key in _this._listeners) {
        _this._listeners[key]({
          value: value
        });
      }
    };

    _this._value = _value;
    _this._animation = null;
    _this._animatedStyles = new Set();
    _this._listeners = {};
    return _this;
  }

  var _proto = AnimatedValue.prototype;

  _proto.__detach = function __detach() {
    this.stopAnimation();
  };

  _proto.__getValue = function __getValue() {
    return this._value;
  };

  _proto._update = function _update() {
    findAnimatedStyles(this, this._animatedStyles);
  };

  _proto._flush = function _flush() {
    if (this._animatedStyles.size === 0) this._update();

    this._animatedStyles.forEach(function (animatedStyle) {
      return animatedStyle.update();
    });
  };

  /**
   * Directly set the value.  This will stop any animations running on the value
   * and update all the bound properties.
   */
  _proto.setValue = function setValue(value) {
    if (this._animation) {
      this._animation.stop();

      this._animation = null;
    }

    this._animatedStyles.clear();

    this._updateValue(value);
  };
  /**
   * Stops any running animation or tracking.  `callback` is invoked with the
   * final value after stopping the animation, which is useful for updating
   * state to match the animation position with layout.
   */


  _proto.stopAnimation = function stopAnimation(callback) {
    this.stopTracking();
    this._animation && this._animation.stop();
    this._animation = null;
    callback && callback(this.__getValue());
  };
  /**
   * Interpolates the value before updating the property, e.g. mapping 0-1 to
   * 0-10.
   */


  _proto.interpolate = function interpolate(config) {
    return new AnimatedInterpolation(this, config);
  };
  /**
   * Typically only used internally, but could be used by a custom Animation
   * class.
   */


  _proto.animate = function animate(animation, callback) {
    var _this2 = this;

    var previousAnimation = this._animation;
    this._animation && this._animation.stop();
    this._animation = animation;

    this._animatedStyles.clear();

    animation.start(this._value, this._updateValue, function (result) {
      _this2._animation = null;
      callback && callback(result);
    }, previousAnimation);
  };
  /**
   * Adds an asynchronous listener to the value so you can observe updates from
   * animations.  This is useful because there is no way to
   * synchronously read the value because it might be driven natively.
   */


  _proto.addListener = function addListener(callback) {
    var id = String(_uniqueId++);
    this._listeners[id] = callback;
    return id;
  };

  _proto.removeListener = function removeListener(id) {
    delete this._listeners[id];
  };

  _proto.removeAllListeners = function removeAllListeners() {
    this._listeners = {};
  };
  /**
   * Typically only used internally.
   */


  _proto.stopTracking = function stopTracking() {
    this._tracking && this._tracking.__detach();
    this._tracking = null;
  };
  /**
   * Typically only used internally.
   */


  _proto.track = function track(tracking) {
    this.stopTracking();
    this._tracking = tracking;
  };

  return AnimatedValue;
}(AnimatedWithChildren);

function shallowEqual(a, b) {
  for (var i in a) {
    if (!(i in b)) return false;
  }

  for (var _i in b) {
    if (a[_i] !== b[_i]) return false;
  }

  return true;
}
function callProp(obj, state) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return typeof obj === 'function' ? obj.apply(void 0, [state].concat(args)) : obj;
}
function getValues(object) {
  return Object.keys(object).map(function (k) {
    return object[k];
  });
}
function getForwardProps(props) {
  var to = props.to,
      from = props.from,
      config = props.config,
      native = props.native,
      onRest = props.onRest,
      onFrame = props.onFrame,
      children = props.children,
      render = props.render,
      reset = props.reset,
      reverse = props.reverse,
      force = props.force,
      immediate = props.immediate,
      impl = props.impl,
      inject = props.inject,
      delay = props.delay,
      attach = props.attach,
      destroyed = props.destroyed,
      forward = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["to", "from", "config", "native", "onRest", "onFrame", "children", "render", "reset", "reverse", "force", "immediate", "impl", "inject", "delay", "attach", "destroyed"]);

  return forward;
}
function renderChildren(props, componentProps) {
  var forward = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, componentProps, getForwardProps(props));

  return props.render ? props.render(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, forward, {
    children: props.children
  })) : props.children(forward);
}
function convertToAnimatedValue(acc, _ref) {
  var _extends2;

  var name = _ref[0],
      value = _ref[1];
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, acc, (_extends2 = {}, _extends2[name] = new AnimatedValue(value), _extends2));
}
function convertValues(props) {
  var from = props.from,
      to = props.to,
      native = props.native;
  var allProps = Object.entries(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, from, to));
  return native ? allProps.reduce(convertToAnimatedValue, {}) : Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, from, to);
}

var check = function check(value) {
  return value === 'auto';
};

var overwrite = function overwrite(width, height) {
  return function (acc, _ref) {
    var _extends2;

    var name = _ref[0],
        value = _ref[1];
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, acc, (_extends2 = {}, _extends2[name] = value === 'auto' ? ~name.indexOf('height') ? height : width : value, _extends2));
  };
};

function fixAuto(props, callback) {
  var from = props.from,
      to = props.to; // Dry-route props back if nothing's using 'auto' in there
  // TODO: deal with "null"

  if (!(getValues(to).some(check) || getValues(from).some(check))) return; // Fetch render v-dom

  var element = renderChildren(props, convertValues(props)); // A spring can return undefined/null, check against that (#153)

  if (!element) return;
  var elementStyles = element.props.style; // Return v.dom with injected ref

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(element.type, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    key: element.key
  }, element.props, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, elementStyles, {
      position: 'absolute',
      visibility: 'hidden'
    }),
    ref: function ref(_ref2) {
      if (_ref2) {
        // Once it's rendered out, fetch bounds (minus padding/margin/borders)
        var node = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(_ref2);
        var width, height;
        var cs = getComputedStyle(node);

        if (cs.boxSizing === 'border-box') {
          width = node.offsetWidth;
          height = node.offsetHeight;
        } else {
          var paddingX = parseFloat(cs.paddingLeft || 0) + parseFloat(cs.paddingRight || 0);
          var paddingY = parseFloat(cs.paddingTop || 0) + parseFloat(cs.paddingBottom || 0);
          var borderX = parseFloat(cs.borderLeftWidth || 0) + parseFloat(cs.borderRightWidth || 0);
          var borderY = parseFloat(cs.borderTopWidth || 0) + parseFloat(cs.borderBottomWidth || 0);
          width = node.offsetWidth - paddingX - borderX;
          height = node.offsetHeight - paddingY - borderY;
        }

        var convert = overwrite(width, height);
        callback(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          from: Object.entries(from).reduce(convert, from),
          to: Object.entries(to).reduce(convert, to)
        }));
      }
    }
  }));
}

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

var prefixKey = function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
};

var prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce(function (acc, prop) {
  prefixes.forEach(function (prefix) {
    return acc[prefixKey(prefix, prop)] = acc[prop];
  });
  return acc;
}, isUnitlessNumber);

function dangerousStyleValue(name, value, isCustomProperty) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers

  return ('' + value).trim();
}

injectDefaultElement('div');
injectInterpolation(createInterpolation);
injectColorNames(colors);
injectBugfixes(fixAuto);
injectApplyAnimatedValues(function (instance, props) {
  if (instance.nodeType && instance.setAttribute !== undefined) {
    var style = props.style,
        children = props.children,
        scrollTop = props.scrollTop,
        scrollLeft = props.scrollLeft,
        attributes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["style", "children", "scrollTop", "scrollLeft"]);

    if (scrollTop) instance.scrollTop = scrollTop;
    if (scrollLeft) instance.scrollLeft = scrollLeft; // Set textContent, if children is an animatable value

    if (children) instance.textContent = children; // Set styles ...

    for (var styleName in style) {
      if (!style.hasOwnProperty(styleName)) continue;
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = dangerousStyleValue(styleName, style[styleName], isCustomProperty);
      if (styleName === 'float') styleName = 'cssFloat';
      if (isCustomProperty) instance.style.setProperty(styleName, styleValue);else instance.style[styleName] = styleValue;
    } // Set attributes ...


    for (var name in attributes) {
      var dashCase = name.replace(/([A-Z])/g, function ($1) {
        return '-' + $1.toLowerCase();
      });
      if (typeof instance.getAttribute(dashCase) !== 'undefined') instance.setAttribute(dashCase, attributes[name]);
    }
  } else return false;
}, function (style) {
  return style;
});

// Important note: start() and stop() will only be called at most once.
// Once an animation has been stopped or finished its course, it will
// not be reused.
var Animation =
/*#__PURE__*/
function () {
  function Animation() {}

  var _proto = Animation.prototype;

  _proto.start = function start(fromValue, onUpdate, onEnd, previousAnimation) {};

  _proto.stop = function stop() {}; // Helper function for subclasses to make sure onEnd is only called once.


  _proto.__debouncedOnEnd = function __debouncedOnEnd(result) {
    var onEnd = this.__onEnd;
    this.__onEnd = null;
    onEnd && onEnd(result);
  };

  return Animation;
}();

var withDefault = function withDefault(value, defaultValue) {
  return value === undefined || value === null ? defaultValue : value;
};

var tensionFromOrigamiValue = function tensionFromOrigamiValue(oValue) {
  return (oValue - 30) * 3.62 + 194;
};

var frictionFromOrigamiValue = function frictionFromOrigamiValue(oValue) {
  return (oValue - 8) * 3 + 25;
};

var fromOrigamiTensionAndFriction = function fromOrigamiTensionAndFriction(tension, friction) {
  return {
    tension: tensionFromOrigamiValue(tension),
    friction: frictionFromOrigamiValue(friction)
  };
};

var SpringAnimation =
/*#__PURE__*/
function (_Animation) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SpringAnimation, _Animation);

  function SpringAnimation(config) {
    var _this;

    _this = _Animation.call(this) || this;

    _this.startAsync = function () {
      _this._lastTime = now();

      if (typeof _this._startPosition === 'string' || typeof _this._to === 'string') {
        _this._onUpdate(_this._to);

        return _this.__debouncedOnEnd({
          finished: true
        });
      }

      if (_this.__previous instanceof SpringAnimation) {
        var internalState = _this.__previous.getInternalState();

        _this._lastPosition = internalState.lastPosition;
        _this._lastVelocity = internalState.lastVelocity;
        _this._lastTime = internalState.lastTime;
      }

      if (_this._initialVelocity !== undefined && _this._initialVelocity !== null) _this._lastVelocity = _this._initialVelocity;

      _this.onUpdate();
    };

    _this.onUpdate = function () {
      var position = _this._lastPosition;
      var velocity = _this._lastVelocity;
      var tempPosition = _this._lastPosition;
      var tempVelocity = _this._lastVelocity; // If for some reason we lost a lot of frames (e.g. process large payload or
      // stopped in the debugger), we only advance by 4 frames worth of
      // computation and will continue on the next frame. It's better to have it
      // running at faster speed than jumping to the end.

      var MAX_STEPS = 64;
      var now$$1 = now();
      if (now$$1 > _this._lastTime + MAX_STEPS) now$$1 = _this._lastTime + MAX_STEPS; // We are using a fixed time step and a maximum number of iterations.
      // The following post provides a lot of thoughts into how to build this
      // loop: http://gafferongames.com/game-physics/fix-your-timestep/

      var TIMESTEP_MSEC = 1;
      var numSteps = Math.floor((now$$1 - _this._lastTime) / TIMESTEP_MSEC);

      for (var i = 0; i < numSteps; ++i) {
        // Velocity is based on seconds instead of milliseconds
        var step = TIMESTEP_MSEC / 1000; // This is using RK4. A good blog post to understand how it works:
        // http://gafferongames.com/game-physics/integration-basics/

        var aVelocity = velocity;
        var aAcceleration = _this._tension * (_this._to - tempPosition) - _this._friction * tempVelocity;
        tempPosition = position + aVelocity * step / 2;
        tempVelocity = velocity + aAcceleration * step / 2;
        var bVelocity = tempVelocity;
        var bAcceleration = _this._tension * (_this._to - tempPosition) - _this._friction * tempVelocity;
        tempPosition = position + bVelocity * step / 2;
        tempVelocity = velocity + bAcceleration * step / 2;
        var cVelocity = tempVelocity;
        var cAcceleration = _this._tension * (_this._to - tempPosition) - _this._friction * tempVelocity;
        tempPosition = position + cVelocity * step / 2;
        tempVelocity = velocity + cAcceleration * step / 2;
        var dVelocity = tempVelocity;
        var dAcceleration = _this._tension * (_this._to - tempPosition) - _this._friction * tempVelocity;
        tempPosition = position + cVelocity * step / 2;
        tempVelocity = velocity + cAcceleration * step / 2;
        var dxdt = (aVelocity + 2 * (bVelocity + cVelocity) + dVelocity) / 6;
        var dvdt = (aAcceleration + 2 * (bAcceleration + cAcceleration) + dAcceleration) / 6;
        position += dxdt * step;
        velocity += dvdt * step;
      }

      _this._lastTime = now$$1;
      _this._lastPosition = position;
      _this._lastVelocity = velocity; // Conditions for stopping the spring animation

      var isOvershooting = _this._overshootClamping && _this._tension !== 0 ? _this._startPosition < _this._to ? position > _this._to : position < _this._to : false;

      var isVelocity = Math.abs(velocity) <= _this._restSpeedThreshold;

      var isDisplacement = _this._tension !== 0 ? Math.abs(_this._to - position) <= _this._restDisplacementThreshold : true;
      var endOfAnimation = isOvershooting || isVelocity && isDisplacement; // a listener might have stopped us in _onUpdate

      if (!_this.__active) return;

      if (endOfAnimation) {
        // Ensure that we end up with a round value
        if (_this._tension !== 0) _this._onUpdate(_this._to);
        return _this.__debouncedOnEnd({
          finished: true
        });
      } else _this._onUpdate(position);

      _this._animationFrame = requestFrame(_this.onUpdate);
    };

    _this._overshootClamping = withDefault(config.overshootClamping, false);
    _this._restDisplacementThreshold = withDefault(config.restDisplacementThreshold, 0.0001);
    _this._restSpeedThreshold = withDefault(config.restSpeedThreshold, 0.0001);
    _this._initialVelocity = config.velocity;
    _this._lastVelocity = withDefault(config.velocity, 0);
    _this._to = config.to;
    var springConfig = fromOrigamiTensionAndFriction(withDefault(config.tension, 40), withDefault(config.friction, 7));
    _this._tension = springConfig.tension;
    _this._friction = springConfig.friction;
    _this._delay = withDefault(config.delay, 0);
    return _this;
  }

  var _proto = SpringAnimation.prototype;

  _proto.start = function start(fromValue, onUpdate, onEnd, previousAnimation) {
    this.__active = true;
    this._startPosition = fromValue;
    this._lastPosition = this._startPosition;
    this._onUpdate = onUpdate;
    this.__onEnd = onEnd;
    this.__previous = previousAnimation;

    if (this._delay > 0) {
      if (this._timer) {
        clearTimeout(this._timer);
        this._timer = undefined;
      }

      this._timer = setTimeout(this.startAsync, this._delay);
    } else this.startAsync();
  };

  _proto.getInternalState = function getInternalState() {
    return {
      lastPosition: this._lastPosition,
      lastVelocity: this._lastVelocity,
      lastTime: this._lastTime
    };
  };

  _proto.stop = function stop() {
    this.__active = false;
    clearTimeout(this._timeout);
    this._timeout = undefined;
    cancelFrame(this._animationFrame);

    this.__debouncedOnEnd({
      finished: false
    });
  };

  return SpringAnimation;
}(Animation);

var AnimatedArray =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AnimatedArray, _AnimatedWithChildren);

  function AnimatedArray(array) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    _this._values = array.map(function (n) {
      return new AnimatedValue(n);
    });
    return _this;
  }

  var _proto = AnimatedArray.prototype;

  _proto.setValue = function setValue(values) {
    var _this2 = this;

    values.forEach(function (n, i) {
      return _this2._values[i].setValue(n);
    });
  };

  _proto.__getValue = function __getValue() {
    return this._values.map(function (v) {
      return v.__getValue();
    });
  };

  _proto.stopAnimation = function stopAnimation(callback) {
    this._values.forEach(function (v) {
      return v.stopAnimation();
    });

    callback && callback(this.__getValue());
  };

  _proto.__attach = function __attach() {
    for (var i = 0; i < this._values.length; ++i) {
      if (this._values[i] instanceof Animated) this._values[i].__addChild(this);
    }
  };

  _proto.__detach = function __detach() {
    for (var i = 0; i < this._values.length; ++i) {
      if (this._values[i] instanceof Animated) this._values[i].__removeChild(this);
    }
  };

  return AnimatedArray;
}(AnimatedWithChildren);

function maybeVectorAnim(array, _ref, anim, impl) {
  var to = _ref.to,
      rest = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["to"]);

  if (array instanceof AnimatedArray) return parallel(array._values.map(function (v, i) {
    return anim(v, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      to: to[i]
    }), impl);
  }), {
    stopTogether: false
  });
  return null;
}

function parallel(animations, config) {
  var doneCount = 0;
  var hasEnded = {};
  var stopTogether = !(config && config.stopTogether === false);
  var result = {
    start: function start(callback) {
      if (doneCount === animations.length) return callback && callback({
        finished: true
      });
      animations.forEach(function (animation, idx) {
        var cb = function cb(endResult) {
          hasEnded[idx] = true;
          doneCount++;

          if (doneCount === animations.length) {
            doneCount = 0;
            return callback && callback(endResult);
          }

          if (!endResult.finished && stopTogether) result.stop();
        };

        if (!animation) cb({
          finished: true
        });else animation.start(cb);
      });
    },
    stop: function stop() {
      animations.forEach(function (animation, idx) {
        !hasEnded[idx] && animation.stop();
        hasEnded[idx] = true;
      });
    }
  };
  return result;
}

function controller(value, config, impl) {
  if (impl === void 0) {
    impl = SpringAnimation;
  }

  return maybeVectorAnim(value, config, controller, impl) || {
    start: function start(callback) {
      var singleValue = value;
      var singleConfig = config;
      singleValue.stopTracking();
      if (config.to instanceof Animated) singleValue.track(new AnimatedTracking(singleValue, config.to, impl, singleConfig, callback));else singleValue.animate(new impl(singleConfig), callback);
    },
    stop: function stop() {
      value.stopAnimation();
    }
  };
}

var AnimatedStyle =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AnimatedStyle, _AnimatedWithChildren);

  function AnimatedStyle(style) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    style = style || {};
    if (style.transform && !(style.transform instanceof Animated)) style = applyAnimatedValues.transform(style);
    _this._style = style;
    return _this;
  }

  var _proto = AnimatedStyle.prototype;

  _proto.__getValue = function __getValue() {
    var style = {};

    for (var key in this._style) {
      var value = this._style[key];
      style[key] = value instanceof Animated ? value.__getValue() : value;
    }

    return style;
  };

  _proto.__getAnimatedValue = function __getAnimatedValue() {
    var style = {};

    for (var key in this._style) {
      var value = this._style[key];
      if (value instanceof Animated) style[key] = value.__getAnimatedValue();
    }

    return style;
  };

  _proto.__attach = function __attach() {
    for (var key in this._style) {
      var value = this._style[key];
      if (value instanceof Animated) value.__addChild(this);
    }
  };

  _proto.__detach = function __detach() {
    for (var key in this._style) {
      var value = this._style[key];
      if (value instanceof Animated) value.__removeChild(this);
    }
  };

  return AnimatedStyle;
}(AnimatedWithChildren);

var AnimatedProps =
/*#__PURE__*/
function (_Animated) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AnimatedProps, _Animated);

  function AnimatedProps(props, callback) {
    var _this;

    _this = _Animated.call(this) || this;

    if (props.style) {
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        style: new AnimatedStyle(props.style)
      });
    }

    _this._props = props;
    _this._callback = callback;

    _this.__attach();

    return _this;
  }

  var _proto = AnimatedProps.prototype;

  _proto.__getValue = function __getValue() {
    var props = {};

    for (var key in this._props) {
      var value = this._props[key];
      if (value instanceof Animated) props[key] = value.__getValue();else props[key] = value;
    }

    return props;
  };

  _proto.__getAnimatedValue = function __getAnimatedValue() {
    var props = {};

    for (var key in this._props) {
      var value = this._props[key];
      if (value instanceof Animated) props[key] = value.__getAnimatedValue();
    }

    return props;
  };

  _proto.__attach = function __attach() {
    for (var key in this._props) {
      var value = this._props[key];
      if (value instanceof Animated) value.__addChild(this);
    }
  };

  _proto.__detach = function __detach() {
    for (var key in this._props) {
      var value = this._props[key];
      if (value instanceof Animated) value.__removeChild(this);
    }
  };

  _proto.update = function update() {
    this._callback();
  };

  return AnimatedProps;
}(Animated);

function createAnimatedComponent(Component) {
  var AnimatedComponent =
  /*#__PURE__*/
  function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AnimatedComponent, _React$Component);

    function AnimatedComponent() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = AnimatedComponent.prototype;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this._propsAnimated && this._propsAnimated.__detach();
    };

    _proto.setNativeProps = function setNativeProps(props) {
      var didUpdate = applyAnimatedValues.fn(this.node, props, this);
      if (didUpdate === false) this.forceUpdate();
    };

    _proto.componentWillMount = function componentWillMount() {
      this.attachProps(this.props);
    };

    _proto.attachProps = function attachProps(_ref) {
      var _this = this;

      var forwardRef = _ref.forwardRef,
          nextProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["forwardRef"]);

      var oldPropsAnimated = this._propsAnimated; // The system is best designed when setNativeProps is implemented. It is
      // able to avoid re-rendering and directly set the attributes that
      // changed. However, setNativeProps can only be implemented on leaf
      // native components. If you want to animate a composite component, you
      // need to re-render it. In this case, we have a fallback that uses
      // forceUpdate.

      var callback = function callback() {
        if (_this.node) {
          var didUpdate = applyAnimatedValues.fn(_this.node, _this._propsAnimated.__getAnimatedValue(), _this);
          if (didUpdate === false) _this.forceUpdate();
        }
      };

      this._propsAnimated = new AnimatedProps(nextProps, callback); // When you call detach, it removes the element from the parent list
      // of children. If it goes to 0, then the parent also detaches itself
      // and so on.
      // An optimization is to attach the new elements and THEN detach the old
      // ones instead of detaching and THEN attaching.
      // This way the intermediate state isn't to go to 0 and trigger
      // this expensive recursive detaching to then re-attach everything on
      // the very next operation.

      oldPropsAnimated && oldPropsAnimated.__detach();
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      this.attachProps(nextProps);
    };

    _proto.render = function render() {
      var _this2 = this;

      var forwardRef = this.props.forwardRef;

      var _this$_propsAnimated$ = this._propsAnimated.__getValue(),
          scrollTop = _this$_propsAnimated$.scrollTop,
          scrollLeft = _this$_propsAnimated$.scrollLeft,
          animatedProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$_propsAnimated$, ["scrollTop", "scrollLeft"]);

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, animatedProps, {
        ref: function ref(node) {
          _this2.node = node;
          var forwardRef = _this2.props.forwardRef;

          if (forwardRef) {
            // If it's a function, assume it's a ref callback
            if (typeof forwardRef === 'function') forwardRef(node); // If it's an object and has a 'current' property, assume it's a ref object
            else if (typeof forwardRef === 'object') forwardRef.current = node;
          }
        }
      }));
    };

    return AnimatedComponent;
  }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(AnimatedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      forwardRef: ref
    }));
  });
}

var config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};

var v = __WEBPACK_IMPORTED_MODULE_3_react___default.a.version.split('.');

if (false) {
  console.warn('Please consider upgrading to react/react-dom 16.4.x or higher! Older React versions break getDerivedStateFromProps, see https://github.com/facebook/react/issues/12898');
}

var Spring =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Spring, _React$Component);

  function Spring() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      lastProps: {
        from: {},
        to: {}
      },
      propsChanged: false,
      internal: false
    };
    _this.didUpdate = false;
    _this.didInject = false;
    _this.updating = false;
    _this.animations = {};
    _this.interpolators = {};
    _this.mergedProps = {};

    _this.start = function () {
      var _this$props = _this.props,
          config$$1 = _this$props.config,
          delay = _this$props.delay,
          impl = _this$props.impl;
      if (_this.props.onStart) _this.props.onStart();
      Object.keys(_this.animations).forEach(function (name) {
        var _this$animations$name = _this.animations[name],
            animation = _this$animations$name.animation,
            to = _this$animations$name.toValue; // TODO: figure out why this is needed ...

        if (!to.__getValue && animation.__getValue() === to) return _this.finishAnimation(name);
        controller(animation, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          to: to,
          delay: delay
        }, callProp(config$$1, name)), impl).start(!to.__getValue && function (props) {
          return props.finished && _this.finishAnimation(name);
        });
      });
    };

    _this.stop = function () {
      return getValues(_this.animations).forEach(function (_ref) {
        var animation = _ref.animation;
        return animation.stopAnimation();
      });
    };

    _this.finishAnimation = function (name) {
      var _this$animations$name2 = _this.animations[name],
          animation = _this$animations$name2.animation,
          to = _this$animations$name2.toValue;
      _this.animations[name].stopped = true;
      if (!_this.mounted) return;

      if (getValues(_this.animations).every(function (a) {
        return a.stopped;
      })) {
        var current = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props.from, _this.props.to);

        if (_this.props.onRest) _this.props.onRest(current); // Restore end-state

        if (_this.didInject) {
          _this.afterInject = convertValues(_this.props);
          _this.didInject = false;

          _this.setState({
            internal: true
          });
        }
      }
    };

    return _this;
  }

  var _proto = Spring.prototype;

  _proto.componentDidMount = function componentDidMount() {
    // componentDidUpdate isn't called on mount, we call it here to start animating
    this.componentDidUpdate();
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    // Stop all ongoing animtions
    this.mounted = false;
    this.stop();
  };

  Spring.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
    var internal = _ref2.internal,
        lastProps = _ref2.lastProps;
    // The following is a test against props that could alter the animation
    var from = props.from,
        to = props.to,
        reset = props.reset,
        force = props.force;
    var propsChanged = !shallowEqual(to, lastProps.to) || !shallowEqual(from, lastProps.from) || reset && !internal || force && !internal;
    return {
      propsChanged: propsChanged,
      lastProps: props,
      internal: false
    };
  };

  _proto.render = function render() {
    var _this2 = this;

    var propsChanged = this.state.propsChanged; // Handle injected frames, for instance targets/web/fix-auto
    // An inject will return an intermediary React node which measures itself out
    // .. and returns a callback when the values sought after are ready, usually "auto".

    if (this.props.inject && propsChanged && !this.injectProps) {
      var frame = this.props.inject(this.props, function (injectProps) {
        // The inject frame has rendered, now let's update animations...
        _this2.injectProps = injectProps;

        _this2.setState({
          internal: true
        });
      }); // Render out injected frame

      if (frame) return frame;
    } // Update animations, this turns from/to props into AnimatedValues
    // An update can occur on injected props, or when own-props have changed.


    if (this.injectProps) {
      this.updateAnimations(this.injectProps);
      this.injectProps = undefined; // didInject is needed, because there will be a 3rd stage, where the original values
      // .. will be restored after the animation is finished. When someone animates towards
      // .. "auto", the end-result should be "auto", not "1999px", which would block nested
      // .. height/width changes.

      this.didInject = true;
    } else if (propsChanged) this.updateAnimations(this.props); // Render out raw values or AnimatedValues depending on "native"


    var values = this.getAnimatedValues();
    return values && Object.keys(values).length ? renderChildren(this.props, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, values, this.afterInject)) : null;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    // The animation has to start *after* render, since at that point the scene
    // .. graph should be established, so we do it here. Unfortunatelly, non-native
    // .. animations as well as "auto"-injects call forceUpdate, so it's causing a loop.
    // .. didUpdate prevents that as it gets set only on prop changes.
    if (this.didUpdate) this.start();
    this.didUpdate = false;
  };

  _proto.updateAnimations = function updateAnimations(_ref3) {
    var _this3 = this;

    var from = _ref3.from,
        to = _ref3.to,
        reverse = _ref3.reverse,
        attach = _ref3.attach,
        reset = _ref3.reset,
        immediate = _ref3.immediate,
        onFrame = _ref3.onFrame,
        native = _ref3.native;
    // This function will turn own-props into AnimatedValues, it tries to re-use
    // .. exsting animations as best as it can by detecting the changes made
    // We can potentially cause setState, but we're inside render, the flag prevents that
    this.updating = true; // Reverse values when requested

    if (reverse) {
      var _ref4 = [to, from];
      from = _ref4[0];
      to = _ref4[1];
    } // Attachment handling, trailed springs can "attach" themselves to a previous spring


    var target = attach && attach(this);
    var animationsChanged = false;
    this.mergedProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, from, this.mergedProps, to);
    var allProps = Object.entries(this.mergedProps);
    this.animations = allProps.reduce(function (acc, _ref5, i) {
      var _extends2, _extends3;

      var name = _ref5[0],
          value = _ref5[1];
      var entry = reset === false && acc[name] || {
        stopped: true
      };
      var isNumber = typeof value === 'number';
      var isString = typeof value === 'string' && !value.startsWith('#') && !/\d/.test(value) && !colorNames[value];
      var isArray = !isNumber && !isString && Array.isArray(value);
      var fromValue = from[name] !== undefined ? from[name] : value;
      var fromAnimated = fromValue instanceof AnimatedValue;
      var toValue = isNumber || isArray ? value : isString ? value : 1;

      if (target) {
        // Attach value to target animation
        var attachedAnimation = target.animations[name];
        if (attachedAnimation) toValue = attachedAnimation.animation;
      }

      var old = entry.animation;
      var animation, interpolation$$1;

      if (fromAnimated) {
        // Use provided animated value
        animation = interpolation$$1 = fromValue;
      } else if (isNumber || isString) {
        // Create animated value
        animation = interpolation$$1 = entry.animation || new AnimatedValue(fromValue);
      } else if (isArray) {
        // Create animated array
        animation = interpolation$$1 = entry.animation || new AnimatedArray(fromValue);
      } else {
        // Deal with interpolations
        var previous = entry.interpolation && entry.interpolation._interpolation(entry.animation._value);

        if (entry.animation) {
          animation = entry.animation;
          animation.setValue(0);
        } else animation = new AnimatedValue(0);

        var _config = {
          range: [0, 1],
          output: [previous !== undefined ? previous : fromValue, value]
        };
        if (entry.interpolation) interpolation$$1 = entry.interpolation.__update(_config);else interpolation$$1 = animation.interpolate(_config);
      }

      if (old !== animation) animationsChanged = true; // Set immediate values

      if (callProp(immediate, name)) animation.setValue(toValue); // Save interpolators

      _this3.interpolators = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this3.interpolators, (_extends2 = {}, _extends2[name] = interpolation$$1, _extends2));
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, acc, (_extends3 = {}, _extends3[name] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, entry, {
        name: name,
        animation: animation,
        interpolation: interpolation$$1,
        toValue: toValue,
        stopped: false
      }), _extends3));
    }, this.animations); // Update animated props (which from now on will take care of the animation)

    if (animationsChanged) {
      var oldAnimatedProps = this.animatedProps;
      this.animatedProps = new AnimatedProps(this.interpolators, function () {
        // This gets called on every animation frame ...
        if (onFrame) onFrame(_this3.animatedProps.__getValue());
        if (!native && !_this3.updating) _this3.setState({
          internal: true
        });
      });
      oldAnimatedProps && oldAnimatedProps.__detach();
    } // Flag an update that occured, componentDidUpdate will start the animation later on


    this.didUpdate = true;
    this.afterInject = undefined;
    this.didInject = false;
    this.updating = false;
  };

  _proto.flush = function flush() {
    getValues(this.animations).forEach(function (_ref6) {
      var animation = _ref6.animation;
      return animation._update && animation._update();
    });
  };

  _proto.getValues = function getValues$$1() {
    return this.animatedProps ? this.animatedProps.__getValue() : {};
  };

  _proto.getAnimatedValues = function getAnimatedValues() {
    return this.props.native ? this.interpolators : this.getValues();
  };

  return Spring;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Spring.defaultProps = {
  from: {},
  to: {},
  config: config.default,
  native: false,
  immediate: false,
  reset: false,
  force: false,
  impl: SpringAnimation,
  inject: bugfixes
};

var empty = function empty() {
  return null;
};

var get = function get(props) {
  var keys = props.keys,
      children = props.children,
      render = props.render,
      items = props.items,
      rest = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["keys", "children", "render", "items"]);

  children = render || children || empty;
  keys = typeof keys === 'function' ? items.map(keys) : keys;

  if (!Array.isArray(children)) {
    children = [children];
    keys = keys !== void 0 ? [keys] : children.map(function (c) {
      return c.toString();
    });
  } // Make sure numeric keys are interpreted as Strings (5 !== "5")


  keys = keys.map(function (k) {
    return String(k);
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    keys: keys,
    children: children,
    items: items
  }, rest);
};

var guid = 0;

var Transition =
/*#__PURE__*/
function (_React$PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Transition, _React$PureComponent);

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  function Transition(prevProps) {
    var _this;

    _this = _React$PureComponent.call(this, prevProps) || this;

    _this.destroyItem = function (item, key) {
      return function (values) {
        var _this$props = _this.props,
            onRest = _this$props.onRest,
            onDestroyed = _this$props.onDestroyed;

        if (_this.mounted) {
          onDestroyed && onDestroyed(item);

          _this.setState(function (_ref) {
            var deleted = _ref.deleted;
            return {
              deleted: deleted.filter(function (t) {
                return t.key !== key;
              })
            };
          }, function () {
            return delete _this.springs[key];
          });

          onRest && onRest(item, values);
        }
      };
    };

    _this.springs = {};
    _this.state = {
      first: true,
      transitions: [],
      current: {},
      deleted: [],
      prevProps: prevProps
    };
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
    var first = _ref2.first,
        prevProps = _ref2.prevProps,
        state = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["first", "prevProps"]);

    var _get = get(props),
        keys = _get.keys,
        children = _get.children,
        items = _get.items,
        initial = _get.initial,
        from = _get.from,
        enter = _get.enter,
        leave = _get.leave,
        update = _get.update,
        _get$delay = _get.delay,
        delay = _get$delay === void 0 ? 0 : _get$delay,
        config$$1 = _get.config;

    var _get2 = get(prevProps),
        _keys = _get2.keys,
        _items = _get2.items;

    var current = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.current);

    var deleted = state.deleted.concat(); // Compare next keys with current keys

    var currentKeys = Object.keys(current);
    var currentSet = new Set(currentKeys);
    var nextSet = new Set(keys);
    var added = keys.filter(function (item) {
      return !currentSet.has(item);
    });
    var removed = currentKeys.filter(function (item) {
      return !nextSet.has(item);
    });
    var updated = keys.filter(function (item) {
      return currentSet.has(item);
    });
    var trail = 0;
    added.forEach(function (key) {
      var keyIndex = keys.indexOf(key);
      var item = items ? items[keyIndex] : key;
      current[key] = {
        originalKey: key,
        key: guid++,
        item: item,
        delay: trail = trail + delay,
        children: children[keyIndex],
        config: callProp(config$$1, item, 'enter'),
        from: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, callProp(first ? typeof initial !== 'undefined' ? initial : from : from, item)),
        to: callProp(enter, item)
      };
    });
    removed.forEach(function (key) {
      var keyIndex = _keys.indexOf(key);

      var item = _items ? _items[keyIndex] : key;
      deleted.push(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, current[key], {
        destroyed: true,
        lastSibling: _keys[Math.max(0, keyIndex - 1)],
        delay: trail = trail + delay,
        config: callProp(config$$1, item, 'leave'),
        to: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, current[key].to, callProp(leave, item))
      }));
      delete current[key];
    });
    updated.forEach(function (key) {
      var keyIndex = keys.indexOf(key);
      var item = items ? items[keyIndex] : key;
      current[key] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, current[key], {
        delay: trail = trail + delay,
        children: children[keyIndex],
        config: callProp(config$$1, item, 'update'),
        to: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, current[key].to, callProp(update, item))
      });
    });
    var transitions = keys.map(function (key) {
      return current[key];
    });
    deleted.forEach(function (_ref3) {
      var s = _ref3.lastSibling,
          t = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["lastSibling"]);

      // Find last known sibling, left aligned
      var i = Math.max(0, transitions.findIndex(function (t) {
        return t.originalKey === s;
      }) + 1);
      transitions = transitions.slice(0, i).concat([t], transitions.slice(i));
    });
    return {
      first: first && added.length === 0,
      transitions: transitions,
      current: current,
      deleted: deleted,
      prevProps: props
    };
  };

  _proto.getValues = function getValues$$1() {
    return undefined;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        render = _this$props2.render,
        initial = _this$props2.initial,
        _this$props2$from = _this$props2.from,
        _this$props2$enter = _this$props2.enter,
        _this$props2$leave = _this$props2.leave,
        onDestroyed = _this$props2.onDestroyed,
        keys = _this$props2.keys,
        items = _this$props2.items,
        onFrame = _this$props2.onFrame,
        onRest = _this$props2.onRest,
        delay = _this$props2.delay,
        config$$1 = _this$props2.config,
        extra = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["render", "initial", "from", "enter", "leave", "onDestroyed", "keys", "items", "onFrame", "onRest", "delay", "config"]);

    return this.state.transitions.map(function (_ref4, i) {
      var key = _ref4.key,
          item = _ref4.item,
          children = _ref4.children,
          from = _ref4.from,
          to = _ref4.to,
          delay = _ref4.delay,
          config$$1 = _ref4.config,
          destroyed = _ref4.destroyed;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Spring, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: function ref(r) {
          return r && (_this2.springs[key] = r.getValues());
        },
        key: key,
        onRest: destroyed ? _this2.destroyItem(item, key) : onRest && function (values) {
          return onRest(item, values);
        },
        onFrame: onFrame && function (values) {
          return onFrame(item, values);
        },
        delay: delay,
        config: config$$1
      }, extra, {
        from: destroyed ? _this2.springs[key] || from : from,
        to: to,
        render: render && children,
        children: render ? _this2.props.children : children
      }));
    });
  };

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent);

var Trail =
/*#__PURE__*/
function (_React$PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Trail, _React$PureComponent);

  function Trail() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Trail.prototype;

  _proto.getValues = function getValues() {
    return this.instance && this.instance.getValues();
  };

  _proto.componentDidMount = function componentDidMount() {
    this.instance && this.instance.flush();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.instance && this.instance.flush();
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        children = _this$props.children,
        render = _this$props.render,
        _this$props$from = _this$props.from,
        from = _this$props$from === void 0 ? {} : _this$props$from,
        _this$props$to = _this$props.to,
        to = _this$props$to === void 0 ? {} : _this$props$to,
        _this$props$native = _this$props.native,
        native = _this$props$native === void 0 ? false : _this$props$native,
        keys = _this$props.keys,
        delay = _this$props.delay,
        onRest = _this$props.onRest,
        extra = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "render", "from", "to", "native", "keys", "delay", "onRest"]);

    var animations = new Set();

    var hook = function hook(index, animation) {
      animations.add(animation);
      if (index === 0) return undefined;else return Array.from(animations)[index - 1];
    };

    var props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, extra, {
      native: native,
      from: from,
      to: to
    });

    var target = render || children;
    return target.map(function (child, i) {
      var attachedHook = function attachedHook(animation) {
        return hook(i, animation);
      };

      var firstDelay = i === 0 && delay;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Spring, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: function ref(_ref) {
          return i === 0 && (_this.instance = _ref);
        },
        onRest: i === 0 ? onRest : null,
        key: keys[i]
      }, props, {
        delay: firstDelay || undefined,
        attach: attachedHook,
        render: render && child,
        children: render ? children : child
      }));
    });
  };

  return Trail;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent);

var DEFAULT = '__default';

var Keyframes =
/*#__PURE__*/
function (_React$PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Keyframes, _React$PureComponent);

  function Keyframes() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.guid = 0;
    _this.state = {
      props: {},
      oldProps: {},
      resolve: function resolve() {
        return null;
      }
    };

    _this.next = function (props) {
      _this.running = true;
      return new Promise(function (resolve) {
        _this.mounted && _this.setState(function (state) {
          return {
            props: props,
            oldProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.state.props),
            resolve: resolve
          };
        }, function () {
          return _this.running = false;
        });
      });
    };

    return _this;
  }

  var _proto = Keyframes.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.componentDidUpdate({});
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    if (prevProps.state !== this.props.state || this.props.reset && !this.running) {
      (function () {
        var _this2$props = _this2.props,
            states = _this2$props.states,
            f = _this2$props.filter,
            state = _this2$props.state;

        if (states && state) {
          (function () {
            var localId = ++_this2.guid;
            var slots = states[state];

            if (slots) {
              if (Array.isArray(slots)) {
                var q = Promise.resolve();

                var _loop = function _loop() {
                  if (_isArray) {
                    if (_i >= _iterator.length) return "break";
                    _ref = _iterator[_i++];
                  } else {
                    _i = _iterator.next();
                    if (_i.done) return "break";
                    _ref = _i.value;
                  }

                  var s = _ref;
                  q = q.then(function () {
                    return localId === _this2.guid && _this2.next(f(s));
                  });
                };

                for (var _iterator = slots, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                  var _ref;

                  var _ret = _loop();

                  if (_ret === "break") break;
                }
              } else if (typeof slots === 'function') {
                slots(function (props) {
                  return localId === _this2.guid && _this2.next(f(props));
                }, _this2.props);
              } else {
                _this2.next(f(states[state]));
              }
            }
          })();
        }
      })();
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$state = this.state,
        props = _this$state.props,
        oldProps = _this$state.oldProps,
        resolve = _this$state.resolve;
    if (!props || Object.keys(props).length === 0) return null;

    var _this$props = this.props,
        state = _this$props.state,
        filter = _this$props.filter,
        states = _this$props.states,
        Component = _this$props.primitive,
        ownFrom = _this$props.from,
        _onRest = _this$props.onRest,
        rest = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["state", "filter", "states", "primitive", "from", "onRest"]);

    var current = this.instance && this.instance.getValues();
    var from = typeof props.from === 'function' ? props.from : Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, oldProps.from, current, props.from);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: function ref(_ref2) {
        return _this3.instance = _ref2;
      }
    }, rest, props, {
      from: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, from, ownFrom),
      onRest: function onRest(args) {
        resolve(args);
        if (_onRest) _onRest(args);
      }
    }));
  };

  return Keyframes;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent);

Keyframes.defaultProps = {
  state: DEFAULT
};

Keyframes.create = function (primitive) {
  return function (states, filter) {
    var _states;

    if (filter === void 0) {
      filter = function filter(states) {
        return states;
      };
    }

    if (typeof states === 'function' || Array.isArray(states)) states = (_states = {}, _states[DEFAULT] = states, _states);
    return function (props) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Keyframes, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        primitive: primitive,
        states: states,
        filter: filter
      }, props));
    };
  };
};

var interpolateTo = function interpolateTo(props) {
  var forward = getForwardProps(props);
  var rest = Object.keys(props).reduce(function (acc, key) {
    var _extends2;

    return typeof forward[key] !== 'undefined' ? acc : Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, acc, (_extends2 = {}, _extends2[key] = props[key], _extends2));
  }, {});
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    to: forward
  }, rest);
};

Keyframes.Spring = Keyframes.create(Spring);

Keyframes.Spring.to = function (states) {
  return Keyframes.Spring(states, interpolateTo);
};

Keyframes.Trail = Keyframes.create(Trail);

Keyframes.Trail.to = function (states) {
  return Keyframes.Trail(states, interpolateTo);
};

Keyframes.Transition = Keyframes.create(Transition);

var AnimatedDiv = createAnimatedComponent('div');

var _React$createContext = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createContext(null),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;

function getScrollType(horizontal) {
  return horizontal ? 'scrollLeft' : 'scrollTop';
}

var START_TRANSLATE_3D = 'translate3d(0px,0px,0px)';
var START_TRANSLATE = 'translate(0px,0px)';
var ParallaxLayer =
/*#__PURE__*/
function (_React$PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ParallaxLayer, _React$PureComponent);

  function ParallaxLayer() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = ParallaxLayer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var parent = this.parent;

    if (parent) {
      parent.layers = parent.layers.concat(this);
      parent.update();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this = this;

    var parent = this.parent;

    if (parent) {
      parent.layers = parent.layers.filter(function (layer) {
        return layer !== _this;
      });
      parent.update();
    }
  };

  _proto.setPosition = function setPosition(height, scrollTop, immediate) {
    if (immediate === void 0) {
      immediate = false;
    }

    var _this$parent$props = this.parent.props,
        config$$1 = _this$parent$props.config,
        impl = _this$parent$props.impl;
    var targetScroll = Math.floor(this.props.offset) * height;
    var offset = height * this.props.offset + targetScroll * this.props.speed;
    var to = parseFloat(-(scrollTop * this.props.speed) + offset);
    if (!immediate) controller(this.animatedTranslate, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      to: to
    }, config$$1), impl).start();else this.animatedTranslate.setValue(to);
  };

  _proto.setHeight = function setHeight(height, immediate) {
    if (immediate === void 0) {
      immediate = false;
    }

    var _this$parent$props2 = this.parent.props,
        config$$1 = _this$parent$props2.config,
        impl = _this$parent$props2.impl;
    var to = parseFloat(height * this.props.factor);
    if (!immediate) controller(this.animatedSpace, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      to: to
    }, config$$1), impl).start();else this.animatedSpace.setValue(to);
  };

  _proto.initialize = function initialize() {
    var props = this.props;
    var parent = this.parent;
    var targetScroll = Math.floor(props.offset) * parent.space;
    var offset = parent.space * props.offset + targetScroll * props.speed;
    var to = parseFloat(-(parent.current * props.speed) + offset);
    this.animatedTranslate = new AnimatedValue(to);
    this.animatedSpace = new AnimatedValue(parent.space * props.factor);
  };

  _proto.renderLayer = function renderLayer() {
    var _extends2;

    var _this$props = this.props,
        style = _this$props.style,
        children = _this$props.children,
        offset = _this$props.offset,
        speed = _this$props.speed,
        factor = _this$props.factor,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["style", "children", "offset", "speed", "factor", "className"]);

    var horizontal = this.parent.props.horizontal;
    var translate3d = this.animatedTranslate.interpolate({
      range: [0, 1],
      output: horizontal ? [START_TRANSLATE_3D, 'translate3d(1px,0,0)'] : [START_TRANSLATE_3D, 'translate3d(0,1px,0)']
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(AnimatedDiv, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: className,
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends2 = {
        position: 'absolute',
        backgroundSize: 'auto',
        backgroundRepeat: 'no-repeat',
        willChange: 'transform'
      }, _extends2[horizontal ? 'height' : 'width'] = '100%', _extends2[horizontal ? 'width' : 'height'] = this.animatedSpace, _extends2.WebkitTransform = translate3d, _extends2.MsTransform = translate3d, _extends2.transform = translate3d, _extends2), style)
    }), children);
  };

  _proto.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Consumer, null, function (parent) {
      if (parent && !_this2.parent) {
        _this2.parent = parent;

        _this2.initialize();
      }

      return _this2.renderLayer();
    });
  };

  return ParallaxLayer;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent);
ParallaxLayer.defaultProps = {
  factor: 1,
  offset: 0,
  speed: 0
};

var Parallax =
/*#__PURE__*/
function (_React$PureComponent2) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Parallax, _React$PureComponent2);

  function Parallax() {
    var _this3;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this3 = _React$PureComponent2.call.apply(_React$PureComponent2, [this].concat(args)) || this;
    _this3.state = {
      ready: false
    };
    _this3.layers = [];
    _this3.space = 0;
    _this3.current = 0;
    _this3.offset = 0;
    _this3.busy = false;

    _this3.moveItems = function () {
      _this3.layers.forEach(function (layer) {
        return layer.setPosition(_this3.space, _this3.current);
      });

      _this3.busy = false;
    };

    _this3.scrollerRaf = function () {
      return requestAnimationFrame(_this3.moveItems);
    };

    _this3.onScroll = function (event) {
      var horizontal = _this3.props.horizontal;

      if (!_this3.busy) {
        _this3.busy = true;

        _this3.scrollerRaf();

        _this3.current = event.target[getScrollType(horizontal)];
      }
    };

    _this3.update = function () {
      var _this3$props = _this3.props,
          scrolling = _this3$props.scrolling,
          horizontal = _this3$props.horizontal;
      var scrollType = getScrollType(horizontal);
      if (!_this3.container) return;
      _this3.space = _this3.container[horizontal ? 'clientWidth' : 'clientHeight'];
      if (scrolling) _this3.current = _this3.container[scrollType];else _this3.container[scrollType] = _this3.current = _this3.offset * _this3.space;
      if (_this3.content) _this3.content.style[horizontal ? 'width' : 'height'] = _this3.space * _this3.props.pages + "px";

      _this3.layers.forEach(function (layer) {
        layer.setHeight(_this3.space, true);
        layer.setPosition(_this3.space, _this3.current, true);
      });
    };

    _this3.updateRaf = function () {
      requestAnimationFrame(_this3.update); // Some browsers don't fire on maximize

      setTimeout(_this3.update, 150);
    };

    _this3.scrollStop = function (event) {
      return _this3.animatedScroll && _this3.animatedScroll.stopAnimation();
    };

    return _this3;
  }

  var _proto2 = Parallax.prototype;

  _proto2.scrollTo = function scrollTo(offset) {
    var _this$props2 = this.props,
        horizontal = _this$props2.horizontal,
        config$$1 = _this$props2.config,
        impl = _this$props2.impl;
    var scrollType = getScrollType(horizontal);
    this.scrollStop();
    this.offset = offset;
    var target = this.container;
    this.animatedScroll = new AnimatedValue(target[scrollType]);
    this.animatedScroll.addListener(function (_ref) {
      var value = _ref.value;
      return target[scrollType] = value;
    });
    controller(this.animatedScroll, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      to: offset * this.space
    }, config$$1), impl).start();
  };

  _proto2.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.updateRaf, false);
    this.update();
    this.setState({
      ready: true
    });
  };

  _proto2.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.updateRaf, false);
  };

  _proto2.componentDidUpdate = function componentDidUpdate() {
    this.update();
  };

  _proto2.render = function render() {
    var _this4 = this,
        _extends3;

    var _this$props3 = this.props,
        style = _this$props3.style,
        innerStyle = _this$props3.innerStyle,
        pages = _this$props3.pages,
        className = _this$props3.className,
        scrolling = _this$props3.scrolling,
        children = _this$props3.children,
        horizontal = _this$props3.horizontal;
    var overflow = scrolling ? 'scroll' : 'hidden';
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      ref: function ref(node) {
        return _this4.container = node;
      },
      onScroll: this.onScroll,
      onWheel: scrolling ? this.scrollStop : null,
      onTouchStart: scrolling ? this.scrollStop : null,
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        position: 'absolute',
        width: '100%',
        height: '100%',
        overflow: overflow,
        overflowY: horizontal ? 'hidden' : overflow,
        overflowX: horizontal ? overflow : 'hidden',
        WebkitOverflowScrolling: 'touch',
        WebkitTransform: START_TRANSLATE,
        MsTransform: START_TRANSLATE,
        transform: START_TRANSLATE_3D
      }, style),
      className: className
    }, this.state.ready && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      ref: function ref(node) {
        return _this4.content = node;
      },
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends3 = {
        position: 'absolute'
      }, _extends3[horizontal ? 'height' : 'width'] = '100%', _extends3.WebkitTransform = START_TRANSLATE, _extends3.MsTransform = START_TRANSLATE, _extends3.transform = START_TRANSLATE_3D, _extends3.overflow = 'hidden', _extends3[horizontal ? 'width' : 'height'] = this.space * pages, _extends3), innerStyle)
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Provider, {
      value: this
    }, children)));
  };

  return Parallax;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent);

Parallax.Layer = ParallaxLayer;
Parallax.defaultProps = {
  config: config.slow,
  scrolling: true,
  horizontal: false,
  impl: SpringAnimation
};

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
var extendedAnimated = domElements.reduce(function (acc, element) {
  acc[element] = createAnimatedComponent(element);
  return acc;
}, createAnimatedComponent);



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Collection":"Collection","collection":"Collection","Collection__Item":"Collection__Item","collectionItem":"Collection__Item","Collection__ItemWrapper":"Collection__ItemWrapper","collectionItemWrapper":"Collection__ItemWrapper"};

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_fetch__ = __webpack_require__(213);
function logout(token){return Object(__WEBPACK_IMPORTED_MODULE_0_api_fetch__["a" /* default */])('/logout',{method:'POST',headers:{'Content-type':'application/json',Authorization:token}});}

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Main */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_client_ClientProvider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Switch__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RunAsBanner__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_moderation__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_reviews__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_qa__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_socialcollection__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ducks_authReducer__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_components_CheckAuthentication__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_components_CheckAuthorization__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_components_AppReady__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_components_LoadAppConfig__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_components_UserSatisfaction__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_RedirectNotice__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ducks_auth_context__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_ducks_authActions__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__containers_socialcollection_WyngSingleSignOn__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_UserTranslation__ = __webpack_require__(762);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModerationPathName='moderation';var OldModerationPathName='content';var ReviewsPathName='reviews';var QAPathName='q&a';var SocialCollectionPathName='socialcollection';var SocialCollectionSSOPathName='socialcollection/sso/saml2';// IDP SAML Request proxy
var USER_IDLE_TIMEOUT_MS=30*60*1000;var USER_IDLE_TIMEOUT_CHECK_INTERVAL_MS=Math.floor(USER_IDLE_TIMEOUT_MS/4);var Main=function(_React$PureComponent){_inherits(Main,_React$PureComponent);function Main(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Main);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Main.__proto__||Object.getPrototypeOf(Main)).call.apply(_ref,[this].concat(args))),_this),_this.state={userInfo:null},_this.checkUserIdleTime=function(){var userIdleStartTime=_this.userIdleStartTime;if(typeof userIdleStartTime==='number'){if(Date.now()-userIdleStartTime>=USER_IDLE_TIMEOUT_MS){_this.props.logout();Object(__WEBPACK_IMPORTED_MODULE_17_ducks_auth_context__["b" /* redirectToAuthService */])();}}},_this.handlePageVisibility=function(e){if(e.target.visibilityState==='visible'){_this.userIdleStartTime=null;}else{_this.userIdleStartTime=Date.now();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Main,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('visibilitychange',this.handlePageVisibility,false);this.checkUserIdleTimeIntervelId=setInterval(this.checkUserIdleTime,USER_IDLE_TIMEOUT_CHECK_INTERVAL_MS);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('visibilitychange',this.handlePageVisibility,false);clearInterval(this.checkUserIdleTimeIntervelId);}},{key:'render',value:function render(){var _props=this.props,match=_props.match,auth=_props.auth;var userInfo=this.state.userInfo;var access=userInfo!=null?userInfo.access:{};var redirectDestination=getLandingPage(match.url,access);var isPowerReviewsUserInRunAsMode=auth.isRunAsMode();return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_pages_components_CheckAuthentication__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_pages_components_CheckAuthorization__["a" /* default */],{authorized:access.app===true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_pages_components_AppReady__["a" /* default */],null,isPowerReviewsUserInRunAsMode?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_RunAsBanner__["a" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_ducks_auth_context__["a" /* AuthContext */].Provider,{value:auth},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_pages_components_LoadAppConfig__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_containers_client_ClientProvider__["c" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_Switch__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{exact:true,from:match.url,to:redirectDestination}),access.moderate===true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:''+match.url+ModerationPathName,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_pages_moderation__["a" /* default */],Object.assign({},userInfo,routeProps));}}),access.moderate===true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:''+match.url+OldModerationPathName,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_components_RedirectNotice__["a" /* default */],{delay:10},function(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:routeProps.location.pathname.replace('/'+OldModerationPathName,'/'+ModerationPathName)});});}}),access.reviews===true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:''+match.url+ReviewsPathName,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_pages_reviews__["a" /* default */],Object.assign({},userInfo,routeProps));}}),access.qa===true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:''+match.url+QAPathName,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_pages_qa__["a" /* default */],Object.assign({},userInfo,routeProps));}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:''+match.url+SocialCollectionSSOPathName,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__containers_socialcollection_WyngSingleSignOn__["a" /* WyngSingleSignOn */],{queryString:routeProps.location.search,token:auth.token});}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:''+match.url+SocialCollectionPathName,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_pages_socialcollection__["a" /* default */],Object.assign({},userInfo,routeProps));}})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_pages_components_UserSatisfaction__["a" /* UserSatisfaction */],{username:auth.name,email:auth.email,page:this.props.location.pathname,internal:auth.role.internal||isPowerReviewsUserInRunAsMode}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__components_UserTranslation__["a" /* UserTranslation */],null)))))));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps){return{userInfo:__WEBPACK_IMPORTED_MODULE_10_ducks_authReducer__["a" /* AuthState */].getUserInfo(nextProps.auth)};}}]);return Main;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);function getLandingPage(matchUrl,access){if(access.reviews){return''+matchUrl+ReviewsPathName;}if(access.qa){return''+matchUrl+QAPathName;}return''+matchUrl+ModerationPathName;}var mapStateToProps=function mapStateToProps(_ref2){var auth=_ref2.auth;return{auth:auth};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,{logout:__WEBPACK_IMPORTED_MODULE_18_ducks_authActions__["b" /* logout */]})(Main)));

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



// istanbul ignore next
var statusDiv = typeof document === 'undefined' ? null : document.getElementById('a11y-status-message');

var statuses = [];

function setStatus(status) {
  var isSameAsLast = statuses[statuses.length - 1] === status;
  if (isSameAsLast) {
    statuses = [].concat(statuses, [status]);
  } else {
    statuses = [status];
  }
  var div = getStatusDiv();

  // Remove previous children
  while (div.lastChild) {
    div.removeChild(div.firstChild);
  }

  statuses.filter(Boolean).forEach(function (statusItem, index) {
    div.appendChild(getStatusChildDiv(statusItem, index));
  });
}

function getStatusChildDiv(status, index) {
  var display = index === statuses.length - 1 ? 'block' : 'none';

  var childDiv = document.createElement('div');
  childDiv.style.display = display;
  childDiv.textContent = status;

  return childDiv;
}

function getStatusDiv() {
  if (statusDiv) {
    return statusDiv;
  }
  statusDiv = document.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'assertive');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  document.body.appendChild(statusDiv);
  return statusDiv;
}

var idCounter = 0;

/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */
function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}
function noop() {}

function findParent(finder, node, rootNode) {
  if (node !== null && node !== rootNode.parentNode) {
    if (finder(node)) {
      if (node === document.body && node.scrollTop === 0) {
        // in chrome body.scrollTop always return 0
        return document.documentElement;
      }
      return node;
    } else {
      return findParent(finder, node.parentNode, rootNode);
    }
  } else {
    return null;
  }
}

/**
 * Get the closest element that scrolls
 * @param {HTMLElement} node - the child element to start searching for scroll parent at
 * @param {HTMLElement} rootNode - the root element of the component
 * @return {HTMLElement} the closest parentNode that scrolls
 */
var getClosestScrollParent = findParent.bind(null, function (node) {
  return node.scrollHeight > node.clientHeight;
});

/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node - the element that should scroll into view
 * @param {HTMLElement} rootNode - the root element of the component
 * @param {Boolean} alignToTop - align element to the top of the visible area of the scrollable ancestor
 */
// eslint-disable-next-line complexity
function scrollIntoView(node, rootNode) {
  var scrollParent = getClosestScrollParent(node, rootNode);
  if (scrollParent === null) {
    return;
  }
  var scrollParentStyles = getComputedStyle(scrollParent);
  var scrollParentRect = scrollParent.getBoundingClientRect();
  var scrollParentBorderTopWidth = parseInt(scrollParentStyles.borderTopWidth, 10);
  var scrollParentBorderBottomWidth = parseInt(scrollParentStyles.borderBottomWidth, 10);
  var bordersWidth = scrollParentBorderTopWidth + scrollParentBorderBottomWidth;
  var scrollParentTop = scrollParentRect.top + scrollParentBorderTopWidth;
  var nodeRect = node.getBoundingClientRect();

  if (nodeRect.top < 0 && scrollParentRect.top < 0) {
    scrollParent.scrollTop += nodeRect.top;
    return;
  }

  if (nodeRect.top < 0) {
    // the item is above the viewport and the parent is not above the viewport
    scrollParent.scrollTop += nodeRect.top - scrollParentTop;
    return;
  }

  if (nodeRect.top > 0 && scrollParentRect.top < 0) {
    if (scrollParentRect.bottom > 0 && nodeRect.bottom + bordersWidth > scrollParentRect.bottom) {
      // the item is below scrollable area
      scrollParent.scrollTop += nodeRect.bottom - scrollParentRect.bottom + bordersWidth;
    }
    // item and parent top are on different sides of view top border (do nothing)
    return;
  }

  var nodeOffsetTop = nodeRect.top + scrollParent.scrollTop;
  var nodeTop = nodeOffsetTop - scrollParentTop;
  if (nodeTop < scrollParent.scrollTop) {
    // the item is above the scrollable area
    scrollParent.scrollTop = nodeTop;
  } else if (nodeTop + nodeRect.height + bordersWidth > scrollParent.scrollTop + scrollParentRect.height) {
    // the item is below the scrollable area
    scrollParent.scrollTop = nodeTop + nodeRect.height - scrollParentRect.height + bordersWidth;
  }
  // the item is within the scrollable area (do nothing)
}

/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */
function debounce(fn, time) {
  var timeoutId = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(undefined, args);
    }, time);
  };
}

/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */
function composeEventHandlers() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (event) {
    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return fns.some(function (fn) {
      fn && fn.apply(undefined, [event].concat(args));
      // TODO: remove everything after the || in the next breaking change
      return event.preventDownshiftDefault || event.defaultPrevented;
    });
  };
}

/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */
function generateId() {
  return String(idCounter++);
}

/**
 * Resets idCounter to 0. Used for SSR.
 */
function resetIdCounter() {
  idCounter = 0;
}

/**
 * Returns the first argument that is not undefined
 * @param {...*} args the arguments
 * @return {*} the defined value
 */
function firstDefined() {
  for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return args.find(function (a) {
    return typeof a !== 'undefined';
  });
}

// eslint-disable-next-line complexity
function getA11yStatusMessage(_ref) {
  var isOpen = _ref.isOpen,
      highlightedItem = _ref.highlightedItem,
      selectedItem = _ref.selectedItem,
      resultCount = _ref.resultCount,
      previousResultCount = _ref.previousResultCount,
      itemToString = _ref.itemToString;

  if (!isOpen) {
    if (selectedItem) {
      return itemToString(selectedItem);
    } else {
      return '';
    }
  }

  if (!resultCount) {
    return 'No results.';
  } else if (!highlightedItem || resultCount !== previousResultCount) {
    return resultCount + ' ' + (resultCount === 1 ? 'result is' : 'results are') + ' available, use up and down arrow keys to navigate.';
  }
  return itemToString(highlightedItem);
}

/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */
function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ? /* istanbul ignore next (preact) */arg[0] : arg;
  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}

/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */
function isDOMElement(element) {
  /* istanbul ignore if */
  if (element.nodeName) {
    // then this is preact
    return typeof element.nodeName === 'string';
  } else {
    // then we assume this is react
    return typeof element.type === 'string';
  }
}

/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */
function getElementProps(element) {
  // props for react, attributes for preact
  return element.props || /* istanbul ignore next (preact) */element.attributes;
}

/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */
function requiredProp(fnName, propName) {
  throw new Error('The property "' + propName + '" is required in "' + fnName + '"');
}

var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
/**
 * @param {Object} state The state object
 * @return {Object} State that is relevant to downshift
 */
function pickState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}

/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */
function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/* eslint camelcase:0 */

var Downshift$1 = function (_Component) {
  inherits(Downshift, _Component);

  function Downshift() {
    classCallCheck(this, Downshift);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args)));

    _initialiseProps.call(_this);

    var state = _this.getState({
      highlightedIndex: _this.props.defaultHighlightedIndex,
      isOpen: _this.props.defaultIsOpen,
      inputValue: _this.props.defaultInputValue,
      selectedItem: _this.props.defaultSelectedItem
    });
    if (state.selectedItem) {
      state.inputValue = _this.props.itemToString(state.selectedItem);
    }
    _this.state = state;
    _this.id = _this.props.id || 'downshift-' + generateId();
    return _this;
  }
  // itemCount can be changed asynchronously
  // from within downshift (so it can't come from a prop)
  // this is why we store it as an instance and use
  // getItemCount rather than just use items.length
  // (to support windowing + async)


  /**
   * Gets the state based on internal state or props
   * If a state value is passed via props, then that
   * is the value given, otherwise it's retrieved from
   * stateToMerge
   *
   * This will perform a shallow merge of the given state object
   * with the state coming from props
   * (for the controlled component scenario)
   * This is used in state updater functions so they're referencing
   * the right state regardless of where it comes from.
   *
   * @param {Object} stateToMerge defaults to this.state
   * @return {Object} the state
   */
  Downshift.prototype.getState = function getState() {
    var _this2 = this;

    var stateToMerge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;

    return Object.keys(stateToMerge).reduce(function (state, key) {
      state[key] = _this2.isControlledProp(key) ? _this2.props[key] : stateToMerge[key];
      return state;
    }, {});
  };

  /**
   * This determines whether a prop is a "controlled prop" meaning it is
   * state which is controlled by the outside of this component rather
   * than within this component.
   * @param {String} key the key to check
   * @return {Boolean} whether it is a controlled controlled prop
   */


  Downshift.prototype.isControlledProp = function isControlledProp(key) {
    return this.props[key] !== undefined;
  };

  Downshift.prototype.getItemCount = function getItemCount() {
    // things read better this way. They're in priority order:
    // 1. `this.itemCount`
    // 2. `this.props.itemCount`
    // 3. `this.items.length`
    /* eslint-disable no-negated-condition */
    if (this.itemCount != null) {
      return this.itemCount;
    } else if (this.props.itemCount !== undefined) {
      return this.props.itemCount;
    } else {
      return this.items.length;
    }
    /* eslint-enable no-negated-condition */
  };

  // eslint-disable-next-line complexity


  // any piece of our state can live in two places:
  // 1. Uncontrolled: it's internal (this.state)
  //    We will call this.setState to update that state
  // 2. Controlled: it's external (this.props)
  //    We will call this.props.onStateChange to update that state
  //
  // In addition, we'll call this.props.onChange if the
  // selectedItem is changed.
  Downshift.prototype.internalSetState = function internalSetState(stateToSet, cb) {
    var _this3 = this;

    var isItemSelected = void 0,
        onChangeArg = void 0;

    var onStateChangeArg = {};
    var isStateToSetFunction = typeof stateToSet === 'function';

    // we want to call `onInputValueChange` before the `setState` call
    // so someone controlling the `inputValue` state gets notified of
    // the input change as soon as possible. This avoids issues with
    // preserving the cursor position.
    // See https://github.com/paypal/downshift/issues/217 for more info.
    if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
      this.props.onInputValueChange(stateToSet.inputValue, _extends({}, this.getStateAndHelpers(), stateToSet));
    }
    return this.setState(function (state) {
      state = _this3.getState(state);
      stateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet;

      // Your own function that could modify the state that will be set.
      stateToSet = _this3.props.stateReducer(state, stateToSet);

      // checks if an item is selected, regardless of if it's different from
      // what was selected before
      // used to determine if onSelect and onChange callbacks should be called
      isItemSelected = stateToSet.hasOwnProperty('selectedItem');
      // this keeps track of the object we want to call with setState
      var nextState = {};
      // this is just used to tell whether the state changed
      var nextFullState = {};
      // we need to call on change if the outside world is controlling any of our state
      // and we're trying to update that state. OR if the selection has changed and we're
      // trying to update the selection
      if (isItemSelected && stateToSet.selectedItem !== state.selectedItem) {
        onChangeArg = stateToSet.selectedItem;
      }
      stateToSet.type = stateToSet.type || Downshift.stateChangeTypes.unknown;

      Object.keys(stateToSet).forEach(function (key) {
        // onStateChangeArg should only have the state that is
        // actually changing
        if (state[key] !== stateToSet[key]) {
          onStateChangeArg[key] = stateToSet[key];
        }
        // the type is useful for the onStateChangeArg
        // but we don't actually want to set it in internal state.
        // this is an undocumented feature for now... Not all internalSetState
        // calls support it and I'm not certain we want them to yet.
        // But it enables users controlling the isOpen state to know when
        // the isOpen state changes due to mouseup events which is quite handy.
        if (key === 'type') {
          return;
        }
        nextFullState[key] = stateToSet[key];
        // if it's coming from props, then we don't care to set it internally
        if (!_this3.isControlledProp(key)) {
          nextState[key] = stateToSet[key];
        }
      });

      // if stateToSet is a function, then we weren't able to call onInputValueChange
      // earlier, so we'll call it now that we know what the inputValue state will be.
      if (isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
        _this3.props.onInputValueChange(stateToSet.inputValue, _extends({}, _this3.getStateAndHelpers(), stateToSet));
      }

      return nextState;
    }, function () {
      // call the provided callback if it's a callback
      cbToCb(cb)();

      // only call the onStateChange and onChange callbacks if
      // we have relevant information to pass them.
      var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
      if (hasMoreStateThanType) {
        _this3.props.onStateChange(onStateChangeArg, _this3.getStateAndHelpers());
      }

      if (isItemSelected) {
        _this3.props.onSelect(stateToSet.selectedItem, _this3.getStateAndHelpers());
      }

      if (onChangeArg !== undefined) {
        _this3.props.onChange(onChangeArg, _this3.getStateAndHelpers());
      }
      // this is currently undocumented and therefore subject to change
      // We'll try to not break it, but just be warned.
      _this3.props.onUserAction(onStateChangeArg, _this3.getStateAndHelpers());
    });
  };

  Downshift.prototype.getStateAndHelpers = function getStateAndHelpers() {
    var _getState = this.getState(),
        highlightedIndex = _getState.highlightedIndex,
        inputValue = _getState.inputValue,
        selectedItem = _getState.selectedItem,
        isOpen = _getState.isOpen;

    var itemToString = this.props.itemToString;
    var id = this.id;
    var getRootProps = this.getRootProps,
        getButtonProps = this.getButtonProps,
        getLabelProps = this.getLabelProps,
        getInputProps = this.getInputProps,
        getItemProps = this.getItemProps,
        openMenu = this.openMenu,
        closeMenu = this.closeMenu,
        toggleMenu = this.toggleMenu,
        selectItem = this.selectItem,
        selectItemAtIndex = this.selectItemAtIndex,
        selectHighlightedItem = this.selectHighlightedItem,
        setHighlightedIndex = this.setHighlightedIndex,
        clearSelection = this.clearSelection,
        clearItems = this.clearItems,
        reset = this.reset,
        setItemCount = this.setItemCount,
        unsetItemCount = this.unsetItemCount;

    return {
      // prop getters
      getRootProps: getRootProps,
      getButtonProps: getButtonProps,
      getLabelProps: getLabelProps,
      getInputProps: getInputProps,
      getItemProps: getItemProps,

      // actions
      reset: reset,
      openMenu: openMenu,
      closeMenu: closeMenu,
      toggleMenu: toggleMenu,
      selectItem: selectItem,
      selectItemAtIndex: selectItemAtIndex,
      selectHighlightedItem: selectHighlightedItem,
      setHighlightedIndex: setHighlightedIndex,
      clearSelection: clearSelection,
      clearItems: clearItems,
      setItemCount: setItemCount,
      unsetItemCount: unsetItemCount,

      //props
      itemToString: itemToString,

      //derived
      id: id,

      // state
      highlightedIndex: highlightedIndex,
      inputValue: inputValue,
      isOpen: isOpen,
      selectedItem: selectedItem
    };
  };

  //////////////////////////// ROOT

  //\\\\\\\\\\\\\\\\\\\\\\\\\\ ROOT

  //////////////////////////// BUTTON

  //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ BUTTON

  /////////////////////////////// LABEL

  //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ LABEL

  /////////////////////////////// INPUT

  //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ INPUT

  /////////////////////////////// ITEM
  Downshift.prototype.getItemId = function getItemId(index) {
    return this.id + '-item-' + index;
  };
  //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ ITEM

  Downshift.prototype.componentDidMount = function componentDidMount() {
    var _this4 = this;

    // the _isMounted property is because we have `updateStatus` in a `debounce`
    // and we don't want to update the status if the component has been umounted
    this._isMounted = true;
    /* istanbul ignore if (react-native) */
    {
      // this.isMouseDown helps us track whether the mouse is currently held down.
      // This is useful when the user clicks on an item in the list, but holds the mouse
      // down long enough for the list to disappear (because the blur event fires on the input)
      // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
      // trigger hiding the menu.
      var onMouseDown = function () {
        _this4.isMouseDown = true;
      };
      var onMouseUp = function (event) {
        var document = _this4.props.environment.document;

        _this4.isMouseDown = false;
        if ((event.target === _this4._rootNode || !_this4._rootNode.contains(event.target)) && _this4.getState().isOpen && (!_this4.inputId || document.activeElement.id !== _this4.inputId)) {
          _this4.reset({ type: Downshift.stateChangeTypes.mouseUp }, function () {
            return _this4.props.onOuterClick(_this4.getStateAndHelpers());
          });
        }
      };
      this.props.environment.addEventListener('mousedown', onMouseDown);
      this.props.environment.addEventListener('mouseup', onMouseUp);

      this.cleanup = function () {
        _this4._isMounted = false;
        _this4.props.environment.removeEventListener('mousedown', onMouseDown);
        _this4.props.environment.removeEventListener('mouseup', onMouseUp);
      };
    }
  };

  Downshift.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.isControlledProp('selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
      this.internalSetState({
        type: Downshift.stateChangeTypes.controlledPropUpdatedSelectedItem,
        inputValue: this.props.itemToString(this.props.selectedItem)
      });
    }

    var current = this.props.highlightedIndex === undefined ? this.state : this.props;
    var prev = prevProps.highlightedIndex === undefined ? prevState : prevProps;

    if (current.highlightedIndex !== prev.highlightedIndex && !this.avoidScrolling) {
      this.scrollHighlightedItemIntoView();
    }

    this.updateStatus();
  };

  Downshift.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cleanup(); // avoids memory leak
  };

  // eslint-disable-next-line complexity


  Downshift.prototype.render = function render() {
    var children = unwrapArray(this.props.render || this.props.children, noop);
    // because the items are rerendered every time we call the children
    // we clear this out each render and
    this.clearItems();
    // we reset this so we know whether the user calls getRootProps during
    // this render. If they do then we don't need to do anything,
    // if they don't then we need to clone the element they return and
    // apply the props for them.
    this.getRootProps.called = false;
    this.getRootProps.refKey = undefined;
    this.getRootProps.suppressRefError = undefined;
    // we do something similar for getLabelProps
    this.getLabelProps.called = false;
    // and something similar for getInputProps
    this.getInputProps.called = false;
    var element = unwrapArray(children(this.getStateAndHelpers()));
    if (!element) {
      return null;
    }
    if (this.getRootProps.called) {
      if (!this.getRootProps.suppressRefError) {
        validateGetRootPropsCalledCorrectly(element, this.getRootProps);
      }
      return element;
    } else if (isDOMElement(element)) {
      // they didn't apply the root props, but we can clone
      // this and apply the props ourselves
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(element, this.getRootProps(getElementProps(element)));
    } else {
      // they didn't apply the root props, but they need to
      // otherwise we can't query around the autocomplete
      throw new Error('downshift: If you return a non-DOM element, you must use apply the getRootProps function');
    }
  };

  return Downshift;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Downshift$1.defaultProps = {
  defaultHighlightedIndex: null,
  defaultSelectedItem: null,
  defaultInputValue: '',
  defaultIsOpen: false,
  getA11yStatusMessage: getA11yStatusMessage,
  itemToString: function itemToString(i) {
    if (i == null) {
      return '';
    }
    if (false) {
      //eslint-disable-next-line no-console
      console.warn('downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.', 'The object that was passed:', i);
    }
    return String(i);
  },
  onStateChange: function onStateChange() {},
  onInputValueChange: function onInputValueChange() {},
  onUserAction: function onUserAction() {},
  onChange: function onChange() {},
  onSelect: function onSelect() {},
  onOuterClick: function onOuterClick() {},
  selectedItemChanged: function selectedItemChanged(prevItem, item) {
    return prevItem !== item;
  },
  environment: typeof window === 'undefined' /* istanbul ignore next (ssr) */
  ? {} : window,
  stateReducer: function stateReducer(state, stateToSet) {
    return stateToSet;
  },
  breakingChanges: {}
};
Downshift$1.stateChangeTypes = {
  unknown: '__autocomplete_unknown__',
  mouseUp: '__autocomplete_mouseup__',
  itemMouseEnter: '__autocomplete_item_mouseenter__',
  keyDownArrowUp: '__autocomplete_keydown_arrow_up__',
  keyDownArrowDown: '__autocomplete_keydown_arrow_down__',
  keyDownEscape: '__autocomplete_keydown_escape__',
  keyDownEnter: '__autocomplete_keydown_enter__',
  clickItem: '__autocomplete_click_item__',
  blurInput: '__autocomplete_blur_input__',
  changeInput: '__autocomplete_change_input__',
  keyDownSpaceButton: '__autocomplete_keydown_space_button__',
  clickButton: '__autocomplete_click_button__',
  blurButton: '__autocomplete_blur_button__',
  controlledPropUpdatedSelectedItem: '__autocomplete_controlled_prop_updated_selected_item__'
};

var _initialiseProps = function () {
  var _this5 = this;

  this.input = null;
  this.items = [];
  this.itemCount = null;
  this.previousResultCount = 0;

  this.setItemCount = function (count) {
    return _this5.itemCount = count;
  };

  this.unsetItemCount = function () {
    return _this5.itemCount = null;
  };

  this.getItemNodeFromIndex = function (index) {
    return _this5.props.environment.document.getElementById(_this5.getItemId(index));
  };

  this.setHighlightedIndex = function () {
    var highlightedIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this5.props.defaultHighlightedIndex;
    var otherStateToSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(_extends({ highlightedIndex: highlightedIndex }, otherStateToSet));
  };

  this.scrollHighlightedItemIntoView = function () {
    /* istanbul ignore else (react-native) */
    {
      var node = _this5.getItemNodeFromIndex(_this5.getState().highlightedIndex);
      var rootNode = _this5._rootNode;
      scrollIntoView(node, rootNode);
    }
  };

  this.openAndHighlightDefaultIndex = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _this5.setHighlightedIndex(undefined, _extends({ isOpen: true }, otherStateToSet));
  };

  this.highlightDefaultIndex = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _this5.setHighlightedIndex(undefined, otherStateToSet);
  };

  this.moveHighlightedIndex = function (amount, otherStateToSet) {
    if (_this5.getState().isOpen) {
      _this5.changeHighlightedIndex(amount, otherStateToSet);
    } else {
      _this5.openAndHighlightDefaultIndex(otherStateToSet);
    }
  };

  this.changeHighlightedIndex = function (moveAmount, otherStateToSet) {
    var itemsLastIndex = _this5.getItemCount() - 1;
    if (itemsLastIndex < 0) {
      return;
    }

    var _getState2 = _this5.getState(),
        highlightedIndex = _getState2.highlightedIndex;

    var baseIndex = highlightedIndex;
    if (baseIndex === null) {
      baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
    }
    var newIndex = baseIndex + moveAmount;
    if (newIndex < 0) {
      newIndex = itemsLastIndex;
    } else if (newIndex > itemsLastIndex) {
      newIndex = 0;
    }
    _this5.setHighlightedIndex(newIndex, otherStateToSet);
  };

  this.clearSelection = function (cb) {
    _this5.internalSetState({
      selectedItem: null,
      inputValue: '',
      isOpen: false
    }, cb);
  };

  this.selectItem = function (item, otherStateToSet, cb) {
    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(_extends({
      isOpen: false,
      highlightedIndex: _this5.props.defaultHighlightedIndex,
      selectedItem: item,
      inputValue: _this5.isControlledProp('selectedItem') && _this5.props.breakingChanges.resetInputOnSelection ? _this5.props.defaultInputValue : _this5.props.itemToString(item)
    }, otherStateToSet), cb);
  };

  this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
    var item = _this5.items[itemIndex];
    if (item == null) {
      return;
    }
    _this5.selectItem(item, otherStateToSet, cb);
  };

  this.selectHighlightedItem = function (otherStateToSet, cb) {
    return _this5.selectItemAtIndex(_this5.getState().highlightedIndex, otherStateToSet, cb);
  };

  this.rootRef = function (node) {
    return _this5._rootNode = node;
  };

  this.getRootProps = function () {
    var _babelHelpers$extends;

    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$suppressRefErro = _ref3.suppressRefError,
        suppressRefError = _ref3$suppressRefErro === undefined ? false : _ref3$suppressRefErro;

    var _ref2$refKey = _ref2.refKey,
        refKey = _ref2$refKey === undefined ? 'ref' : _ref2$refKey,
        rest = objectWithoutProperties(_ref2, ['refKey']);

    // this is used in the render to know whether the user has called getRootProps.
    // It uses that to know whether to apply the props automatically
    _this5.getRootProps.called = true;
    _this5.getRootProps.refKey = refKey;
    _this5.getRootProps.suppressRefError = suppressRefError;
    return _extends((_babelHelpers$extends = {}, _babelHelpers$extends[refKey] = _this5.rootRef, _babelHelpers$extends), rest);
  };

  this.keyDownHandlers = {
    ArrowDown: function ArrowDown(event) {
      event.preventDefault();
      var amount = event.shiftKey ? 5 : 1;
      this.moveHighlightedIndex(amount, {
        type: Downshift$1.stateChangeTypes.keyDownArrowDown
      });
    },
    ArrowUp: function ArrowUp(event) {
      event.preventDefault();
      var amount = event.shiftKey ? -5 : -1;
      this.moveHighlightedIndex(amount, {
        type: Downshift$1.stateChangeTypes.keyDownArrowUp
      });
    },
    Enter: function Enter(event) {
      if (this.getState().isOpen) {
        event.preventDefault();
        this.selectHighlightedItem({
          type: Downshift$1.stateChangeTypes.keyDownEnter
        });
      }
    },
    Escape: function Escape(event) {
      event.preventDefault();
      this.reset({ type: Downshift$1.stateChangeTypes.keyDownEscape });
    }
  };
  this.buttonKeyDownHandlers = _extends({}, this.keyDownHandlers, {
    ' ': function _(event) {
      event.preventDefault();
      this.toggleMenu({ type: Downshift$1.stateChangeTypes.keyDownSpaceButton });
    }
  });

  this.getButtonProps = function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onClick = _ref4.onClick,
        onKeyDown = _ref4.onKeyDown,
        onBlur = _ref4.onBlur,
        rest = objectWithoutProperties(_ref4, ['onClick', 'onKeyDown', 'onBlur']);

    var _getState3 = _this5.getState(),
        isOpen = _getState3.isOpen;

    var enabledEventHandlers = {
      onClick: composeEventHandlers(onClick, _this5.button_handleClick),
      onKeyDown: composeEventHandlers(onKeyDown, _this5.button_handleKeyDown),
      onBlur: composeEventHandlers(onBlur, _this5.button_handleBlur)
    };
    var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
    return _extends({
      type: 'button',
      role: 'button',
      'aria-label': isOpen ? 'close menu' : 'open menu',
      'aria-expanded': isOpen,
      'aria-haspopup': true
    }, eventHandlers, rest);
  };

  this.button_handleKeyDown = function (event) {
    if (_this5.buttonKeyDownHandlers[event.key]) {
      _this5.buttonKeyDownHandlers[event.key].call(_this5, event);
    }
  };

  this.button_handleClick = function (event) {
    event.preventDefault();
    // handle odd case for Safari and Firefox which
    // don't give the button the focus properly.
    /* istanbul ignore if (can't reasonably test this) */
    if (_this5.props.environment.document.activeElement === _this5.props.environment.document.body) {
      event.target.focus();
    }
    _this5.toggleMenu({ type: Downshift$1.stateChangeTypes.clickButton });
  };

  this.button_handleBlur = function () {
    if (!_this5.isMouseDown) {
      _this5.reset({ type: Downshift$1.stateChangeTypes.blurButton });
    }
  };

  this.getLabelProps = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _this5.getLabelProps.called = true;
    if (_this5.getInputProps.called && props.htmlFor && props.htmlFor !== _this5.inputId) {
      throw new Error('downshift: You provided the htmlFor of "' + props.htmlFor + '" for your label, but the id of your input is "' + _this5.inputId + '". You must either remove the id from your input or set the htmlFor of the label equal to the input id.');
    }
    _this5.inputId = firstDefined(_this5.inputId, props.htmlFor, _this5.id + '-input');
    return _extends({}, props, {
      htmlFor: _this5.inputId
    });
  };

  this.getInputProps = function () {
    var _ref6;

    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onKeyDown = _ref5.onKeyDown,
        onBlur = _ref5.onBlur,
        onChange = _ref5.onChange,
        onInput = _ref5.onInput,
        rest = objectWithoutProperties(_ref5, ['onKeyDown', 'onBlur', 'onChange', 'onInput']);

    _this5.getInputProps.called = true;
    if (_this5.getLabelProps.called && rest.id && rest.id !== _this5.inputId) {
      throw new Error('downshift: You provided the id of "' + rest.id + '" for your input, but the htmlFor of your label is "' + _this5.inputId + '". You must either remove the id from your input or set the htmlFor of the label equal to the input id.');
    }
    _this5.inputId = firstDefined(_this5.inputId, rest.id, _this5.id + '-input');
    var onChangeKey = void 0;
    /* istanbul ignore next (preact) */
    onChangeKey = 'onChange';

    var _getState4 = _this5.getState(),
        inputValue = _getState4.inputValue,
        isOpen = _getState4.isOpen,
        highlightedIndex = _getState4.highlightedIndex;

    var eventHandlers = rest.disabled ? {} : (_ref6 = {}, _ref6[onChangeKey] = composeEventHandlers(onChange, onInput, _this5.input_handleChange), _ref6.onKeyDown = composeEventHandlers(onKeyDown, _this5.input_handleKeyDown), _ref6.onBlur = composeEventHandlers(onBlur, _this5.input_handleBlur), _ref6);
    return _extends({
      role: 'combobox',
      'aria-autocomplete': 'list',
      'aria-expanded': isOpen,
      'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this5.getItemId(highlightedIndex) : null,
      autoComplete: 'off',
      value: inputValue
    }, eventHandlers, rest, {
      id: _this5.inputId
    });
  };

  this.input_handleKeyDown = function (event) {
    if (event.key && _this5.keyDownHandlers[event.key]) {
      _this5.keyDownHandlers[event.key].call(_this5, event);
    }
  };

  this.input_handleChange = function (event) {
    _this5.internalSetState({
      type: Downshift$1.stateChangeTypes.changeInput,
      isOpen: true,
      inputValue: event.target.value
    });
  };

  this.input_handleBlur = function () {
    if (!_this5.isMouseDown) {
      _this5.reset({ type: Downshift$1.stateChangeTypes.blurInput });
    }
  };

  this.getItemProps = function () {
    var _babelHelpers$extends2;

    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onMouseMove = _ref7.onMouseMove,
        onMouseDown = _ref7.onMouseDown,
        onClick = _ref7.onClick,
        index = _ref7.index,
        _ref7$item = _ref7.item,
        item = _ref7$item === undefined ? requiredProp('getItemProps', 'item') : _ref7$item,
        rest = objectWithoutProperties(_ref7, ['onMouseMove', 'onMouseDown', 'onClick', 'index', 'item']);

    if (index === undefined) {
      _this5.items.push(item);
      index = _this5.items.indexOf(item);
    } else {
      _this5.items[index] = item;
    }

    var onSelectKey = 'onClick';
    return _extends((_babelHelpers$extends2 = {
      id: _this5.getItemId(index),
      // onMouseMove is used over onMouseEnter here. onMouseMove
      // is only triggered on actual mouse movement while onMouseEnter
      // can fire on DOM changes, interrupting keyboard navigation
      onMouseMove: composeEventHandlers(onMouseMove, function () {
        if (index === _this5.getState().highlightedIndex) {
          return;
        }
        _this5.setHighlightedIndex(index, {
          type: Downshift$1.stateChangeTypes.itemMouseEnter
        });

        // We never want to manually scroll when changing state based
        // on `onMouseMove` because we will be moving the element out
        // from under the user which is currently scrolling/moving the
        // cursor
        _this5.avoidScrolling = true;
        setTimeout(function () {
          return _this5.avoidScrolling = false;
        }, 250);
      }),
      onMouseDown: composeEventHandlers(onMouseDown, function (event) {
        // This prevents the activeElement from being changed
        // to the item so it can remain with the current activeElement
        // which is a more common use case.
        event.preventDefault();
      })
    }, _babelHelpers$extends2[onSelectKey] = composeEventHandlers(onClick, function () {
      _this5.selectItemAtIndex(index, {
        type: Downshift$1.stateChangeTypes.clickItem
      });
    }), _babelHelpers$extends2), rest);
  };

  this.clearItems = function () {
    _this5.items = [];
  };

  this.reset = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cb = arguments[1];

    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(function (_ref8) {
      var selectedItem = _ref8.selectedItem;
      return _extends({
        isOpen: false,
        highlightedIndex: _this5.props.defaultHighlightedIndex,
        inputValue: _this5.props.itemToString(selectedItem)
      }, otherStateToSet);
    }, cbToCb(cb));
  };

  this.toggleMenu = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cb = arguments[1];

    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(function (_ref9) {
      var isOpen = _ref9.isOpen;

      return _extends({ isOpen: !isOpen }, otherStateToSet);
    }, function () {
      var _getState5 = _this5.getState(),
          isOpen = _getState5.isOpen;

      if (isOpen) {
        _this5.highlightDefaultIndex();
      }
      cbToCb(cb)();
    });
  };

  this.openMenu = function (cb) {
    _this5.internalSetState({ isOpen: true }, cbToCb(cb));
  };

  this.closeMenu = function (cb) {
    _this5.internalSetState({ isOpen: false }, cbToCb(cb));
  };

  this.updateStatus = debounce(function () {
    if (!_this5._isMounted) {
      return;
    }
    var state = _this5.getState();
    var item = _this5.items[state.highlightedIndex];
    var resultCount = _this5.getItemCount();
    var status = _this5.props.getA11yStatusMessage(_extends({
      itemToString: _this5.props.itemToString,
      previousResultCount: _this5.previousResultCount,
      resultCount: resultCount,
      highlightedItem: item
    }, state));
    _this5.previousResultCount = resultCount;
    /* istanbul ignore else (react-native) */
    setStatus(status);
  }, 200);
};

 false ? Downshift$1.propTypes = {
  children: PropTypes.func,
  render: PropTypes.func,
  defaultHighlightedIndex: PropTypes.number,
  defaultSelectedItem: PropTypes.any,
  defaultInputValue: PropTypes.string,
  defaultIsOpen: PropTypes.bool,
  getA11yStatusMessage: PropTypes.func,
  itemToString: PropTypes.func,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onStateChange: PropTypes.func,
  onInputValueChange: PropTypes.func,
  onUserAction: PropTypes.func,
  onOuterClick: PropTypes.func,
  selectedItemChanged: PropTypes.func,
  stateReducer: PropTypes.func,
  itemCount: PropTypes.number,
  id: PropTypes.string,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
    document: PropTypes.shape({
      getElementById: PropTypes.func,
      activeElement: PropTypes.any,
      body: PropTypes.any
    })
  }),
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: PropTypes.any,
  isOpen: PropTypes.bool,
  inputValue: PropTypes.string,
  highlightedIndex: PropTypes.number,
  breakingChanges: PropTypes.shape({
    resetInputOnSelection: PropTypes.bool
  })
  /* eslint-enable */
} : void 0;


function validateGetRootPropsCalledCorrectly(element, _ref) {
  var refKey = _ref.refKey;

  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);
  if (isComposite && !refKeySpecified) {
    throw new Error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    throw new Error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + refKey + '"');
  }
  if (!getElementProps(element)[refKey]) {
    throw new Error('downshift: You must apply the ref prop "' + refKey + '" from getRootProps onto your root element.');
  }
}

/*
 * Fix importing in typescript after rollup compilation
 * https://github.com/rollup/rollup/issues/1156
 * https://github.com/Microsoft/TypeScript/issues/13017#issuecomment-268657860
 */
Downshift$1.default = Downshift$1;
Downshift$1.resetIdCounter = resetIdCounter;

/* harmony default export */ __webpack_exports__["a"] = (Downshift$1);


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScrollDirection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var ALIGNMENT;
(function (ALIGNMENT) {
    ALIGNMENT["AUTO"] = "auto";
    ALIGNMENT["START"] = "start";
    ALIGNMENT["CENTER"] = "center";
    ALIGNMENT["END"] = "end";
})(ALIGNMENT || (ALIGNMENT = {}));
var DIRECTION;
(function (DIRECTION) {
    DIRECTION["HORIZONTAL"] = "horizontal";
    DIRECTION["VERTICAL"] = "vertical";
})(DIRECTION || (DIRECTION = {}));
var SCROLL_CHANGE_REASON;
(function (SCROLL_CHANGE_REASON) {
    SCROLL_CHANGE_REASON["OBSERVED"] = "observed";
    SCROLL_CHANGE_REASON["REQUESTED"] = "requested";
})(SCROLL_CHANGE_REASON || (SCROLL_CHANGE_REASON = {}));
var scrollProp = (_a = {}, _a[DIRECTION.VERTICAL] = 'scrollTop', _a[DIRECTION.HORIZONTAL] = 'scrollLeft', _a);
var sizeProp = (_b = {}, _b[DIRECTION.VERTICAL] = 'height', _b[DIRECTION.HORIZONTAL] = 'width', _b);
var positionProp = (_c = {}, _c[DIRECTION.VERTICAL] = 'top', _c[DIRECTION.HORIZONTAL] = 'left', _c);
var marginProp = (_d = {}, _d[DIRECTION.VERTICAL] = 'marginTop', _d[DIRECTION.HORIZONTAL] = 'marginLeft', _d);
var oppositeMarginProp = (_e = {}, _e[DIRECTION.VERTICAL] = 'marginBottom', _e[DIRECTION.HORIZONTAL] = 'marginRight', _e);
var _a;
var _b;
var _c;
var _d;
var _e;

/* Forked from react-virtualized 💖 */
var SizeAndPositionManager = /** @class */function () {
    function SizeAndPositionManager(_a) {
        var itemCount = _a.itemCount,
            itemSizeGetter = _a.itemSizeGetter,
            estimatedItemSize = _a.estimatedItemSize;
        this.itemSizeGetter = itemSizeGetter;
        this.itemCount = itemCount;
        this.estimatedItemSize = estimatedItemSize;
        // Cache of size and position data for items, mapped by item index.
        this.itemSizeAndPositionData = {};
        // Measurements for items up to this index can be trusted; items afterward should be estimated.
        this.lastMeasuredIndex = -1;
    }
    SizeAndPositionManager.prototype.updateConfig = function (_a) {
        var itemCount = _a.itemCount,
            itemSizeGetter = _a.itemSizeGetter,
            estimatedItemSize = _a.estimatedItemSize;
        if (itemCount != null) {
            this.itemCount = itemCount;
        }
        if (estimatedItemSize != null) {
            this.estimatedItemSize = estimatedItemSize;
        }
        if (itemSizeGetter != null) {
            this.itemSizeGetter = itemSizeGetter;
        }
    };
    SizeAndPositionManager.prototype.getLastMeasuredIndex = function () {
        return this.lastMeasuredIndex;
    };
    /**
     * This method returns the size and position for the item at the specified index.
     * It just-in-time calculates (or used cached values) for items leading up to the index.
     */
    SizeAndPositionManager.prototype.getSizeAndPositionForIndex = function (index) {
        if (index < 0 || index >= this.itemCount) {
            throw Error("Requested index " + index + " is outside of range 0.." + this.itemCount);
        }
        if (index > this.lastMeasuredIndex) {
            var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
            var offset = lastMeasuredSizeAndPosition.offset + lastMeasuredSizeAndPosition.size;
            for (var i = this.lastMeasuredIndex + 1; i <= index; i++) {
                var size = this.itemSizeGetter(i);
                if (size == null || isNaN(size)) {
                    throw Error("Invalid size returned for index " + i + " of value " + size);
                }
                this.itemSizeAndPositionData[i] = {
                    offset: offset,
                    size: size
                };
                offset += size;
            }
            this.lastMeasuredIndex = index;
        }
        return this.itemSizeAndPositionData[index];
    };
    SizeAndPositionManager.prototype.getSizeAndPositionOfLastMeasuredItem = function () {
        return this.lastMeasuredIndex >= 0 ? this.itemSizeAndPositionData[this.lastMeasuredIndex] : { offset: 0, size: 0 };
    };
    /**
     * Total size of all items being measured.
     * This value will be completedly estimated initially.
     * As items as measured the estimate will be updated.
     */
    SizeAndPositionManager.prototype.getTotalSize = function () {
        var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
        return lastMeasuredSizeAndPosition.offset + lastMeasuredSizeAndPosition.size + (this.itemCount - this.lastMeasuredIndex - 1) * this.estimatedItemSize;
    };
    /**
     * Determines a new offset that ensures a certain item is visible, given the alignment.
     *
     * @param align Desired alignment within container; one of "start" (default), "center", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @return Offset to use to ensure the specified item is visible
     */
    SizeAndPositionManager.prototype.getUpdatedOffsetForIndex = function (_a) {
        var _b = _a.align,
            align = _b === void 0 ? ALIGNMENT.START : _b,
            containerSize = _a.containerSize,
            currentOffset = _a.currentOffset,
            targetIndex = _a.targetIndex;
        if (containerSize <= 0) {
            return 0;
        }
        var datum = this.getSizeAndPositionForIndex(targetIndex);
        var maxOffset = datum.offset;
        var minOffset = maxOffset - containerSize + datum.size;
        var idealOffset;
        switch (align) {
            case ALIGNMENT.END:
                idealOffset = minOffset;
                break;
            case ALIGNMENT.CENTER:
                idealOffset = maxOffset - (containerSize - datum.size) / 2;
                break;
            case ALIGNMENT.START:
                idealOffset = maxOffset;
                break;
            default:
                idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
        }
        var totalSize = this.getTotalSize();
        return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    };
    SizeAndPositionManager.prototype.getVisibleRange = function (_a) {
        var containerSize = _a.containerSize,
            offset = _a.offset,
            overscanCount = _a.overscanCount;
        var totalSize = this.getTotalSize();
        if (totalSize === 0) {
            return {};
        }
        var maxOffset = offset + containerSize;
        var start = this.findNearestItem(offset);
        if (typeof start === 'undefined') {
            throw Error("Invalid offset " + offset + " specified");
        }
        var datum = this.getSizeAndPositionForIndex(start);
        offset = datum.offset + datum.size;
        var stop = start;
        while (offset < maxOffset && stop < this.itemCount - 1) {
            stop++;
            offset += this.getSizeAndPositionForIndex(stop).size;
        }
        if (overscanCount) {
            start = Math.max(0, start - overscanCount);
            stop = Math.min(stop + overscanCount, this.itemCount - 1);
        }
        return {
            start: start,
            stop: stop
        };
    };
    /**
     * Clear all cached values for items after the specified index.
     * This method should be called for any item that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionForIndex() is called.
     */
    SizeAndPositionManager.prototype.resetItem = function (index) {
        this.lastMeasuredIndex = Math.min(this.lastMeasuredIndex, index - 1);
    };
    /**
     * Searches for the item (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest item index will be returned.
     * This allows partially visible items (with offsets just before/above the fold) to be visible.
     */
    SizeAndPositionManager.prototype.findNearestItem = function (offset) {
        if (isNaN(offset)) {
            throw Error("Invalid offset " + offset + " specified");
        }
        // Our search algorithms find the nearest match at or below the specified offset.
        // So make sure the offset is at least 0 or no match will be found.
        offset = Math.max(0, offset);
        var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
        var lastMeasuredIndex = Math.max(0, this.lastMeasuredIndex);
        if (lastMeasuredSizeAndPosition.offset >= offset) {
            // If we've already measured items within this range just use a binary search as it's faster.
            return this.binarySearch({
                high: lastMeasuredIndex,
                low: 0,
                offset: offset
            });
        } else {
            // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
            // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
            // The overall complexity for this approach is O(log n).
            return this.exponentialSearch({
                index: lastMeasuredIndex,
                offset: offset
            });
        }
    };
    SizeAndPositionManager.prototype.binarySearch = function (_a) {
        var low = _a.low,
            high = _a.high,
            offset = _a.offset;
        var middle = 0;
        var currentOffset = 0;
        while (low <= high) {
            middle = low + Math.floor((high - low) / 2);
            currentOffset = this.getSizeAndPositionForIndex(middle).offset;
            if (currentOffset === offset) {
                return middle;
            } else if (currentOffset < offset) {
                low = middle + 1;
            } else if (currentOffset > offset) {
                high = middle - 1;
            }
        }
        if (low > 0) {
            return low - 1;
        }
        return 0;
    };
    SizeAndPositionManager.prototype.exponentialSearch = function (_a) {
        var index = _a.index,
            offset = _a.offset;
        var interval = 1;
        while (index < this.itemCount && this.getSizeAndPositionForIndex(index).offset < offset) {
            index += interval;
            interval *= 2;
        }
        return this.binarySearch({
            high: Math.min(index, this.itemCount - 1),
            low: Math.floor(index / 2),
            offset: offset
        });
    };
    return SizeAndPositionManager;
}();

var STYLE_WRAPPER = {
    overflow: 'auto',
    willChange: 'transform',
    WebkitOverflowScrolling: 'touch'
};
var STYLE_INNER = {
    position: 'relative',
    width: '100%',
    minHeight: '100%'
};
var STYLE_ITEM = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%'
};
var STYLE_STICKY_ITEM = __assign({}, STYLE_ITEM, { position: 'sticky' });
var VirtualList = /** @class */function (_super) {
    __extends(VirtualList, _super);
    function VirtualList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemSizeGetter = function (itemSize) {
            return function (index) {
                return _this.getSize(index, itemSize);
            };
        };
        _this.sizeAndPositionManager = new SizeAndPositionManager({
            itemCount: _this.props.itemCount,
            itemSizeGetter: _this.itemSizeGetter(_this.props.itemSize),
            estimatedItemSize: _this.getEstimatedItemSize()
        });
        _this.state = {
            offset: _this.props.scrollOffset || _this.props.scrollToIndex != null && _this.getOffsetForIndex(_this.props.scrollToIndex) || 0,
            scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
        };
        _this.styleCache = {};
        _this.getRef = function (node) {
            _this.rootNode = node;
        };
        _this.handleScroll = function (event) {
            var onScroll = _this.props.onScroll;
            var offset = _this.getNodeOffset();
            if (offset < 0 || _this.state.offset === offset || event.target !== _this.rootNode) {
                return;
            }
            _this.setState({
                offset: offset,
                scrollChangeReason: SCROLL_CHANGE_REASON.OBSERVED
            });
            if (typeof onScroll === 'function') {
                onScroll(offset, event);
            }
        };
        return _this;
    }
    VirtualList.prototype.componentDidMount = function () {
        var _a = this.props,
            scrollOffset = _a.scrollOffset,
            scrollToIndex = _a.scrollToIndex;
        this.rootNode.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        if (scrollOffset != null) {
            this.scrollTo(scrollOffset);
        } else if (scrollToIndex != null) {
            this.scrollTo(this.getOffsetForIndex(scrollToIndex));
        }
    };
    VirtualList.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.props,
            estimatedItemSize = _a.estimatedItemSize,
            itemCount = _a.itemCount,
            itemSize = _a.itemSize,
            scrollOffset = _a.scrollOffset,
            scrollToAlignment = _a.scrollToAlignment,
            scrollToIndex = _a.scrollToIndex;
        var scrollPropsHaveChanged = nextProps.scrollToIndex !== scrollToIndex || nextProps.scrollToAlignment !== scrollToAlignment;
        var itemPropsHaveChanged = nextProps.itemCount !== itemCount || nextProps.itemSize !== itemSize || nextProps.estimatedItemSize !== estimatedItemSize;
        if (nextProps.itemSize !== itemSize) {
            this.sizeAndPositionManager.updateConfig({
                itemSizeGetter: this.itemSizeGetter(nextProps.itemSize)
            });
        }
        if (nextProps.itemCount !== itemCount || nextProps.estimatedItemSize !== estimatedItemSize) {
            this.sizeAndPositionManager.updateConfig({
                itemCount: nextProps.itemCount,
                estimatedItemSize: this.getEstimatedItemSize(nextProps)
            });
        }
        if (itemPropsHaveChanged) {
            this.recomputeSizes();
        }
        if (nextProps.scrollOffset !== scrollOffset) {
            this.setState({
                offset: nextProps.scrollOffset || 0,
                scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
            });
        } else if (typeof nextProps.scrollToIndex === 'number' && (scrollPropsHaveChanged || itemPropsHaveChanged)) {
            this.setState({
                offset: this.getOffsetForIndex(nextProps.scrollToIndex, nextProps.scrollToAlignment, nextProps.itemCount),
                scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
            });
        }
    };
    VirtualList.prototype.componentDidUpdate = function (_, prevState) {
        var _a = this.state,
            offset = _a.offset,
            scrollChangeReason = _a.scrollChangeReason;
        if (prevState.offset !== offset && scrollChangeReason === SCROLL_CHANGE_REASON.REQUESTED) {
            this.scrollTo(offset);
        }
    };
    VirtualList.prototype.componentWillUnmount = function () {
        this.rootNode.removeEventListener('scroll', this.handleScroll);
    };
    VirtualList.prototype.scrollTo = function (value) {
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        this.rootNode[scrollProp[scrollDirection]] = value;
    };
    VirtualList.prototype.getOffsetForIndex = function (index, scrollToAlignment, itemCount) {
        if (scrollToAlignment === void 0) {
            scrollToAlignment = this.props.scrollToAlignment;
        }
        if (itemCount === void 0) {
            itemCount = this.props.itemCount;
        }
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        if (index < 0 || index >= itemCount) {
            index = 0;
        }
        return this.sizeAndPositionManager.getUpdatedOffsetForIndex({
            align: scrollToAlignment,
            containerSize: this.props[sizeProp[scrollDirection]],
            currentOffset: this.state && this.state.offset || 0,
            targetIndex: index
        });
    };
    VirtualList.prototype.recomputeSizes = function (startIndex) {
        if (startIndex === void 0) {
            startIndex = 0;
        }
        this.styleCache = {};
        this.sizeAndPositionManager.resetItem(startIndex);
    };
    VirtualList.prototype.render = function () {
        var _this = this;
        var _a = this.props,
            estimatedItemSize = _a.estimatedItemSize,
            height = _a.height,
            _b = _a.overscanCount,
            overscanCount = _b === void 0 ? 3 : _b,
            renderItem = _a.renderItem,
            itemCount = _a.itemCount,
            itemSize = _a.itemSize,
            onItemsRendered = _a.onItemsRendered,
            onScroll = _a.onScroll,
            _c = _a.scrollDirection,
            scrollDirection = _c === void 0 ? DIRECTION.VERTICAL : _c,
            scrollOffset = _a.scrollOffset,
            scrollToIndex = _a.scrollToIndex,
            scrollToAlignment = _a.scrollToAlignment,
            stickyIndices = _a.stickyIndices,
            style = _a.style,
            width = _a.width,
            props = __rest(_a, ["estimatedItemSize", "height", "overscanCount", "renderItem", "itemCount", "itemSize", "onItemsRendered", "onScroll", "scrollDirection", "scrollOffset", "scrollToIndex", "scrollToAlignment", "stickyIndices", "style", "width"]);
        var offset = this.state.offset;
        var _d = this.sizeAndPositionManager.getVisibleRange({
            containerSize: this.props[sizeProp[scrollDirection]] || 0,
            offset: offset,
            overscanCount: overscanCount
        }),
            start = _d.start,
            stop = _d.stop;
        var items = [];
        var wrapperStyle = __assign({}, STYLE_WRAPPER, style, { height: height, width: width });
        var innerStyle = __assign({}, STYLE_INNER, (_e = {}, _e[sizeProp[scrollDirection]] = this.sizeAndPositionManager.getTotalSize(), _e));
        if (stickyIndices != null && stickyIndices.length !== 0) {
            stickyIndices.forEach(function (index) {
                return items.push(renderItem({
                    index: index,
                    style: _this.getStyle(index, true)
                }));
            });
            if (scrollDirection === DIRECTION.HORIZONTAL) {
                innerStyle.display = 'flex';
            }
        }
        if (typeof start !== 'undefined' && typeof stop !== 'undefined') {
            for (var index = start; index <= stop; index++) {
                if (stickyIndices != null && stickyIndices.includes(index)) {
                    continue;
                }
                items.push(renderItem({
                    index: index,
                    style: this.getStyle(index, false)
                }));
            }
            if (typeof onItemsRendered === 'function') {
                onItemsRendered({
                    startIndex: start,
                    stopIndex: stop
                });
            }
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", __assign({ ref: this.getRef }, props, { style: wrapperStyle }), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { style: innerStyle }, items));
        var _e;
    };
    VirtualList.prototype.getNodeOffset = function () {
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        return this.rootNode[scrollProp[scrollDirection]];
    };
    VirtualList.prototype.getEstimatedItemSize = function (props) {
        if (props === void 0) {
            props = this.props;
        }
        return props.estimatedItemSize || typeof props.itemSize === 'number' && props.itemSize || 50;
    };
    VirtualList.prototype.getSize = function (index, itemSize) {
        if (typeof itemSize === 'function') {
            return itemSize(index);
        }
        return Array.isArray(itemSize) ? itemSize[index] : itemSize;
    };
    VirtualList.prototype.getStyle = function (index, sticky) {
        var style = this.styleCache[index];
        if (style) {
            return style;
        }
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        var _b = this.sizeAndPositionManager.getSizeAndPositionForIndex(index),
            size = _b.size,
            offset = _b.offset;
        return this.styleCache[index] = sticky ? __assign({}, STYLE_STICKY_ITEM, (_c = {}, _c[sizeProp[scrollDirection]] = size, _c[marginProp[scrollDirection]] = offset, _c[oppositeMarginProp[scrollDirection]] = -(offset + size), _c.zIndex = 1, _c)) : __assign({}, STYLE_ITEM, (_d = {}, _d[sizeProp[scrollDirection]] = size, _d[positionProp[scrollDirection]] = offset, _d));
        var _c, _d;
    };
    VirtualList.defaultProps = {
        overscanCount: 3,
        scrollDirection: DIRECTION.VERTICAL,
        width: '100%'
    };
    VirtualList.propTypes = {
        estimatedItemSize: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        height: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]).isRequired,
        itemCount: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"].isRequired,
        itemSize: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["array"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]]).isRequired,
        onScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
        onItemsRendered: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
        overscanCount: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        renderItem: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"].isRequired,
        scrollOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        scrollToIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        scrollToAlignment: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOf"])([ALIGNMENT.AUTO, ALIGNMENT.START, ALIGNMENT.CENTER, ALIGNMENT.END]),
        scrollDirection: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOf"])([DIRECTION.HORIZONTAL, DIRECTION.VERTICAL]),
        stickyIndices: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"]),
        style: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
        width: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]])
    };
    return VirtualList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);


/* harmony default export */ __webpack_exports__["a"] = (VirtualList);


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rankings */
function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var diacritics = createCommonjsModule(function (module) {
// Diacritics.js
// 
// Started as something to be an equivalent of the Google Java Library diacritics library for JavaScript.
// Found this: http://jsperf.com/diacritics/6 and converted it into a reusable module.
// 
// @author Nijiko Yonskai
// @license MIT
// @copyright Nijikokun 2013 <nijikokun@gmail.com>
(function (name, definition) {
  if ('object' != 'undefined' && module.exports) module.exports = definition();
  else if (false) undefined(definition);
  else this[name] = definition();
})('Diacritics', function () {
  // Create public object
  var output = {
    map: {}
  };

  // Create private reference map.
  var reference = [
    {'base':' ',    'letters':'\u00A0'},
    {'base':'A',    'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
    {'base':'AA',   'letters':'\uA732'},
    {'base':'AE',   'letters':'\u00C6\u01FC\u01E2'},
    {'base':'AO',   'letters':'\uA734'},
    {'base':'AU',   'letters':'\uA736'},
    {'base':'AV',   'letters':'\uA738\uA73A'},
    {'base':'AY',   'letters':'\uA73C'},
    {'base':'B',    'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
    {'base':'C',    'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
    {'base':'D',    'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
    {'base':'DZ',   'letters':'\u01F1\u01C4'},
    {'base':'Dz',   'letters':'\u01F2\u01C5'},
    {'base':'E',    'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
    {'base':'F',    'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
    {'base':'G',    'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
    {'base':'H',    'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
    {'base':'I',    'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
    {'base':'J',    'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
    {'base':'K',    'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
    {'base':'L',    'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
    {'base':'LJ',   'letters':'\u01C7'},
    {'base':'Lj',   'letters':'\u01C8'},
    {'base':'M',    'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
    {'base':'N',    'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
    {'base':'NJ',   'letters':'\u01CA'},
    {'base':'Nj',   'letters':'\u01CB'},
    {'base':'O',    'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
    {'base':'OI',   'letters':'\u01A2'},
    {'base':'OO',   'letters':'\uA74E'},
    {'base':'OU',   'letters':'\u0222'},
    {'base':'P',    'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
    {'base':'Q',    'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
    {'base':'R',    'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
    {'base':'S',    'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
    {'base':'T',    'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
    {'base':'Th',   'letters':'\u00DE'},
    {'base':'TZ',   'letters':'\uA728'},
    {'base':'U',    'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
    {'base':'V',    'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
    {'base':'VY',   'letters':'\uA760'},
    {'base':'W',    'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
    {'base':'X',    'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
    {'base':'Y',    'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
    {'base':'Z',    'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
    {'base':'a',    'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251'},
    {'base':'aa',   'letters':'\uA733'},
    {'base':'ae',   'letters':'\u00E6\u01FD\u01E3'},
    {'base':'ao',   'letters':'\uA735'},
    {'base':'au',   'letters':'\uA737'},
    {'base':'av',   'letters':'\uA739\uA73B'},
    {'base':'ay',   'letters':'\uA73D'},
    {'base':'b',    'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
    {'base':'c',    'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
    {'base':'d',    'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
    {'base':'dz',   'letters':'\u01F3\u01C6'},
    {'base':'e',    'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
    {'base':'f',    'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
    {'base':'ff',   'letters':'\uFB00'},
    {'base':'fi',   'letters':'\uFB01'},
    {'base':'fl',   'letters':'\uFB02'},
    {'base':'ffi',  'letters':'\uFB03'},
    {'base':'ffl',  'letters':'\uFB04'},
    {'base':'g',    'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
    {'base':'h',    'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
    {'base':'hv',   'letters':'\u0195'},
    {'base':'i',    'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
    {'base':'j',    'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
    {'base':'k',    'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
    {'base':'l',    'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
    {'base':'lj',   'letters':'\u01C9'},
    {'base':'m',    'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
    {'base':'n',    'letters':'\x6E\xF1\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509'},
    {'base':'nj',   'letters':'\u01CC'},
    {'base':'o',    'letters':'\u07C0\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
    {'base':'oe',   'letters':'\u0152\u0153'},
    {'base':'oi',   'letters':'\u01A3'},
    {'base':'ou',   'letters':'\u0223'},
    {'base':'oo',   'letters':'\uA74F'},
    {'base':'p',    'letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
    {'base':'q',    'letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
    {'base':'r',    'letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
    {'base':'s',    'letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
    {'base':'ss',   'letters':'\xDF'},
    {'base':'t',    'letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
    {'base':'th',   'letters':'\u00FE'},
    {'base':'tz',   'letters':'\uA729'},
    {'base':'u',    'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
    {'base':'v',    'letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
    {'base':'vy',   'letters':'\uA761'},
    {'base':'w',    'letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
    {'base':'x',    'letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
    {'base':'y',    'letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
    {'base':'z',    'letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
  ];

  // Generate reference mapping
  for (var i = 0, refLength = reference.length; i < refLength; i++){
    var letters = reference[i].letters.split("");

    for (var j = 0, letLength = letters.length; j < letLength; j++){
      output.map[letters[j]] = reference[i].base;
    }
  }

  /**
   * Clean accents (diacritics) from string.
   * 
   * @param  {String} input String to be cleaned of diacritics.
   * @return {String}
   */
  output.clean = function (input) {
    if (!input || !input.length || input.length < 1) {
      return "";
    }

    var string = "";
    var letters = input.split("");
    var index = 0;
    var length = letters.length;
    var letter;

    for (; index < length; index++) {
      letter = letters[index];
      string += letter in output.map ? output.map[letter] : letter;
    }

    return string;
  };

  return output;
});
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2017 Kent C. Dodds
 * @author Kent C. Dodds <kent@doddsfamily.us>
 */

var rankings = {
  CASE_SENSITIVE_EQUAL: 9,
  EQUAL: 8,
  STARTS_WITH: 7,
  WORD_STARTS_WITH: 6,
  STRING_CASE: 5,
  STRING_CASE_ACRONYM: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};

var caseRankings = {
  CAMEL: 0.8,
  PASCAL: 0.6,
  KEBAB: 0.4,
  SNAKE: 0.2,
  NO_CASE: 0
};

matchSorter.rankings = rankings;
matchSorter.caseRankings = caseRankings;

/**
 * Takes an array of items and a value and returns a new array with the items that match the given value
 * @param {Array} items - the items to sort
 * @param {String} value - the value to use for ranking
 * @param {Object} options - Some options to configure the sorter
 * @return {Array} - the new sorted array
 */
function matchSorter(items, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // not performing any search/sort if value(search term) is empty
  if (!value) return items;

  var keys = options.keys,
      _options$threshold = options.threshold,
      threshold = _options$threshold === undefined ? rankings.MATCHES : _options$threshold;

  var matchedItems = items.reduce(function (matches, item, index) {
    var _getHighestRanking = getHighestRanking(item, keys, value, options),
        rank = _getHighestRanking.rank,
        keyIndex = _getHighestRanking.keyIndex,
        _getHighestRanking$ke = _getHighestRanking.keyThreshold,
        keyThreshold = _getHighestRanking$ke === undefined ? threshold : _getHighestRanking$ke;

    if (rank >= keyThreshold) {
      matches.push({ item: item, rank: rank, index: index, keyIndex: keyIndex });
    }
    return matches;
  }, []);
  return matchedItems.sort(sortRankedItems).map(function (_ref) {
    var item = _ref.item;
    return item;
  });
}

/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, keyIndex: Number, keyThreshold: Number}} - the highest ranking
 */
function getHighestRanking(item, keys, value, options) {
  if (!keys) {
    return {
      rank: getMatchRanking(item, value, options),
      keyIndex: -1,
      keyThreshold: options.threshold
    };
  }
  var valuesToRank = getAllValuesToRank(item, keys);
  return valuesToRank.reduce(function (_ref2, _ref3, i) {
    var rank = _ref2.rank,
        keyIndex = _ref2.keyIndex,
        keyThreshold = _ref2.keyThreshold;
    var itemValue = _ref3.itemValue,
        attributes = _ref3.attributes;

    var newRank = getMatchRanking(itemValue, value, options);
    var minRanking = attributes.minRanking,
        maxRanking = attributes.maxRanking,
        threshold = attributes.threshold;

    if (newRank < minRanking && newRank >= rankings.MATCHES) {
      newRank = minRanking;
    } else if (newRank > maxRanking) {
      newRank = maxRanking;
    }
    if (newRank > rank) {
      rank = newRank;
      keyIndex = i;
      keyThreshold = threshold;
    }
    return { rank: rank, keyIndex: keyIndex, keyThreshold: keyThreshold };
  }, { rank: rankings.NO_MATCH, keyIndex: -1, keyThreshold: options.threshold });
}

/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */
function getMatchRanking(testString, stringToRank, options) {
  /* eslint complexity:[2, 12] */
  testString = prepareValueForComparison(testString, options);
  stringToRank = prepareValueForComparison(stringToRank, options);

  // too long
  if (stringToRank.length > testString.length) {
    return rankings.NO_MATCH;
  }

  // case sensitive equals
  if (testString === stringToRank) {
    return rankings.CASE_SENSITIVE_EQUAL;
  }

  var caseRank = getCaseRanking(testString);
  var isPartial = isPartialOfCase(testString, stringToRank, caseRank);
  var isCasedAcronym = isCaseAcronym(testString, stringToRank, caseRank);

  // Lower casing before further comparison
  testString = testString.toLowerCase();
  stringToRank = stringToRank.toLowerCase();

  // case insensitive equals
  if (testString === stringToRank) {
    return rankings.EQUAL + caseRank;
  }

  // starts with
  if (testString.indexOf(stringToRank) === 0) {
    return rankings.STARTS_WITH + caseRank;
  }

  // word starts with
  if (testString.indexOf(' ' + stringToRank) !== -1) {
    return rankings.WORD_STARTS_WITH + caseRank;
  }

  // is a part inside a cased string
  if (isPartial) {
    return rankings.STRING_CASE + caseRank;
  }

  // is acronym for a cased string
  if (caseRank > 0 && isCasedAcronym) {
    return rankings.STRING_CASE_ACRONYM + caseRank;
  }

  // contains
  if (testString.indexOf(stringToRank) !== -1) {
    return rankings.CONTAINS + caseRank;
  } else if (stringToRank.length === 1) {
    // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return rankings.NO_MATCH;
  }

  // acronym
  if (getAcronym(testString).indexOf(stringToRank) !== -1) {
    return rankings.ACRONYM + caseRank;
  }

  // will return a number between rankings.MATCHES and
  // rankings.MATCHES + 1 depending  on how close of a match it is.
  return getClosenessRanking(testString, stringToRank);
}

/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */
function getAcronym(string) {
  var acronym = '';
  var wordsInString = string.split(' ');
  wordsInString.forEach(function (wordInString) {
    var splitByHyphenWords = wordInString.split('-');
    splitByHyphenWords.forEach(function (splitByHyphenWord) {
      acronym += splitByHyphenWord.substr(0, 1);
    });
  });
  return acronym;
}

/**
 * Returns a score base on the case of the testString
 * @param {String} testString - the string to test against
 * @returns {Number} the number of the ranking,
 * based on the case between 0 and 1 for how the testString matches the case
 */
function getCaseRanking(testString) {
  var containsUpperCase = testString.toLowerCase() !== testString;
  var containsDash = testString.indexOf('-') >= 0;
  var containsUnderscore = testString.indexOf('_') >= 0;

  if (!containsUpperCase && !containsUnderscore && containsDash) {
    return caseRankings.KEBAB;
  }

  if (!containsUpperCase && containsUnderscore && !containsDash) {
    return caseRankings.SNAKE;
  }

  if (containsUpperCase && !containsDash && !containsUnderscore) {
    var startsWithUpperCase = testString[0].toUpperCase() === testString[0];
    if (startsWithUpperCase) {
      return caseRankings.PASCAL;
    }

    return caseRankings.CAMEL;
  }

  return caseRankings.NO_CASE;
}

/**
 * Returns whether the stringToRank is one of the case parts in the testString (works with any string case)
 * @example
 * // returns true
 * isPartialOfCase('helloWorld', 'world', caseRankings.CAMEL)
 * @example
 * // returns false
 * isPartialOfCase('helloWorld', 'oworl', caseRankings.CAMEL)
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Number} caseRanking - the ranking score based on case of testString
 * @returns {Boolean} whether the stringToRank is one of the case parts in the testString
 */
function isPartialOfCase(testString, stringToRank, caseRanking) {
  var testIndex = testString.toLowerCase().indexOf(stringToRank.toLowerCase());

  switch (caseRanking) {
    case caseRankings.SNAKE:
      return testString[testIndex - 1] === '_';
    case caseRankings.KEBAB:
      return testString[testIndex - 1] === '-';
    case caseRankings.PASCAL:
    case caseRankings.CAMEL:
      return testIndex !== -1 && testString[testIndex] === testString[testIndex].toUpperCase();
    default:
      return false;
  }
}

/**
 * Check if stringToRank is an acronym for a partial case
 * @example
 * // returns true
 * isCaseAcronym('super_duper_file', 'sdf', caseRankings.SNAKE)
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the acronym to test
 * @param {Number} caseRank - the ranking of the case
 * @returns {Boolean} whether the stringToRank is an acronym for the testString
 */
function isCaseAcronym(testString, stringToRank, caseRank) {
  var splitValue = null;
  switch (caseRank) {
    case caseRankings.SNAKE:
      splitValue = '_';
      break;
    case caseRankings.KEBAB:
      splitValue = '-';
      break;
    case caseRankings.PASCAL:
    case caseRankings.CAMEL:
      splitValue = /(?=[A-Z])/;
      break;
    default:
      splitValue = null;
  }

  var splitTestString = testString.split(splitValue);
  return stringToRank.toLowerCase().split('').reduce(function (correct, char, charIndex) {
    var splitItem = splitTestString[charIndex];
    return correct && splitItem && splitItem[0].toLowerCase() === char;
  }, true);
}

/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a loose match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */
function getClosenessRanking(testString, stringToRank) {
  var charNumber = 0;
  function findMatchingCharacter(matchChar, string, index) {
    for (var j = index; j < string.length; j++) {
      var stringChar = string[j];
      if (stringChar === matchChar) {
        return j + 1;
      }
    }
    return -1;
  }

  var firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);
  if (firstIndex < 0) {
    return rankings.NO_MATCH;
  }
  charNumber = firstIndex;
  for (var i = 1; i < stringToRank.length; i++) {
    var matchChar = stringToRank[i];
    charNumber = findMatchingCharacter(matchChar, testString, charNumber);
    var found = charNumber > -1;
    if (!found) {
      return rankings.NO_MATCH;
    }
  }

  var spread = charNumber - firstIndex;
  return function (spread) {
    var matching = spread - stringToRank.length + 1;
    var ranking = rankings.MATCHES + 1 / matching;
    return ranking;
  }(spread);
}

/**
 * Sorts items that have a rank, index, and keyIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first
 * Note: will never return 0
 */
function sortRankedItems(a, b) {
  var aFirst = -1;
  var bFirst = 1;
  var aRank = a.rank,
      aIndex = a.index,
      aKeyIndex = a.keyIndex;
  var bRank = b.rank,
      bIndex = b.index,
      bKeyIndex = b.keyIndex;

  if (aRank === bRank) {
    if (aKeyIndex === bKeyIndex) {
      return aIndex < bIndex ? aFirst : bFirst;
    } else {
      return aKeyIndex < bKeyIndex ? aFirst : bFirst;
    }
  } else {
    return aRank > bRank ? aFirst : bFirst;
  }
}

/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */
function prepareValueForComparison(value, _ref4) {
  var keepDiacritics = _ref4.keepDiacritics;

  value = '' + value; // toString
  if (!keepDiacritics) {
    value = diacritics.clean(value);
  }
  return value;
}

/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */
function getItemValues(item, key) {
  if ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object') {
    key = key.key;
  }
  var value = void 0;
  if (typeof key === 'function') {
    value = key(item);
    // eslint-disable-next-line no-negated-condition
  } else if (key.indexOf('.') !== -1) {
    // handle nested keys
    value = key.split('.').reduce(function (itemObj, nestedKey) {
      return itemObj ? itemObj[nestedKey] : null;
    }, item);
  } else {
    value = item[key];
  }
  // concat because `value` can be a string or an array
  // eslint-disable-next-line
  return value != null ? [].concat(value) : null;
}

/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param {Object} item - the item from which the values will be retrieved
 * @param {Array} keys - the keys to use to retrieve the values
 * @return {Array} objects with {itemValue, attributes}
 */
function getAllValuesToRank(item, keys) {
  return keys.reduce(function (allVals, key) {
    var values = getItemValues(item, key);
    if (values) {
      values.forEach(function (itemValue) {
        allVals.push({
          itemValue: itemValue,
          attributes: getKeyAttributes(key)
        });
      });
    }
    return allVals;
  }, []);
}

/**
 * Gets all the attributes for the given key
 * @param {Object|String} key - the key from which the attributes will be retrieved
 * @return {Object} object containing the key's attributes
 */
function getKeyAttributes(key) {
  if (typeof key === 'string') {
    key = { key: key };
  }
  return _extends({
    maxRanking: Infinity,
    minRanking: -Infinity
  }, key);
}

/* harmony default export */ __webpack_exports__["a"] = (matchSorter);



/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clientsActions__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * This component will harvest the client id from a url parameter on mount.
 * if the client_id is set we strip it and replace the route
 * we do not replace the client_id in search results
 */var clientIdRegex=/client_id=([0-9]+)/;var ClientFromUrl=function(_React$Component){_inherits(ClientFromUrl,_React$Component);function ClientFromUrl(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientFromUrl);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientFromUrl.__proto__||Object.getPrototypeOf(ClientFromUrl)).call.apply(_ref,[this].concat(args))),_this),_this.state={isMounted:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientFromUrl,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,location=_props.location,history=_props.history;var match=clientIdRegex.exec(location.search);if(Array.isArray(match)){var _clientId=match[1];if(+this.props.clientId!==+_clientId){this.props.selectClient(+_clientId);}!isResultsPage(location.pathname)&&history.replace(location.pathname);}this.setState({isMounted:true});}},{key:'render',value:function render(){return this.state.isMounted?this.props.children():null;}}]);return ClientFromUrl;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{clientId:state.clients.currentClient};},{selectClient:__WEBPACK_IMPORTED_MODULE_3__clientsActions__["c" /* selectClient */]})(ClientFromUrl)));function isResultsPage(location){return location.indexOf('/results')>0;}

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clientsActions__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clientsApi__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__userProfileActions__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__userProfilesApi__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__alertConfigApi__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__alertConfigActions__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__clientPropertiesActions__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__clientPropertiesApi__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__catalogActions__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__catalogApi__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__clientsReducer__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__storage__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ducks_authActions__ = __webpack_require__(27);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(_callee),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(clientsSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(onClientChange),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(clientUserProfilesSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(clientExpertUserProfileSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(clientPropertiesSaga),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(clientCatalogsSaga),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchModerationAlertConfigSaga),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setModerationAlertSaga);// clients
// user Profles
// alert Config
// client properties
// client catalogs
function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5__clientsActions__["c" /* selectClient */],onClientChange);case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5__clientsActions__["a" /* fetchClients */],clientsSaga);case 4:_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_7__userProfileActions__["b" /* fetchClientUserProfiles */],clientUserProfilesSaga);case 6:_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_7__userProfileActions__["a" /* fetchClientExpertUserProfiles */],clientExpertUserProfileSaga);case 8:_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_10__alertConfigActions__["b" /* fetchModerationAlertConfig */],fetchModerationAlertConfigSaga);case 10:_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_10__alertConfigActions__["d" /* requestModerationAlertUpdate */],setModerationAlertSaga);case 12:_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_11__clientPropertiesActions__["a" /* fetchClientProperties */],clientPropertiesSaga);case 14:_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_13__catalogActions__["a" /* fetchClientCatalog */],clientCatalogsSaga);case 16:case'end':return _context.stop();}}},_marked,this);}function clientsSaga(action){var token,currentClient,response,_determineNextClient,clients,nextClient;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function clientsSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["c" /* selectToken */]);case 2:token=_context2.sent;currentClient=action.payload;_context2.prev=4;_context2.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6__clientsApi__["a" /* getClients */],token);case 7:response=_context2.sent;_determineNextClient=Object(__WEBPACK_IMPORTED_MODULE_15__clientsReducer__["b" /* determineNextClient */])(response,currentClient),clients=_determineNextClient.clients,nextClient=_determineNextClient.currentClient;_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__clientsActions__["e" /* storeClients */])(clients)),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__clientsActions__["c" /* selectClient */])(nextClient))]);case 11:_context2.next=17;break;case 13:_context2.prev=13;_context2.t0=_context2['catch'](4);_context2.next=17;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__clientsActions__["e" /* storeClients */])(_context2.t0));case 17:case'end':return _context2.stop();}}},_marked2,this,[[4,13]]);}function onClientChange(action){var clientId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function onClientChange$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:clientId=action.payload;if(!(clientId!=null)){_context3.next=16;break;}_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__userProfileActions__["b" /* fetchClientUserProfiles */])(clientId));case 4:_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__userProfileActions__["a" /* fetchClientExpertUserProfiles */])(clientId));case 6:_context3.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__alertConfigActions__["b" /* fetchModerationAlertConfig */])(clientId));case 8:_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__clientPropertiesActions__["a" /* fetchClientProperties */])(clientId));case 10:_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_13__catalogActions__["a" /* fetchClientCatalog */])(clientId));case 12:_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_17_ducks_authActions__["d" /* regenerateToken */])(clientId));case 14:_context3.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_16__storage__["a" /* default */].setSelected,clientId);case 16:case'end':return _context3.stop();}}},_marked3,this);}// user profiles
function clientUserProfilesSaga(action){var clientId,token,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function clientUserProfilesSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:clientId=action.payload;_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["c" /* selectToken */]);case 3:token=_context4.sent;_context4.prev=4;_context4.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_8__userProfilesApi__["b" /* getUserProfiles */],token,clientId);case 7:response=_context4.sent;_context4.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__userProfileActions__["d" /* storeClientUserProfiles */])(response,clientId));case 10:_context4.next=16;break;case 12:_context4.prev=12;_context4.t0=_context4['catch'](4);_context4.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__userProfileActions__["d" /* storeClientUserProfiles */])(_context4.t0,clientId));case 16:case'end':return _context4.stop();}}},_marked4,this,[[4,12]]);}function clientExpertUserProfileSaga(action){var clientId,token,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function clientExpertUserProfileSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:clientId=action.payload;_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["c" /* selectToken */]);case 3:token=_context5.sent;_context5.prev=4;_context5.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_8__userProfilesApi__["a" /* getExpertUserProfiles */],token,clientId);case 7:response=_context5.sent;_context5.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__userProfileActions__["c" /* storeClientExportUserProfiles */])(response,clientId));case 10:_context5.next=16;break;case 12:_context5.prev=12;_context5.t0=_context5['catch'](4);_context5.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__userProfileActions__["c" /* storeClientExportUserProfiles */])(_context5.t0,clientId));case 16:case'end':return _context5.stop();}}},_marked5,this,[[4,12]]);}// client properties
function clientPropertiesSaga(action){var clientId,token,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function clientPropertiesSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:clientId=action.payload;_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["c" /* selectToken */]);case 3:token=_context6.sent;_context6.prev=4;_context6.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_12__clientPropertiesApi__["a" /* getClientProperties */],token,clientId);case 7:response=_context6.sent;_context6.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__clientPropertiesActions__["b" /* storeClientProperties */])(response,clientId));case 10:_context6.next=16;break;case 12:_context6.prev=12;_context6.t0=_context6['catch'](4);_context6.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__clientPropertiesActions__["b" /* storeClientProperties */])(_context6.t0,clientId));case 16:case'end':return _context6.stop();}}},_marked6,this,[[4,12]]);}// catalogs
function clientCatalogsSaga(action){var clientId,token,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function clientCatalogsSaga$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:clientId=action.payload;_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["c" /* selectToken */]);case 3:token=_context7.sent;_context7.prev=4;_context7.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_14__catalogApi__["a" /* getClientCatalogs */],token,clientId);case 7:response=_context7.sent;_context7.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_13__catalogActions__["c" /* storeClientCatalog */])(response,clientId));case 10:_context7.next=16;break;case 12:_context7.prev=12;_context7.t0=_context7['catch'](4);_context7.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_13__catalogActions__["c" /* storeClientCatalog */])(_context7.t0,clientId));case 16:case'end':return _context7.stop();}}},_marked7,this,[[4,12]]);}// alert config
function fetchModerationAlertConfigSaga(action){var clientId,token,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchModerationAlertConfigSaga$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:clientId=action.payload;_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["c" /* selectToken */]);case 3:token=_context8.sent;_context8.prev=4;_context8.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_9__alertConfigApi__["b" /* getModerationAlertConfig */],token,clientId);case 7:response=_context8.sent;_context8.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__alertConfigActions__["e" /* storeModerationAlertConfig */])(response,clientId));case 10:_context8.next=16;break;case 12:_context8.prev=12;_context8.t0=_context8['catch'](4);_context8.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__alertConfigActions__["e" /* storeModerationAlertConfig */])(_context8.t0,clientId));case 16:case'end':return _context8.stop();}}},_marked8,this,[[4,12]]);}function setModerationAlertSaga(action){var config,meta,method,token,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setModerationAlertSaga$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:config=action.payload,meta=action.meta;method='config_id'in config?__WEBPACK_IMPORTED_MODULE_9__alertConfigApi__["c" /* updateChannelAlertConfig */]:__WEBPACK_IMPORTED_MODULE_9__alertConfigApi__["a" /* createChannelAlertConfig */];_context9.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["c" /* selectToken */]);case 4:token=_context9.sent;_context9.prev=5;_context9.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(method,token,config);case 8:response=_context9.sent;_context9.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__alertConfigActions__["c" /* receiveModerationAlertUpdate */])(response,meta));case 11:_context9.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */],2000);case 13:_context9.next=15;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__alertConfigActions__["a" /* clearModerationAlertUpdateStatus */])(meta));case 15:_context9.next=21;break;case 17:_context9.prev=17;_context9.t0=_context9['catch'](5);_context9.next=21;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__alertConfigActions__["c" /* receiveModerationAlertUpdate */])(_context9.t0,meta));case 21:case'end':return _context9.stop();}}},_marked9,this,[[5,17]]);}

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClients; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
var getClients=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function(token){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/merchantGroup');var fetchOptions={headers:{Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();});});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProfileFetcher */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserProfiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getExpertUserProfiles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_cache__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lru_cache__);
var cache=__WEBPACK_IMPORTED_MODULE_3_lru_cache___default()({max:10});var createProfileFetcher=function createProfileFetcher(resource){return Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function(token,clientId){var cacheKey=resource+'/'+clientId;// check cache
if(cache.has(cacheKey)){var data=cache.get(cacheKey);if(data)return Promise.resolve(data);}var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/merchantGroup/'+clientId+'/'+resource);var fetchOptions={method:'GET',headers:{'Content-type':'application/json',Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();}).then(function(response){cache.set(cacheKey,response);return response;});});};var getUserProfiles=createProfileFetcher('profile');var getExpertUserProfiles=createProfileFetcher('expertUserProfile');

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

if (Object({"NODE_ENV":"production","PUBLIC_URL":"//d17h9cyp9eegq8.cloudfront.net/prod-builds/48.0.0","REACT_APP_WEGLOT_API_KEY":"wg_3a3c94e641aaf99979e9565c889eccd91","REACT_APP_BUILD_ENV":"prod","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_IMAGE":"visual-answers-image","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_VIDEO":"visual-answers-video"}).npm_package_name === 'pseudomap' &&
    Object({"NODE_ENV":"production","PUBLIC_URL":"//d17h9cyp9eegq8.cloudfront.net/prod-builds/48.0.0","REACT_APP_WEGLOT_API_KEY":"wg_3a3c94e641aaf99979e9565c889eccd91","REACT_APP_BUILD_ENV":"prod","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_IMAGE":"visual-answers-image","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_VIDEO":"visual-answers-video"}).npm_lifecycle_script === 'test')
  Object({"NODE_ENV":"production","PUBLIC_URL":"//d17h9cyp9eegq8.cloudfront.net/prod-builds/48.0.0","REACT_APP_WEGLOT_API_KEY":"wg_3a3c94e641aaf99979e9565c889eccd91","REACT_APP_BUILD_ENV":"prod","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_IMAGE":"visual-answers-image","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_VIDEO":"visual-answers-video"}).TEST_PSEUDOMAP = 'true'

if (typeof Map === 'function' && !Object({"NODE_ENV":"production","PUBLIC_URL":"//d17h9cyp9eegq8.cloudfront.net/prod-builds/48.0.0","REACT_APP_WEGLOT_API_KEY":"wg_3a3c94e641aaf99979e9565c889eccd91","REACT_APP_BUILD_ENV":"prod","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_IMAGE":"visual-answers-image","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_VIDEO":"visual-answers-video"}).TEST_PSEUDOMAP) {
  module.exports = Map
} else {
  module.exports = __webpack_require__(546)
}


/***/ }),
/* 546 */
/***/ (function(module, exports) {

var hasOwnProperty = Object.prototype.hasOwnProperty

module.exports = PseudoMap

function PseudoMap (set) {
  if (!(this instanceof PseudoMap)) // whyyyyyyy
    throw new TypeError("Constructor PseudoMap requires 'new'")

  this.clear()

  if (set) {
    if ((set instanceof PseudoMap) ||
        (typeof Map === 'function' && set instanceof Map))
      set.forEach(function (value, key) {
        this.set(key, value)
      }, this)
    else if (Array.isArray(set))
      set.forEach(function (kv) {
        this.set(kv[0], kv[1])
      }, this)
    else
      throw new TypeError('invalid argument')
  }
}

PseudoMap.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  Object.keys(this._data).forEach(function (k) {
    if (k !== 'size')
      fn.call(thisp, this._data[k].value, this._data[k].key)
  }, this)
}

PseudoMap.prototype.has = function (k) {
  return !!find(this._data, k)
}

PseudoMap.prototype.get = function (k) {
  var res = find(this._data, k)
  return res && res.value
}

PseudoMap.prototype.set = function (k, v) {
  set(this._data, k, v)
}

PseudoMap.prototype.delete = function (k) {
  var res = find(this._data, k)
  if (res) {
    delete this._data[res._index]
    this._data.size--
  }
}

PseudoMap.prototype.clear = function () {
  var data = Object.create(null)
  data.size = 0

  Object.defineProperty(this, '_data', {
    value: data,
    enumerable: false,
    configurable: true,
    writable: false
  })
}

Object.defineProperty(PseudoMap.prototype, 'size', {
  get: function () {
    return this._data.size
  },
  set: function (n) {},
  enumerable: true,
  configurable: true
})

PseudoMap.prototype.values =
PseudoMap.prototype.keys =
PseudoMap.prototype.entries = function () {
  throw new Error('iterators are not implemented in this version')
}

// Either identical, or both NaN
function same (a, b) {
  return a === b || a !== a && b !== b
}

function Entry (k, v, i) {
  this.key = k
  this.value = v
  this._index = i
}

function find (data, k) {
  for (var i = 0, s = '_' + k, key = s;
       hasOwnProperty.call(data, key);
       key = s + i++) {
    if (same(data[key].key, k))
      return data[key]
  }
}

function set (data, k, v) {
  for (var i = 0, s = '_' + k, key = s;
       hasOwnProperty.call(data, key);
       key = s + i++) {
    if (same(data[key].key, k)) {
      data[key].value = v
      return
    }
  }
  data.size++
  data[key] = new Entry(k, v, key)
}


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"//d17h9cyp9eegq8.cloudfront.net/prod-builds/48.0.0","REACT_APP_WEGLOT_API_KEY":"wg_3a3c94e641aaf99979e9565c889eccd91","REACT_APP_BUILD_ENV":"prod","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_IMAGE":"visual-answers-image","REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_VIDEO":"visual-answers-video"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(549);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(550);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(548)))

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = Yallist

Yallist.Node = Node
Yallist.create = Yallist

function Yallist (list) {
  var self = this
  if (!(self instanceof Yallist)) {
    self = new Yallist()
  }

  self.tail = null
  self.head = null
  self.length = 0

  if (list && typeof list.forEach === 'function') {
    list.forEach(function (item) {
      self.push(item)
    })
  } else if (arguments.length > 0) {
    for (var i = 0, l = arguments.length; i < l; i++) {
      self.push(arguments[i])
    }
  }

  return self
}

Yallist.prototype.removeNode = function (node) {
  if (node.list !== this) {
    throw new Error('removing node which does not belong to this list')
  }

  var next = node.next
  var prev = node.prev

  if (next) {
    next.prev = prev
  }

  if (prev) {
    prev.next = next
  }

  if (node === this.head) {
    this.head = next
  }
  if (node === this.tail) {
    this.tail = prev
  }

  node.list.length--
  node.next = null
  node.prev = null
  node.list = null
}

Yallist.prototype.unshiftNode = function (node) {
  if (node === this.head) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var head = this.head
  node.list = this
  node.next = head
  if (head) {
    head.prev = node
  }

  this.head = node
  if (!this.tail) {
    this.tail = node
  }
  this.length++
}

Yallist.prototype.pushNode = function (node) {
  if (node === this.tail) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var tail = this.tail
  node.list = this
  node.prev = tail
  if (tail) {
    tail.next = node
  }

  this.tail = node
  if (!this.head) {
    this.head = node
  }
  this.length++
}

Yallist.prototype.push = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    push(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.unshift = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    unshift(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.pop = function () {
  if (!this.tail) {
    return undefined
  }

  var res = this.tail.value
  this.tail = this.tail.prev
  if (this.tail) {
    this.tail.next = null
  } else {
    this.head = null
  }
  this.length--
  return res
}

Yallist.prototype.shift = function () {
  if (!this.head) {
    return undefined
  }

  var res = this.head.value
  this.head = this.head.next
  if (this.head) {
    this.head.prev = null
  } else {
    this.tail = null
  }
  this.length--
  return res
}

Yallist.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.head, i = 0; walker !== null; i++) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.next
  }
}

Yallist.prototype.forEachReverse = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.prev
  }
}

Yallist.prototype.get = function (n) {
  for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.next
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.getReverse = function (n) {
  for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.prev
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.map = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.head; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.next
  }
  return res
}

Yallist.prototype.mapReverse = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.tail; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.prev
  }
  return res
}

Yallist.prototype.reduce = function (fn, initial) {
  var acc
  var walker = this.head
  if (arguments.length > 1) {
    acc = initial
  } else if (this.head) {
    walker = this.head.next
    acc = this.head.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = 0; walker !== null; i++) {
    acc = fn(acc, walker.value, i)
    walker = walker.next
  }

  return acc
}

Yallist.prototype.reduceReverse = function (fn, initial) {
  var acc
  var walker = this.tail
  if (arguments.length > 1) {
    acc = initial
  } else if (this.tail) {
    walker = this.tail.prev
    acc = this.tail.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = this.length - 1; walker !== null; i--) {
    acc = fn(acc, walker.value, i)
    walker = walker.prev
  }

  return acc
}

Yallist.prototype.toArray = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.head; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.next
  }
  return arr
}

Yallist.prototype.toArrayReverse = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.tail; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.prev
  }
  return arr
}

Yallist.prototype.slice = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
    walker = walker.next
  }
  for (; walker !== null && i < to; i++, walker = walker.next) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.sliceReverse = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
    walker = walker.prev
  }
  for (; walker !== null && i > from; i--, walker = walker.prev) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.reverse = function () {
  var head = this.head
  var tail = this.tail
  for (var walker = head; walker !== null; walker = walker.prev) {
    var p = walker.prev
    walker.prev = walker.next
    walker.next = p
  }
  this.head = tail
  this.tail = head
  return this
}

function push (self, item) {
  self.tail = new Node(item, self.tail, null, self)
  if (!self.head) {
    self.head = self.tail
  }
  self.length++
}

function unshift (self, item) {
  self.head = new Node(item, null, self.head, self)
  if (!self.tail) {
    self.tail = self.head
  }
  self.length++
}

function Node (value, prev, next, list) {
  if (!(this instanceof Node)) {
    return new Node(value, prev, next, list)
  }

  this.list = list
  this.value = value

  if (prev) {
    prev.next = this
    this.prev = prev
  } else {
    this.prev = null
  }

  if (next) {
    next.prev = this
    this.next = next
  } else {
    this.next = null
  }
}


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getModerationAlertConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createChannelAlertConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateChannelAlertConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
var getModerationAlertConfig=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function(token,clientId){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/mod_alert/client/'+clientId);var fetchOptions={method:'GET',headers:{'Content-type':'application/json',Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();});});var setChannelAlertConfig=function setChannelAlertConfig(method){return Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function(token,config){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/mod_alert/client/'+String(config.client_id)+'/channel/'+config.channel);var fetchOptions={method:method,headers:{'Content-type':'application/json',Authorization:token},body:JSON.stringify(config)};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();});});};var createChannelAlertConfig=setChannelAlertConfig('POST');var updateChannelAlertConfig=setChannelAlertConfig('PUT');

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClientProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
var PROPERTY_NAME_LIST=[// publication
'IS_LIVE_MODERATION','LEVEL1_AUTO_APPROVE','LEVEL2_AUTO_APPROVE_LEVEL','LEVEL2_AUTO_APPROVE_LEVEL_FOR_SHARED_REVIEWS','PA_QUESTION_LEVEL1_AUTO_APPROVE','PA_QUESTION_LEVEL2_AUTO_APPROVE','PA_ANSWER_APO_LEVEL1_AUTO_APPROVE','PA_ANSWER_COMMUNITY_LEVEL1_AUTO_APPROVE','PA_ANSWER_CROWD_LEVEL1_AUTO_APPROVE','PA_ANSWER_LEVEL2_AUTO_APPROVE',// brand engage
'BRAND_ENGAGE_TIER','BRAND_ENGAGE_TYPE',// portal
'IS_PORTAL',// Show default client moderation channels
'SHOW_CLIENT_MODERATION_CHANNELS','ENABLE_UGC_EDITING','ENABLE_VISUAL_ANSWERS','ss_account_information_id','ENABLE_MEDIA_FEATURED_FLAG',//
'SOCIAL_COLLECTION_WYNG_DIRECT_ACCESS','OCADO_PORTAL_LANGUAGES'];var PROPERTY_NAME_KEYS=PROPERTY_NAME_LIST.join(',');var getClientProperties=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function _getAppConfig(token,merchantGroupId){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/getAppConfig/merchantGroupProps/g'+merchantGroupId+'/keys/'+PROPERTY_NAME_KEYS);var fetchOptions={headers:{Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();});});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClientCatalogs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_cache__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lru_cache__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var cache=__WEBPACK_IMPORTED_MODULE_3_lru_cache___default()({max:10});var getClientCatalogs=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function(token,clientId){// check cache
if(cache.has(clientId)){var data=cache.get(clientId);if(data)return Promise.resolve(data);}// This was changed from '/merchantGroup/{clientId}/merchant'. The new
// endpoint should return all the same information as the old endpoint,
// plus additional data regarding social collection.  If a bug is
// discovered in this new endpoint or it is changed in a way that causes
// it to take a while to return, we may need to revert.
var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/socialcollection/client/'+clientId);var fetchOptions={method:'GET',headers:{'Content-type':'application/json',Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();}).then(function(_response){var response=_response.map(merchantIdToCatalogId);cache.set(clientId,response);return response;});});function merchantIdToCatalogId(item){var catalog_id=item.merchant_id,rest=_objectWithoutProperties(item,['merchant_id']);return Object.assign({catalog_id:catalog_id},rest);}

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clientsReducer__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__userProfilesReducer__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alertConfigReducer__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clientPropertiesReducer__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__catalogReducer__ = __webpack_require__(220);
/* unused harmony namespace reexport */
var reducers={clients:__WEBPACK_IMPORTED_MODULE_0__clientsReducer__["a" /* default */],clientUserProfiles:__WEBPACK_IMPORTED_MODULE_1__userProfilesReducer__["b" /* userProfilesReducer */],clientExpertUserProfiles:__WEBPACK_IMPORTED_MODULE_1__userProfilesReducer__["a" /* expertUserProfilesReducer */],clientModerationAlertConfig:__WEBPACK_IMPORTED_MODULE_2__alertConfigReducer__["b" /* default */],clientProperties:__WEBPACK_IMPORTED_MODULE_3__clientPropertiesReducer__["a" /* default */],clientCatalogs:__WEBPACK_IMPORTED_MODULE_4__catalogReducer__["a" /* default */]};/* harmony default export */ __webpack_exports__["a"] = (reducers);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return userProfilesReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return expertUserProfilesReducer; });
/* unused harmony export userProfilesSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_async_value__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userProfileActions__ = __webpack_require__(215);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var userProfilesReducer=createReducer({fetchAction:__WEBPACK_IMPORTED_MODULE_2__userProfileActions__["b" /* fetchClientUserProfiles */],storeAction:__WEBPACK_IMPORTED_MODULE_2__userProfileActions__["d" /* storeClientUserProfiles */]});var expertUserProfilesReducer=createReducer({fetchAction:__WEBPACK_IMPORTED_MODULE_2__userProfileActions__["a" /* fetchClientExpertUserProfiles */],storeAction:__WEBPACK_IMPORTED_MODULE_2__userProfileActions__["c" /* storeClientExportUserProfiles */]});function createReducer(_ref){var _handleActions;var fetchAction=_ref.fetchAction,storeAction=_ref.storeAction;return Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,fetchAction.toString(),function(state,action){return __WEBPACK_IMPORTED_MODULE_1_lib_async_value__["b" /* default */].Pending;}),_defineProperty(_handleActions,storeAction.toString(),function(state,action){return action.payload;}),_handleActions),null);}function userProfilesSelector(state){return state;}

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clientPropertiesActions__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_async_value__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__types__);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__clientPropertiesActions__["a" /* fetchClientProperties */].toString(),function(state,action){return __WEBPACK_IMPORTED_MODULE_3_lib_async_value__["b" /* default */].Pending;}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__clientPropertiesActions__["b" /* storeClientProperties */].toString(),function(state,action){if(action.error){return action.payload;}return parseRawProperties(action.payload);}),_handleActions),null));function parseRawProperties(list){var isNumberRegex=/^\d+$/;return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(list.map(function(_ref){var key=_ref.key,data_type=_ref.data_type,rawValue=_ref.value;var value=rawValue.trim();if(data_type==='boolean'){value=rawValue==='true'?true:false;}else if(data_type==='number'||isNumberRegex.test(rawValue)){value=+rawValue;}else{value=rawValue;}return[key,value];}));}

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var containerStyles={height:50,marginBottom:'1rem',position:'relative',width:'100%'};var bannerStyles={backgroundColor:'#d0021b',color:'#FFF',fontSize:'1.15rem',fontWeight:'500',margin:0,opacity:'0.75',padding:'1rem',paddingLeft:150,// Account for left-hand navigation
position:'absolute',textAlign:'center',top:0,width:'100%'};var RunAsBanner=function RunAsBanner(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:containerStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{role:'banner',style:bannerStyles},'You\'re currently browsing Moderation in Run-As mode.'));};/* harmony default export */ __webpack_exports__["a"] = (RunAsBanner);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__moderate_Moderate__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__second_opinion_SecondOpinion__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_components_LandingPage__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_search_NativeReviews__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers_search_Media__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_search_NetworkReviews__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_search_NetworkQuestions__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_search_Questions__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_search_Answers__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ducks_coreDataReducer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ducks_coreDataActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_ContentSection_UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_context_content_card_context__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_containers_client_ClientProvider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_containers_search_PwrDistribution__ = __webpack_require__(264);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// Commenting out until these ugc types are supported
var moderateRoute={exact:true,path:'moderate',component:__WEBPACK_IMPORTED_MODULE_1__moderate_Moderate__["a" /* default */],label:'Moderate',navItem:true,clientContextRequired:false};var secondOpinionRoute={exact:true,path:'second-opinion',component:__WEBPACK_IMPORTED_MODULE_2__second_opinion_SecondOpinion__["a" /* default */],label:'Second Opinion',navItem:true,clientContextRequired:false};var searchRoutes=['sep',{exact:false,path:'native-reviews',label:__WEBPACK_IMPORTED_MODULE_4_containers_search_NativeReviews__["a" /* default */].label,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_containers_search_NativeReviews__["a" /* default */],Object.assign({},props,{CardComponent:PwrCard}));},navItem:true},{exact:false,path:'network-reviews',label:__WEBPACK_IMPORTED_MODULE_6_containers_search_NetworkReviews__["a" /* default */].label,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_containers_search_NetworkReviews__["a" /* default */],Object.assign({hideCopy:true},props,{CardComponent:PwrCard}));},navItem:true},{exact:false,path:'images-and-video',label:__WEBPACK_IMPORTED_MODULE_5_containers_search_Media__["a" /* default */].label,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_containers_search_Media__["a" /* default */],Object.assign({},props,{CardComponent:PwrCard}));},navItem:true},{exact:false,path:'questions',label:__WEBPACK_IMPORTED_MODULE_8_containers_search_Questions__["a" /* default */].label,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_containers_search_Questions__["a" /* default */],Object.assign({},props,{CardComponent:PwrCard}));},navItem:true},{exact:false,path:'network-questions',label:__WEBPACK_IMPORTED_MODULE_7_containers_search_NetworkQuestions__["a" /* default */].label,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_containers_search_NetworkQuestions__["a" /* default */],Object.assign({hideCopy:true},props,{CardComponent:PwrCard}));},navItem:true},{exact:false,path:'answers',label:'Answers',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_containers_search_Answers__["a" /* default */],Object.assign({},props,{CardComponent:PwrCard}));},navItem:true}];var pwrDistroSearchRoutes=['sep',{exact:false,path:'reviews-search',label:'Reviews',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_containers_search_PwrDistribution__["a" /* ReviewSearch */],Object.assign({},props,{CardComponent:PwrCard}));},navItem:true}].concat(searchRoutes);function getRoutesForUser(clientId,userInfo){var access=userInfo.access,role=userInfo.role;var routes=[];if(access.moderate){routes.push(moderateRoute);}if(access.secondOpinion){routes.push(secondOpinionRoute);}if(role.moderationAdmin){if(clientId===164195141||clientId===1986404165||clientId===380979969||clientId===12846||clientId===1901388221){routes.push.apply(routes,_toConsumableArray(pwrDistroSearchRoutes));}else{routes.push.apply(routes,searchRoutes);}}return routes;}/* harmony default export */ __webpack_exports__["a"] = (function(props){var clientProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_15_containers_client_ClientProvider__["a" /* ClientContext */]);var clientId=clientProps?clientProps.clientId:null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_context_content_card_context__["b" /* PwrContentCardProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_components_ContentSection_UserGeneratedTextContainer__["a" /* UserGeneratedTextHighlighter */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_pages_components_LandingPage__["a" /* default */],Object.assign({label:'Moderation',routes:getRoutesForUser(clientId,props),landingRoute:'moderate'},props))));});//
// PwrCard
//
var PwrCard=function(_React$Component){_inherits(PwrCard,_React$Component);function PwrCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PwrCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PwrCard.__proto__||Object.getPrototypeOf(PwrCard)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(){return _this.props.dispatch(__WEBPACK_IMPORTED_MODULE_12_ducks_coreDataActions__["o" /* updateObservations */].apply(undefined,arguments));},_this.onSubmit=function(){return _this.props.dispatch(__WEBPACK_IMPORTED_MODULE_12_ducks_coreDataActions__["n" /* requestObservationsUpdate */].apply(undefined,arguments));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PwrCard,[{key:'render',value:function render(){var _props$datum=this.props.datum,ugc=_props$datum.ugc,moderationState=_props$datum.moderationState,subject=_props$datum.subject,submitStatus=_props$datum.observationRequestStatus;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_components__["m" /* PowerReviewsModerationCard */],{product:subject,ugc:ugc,moderationState:moderationState,status:submitStatus,onChange:this.onChange,onSubmit:this.onSubmit});}}]);return PwrCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Moderate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__moderateActions__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Moderate_scss__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Moderate_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Moderate_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_components_ContentRequest__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_components_ContentResponse__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ducks_appConfigReducer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__moderateReducer__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ducks_authReducer__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ducks_coreDataReducer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__moderateSaga__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_containers_client_HideClientSelectMenu__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_store__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}Object(__WEBPACK_IMPORTED_MODULE_16_store__["c" /* injectSaga */])(__WEBPACK_IMPORTED_MODULE_14__moderateSaga__["a" /* default */]);Object(__WEBPACK_IMPORTED_MODULE_16_store__["b" /* injectReducer */])({moderate:__WEBPACK_IMPORTED_MODULE_10__moderateReducer__["a" /* default */]});var Moderate=function(_React$Component){_inherits(Moderate,_React$Component);function Moderate(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Moderate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Moderate.__proto__||Object.getPrototypeOf(Moderate)).call.apply(_ref,[this].concat(args))),_this),_this.state={savedNextUgc:null},_this.handleSubmit=function(){if(_this.state.savedNextUgc!==null){var _this$props;(_this$props=_this.props).requestObservationsUpdate.apply(_this$props,arguments);_this.props.updateCurrentUgcId(_this.state.savedNextUgc);_this.setState({savedNextUgc:null});}else{var _this$props2;_this.props.requestPreviousUgcIdUpdate();(_this$props2=_this.props).requestObservationsUpdate.apply(_this$props2,arguments);_this.props.requestContent();}},_this.loadPreviousContent=function(){_this.setState({savedNextUgc:_this.props.ugcId});_this.props.updateCurrentUgcId(_this.props.previousUgcId);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Moderate,[{key:'componentDidMount',value:function componentDidMount(){this.props.requestContent();}},{key:'render',value:function render(){var _props=this.props,contentRequestStatus=_props.contentRequestStatus,observationRequestStatus=_props.observationRequestStatus,product=_props.subject,ugc=_props.ugc,ugcId=_props.ugcId,todaysCompletedCount=_props.todaysCompletedCount,requestContent=_props.requestContent,updateObservations=_props.updateObservations,previousContentButtonShouldBeEnabled=_props.previousContentButtonShouldBeEnabled;var showingPreviousContent=this.props.previousUgcId===this.props.ugcId;var moderationState=showingPreviousContent&&this.props.moderationState?clearPreviousDecision(this.props.moderationState):this.props.moderationState;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_containers_client_HideClientSelectMenu__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_5__Moderate_scss___default.a.moderate},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'Moderate__StatusBar'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'Moderate__StatusBar__Left'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{className:'Moderate__PreviousContentButton',disabled:!previousContentButtonShouldBeEnabled,onClick:this.loadPreviousContent,'data-testid':'back-button'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i',{className:'fa fa-chevron-left mr2','aria-hidden':'true'}),'Previous Content')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'Moderate__StatusBar__Right justify-between'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'mr3 mid-gray'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'Moderate__TodayCount mr2','data-testid':'today-count-value'},todaysCompletedCount),'Today\'s Count'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('a',{href:'https://docs.google.com/document/d/1PBUQukXSYY3_QlEM3nWtA8-NE_L2gcMAlsbMmjgjcvw',target:'_blank',rel:'noopener noreferrer',className:'no-underline hover-dark-blue Moderate__GuidelinesLink'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i',{className:'fa fa-external-link v-mid mr2','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'Moderate__GuidelinesLink__Prefix'},'Moderation',' '),'Guidelines'))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_pages_components_ContentRequest__["a" /* default */],{requestStatus:contentRequestStatus},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_pages_components_ContentResponse__["a" /* default */],{ugcId:ugcId,requestContent:requestContent,moderationState:moderationState},moderationState&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{key:moderationState.getId(),className:__WEBPACK_IMPORTED_MODULE_5__Moderate_scss___default.a.moderateCard},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["l" /* PowerReviewsKeyboardEnchancer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["m" /* PowerReviewsModerationCard */],{key:moderationState.getId(),'data-id':moderationState.getId(),status:observationRequestStatus,product:product,ugc:ugc,beforeSubmit:__WEBPACK_IMPORTED_MODULE_13_models__["d" /* ModerationState */].completePowerReviewsModeration,moderationState:moderationState,onSubmit:this.handleSubmit,onChange:updateObservations})))))));}}]);return Moderate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// We do this to enable the save button for previously mod'd content
function clearPreviousDecision(moderationState){var prModeratorClientId=1;var updater=function updater(mp){return mp.delete(__WEBPACK_IMPORTED_MODULE_13_models__["e" /* Observation */].PowerModerationCode).delete(__WEBPACK_IMPORTED_MODULE_13_models__["e" /* Observation */].SecondOpinionCode);};return moderationState.updateIn(['savedObservations',prModeratorClientId],updater).updateIn(['currentObservations',prModeratorClientId],updater);}var mapStateToProps=function mapStateToProps(state){var appConfig=state.appConfig,session=state.moderate,auth=state.auth,coreData=state.coreData;var ugcId=session.ugcId;var previousContentButtonShouldBeEnabled=session.previousUgcId!==ugcId&&session.updatePreviousContentRequestStatus==='complete';return Object.assign({previousContentButtonShouldBeEnabled:previousContentButtonShouldBeEnabled,token:auth.token,todaysCompletedCount:session.getCompletedCount(),ugcId:ugcId,previousUgcId:session.previousUgcId},__WEBPACK_IMPORTED_MODULE_12_ducks_coreDataReducer__["a" /* CoreDataState */].getTheThings(coreData,ugcId),{observationsMap:appConfig.observationsMap,contentRequestStatus:session.contentRequestStatus});};var mergeProps=function mergeProps(stateProps,_ref2,ownProps){var dispatch=_ref2.dispatch;var token=stateProps.token,observationsMap=stateProps.observationsMap,restStateProps=_objectWithoutProperties(stateProps,['token','observationsMap']);return Object.assign({},ownProps,restStateProps,Object(__WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */])({updateObservations:__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["o" /* updateObservations */],requestObservationsUpdate:__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["n" /* requestObservationsUpdate */],updateCurrentUgcId:__WEBPACK_IMPORTED_MODULE_3__moderateActions__["e" /* updateCurrentUgcId */],requestPreviousUgcIdUpdate:__WEBPACK_IMPORTED_MODULE_3__moderateActions__["d" /* requestPreviousUgcIdUpdate */]},dispatch),{requestContent:function requestContent(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__moderateActions__["c" /* requestContent */])({token:token,observationsMap:observationsMap}));}});};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,undefined,mergeProps)(Moderate));

/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Moderate__StatusBar":"Moderate__StatusBar","moderateStatusBar":"Moderate__StatusBar","Moderate__StatusBar__Left":"Moderate__StatusBar__Left","moderateStatusBarLeft":"Moderate__StatusBar__Left","Moderate__StatusBar__Right":"Moderate__StatusBar__Right","moderateStatusBarRight":"Moderate__StatusBar__Right","Moderate__PreviousContentButton":"Moderate__PreviousContentButton","moderatePreviousContentButton":"Moderate__PreviousContentButton","c-button--active":"c-button--active","cButtonActive":"c-button--active","Moderate__TodayCount":"Moderate__TodayCount","moderateTodayCount":"Moderate__TodayCount","Moderate__GuidelinesLink__Prefix":"Moderate__GuidelinesLink__Prefix","moderateGuidelinesLinkPrefix":"Moderate__GuidelinesLink__Prefix","Moderate__Card":"Moderate__Card","moderateCard":"Moderate__Card","enter":"enter"};

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmptyQueueMessage_scss__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmptyQueueMessage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EmptyQueueMessage_scss__);
var RetryButton=function RetryButton(_ref){var label=_ref.label,onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{type:'button',onClick:onClick,className:__WEBPACK_IMPORTED_MODULE_2__EmptyQueueMessage_scss___default.a.emptyQueueMessageRetryButton},label||'Retry');};var EmptyQueueMessage=function EmptyQueueMessage(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */].Title,null,props.title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */].Message,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RetryButton,{onClick:props.onClick,label:props.label})));};/* harmony default export */ __webpack_exports__["a"] = (EmptyQueueMessage);

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"EmptyQueueMessage__RetryButton":"EmptyQueueMessage__RetryButton","emptyQueueMessageRetryButton":"EmptyQueueMessage__RetryButton"};

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export requestModerateContent */
/* harmony export (immutable) */ __webpack_exports__["a"] = moderateSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_content_getModerationContent__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__moderateActions__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ducks_coreDataSaga__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__moderateStorage__ = __webpack_require__(225);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(requestModerateContent),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(saveCompletedCount),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postThenSave),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(triggerUpdatePreviousUgcId),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(moderateSaga);function requestModerateContent(action){var _action$payload,token,observationsMap,data,ugc_id;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function requestModerateContent$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,token=_action$payload.token,observationsMap=_action$payload.observationsMap;_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_api_content_getModerationContent__["a" /* default */],token);case 4:data=_context.sent;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_ducks_coreDataSaga__["a" /* addItemTask */],{data:data,observationsMap:observationsMap,clientId:1});case 7:ugc_id=_context.sent;_context.next=10;return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_3__moderateActions__["a" /* receiveContent */])({ugc_id:ugc_id}));case 10:_context.next=16;break;case 12:_context.prev=12;_context.t0=_context['catch'](1);_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__moderateActions__["a" /* receiveContent */])(_context.t0));case 16:case'end':return _context.stop();}}},_marked,this,[[1,12]]);}function saveCompletedCount(){var count;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saveCompletedCount$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(function(state){return state.moderate.getCompletedCount();});case 2:count=_context2.sent;_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_7__moderateStorage__["a" /* default */].saveTodayCount,count);case 5:case'end':return _context2.stop();}}},_marked2,this);}function postThenSave(action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postThenSave$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(saveCompletedCount);case 3:_context3.next=7;break;case 5:_context3.prev=5;_context3.t0=_context3['catch'](0);case 7:case'end':return _context3.stop();}}},_marked3,this,[[0,5]]);}function triggerUpdatePreviousUgcId(action){var ugcId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function triggerUpdatePreviousUgcId$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:ugcId=action.payload.ugcId;_context4.prev=1;_context4.next=4;return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_3__moderateActions__["b" /* receivePreviousUgcIdUpdate */])(ugcId));case 4:_context4.next=8;break;case 6:_context4.prev=6;_context4.t0=_context4['catch'](1);case 8:case'end':return _context4.stop();}}},_marked4,this,[[1,6]]);}function moderateSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function moderateSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__moderateActions__["c" /* requestContent */],requestModerateContent);case 2:_context5.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["n" /* requestObservationsUpdate */],postThenSave);case 4:_context5.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["c" /* commitObservationsUpdate */],triggerUpdatePreviousUgcId);case 6:case'end':return _context5.stop();}}},_marked5,this);}

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createGetContent__ = __webpack_require__(226);
var getContent=Object(__WEBPACK_IMPORTED_MODULE_0__createGetContent__["a" /* default */])('content');/* harmony default export */ __webpack_exports__["a"] = (getContent);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__secondOpinionActions__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SecondOpinion_scss__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SecondOpinion_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SecondOpinion_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_components_ContentRequest__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_components_ContentResponse__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ducks_coreDataReducer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__secondOpinionReducer__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__secondOpinionSaga__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_containers_client_HideClientSelectMenu__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}Object(__WEBPACK_IMPORTED_MODULE_14_store__["c" /* injectSaga */])(__WEBPACK_IMPORTED_MODULE_12__secondOpinionSaga__["a" /* default */]);Object(__WEBPACK_IMPORTED_MODULE_14_store__["b" /* injectReducer */])({secondOpinion:__WEBPACK_IMPORTED_MODULE_11__secondOpinionReducer__["a" /* default */]});var SecondOpinion=function(_React$PureComponent){_inherits(SecondOpinion,_React$PureComponent);function SecondOpinion(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SecondOpinion);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SecondOpinion.__proto__||Object.getPrototypeOf(SecondOpinion)).call.apply(_ref,[this].concat(args))),_this),_initialiseProps.call(_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SecondOpinion,[{key:'componentDidMount',value:function componentDidMount(){this.props.requestContent();}},{key:'render',value:function render(){var _props=this.props,contentRequestStatus=_props.contentRequestStatus,observationRequestStatus=_props.observationRequestStatus,moderationState=_props.moderationState,product=_props.subject,ugc=_props.ugc,ugcId=_props.ugcId;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_containers_client_HideClientSelectMenu__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_6__SecondOpinion_scss___default.a.secondOpinion},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_pages_components_ContentRequest__["a" /* default */],{requestStatus:contentRequestStatus},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_pages_components_ContentResponse__["a" /* default */],{ugcId:ugcId,requestContent:this.props.requestContent,moderationState:moderationState},moderationState&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{key:moderationState.getId(),className:__WEBPACK_IMPORTED_MODULE_6__SecondOpinion_scss___default.a.secondOpinionCard},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components__["l" /* PowerReviewsKeyboardEnchancer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components__["m" /* PowerReviewsModerationCard */],{key:moderationState.getId(),'data-id':moderationState.getId(),status:observationRequestStatus,product:product,ugc:ugc,beforeSubmit:__WEBPACK_IMPORTED_MODULE_7_models__["d" /* ModerationState */].completePowerReviewsModeration,moderationState:moderationState,onSubmit:this.handleSubmit,onChange:this.props.updateObservations})))))));}}]);return SecondOpinion;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleSubmit=function(){var _props2;(_props2=_this2.props).requestObservationsUpdate.apply(_props2,arguments);_this2.props.requestContent();};};var mapStateToProps=function mapStateToProps(state){var auth=state.auth,appConfig=state.appConfig,coreData=state.coreData,session=state.secondOpinion;var ugcId=session.ugcId;return Object.assign({token:auth.token,ugcId:ugcId},__WEBPACK_IMPORTED_MODULE_10_ducks_coreDataReducer__["a" /* CoreDataState */].getTheThings(coreData,ugcId),{observationsMap:appConfig.observationsMap,contentRequestStatus:session.contentRequestStatus});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object.assign({dispatch:dispatch},Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({updateObservations:__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["o" /* updateObservations */],requestObservationsUpdate:__WEBPACK_IMPORTED_MODULE_4_ducks_coreDataActions__["n" /* requestObservationsUpdate */],requestContent:__WEBPACK_IMPORTED_MODULE_3__secondOpinionActions__["b" /* requestContent */]},dispatch));};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var token=stateProps.token,observationsMap=stateProps.observationsMap,restStateProps=_objectWithoutProperties(stateProps,['token','observationsMap']);var dispatch=dispatchProps.dispatch,restDispatchProps=_objectWithoutProperties(dispatchProps,['dispatch']);return Object.assign({},ownProps,restStateProps,restDispatchProps,{requestContent:function requestContent(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__secondOpinionActions__["b" /* requestContent */])({token:token,observationsMap:observationsMap}));}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps,mergeProps)(SecondOpinion));

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SecondOpinion__Card":"SecondOpinion__Card","secondOpinionCard":"SecondOpinion__Card","enter":"enter","SecondOpinion__StatusRow":"SecondOpinion__StatusRow","secondOpinionStatusRow":"SecondOpinion__StatusRow"};

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__secondOpinionActions__ = __webpack_require__(136);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultState={contentRequestStatus:'pending',ugcId:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__secondOpinionActions__["b" /* requestContent */].toString(),function(state,action){return Object.assign({},state,{contentRequestStatus:'pending'});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__secondOpinionActions__["a" /* receiveContent */].toString(),{next:function next(state,action){return Object.assign({},state,{ugcId:action.payload.ugc_id,contentRequestStatus:'complete'});},throw:function _throw(state,action){return Object.assign({},state,{contentRequestStatus:action.payload});}}),_handleActions),defaultState));

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export requestSecondOpinionContent */
/* harmony export (immutable) */ __webpack_exports__["a"] = secondOpinionSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_content_getSecondOpinionContent__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__secondOpinionActions__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_coreDataSaga__ = __webpack_require__(44);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(requestSecondOpinionContent),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(secondOpinionSaga);function requestSecondOpinionContent(action){var _action$payload,token,observationsMap,data,ugc_id;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function requestSecondOpinionContent$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,token=_action$payload.token,observationsMap=_action$payload.observationsMap;_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_api_content_getSecondOpinionContent__["a" /* default */],token);case 4:data=_context.sent;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_ducks_coreDataSaga__["a" /* addItemTask */],{data:data,observationsMap:observationsMap,clientId:1});case 7:ugc_id=_context.sent;_context.next=10;return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_3__secondOpinionActions__["a" /* receiveContent */])({ugc_id:ugc_id}));case 10:_context.next=16;break;case 12:_context.prev=12;_context.t0=_context['catch'](1);_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__secondOpinionActions__["a" /* receiveContent */])(_context.t0));case 16:case'end':return _context.stop();}}},_marked,this,[[1,12]]);}function secondOpinionSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function secondOpinionSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__secondOpinionActions__["b" /* requestContent */],requestSecondOpinionContent);case 2:case'end':return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createGetContent__ = __webpack_require__(226);
var getSecondOpinionContent=Object(__WEBPACK_IMPORTED_MODULE_0__createGetContent__["a" /* default */])('content/secondOpinion');/* harmony default export */ __webpack_exports__["a"] = (getSecondOpinionContent);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Main; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var NAV_WIDTH=200;var MAIN_WIDTH=1240;var Viewport=function Viewport(_ref){var children=_ref.children;if(__WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children)!==2){throw new Error('Shell component expects exactly 2 children');}var _React$Children$toArr=__WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children),_React$Children$toArr2=_slicedToArray(_React$Children$toArr,2),nav=_React$Children$toArr2[0],main=_React$Children$toArr2[1];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'min-vh-100 min-vw-100',style:{paddingLeft:NAV_WIDTH}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'w5 min-vh-100 fixed top-0 left-0 bottom-0 bg-dark-gray',style:{width:NAV_WIDTH}},nav),main);};var Main=function Main(_ref2){var children=_ref2.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('main',{className:'db cf min-vh-100 center ph5-l ph4 ',style:{maxWidth:MAIN_WIDTH}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mv4'},children));};var Header=function Header(_ref3){var children=_ref3.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mv4 w-100 flex flex-row justify-between items-center'},children);};/* harmony default export */ __webpack_exports__["c"] = (Viewport);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Nav */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Icons_Logo__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Icons_Nav__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_auth_context__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Nav_scss__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Nav_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Nav_scss__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var NavWidth=220;var PortalNavWidth=60;var Nav=function Nav(props){var contextLabel=props.contextLabel,contextRoutes=props.contextRoutes,match=props.match;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_ducks_auth_context__["a" /* AuthContext */].Consumer,null,function(auth){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('nav',{className:'w5 min-vh-100 fixed top-0 left-0 bottom-0 bg-white Nav',style:{width:NavWidth},'data-translate':true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'h-100 fixed br Nav__border',style:{width:PortalNavWidth}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('ul',{className:'list pl0 Nav__Portal flex flex-column items-center justify-center w-100'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('li',{className:'mv3 Nav__Portal__item--home'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](NavLink,{to:auth.apps.get('Home')},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Icons_Logo__["a" /* default */],{className:'db center'}))),[].concat(_toConsumableArray(auth.apps.entries())).slice(1).map(function(_ref){var _ref2=_slicedToArray(_ref,2),label=_ref2[0],url=_ref2[1];var Icon=getAppIcon(label);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('li',{className:'Nav__Portal__item flex items-center justify-center',key:url},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](NavLink,{to:url,className:'link Nav__Portal__link',activeClassName:'Nav__Portal__link--active'},Icon&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,null)));}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'h-100 bg-white fixed br Nav__border',style:{marginLeft:PortalNavWidth,width:NavWidth-PortalNavWidth}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('ul',{className:'list pl0 Nav__App brandon flex flex-column'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('li',{className:'mv3 Nav__App__item flex items-center justify-center'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'f4 b ttu'},contextLabel)),contextRoutes.filter(function(route){return route==='sep'||route.navItem;}).map(function(route){if(route==='sep'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('li',{className:'pv2',key:route},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'db mh3 bt Nav__border'}));}var label=route.label,to=route.path;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('li',{className:'Nav__App__item flex',key:to},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](NavLink,{to:match.url+'/'+to,className:'link Nav__App__link',activeClassName:'Nav__App__link--active'},label));}))));});};function getAppIcon(label){switch(label){case'Reviews':return __WEBPACK_IMPORTED_MODULE_2_components_Icons_Nav__["g" /* ReviewsIcon */];case'QA':return __WEBPACK_IMPORTED_MODULE_2_components_Icons_Nav__["f" /* QAIcon */];case'Moderation':return __WEBPACK_IMPORTED_MODULE_2_components_Icons_Nav__["d" /* ContentIcon */];case'Analytics':return __WEBPACK_IMPORTED_MODULE_2_components_Icons_Nav__["c" /* AnalyticsIcon */];case'Setup':return __WEBPACK_IMPORTED_MODULE_2_components_Icons_Nav__["i" /* SupportIcon */];case'Account':return __WEBPACK_IMPORTED_MODULE_2_components_Icons_Nav__["a" /* AccountIcon */];case'Admin':return __WEBPACK_IMPORTED_MODULE_2_components_Icons_Nav__["b" /* AdminIcon */];case'SocialCollection':return __WEBPACK_IMPORTED_MODULE_2_components_Icons_Nav__["h" /* SocialCollectionIcon */];case'Dashboard':return __WEBPACK_IMPORTED_MODULE_2_components_Icons_Nav__["e" /* DashboardIcon */];default:return null;}}function NavLink(_ref3){var to=_ref3.to,activeClassName=_ref3.activeClassName,children=_ref3.children,rest=_objectWithoutProperties(_ref3,['to','activeClassName','children']);var isInternal=/^\/(?!\/)/.test(to);if(isInternal){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* NavLink */],Object.assign({to:to,activeClassName:activeClassName},rest),children);}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('a',Object.assign({href:to},rest),children);}/* harmony default export */ __webpack_exports__["a"] = (Nav);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Logo=function Logo(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({viewBox:'0 0 30 30',xmlns:'http://www.w3.org/2000/svg'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('g',{'clip-path':'url(#clip0_1678_56)'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{'fill-rule':'evenodd','clip-rule':'evenodd',d:'M15.8363 9.20568H12.4879V14.293H15.8363C17.446 14.293 18.5403 13.3696 18.5403 11.7601C18.5403 10.1503 17.446 9.20568 15.8363 9.20568ZM15.9647 16.3964H12.4879V22.4053H10.1699C10.1699 22.4053 10.1699 8.87741 10.1699 8.27914C10.1699 7.68064 10.737 7.12402 11.3588 7.12402C11.9803 7.12402 15.9647 7.12402 15.9647 7.12402C18.9484 7.12402 20.8587 9.09883 20.8587 11.7601C20.8587 14.4216 18.9484 16.3964 15.9647 16.3964Z',fill:'#0D0D11'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{'fill-rule':'evenodd','clip-rule':'evenodd',d:'M21.1713 22.4065L17.6557 17.3481C17.6557 17.3481 17.2638 17.5368 16.0781 17.5368C15.3879 17.5368 14.936 17.5368 14.936 17.5368L18.2868 22.4095L21.1713 22.4065Z',fill:'#0D0D11'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{'fill-rule':'evenodd','clip-rule':'evenodd',d:'M2.23488 15.0722C2.22669 11.881 3.24808 9.12854 5.33538 6.71492L3.645 5.253C1.19111 8.09019 -0.00946328 11.3262 -1.73676e-06 15.0773C0.021229 23.3398 6.73661 30.021 14.9986 30L14.993 27.7678C7.96488 27.7844 2.25277 22.1011 2.23488 15.0722Z',fill:'#7ACFB3'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{'fill-rule':'evenodd','clip-rule':'evenodd',d:'M27.5709 16.7789C26.6978 23.1085 21.3842 27.7515 14.9949 27.7678L14.993 27.7678L14.9986 30C22.5091 29.9807 28.7548 24.5238 29.7811 17.0838L27.5709 16.7789Z',fill:'#FBB209'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{'fill-rule':'evenodd','clip-rule':'evenodd',d:'M22.8564 2.33192L21.678 4.22827L21.6798 4.2293C26.0202 6.9263 28.269 11.7167 27.5709 16.7789L29.7811 17.0838C30.602 11.1335 27.9585 5.502 22.8564 2.33192Z',fill:'#69CEEA'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{'fill-rule':'evenodd','clip-rule':'evenodd',d:'M21.678 4.22827L22.8564 2.33192C19.0314 -0.0448875 14.8533 -0.583964 10.5504 0.74319L11.2092 2.87838L11.2104 2.87804C14.8703 1.74888 18.4244 2.20707 21.678 4.22827Z',fill:'#81CC28'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{'fill-rule':'evenodd','clip-rule':'evenodd',d:'M11.2092 2.87838L10.5504 0.74319C7.68461 1.6275 5.60677 2.98419 3.645 5.253L5.33538 6.71492C7.00408 4.78511 8.77177 3.63046 11.2092 2.87838Z',fill:'#f15d23'})));};/* harmony default export */ __webpack_exports__["a"] = (Logo);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AnalyticsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ReviewsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return QAIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ContentIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SupportIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AdminIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SocialCollectionIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DashboardIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var AnalyticsIcon=function AnalyticsIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({viewBox:'0 0 216 216'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'currentColor',d:'M122.1,0h-9.4v103.3H216v-9.4C216,42.1,173.9,0,122.1,0z M131.5,84.5V19.4c33.9,4.2,60.9,31.2,65.1,65.1 H131.5z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'currentColor',d:'M103.3,28.2h-9.4C42.1,28.2,0,70.3,0,122.1C0,173.9,42.1,216,93.9,216c51.8,0,93.9-42.1,93.9-93.9v-9.4 h-84.5V28.2z M168.5,131.5c-4.6,37-36.3,65.7-74.5,65.7c-41.4,0-75.1-33.7-75.1-75.1c0-38.2,28.7-69.9,65.7-74.5v83.9H168.5z'})));};var ReviewsIcon=function ReviewsIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({viewBox:'0 0 360 360'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('defs',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{id:'SVGID_1_',d:'M179.4,10L179.4,10c-12.9,0-23.7,8.2-27.4,20.5l-27.4,86.9H31.7c-12.4,0-23.7,8.2-27.4,19.7 c-3.7,11.8,0.5,24.7,10.3,32.1l74.2,54.2l-27.4,86.3c-3.7,11.8,0.5,24.7,10.8,32.1c4.7,3.7,10.8,5.3,16.6,5.3 c5.8,0,11.8-1.6,17.1-5.3l73.4-54.2l72.4,53.7c5.3,3.7,11.3,5.8,17.1,5.8c5.8,0,11.8-1.6,16.6-5.3c10.3-7.6,14.5-20.5,10.8-32.1 l-27.4-86.3l74.2-54.2c10.3-7.6,14.5-20.5,10.3-32.1c-3.7-11.8-15-19.7-27.4-19.7h-90.8l-28.4-86.9C202.8,17.9,191.8,10,179.4,10z M179.4,39l35,107.4H326L235.2,213l34,105.8l-89.8-66.6l-90.8,66.6L122.3,213l-90.8-66.6h113.7L179.4,39z'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use',{xlinkHref:'#SVGID_1_',overflow:'visible',fillRule:'evenodd',clipRule:'evenodd',fill:'currentColor'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('clipPath',{id:'SVGID_2_'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use',{xlinkHref:'#SVGID_1_',overflow:'visible'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('rect',{x:'-94.8',y:'-87.8',clipPath:'url(#SVGID_2_)',fill:'currentColor',width:'547.6',height:'532.8'})));};var QAIcon=function QAIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({viewBox:'0 0 360 360'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('defs',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{id:'QSVGID_1_',d:'M208.3,214.4c-9.2-6.9-18.9-12.2-29.1-15.6l-8.6,17.6c6.5,2.3,12.8,5.5,19.1,9.6c-4,1.5-8.2,2.2-12.6,2.2 c-11.9,0-21.8-4.4-29.6-13.3c-7.8-8.9-11.7-22.2-11.7-40.1c0-17.6,3.9-30.7,11.7-39.5c7.8-8.8,18-13.1,30.6-13.1 c12.6,0,22.8,4.4,30.5,13.1c7.8,8.7,11.7,21.9,11.7,39.5c0,8.5-1,16.1-3,22.7C215.2,204.2,212.2,209.8,208.3,214.4z M233.1,231.8 c6.1-7.2,10.6-14.6,13.3-22.2c3.7-10,5.5-21.6,5.5-34.8c0-24.9-6.6-44.3-19.9-58.2c-13.3-13.9-31.2-20.8-53.9-20.8 c-22.9,0-41,6.9-54.3,20.8c-13.3,13.9-20,33.3-20,58.2c0,25,6.7,44.4,20,58.3c13.3,13.8,31.7,20.7,55.2,20.7 c12.2,0,23.2-2.2,33.2-6.6c12.7,8.5,19.6,13.1,20.5,13.5c4.4,2.4,9,4.3,13.7,5.7l11.4-21.8C248.9,241.6,240.7,237.3,233.1,231.8z M179.5,350C84.8,350,8,273.2,8,178.5S84.8,7,179.5,7S351,83.8,351,178.5S274.2,350,179.5,350z'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use',{xlinkHref:'#QSVGID_1_',overflow:'visible',fillRule:'evenodd',clipRule:'evenodd',fill:'currentColor'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('clipPath',{id:'QSVGID_2_'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use',{xlinkHref:'#QSVGID_1_',overflow:'visible'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('rect',{x:'-82.3',y:'-83.3',clipPath:'url(#QSVGID_2_)',fill:'currentColor',width:'523.5',height:'523.5'})));};var ContentIcon=function ContentIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({viewBox:'36 -24 146 176'/* 0 0 216 146 */},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'currentColor',d:'M164.3,34.8c-1.3-1.3-3-2-4.9-2h-36.1V9.9c0-1.6-0.6-2.9-1.7-4.1c-1.1-1.1-2.5-1.7-4.1-1.7H79.3 c-1.6,0-3.3,0.4-5.3,1.2c-1.9,0.8-3.4,1.8-4.5,2.9L50.9,26.9c-1.1,1.1-2.1,2.6-2.9,4.5s-1.2,3.7-1.2,5.3v53.5c0,1.6,0.6,2.9,1.7,4.1 c1.1,1.1,2.5,1.7,4.1,1.7h21.7v40.4c0,1.9,0.7,3.5,2,4.9c1.3,1.3,3,2,4.9,2h78.2c1.9,0,3.5-0.7,4.9-2c1.3-1.3,2-3,2-4.9V39.7 C166.3,37.8,165.6,36.2,164.3,34.8z M56.3,32.3L75,13.6c0.5-0.5,1.3-0.9,2.4-1.3v22.4H55C55.4,33.6,55.8,32.8,56.3,32.3z M54.5,88.3 V42.4h24.8c1.6,0,2.9-0.6,4.1-1.7c1.1-1.1,1.7-2.5,1.7-4.1V11.8h30.6v21h-2.3c-1.9,0-4,0.5-6.3,1.4c-2.3,1-4.1,2.1-5.5,3.5 L79.2,60.1c-1.3,1.3-2.5,3.2-3.5,5.5c-1,2.3-1.4,4.4-1.4,6.3v16.3H54.5z M111.1,42.6v27h-27c0.5-1.4,1-2.4,1.6-2.9l22.5-22.5 C108.7,43.6,109.7,43.1,111.1,42.6z M157.1,134H83.5V78.8h29.9c1.9,0,3.5-0.7,4.9-2c1.3-1.3,2-3,2-4.9V42h36.8V134z'}));};var AccountIcon=function AccountIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({viewBox:'26 -20 166 166'/* 0 0 216 146 */},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'currentColor',d:'M124.9,102.2c0-0.5-0.2-1.1-0.6-1.6c-3-3.6-5.5-6.8-7.3-9.4c1.1-2.2,2-4.3,2.6-6.2l12.6-2 c0.5-0.1,0.9-0.3,1.3-0.9c0.4-0.5,0.6-1,0.6-1.6V65.5c0-0.6-0.2-1.1-0.6-1.6s-0.8-0.7-1.4-0.9l-12.4-1.9c-0.6-1.8-1.5-4.1-2.8-6.7 c0.8-1.2,2-2.8,3.7-4.9c1.6-2.1,2.8-3.5,3.4-4.4c0.4-0.5,0.6-1.1,0.6-1.5c0-1.5-3.9-5.8-11.7-13c-0.5-0.4-1.1-0.7-1.7-0.7 c-0.7,0-1.2,0.2-1.6,0.6l-9.6,7.3c-2.2-1.1-4.3-2-6.1-2.5l-1.9-12.5c-0.1-0.5-0.3-1-0.8-1.4c-0.5-0.4-1-0.6-1.6-0.6H74.4 c-1.2,0-2.1,0.7-2.4,2c-0.7,2.5-1.3,6.7-1.9,12.5c-2.3,0.8-4.4,1.6-6.3,2.6l-9.4-7.3c-0.5-0.4-1.1-0.6-1.7-0.6 c-1,0-3.2,1.6-6.4,4.8c-3.3,3.2-5.5,5.6-6.7,7.3c-0.4,0.4-0.6,1-0.6,1.6c0,0.5,0.2,1,0.6,1.6c3,3.6,5.5,6.8,7.3,9.4 c-1.1,2.2-2,4.3-2.6,6.2l-12.6,2c-0.5,0.1-0.9,0.3-1.3,0.9c-0.4,0.5-0.6,1-0.6,1.6v15.1c0,0.6,0.2,1.1,0.6,1.6 c0.4,0.5,0.8,0.7,1.4,0.8l12.4,2c0.7,2.1,1.6,4.3,2.9,6.7c-0.9,1.2-2.1,2.9-3.8,5c-1.7,2.1-2.8,3.6-3.3,4.3 c-0.4,0.5-0.6,1.1-0.6,1.5c0,1.5,3.9,5.8,11.7,13c0.5,0.4,1.1,0.7,1.7,0.7c0.7,0,1.2-0.2,1.6-0.6l9.6-7.3c2.2,1.1,4.3,2,6.1,2.5 l1.9,12.5c0.1,0.5,0.3,1,0.8,1.4c0.5,0.4,1,0.6,1.6,0.6h15.2c1.2,0,2.1-0.7,2.4-2c0.7-2.6,1.3-6.8,1.9-12.6 c2.2-0.7,4.3-1.5,6.3-2.5l9.4,7.3c0.5,0.4,1.1,0.6,1.7,0.6c1,0,3.2-1.6,6.4-4.8c3.2-3.2,5.5-5.7,6.7-7.3 C124.7,103.4,124.9,102.9,124.9,102.2z M96.7,87.7c-4.1,4.1-9,6.1-14.7,6.1c-5.8,0-10.7-2-14.7-6.1c-4.1-4.1-6.1-9-6.1-14.7 c0-5.8,2-10.7,6.1-14.7c4.1-4.1,9-6.1,14.7-6.1c5.8,0,10.7,2,14.7,6.1c4.1,4.1,6.1,9,6.1,14.7C102.8,78.7,100.7,83.6,96.7,87.7z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'currentColor',d:'M174.1,106.4c-0.7-1.6-1.5-3-2.4-4.2c2.8-6.1,4.2-9.9,4.2-11.2c0-0.2-0.1-0.4-0.3-0.6 c-6.5-3.8-9.9-5.7-10.1-5.7l-0.5,0.2c-2.2,2.2-4.7,5.3-7.5,9.1c-1.1-0.1-1.9-0.2-2.4-0.2c-0.5,0-1.4,0.1-2.4,0.2 c-0.8-1.1-2.2-3-4.2-5.5s-3.3-3.8-3.7-3.8c-0.1,0-0.9,0.4-2.4,1.3c-1.5,0.9-3.1,1.8-4.8,2.8c-1.7,1-2.6,1.5-2.9,1.6 c-0.2,0.2-0.3,0.4-0.3,0.6c0,1.4,1.4,5.1,4.2,11.2c-0.9,1.2-1.7,2.7-2.4,4.2c-8.1,0.8-12.1,1.7-12.1,2.5v11.4c0,0.9,4,1.7,12.1,2.5 c0.6,1.5,1.5,2.9,2.4,4.2c-2.8,6.1-4.2,9.9-4.2,11.2c0,0.2,0.1,0.4,0.3,0.6c6.6,3.9,10,5.8,10.1,5.8c0.4,0,1.7-1.3,3.7-3.8 c2.1-2.6,3.5-4.4,4.2-5.5c1.1,0.1,1.9,0.2,2.4,0.2c0.5,0,1.4-0.1,2.4-0.2c0.8,1.1,2.2,3,4.2,5.5c2.1,2.6,3.3,3.8,3.7,3.8 c0.1,0,3.5-1.9,10.1-5.8c0.2-0.2,0.3-0.4,0.3-0.6c0-1.4-1.4-5.1-4.2-11.2c1-1.4,1.8-2.8,2.4-4.2c8.1-0.8,12.1-1.7,12.1-2.5V109 C186.2,108.1,182.2,107.3,174.1,106.4z M162.3,122c-2,2-4.5,3.1-7.4,3.1s-5.3-1-7.4-3.1c-2-2-3.1-4.5-3.1-7.4c0-2.8,1-5.3,3.1-7.3 s4.5-3.1,7.3-3.1s5.3,1,7.3,3.1c2.1,2.1,3.1,4.5,3.1,7.3C165.4,117.6,164.3,120,162.3,122z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'currentColor',d:'M174.1,23c-0.7-1.6-1.5-3-2.4-4.2c2.8-6.1,4.2-9.9,4.2-11.2c0-0.2-0.1-0.4-0.3-0.6 c-6.5-3.8-9.9-5.7-10.1-5.7l-0.5,0.2c-2.2,2.2-4.7,5.3-7.5,9.1c-1.1-0.1-1.9-0.2-2.4-0.2c-0.5,0-1.4,0.1-2.4,0.2 c-0.8-1.1-2.2-3-4.2-5.5c-2.1-2.5-3.3-3.8-3.7-3.8c-0.1,0-0.9,0.4-2.4,1.3s-3.1,1.8-4.8,2.8c-1.7,1-2.6,1.5-2.9,1.6 c-0.2,0.2-0.3,0.4-0.3,0.6c0,1.4,1.4,5.1,4.2,11.2c-0.9,1.2-1.7,2.7-2.4,4.2c-8.1,0.8-12.1,1.7-12.1,2.5v11.4c0,0.9,4,1.7,12.1,2.5 c0.6,1.5,1.5,2.9,2.4,4.2c-2.8,6.1-4.2,9.9-4.2,11.2c0,0.2,0.1,0.4,0.3,0.6c6.6,3.9,10,5.8,10.1,5.8c0.4,0,1.7-1.3,3.7-3.8 c2.1-2.6,3.5-4.4,4.2-5.5c1.1,0.1,1.9,0.2,2.4,0.2c0.5,0,1.4-0.1,2.4-0.2c0.8,1.1,2.2,3,4.2,5.5c2.1,2.6,3.3,3.8,3.7,3.8 c0.1,0,3.5-1.9,10.1-5.8c0.2-0.2,0.3-0.4,0.3-0.6c0-1.4-1.4-5.1-4.2-11.2c1-1.4,1.8-2.8,2.4-4.2c8.1-0.8,12.1-1.7,12.1-2.5V25.5 C186.2,24.7,182.2,23.8,174.1,23z M162.3,38.6c-2,2-4.5,3.1-7.4,3.1s-5.3-1-7.4-3.1c-2-2-3.1-4.5-3.1-7.4c0-2.8,1-5.3,3.1-7.3 s4.5-3.1,7.3-3.1s5.3,1,7.3,3.1c2.1,2.1,3.1,4.5,3.1,7.3C165.4,34.1,164.3,36.6,162.3,38.6z'})));};var SupportIcon=function SupportIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 228.081 228.081'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'currentColor',d:'M220.581 71.027h-63.527V7.501c0-4.142-3.358-7.5-7.5-7.5H78.526c-4.142 0-7.5 3.358-7.5 7.5v63.526H7.5c-4.142 0-7.5 3.358-7.5 7.5v71.032c0 4.142 3.358 7.5 7.5 7.5h63.526v63.521c0 4.142 3.358 7.5 7.5 7.5h71.027c4.142 0 7.5-3.358 7.5-7.5v-63.521h63.527c4.142 0 7.5-3.358 7.5-7.5V78.527c.001-4.142-3.357-7.5-7.499-7.5zm-7.5 71.032h-63.527c-4.142 0-7.5 3.358-7.5 7.5v63.521H86.026v-63.521c0-4.142-3.358-7.5-7.5-7.5H15V86.027h63.526c4.142 0 7.5-3.358 7.5-7.5V15.001h56.027v63.526c0 4.142 3.358 7.5 7.5 7.5h63.527v56.032z'}));};var AdminIcon=function AdminIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({viewBox:'0 0 216 216'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'currentColor',d:'M214.8,88.7c-1.2-1.2-1.2-1.2-2.4-1.2L187,83.9c-1.2-3.6-3.6-8.4-6-13.3c1.2-2.4,4.8-6,7.2-9.7 c3.6-4.8,6-7.2,7.2-9.7c1.2-1.2,1.2-2.4,1.2-3.6c0-3.6-8.4-12.1-24.1-26.5c-1.2-1.2-2.4-1.2-3.6-1.2c-1.2,0-2.4,0-3.6,1.2L146,35.6 c-4.8-2.4-8.4-3.6-13.3-4.8l-3.6-25.3c0-1.2-1.2-2.4-1.2-2.4c-1.2-1.2-2.4-1.2-3.6-1.2H92.9c-2.4,0-4.8,1.2-4.8,3.6 c-1.2,4.8-2.4,13.3-4.8,25.3c-4.8,1.2-8.4,3.6-12.1,4.8L50.7,21.1c0-1.2-1.2-1.2-2.4-1.2c-2.4,0-6,3.6-13.3,9.7S22.9,41.6,20.5,44 c-1.2,1.2-1.2,2.4-1.2,3.6c0,1.2,0,2.4,1.2,3.6c6,7.2,10.9,13.3,15.7,19.3c-2.4,4.8-4.8,8.4-6,13.3L3.6,87.5 c-1.2,0-2.4,1.2-2.4,1.2C0,89.9,0,91.1,0,92.3v31.4c0,1.2,0,2.4,1.2,3.6s1.2,1.2,2.4,1.2l26.5,3.6c1.2,4.8,3.6,8.4,6,13.3 c-1.2,2.4-4.8,6-8.4,10.9c-3.6,4.8-6,7.2-7.2,8.4c-1.2,1.2-1.2,2.4-1.2,3.6c0,3.6,8.4,12.1,24.1,26.5c1.2,1.2,2.4,1.2,3.6,1.2 c1.2,0,2.4,0,3.6-1.2l20.5-14.5c4.8,2.4,8.4,3.6,13.3,4.8l3.6,25.3c0,1.2,1.2,2.4,1.2,2.4c1.2,1.2,2.4,1.2,3.6,1.2h31.4 c2.4,0,4.8-1.2,4.8-3.6c1.2-4.8,2.4-14.5,3.6-26.5c4.8-1.2,8.4-3.6,13.3-4.8l19.3,15.7c1.2,1.2,2.4,1.2,3.6,1.2 c2.4,0,6-3.6,13.3-9.7c7.2-7.2,10.9-12.1,14.5-14.5c1.2-1.2,1.2-2.4,1.2-3.6c0-1.2,0-2.4-1.2-3.6c-6-7.2-10.9-14.5-15.7-19.3 c2.4-4.8,3.6-8.4,4.8-13.3l26.5-3.6c1.2,0,2.4-1.2,2.4-1.2c1.2-1.2,1.2-2.4,1.2-3.6V92.3C216,91.1,216,89.9,214.8,88.7z M138.8,138.2c-8.4,8.4-19.3,12.1-30.2,12.1c-12.1,0-21.7-3.6-30.2-12.1c-8.4-8.4-13.3-18.1-13.3-30.2S70,86.3,78.4,77.8 s19.3-12.1,30.2-12.1c12.1,0,21.7,3.6,30.2,12.1c8.4,8.4,13.3,18.1,13.3,30.2S147.2,129.7,138.8,138.2z'})));};var SocialCollectionIcon=function SocialCollectionIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({xmlns:'http://www.w3.org/2000/svg',xmlnsXlink:'http://www.w3.org/1999/xlink',viewBox:'0 0 432 432'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('defs',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{id:'social-collection-a',d:'M267.3 95.5l24.7 48.2h115v197.9H26V143.7h114.9l24.7-48.2h101.7zm0-24.7H165.7c-9.3 0-17.8 5.2-22 13.4L125.8 119H26c-13.7 0-24.7 11.1-24.7 24.7v197.9c0 13.7 11.1 24.7 24.7 24.7h381c13.7 0 24.7-11.1 24.7-24.7V143.7c0-13.7-11.1-24.7-24.7-24.7h-99.8l-17.8-34.8c-4.3-8.2-12.8-13.4-22.1-13.4z'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use',{xlinkHref:'#social-collection-a',overflow:'visible',fillRule:'evenodd',clipRule:'evenodd',fill:'currentColor'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('clipPath',{id:'social-collection-b'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use',{xlinkHref:'#social-collection-a',overflow:'visible'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{clipPath:'url(#social-collection-b)',fill:'currentColor',d:'M-75.9-6.4H509v450H-75.9z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('defs',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{id:'social-collection-c',d:'M217.4 286.9c30.6 0 55.4-24.8 55.4-55.4 0-30.6-24.8-55.4-55.4-55.4S162 200.9 162 231.5c0 30.6 24.8 55.4 55.4 55.4zm0 22.2c-42.9 0-77.6-34.7-77.6-77.6s34.7-77.6 77.6-77.6 77.6 34.7 77.6 77.6-34.7 77.6-77.6 77.6z'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use',{xlinkHref:'#social-collection-c',overflow:'visible',fill:'currentColor'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('clipPath',{id:'social-collection-d'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use',{xlinkHref:'#social-collection-c',overflow:'visible'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{clipPath:'url(#social-collection-d)',fill:'currentColor',d:'M62.6 76.7h309.6v309.6H62.6z'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('defs',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{id:'social-collection-e',d:'M97.8 104.9H51.6c-6.4 0-11.5-5.2-11.5-11.5 0-6.4 5.2-11.5 11.5-11.5h46.2c6.4 0 11.5 5.2 11.5 11.5 0 6.4-5.1 11.5-11.5 11.5z'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use',{xlinkHref:'#social-collection-e',overflow:'visible',fillRule:'evenodd',clipRule:'evenodd',fill:'currentColor'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('clipPath',{id:'social-collection-f'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use',{xlinkHref:'#social-collection-e',overflow:'visible'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{clipPath:'url(#social-collection-f)',fill:'currentColor',d:'M-37.1 4.7h223.7v177.5H-37.1z'})));};var DashboardIcon=function DashboardIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({xmlns:'http://www.w3.org/2000/svg',viewBox:'0 -960 960 960',fill:'currentColor'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{d:'M418-340q24 24 62 23.5t56-27.5l224-336-336 224q-27 18-28.5 55t22.5 61Zm62-460q59 0 113.5 16.5T696-734l-76 48q-33-17-68.5-25.5T480-720q-133 0-226.5 93.5T160-400q0 42 11.5 83t32.5 77h552q23-38 33.5-79t10.5-85q0-36-8.5-70T766-540l48-76q30 47 47.5 100T880-406q1 57-13 109t-41 99q-11 18-30 28t-40 10H204q-21 0-40-10t-30-28q-26-45-40-95.5T80-400q0-83 31.5-155.5t86-127Q252-737 325-768.5T480-800Zm7 313Z'}));};

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Nav__border":"Nav__border","navBorder":"Nav__border","Nav__Portal__item":"Nav__Portal__item","navPortalItem":"Nav__Portal__item","Nav__Portal__item--home":"Nav__Portal__item--home","navPortalItemHome":"Nav__Portal__item--home","Nav__Portal__link":"Nav__Portal__link","navPortalLink":"Nav__Portal__link","Nav__Portal__link--active":"Nav__Portal__link--active","navPortalLinkActive":"Nav__Portal__link--active","Nav__App__item":"Nav__App__item","navAppItem":"Nav__App__item","Nav__App__link":"Nav__App__link","navAppLink":"Nav__App__link","Nav__App__link--active":"Nav__App__link--active","navAppLinkActive":"Nav__App__link--active"};

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserIcon__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu__ = __webpack_require__(228);
var UserMenu=function UserMenu(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Menu__["a" /* default */],{id:'user-menu',label:props.username,renderIcon:function renderIcon(_ref){var getProps=_ref.getProps;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__UserIcon__["a" /* default */],getProps());},renderItems:function renderItems(_ref2){var getProps=_ref2.getProps;return[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],Object.assign({key:'logout',to:'/logout'},getProps()),'Logout')];}});};/* harmony default export */ __webpack_exports__["a"] = (UserMenu);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var UserIcon=function UserIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",viewBox:"0 0 360 360"},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("defs",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{id:"a",d:"M342.4 309.9c0-62.7-51-113.7-113.7-113.7h-97.4c-62.7 0-113.7 51-113.7 113.7v32.5h324.8v-32.5zm-292.3 0c0-44.8 36.4-81.2 81.2-81.2h97.4c44.8 0 81.2 36.4 81.2 81.2H50.1z"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("clipPath",{id:"b"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#a",overflow:"visible"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{clipPath:"url(#b)",fill:"currentColor",d:"M-83.9 94.8h527.7v349.1H-83.9z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("defs",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{id:"c",d:"M261.2 98.8c0-44.8-36.4-81.2-81.2-81.2S98.8 54 98.8 98.8 135.2 180 180 180s81.2-36.4 81.2-81.2m-129.9 0c0-26.9 21.9-48.7 48.7-48.7s48.7 21.9 48.7 48.7-21.9 48.7-48.7 48.7-48.7-21.8-48.7-48.7"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("clipPath",{id:"d"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#c",overflow:"visible"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{clipPath:"url(#d)",fill:"currentColor",d:"M-2.7-83.9h365.4v365.4H-2.7z"}));};/* harmony default export */ __webpack_exports__["a"] = (UserIcon);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu__ = __webpack_require__(228);
var HelpMenu=function HelpMenu(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Menu__["a" /* default */],{id:'help-menu',label:'Help',justify:'right',renderItems:function renderItems(_ref){var getProps=_ref.getProps;return[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('a',Object.assign({key:'documentation',href:'http://help.powerreviews.com/Content/Moderation/Moderation%20&%20Observations.htm',target:'_blank',rel:'noopener noreferrer'},getProps()),'Documentation'),// <a key="chat" href="#">
//   Chat
// </a>,
__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('a',Object.assign({key:'support',href:'http://help.powerreviews.com/Content/Contact%20Us.htm',target:'_blank',rel:'noopener noreferrer'},getProps()),'Support')];}});};/* harmony default export */ __webpack_exports__["a"] = (HelpMenu);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchView */
/* unused harmony export queryHacks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_appConfigReducer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchForm__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchForm_SearchFormHelper__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_sub_weeks__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_sub_weeks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_sub_weeks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_api_content_search__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SearchCollection__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_ClientCard__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_containers_client_ClientProvider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__searchSaga__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__searchReducer__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__searchActions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_store__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lib_analytics__ = __webpack_require__(257);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}Object(__WEBPACK_IMPORTED_MODULE_17_store__["b" /* injectReducer */])(__WEBPACK_IMPORTED_MODULE_15__searchReducer__["a" /* default */]);Object(__WEBPACK_IMPORTED_MODULE_17_store__["c" /* injectSaga */])(__WEBPACK_IMPORTED_MODULE_14__searchSaga__["a" /* default */]);var StatusObservationCodes=[__WEBPACK_IMPORTED_MODULE_9_models__["e" /* Observation */].PowerModerationCode,__WEBPACK_IMPORTED_MODULE_9_models__["e" /* Observation */].ClientModerationCode,__WEBPACK_IMPORTED_MODULE_9_models__["e" /* Observation */].PublicationOverrideCode,__WEBPACK_IMPORTED_MODULE_9_models__["e" /* Observation */].NotForPublicationOverrideCode];// const StatusObservationCodesSet = Set(StatusObservationCodes);
var SearchView=function(_React$PureComponent){_inherits(SearchView,_React$PureComponent);function SearchView(props){_classCallCheck(this,SearchView);var _this=_possibleConstructorReturn(this,(SearchView.__proto__||Object.getPrototypeOf(SearchView)).call(this,props));_this.toggleExtraFields=function(){_this.setState(function(prevState){var expanded=!prevState.expanded;var value=expanded===false?_this.helper.clearHiddenFields(prevState.value):prevState.value;return{expanded:expanded,value:value};});};_this.handleSubmitClick=function(){__WEBPACK_IMPORTED_MODULE_18_lib_analytics__["a" /* default */].event({eventCategory:_this.props.label+' Search',eventAction:'Search'});_this.submit();};_this.handleChange=function(unsanitizedValue){var value=_this.helper.sanitize(_this.state.value,unsanitizedValue);_this.setState({value:value});};_this.handleReset=function(){_this.setState(createDefaultState(_this.helper));};_this.handleLocationSearchChange=function(search){_this.setState(createStateFromSearch(_this.helper,search),_this.submit);};_this.helper=new __WEBPACK_IMPORTED_MODULE_6__SearchForm_SearchFormHelper__["a" /* default */](props.primaryFieldsets,props.extraFieldsets);_this.state=props.location.search?createStateFromSearch(_this.helper,props.location.search):createDefaultState(_this.helper);if(_this.props.location.search){_this.submit(_this.state.value);}// cache code & status options
_this.codeOptions=getCodeOptions(_this.props.observationByCode);_this.statusOptions=StatusObservationCodes.reduce(function(acc,code){var ob=props.observationByCode.get(code);if(ob){acc.push(mapObservationToOption(ob));}return acc;},[]);return _this;}_createClass(SearchView,[{key:'submit',value:function submit(){var _props=this.props,onSubmit=_props.onSubmit,clientId=_props.clientId;var _value=this.state.value;var value=_value.withMutations(function(v){v.set('client_id',String(clientId));if(typeof onSubmit==='function'){v=onSubmit(v);}});this.props.submitSearch(this.helper.serializeToObject(value));}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _props2=this.props,isSearching=_props2.isSearching,clientId=_props2.clientId,query=_props2.query,search=_props2.location.search,match=_props2.match;var didBeginSearch=isSearching===true&&prevProps.isSearching===false;// begin search
if(didBeginSearch){var queryString='?'+__WEBPACK_IMPORTED_MODULE_6__SearchForm_SearchFormHelper__["a" /* default */].convertObjectToURI(query);if(search!==queryString){var nextRoute=match.url+'/results'+queryString;this.props.history.push(nextRoute);}}if(isSearching&&prevProps.clientId!==clientId){// Catalog options are dependent on clients, we need to invalidate this search if the catalog param is used
// this behavior might be confusing to users we should either always invalidate or display a notification
if(search.indexOf(__WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__["c" /* catalog */].name)>0){this.setState(function(prevState){return{value:prevState.value.remove(__WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__["c" /* catalog */].name)};},this.props.history.replace(this.props.match.url));}else{this.submit();}}if(prevProps.clientId!==clientId){this.codeOptions=getCodeOptions(this.props.observationByCode);this.setState(function(prevState){return{value:prevState.value.remove(__WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__["c" /* catalog */].name).remove(__WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__["g" /* codesIncluded */].name).remove(__WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__["f" /* codesExcluded */].name)};});}}},{key:'getCodesFieldConfigOverrides',value:function getCodesFieldConfigOverrides(){var _ref;var value=this.state.value;var codesIncludedName=__WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__["g" /* codesIncluded */].name;var codesExcludedName=__WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__["f" /* codesExcluded */].name;var codesIncludedOptions=getAvailableOptions(this.codeOptions,value.get(codesExcludedName));var codesExcludedOptions=getAvailableOptions(this.codeOptions,value.get(codesIncludedName));return _ref={},_defineProperty(_ref,codesIncludedName,{options:codesIncludedOptions,placeholder:codesIncludedOptions.length===this.codeOptions.length?'Any Code':''}),_defineProperty(_ref,codesExcludedName,{options:codesExcludedOptions}),_ref;}},{key:'getStatusFieldConfigOverrides',value:function getStatusFieldConfigOverrides(){var _ref2;var value=this.state.value;var statusIncludedName=__WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__["D" /* statusIncluded */].name;var statusExcludedName=__WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__["C" /* statusExcluded */].name;var includedOptions=getAvailableOptions(this.statusOptions,value.get(statusExcludedName));var excludedOptions=getAvailableOptions(this.statusOptions,value.get(statusIncludedName));return _ref2={},_defineProperty(_ref2,statusIncludedName,{options:includedOptions,placeholder:includedOptions.length===this.statusOptions.length?'Any Code':''}),_defineProperty(_ref2,statusExcludedName,{options:excludedOptions}),_ref2;}},{key:'getCatalogFieldConfigOverrides',value:function getCatalogFieldConfigOverrides(catalogs){var options=catalogs instanceof __WEBPACK_IMPORTED_MODULE_1_immutable__["List"]?catalogs.map(function(item){return{value:item.catalog_id,label:item.name+(item.locale?' - '+item.locale:'')};}).toArray():[];return _defineProperty({},__WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__["c" /* catalog */].name,{options:options.length===1?[]:options,placeholder:options.length===1?[options[0].label]:__WEBPACK_IMPORTED_MODULE_7__SearchForm_config_fields_config__["c" /* catalog */].placeholder});}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,match=_props3.match,label=_props3.label,primaryFieldsets=_props3.primaryFieldsets,extraFieldsets=_props3.extraFieldsets,clientId=_props3.clientId,_props3$copy=_props3.copy,copy=_props3$copy===undefined?null:_props3$copy,_props3$CardComponent=_props3.CardComponent,CardComponent=_props3$CardComponent===undefined?__WEBPACK_IMPORTED_MODULE_12_containers_ClientCard__["a" /* default */]:_props3$CardComponent,catalogs=_props3.catalogs;var fieldConfigOverrides=Object.assign({},this.getCodesFieldConfigOverrides(),this.getStatusFieldConfigOverrides(),this.getCatalogFieldConfigOverrides(catalogs));var isUsingNewSearch=window.location.href.includes('-search');var method=isUsingNewSearch?__WEBPACK_IMPORTED_MODULE_10_api_content_search__["c" /* ugcSearch */]:__WEBPACK_IMPORTED_MODULE_10_api_content_search__["a" /* nativeSearch */];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mv4','data-translate':true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{exact:true,path:match.url,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,copy,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__SearchForm__["i" /* default */],{primaryFieldsets:primaryFieldsets,extraFieldsets:extraFieldsets,value:_this2.state.value,onSubmit:_this2.handleSubmitClick,onReset:_this2.handleReset,onChange:_this2.handleChange,fieldConfigOverrides:fieldConfigOverrides,expanded:_this2.state.expanded,onExpand:_this2.toggleExtraFields,isUsingNewSearch:isUsingNewSearch}));}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{exact:true,path:match.url+'/results',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__SearchCollection__["a" /* default */],{label:label,clientId:clientId,method:_this2.props.method||method,CardComponent:CardComponent,locationSearch:props.location.search,onLocationSearchChange:_this2.handleLocationSearchChange});}})));}}]);return SearchView;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);var mapStateToProps=function mapStateToProps(state,_ref4){var clientId=_ref4.clientId;var appConfig=state.appConfig;var _isSearching=Object(__WEBPACK_IMPORTED_MODULE_15__searchReducer__["b" /* isSearching */])(state.search);var observationByCode=getObservationsFilteredByClient(clientId,appConfig);return{observationByCode:observationByCode,query:_isSearching?state.search.queries.get(1)||{}:{},isSearching:_isSearching};};var mapDispatchToProps={submitSearch:__WEBPACK_IMPORTED_MODULE_16__searchActions__["e" /* submitSearch */]};var ConnectedSearchView=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SearchView);/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_containers_client_ClientProvider__["a" /* ClientContext */].Consumer,null,function(_ref5){var clientId=_ref5.clientId,catalogs=_ref5.catalogs;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ConnectedSearchView,Object.assign({clientId:clientId,catalogs:catalogs},props));});});function getAvailableOptions(available,restricted){if(!Array.isArray(restricted)){return available;}var restrictedSet=new __WEBPACK_IMPORTED_MODULE_1_immutable__["Set"](restricted.map(function(option){return option.value;}));return available.filter(function(_ref6){var value=_ref6.value;return!restrictedSet.has(value);});}//
function queryHacks(q){// change star_rating to between_star_rating
return q.replace(/&star_rating(?==)/,'&between_star_rating');}function createStateFromSearch(helper,search){// get value and eventually show results
var deserializedValue=helper.deserializeFromURI(queryHacks(search));var value=helper.bootstrapValues(deserializedValue);return{value:value,expanded:true};}function createDefaultState(helper){var today=new Date();var value=helper.bootstrapValues(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({start_date:__WEBPACK_IMPORTED_MODULE_8_date_fns_sub_weeks___default()(today,1),end_date:today}));return{value:value,expanded:false};}function mapObservationToOption(ob){return{value:ob.observation_type_code,label:ob.observation_type_code===__WEBPACK_IMPORTED_MODULE_9_models__["e" /* Observation */].PowerModerationCode?'PowerReviews Moderated':ob.name};}function getCodeOptions(observationByCodeMap){return observationByCodeMap.filter(function(ob){return ob.observation_type_code!==__WEBPACK_IMPORTED_MODULE_9_models__["e" /* Observation */].SecondOpinionCode;}).map(mapObservationToOption).toArray();}function getObservationsFilteredByClient(clientId,_ref7){var observationsMap=_ref7.observationsMap,observationCodeByClientIdMap=_ref7.observationCodeByClientIdMap;var clientIdAsString=clientId.toString();var standardObservationCodes=observationCodeByClientIdMap.get('global',[]);var customObservationCodesByClient=observationCodeByClientIdMap.get(clientIdAsString,[]);var availableObservationCodes=[].concat(_toConsumableArray(standardObservationCodes),_toConsumableArray(customObservationCodesByClient));return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])().withMutations(function(map){availableObservationCodes.forEach(function(code){var observation=observationsMap.get(code);if(observation){map.set(code,observation);}});});}

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchForm_scss__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchForm_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SearchForm_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Field__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Fieldset__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_fields_config__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var Button=function Button(props){var _className=props.className,_props$disabled=props.disabled,disabled=_props$disabled===undefined?undefined:_props$disabled,rest=_objectWithoutProperties(props,['className','disabled']);var className=__WEBPACK_IMPORTED_MODULE_6_classnames___default()('ba b--black-025 mid-gray bg-moon-gray br1 brandon button-reset input-reset f4 lh-title ph3 pv2',{'o-50 not-allowed':disabled===true,'dim pointer':disabled!==true},_className);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',Object.assign({},rest,{disabled:disabled,className:className}));};var renderFields=function renderFields(valueMap,fields,onChange){var fieldOverride=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};return fields.map(function(props){var value=valueMap.get(props.name);var overrideProps=fieldOverride[props.name]||{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Field__["a" /* default */],Object.assign({key:props.name},props,overrideProps,{value:value,onChange:onChange}));});};var SearchForm=function(_React$PureComponent){_inherits(SearchForm,_React$PureComponent);function SearchForm(props){_classCallCheck(this,SearchForm);var _this=_possibleConstructorReturn(this,(SearchForm.__proto__||Object.getPrototypeOf(SearchForm)).call(this,props));_this.toggleExtraOptions=function(){_this.props.onExpand();};_this.updateValues=function(_ref){var name=_ref.name,fieldValue=_ref.value;var currentValue=_this.props.value;var nextValue=fieldValue!=null?currentValue.set(name,fieldValue):currentValue.remove(name);_this.props.onChange(nextValue);};_this.handleSubmit=function(e){e.preventDefault();_this.props.onSubmit(_this.props.value);};_this.handleReset=function(){_this.props.onReset();};_this.state={showExtraOptions:false};return _this;}_createClass(SearchForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,extraFieldsets=_props.extraFieldsets,value=_props.value,showExtraOptions=_props.expanded,isUsingNewSearch=_props.isUsingNewSearch;var startDateValue=value.get(__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["B" /* startDate */].name,__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["B" /* startDate */].defaultValue);var endDateValue=value.get(__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["k" /* endDate */].name,__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["k" /* endDate */].defaultValue);var sortByValue=value.get(__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["A" /* sortBy */].name,__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["A" /* sortBy */].defaultValue);var catalogValue=value.get(__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["c" /* catalog */].name,__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["c" /* catalog */].defaultValue);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('form',{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__SearchForm_scss__["searchFormBody"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',{className:__WEBPACK_IMPORTED_MODULE_1__SearchForm_scss__["searchDateSortOptions"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__SearchForm_scss__["searchField"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('label',{htmlFor:''},'Date Range'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex flex-row justify-between',style:{margin:'-0.5em 0'}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Field__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["B" /* startDate */],{className:__WEBPACK_IMPORTED_MODULE_1__SearchForm_scss__["searchDateSortOptionsDateInput"],value:startDateValue,onChange:this.updateValues})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i',{className:'fa fa-long-arrow-right self-center','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Field__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["k" /* endDate */],{className:__WEBPACK_IMPORTED_MODULE_1__SearchForm_scss__["searchDateSortOptionsDateInput"],value:endDateValue,onChange:this.updateValues})))),isUsingNewSearch?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Field__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["c" /* catalog */],{value:catalogValue,onChange:this.updateValues})):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Field__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_4__config_fields_config__["A" /* sortBy */],{value:sortByValue,onChange:this.updateValues}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__SearchForm_scss__["searchOptionsContainer"]},this.props.primaryFieldsets.map(function(_ref2,index){var legend=_ref2.legend,Icon=_ref2.Icon,fields=_ref2.fields;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Fieldset__["a" /* default */],{key:index,legend:legend,Icon:Icon},renderFields(_this2.props.value,fields,_this2.updateValues,_this2.props.fieldConfigOverrides));}),Array.isArray(extraFieldsets)&&extraFieldsets.length?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'SearchForm--extra-fieldsets'},showExtraOptions===true&&extraFieldsets.map(function(_ref3,index){var legend=_ref3.legend,fields=_ref3.fields,Icon=_ref3.Icon;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Fieldset__["a" /* default */],{key:index,legend:legend,Icon:Icon},renderFields(_this2.props.value,fields,_this2.updateValues,_this2.props.fieldConfigOverrides));}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{type:'button',onClick:this.toggleExtraOptions,className:__WEBPACK_IMPORTED_MODULE_1__SearchForm_scss__["searchExtraOptionsToggle"]},showExtraOptions?'Hide Options':'More Options')):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('br',null))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{type:'submit',className:'Search__submitButton bg-blue white mt3 mr2'},'Search'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{type:'reset',className:'Search__resetButton mt3',onClick:this.handleReset},'Clear'));}}]);return SearchForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (SearchForm);

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field":"field","Search__DateSortOptions":"Search__DateSortOptions","searchDateSortOptions":"Search__DateSortOptions","Search__DateSortOptions__date-input":"Search__DateSortOptions__date-input","searchDateSortOptionsDateInput":"Search__DateSortOptions__date-input","Field__input":"Field__input","fieldInput":"Field__input","Search__QuickSearch":"Search__QuickSearch","searchQuickSearch":"Search__QuickSearch","Search__QuickSearch__label":"Search__QuickSearch__label","searchQuickSearchLabel":"Search__QuickSearch__label","Search__QuickSearch__button":"Search__QuickSearch__button","searchQuickSearchButton":"Search__QuickSearch__button","c-button--active":"c-button--active","cButtonActive":"c-button--active","Search__form-body":"Search__form-body","searchFormBody":"Search__form-body","Search__optionsContainer":"Search__optionsContainer","searchOptionsContainer":"Search__optionsContainer","Search__extra-options-toggle":"Search__extra-options-toggle","searchExtraOptionsToggle":"Search__extra-options-toggle","Search__Fieldset":"Search__Fieldset","searchFieldset":"Search__Fieldset","Search__Fieldset__fields-container":"Search__Fieldset__fields-container","searchFieldsetFieldsContainer":"Search__Fieldset__fields-container","Search__Field":"Search__Field","searchField":"Search__Field"};

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Field_scss__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Field_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Field_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RatingRange__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fieldUtils__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DatePicker__ = __webpack_require__(592);
var Field=function Field(props){var name=props.name,label=props.label,type=props.type,rawValue=props.value,_props$placeholder=props.placeholder,placeholder=_props$placeholder===undefined?'':_props$placeholder,onChange=props.onChange,_props$className=props.className,className=_props$className===undefined?'':_props$className,_props$attributes=props.attributes,attributes=_props$attributes===undefined?{}:_props$attributes,style=props.style;var input=void 0;var value=Object(__WEBPACK_IMPORTED_MODULE_4__fieldUtils__["b" /* fieldDefault */])(type,rawValue);if(type==='hidden'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{type:type,name:name,value:props.defaultValue});}if(!input&&(type==='select'||type==='multiselect')&&props.options!=null){var options=props.options;input=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["q" /* Select */],{options:options,name:name// id={name}
,instanceId:name,inputProps:{'data-id':name,id:name},value:value,multi:type==='multiselect',clearable:true,disabled:options.length===0,placeholder:placeholder,onChange:function(_onChange){function onChange(_x){return _onChange.apply(this,arguments);}onChange.toString=function(){return _onChange.toString();};return onChange;}(function(value){return onChange({name:name,value:value});})});}if(!input&&type==='RatingRange'&&Array.isArray(value)){input=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__RatingRange__["a" /* default */],{name:name,value:value,onChange:function(_onChange2){function onChange(_x2){return _onChange2.apply(this,arguments);}onChange.toString=function(){return _onChange2.toString();};return onChange;}(function(value){return onChange({name:name,value:value});})});}if(!input&&type==='date'){input=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__DatePicker__["a" /* default */],Object.assign({name:name// $$FlowFixMe
,value:value,onChange:function(_onChange3){function onChange(_x3){return _onChange3.apply(this,arguments);}onChange.toString=function(){return _onChange3.toString();};return onChange;}(function(value){return onChange({name:name,value:value});})//className={`${styles.fieldInput} ${className}`}
},attributes));}if(!input){input=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',Object.assign({type:type,name:name,value:value,className:__WEBPACK_IMPORTED_MODULE_2__Field_scss___default.a.fieldInput+' '+className,onChange:function(_onChange4){function onChange(_x4){return _onChange4.apply(this,arguments);}onChange.toString=function(){return _onChange4.toString();};return onChange;}(function(_ref){var value=_ref.currentTarget.value;return onChange({name:name,value:value});})},attributes));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_2__Field_scss___default.a.field,style:style},label&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('label',{htmlFor:name,className:__WEBPACK_IMPORTED_MODULE_2__Field_scss___default.a.fieldLabel},label),label==='Catalog'?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{'data-translate':false},input):input);};/* harmony default export */ __webpack_exports__["a"] = (Field);

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field":"Field","Field":"Field","Field__label":"Field__label","fieldLabel":"Field__label","Field__input":"Field__input","fieldInput":"Field__input"};

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RatingRange_scss__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RatingRange_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__RatingRange_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_range__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MIN_RATING=1;var MAX_RATING=5;var STEP=1;var RatingRange=function(_React$PureComponent){_inherits(RatingRange,_React$PureComponent);function RatingRange(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RatingRange);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RatingRange.__proto__||Object.getPrototypeOf(RatingRange)).call.apply(_ref,[this].concat(args))),_this),_this.handleStartChange=function(e){var newStart=Number(e.currentTarget.value);var currentEnd=_this.props.value[1];var newEnd=newStart>currentEnd?newStart:currentEnd;_this.props.onChange([newStart,newEnd]);},_this.handleEndChange=function(e){var newEnd=Number(e.currentTarget.value);var currentStart=_this.props.value[0];var newStart=currentStart>newEnd?newEnd:currentStart;_this.props.onChange([newStart,newEnd]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RatingRange,[{key:'render',value:function render(){var _props=this.props,name=_props.name,_props$value=_slicedToArray(_props.value,2),startValue=_props$value[0],endValue=_props$value[1];var startRange=__WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(MIN_RATING,Math.min(MAX_RATING,endValue)+STEP,STEP);var endRange=__WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(startValue,MAX_RATING+STEP,STEP);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__RatingRange_scss___default.a.ratingRange},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('select',{name:name+'_start',className:__WEBPACK_IMPORTED_MODULE_1__RatingRange_scss___default.a.ratingRangeInput,value:startValue,onChange:this.handleStartChange},startRange.map(function(v){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('option',{key:v,value:v},v);})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_1__RatingRange_scss___default.a.ratingRangeText},' to '),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('select',{name:name+'_end',className:__WEBPACK_IMPORTED_MODULE_1__RatingRange_scss___default.a.ratingRangeInput,value:endValue,onChange:this.handleEndChange},endRange.map(function(v){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('option',{key:v,value:v},v);})));}}]);return RatingRange;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);RatingRange.defaultProps={name:'RatingRange',value:[MIN_RATING,MAX_RATING]};/* harmony default export */ __webpack_exports__["a"] = (RatingRange);

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field":"field","RatingRange":"RatingRange","ratingRange":"RatingRange","RatingRange__text":"RatingRange__text","ratingRangeText":"RatingRange__text","RatingRange__input":"RatingRange__input","ratingRangeInput":"RatingRange__input"};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(587);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(588),
    isIterateeCall = __webpack_require__(230),
    toFinite = __webpack_require__(235);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 588 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(590),
    isObject = __webpack_require__(93),
    isSymbol = __webpack_require__(182);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(591);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 591 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_get_days_in_month__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_get_days_in_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_get_days_in_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_get_day__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_get_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_get_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_set_date__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_set_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_set_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_get_date__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_get_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_get_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_start_of_month__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_start_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_start_of_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_add_months__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_add_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_add_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_months__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_sub_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_sub_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_days__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_is_same_day__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_is_same_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_is_same_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_add_years__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_add_years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_add_years__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_sub_years__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_sub_years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_sub_years__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_click_outside__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Days=['Su','Mo','Tu','We','Th','Fr','Sa'];// type DateValue = string | Date;
var DatePicker=function(_React$PureComponent){_inherits(DatePicker,_React$PureComponent);function DatePicker(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DatePicker);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DatePicker.__proto__||Object.getPrototypeOf(DatePicker)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:false,dateInView:_this.props.value||new Date()},_this.open=function(){_this.setState({isOpen:true});},_this.close=function(){_this.setState({isOpen:false});},_this.setDate=function(d){_this.setState({dateInView:d});if(typeof _this.props.onChange==='function'){_this.props.onChange(d);}},_this.handleDayClick=function(e){var day=Number(e.currentTarget.textContent);_this.setDate(__WEBPACK_IMPORTED_MODULE_3_date_fns_set_date___default()(_this.state.dateInView,day));e.preventDefault();},_this.addYears=function(){return _this.setState(function(prevState){return{dateInView:__WEBPACK_IMPORTED_MODULE_11_date_fns_add_years___default()(prevState.dateInView,1)};});},_this.subYears=function(){return _this.setState(function(prevState){return{dateInView:__WEBPACK_IMPORTED_MODULE_12_date_fns_sub_years___default()(prevState.dateInView,1)};});},_this.addMonths=function(){return _this.setState(function(prevState){return{dateInView:__WEBPACK_IMPORTED_MODULE_6_date_fns_add_months___default()(prevState.dateInView,1)};});},_this.subMonths=function(){return _this.setState(function(prevState){return{dateInView:__WEBPACK_IMPORTED_MODULE_7_date_fns_sub_months___default()(prevState.dateInView,1)};});},_this.resetRange=function(){_this.setDate(new Date());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DatePicker,[{key:'getButtonClassName',value:function getButtonClassName(isToday,isActive){return __WEBPACK_IMPORTED_MODULE_14_classnames___default()('lh-solid tc ma0 w-100 br-pill b--none bg-white pointer link pa2 bg-animate',{'b bg-gold br-pill':isToday===true,'bg-blue white':isActive===true,'hover-bg-silver hover-white':isActive===false});}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){// update DateInView if nece
if(nextProps.value&&nextProps.value!==this.props.value){this.setState({dateInView:nextProps.value});}}},{key:'renderHeader',value:function renderHeader(){var dateInView=this.state.dateInView;return[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',{key:'years'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:'bb b--moon-gray'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ArrowButton,{onClick:this.subYears,dir:'left'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{colSpan:'5',className:'tc bb b--moon-gray'},__WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(dateInView,'YYYY')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:'bb b--moon-gray'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ArrowButton,{onClick:this.addYears,dir:'right'}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',{key:'months'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:'bb b--moon-gray'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ArrowButton,{onClick:this.subMonths,dir:'left'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{colSpan:'5',className:'tc bb b--moon-gray'},__WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(dateInView,'MMMM')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:'bb b--moon-gray'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ArrowButton,{onClick:this.addMonths,dir:'right'}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',{key:'days'},Days.map(function(d){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('th',{key:d,className:'pa2'},d);}))];}},{key:'render',value:function render(){var _this2=this;var _state=this.state,dateInView=_state.dateInView,isOpen=_state.isOpen;var today=new Date();var value=this.props.value;var data=generateDates(dateInView);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_react_click_outside___default.a,{onClickOutside:this.close,className:'relative DatePicker'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{type:'text',value:this.props.value?__WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(this.props.value,'MM/DD/YYYY'):'',readOnly:true,ref:function ref(_ref2){return _this2.input=_ref2;},onClick:this.open,onFocus:this.open,className:'DatePicker__input'}),isOpen===true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('table',{className:'collapse ba br1 bg-white b--moon-gray shadow-5 z-999 DatePicker__menu',ref:function ref(_ref3){_this2.menu=_ref3;//this.input && this.input.focus();
},style:{position:'absolute',left:0,marginTop:'-1px'}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('thead',null,this.renderHeader()),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tbody',null,data.map(function(r,i){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',{key:'row'+i},r.map(function(r,j){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{key:'cell'+j,className:'pa1'},r?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{onClick:_this2.handleDayClick,role:'option','aria-selected':'true',className:_this2.getButtonClassName(__WEBPACK_IMPORTED_MODULE_10_date_fns_is_same_day___default()(r,today),value!=null?__WEBPACK_IMPORTED_MODULE_10_date_fns_is_same_day___default()(r,value):false)},__WEBPACK_IMPORTED_MODULE_4_date_fns_get_date___default()(r)):' ');}));})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{colSpan:'7',className:'ba b--moon-gray pa0'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{onClick:this.resetRange,type:'button',className:'input-reset button-reset db w-100 pa2 ma0 bg-near-white b--none mid-gray'},'Today'))))));}}]);return DatePicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (DatePicker);function generateDates(dt){var _fdates;var dates=[];var firstDayOfMonth=__WEBPACK_IMPORTED_MODULE_5_date_fns_start_of_month___default()(dt);var daysInMonth=__WEBPACK_IMPORTED_MODULE_1_date_fns_get_days_in_month___default()(dt);var dayOfFirstOfMonth=__WEBPACK_IMPORTED_MODULE_2_date_fns_get_day___default()(firstDayOfMonth);var fdates=Array(daysInMonth).fill(firstDayOfMonth).map(function(_,index){return __WEBPACK_IMPORTED_MODULE_8_date_fns_add_days___default()(_,index);});(_fdates=fdates).unshift.apply(_fdates,_toConsumableArray(Array(dayOfFirstOfMonth).fill(null)));while(fdates.length>0){dates.push(fdates.slice(0,7));fdates=fdates.slice(7);}// fill
var lastRow=dates[dates.length-1];while(lastRow.length<7){lastRow.push(null);}return dates;}function ArrowButton(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{onClick:props.onClick,type:'button',className:'input-reset pointer w-100 b--none bg-white pa2 lh-solid link'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i',{className:'fa fa-chevron-'+props.dir+' silver'}));}

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(138)

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(128)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var addYears = __webpack_require__(239)

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addYears(dirtyDate, -amount)
}

module.exports = subYears


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fieldset_scss__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fieldset_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Fieldset_scss__);
var FieldsetLegend=function FieldsetLegend(_ref){var legend=_ref.legend,Icon=_ref.Icon;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__Fieldset_scss___default.a.fieldsetLegend},Icon&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__Fieldset_scss___default.a.fieldsetLegendIcon},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:__WEBPACK_IMPORTED_MODULE_1__Fieldset_scss___default.a.fieldsetLegendHeading},legend));};var Fieldset=function Fieldset(props){var legend=props.legend,Icon=props.Icon,children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('fieldset',{className:__WEBPACK_IMPORTED_MODULE_1__Fieldset_scss___default.a.fieldset},legend&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FieldsetLegend,{legend:legend,Icon:Icon}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1__Fieldset_scss___default.a.fieldsetContent},children));};Fieldset.Legend=FieldsetLegend;/* harmony default export */ __webpack_exports__["a"] = (Fieldset);

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Fieldset":"Fieldset","fieldset":"Fieldset","Fieldset__legend":"Fieldset__legend","fieldsetLegend":"Fieldset__legend","Fieldset__legend__icon":"Fieldset__legend__icon","fieldsetLegendIcon":"Fieldset__legend__icon","Fieldset__legend__heading":"Fieldset__legend__heading","fieldsetLegendHeading":"Fieldset__legend__heading","Fieldset__content":"Fieldset__content","fieldsetContent":"Fieldset__content"};

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ProductTag=function ProductTag(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({xmlns:'http://www.w3.org/2000/svg',viewBox:'0 123.1 800 585'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#CCC',d:'M746.3 511.3L243.1 648.5c-3.3.9-6.8.3-9.6-1.7L62.7 525.4c-4.5-3.2-6.1-9.2-3.7-14.2l87.1-185.6c1.4-3 4.1-5.3 7.3-6.2l503.1-137.2c6.1-1.7 12.4 1.9 14 8l83.7 307c.8 2.9.4 6-1.1 8.7-1.4 2.7-3.9 4.6-6.8 5.4z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#FFF',d:'M752.7 473.3l-528.1 144L45.3 489.9l91.4-194.8 528.1-144'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('circle',{fill:'#E7E7E7',cx:'161.2',cy:'456.9',r:'30.7'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#808283',d:'M755.9 484.9l-528.1 144c-3.5.9-7.2.3-10.1-1.8L38.4 499.7c-4.7-3.4-6.4-9.6-3.9-14.9L125.9 290c1.5-3.2 4.3-5.6 7.7-6.5l528.1-144c6.4-1.7 13 2 14.7 8.4l87.9 322.2c.8 3.1.4 6.3-1.2 9.1s-4.2 4.8-7.2 5.7zm-529 119.3l511-139.3-81.6-299.1-511.1 139.4-84.7 180.7 166.4 118.3z'}));};/* harmony default export */ __webpack_exports__["a"] = (ProductTag);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var StarsEmpty=function StarsEmpty(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({xmlns:'http://www.w3.org/2000/svg',viewBox:'0 90 300 100'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#CCC',d:'M292.4 142.7c-.7-2.1-2.7-3.6-4.9-3.6h-16.2l-5.1-15.6c-.7-2.1-2.7-3.6-4.9-3.6s-4.2 1.5-4.9 3.6l-4.9 15.6h-16.6c-.5 0-1 .1-1.5.2-.5-.1-1-.2-1.5-.2h-16.2l-5.1-15.6c-.7-2.1-2.7-3.6-4.9-3.6s-4.2 1.5-4.9 3.6l-4.9 15.6h-16.6c-.5 0-1 .1-1.5.2-.5-.1-1-.2-1.5-.2h-16.2l-5.1-15.6c-.7-2.1-2.7-3.6-4.9-3.6s-4.2 1.5-4.9 3.6l-4.9 15.6h-16.6c-.5 0-1 .1-1.5.2-.5-.1-1-.2-1.5-.2h-16.2L99 123.5c-.7-2.1-2.7-3.6-4.9-3.6s-4.2 1.5-4.9 3.6l-4.9 15.6H67.7c-.5 0-1 .1-1.5.2-.5-.1-1-.2-1.5-.2H48.4l-5.1-15.6c-.7-2.1-2.7-3.6-4.9-3.6s-4.2 1.5-4.9 3.6l-4.9 15.6H12c-2.2 0-4.2 1.4-4.9 3.6s.1 4.5 1.9 5.8l13.3 9.7-4.9 15.4c-.7 2.1.1 4.5 1.9 5.8.9.6 2 1 3 1 1.1 0 2.2-.3 3.1-1l13.2-9.7 13 9.7c.9.7 2 1 3.1 1s2.1-.3 3-1c1.8-1.3 2.6-3.6 1.9-5.8l-4.9-15.4 11.7-8.6 11.7 8.6-4.9 15.4c-.7 2.1.1 4.5 1.9 5.8.9.6 2 1 3 1 1.1 0 2.2-.3 3.1-1l13.2-9.7 13 9.7c.9.7 2 1 3.1 1s2.1-.3 3-1c1.8-1.3 2.6-3.6 1.9-5.8l-4.9-15.4 11.7-8.6 11.7 8.6-4.9 15.4c-.7 2.1.1 4.5 1.9 5.8.9.6 2 1 3 1 1.1 0 2.2-.3 3.1-1l13.2-9.7 13 9.7c.9.7 2 1 3.1 1s2.1-.3 3-1c1.8-1.3 2.6-3.6 1.9-5.8l-4.9-15.4 11.7-8.6 11.7 8.6-4.9 15.4c-.7 2.1.1 4.5 1.9 5.8.9.6 2 1 3 1 1.1 0 2.2-.3 3.1-1l13.2-9.7 13 9.7c.9.7 2 1 3.1 1s2.1-.3 3-1c1.8-1.3 2.6-3.6 1.9-5.8l-4.9-15.4 11.7-8.6 11.7 8.6-4.9 15.4c-.7 2.1.1 4.5 1.9 5.8.9.6 2 1 3 1 1.1 0 2.2-.3 3.1-1l13.2-9.7 13 9.7c.9.7 2 1 3.1 1s2.1-.3 3-1c1.8-1.3 2.6-3.6 1.9-5.8l-4.9-15.4 13.3-9.7c1.1-1.3 1.9-3.7 1.2-5.8z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#FFF',d:'M17.1 171.9c-.6 0-1.1-.2-1.6-.5-.9-.7-1.3-1.9-1-3l5.7-17.9-15.3-11.3c-.9-.7-1.3-1.9-1-3s1.4-1.9 2.6-1.9h19.2l5.7-18.1c.4-1.1 1.4-1.9 2.6-1.9 1.2 0 2.2.7 2.6 1.9l5.9 18.1h18.8c1.2 0 2.2.7 2.6 1.9s0 2.3-1 3l-15.3 11.3 5.7 17.9c.4 1.1 0 2.3-1 3-.5.3-1 .5-1.6.5-.6 0-1.1-.2-1.6-.5L34 160.2l-15.3 11.2c-.5.4-1.1.5-1.6.5z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#808283',d:'M34 117.1l6.5 20h20.8l-16.9 12.4 6.3 19.7L34 156.8l-16.9 12.4 6.3-19.7-16.9-12.4h21.2l6.3-20m0-5.4c-2.4 0-4.4 1.5-5.1 3.8l-5.1 16.2H6.5c-2.3 0-4.4 1.5-5.1 3.7s.1 4.6 1.9 6l13.8 10.1-5.1 16.1c-.7 2.2.1 4.6 2 6 .9.7 2 1 3.1 1s2.2-.3 3.2-1L34 163.5l13.5 10c1 .7 2.1 1.1 3.2 1.1s2.2-.3 3.1-1c1.9-1.4 2.7-3.8 2-6l-5.1-16.1 13.8-10.1c1.9-1.4 2.7-3.8 1.9-6-.7-2.2-2.8-3.7-5.1-3.7H44.4l-5.3-16.2c-.7-2.3-2.8-3.8-5.1-3.8z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#FFF',d:'M75 171.9c-.6 0-1.1-.2-1.6-.5-.9-.7-1.3-1.9-1-3l5.7-17.9-15.3-11.3c-.9-.7-1.3-1.9-1-3s1.4-1.9 2.6-1.9h19.2l5.7-18.1c.4-1.1 1.4-1.9 2.6-1.9 1.2 0 2.2.7 2.6 1.9l5.9 18.1h18.8c1.2 0 2.2.7 2.6 1.9s0 2.3-1 3l-15.3 11.3 5.7 17.9c.4 1.1 0 2.3-1 3-.5.3-1 .5-1.6.5-.6 0-1.1-.2-1.6-.5l-15.1-11.2-15.3 11.2c-.5.4-1 .5-1.6.5z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#808283',d:'M91.9 117.1l6.5 20h20.8l-16.9 12.4 6.3 19.7-16.7-12.4L75 169.2l6.3-19.7-16.9-12.4h21.2l6.3-20m0-5.4c-2.4 0-4.4 1.5-5.1 3.8l-5.1 16.2H64.4c-2.3 0-4.4 1.5-5.1 3.7s.1 4.6 1.9 6L75 151.5l-5.1 16.1c-.7 2.2.1 4.6 2 6 .9.7 2 1 3.1 1s2.2-.3 3.2-1l13.7-10.1 13.5 10c1 .7 2.1 1.1 3.2 1.1s2.2-.3 3.1-1c1.9-1.4 2.7-3.8 2-6l-5.1-16.1 13.8-10.1c1.9-1.4 2.7-3.8 1.9-6-.7-2.2-2.8-3.7-5.1-3.7h-16.9L97 115.5c-.7-2.3-2.8-3.8-5.1-3.8z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#FFF',d:'M166.5 171.9c-.6 0-1.1-.2-1.6-.5l-15.1-11.2-15.3 11.2c-.5.3-1 .5-1.6.5-.6 0-1.1-.2-1.6-.5-.9-.7-1.3-1.9-1-3l5.7-17.9-15.3-11.3c-.9-.7-1.3-1.9-1-3s1.4-1.9 2.6-1.9h19.2l5.7-18.1c.4-1.1 1.4-1.9 2.6-1.9 1.2 0 2.2.7 2.6 1.9l5.9 18.1h18.8c1.2 0 2.2.7 2.6 1.9s0 2.3-1 3l-15.3 11.3 5.7 17.9c.4 1.1 0 2.3-1 3-.5.4-1 .5-1.6.5z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#808283',d:'M149.8 117.1l6.5 20h20.8l-16.9 12.4 6.3 19.7-16.7-12.4-16.9 12.4 6.3-19.7-16.9-12.4h21.2l6.3-20m0-5.4c-2.4 0-4.4 1.5-5.1 3.8l-5.1 16.2h-17.2c-2.3 0-4.4 1.5-5.1 3.7-.7 2.2.1 4.6 1.9 6l13.8 10.1-5.1 16.1c-.7 2.2.1 4.6 2 6 .9.7 2 1 3.1 1s2.2-.3 3.2-1l13.7-10.1 13.5 10c1 .7 2.1 1.1 3.2 1.1s2.2-.3 3.1-1c1.9-1.4 2.7-3.8 2-6l-5.1-16.1 13.8-10.1c1.9-1.4 2.7-3.8 1.9-6-.7-2.2-2.8-3.7-5.1-3.7h-16.9l-5.3-16.2c-.8-2.3-2.9-3.8-5.2-3.8z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#FFF',d:'M224.4 171.9c-.6 0-1.1-.2-1.6-.5l-15.1-11.2-15.3 11.2c-.5.3-1 .5-1.6.5-.6 0-1.1-.2-1.6-.5-.9-.7-1.3-1.9-1-3l5.7-17.9-15.3-11.3c-.9-.7-1.3-1.9-1-3s1.4-1.9 2.6-1.9h19.2l5.7-18.1c.4-1.1 1.4-1.9 2.6-1.9 1.2 0 2.2.7 2.6 1.9l5.9 18.1H235c1.2 0 2.2.7 2.6 1.9s0 2.3-1 3l-15.3 11.3 5.7 17.9c.4 1.1 0 2.3-1 3-.5.4-1 .5-1.6.5z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#808283',d:'M207.7 117.1l6.5 20H235l-16.9 12.4 6.3 19.7-16.7-12.4-16.9 12.4 6.3-19.7-16.9-12.4h21.2l6.3-20m0-5.4c-2.4 0-4.4 1.5-5.1 3.8l-5.1 16.2h-17.2c-2.3 0-4.4 1.5-5.1 3.7-.7 2.2.1 4.6 1.9 6l13.8 10.1-5.1 16.1c-.7 2.2.1 4.6 2 6 .9.7 2 1 3.1 1s2.2-.3 3.2-1l13.7-10.1 13.5 10c1 .7 2.1 1.1 3.2 1.1s2.2-.3 3.1-1c1.9-1.4 2.7-3.8 2-6l-5.1-16.1 13.8-10.1c1.9-1.4 2.7-3.8 1.9-6-.7-2.2-2.8-3.7-5.1-3.7h-16.9l-5.3-16.2c-.8-2.3-2.8-3.8-5.2-3.8z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#FFF',d:'M282.4 171.9c-.6 0-1.1-.2-1.6-.5l-15.1-11.2-15.3 11.2c-.5.3-1 .5-1.6.5-.6 0-1.1-.2-1.6-.5-.9-.7-1.3-1.9-1-3l5.7-17.9-15.3-11.3c-.9-.7-1.3-1.9-1-3s1.4-1.9 2.6-1.9h19.2l5.7-18.1c.4-1.1 1.4-1.9 2.6-1.9 1.2 0 2.2.7 2.6 1.9l5.9 18.1H293c1.2 0 2.2.7 2.6 1.9s0 2.3-1 3l-15.3 11.3 5.7 17.9c.4 1.1 0 2.3-1 3-.5.4-1.1.5-1.6.5z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#808283',d:'M265.7 117.1l6.5 20H293l-17 12.4 6.3 19.7-16.7-12.4-16.9 12.4 6.3-19.7-16.9-12.4h21.2l6.4-20m0-5.4s-.1 0 0 0c-2.4 0-4.4 1.5-5.1 3.8l-5.1 16.2h-17.2c-2.3 0-4.4 1.5-5.1 3.7s.1 4.6 1.9 6l13.8 10.1-5.1 16.1c-.7 2.2.1 4.6 2 6 .9.7 2 1 3.1 1s2.2-.3 3.2-1l13.7-10.1 13.5 10c1 .7 2.1 1.1 3.2 1.1s2.2-.3 3.1-1c1.9-1.4 2.7-3.8 2-6l-5.1-16.1 13.8-10.1c1.9-1.4 2.7-3.8 1.9-6-.7-2.2-2.8-3.7-5.1-3.7h-16.9l-5.3-16.2c-.8-2.3-2.9-3.8-5.2-3.8z'}));};/* harmony default export */ __webpack_exports__["a"] = (StarsEmpty);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var MediaPlaceholder=function MediaPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({xmlns:'http://www.w3.org/2000/svg',viewBox:'0 100 800 685'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#CCC',d:'M45.9 695.5c-4.3 0-8-3.5-8-8v-482c0-4.3 3.5-8 8-8h708.5c4.3 0 8 3.5 8 8v481.8c0 4.3-3.5 8-8 8H45.9v.2z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#CCC',d:'M752.3 207.7v477.9H47.7V207.7h704.6m1.8-20H45.9c-9.8 0-17.9 8-17.9 17.9v481.8c0 9.8 8 17.9 17.9 17.9h708.5c9.8 0 17.9-8 17.9-17.9V205.6c-.3-9.8-8.2-17.9-18.2-17.9z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#FFF',d:'M8.5 680c-4.8 0-8.5-3.8-8.5-8.5V147.1c0-4.8 3.8-8.5 8.5-8.5h761.6c4.8 0 8.5 3.8 8.5 8.5v524.3c0 4.8-3.8 8.5-8.5 8.5H8.5v.1z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#808283',d:'M778.7 146.6v520H21.3v-520h757.4m2.1-21.3H19.2C8.5 125.3 0 133.8 0 144.5v524.3C0 679.5 8.5 688 19.2 688h761.6c10.7 0 19.2-8.5 19.2-19.2V144.5c0-10.7-8.5-19.2-19.2-19.2z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{fill:'#E7E7E7',d:'M48.1 445.6v192h700.5v-72l-285-250.5-208.5 195'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('circle',{fill:'#E7E7E7',cx:'210.1',cy:'289.6',r:'54.7'}));};/* harmony default export */ __webpack_exports__["a"] = (MediaPlaceholder);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Question; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Answer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var CircleIcon=function CircleIcon(props){var letter=props.letter,rest=_objectWithoutProperties(props,['letter']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({viewBox:'0 0 100 100'},rest),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('circle',{cx:'50%',cy:'50%',r:'40',stroke:'#808283',strokeWidth:'6',fill:'none'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('text',{x:'50%',y:'50%',textAnchor:'middle',fill:'#C0C0C0',dy:'.3em',fontSize:'50',strokeWidth:'4'},letter));};var Question=function Question(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CircleIcon,Object.assign({letter:'Q'},props));};var Answer=function Answer(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CircleIcon,Object.assign({letter:'A'},props));};

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fieldUtils__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_fields_config__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_is_date__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_is_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_is_date__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var TEXT_TYPE={type:'text'};var CONSTANT_FIELDS=[__WEBPACK_IMPORTED_MODULE_2__config_fields_config__["A" /* sortBy */],__WEBPACK_IMPORTED_MODULE_2__config_fields_config__["B" /* startDate */],__WEBPACK_IMPORTED_MODULE_2__config_fields_config__["k" /* endDate */],__WEBPACK_IMPORTED_MODULE_2__config_fields_config__["e" /* clientId */]];var addField=function addField(map,field){var primary=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return map.set(field.name,{type:field.type,primary:primary,defaultValue:field.defaultValue});};var SearchFormHelper=function(){_createClass(SearchFormHelper,null,[{key:'createFieldMap',value:function createFieldMap(primaryFieldsets,extraFieldsets){return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])().withMutations(function(map){primaryFieldsets.forEach(function(fieldset){fieldset.fields.forEach(function(f){return addField(map,f,true);});});CONSTANT_FIELDS.forEach(function(field){return addField(map,field,true);});if(Array.isArray(extraFieldsets)){extraFieldsets.forEach(function(fieldset){return fieldset.fields.forEach(function(f){return addField(map,f);});});}});}},{key:'bootstrapValues',value:function bootstrapValues(infoMap,defaultValue){return defaultValue.withMutations(function(mp){// for each field set defaultValue if unset
infoMap.forEach(function(fieldInfo,name){var type=fieldInfo.type;var _fieldInfo$defaultVal=fieldInfo.defaultValue,defaultValue=_fieldInfo$defaultVal===undefined?Object(__WEBPACK_IMPORTED_MODULE_1__fieldUtils__["c" /* getFieldEmptyValue */])(type):_fieldInfo$defaultVal;if(!mp.has(name)){mp.set(name,defaultValue);}});});}},{key:'sanitize',value:function sanitize(infoMap,current,next){// date range
// if start_date chan
var currentStartDate=current.get(__WEBPACK_IMPORTED_MODULE_2__config_fields_config__["B" /* startDate */].name);var nextStartDate=next.get(__WEBPACK_IMPORTED_MODULE_2__config_fields_config__["B" /* startDate */].name);var currentEndDate=current.get(__WEBPACK_IMPORTED_MODULE_2__config_fields_config__["k" /* endDate */].name);var nextEndDate=next.get(__WEBPACK_IMPORTED_MODULE_2__config_fields_config__["k" /* endDate */].name);var result=next;if(__WEBPACK_IMPORTED_MODULE_3_date_fns_is_date___default()(currentStartDate)&&__WEBPACK_IMPORTED_MODULE_3_date_fns_is_date___default()(nextStartDate)&&currentStartDate.getTime()!==nextStartDate.getTime()){if(__WEBPACK_IMPORTED_MODULE_3_date_fns_is_date___default()(nextEndDate)&&nextStartDate.getTime()>nextEndDate.getTime()){result=result.set(__WEBPACK_IMPORTED_MODULE_2__config_fields_config__["k" /* endDate */].name,nextStartDate);}}// if endDate is changes
if(__WEBPACK_IMPORTED_MODULE_3_date_fns_is_date___default()(currentEndDate)&&__WEBPACK_IMPORTED_MODULE_3_date_fns_is_date___default()(nextEndDate)&&currentEndDate.getTime()!==nextEndDate.getTime()){// endDate should not be less than startDate
if(__WEBPACK_IMPORTED_MODULE_3_date_fns_is_date___default()(nextStartDate)&&nextStartDate.getTime()>nextEndDate.getTime()){result=result.set(__WEBPACK_IMPORTED_MODULE_2__config_fields_config__["B" /* startDate */].name,nextEndDate);}}return result;}},{key:'clearHiddenFields',value:function clearHiddenFields(infoMap,val){var extras=infoMap.reduce(function(reduction,value,name){var _infoMap$get=infoMap.get(name,TEXT_TYPE),_infoMap$get$primary=_infoMap$get.primary,primary=_infoMap$get$primary===undefined?false:_infoMap$get$primary;if(primary===false){reduction.push(name);}return reduction;},[]);return val.withMutations(function(map){extras.forEach(function(name){return map.remove(name);});});}},{key:'serializeToObject',value:function serializeToObject(infoMap,value){return value.reduce(function(reduction,value,name){var _infoMap$get2=infoMap.get(name,TEXT_TYPE),fieldType=_infoMap$get2.type;if(value!=null&&!Object(__WEBPACK_IMPORTED_MODULE_1__fieldUtils__["d" /* isFieldEmpty */])(fieldType,value)){var serializedValue=Object(__WEBPACK_IMPORTED_MODULE_1__fieldUtils__["e" /* serializeField */])(fieldType,value);if(serializedValue){reduction[name]=serializedValue;}}return reduction;},{});}},{key:'convertObjectToURI',value:function convertObjectToURI(obj){return Object.keys(obj).reduce(function(acc,name){acc.push(name+'='+encodeURIComponent(obj[name]));return acc;},[]).join('&');}},{key:'serializeToURI',value:function serializeToURI(infoMap,value){return value.reduce(function(reduction,value,name){var _infoMap$get3=infoMap.get(name,TEXT_TYPE),fieldType=_infoMap$get3.type;var isEmpty=Object(__WEBPACK_IMPORTED_MODULE_1__fieldUtils__["d" /* isFieldEmpty */])(fieldType,value);if(!isEmpty){var serializedValue=Object(__WEBPACK_IMPORTED_MODULE_1__fieldUtils__["e" /* serializeField */])(fieldType,value);if(serializedValue){reduction.push(name+'='+encodeURIComponent(String(serializedValue)));}}return reduction;},[]).join('&');}},{key:'deserializeFromURI',value:function deserializeFromURI(infoMap,value){var entries=value.replace(/^\?/g,'').split('&').reduce(function(acc,pair){var _pair$split=pair.split('='),_pair$split2=_slicedToArray(_pair$split,2),name=_pair$split2[0],rawValue=_pair$split2[1];if(name&&value){var _infoMap$get4=infoMap.get(name,TEXT_TYPE),fieldType=_infoMap$get4.type;var decodedValue=decodeURIComponent(rawValue);// if deserialization fails lets fallback to the value decodedValue
// this is useful for fields that are not included the field map eg client_id
var _value=Object(__WEBPACK_IMPORTED_MODULE_1__fieldUtils__["a" /* deserializeField */])(fieldType,decodedValue)||decodedValue;var notEmpty=!Object(__WEBPACK_IMPORTED_MODULE_1__fieldUtils__["d" /* isFieldEmpty */])(fieldType,_value);notEmpty&&acc.push([name,_value]);}return acc;},[]);return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(entries);}}]);function SearchFormHelper(primaryFieldsets,extraFieldsets){_classCallCheck(this,SearchFormHelper);this.fieldMap=SearchFormHelper.createFieldMap(primaryFieldsets,extraFieldsets);}_createClass(SearchFormHelper,[{key:'bootstrapValues',value:function bootstrapValues(){for(var _len=arguments.length,rest=Array(_len),_key=0;_key<_len;_key++){rest[_key]=arguments[_key];}return SearchFormHelper.bootstrapValues.apply(SearchFormHelper,[this.fieldMap].concat(_toConsumableArray(rest)));}},{key:'sanitize',value:function sanitize(){for(var _len2=arguments.length,rest=Array(_len2),_key2=0;_key2<_len2;_key2++){rest[_key2]=arguments[_key2];}return SearchFormHelper.sanitize.apply(SearchFormHelper,[this.fieldMap].concat(_toConsumableArray(rest)));}},{key:'clearHiddenFields',value:function clearHiddenFields(){for(var _len3=arguments.length,rest=Array(_len3),_key3=0;_key3<_len3;_key3++){rest[_key3]=arguments[_key3];}return SearchFormHelper.clearHiddenFields.apply(SearchFormHelper,[this.fieldMap].concat(_toConsumableArray(rest)));}},{key:'serializeToObject',value:function serializeToObject(){for(var _len4=arguments.length,rest=Array(_len4),_key4=0;_key4<_len4;_key4++){rest[_key4]=arguments[_key4];}return SearchFormHelper.serializeToObject.apply(SearchFormHelper,[this.fieldMap].concat(_toConsumableArray(rest)));}},{key:'serializeToURI',value:function serializeToURI(){for(var _len5=arguments.length,rest=Array(_len5),_key5=0;_key5<_len5;_key5++){rest[_key5]=arguments[_key5];}return SearchFormHelper.serializeToURI.apply(SearchFormHelper,[this.fieldMap].concat(_toConsumableArray(rest)));}},{key:'deserializeFromURI',value:function deserializeFromURI(){for(var _len6=arguments.length,rest=Array(_len6),_key6=0;_key6<_len6;_key6++){rest[_key6]=arguments[_key6];}return SearchFormHelper.deserializeFromURI.apply(SearchFormHelper,[this.fieldMap].concat(_toConsumableArray(rest)));}}]);return SearchFormHelper;}();/* harmony default export */ __webpack_exports__["a"] = (SearchFormHelper);

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var addWeeks = __webpack_require__(608)

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(238)

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var days = amount * 7
  return addDays(dirtyDate, days)
}

module.exports = addWeeks


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Collection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__searchActions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ducks_coreDataReducer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_components_ContentRequest__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers_HandleRequestError__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__searchReducer__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaginationUtils__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__searchCollectionMessages__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEqual__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_api_content_search__ = __webpack_require__(94);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Collection=function(_React$PureComponent){_inherits(Collection,_React$PureComponent);function Collection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Collection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Collection.__proto__||Object.getPrototypeOf(Collection)).call.apply(_ref,[this].concat(args))),_this),_this.handlePageNavigation=function(_ref2){var query=_ref2.query,number=_ref2.number;var pagingQuery=Object.assign({},query,{page_number:number});_this.props.navigateSearchResults({query:pagingQuery,method:_this.props.method,page:number,label:_this.props.label});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Collection,[{key:'componentDidMount',value:function componentDidMount(){this.props.requestSearchResults({query:this.props.query,method:this.props.method,page:this.props.currentPage,label:this.props.label});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){//
if(!__WEBPACK_IMPORTED_MODULE_9_lodash_isEqual___default()(prevProps.query,this.props.query)){var pageIsLoaded=Array.isArray(this.props.pages.get(this.props.currentPage));if(!pageIsLoaded){this.props.requestSearchResults({query:this.props.query,method:this.props.method,page:this.props.currentPage,label:this.props.label});}else{smoothscroll();}}if(prevProps.locationSearch!==this.props.locationSearch){this.props.onLocationSearchChange(this.props.locationSearch);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clearSearch();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,items=_props.items,_props$requestStatus=_props.requestStatus,requestStatus=_props$requestStatus===undefined?null:_props$requestStatus,CardComponent=_props.CardComponent,currentPage=_props.currentPage,pages=_props.pages,totalPages=_props.totalPages,nextPageProps=_props.nextPageProps,prevPageProps=_props.prevPageProps;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_containers_HandleRequestError__["a" /* default */],{requestStatus:requestStatus,match:function match(err){return typeof err.status==='number'&&err.status>=500;},render:__WEBPACK_IMPORTED_MODULE_8__searchCollectionMessages__["c" /* ServerErrorMessage */]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_containers_HandleRequestError__["a" /* default */],{requestStatus:requestStatus,match:function match(err){return typeof err.status==='number'&&err.status>=400;},render:__WEBPACK_IMPORTED_MODULE_8__searchCollectionMessages__["a" /* ClientErrorMessage */]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_pages_components_ContentRequest__["a" /* default */],{requestStatus:requestStatus,render:function render(){if(items.length===0&&currentPage===1){return Object(__WEBPACK_IMPORTED_MODULE_8__searchCollectionMessages__["b" /* NoItemsMessage */])();}if(items.length===0){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_components__["i" /* EmptyCard */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_components__["i" /* EmptyCard */].Message,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,'There are no more results'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_components__["c" /* Button */],{onClick:function onClick(){return prevPageProps!=null&&_this2.handlePageNavigation(prevPageProps);},className:'SearchCollection_NavButton SearchCollection_NavButton--prev'},'Go Back to Previous results.')));}var hasMorePages=typeof totalPages==='number'&&totalPages>currentPage;var shouldHidePaginationNav=currentPage===1&&items.length<100&&!hasMorePages;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Items,{items:items,pages:pages,currentPage:currentPage,totalPages:totalPages}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_components__["g" /* CollectionItemTranisitionProvider */],{key:currentPage,items:items,itemKey:function itemKey(item){return item.moderationState.getUGCId();}},function(item){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CardComponent,{datum:item,dispatch:_this2.props.dispatch,clientId:_this2.props.clientId});}),shouldHidePaginationNav?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_components__["c" /* Button */],{onClick:function onClick(){return prevPageProps&&_this2.handlePageNavigation(prevPageProps);},className:'SearchCollection_NavButton SearchCollection_NavButton--prev',disabled:prevPageProps==null},'Previous'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_components__["c" /* Button */],{style:{marginLeft:'auto'},className:'SearchCollection_NavButton SearchCollection_NavButton--next',onClick:function onClick(){return nextPageProps&&_this2.handlePageNavigation(nextPageProps);},disabled:nextPageProps==null},'Next')));}})));}}]);return Collection;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Collection));function Items(_ref3){var pages=_ref3.pages,currentPage=_ref3.currentPage,items=_ref3.items,totalPages=_ref3.totalPages;var isFirstPage=currentPage===1;var lastPageCount=function(){var _=pages.get(pages.size);return Array.isArray(_)?_.length:null;}();var className='bg-silver white br-pill f6 pv1 ph2 PaginationStatus';if(isFirstPage&&items.length===1){return null;}var hasMorePages=typeof totalPages==='number'&&totalPages>currentPage;if(isFirstPage&&items.length<__WEBPACK_IMPORTED_MODULE_7__PaginationUtils__["a" /* DefaultPaginationPageSize */]&&!hasMorePages){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{style:{margin:'-1em 0 -0.5em'}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:className,'data-translate':true},items.length,' items'));}// Calculate running totals from actual page sizes
var itemsBefore=0;for(var i=1;i<currentPage;i++){var pageItems=coerceToArray(pages.get(i));itemsBefore+=pageItems.length;}var total=pages.map(coerceToArray).reduce(function(t,items){return t+items.length;},0);var first=itemsBefore+1;var last=itemsBefore+items.length;var potentiallyMoreItems=hasMorePages||typeof lastPageCount==='number'&&lastPageCount>=__WEBPACK_IMPORTED_MODULE_7__PaginationUtils__["a" /* DefaultPaginationPageSize */];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{style:{margin:'-1em 0 -0.5em'}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:className},first,' - ',last,' of ',total,potentiallyMoreItems?'+':'',' items'));}function getNavigation(_ref4){var queries=_ref4.queries,currentPage=_ref4.currentPage,pages=_ref4.pages,itemGetter=_ref4.itemGetter,method=_ref4.method,totalPages=_ref4.totalPages;var prevPage=void 0;var nextPage=void 0;// the first page serves as the base query
var baseQuery=queries.get(1);var itemsInPage=coerceToArray(pages.get(currentPage));var prevPageNumber=currentPage-1;var nextPageNumber=currentPage+1;var itemsAreUnderPageSizeLimit=itemsInPage.length<__WEBPACK_IMPORTED_MODULE_7__PaginationUtils__["a" /* DefaultPaginationPageSize */];var hasMorePages=typeof totalPages==='number'&&totalPages>currentPage;// pagination isn't required if the first page is under page size and no more pages
if(currentPage===1&&itemsAreUnderPageSizeLimit&&!hasMorePages){return[prevPage,nextPage];}// corceToArray returns EmptyCollection, which seems to be bound to CoreDatum[] even
// though its just an empty array
// $FlowIssue
var lastItemId=itemsInPage[itemsInPage.length-1];var lastItem=itemGetter(lastItemId);if(lastItem){var nextPageValue=pages.get(nextPageNumber);var nextPageItemCount=Array.isArray(nextPageValue)?nextPageValue.length:null;// nextPage
if(hasMorePages){nextPage=nextPageItemCount===0?nextPage:{number:nextPageNumber,query:baseQuery};}else{nextPage=itemsAreUnderPageSizeLimit===false?nextPageItemCount===0?nextPage:{number:nextPageNumber,// $FlowFixMe
query:method===__WEBPACK_IMPORTED_MODULE_12_api_content_search__["c" /* ugcSearch */]?baseQuery:Object(__WEBPACK_IMPORTED_MODULE_7__PaginationUtils__["b" /* createNextPageQuery */])(lastItem.ugc.created_date,baseQuery)}:nextPage;}}prevPage=queries.has(prevPageNumber)?{number:prevPageNumber,query:queries.get(prevPageNumber)}:prevPage;// For ugcSearch with totalPages, always allow going back if not on page 1
if(!prevPage&&currentPage>1&&hasMorePages){prevPage={number:prevPageNumber,query:baseQuery};}return[prevPage,nextPage];}function smoothscroll(){var currentScroll=parseInt(document.documentElement&&document.documentElement.scrollTop||document.body&&document.body.scrollTop,10);if(currentScroll>0){window.requestAnimationFrame(smoothscroll);window.scrollTo(0,currentScroll-currentScroll/5);}}function selectCoreData(coreData,ids){return ids.reduce(function(acc,id){var datum=__WEBPACK_IMPORTED_MODULE_3_ducks_coreDataReducer__["a" /* CoreDataState */].getTheThings(coreData,id);if(datum!=null){acc.push(datum);}return acc;},[]);}var EmptyCollectionArray=[];function mapStateToProps(state,ownProps){var _state$search=state.search,currentPage=_state$search.currentPage,pages=_state$search.pages,queries=_state$search.queries,totalPages=_state$search.totalPages,coreData=state.coreData;var query=queries.get(currentPage);var asyncItem=pages.get(currentPage);if(asyncItem instanceof Error){return{requestStatus:asyncItem,items:EmptyCollectionArray,query:query,currentPage:currentPage,pages:pages,totalPages:totalPages};}if(Array.isArray(asyncItem)){var _items=selectCoreData(coreData,asyncItem);var _getNavigation=getNavigation({queries:queries,currentPage:currentPage,pages:pages,itemGetter:function itemGetter(id){return __WEBPACK_IMPORTED_MODULE_3_ducks_coreDataReducer__["a" /* CoreDataState */].getTheThings(coreData,id);},method:ownProps.method,totalPages:totalPages}),_getNavigation2=_slicedToArray(_getNavigation,2),_prevPageProps=_getNavigation2[0],_nextPageProps=_getNavigation2[1];return{requestStatus:'complete',pages:pages,items:_items,query:query,currentPage:currentPage,totalPages:totalPages,prevPageProps:_prevPageProps,nextPageProps:_nextPageProps};}return{requestStatus:'pending',items:EmptyCollectionArray,query:query,currentPage:currentPage,pages:pages,totalPages:totalPages};}function mapDispatchToProps(dispatch){return Object.assign({dispatch:dispatch},Object(__WEBPACK_IMPORTED_MODULE_11_redux__["b" /* bindActionCreators */])({requestSearchResults:__WEBPACK_IMPORTED_MODULE_2__searchActions__["d" /* requestSearchResults */],navigateSearchResults:__WEBPACK_IMPORTED_MODULE_2__searchActions__["b" /* navigateSearchResults */],clearSearch:__WEBPACK_IMPORTED_MODULE_2__searchActions__["a" /* clearSearch */]},dispatch));}function coerceToArray(items){return Array.isArray(items)?items:EmptyCollectionArray;}

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultPaginationPageSize; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createNextPageQuery;
var DefaultPaginationPageSize=100;function createNextPageQuery(lastUgcCreatedTime,query){var pageSize=arguments.length>2&&arguments[2]!==undefined?arguments[2]:DefaultPaginationPageSize;var sort_order=query.sort_order;if(sort_order==='desc'){return Object.assign({},query,{end_date:lastUgcCreatedTime});}if(sort_order==='asc'){return Object.assign({},query,{start_date:lastUgcCreatedTime});}return query;}

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ClientErrorMessage;
/* harmony export (immutable) */ __webpack_exports__["c"] = ServerErrorMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = NoItemsMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
var SEARCH_ERROR_TITLE="This search couldn't run.";function ClientErrorMessage(err){if(err.status===400){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],{title:SEARCH_ERROR_TITLE,message:'You seem to have submitted an invalid request. If you think this is an error, contact PowerReviews Support.'});}if(err.status===403){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],{title:SEARCH_ERROR_TITLE,message:'You don\'t seem to have permissions to run this search. If you think this is an error, contact PowerReviews Support.'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],{title:SEARCH_ERROR_TITLE,message:'Could not run this search.'});}function ServerErrorMessage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],{title:SEARCH_ERROR_TITLE,message:'An Error occurred while running your search. If this error persists, contact PowerReviews Support.'});}function NoItemsMessage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],{title:'No Results',message:'Sorry, your search did not return any results.'});}

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(613);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(614),
    isObjectLike = __webpack_require__(61);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(615),
    equalArrays = __webpack_require__(244),
    equalByTag = __webpack_require__(647),
    equalObjects = __webpack_require__(651),
    getTag = __webpack_require__(671),
    isArray = __webpack_require__(80),
    isBuffer = __webpack_require__(245),
    isTypedArray = __webpack_require__(246);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(97),
    stackClear = __webpack_require__(621),
    stackDelete = __webpack_require__(622),
    stackGet = __webpack_require__(623),
    stackHas = __webpack_require__(624),
    stackSet = __webpack_require__(625);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 616 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(97);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 622 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 623 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 624 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(97),
    Map = __webpack_require__(139),
    MapCache = __webpack_require__(243);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(232),
    isMasked = __webpack_require__(627),
    isObject = __webpack_require__(93),
    toSource = __webpack_require__(242);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(628);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(28);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 629 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(631),
    ListCache = __webpack_require__(97),
    Map = __webpack_require__(139);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(632),
    hashDelete = __webpack_require__(633),
    hashGet = __webpack_require__(634),
    hashHas = __webpack_require__(635),
    hashSet = __webpack_require__(636);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 633 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 638 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(243),
    setCacheAdd = __webpack_require__(643),
    setCacheHas = __webpack_require__(644);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 643 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 644 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 646 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(79),
    Uint8Array = __webpack_require__(648),
    eq = __webpack_require__(137),
    equalArrays = __webpack_require__(244),
    mapToArray = __webpack_require__(649),
    setToArray = __webpack_require__(650);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(28);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 649 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 650 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(652);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(653),
    getSymbols = __webpack_require__(655),
    keys = __webpack_require__(658);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(654),
    isArray = __webpack_require__(80);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 654 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(656),
    stubArray = __webpack_require__(657);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 656 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 657 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(659),
    baseKeys = __webpack_require__(667),
    isArrayLike = __webpack_require__(231);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(660),
    isArguments = __webpack_require__(661),
    isArray = __webpack_require__(80),
    isBuffer = __webpack_require__(245),
    isIndex = __webpack_require__(234),
    isTypedArray = __webpack_require__(246);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 660 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(662),
    isObjectLike = __webpack_require__(61);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(60),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 663 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(60),
    isLength = __webpack_require__(233),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 665 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(181);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)(module)))

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(668),
    nativeKeys = __webpack_require__(669);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 668 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(670);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 670 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(672),
    Map = __webpack_require__(139),
    Promise = __webpack_require__(673),
    Set = __webpack_require__(674),
    WeakMap = __webpack_require__(675),
    baseGetTag = __webpack_require__(60),
    toSource = __webpack_require__(242);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UgcAssignmentContainer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UgcAssignment__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UgcAssignmentContext__ = __webpack_require__(248);
// $$FlowFixMe
var EMPTY_RECORD={};function UgcAssignmentContainer(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__UgcAssignmentContext__["a" /* default */]),assignments=_useContext.assignments,requestAssignment=_useContext.requestAssignment;var ugc=props.ugc,userProfiles=props.userProfiles,clientId=props.clientId;var assignment=assignments.get(ugc.ugc_id,EMPTY_RECORD);var pending_assigned_to=assignment.assigned_to,pending_assigned_by=assignment.assigned_by,changeStatus=assignment.changeStatus;var assigned_to=pending_assigned_to!==undefined?pending_assigned_to:ugc.assigned_to;var assigned_by=pending_assigned_by!==undefined?pending_assigned_by:ugc.assigned_by;var assignedToProfile=Array.isArray(userProfiles)?userProfiles.find(function(p){return p.profile_id===assigned_to;}):undefined;var assignedByProfile=Array.isArray(userProfiles)?userProfiles.find(function(p){return p.profile_id===assigned_by;}):undefined;var assigned_at=ugc.assignment_updated_date?__WEBPACK_IMPORTED_MODULE_1_date_fns_parse___default()(ugc.assignment_updated_date):undefined;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__UgcAssignment__["a" /* default */],{options:userProfiles,assignedToId:assigned_to,assignedToName:assignedToProfile&&assignedToProfile.name,assignedByName:assignedByProfile&&assignedByProfile.name,assignedAt:assigned_at,onChange:function onChange(profileId){return requestAssignment({ugcId:ugc.ugc_id,clientId:clientId,profileId:profileId});},changeStatus:changeStatus});}

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UgcAssignment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_async_value__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UgcAssignment_css__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UgcAssignment_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UgcAssignment_css__);
var Notice=function Notice(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'gray tc f6 ma2 mr0'},children);};function UgcAssignment(props){var assignedToName=props.assignedToName,assignedToId=props.assignedToId,assignedByName=props.assignedByName,assignedAt=props.assignedAt,options=props.options,onChange=props.onChange,changeStatus=props.changeStatus;var optionsAreAvailable=Array.isArray(options)&&options.length;if(changeStatus instanceof Error){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Notice,null,'Error updating assignment.');}if(!optionsAreAvailable){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Notice,null,'No team members were found.');}if(Array.isArray(options)&&options.length&&(assignedToName==null||assignedToId==null)){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{'data-translate':'false'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["q" /* Select */],{name:'assignment',placeholder:'Select a team member...',options:options,valueKey:'profile_id',labelKey:'name',value:assignedToId// $FlowIssue
,onChange:function(_onChange){function onChange(_x){return _onChange.apply(this,arguments);}onChange.toString=function(){return _onChange.toString();};return onChange;}(function(v){onChange(v.profile_id);}),multi:false}));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex flex-wrap items-center justify-between'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'bg-moon-gray mid-gray pv1 pl2 dib f6 br1 mr2 inline-flex items-center'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'lh-solid'},assignedToName),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{type:'button',className:'button-reset bg-transparent b--none ml1 inline-flex gray hover-dark-gray UgcAssignment__removeButton',onClick:function onClick(){return onChange(null);}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',{viewBox:'0 0 12 12',version:'1.1',xmlns:'http://www.w3.org/2000/svg',style:{width:10,height:10}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('line',{x1:'1',y1:'11',x2:'11',y2:'1',stroke:'currentColor',strokeWidth:'2'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('line',{x1:'1',y1:'1',x2:'11',y2:'11',stroke:'currentColor',strokeWidth:'2'})))),changeStatus===__WEBPACK_IMPORTED_MODULE_3_lib_async_value__["b" /* default */].Pending?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Notice,null,'Saving...'):(assignedByName||assignedAt)&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('small',{className:'gray dib lh-solid ma2 mr0'},assignedByName,' ',assignedAt&&__WEBPACK_IMPORTED_MODULE_2_date_fns_format___default()(assignedAt,'M/D/YY')));}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"UgcAssignment__removeButton":"UgcAssignment__removeButton","ugcAssignmentRemoveButton":"UgcAssignment__removeButton"};

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_async_value__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function IndicatorIcon(_ref){var published=_ref.published;var color='#ccc';if(published===true){color='#8AC734';}else if(published===false){color='rgba(240, 94, 36, 1)';}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',{viewBox:'0 0 200 200',xmlns:'http://www.w3.org/2000/svg',className:'w1 h1',style:{marginRight:'0.3rem',color:color}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('circle',{cx:'100',cy:'100',r:'100',fill:'currentColor'}));}var SITE_STATUS_OPTIONS=[{label:'Published',value:true},{label:'Unpublished',value:false}];var EMPTY_SITE_STATUS_SELECT_OPTIONS=[];var SiteStatusSelect=function(_React$Component){_inherits(SiteStatusSelect,_React$Component);function SiteStatusSelect(){_classCallCheck(this,SiteStatusSelect);return _possibleConstructorReturn(this,(SiteStatusSelect.__proto__||Object.getPrototypeOf(SiteStatusSelect)).apply(this,arguments));}_createClass(SiteStatusSelect,[{key:'render',value:function render(){var _props=this.props,published=_props.published,onChange=_props.onChange;var value=published;var options=EMPTY_SITE_STATUS_SELECT_OPTIONS;var placeholder=void 0;var disabled=void 0;if(published===__WEBPACK_IMPORTED_MODULE_2_lib_async_value__["a" /* AsyncValues */].Pending){placeholder='Updating site status...';value=null;disabled=true;}else if(published instanceof Error){placeholder='Failed to update site status';value=null;disabled=true;}else if(published==null){placeholder='Site status unavailable';value=null;disabled=true;}else{options=SITE_STATUS_OPTIONS.map(function(option){return option.value===published?Object.assign({},option,{disabled:true}):option;});}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex items-center mb1'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IndicatorIcon,{published:published}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'dark-gray ma0 brandon'},'Site Status',published===__WEBPACK_IMPORTED_MODULE_2_lib_async_value__["a" /* AsyncValues */].Pending&&'*')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["q" /* Select */],{value:value,options:options,placeholder:placeholder,disabled:disabled,name:'ugc-site-status',clearable:false// $FlowIssue
,onChange:function(_onChange){function onChange(_x){return _onChange.apply(this,arguments);}onChange.toString=function(){return _onChange.toString();};return onChange;}(function(v){return onChange(v.value);})}));}}]);return SiteStatusSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SiteStatusSelect);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UgcFeaturedMedia;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ducks_auth_context__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_client_UgcFeaturedMediaApi__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// $$FlowFixMe
var delay=function delay(timeout){return new Promise(function(resolve){return setTimeout(resolve,timeout);});};function UgcFeaturedMedia(props){var handleChange=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var featured,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:featured=e.currentTarget.checked;_context.prev=1;setRequestStatus('pending');_context.next=5;return delay(1000);case 5:_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3_containers_client_UgcFeaturedMediaApi__["a" /* setFeaturedMedia */])(token,{ugcId:ugc_id,featured:featured});case 7:response=_context.sent;onSubmit({featured:response.featured});setRequestStatus('complete');_context.next=15;break;case 12:_context.prev=12;_context.t0=_context['catch'](1);setRequestStatus(_context.t0);case 15:case'end':return _context.stop();}}},_callee,this,[[1,12]]);}));return function handleChange(_x){return _ref.apply(this,arguments);};}();var ugc_id=props.ugc_id,ugc_type=props.ugc_type,featured=props.featured,onSubmit=props.onSubmit;var _useAuth=Object(__WEBPACK_IMPORTED_MODULE_2_ducks_auth_context__["c" /* useAuth */])(),token=_useAuth.token;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),requestStatus=_useState2[0],setRequestStatus=_useState2[1];var loading=requestStatus==='pending';var errored=requestStatus instanceof Error;var completed=requestStatus==='complete';Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){// clear error message after 3 seconds
var timeoutId=void 0;var current=true;if(completed||errored){timeoutId=setTimeout(function(){if(current){setRequestStatus(null);}},3000);}return function(){current=false;timeoutId&&clearTimeout(timeoutId);};},[requestStatus]);var descriptionLabelId=ugc_id+'-description-featured-media';var errorDescriptionLabelId=ugc_id+'-description-featured-media';return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()('flex items-start pt3',{'o-70':loading}),style:{minHeight:67}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('input',{id:ugc_id+'-featured-checkbox',type:'checkbox',checked:loading?!featured:featured,onChange:handleChange,disabled:requestStatus!=null,className:'mt1','aria-describedby':errored?errorDescriptionLabelId:descriptionLabelId}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'flex flex-column pl2'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('label',{htmlFor:ugc_id+'-featured-checkbox',className:'brandon b f4 dark-gray'},'Featured '+ugc_type),errored?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('p',{id:errorDescriptionLabelId,className:'brandon tl f6 normal db dark-red mv0'},'An error occured while saving your preference, please try again.'):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('p',{id:descriptionLabelId,className:'brandon tl f6 normal db gray mv0'},loading?'Saving...':completed?ugc_type+' updated!':ugc_type+'s marked as featured will be given priority in your galleries and shown first.')));}

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setFeaturedMedia; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
var setFeaturedMedia=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function(token,_ref){var ugcId=_ref.ugcId,featured=_ref.featured;var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/moderate/content/ugc/'+ugcId+'/media?featured='+featured);var fetchOptions={method:'PUT',headers:{'Content-type':'application/json',Authorization:token}};return fetch(fetchUrl,fetchOptions).then(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */]).then(function(response){return response.json();});});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuestionSection__ = __webpack_require__(683);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__QuestionSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnswerSection__ = __webpack_require__(703);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__AnswerSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentSection__ = __webpack_require__(141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddAnswer__ = __webpack_require__(704);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__AddAnswer__["a"]; });


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuestionSection; });
/* unused harmony export PwrQuestionSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentSection__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ContentSection_UgcMetaInfo__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QAComponents__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AnswerArticle__ = __webpack_require__(249);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuestionSection=function(_React$Component){_inherits(QuestionSection,_React$Component);function QuestionSection(){_classCallCheck(this,QuestionSection);return _possibleConstructorReturn(this,(QuestionSection.__proto__||Object.getPrototypeOf(QuestionSection)).apply(this,arguments));}_createClass(QuestionSection,[{key:'getAnswers',value:function getAnswers(question){var answers=question.ugc_related_content.filter(function(ugc){return ugc&&ugc.ugc_archetype==='Answer';});return answers;}},{key:'render',value:function render(){var _props=this.props,ugc=_props.ugc,addAnswerTextBox=_props.children,MetaInfoComponent=_props.MetaInfoComponent,subject=_props.subject,locale=_props.locale,allowMedia=_props.allowMedia;var answers=this.getAnswers(ugc);var body=function(){if(answers.size===0&&!addAnswerTextBox)return null;var answerElements=answers.map(function(answer,index,list){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:answer.ugc_id},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mh4 mv3'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__AnswerArticle__["a" /* AnswerArticle */],{ugc:answer,viewContext:'Question',parentUgcId:ugc.ugc_id,subject:subject,locale:locale,allowMedia:allowMedia})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('hr',{className:'ml0 mr0 bb bt-0 b--black-05'}));});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,answerElements,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ma4'},addAnswerTextBox));}();return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ContentSection__["a" /* ContentSection */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ContentSection__["a" /* ContentSection */].Section,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__QAComponents__["a" /* Article */],{ugc:ugc})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ContentSection__["a" /* ContentSection */].Divider,null),body,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ContentSection__["a" /* ContentSection */].Meta,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MetaInfoComponent,{model:ugc})));}}]);return QuestionSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);QuestionSection.defaultProps={MetaInfoComponent:__WEBPACK_IMPORTED_MODULE_2_components_ContentSection_UgcMetaInfo__["b" /* ClientUgcMetaInfo */]};var PwrQuestionSection=function PwrQuestionSection(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](QuestionSection,Object.assign({},props,{MetaInfoComponent:__WEBPACK_IMPORTED_MODULE_2_components_ContentSection_UgcMetaInfo__["d" /* PwrUgcMetaInfo */]}));};

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthorInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_format__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AuthorInfo_scss__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AuthorInfo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AuthorInfo_scss__);
var AuthorInfo=function AuthorInfo(props){var _props$ugc=props.ugc,created_date=_props$ugc.created_date,author=_props$ugc.author,location=_props$ugc.location;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'AuthorInfo'},'Submitted on',' ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{'data-key':'created_date'},formatDate(created_date)),author&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',null,' ','by ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer__["b" /* default */],{'data-key':'author',text:author})),location&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',null,' ','from',' ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__UserGeneratedTextContainer__["b" /* default */],{'data-key':'location',text:location})));};function formatDate(isoDateString){return typeof isoDateString==='string'?__WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default()(isoDateString),'M/DD/YYYY h:mm A'):'';}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AuthorInfo":"AuthorInfo","authorInfo":"AuthorInfo"};

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"QA-Icon":"QA-Icon","qaIcon":"QA-Icon","QA-Text":"QA-Text","qaText":"QA-Text","QA-Article":"QA-Article","qaArticle":"QA-Article","QA-Article__LeftAside":"QA-Article__LeftAside","qaArticleLeftAside":"QA-Article__LeftAside","QA-Article__RightAside":"QA-Article__RightAside","qaArticleRightAside":"QA-Article__RightAside","QA-Article__Main":"QA-Article__Main","qaArticleMain":"QA-Article__Main"};

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EditAnswer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QAComponents__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ContentSection_UserGeneratedTextContainer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_alerts__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaUpload__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AnswerTextarea__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lib_nanoid__ = __webpack_require__(255);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(['input'],['input']),_templateObject2=_taggedTemplateLiteral(['media-input'],['media-input']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// $$FlowFixMe
function EditAnswer(props){var ugc=props.ugc,onSubmit=props.onSubmit,isLoading=props.isLoading,error=props.error,onCancel=props.onCancel,allowMedia=props.allowMedia;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),deletedMedia=_useState2[0],setDeletedMedia=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(Object(__WEBPACK_IMPORTED_MODULE_2_components_ContentSection_UserGeneratedTextContainer__["c" /* stripWarningTags */])(ugc.answer)),_useState4=_slicedToArray(_useState3,2),answerText=_useState4[0],setAnswerText=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["Map"])()),_useState6=_slicedToArray(_useState5,2),updatedCaptions=_useState6[0],setUpdatedCaptions=_useState6[1];var existingMedia=ugc.getMedia();var maxItems=__WEBPACK_IMPORTED_MODULE_4__MediaUpload__["b" /* DEFAULT_MAX_MEDIA_ITEMS */]-existingMedia.size+deletedMedia.length;var _useMediaUpload=Object(__WEBPACK_IMPORTED_MODULE_4__MediaUpload__["g" /* useMediaUpload */])(maxItems),newMedia=_useMediaUpload.media,newCaptions=_useMediaUpload.captions,canPersistMedia=_useMediaUpload.canPersistMedia,addFiles=_useMediaUpload.addFiles,uploadFile=_useMediaUpload.uploadFile,setCaption=_useMediaUpload.setCaption,removeFile=_useMediaUpload.removeFile,clearFiles=_useMediaUpload.clearFiles,isModalOpen=_useMediaUpload.isModalOpen,toggleModal=_useMediaUpload.toggleModal;var isOverMediaLimit=maxItems-newMedia.size<0;var idRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(Object(__WEBPACK_IMPORTED_MODULE_8_lib_nanoid__["a" /* nanoid */])());function id(strings){return idRef.current+'-'+strings.join('-');}function toggleDeleteMedia(ugcId){setDeletedMedia(function(list){if(list.includes(ugcId)){return list.filter(function(i){return i!==ugcId;});}return[].concat(_toConsumableArray(list),[ugcId]);});}function getUgcCaption(ugc){return updatedCaptions.has(ugc.ugc_id)?updatedCaptions.get(ugc.ugc_id):Object(__WEBPACK_IMPORTED_MODULE_2_components_ContentSection_UserGeneratedTextContainer__["c" /* stripWarningTags */])(ugc.caption);}function serializeUgcToResponseMediaDTO(ugc){return{ugc_id:ugc.ugc_id,ugc_type:ugc.ugctype,url:ugc.url,caption:getUgcCaption(ugc)};}function handleSubmit(e){e.preventDefault();var payload={answer_media:[].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_4__MediaUpload__["f" /* serializeResponseMedia */])(newMedia,newCaptions)),_toConsumableArray(existingMedia.filter(function(ugc){return!deletedMedia.includes(ugc.ugc_id);}).map(serializeUgcToResponseMediaDTO))),deleted_media:deletedMedia,text:answerText};onSubmit(payload);}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__QAComponents__["b" /* ArticleContainer */],{ugctype:'Answer',main:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('form',{onSubmit:handleSubmit,style:{opacity:isLoading?0.5:1,pointerEvents:isLoading?'none':'auto'}},error!=null?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_alerts__["b" /* ErrorAlert */],null,error):null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__AnswerTextarea__["a" /* AnswerTextarea */],{id:id(_templateObject),value:answerText,onChange:function onChange(e){return setAnswerText(e.target.value);},placeholder:'Add an answer to this question'}),isOverMediaLimit?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_alerts__["a" /* Alert */],null,'You can only include '+__WEBPACK_IMPORTED_MODULE_4__MediaUpload__["b" /* DEFAULT_MAX_MEDIA_ITEMS */]+' media items.'):null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('ul',{className:'list mv4 pa0'},existingMedia.map(function(ugc){var ugcId=ugc.ugc_id;var isDeleted=deletedMedia.includes(ugc.ugc_id);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('li',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('flex items-start mb4',{'o-50':isDeleted}),key:ugcId},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MediaUpload__["c" /* ExistingMediaThumbnail */],{ugc:ugc,onDelete:toggleDeleteMedia}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MediaUpload__["a" /* CaptionTextarea */],{value:getUgcCaption(ugc),placeholder:'Add a caption',disabled:isDeleted,onChange:function onChange(e){var caption=e.target.value;setUpdatedCaptions(function(curr){return curr.set(ugcId,caption);});}}));})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('ul',{className:'list mv4 pa0'},Array.from(newMedia.entries()).map(function(_ref){var _ref2=_slicedToArray(_ref,2),id=_ref2[0],item=_ref2[1];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('li',{key:id,className:'flex items-start mb4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MediaUpload__["d" /* MediaThumbnail */],{item:item,onDelete:removeFile}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MediaUpload__["a" /* CaptionTextarea */],{placeholder:'Add a caption...',value:newCaptions.get(id)||'',onChange:function onChange(e){setCaption(id,e.target.value);}}));})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex'},allowMedia&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MediaUpload__["e" /* MediaUploadControl */],{media:newMedia,isOpen:isModalOpen,onToggle:toggleModal,onUpload:uploadFile,onDelete:removeFile,maxItems:maxItems,onAdd:addFiles,id:id(_templateObject2)}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{style:{marginLeft:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{className:'btn btn--small btn--link',type:'reset',onClick:function onClick(){clearFiles();onCancel();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{className:__WEBPACK_IMPORTED_MODULE_5_classnames___default()('btn btn--small btn--primary',{'btn--loading':isLoading}),type:'submit',disabled:canPersistMedia===false||isOverMediaLimit===true},error==null?'Save':'Retry'))))});}

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MediaUploadControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UploadIcon__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaUploadControl_module_scss__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaUploadControl_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MediaUploadControl_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaUploadModal__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tabs__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__URLUploadControl__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ResourceTypes__ = __webpack_require__(72);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();// $$FlowIssue
function MediaUploadControl(props){var id=props.id,onAdd=props.onAdd,media=props.media,maxItems=props.maxItems,isOpen=props.isOpen,onToggle=props.onToggle,onUpload=props.onUpload,onDelete=props.onDelete;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState2=_slicedToArray(_useState,2),selectedTab=_useState2[0],setSelectedTab=_useState2[1];var multiple=media.size<maxItems-1;var disabled=media.size>=maxItems;function closeModal(){onToggle(false);setSelectedTab(0);}function handleAddFiles(files){onAdd(files.map(function(f){return new __WEBPACK_IMPORTED_MODULE_8__ResourceTypes__["b" /* FileSystemResource */](f);}));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,isOpen&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MediaUploadModal__["a" /* MediaUploadModal */],{onClose:closeModal,body:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Tabs__["c" /* Tabs */],{id:id,index:selectedTab,onChange:setSelectedTab},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Tabs__["a" /* Tab */],null,'Upload'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Tabs__["a" /* Tab */],null,'URL'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Tabs__["b" /* TabPanel */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DropZone,{onChange:handleAddFiles},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DropZoneUploadIcon,{style:{width:50,height:50},'aria-hidden':true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'mt1 mb3 brandon'},'Drag and drop your Photo or Video files here ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('br',null),' or'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{className:__WEBPACK_IMPORTED_MODULE_2__MediaUploadControl_module_scss___default.a.fileInput,type:'file',accept:'image/*,video/*',id:id+'-file-input',multiple:multiple,value:'',onChange:function onChange(e){return handleAddFiles(Array.from(e.target.files));},disabled:disabled}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('label',{htmlFor:id+'-file-input',className:'btn btn--secondary'},'Choose File'))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Tabs__["b" /* TabPanel */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__URLUploadControl__["a" /* URLUploadControl */],{onChange:function onChange(data){onAdd([new __WEBPACK_IMPORTED_MODULE_8__ResourceTypes__["c" /* RemoteResource */](data)]);}}))),footer:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex flex-column'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('ul',{className:'list pa0 cf'},Array.from(media.entries()).map(function(_ref){var _ref2=_slicedToArray(_ref,2),id=_ref2[0],item=_ref2[1];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('li',{key:id,className:'mb2 fl'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5____["d" /* MediaThumbnail */],{item:item,onUpload:onUpload,onDelete:onDelete}));})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{className:'btn btn--primary',onClick:closeModal,type:'button'},'Finish'))}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{type:'button',className:__WEBPACK_IMPORTED_MODULE_2__MediaUploadControl_module_scss___default.a.target,onClick:function onClick(){return onToggle(true);},disabled:disabled,'aria-label':'Add media to your answer'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__UploadIcon__["a" /* UploadIcon */],{className:__WEBPACK_IMPORTED_MODULE_2__MediaUploadControl_module_scss___default.a.uploadIcon})));}var DropZoneUploadIcon=function DropZoneUploadIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('svg',Object.assign({viewBox:'0 0 69 69'},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('g',{transform:'translate(.741 .421)',fill:'none',fillRule:'evenodd'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('circle',{fill:'#FFF',cx:34,cy:34,r:34}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path',{d:'M30 37h8v12h-8zm-7-1h22v1H23zm11-16l11 16H23z',fill:'#007BC3'})));};function DropZone(props){var children=props.children,onChange=props.onChange;var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isDragging=_useState4[0],setIsDragging=_useState4[1];function handleDrop(e){e.preventDefault();var files=void 0;if(e.dataTransfer.items){files=Array.from(e.dataTransfer.items).filter(function(item){return item.kind==='file';}).map(function(item){return item.getAsFile();});// Use DataTransferItemList interface to access the file(s)
}else if(e.dataTransfer.files){files=Array.from(e.dataTransfer.files);}var mediaRegex=/(image\/|video\/*)/;if(Array.isArray(files)){onChange(files.filter(function(file){return mediaRegex.test(file.type);}));}setIsDragging(false);}function handleDragOver(e){e.preventDefault();setIsDragging(true);}function handleDragEnter(e){setIsDragging(true);}function handleDragLeave(e){setIsDragging(false);}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('bg-light-gray tc pa4 br4 b--moon-gray b--dotted',{'bg-lightest-blue b--light-blue':isDragging}),onDrop:handleDrop,onDragOver:handleDragOver,onDragEnter:handleDragEnter,onDragLeave:handleDragLeave},children);}

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UploadIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var UploadIcon=function UploadIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({viewBox:"0 0 30 30",xmlns:"http://www.w3.org/2000/svg","aria-hidden":"true"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{fill:"none",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M15 5H4C2.35 5 1 6.35 1 8v18c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3V15",stroke:"currentColor",strokeWidth:"2",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M19 6h10M24 1v10",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"square"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M22 24H4l4.5-5.6 3.045 3.794L16 17l6 7zM10 12c0-1.10666667-.89333333-2-2-2s-2 .89333333-2 2c0 1.1066667.89333333 2 2 2s2-.8933333 2-2z",fill:"currentColor"})));};

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"target":"target","file-input":"file-input","fileInput":"file-input","upload-icon":"upload-icon","uploadIcon":"upload-icon"};

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MediaUploadModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Modal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Icons_XIcon__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaUploadModal_module_scss__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaUploadModal_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MediaUploadModal_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_click_outside__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_click_outside__);
// $FlowIssue
function Backdrop(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'fixed left-0 right-0 bottom-0 top-0 bg-black-60 flex flex-row items-center justify-around z-max'},props.children);}function MediaUploadModal(props){var body=props.body,footer=props.footer,onClose=props.onClose;var container=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Modal__["a" /* ModalPortal */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Backdrop,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_click_outside___default.a,{onClickOutside:function onClickOutside(e){e.stopPropagation();onClose();}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{ref:container,className:__WEBPACK_IMPORTED_MODULE_3__MediaUploadModal_module_scss___default.a['mu-modal'],onKeyDown:function onKeyDown(e){if(e.key==='Escape'){e.stopPropagation();e.preventDefault();onClose();}}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{type:'button',className:'input-reset b--none bg-transparent pa1 absolute top-0 right-0',onClick:onClose,'aria-label':'Close Modal'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_Icons_XIcon__["a" /* XIcon */],{className:'db gray ma1',style:{width:22,height:22,strokeLinecap:'round',strokeWidth:4,stroke:'currentColor'}})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_3__MediaUploadModal_module_scss___default.a['mu-modal__body']},body),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_3__MediaUploadModal_module_scss___default.a['mu-modal__footer']},footer)))));}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mu-modal":"mu-modal","muModal":"mu-modal","mu-modal__body":"mu-modal__body","muModalBody":"mu-modal__body","mu-modal__footer":"mu-modal__footer","muModalFooter":"mu-modal__footer"};

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = Tabs;
/* unused harmony export TabList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* unused harmony export TabPanels */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TabPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tabs_module_scss__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tabs_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tabs_module_scss__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(['index'],['index']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// $$FlowIssue
function Tabs(props){var id=props.id,selectedIndex=props.index,onChange=props.onChange,children=props.children;var arr=__WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children);var tabs=arr.filter(function(child){return child.type===Tab;});var tabpanels=arr.filter(function(child){return child.type===TabPanel;});var tablistRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),keyDownHandled=_useState2[0],setKeyDownHandled=_useState2[1];if(tabs.length!==tabpanels.length){throw new Error('Mismatch between <Tabs/> & <TabPanels />');}function tabId(strings){return id+'-tab-'+strings.join('-');}function tabPanelId(strings){return id+'-tabpanel-'+strings.join('-');}function handleKeyDown(e){var nextSelectedIndex=selectedIndex;if(e.key==='ArrowRight'){nextSelectedIndex+=1;}else if(e.key==='ArrowLeft'){nextSelectedIndex-=1;}if(nextSelectedIndex===selectedIndex){return;}e.stopPropagation();e.preventDefault();if(nextSelectedIndex===tabs.length)nextSelectedIndex=0;if(nextSelectedIndex<0)nextSelectedIndex=tabs.length-1;setKeyDownHandled(Date.now());onChange(nextSelectedIndex);}Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(keyDownHandled){// we only want this effect run when a keyDown event happens
// without this guard it will run on mount, stealing focus form the modal close button
// violating ARIA recommendations
tablistRef.current.querySelector('[aria-selected=true]').focus();}},[keyDownHandled]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TabList,{onKeyDown:handleKeyDown,ref:tablistRef},tabs.map(function(el,index){var isSelected=index===selectedIndex;return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](el,{role:'tab',id:tabId(_templateObject),'aria-controls':tabPanelId(_templateObject),'aria-selected':isSelected,tabIndex:index===selectedIndex?0:-1,onClick:function onClick(e){if(isSelected)return;onChange(index);el.props.onClick&&tabs.props.onClick();}});})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TabPanels,null,tabpanels.map(function(el,index){var isSelected=selectedIndex===index;return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](el,{role:'tabpanel',id:tabPanelId(_templateObject),'aria-labelledby':tabId(_templateObject),tabIndex:0,style:{display:isSelected?'block':'none'}});})));}var TabList=Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function TabList(props,ref){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',Object.assign({},props,{className:__WEBPACK_IMPORTED_MODULE_1__Tabs_module_scss___default.a.tablist,ref:ref}));});var Tab=Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function Tab(props,ref){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',Object.assign({type:'button',className:__WEBPACK_IMPORTED_MODULE_1__Tabs_module_scss___default.a.tab},props,{ref:ref}));});var TabPanels=Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function TabPanels(props,ref){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',Object.assign({className:__WEBPACK_IMPORTED_MODULE_1__Tabs_module_scss___default.a.tabpanels},props));});var TabPanel=Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function TabPanel(props,ref){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',Object.assign({},props,{className:__WEBPACK_IMPORTED_MODULE_1__Tabs_module_scss___default.a.tabpanel,ref:ref}));});

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tablist":"tablist","tab":"tab","tabpanels":"tabpanels","tabpanel":"tabpanel"};

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = URLUploadControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_pwr_cloudinary__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nanoid__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nanoid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nanoid__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var getRemoteResourceType=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url){var response,contentType;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return fetch('https://cors-anywhere.herokuapp.com/'+url,{method:'HEAD'});case 3:response=_context2.sent;if(!response.ok){_context2.next=7;break;}contentType=response.headers.get('content-type')||'';return _context2.abrupt('return',contentType.split('/')[0]);case 7:_context2.next=11;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](0);case 11:return _context2.abrupt('return',null);case 12:case'end':return _context2.stop();}}},_callee2,this,[[0,9]]);}));return function getRemoteResourceType(_x2){return _ref2.apply(this,arguments);};}();var validateMediaURL=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url){var isYoutube,urlToValidate,resourceType;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:isYoutube=Object(__WEBPACK_IMPORTED_MODULE_2_lib_pwr_cloudinary__["c" /* isYoutubeVideo */])(url);urlToValidate=isYoutube?'https://img.youtube.com/vi/'+(Object(__WEBPACK_IMPORTED_MODULE_2_lib_pwr_cloudinary__["b" /* getYoutubeVideoID */])(url)||'')+'/0.jpg':url;_context3.next=4;return getRemoteResourceType(urlToValidate);case 4:resourceType=_context3.sent;if(resourceType){_context3.next=7;break;}throw new Error('Could not determine resource type');case 7:if(!(resourceType!=='image'&&resourceType!=='video')){_context3.next=9;break;}throw new Error('Unsupported resource type: '+resourceType);case 9:if(!isYoutube){_context3.next=11;break;}return _context3.abrupt('return',{accessType:'youtube',resourceType:'video',url:url});case 11:return _context3.abrupt('return',{resourceType:resourceType,accessType:'upload',url:url});case 12:case'end':return _context3.stop();}}},_callee3,this);}));return function validateMediaURL(_x3){return _ref3.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// $FlowFixMe
function URLUploadControl(props){var handleSubmit=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:e.preventDefault();dispatch({type:'submit'});_context.prev=2;_context.next=5;return validateMediaURL(url);case 5:payload=_context.sent;onChange(payload);dispatch({type:'success'});_context.next=13;break;case 10:_context.prev=10;_context.t0=_context['catch'](2);dispatch({type:'fail',payload:_context.t0});case 13:case'end':return _context.stop();}}},_callee,this,[[2,10]]);}));return function handleSubmit(_x){return _ref.apply(this,arguments);};}();var id=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(__WEBPACK_IMPORTED_MODULE_4_nanoid___default()());var onChange=props.onChange;var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useReducer"])(reducer,{isLoading:false,error:null,url:''}),_useReducer2=_slicedToArray(_useReducer,2),_useReducer2$=_useReducer2[0],url=_useReducer2$.url,isLoading=_useReducer2$.isLoading,error=_useReducer2$.error,dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('label',{htmlFor:id.current+'-url',className:'mb2 db dark-gray'},'Enter URL for Photo or Video below'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('input',{type:'url',id:id.current+'-url',className:'form-control',value:url,onChange:function onChange(e){return dispatch({type:'url',payload:e.target.value});}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('button',{type:'submit',disabled:isLoading||!url,className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('btn btn--link',{'btn--loading':isLoading}),onClick:handleSubmit},'Add')),error&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'dark-red mt1'},error.message?error.message:'An error occurred while fetching this URL'));}function reducer(state,action){switch(action.type){case'url':return Object.assign({},state,{url:action.payload});case'submit':return Object.assign({},state,{isLoading:true,error:null});case'success':{return{url:'',isLoading:false,error:null};}case'fail':return Object.assign({},state,{isLoading:false,error:action.payload});default:throw new Error();}}

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CaptionTextarea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_textarea_autosize__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CaptionTextarea_module_scss__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CaptionTextarea_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CaptionTextarea_module_scss__);
// $$FlowFixMe
var CaptionTextarea=function CaptionTextarea(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_textarea_autosize__["a" /* default */],Object.assign({},props,{rows:'1',className:'form-control '+__WEBPACK_IMPORTED_MODULE_2__CaptionTextarea_module_scss___default.a['form-control--caption-textarea']}));};

/***/ }),
/* 697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-control--caption-textarea":"form-control--caption-textarea","formControlCaptionTextarea":"form-control--caption-textarea"};

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_MAX_MEDIA_ITEMS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = serializeResponseMedia;
/* harmony export (immutable) */ __webpack_exports__["c"] = useMediaUpload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloudinaryApi__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceTypes__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();// $FlowIssue
var DEFAULT_MAX_MEDIA_ITEMS=4;function serializeResponseMedia(media,captions){return Array.from(media.values()).filter(__WEBPACK_IMPORTED_MODULE_2__ResourceTypes__["d" /* ResourceTypes */].isSerializable).map(function(item){return item.serialize(captions);});}function deleteUpload(delete_token){if(typeof delete_token==='string'){Object(__WEBPACK_IMPORTED_MODULE_1__cloudinaryApi__["a" /* deleteByToken */])(delete_token);}}function useMediaUpload(maxItems){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()),_useState2=_slicedToArray(_useState,2),media=_useState2[0],setMedia=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()),_useState4=_slicedToArray(_useState3,2),captions=_useState4[0],setCaptions=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),isModalOpen=_useState6[0],setIsModalOpen=_useState6[1];var uploadsHaveResolved=Array.from(media.values()).every(__WEBPACK_IMPORTED_MODULE_2__ResourceTypes__["d" /* ResourceTypes */].isSerializable);var canPersistMedia=uploadsHaveResolved===true&&media.size<=maxItems;function addFiles(files){setMedia(function(prevMedia){return files.reduce(function(media,item){return media.has(item.id)?media:media.set(item.id,item);},prevMedia);});}function removeFile(id){var _ref=media.get(id)||{},delete_token=_ref.delete_token;deleteUpload(delete_token);setMedia(function(prevMedia){return prevMedia.delete(id);});setCaptions(function(prevCaptions){return prevCaptions.delete(id);});}function uploadFile(id,response){if(response instanceof Error){// remove failed upload
var timeoutId=setTimeout(function(){removeFile(id);clearTimeout(timeoutId);},2000);return;}setMedia(function(prevMedia){// $$FlowIssue
return prevMedia.set(id,new __WEBPACK_IMPORTED_MODULE_2__ResourceTypes__["a" /* CloudResource */](id,response));});}function setCaption(id,caption){setCaptions(function(prevCaptions){return prevCaptions.set(id,caption);});}function clearFiles(){// clear uploads which will not be persisted
Array.from(media.values()).map(function(rec){return rec.delete_token;}).forEach(deleteUpload);reset();}function toggleModal(){setIsModalOpen(function(current){return!current;});}function reset(){setMedia(function(prevMedia){return prevMedia.clear();});setCaptions(function(prevCaptions){return prevCaptions.clear();});setIsModalOpen(false);}return{media:media,captions:captions,canPersistMedia:canPersistMedia,addFiles:addFiles,removeFile:removeFile,uploadFile:uploadFile,setCaption:setCaption,clearFiles:clearFiles,reset:reset,isModalOpen:isModalOpen,toggleModal:toggleModal,maxItems:maxItems};}

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = MediaThumbnail;
/* harmony export (immutable) */ __webpack_exports__["a"] = ExistingMediaThumbnail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloudinaryApi__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaThumbnail_module_scss__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaThumbnail_module_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MediaThumbnail_module_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icons_XIcon__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_pwr_cloudinary__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ResourceTypes__ = __webpack_require__(72);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// $FlowIssue
function MediaThumbnail(props){var item=props.item,onUpload=props.onUpload,onDelete=props.onDelete;if(__WEBPACK_IMPORTED_MODULE_7__ResourceTypes__["d" /* ResourceTypes */].isUploadable(item)){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](UploadFile,{item:item,onUpload:onUpload});}// $FlowFixMe
var _item$url=item.url,url=_item$url===undefined?'':_item$url,resourceType=item.resourceType;var thumbnailUrl=createThumbnailURL(url,resourceType);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('img',{src:thumbnailUrl,alt:item.id,className:__WEBPACK_IMPORTED_MODULE_3__MediaThumbnail_module_scss___default.a.img}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MediaTypeIcon,{type:resourceType}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RemoveButton,{itemId:item.id,onClick:onDelete}));}function ExistingMediaThumbnail(props){var _props$ugc=props.ugc,ugc_id=_props$ugc.ugc_id,ugctype=_props$ugc.ugctype,thumbnail=_props$ugc.urlSet.thumbnail,onDelete=props.onDelete;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('img',{src:thumbnail,alt:ugc_id,className:__WEBPACK_IMPORTED_MODULE_3__MediaThumbnail_module_scss___default.a.img}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MediaTypeIcon,{type:ugctype}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RemoveButton,{itemId:ugc_id,onClick:onDelete}));}function RemoveButton(_ref){var itemId=_ref.itemId,_onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('button',{onClick:function onClick(){return _onClick(itemId);},type:'button',className:__WEBPACK_IMPORTED_MODULE_3__MediaThumbnail_module_scss___default.a.removeButton,'aria-label':'Remove '+itemId},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_Icons_XIcon__["a" /* XIcon */],{className:__WEBPACK_IMPORTED_MODULE_3__MediaThumbnail_module_scss___default.a.removeButtonIcon}));}function MediaTypeIcon(_ref2){var _type=_ref2.type;var type=_type.toLowerCase();return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_3__MediaThumbnail_module_scss___default.a.resourceTypeIcon},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('i',{className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()('fa white',{'fa-camera':type==='image','fa-video-camera':type==='video'}),'aria-hidden':true}));}function Container(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_3__MediaThumbnail_module_scss___default.a.mediaThumbnail},props.children);}// $$FlowFixMe
var UploadFile=__WEBPACK_IMPORTED_MODULE_1_react__["memo"](function UploadFile(props){var _this=this;var item=props.item,onUpload=props.onUpload;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),isLoading=_useState2[0],setIsLoading=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),error=_useState4[0],setError=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(typeof onUpload!=='function'){return;}var current=true;var uploadFileToCloudinary=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ResourceTypes$getUpl,_ResourceTypes$getUpl2,file,resourceType,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_ResourceTypes$getUpl=__WEBPACK_IMPORTED_MODULE_7__ResourceTypes__["d" /* ResourceTypes */].getUploadProps(item),_ResourceTypes$getUpl2=_slicedToArray(_ResourceTypes$getUpl,2),file=_ResourceTypes$getUpl2[0],resourceType=_ResourceTypes$getUpl2[1];_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__cloudinaryApi__["b" /* upload */])(file,resourceType);case 4:response=_context.sent;current&&setIsLoading(false);onUpload(item.id,response);_context.next=14;break;case 9:_context.prev=9;_context.t0=_context['catch'](0);setIsLoading(false);current&&setError(true);onUpload(item.id,_context.t0);case 14:case'end':return _context.stop();}}},_callee,_this,[[0,9]]);}));return function uploadFileToCloudinary(){return _ref3.apply(this,arguments);};}();uploadFileToCloudinary();return function(){return current=false;};},[item]);var status=isLoading?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('i',{className:'fa fa-cloud-upload black-30','aria-label':'Uploading '+item.id}):error?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('i',{className:'fa fa-exclamation-triangle dark-red','aria-label':'Upload of '+item.id+' Failed'}):null;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'flex w-100 h-100 items-center justify-center f3'},status));},function(prevProps,nextProps){return prevProps.item.id===nextProps.item.id;});function createThumbnailURL(src,contentType){if(contentType==='image'){return __WEBPACK_IMPORTED_MODULE_5_lib_pwr_cloudinary__["a" /* default */].libraryUrlSet(src).thumbnail;}if(contentType==='video'){var accessType=__WEBPACK_IMPORTED_MODULE_5_lib_pwr_cloudinary__["a" /* default */].isYoutubeVideo(src)?'youtube':'upload';var _ref4=accessType==='youtube'?__WEBPACK_IMPORTED_MODULE_5_lib_pwr_cloudinary__["a" /* default */].youtubeUrlSet(src):__WEBPACK_IMPORTED_MODULE_5_lib_pwr_cloudinary__["a" /* default */].libraryVideoUrlSet(src),thumbnail=_ref4.thumbnail;return thumbnail;}throw new Error('Unknown content type '+contentType);}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"media-thumbnail":"media-thumbnail","mediaThumbnail":"media-thumbnail","img":"img","remove-button":"remove-button","removeButton":"remove-button","remove-button__icon":"remove-button__icon","removeButtonIcon":"remove-button__icon","media-thumbnail--upload-pending":"media-thumbnail--upload-pending","mediaThumbnailUploadPending":"media-thumbnail--upload-pending","upload-status":"upload-status","uploadStatus":"upload-status","resource-type-icon":"resource-type-icon","resourceTypeIcon":"resource-type-icon"};

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__answerEditingActions__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
var reducerMap=new Map();/**
 * Editing
 */reducerMap.set(__WEBPACK_IMPORTED_MODULE_0__answerEditingActions__["e" /* openAnswerEditor */],function(state,action){var ugcId=action.payload;return state.set(ugcId,{type:'edit',requestStatus:null});});reducerMap.set(__WEBPACK_IMPORTED_MODULE_0__answerEditingActions__["c" /* editAnswer */],function(state,action){return state.set(action.payload.ugc_id,{type:'edit',requestStatus:'pending'});});reducerMap.set(__WEBPACK_IMPORTED_MODULE_0__answerEditingActions__["d" /* editAnswerSync */],{next:function next(state,action){return state.remove(action.payload.ugc_id);},throw:function _throw(state,action){if(!action.meta)return state;return state.set(action.meta.ugc_id,{type:'edit',requestStatus:action.payload});}});/**
 * Deleting
 */reducerMap.set(__WEBPACK_IMPORTED_MODULE_0__answerEditingActions__["a" /* deleteAnswer */],function(state,action){var ugc_id=action.payload.ugc_id;return state.set(ugc_id,{type:'delete',requestStatus:'pending'});});reducerMap.set(__WEBPACK_IMPORTED_MODULE_0__answerEditingActions__["b" /* deleteAnswerSync */],{next:function next(state,action){return state.remove(action.payload.ugc_id);},throw:function _throw(state,action){if(!action.meta)return state;return state.set(action.meta.ugc_id,{type:'delete',requestStatus:action.payload});}});/**
 * Cancelling
 */reducerMap.set(__WEBPACK_IMPORTED_MODULE_0__answerEditingActions__["f" /* resetView */],function(state,action){var ugcId=action.payload;return state.remove(ugcId);});var defaultState=Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();var reducer=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])(reducerMap,defaultState);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__answerEditingActions__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_coreDataApi__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ducks_coreDataActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ducks_SagaUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_models__ = __webpack_require__(5);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteAnswerSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(editAnswerSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(saga);function deleteAnswerSaga(action){var _action$payload,ugc_id,target,parent_ugc_id,token,startTs,actionToPut;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteAnswerSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,ugc_id=_action$payload.ugc_id,target=_action$payload.target,parent_ugc_id=_action$payload.parent_ugc_id;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_7_ducks_SagaUtils__["c" /* selectToken */]);case 3:token=_context.sent;startTs=Date.now();actionToPut=void 0;_context.prev=6;_context.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_ducks_coreDataApi__["a" /* deleteUgc */],token,ugc_id);case 9:actionToPut=Object(__WEBPACK_IMPORTED_MODULE_3__answerEditingActions__["b" /* deleteAnswerSync */])(action.payload);if(!(target==='Question')){_context.next=15;break;}_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_ducks_coreDataActions__["q" /* updateUgc */])(function(ugc){return ugc.update('ugc_related_content',function(l){return l.filter(function(ugc){return ugc.ugc_id!==ugc_id;});});},parent_ugc_id));case 13:_context.next=18;break;case 15:if(!(target==='Answer')){_context.next=18;break;}_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_ducks_coreDataActions__["j" /* removeUgc */])(ugc_id));case 18:_context.next=23;break;case 20:_context.prev=20;_context.t0=_context['catch'](6);actionToPut=Object(__WEBPACK_IMPORTED_MODULE_3__answerEditingActions__["b" /* deleteAnswerSync */])(_context.t0,action.payload);case 23:_context.prev=23;_context.next=26;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */],Object(__WEBPACK_IMPORTED_MODULE_7_ducks_SagaUtils__["a" /* boundedDelay */])(startTs));case 26:_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(actionToPut);case 28:return _context.finish(23);case 29:case'end':return _context.stop();}}},_marked,this,[[6,20,23,29]]);}function editAnswerSaga(action){var token,startTs,_action$payload2,ugc_id,parent_ugc_id,target,response,updatedUgc,updateAnswerProperties;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function editAnswerSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_7_ducks_SagaUtils__["c" /* selectToken */]);case 2:token=_context2.sent;startTs=Date.now();_action$payload2=action.payload,ugc_id=_action$payload2.ugc_id,parent_ugc_id=_action$payload2.parent_ugc_id,target=_action$payload2.target;_context2.prev=5;_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_ducks_coreDataApi__["e" /* updateResponse */],token,action.payload);case 8:response=_context2.sent;updatedUgc=__WEBPACK_IMPORTED_MODULE_8_models__["j" /* UGC */].createWithData({ugc:response});_context2.next=12;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */],Object(__WEBPACK_IMPORTED_MODULE_7_ducks_SagaUtils__["a" /* boundedDelay */])(startTs));case 12:_context2.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__answerEditingActions__["d" /* editAnswerSync */])(updatedUgc,action.payload));case 14:if(!(target==='Question')){_context2.next=19;break;}_context2.next=17;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_ducks_coreDataActions__["q" /* updateUgc */])(function(ugc){var idx=ugc.ugc_related_content.findIndex(function(ugc){return ugc.ugc_id===ugc_id;});return ugc.setIn(['ugc_related_content',idx],updatedUgc);},parent_ugc_id));case 17:_context2.next=23;break;case 19:if(!(target==='Answer')){_context2.next=23;break;}updateAnswerProperties=function updateAnswerProperties(ugc){// the response payload  does not include the question,
// so we need to add it to the new object
var existingQuestion=ugc.getQuestion();var answer=updatedUgc.answer,updated_date=updatedUgc.updated_date,author=updatedUgc.author,location=updatedUgc.location,ugc_related_content=updatedUgc.ugc_related_content;return ugc.merge({author:author,location:location,answer:answer,updated_date:updated_date,ugc_related_content:ugc_related_content.push(existingQuestion)});};_context2.next=23;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_ducks_coreDataActions__["q" /* updateUgc */])(updateAnswerProperties,ugc_id));case 23:_context2.next=31;break;case 25:_context2.prev=25;_context2.t0=_context2['catch'](5);_context2.next=29;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */],Object(__WEBPACK_IMPORTED_MODULE_7_ducks_SagaUtils__["a" /* boundedDelay */])(startTs));case 29:_context2.next=31;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__answerEditingActions__["d" /* editAnswerSync */])(_context2.t0,action.payload));case 31:case'end':return _context2.stop();}}},_marked2,this,[[5,25]]);}function saga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3__answerEditingActions__["a" /* deleteAnswer */],deleteAnswerSaga);case 2:_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3__answerEditingActions__["c" /* editAnswer */],editAnswerSaga);case 4:case'end':return _context3.stop();}}},_marked3,this);}

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnswerSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentSection__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ContentSection_UgcMetaInfo__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QAComponents__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AnswerArticle__ = __webpack_require__(249);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnswerSection=function(_React$Component){_inherits(AnswerSection,_React$Component);function AnswerSection(){_classCallCheck(this,AnswerSection);return _possibleConstructorReturn(this,(AnswerSection.__proto__||Object.getPrototypeOf(AnswerSection)).apply(this,arguments));}_createClass(AnswerSection,[{key:'render',value:function render(){var _props=this.props,ugc=_props.ugc,MetaInfoComponent=_props.MetaInfoComponent,subject=_props.subject,locale=_props.locale,allowMedia=_props.allowMedia;var parentUgc=ugc.getQuestion();return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ContentSection__["a" /* ContentSection */],null,parentUgc&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ContentSection__["a" /* ContentSection */].Section,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'o-40'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__QAComponents__["a" /* Article */],{ugc:parentUgc}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ContentSection__["a" /* ContentSection */].Divider,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ContentSection__["a" /* ContentSection */].Section,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__AnswerArticle__["a" /* AnswerArticle */],{ugc:ugc,viewContext:'Answer',subject:subject,locale:locale,parentUgcId:parentUgc.ugc_id,allowMedia:allowMedia})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ContentSection__["a" /* ContentSection */].Meta,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MetaInfoComponent,{model:ugc})));}}]);return AnswerSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AnswerSection.defaultProps={MetaInfoComponent:__WEBPACK_IMPORTED_MODULE_2_components_ContentSection_UgcMetaInfo__["b" /* ClientUgcMetaInfo */]};

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AddAnswer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QAComponents__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaUpload__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_auth_context__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_coreDataApi__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_alerts__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_click_outside__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnswerTextarea__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lib_nanoid__ = __webpack_require__(255);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(['answer-controls'],['answer-controls']),_templateObject2=_taggedTemplateLiteral(['answer-textarea'],['answer-textarea']),_templateObject3=_taggedTemplateLiteral(['media-input'],['media-input']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// $FlowIssue
var postResponse=Object(__WEBPACK_IMPORTED_MODULE_4_ducks_auth_context__["d" /* withAuthError */])(__WEBPACK_IMPORTED_MODULE_5_ducks_coreDataApi__["c" /* postResponse */]);function AddAnswerMain(props){var submitAnswer=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var data,response,errMessage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:'submit'});_context.prev=1;data={parent_ugc_id:questionId,subject_id:subject.subject_id,catalog_id:subject.merchant.id,locale:locale,ugc_type:'Answer',text:answerText,answer_media:Object(__WEBPACK_IMPORTED_MODULE_3__MediaUpload__["f" /* serializeResponseMedia */])(media,captions)};_context.next=5;return postResponse(token,data);case 5:response=_context.sent;onSubmit(__WEBPACK_IMPORTED_MODULE_7_models__["k" /* Ugcs */].createWithData({ugc:response}));reset();dispatch({type:'submit/success'});_context.next=16;break;case 11:_context.prev=11;_context.t0=_context['catch'](1);console.log(_context.t0);errMessage=_context.t0.status===403?'You do not have the necessary permissions to make this change.':'An error occurred while posting your response.';dispatch({type:'submit/fail',payload:errMessage});case 16:case'end':return _context.stop();}}},_callee,this,[[1,11]]);}));return function submitAnswer(){return _ref.apply(this,arguments);};}();var questionId=props.questionId,_props$allowMedia=props.allowMedia,allowMedia=_props$allowMedia===undefined?true:_props$allowMedia,subject=props.subject,locale=props.locale,onSubmit=props.onSubmit;var _useAuth=Object(__WEBPACK_IMPORTED_MODULE_4_ducks_auth_context__["c" /* useAuth */])(),token=_useAuth.token;var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useReducer"])(reducer,initialState()),_useReducer2=_slicedToArray(_useReducer,2),_useReducer2$=_useReducer2[0],isLoading=_useReducer2$.isLoading,answerText=_useReducer2$.answerText,error=_useReducer2$.error,isExpanded=_useReducer2$.isExpanded,dispatch=_useReducer2[1];var _useMediaUpload=Object(__WEBPACK_IMPORTED_MODULE_3__MediaUpload__["g" /* useMediaUpload */])(__WEBPACK_IMPORTED_MODULE_3__MediaUpload__["b" /* DEFAULT_MAX_MEDIA_ITEMS */]),media=_useMediaUpload.media,captions=_useMediaUpload.captions,canPersistMedia=_useMediaUpload.canPersistMedia,addFiles=_useMediaUpload.addFiles,uploadFile=_useMediaUpload.uploadFile,setCaption=_useMediaUpload.setCaption,removeFile=_useMediaUpload.removeFile,clearFiles=_useMediaUpload.clearFiles,reset=_useMediaUpload.reset,isModalOpen=_useMediaUpload.isModalOpen,toggleModal=_useMediaUpload.toggleModal,maxItems=_useMediaUpload.maxItems;var isOverMediaLimit=media.size>__WEBPACK_IMPORTED_MODULE_3__MediaUpload__["b" /* DEFAULT_MAX_MEDIA_ITEMS */];var answerIsEmpty=Boolean(answerText.trim())===false;var idRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(Object(__WEBPACK_IMPORTED_MODULE_11_lib_nanoid__["a" /* nanoid */])());function id(strings){return idRef.current+'-'+strings.join('-');}var answerControlsContainerId=id(_templateObject);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_click_outside___default.a,{onClickOutside:function onClickOutside(){return dispatch({type:'blur',payload:media.size===0&&answerIsEmpty&&!isModalOpen});},style:{opacity:isLoading?0.5:1,pointerEvents:isLoading?'none':'auto'}},error&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_alerts__["b" /* ErrorAlert */],null,error),isOverMediaLimit?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components_alerts__["a" /* Alert */],null,'You can only include '+__WEBPACK_IMPORTED_MODULE_3__MediaUpload__["b" /* DEFAULT_MAX_MEDIA_ITEMS */]+' media items.'):null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__AnswerTextarea__["a" /* AnswerTextarea */],{minRows:isExpanded?2:1,id:id(_templateObject2),'aria-controls':answerControlsContainerId,value:answerText,onChange:function onChange(e){return dispatch({type:'answer',payload:e.target.value});},placeholder:'Add an answer to this question',onFocus:function onFocus(){return dispatch({type:'focus'});}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('ul',{className:'list mv4 pa0'},Array.from(media.entries()).map(function(_ref2){var _ref3=_slicedToArray(_ref2,2),id=_ref3[0],item=_ref3[1];return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('li',{key:id,className:'flex items-start mb4'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MediaUpload__["d" /* MediaThumbnail */],{item:item,onDelete:removeFile}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MediaUpload__["a" /* CaptionTextarea */],{placeholder:'Add a caption...',value:captions.get(id)||'',onChange:function onChange(e){setCaption(id,e.target.value);}}));})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{style:{display:isExpanded?'flex':'none'},id:answerControlsContainerId,'aria-expanded':isExpanded},allowMedia&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MediaUpload__["e" /* MediaUploadControl */],{media:media,isOpen:isModalOpen,onToggle:toggleModal,onUpload:uploadFile,onDelete:removeFile,maxItems:maxItems,onAdd:addFiles,id:id(_templateObject3)}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{style:{marginLeft:'auto'}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('button',{className:'btn btn--small btn--link',onClick:function onClick(){clearFiles();dispatch({type:'cancel'});}},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('button',{className:__WEBPACK_IMPORTED_MODULE_9_classnames___default()('btn btn--small btn--primary',{'btn--loading':isLoading}),type:'submit',onClick:submitAnswer,disabled:answerIsEmpty||!canPersistMedia||isOverMediaLimit},'Submit'))));}function initialState(){return{answerText:'',isLoading:false,error:null,isExpanded:false};}function reducer(state,action){switch(action.type){case'focus':return Object.assign({},state,{isExpanded:true});case'blur':{var collapse=action.payload;return collapse?Object.assign({},state,{isExpanded:false}):state;}case'answer':{return Object.assign({},state,{answerText:action.payload});}case'submit':{return Object.assign({},state,{isLoading:true});}case'submit/success':return initialState();case'submit/fail':return Object.assign({},state,{isLoading:false,error:action.payload});case'cancel':return initialState();default:throw new Error('Unknown action type: '+action.type);}}function AddAnswer(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__QAComponents__["b" /* ArticleContainer */],{ugctype:'Answer',main:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](AddAnswerMain,props)});}

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__searchActions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_SagaUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_coreDataSaga__ = __webpack_require__(44);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchResults),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(_callee);function fetchResults(action){var _action$payload,query,method,token,response,responseFormatted,pwr_observations,grouped,itemsToPut,totalPages;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchResults$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,query=_action$payload.query,method=_action$payload.method;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_4_ducks_SagaUtils__["c" /* selectToken */]);case 3:token=_context.sent;_context.prev=4;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(method,token,query);case 7:response=_context.sent;responseFormatted=response;if(response.ugc_results){if(response.ugc_results.length===0){responseFormatted=response.ugc_results;}else{pwr_observations=response.pwr_observation_codes;// Group results by ugc_id to merge syndicated products
grouped={};response.ugc_results.forEach(function(ugc){var key=ugc.ugc_id;if(!grouped[key]){grouped[key]={primary:ugc,associated_products:[]};}grouped[key].associated_products.push({page_id:ugc.page_id,product_name:ugc.product_name,product_image_url:ugc.product_image_url});});responseFormatted=Object.values(grouped).map(function(_ref){var ugc=_ref.primary,associated_products=_ref.associated_products;var subject_id=ugc.subject_id,ugc_id=ugc.ugc_id,page_id=ugc.page_id,product_image_url=ugc.product_image_url,created_date=ugc.created_date,author=ugc.author,rating=ugc.rating,locale=ugc.locale,device_id=ugc.device_id,source=ugc.source,custom_observation_codes=ugc.custom_observation_codes,observations=ugc.observations,editable=ugc.editable,assignment_created_date=ugc.assignment_created_date,assignment_updated_date=ugc.assignment_updated_date,assigned_to=ugc.assigned_to,assigned_by=ugc.assigned_by,publication_status=ugc.publication_status;return{subject:{subject_id:subject_id,subject_type:'Product',name:ugc.product_name,page_id:page_id,product_image_url:product_image_url,associated_products:associated_products.length>1?associated_products:[],merchant:{id:ugc.catalog_id,group_id:ugc.client_id}},ugc:{ugc_id:ugc_id,subject_id:subject_id,created_date:created_date,author:author,review_headline:ugc.headline,review_comments:ugc.primary_contents,rating:rating,locale:locale,device_id:device_id,ugctype:ugc.ugc_type,source:source,assignment_created_date:assignment_created_date,assignment_updated_date:assignment_updated_date,assigned_to:assigned_to,assigned_by:assigned_by,editable:editable,published:publication_status==='APPROVED'?true:false},custom_observations:custom_observation_codes,existing_observations:observations,pwr_observations:pwr_observations};});}}_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_ducks_coreDataSaga__["b" /* addItemsTask */],{data:{items:responseFormatted}});case 12:itemsToPut=_context.sent;totalPages=response.total_pages!=null?response.total_pages:undefined;_context.next=16;return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_2__searchActions__["c" /* receiveSearchResults */])(itemsToPut.items,totalPages));case 16:_context.next=23;break;case 18:_context.prev=18;_context.t0=_context['catch'](4);console.error(_context.t0);_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__searchActions__["c" /* receiveSearchResults */])(_context.t0));case 23:case'end':return _context.stop();}}},_marked,this,[[4,18]]);}function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__searchActions__["d" /* requestSearchResults */],fetchResults);case 2:case'end':return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/network-icon.9a0fa869.png";

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ReviewSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_search__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__ = __webpack_require__(26);
function ReviewSearch(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_search__["a" /* default */],Object.assign({label:'Reviews',primaryFieldsets:__WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__["j" /* pwrDistroReviewFieldsets */].primaryFieldsets,extraFieldsets:__WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__["j" /* pwrDistroReviewFieldsets */].extraFieldsets},props));}

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MediaSearch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_search__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__ = __webpack_require__(26);
function MediaSearch(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_search__["a" /* default */],Object.assign({label:'Images & Video',primaryFieldsets:__WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__["e" /* PwrDistroMediaFieldsets */].primaryFieldsets,extraFieldsets:__WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__["e" /* PwrDistroMediaFieldsets */].extraFieldsets},props));}

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QuestionSearch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_search__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__ = __webpack_require__(26);
function QuestionSearch(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_search__["a" /* default */],Object.assign({label:'Questions',primaryFieldsets:__WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__["f" /* PwrDistroQuestionFieldsets */].primaryFieldsets,extraFieldsets:__WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__["f" /* PwrDistroQuestionFieldsets */].extraFieldsets},props));}

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AnswerSearch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_search__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__ = __webpack_require__(26);
function AnswerSearch(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_search__["a" /* default */],Object.assign({label:'Answers',primaryFieldsets:__WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__["d" /* PwrDistroAnswerFieldsets */].primaryFieldsets,extraFieldsets:__WEBPACK_IMPORTED_MODULE_2_containers_search_SearchForm__["d" /* PwrDistroAnswerFieldsets */].extraFieldsets},props));}

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reviews__ = __webpack_require__(712);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reviews__["a"]; });


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ugcSearchPathname */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_search_NativeReviews__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_search_Media__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_search_NetworkReviews__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_components_LandingPage__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers_UgcLinkContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_client_UgcAssignmentProvider__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_search_SearchForm_ugcSearchQuery__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReviewChannels__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_context_content_card_context__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_client_ClientProvider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_search_PwrDistribution__ = __webpack_require__(264);
// Commenting out until this ugc type is supported
var channelsRoute={exact:false,path:'channels',component:__WEBPACK_IMPORTED_MODULE_8__ReviewChannels__["a" /* default */],label:'Channels',navItem:true};var reviewSearchRoute={exact:false,path:'native-reviews',label:__WEBPACK_IMPORTED_MODULE_1_containers_search_NativeReviews__["a" /* default */].label,component:__WEBPACK_IMPORTED_MODULE_1_containers_search_NativeReviews__["a" /* default */],navItem:true};var networkSearchRoute={exact:false,path:'network-reviews',label:__WEBPACK_IMPORTED_MODULE_3_containers_search_NetworkReviews__["a" /* default */].label,component:__WEBPACK_IMPORTED_MODULE_3_containers_search_NetworkReviews__["a" /* default */],navItem:true};var mediaSearchRoute={exact:false,path:'images-and-video',label:__WEBPACK_IMPORTED_MODULE_2_containers_search_Media__["a" /* default */].label,component:__WEBPACK_IMPORTED_MODULE_2_containers_search_Media__["a" /* default */],navItem:true};var allRoutes=[channelsRoute,reviewSearchRoute,networkSearchRoute,mediaSearchRoute];var pwrDistroSearchRoutes=[channelsRoute,{exact:false,path:'reviews-search',label:'Reviews',component:__WEBPACK_IMPORTED_MODULE_11_containers_search_PwrDistribution__["a" /* ReviewSearch */],navItem:true},'sep',reviewSearchRoute,networkSearchRoute,mediaSearchRoute];var channelOnlySlice=[channelsRoute];var ugcSearchPathname=function ugcSearchPathname(ugc){if(ugc.ugc_archetype==='Review'){return reviewSearchRoute.path;}if(ugc.ugc_archetype==='Image'||ugc.ugc_archetype==='Video'){return mediaSearchRoute.path;}return null;};// we do not support linking when running network searches...for now
var locationSupportsUgcLinking=function locationSupportsUgcLinking(path){return path.indexOf(networkSearchRoute.path)===-1;};var ReviewsIndex=function ReviewsIndex(props){var clientProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10_containers_client_ClientProvider__["a" /* ClientContext */]);var routes=void 0;if(clientProps&&(clientProps.clientId===164195141||clientProps.clientId===1986404165||clientProps.clientId===380979969||clientProps.clientId===12846||clientProps.clientId===1901388221)){routes=pwrDistroSearchRoutes;}else if(props.access.search){routes=allRoutes;}else{routes=channelOnlySlice;}var linkFn=locationSupportsUgcLinking(props.location.pathname)?function(ugc){var searchPathname=ugcSearchPathname(ugc);return searchPathname!=null?['#'+props.match.url,searchPathname,'results?'+Object(__WEBPACK_IMPORTED_MODULE_7_containers_search_SearchForm_ugcSearchQuery__["a" /* default */])(ugc)].join('/'):null;}:null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_context_content_card_context__["a" /* ClientContentCardProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_containers_UgcLinkContext__["b" /* default */].Provider,{value:linkFn},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_containers_client_UgcAssignmentProvider__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_pages_components_LandingPage__["a" /* default */],Object.assign({label:'Reviews',routes:routes,landingRoute:'channels'},props)))));};/* harmony default export */ __webpack_exports__["a"] = (ReviewsIndex);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ugcAssignmentApi__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ugcAssignmentReducer__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_SagaUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ducks_coreDataActions__ = __webpack_require__(22);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(saga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(requestAssignmentSaga);function saga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__ugcAssignmentReducer__["f" /* requestAssignment */],requestAssignmentSaga);case 2:case'end':return _context.stop();}}},_marked,this);}function requestAssignmentSaga(action){var token,ugcId,payload,startTs;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function requestAssignmentSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_5_ducks_SagaUtils__["c" /* selectToken */]);case 2:token=_context2.sent;ugcId=action.payload.ugcId,payload=action.payload;startTs=Date.now();_context2.prev=5;_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1__ugcAssignmentApi__["a" /* default */],token,action.payload);case 8:_context2.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */],Object(__WEBPACK_IMPORTED_MODULE_5_ducks_SagaUtils__["a" /* boundedDelay */])(startTs));case 10:_context2.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7_ducks_coreDataActions__["q" /* updateUgc */])({assigned_to:payload.profileId},ugcId));case 12:_context2.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__ugcAssignmentReducer__["b" /* clearAssignment */])(ugcId));case 14:_context2.next=24;break;case 16:_context2.prev=16;_context2.t0=_context2['catch'](5);_context2.next=20;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__ugcAssignmentReducer__["e" /* receiveAssignment */])(_context2.t0,ugcId));case 20:_context2.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */],1000);case 22:_context2.next=24;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__ugcAssignmentReducer__["c" /* clearChangeStatus */])(ugcId));case 24:case'end':return _context2.stop();}}},_marked2,this,[[5,16]]);}

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createUgcAssignment */
/* unused harmony export deleteUgcAssignment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_fetch__ = __webpack_require__(213);
var createUgcAssignment=function createUgcAssignment(token,props){var clientId=props.clientId,profileId=props.profileId,ugcId=props.ugcId;var fetchUrl='/cdm/ugc/assign/'+ugcId;var fetchOptions={method:'POST',headers:{'Content-type':'application/json',Authorization:token},body:JSON.stringify({ugcId:ugcId,client_id:clientId,target_profile_id:profileId})};return Object(__WEBPACK_IMPORTED_MODULE_0_api_fetch__["a" /* default */])(fetchUrl,fetchOptions);};var deleteUgcAssignment=function deleteUgcAssignment(token,props){var clientId=props.clientId,ugcId=props.ugcId;var fetchUrl='/cdm/ugc/assign/'+ugcId;var fetchOptions={method:'DELETE',headers:{'Content-type':'application/json',Authorization:token},body:JSON.stringify({client_id:clientId})};return Object(__WEBPACK_IMPORTED_MODULE_0_api_fetch__["a" /* default */])(fetchUrl,fetchOptions);};/* harmony default export */ __webpack_exports__["a"] = (function(token,props){return props.profileId!=null?createUgcAssignment(token,props):deleteUgcAssignment(token,props);});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildQueryObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildQueryParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_fields_config__ = __webpack_require__(51);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function buildQueryObject(ugc){var _ref;var ugc_id=ugc.ugc_id,ugctype=ugc.ugctype,created_date=ugc.created_date;var dt=created_date&&created_date.split(/\s|T/).shift();return _ref={},_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_0__config_fields_config__["E" /* ugcId */].name,ugc_id),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_0__config_fields_config__["F" /* ugcTypeFieldName */],ugctype),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_0__config_fields_config__["B" /* startDate */].name,dt),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_0__config_fields_config__["k" /* endDate */].name,dt),_ref;}function buildQueryParams(ugc){var args=buildQueryObject(ugc);return Object.keys(args).map(function(key){return key+'='+args[key];}).join('&');}

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_channels_Channels__ = __webpack_require__(266);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReviewChannels=function(_React$PureComponent){_inherits(ReviewChannels,_React$PureComponent);function ReviewChannels(){_classCallCheck(this,ReviewChannels);return _possibleConstructorReturn(this,(ReviewChannels.__proto__||Object.getPrototypeOf(ReviewChannels)).apply(this,arguments));}_createClass(ReviewChannels,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_channels_Channels__["a" /* default */],Object.assign({ugctype:'Review'},this.props));}}]);return ReviewChannels;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (ReviewChannels);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Modal__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_async_value__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_alerts__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tchyns={recipientCell:'pv1 b--light-gray',recipientLabel:'db mv1 mid-gray'};var Recipient=function Recipient(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{className:Tchyns.recipientCell,'data-translate':false},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('label',{className:Tchyns.recipientLabel,htmlFor:props.id},props.children,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'ml3'},props.label)));};Recipient.Empty=function(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',null,'\xA0');};var ChannelAlert=function(_React$PureComponent){_inherits(ChannelAlert,_React$PureComponent);function ChannelAlert(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChannelAlert);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChannelAlert.__proto__||Object.getPrototypeOf(ChannelAlert)).call.apply(_ref,[this].concat(args))),_this),_this.state={alertedUsers:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(_this.props.currentAlertConfig.recipients.map(function(r){return r.profile_id;})),batch:_this.props.currentAlertConfig.batch||false},_this.handleRecipientChange=function(// e: Event & {
//   currentTarget: HTMLInputElement & { value: string, checked: boolean },
// }
e){var _e$currentTarget=e.currentTarget,sIndex=_e$currentTarget.value,alerted=_e$currentTarget.checked;var index=Number(sIndex);var item=_this.props.userProfiles[index];item&&_this.setState(function(_ref2){var alertedUsers=_ref2.alertedUsers;return{alertedUsers:alerted?alertedUsers.add(item.profile_id):alertedUsers.remove(item.profile_id)};});},_this.handleBulkRecipientChange=function(e){var alerted=e.currentTarget.checked;var userProfiles=_this.props.userProfiles;_this.setState({alertedUsers:alerted?Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(userProfiles.map(function(p){return p.profile_id;})):Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])()});},_this.handleSubmit=function(){var updatedRecipientlist=_this.state.alertedUsers.map(function(profile_id){return{profile_id:profile_id};}).toArray();_this.props.onSubmit(Object.assign({},_this.props.currentAlertConfig,{recipients:updatedRecipientlist,batch:_this.state.batch}));},_this.handleChannelAlertSubButtonClick=function(isBatchOptionSelected,e){_this.setState({batch:isBatchOptionSelected});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChannelAlert,[{key:'renderRecepients',value:function renderRecepients(){var _this2=this;var userProfiles=this.props.userProfiles;var alertedUsers=this.state.alertedUsers;var rows=userProfiles.reduce(function(acc,_,index,list){if(index%2===0){var rowKey='';var rowItems=list.slice(index,index+2).map(function(item,rIndex){if(item){var localIndex=index+rIndex;var _id='r-'+localIndex;rowKey+=_id;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Recipient,{id:_id,label:item.name,key:_id},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{type:'checkbox',checked:alertedUsers.has(item.profile_id),onChange:_this2.handleRecipientChange,value:localIndex,id:_id}));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Recipient.Empty,null);});acc.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',{key:rowKey},rowItems));}return acc;},[]);return rows;}},{key:'renderChangeStatus',value:function renderChangeStatus(changeStatus){if(changeStatus instanceof Error){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_alerts__["a" /* Alert */],null,'An error occurred while saving your changes.');}if(changeStatus===__WEBPACK_IMPORTED_MODULE_3_lib_async_value__["b" /* default */].Complete){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_alerts__["a" /* Alert */],null,'Your changes have been saved.');}return null;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.changeStatus===__WEBPACK_IMPORTED_MODULE_3_lib_async_value__["b" /* default */].Complete&&this.props.changeStatus==null){this.props.onClose();}}},{key:'render',value:function render(){var _props=this.props,title=_props.title,onClose=_props.onClose,userProfiles=_props.userProfiles,changeStatus=_props.changeStatus;var alertedUsers=this.state.alertedUsers;var allRecipientsSelected=alertedUsers.count()===userProfiles.length;var modalBodyContent=userProfiles.length===0?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ph4 pv6 tc relative gray',style:{width:'55em'}},'Could not find any users with permissions to receive alerts for this channel.'):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ph4 pv3 relative',style:{width:'55em'}},this.renderChangeStatus(changeStatus),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('header',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'f3 ma0 mb2 brandon'},'Manage Users')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('table',{className:'w-100 collapse'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tbody',null,userProfiles.length>1&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('tr',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('td',{colSpan:'2',className:Tchyns.recipientCell},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('label',{className:Tchyns.recipientLabel},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{type:'checkbox',checked:allRecipientsSelected,onChange:this.handleBulkRecipientChange}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'pl3 b'},'Select All')))),this.renderRecepients()))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('br',null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('section',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('header',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h3',{className:'f3 ma0 mb2 brandon'},'Manage Alerts')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex flex-row'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'ma0 mr4'},'Receive email alerts for content in this channel. Choose the frequency of your notifications.'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex-none nowrap'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ChannelAlertSubscriptionButtons,{isBatchOptionSelected:this.state.batch,handleSubButtonClick:this.handleChannelAlertSubButtonClick})))));return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Modal__["b" /* default */],{onClose:onClose},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Modal__["b" /* default */].Header,null,title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Modal__["b" /* default */].Body,null,modalBodyContent),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Modal__["b" /* default */].Footer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components__["c" /* Button */],{type:'button',className:'input-reset bg-blue white brandon b--none b pv2 ph3 f4 br1 shadow-hover pointer grow',onClick:this.handleSubmit,disabled:changeStatus===__WEBPACK_IMPORTED_MODULE_3_lib_async_value__["b" /* default */].Pending||userProfiles.length===0},changeStatus===__WEBPACK_IMPORTED_MODULE_3_lib_async_value__["b" /* default */].Pending?'Saving...':'Save')));}}]);return ChannelAlert;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);var ChannelAlertSubscriptionButtons=function(_React$PureComponent2){_inherits(ChannelAlertSubscriptionButtons,_React$PureComponent2);function ChannelAlertSubscriptionButtons(){_classCallCheck(this,ChannelAlertSubscriptionButtons);return _possibleConstructorReturn(this,(ChannelAlertSubscriptionButtons.__proto__||Object.getPrototypeOf(ChannelAlertSubscriptionButtons)).apply(this,arguments));}_createClass(ChannelAlertSubscriptionButtons,[{key:'render',value:function render(){var _this4=this;var isBatchOptionSelected=this.props.isBatchOptionSelected;var buttons=ChannelAlertSubscriptionButtons.buttonData.map(function(button){var isBatchOption=button.isBatchOption,buttonLabel=button.buttonLabel;var isActive=isBatchOptionSelected===isBatchOption;var className=__WEBPACK_IMPORTED_MODULE_6_classnames___default()('input-reset button-reset bg-animate pointer br1 f6 ph3 ba pv2 hover-shadow',{'bg-blue o-80 white':isActive,'bg-white blue hover-dark-blue':!isActive});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{key:buttonLabel,className:className,onClick:function onClick(e){return _this4.props.handleSubButtonClick(isBatchOption,e);}},buttonLabel);});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_components__["d" /* ButtonGroup */],null,buttons);}}]);return ChannelAlertSubscriptionButtons;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);ChannelAlertSubscriptionButtons.buttonData=[{buttonLabel:'Individual Alerts',isBatchOption:false},{buttonLabel:'Daily Batches',isBatchOption:true}];/* harmony default export */ __webpack_exports__["a"] = (ChannelAlert);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_channels_ChannelList__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChannelInfo__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__channelStatsActions__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ManageChannelAlertsButton__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChannelContentCollection__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_brand_engage_BrandEngageChannel__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ChannelContentQueue__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_brand_engage_brandEngageSearchApi__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_api_content_getChannelContent__ = __webpack_require__(738);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChannelListContainer=function(_React$Component){_inherits(ChannelListContainer,_React$Component);function ChannelListContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChannelListContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChannelListContainer.__proto__||Object.getPrototypeOf(ChannelListContainer)).call.apply(_ref,[this].concat(args))),_this),_this.state={channelMap:Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["Map"])(_this.props.channels.map(function(ch){return[ch.name,ch];}))},_this.requestChannelStats=function(channelName){var channel=_this.state.channelMap.get(channelName);if(channel){_this.props.requestChannelStats({channelName:channelName,clientId:_this.props.clientId});}},_this.requestChannelQueueStats=function(channelName){var channel=_this.state.channelMap.get(channelName);if(channel){_this.props.requestChannelStats({channelName:channelName,clientId:_this.props.clientId,worklist:true});}},_this.requestBrandEngageChannelStats=function(channelName){var channel=_this.state.channelMap.get(channelName);if(channel){_this.props.requestBrandEngageChannelStats({channelName:channelName,clientId:_this.props.clientId,brandEngageType:channel.brandEngageType});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChannelListContainer,[{key:'render',value:function render(){var _this2=this;var _props=this.props,match=_props.match,stats=_props.stats,worklistStats=_props.worklistStats,clientId=_props.clientId,onChannelSelect=_props.onChannelSelect,properties=_props.properties;var clientBrandEngageTier=properties.get('BRAND_ENGAGE_TIER');var channelRecords=this.props.channels;var moderationChannels=Array.isArray(channelRecords)?channelRecords.filter(function(channel){return Object(__WEBPACK_IMPORTED_MODULE_2__ChannelInfo__["h" /* isModerationChannel */])(channel);}):[];var brandEngageChannels=Array.isArray(channelRecords)?channelRecords.filter(function(channel){return Object(__WEBPACK_IMPORTED_MODULE_2__ChannelInfo__["f" /* isBrandEngageChannel */])(channel);}):[];var shouldShowChannelListHeader=moderationChannels.length>0&&brandEngageChannels.length>0;var modChannelContentType=moderationChannels.length>0&&moderationChannels[0].ugctype!=null?moderationChannels[0].ugctype:'Your';var modChannelHeaderText=shouldShowChannelListHeader?modChannelContentType+' Content Channels':null;var brandChannelHeaderText=shouldShowChannelListHeader?'Brand Engage Content Channels':null;var _moderationChannels$r=moderationChannels.reduce(function(acc,ch){var hasWorklist=ch.worklist!=null;var channelPath=makeChannelPath(match.url,ch);var channelWorklist=ch.worklist;var _acc=_slicedToArray(acc,2),items=_acc[0],routes=_acc[1];var item=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_channels_ChannelList__["a" /* default */].Item,{label:ch.label,description:ch.description,key:ch.name,channelName:ch.name,path:channelPath,count:stats.get(ch.name),ugctype:ch.contentUgctype,children:typeof onChannelSelect==='function'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ManageChannelAlertsButton__["a" /* default */],{channelName:ch.label,onClick:function onClick(){return onChannelSelect(ch);}}),requestChannelStats:_this2.requestChannelStats,hasWorklist:hasWorklist});var route=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{key:ch.name,exact:true,path:channelPath,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ChannelContentCollection__["a" /* default */],{clientId:clientId,channelName:ch.name,apiMethod:function apiMethod(token,endDateTime){return Object(__WEBPACK_IMPORTED_MODULE_13_api_content_getChannelContent__["a" /* default */])(token,Object.assign({clientId:clientId,channelName:ch.name},endDateTime&&{endDateTime:endDateTime}));}});}});items.push(item);routes.push(route);if(channelWorklist){var channelWorklistKey=ch.name+':worklist';var channelWorklistPath=makeChannelWorkListPath(match.url,ch);var _item=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_channels_ChannelList__["a" /* default */].WorkListItem,{label:ch.label,description:channelWorklist,key:channelWorklistKey,channelName:ch.name,path:channelWorklistPath,count:worklistStats.get(ch.name),requestChannelStats:_this2.requestChannelQueueStats});var _route=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{key:channelWorklistKey,exact:true,path:channelWorklistPath,render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ChannelContentQueue__["a" /* default */],{clientId:clientId,parentChannelName:ch.name});}});items.push(_item);routes.push(_route);}return acc;},[[],[]]),_moderationChannels$r2=_slicedToArray(_moderationChannels$r,2),moderationChannelListItems=_moderationChannels$r2[0],moderationChannelRoutes=_moderationChannels$r2[1];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{exact:true,path:match.url,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,moderationChannelListItems.length>0&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_channels_ChannelList__["a" /* default */],{header:modChannelHeaderText},moderationChannelListItems),brandEngageChannels.length>0&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_channels_ChannelList__["a" /* default */],{header:brandChannelHeaderText},brandEngageChannels.map(function(ch){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_channels_ChannelList__["a" /* default */].Item,{label:ch.label,description:ch.description,key:ch.name,channelName:ch.name,path:makeChannelPath(match.url,ch),count:stats.get(ch.name),children:typeof onChannelSelect==='function'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ManageChannelAlertsButton__["a" /* default */],{channelName:ch.label,onClick:function onClick(){return onChannelSelect(ch);}}),requestChannelStats:_this2.requestBrandEngageChannelStats,ugctype:ch.contentUgctype});})));}}),moderationChannelRoutes,brandEngageChannels.map(function(brandEngageChannel){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{key:brandEngageChannel.name,exact:true,path:makeChannelPath(match.url,brandEngageChannel),render:function render(props){if(Object(__WEBPACK_IMPORTED_MODULE_2__ChannelInfo__["e" /* isBrandEngageBrandChannel */])(brandEngageChannel)){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_containers_brand_engage_BrandEngageChannel__["a" /* default */],{name:brandEngageChannel.name,brandEngageType:brandEngageChannel.brandEngageType,brandEngageTier:clientBrandEngageTier,ugctype:brandEngageChannel.ugctype,clientId:clientId});}if(Object(__WEBPACK_IMPORTED_MODULE_2__ChannelInfo__["g" /* isBrandEngageRetailerChannel */])(brandEngageChannel)){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ChannelContentCollection__["a" /* default */],{clientId:clientId,channelName:brandEngageChannel.name,apiMethod:function apiMethod(token){return Object(__WEBPACK_IMPORTED_MODULE_12_containers_brand_engage_brandEngageSearchApi__["a" /* default */])(token,{clientId:clientId,channelName:brandEngageChannel.name,brandEngageType:brandEngageChannel.brandEngageType});}});}}});}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_components__["i" /* EmptyCard */],{title:'Error loading channel',message:'The channel you requested doesn\'t exist, or it might not be available to you. If you think this is an error, contact PowerReviews Support.'});}}));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props){return{channelMap:Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["Map"])(props.channels.map(function(ch){return[ch.name,ch];}))};}}]);return ChannelListContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{stats:state.channelStats.stats,worklistStats:state.channelStats.worklistStats};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,{requestChannelStats:__WEBPACK_IMPORTED_MODULE_5__channelStatsActions__["c" /* requestChannelStats */],requestBrandEngageChannelStats:__WEBPACK_IMPORTED_MODULE_5__channelStatsActions__["b" /* requestBrandEngageChannelStats */]})(ChannelListContainer));function makeChannelPath(matchUrl,channel){return matchUrl+'/'+channel.slug;}function makeChannelWorkListPath(matchUrl,channel){return makeChannelPath(matchUrl,channel)+'/worklist';}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ChannelList__count-loader":"ChannelList__count-loader","channelListCountLoader":"ChannelList__count-loader","ChannelCountAnimation":"ChannelCountAnimation","channelCountAnimation":"ChannelCountAnimation","ChannelList__item__count":"ChannelList__item__count","channelListItemCount":"ChannelList__item__count","ChannelList__item":"ChannelList__item","channelListItem":"ChannelList__item"};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(721),
    isIterateeCall = __webpack_require__(230),
    toFinite = __webpack_require__(235);

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min,
    nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = toFinite(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom();
    return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return baseRandom(lower, upper);
}

module.exports = random;


/***/ }),
/* 721 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(180);

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){var buttonText='Manage Users & Alerts';return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{'aria-label':buttonText+' for '+props.channelName,className:'ba bw0 link bg-white blue ma0 v-mid dim pointer nowrap brandon Channel__manage-alerts',type:'button',onClick:props.onClick},buttonText);});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Collection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ducks_channelContentActions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ducks_channelContentSaga__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ducks_coreDataActions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_ClientCard__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ducks_coreDataReducer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_components_ContentRequest__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ducks_routeActions__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_HandleRequestError__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EmptyChannelStates__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__channelContentSortUtils__ = __webpack_require__(726);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Collection=function(_React$PureComponent){_inherits(Collection,_React$PureComponent);function Collection(props){_classCallCheck(this,Collection);var _this=_possibleConstructorReturn(this,(Collection.__proto__||Object.getPrototypeOf(Collection)).call(this,props));_this.state={currentPage:1,pageMarkers:Object(__WEBPACK_IMPORTED_MODULE_12_immutable__["Map"])([[1,null]]),pageCounts:Object(__WEBPACK_IMPORTED_MODULE_12_immutable__["Map"])(),contentSortType:__WEBPACK_IMPORTED_MODULE_14__channelContentSortUtils__["b" /* ChannelContentSortTypeOptions */].SortByNewest};_this.changePage=function(nextPage){var items=_this.props.items;var _this$state=_this.state,currentPage=_this$state.currentPage,pageMarkers=_this$state.pageMarkers;var endDateTime=void 0;// when going back we should already have page marker
if(currentPage>nextPage){endDateTime=pageMarkers.get(nextPage);}else{endDateTime=items[items.length-1].ugc.created_date;}_this.setState({currentPage:nextPage,pageMarkers:pageMarkers.set(nextPage,endDateTime)});_this.actions.requestAction(endDateTime);};_this.onSortOptionChange=function(value){_this.setState({contentSortType:__WEBPACK_IMPORTED_MODULE_14__channelContentSortUtils__["b" /* ChannelContentSortTypeOptions */][value]});};var requestAction=function requestAction(endDateTime){return Object(__WEBPACK_IMPORTED_MODULE_4__ducks_channelContentActions__["c" /* requestChannelContent */])(props.apiMethod,props.channelName,endDateTime);};_this.actions=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({enterRoute:__WEBPACK_IMPORTED_MODULE_10_ducks_routeActions__["a" /* enterRoute */],exitRoute:__WEBPACK_IMPORTED_MODULE_10_ducks_routeActions__["b" /* exitRoute */],mountCollection:__WEBPACK_IMPORTED_MODULE_4__ducks_channelContentActions__["a" /* mountCollection */],unmountCollection:__WEBPACK_IMPORTED_MODULE_4__ducks_channelContentActions__["d" /* unmountCollection */],onChange:__WEBPACK_IMPORTED_MODULE_6_ducks_coreDataActions__["o" /* updateObservations */],onSubmit:__WEBPACK_IMPORTED_MODULE_6_ducks_coreDataActions__["n" /* requestObservationsUpdate */],requestAction:requestAction},_this.props.dispatch);return _this;}_createClass(Collection,[{key:'componentDidMount',value:function componentDidMount(){var channelName=this.props.channelName;this.actions.mountCollection(channelName);this.actions.enterRoute({saga:__WEBPACK_IMPORTED_MODULE_5__ducks_channelContentSaga__["a" /* default */],sagaArgs:[channelName],cb:this.actions.requestAction});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var nextItems=nextProps.items,nextRequestStatus=nextProps.requestStatus;var requestStatus=this.props.requestStatus;if(requestStatus==='pending'&&nextRequestStatus==='complete'){this.setState(function(prevState){var currentPage=prevState.currentPage,pageCounts=prevState.pageCounts;return{pageCounts:pageCounts.set(currentPage,nextItems.length)};});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var channelName=this.props.channelName;this.actions.unmountCollection(channelName);this.actions.exitRoute();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,items=_props.items,_props$requestStatus=_props.requestStatus,requestStatus=_props$requestStatus===undefined?null:_props$requestStatus,role=_props.role,clientId=_props.clientId;var _state=this.state,currentPage=_state.currentPage,pageCounts=_state.pageCounts;var currentPageCount=pageCounts.get(currentPage);var nextPageCount=pageCounts.get(currentPage+1);var itemsSortedBySortType=this.state.contentSortType.sortFunction(items);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_containers_HandleRequestError__["a" /* default */],{requestStatus:requestStatus,match:function match(err){return typeof err.status==='number'&&err.status>=400;},render:__WEBPACK_IMPORTED_MODULE_13__EmptyChannelStates__["b" /* RequestErrorMessage */]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_pages_components_ContentRequest__["a" /* default */],{requestStatus:requestStatus,render:function render(){if(currentPage===1&&currentPageCount===0){return Object(__WEBPACK_IMPORTED_MODULE_13__EmptyChannelStates__["a" /* NoItemsMessage */])();}if(currentPageCount===0){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components__["i" /* EmptyCard */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components__["i" /* EmptyCard */].Message,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,'There are no more results'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components__["c" /* Button */].Primary,{onClick:function onClick(){return _this2.changePage(currentPage-1);}},'Go back to previous page.')));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{style:{margin:'-1em 0 -0.5em',display:'flex',justifyContent:'space-between',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PaginationStatus,_this2.state),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex items-center'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'b mr3 mid-gray'},'Sort by:'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components__["q" /* Select */],{options:__WEBPACK_IMPORTED_MODULE_14__channelContentSortUtils__["a" /* ChannelContentSortDropdownOptions */],value:_this2.state.contentSortType,clearable:false,style:{width:'200px'},onChange:function onChange(v){return _this2.onSortOptionChange(v.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components__["g" /* CollectionItemTranisitionProvider */],{items:itemsSortedBySortType,itemKey:function itemKey(item){return item.moderationState.getUGCId();}},function(item){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_containers_ClientCard__["a" /* default */],{datum:item,dispatch:_this2.props.dispatch,role:role,clientId:clientId,onChange:_this2.actions.onChange,onSubmit:_this2.actions.onSubmit});}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PaginationNav,{currentPage:currentPage,currentPageCount:currentPageCount,nextPageCount:nextPageCount,onClick:_this2.changePage}));}}));}}]);return Collection;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);function PaginationNav(props){var currentPageCount=props.currentPageCount,currentPage=props.currentPage,nextPageCount=props.nextPageCount,onClick=props.onClick;if(typeof currentPageCount!=='number')return null;// page navigation is not necessary in this case
if(currentPageCount<100&&currentPage===1)return null;// when we determine the next page is empty we skip rendering
if(currentPage===1&&nextPageCount===0)return null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex justify-between'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components__["c" /* Button */],{className:'ChannelContent_NavButton ChannelContent_NavButton--prev',onClick:function(_onClick){function onClick(){return _onClick.apply(this,arguments);}onClick.toString=function(){return _onClick.toString();};return onClick;}(function(){return onClick(currentPage-1);}),disabled:currentPage<2},'Previous'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components__["c" /* Button */],{className:'ChannelContent_NavButton ChannelContent_NavButton--next',onClick:function(_onClick2){function onClick(){return _onClick2.apply(this,arguments);}onClick.toString=function(){return _onClick2.toString();};return onClick;}(function(){return onClick(currentPage+1);}),disabled:currentPageCount<100||nextPageCount===0},'Next'));}function PaginationStatus(props){var currentPage=props.currentPage,pageCounts=props.pageCounts;var currentPageCount=pageCounts.get(currentPage);var lastPageCount=pageCounts.get(pageCounts.size);var isFirstPage=currentPage===1;var content=void 0;if(isFirstPage&&currentPageCount===1){return null;}if(isFirstPage&&currentPageCount<100){content=currentPageCount+' items';}else{var potentiallyMoreItems=typeof lastPageCount==='number'&&lastPageCount<100?false:true;var totalItemCount=pageCounts.reduce(function(running,count){return running+count;},0);var first=isFirstPage?1:(currentPage-1)*100+1;var last=isFirstPage?100:first+currentPageCount-1;content=first+' - '+last+' of '+totalItemCount+(potentiallyMoreItems?'+':'')+' items';}return content&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'bg-silver white br-pill f6 pv1 ph2 PaginationStatus'},content);}var mapStateToProps=function mapStateToProps(state,ownProps){var channelContent=state.channelContent,coreData=state.coreData,auth=state.auth;var channelName=ownProps.channelName;var value=channelContent.get(channelName,'pending');var _ref=Array.isArray(value)?['complete',selectCoreData(coreData,value)]:[value,[]],_ref2=_slicedToArray(_ref,2),requestStatus=_ref2[0],items=_ref2[1];return{requestStatus:requestStatus,role:auth.role,items:items};};function selectCoreData(coreData,ids){return ids.reduce(function(acc,id){var datum=__WEBPACK_IMPORTED_MODULE_8_ducks_coreDataReducer__["a" /* CoreDataState */].getTheThings(coreData,id);if(datum!=null){acc.push(datum);}return acc;},[]);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Collection));

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channelContentActions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_SagaUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_coreDataSaga__ = __webpack_require__(44);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchChannelContent),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(_callee);function fetchChannelContent(action){var _action$payload,apiMethod,channelName,endDateTime,token,response,itemsToPut;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchChannelContent$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,apiMethod=_action$payload.apiMethod,channelName=_action$payload.channelName,endDateTime=_action$payload.endDateTime;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_4_ducks_SagaUtils__["c" /* selectToken */]);case 3:token=_context.sent;_context.prev=4;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(apiMethod,token,endDateTime);case 7:response=_context.sent;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_ducks_coreDataSaga__["b" /* addItemsTask */],{data:{items:response}});case 10:itemsToPut=_context.sent;_context.next=13;return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_2__channelContentActions__["b" /* receiveChannelContent */])(channelName,itemsToPut.items));case 13:_context.next=20;break;case 15:_context.prev=15;_context.t0=_context['catch'](4);console.error(_context.t0);_context.next=20;return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_2__channelContentActions__["b" /* receiveChannelContent */])(channelName,_context.t0));case 20:case'end':return _context.stop();}}},_marked,this,[[4,15]]);}function _callee(collectionId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__channelContentActions__["c" /* requestChannelContent */],fetchChannelContent);case 2:case'end':return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ChannelContentSortTypeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelContentSortDropdownOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ducks_coreDataReducer__ = __webpack_require__(29);
var sortByNewestContent=function sortByNewestContent(items){return items.sort(function(item1,item2){return new Date(item2.ugc.created_date).getTime()-new Date(item1.ugc.created_date).getTime();});};var sortByOldestContent=function sortByOldestContent(items){return items.sort(function(item1,item2){return new Date(item1.ugc.created_date).getTime()-new Date(item2.ugc.created_date).getTime();});};var ChannelContentSortTypeOptions={SortByNewest:{label:'Newest',value:'SortByNewest',sortFunction:sortByNewestContent},SortByOldest:{label:'Oldest',value:'SortByOldest',sortFunction:sortByOldestContent}};var ChannelContentSortDropdownOptions=[ChannelContentSortTypeOptions.SortByOldest,ChannelContentSortTypeOptions.SortByNewest];

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BrandEngageCardContainer__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__brandEngageActions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_HandleRequestError__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_components_ContentRequest__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BrandEngageChannel_scss__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BrandEngageChannel_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__BrandEngageChannel_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__brandEngageReducer__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__brandEngageSaga__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}Object(__WEBPACK_IMPORTED_MODULE_10_store__["b" /* injectReducer */])({brandEngage:__WEBPACK_IMPORTED_MODULE_8__brandEngageReducer__["a" /* default */]});Object(__WEBPACK_IMPORTED_MODULE_10_store__["c" /* injectSaga */])(__WEBPACK_IMPORTED_MODULE_9__brandEngageSaga__["a" /* default */]);var RequestErrorMessage=function RequestErrorMessage(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components__["i" /* EmptyCard */],{title:'This channel couldn\'t load.',message:'An Error occurred while fetching content. If this error persists, contact PowerReviews Support.'});};var isFreeTier=function isFreeTier(beType){return beType==='free';};var BrandEngageChannel=function(_React$Component){_inherits(BrandEngageChannel,_React$Component);function BrandEngageChannel(){_classCallCheck(this,BrandEngageChannel);return _possibleConstructorReturn(this,(BrandEngageChannel.__proto__||Object.getPrototypeOf(BrandEngageChannel)).apply(this,arguments));}_createClass(BrandEngageChannel,[{key:'componentDidMount',value:function componentDidMount(){this.props.requestBrandEngageSearchResults({clientId:this.props.clientId,channelName:this.props.name,brandEngageType:this.props.brandEngageType});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_containers_HandleRequestError__["a" /* default */],{requestStatus:this.props.requestStatus,match:function match(err){return typeof err.status==='number'&&err.status>=400;},render:RequestErrorMessage},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_pages_components_ContentRequest__["a" /* default */],{requestStatus:this.props.requestStatus,render:function render(){if(Array.isArray(_this2.props.items)&&_this2.props.items.length===0){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex flex-column'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'center tc mt4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components__["i" /* EmptyCard */].Title,null,'No Content'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_components__["i" /* EmptyCard */].Message,null,'This channel does not have any content.')));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,_this2.props.items.length>1&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{style:{margin:'-1em 0 -0.5em'}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'bg-silver white br-pill f6 pv1 ph2'},_this2.props.items.length,' items')),_this2.props.items.map(function(item){var containerClass=__WEBPACK_IMPORTED_MODULE_11_classnames___default()('mv4',_defineProperty({},__WEBPACK_IMPORTED_MODULE_7__BrandEngageChannel_scss___default.a.brandEngageChannelCardDismissed,_this2.props.dismissedUgcIds.has(item.ugc.ugc_id)));return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{key:item.ugc.ugc_id,className:containerClass},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__BrandEngageCardContainer__["a" /* default */],{clientId:_this2.props.clientId,product:item.subject,observations:item.observations,readonly:isFreeTier(_this2.props.brandEngageTier)&&_this2.props.ugctype==='Review'||undefined,ugc:item.ugc,status:_this2.props.requestStatus,brandCatalogId:item.brand_catalog_id,brandEngageResponseStatus:item.responseRequestStatus,dismissRequestStatus:item.dismissRequestStatus,requestBrandEngageAddResponse:_this2.props.requestBrandEngageAddResponse,requestBrandEngageDismissContent:_this2.props.requestBrandEngageDismissContent}));}));}}));}}]);return BrandEngageChannel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){var _state$brandEngage=state.brandEngage,ugcIds=_state$brandEngage.ugcIds,data=_state$brandEngage.data,responseRequestStatus=_state$brandEngage.responseRequestStatus,dismissRequestStatus=_state$brandEngage.dismissRequestStatus,dismissedUgcIds=_state$brandEngage.dismissedUgcIds;var items=ugcIds.reduce(function(acc,ugcId){var item=data.get(ugcId);if(item){item.responseRequestStatus=responseRequestStatus.get(ugcId);item.dismissRequestStatus=dismissRequestStatus.get(ugcId);acc.push(item);}return acc;},[]);return{requestStatus:state.brandEngage.requestStatus,dismissedUgcIds:dismissedUgcIds,items:items};}var mapDispatchToProps={requestBrandEngageSearchResults:__WEBPACK_IMPORTED_MODULE_3__brandEngageActions__["g" /* requestBrandEngageSearchResults */],requestBrandEngageAddResponse:__WEBPACK_IMPORTED_MODULE_3__brandEngageActions__["e" /* requestBrandEngageAddResponse */],requestBrandEngageDismissContent:__WEBPACK_IMPORTED_MODULE_3__brandEngageActions__["f" /* requestBrandEngageDismissContent */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(BrandEngageChannel));

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_BrandEngageCard_BrandEngageCard__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Common__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ContentSection_QASection__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ContentSection_ReviewResponse__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_models_Observation__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Container=function(_React$Component){_inherits(Container,_React$Component);function Container(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Container);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Container.__proto__||Object.getPrototypeOf(Container)).call.apply(_ref,[this].concat(args))),_this),_this.state={responseValue:'',responseStatus:null},_this.handleChange=function(nextState){if(!_this.state.pending){_this.setState(nextState);}},_this.handleResponseSubmit=function(){var addPayload={brand_catalog_id:_this.props.brandCatalogId,parent_ugc_id:_this.props.ugc.ugc_id,subject_id:_this.props.product.subject_id,catalog_id:_this.props.product.merchant.id,text:_this.state.responseValue,ugc_type:_this.props.ugc.ugc_archetype==='Review'?'BrandMerchantResponse':'BrandAnswer',locale:'en_US'};_this.props.requestBrandEngageAddResponse(addPayload,_this.props.ugc.ugc_id);},_this.handleResponseChange=function(value){return _this.setState({responseValue:value});},_this.handleDismiss=function(){var dismissPayload={ugc_id:_this.props.ugc.ugc_id,clientId:_this.props.clientId,observationPayload:[{catalog_id:_this.props.product.merchant.id,observation_type_code:__WEBPACK_IMPORTED_MODULE_6_models_Observation__["a" /* default */].BrandEngaged,observation_data:{comments:''},client_id:_this.props.product.merchant.group_id}]};_this.props.requestBrandEngageDismissContent(dismissPayload,_this.props.ugc.ugc_id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Container,[{key:'render',value:function render(){var _props=this.props,ugc=_props.ugc,readonly=_props.readonly;var placeholder=void 0;var buttonLabel=void 0;var hideTextBox=readonly===true||__WEBPACK_IMPORTED_MODULE_5_models__["j" /* UGC */].hasBrandResponseOrAnswer(ugc)||ugc.ugc_archetype==='Answer'||ugc.ugc_archetype==='MerchantResponse';if(this.props.ugc.ugc_archetype==='Question'){buttonLabel='Add Answer';placeholder='Add a brand answer to this question...';}else if(this.props.ugc.ugc_archetype==='Review'){buttonLabel='Add Response';placeholder='Add a brand response to this review...';}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_BrandEngageCard_BrandEngageCard__["a" /* default */],Object.assign({},this.props,{onDismiss:this.handleDismiss}),renderBrandResponse(this.props.ugc),!hideTextBox&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex flex-row'},this.props.ugc.ugc_archetype==='Question'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components_ContentSection_QASection__["b" /* QAItemIcon */],{ugctype:'Answer'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'flex-auto'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components_Common__["i" /* ResponseTextBox */],{name:'response',placeholder:placeholder,buttonLabel:buttonLabel,value:this.state.responseValue,onChange:this.handleResponseChange,onSubmit:this.handleResponseSubmit,status:this.props.brandEngageResponseStatus}))));}}]);return Container;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function renderBrandResponse(ugc){if(ugc instanceof __WEBPACK_IMPORTED_MODULE_5_models__["i" /* Review */]){var brandResponse=ugc.getBrandResponse();if(brandResponse){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_components_ContentSection_ReviewResponse__["a" /* SimpleResponse */],{ugc:brandResponse});}return null;}}/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BrandEngageCard_scss__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BrandEngageCard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BrandEngageCard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModerationCard_SectionSeparator__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Observation__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Common_Loader__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_alerts__ = __webpack_require__(71);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BrandEngageCard=function(_React$PureComponent){_inherits(BrandEngageCard,_React$PureComponent);function BrandEngageCard(){_classCallCheck(this,BrandEngageCard);return _possibleConstructorReturn(this,(BrandEngageCard.__proto__||Object.getPrototypeOf(BrandEngageCard)).apply(this,arguments));}_createClass(BrandEngageCard,[{key:'render',value:function render(){var _props=this.props,product=_props.product,ugc=_props.ugc,status=_props.status,children=_props.children,observations=_props.observations,dismissRequestStatus=_props.dismissRequestStatus,onDismiss=_props.onDismiss,readonly=_props.readonly;var pending=status==='pending';var dismissPending=dismissRequestStatus==='pending';var showDismissButton=readonly!==true&&shouldShowDismissButton(ugc,observations);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_4__BrandEngageCard_scss__["brandEngageCard"]},pending&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_4__BrandEngageCard_scss__["brandEngageCardOverlay"]}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_4__BrandEngageCard_scss__["brandEngageCardMain"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["n" /* ProductSection */],{model:product,key:product.subject_id,brandName:true,categoryName:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mb4'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ModerationCard_SectionSeparator__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["h" /* ContentSection */],{key:'cc-'+ugc.ugc_id,model:ugc,hideMeta:true,program:'brand'}),__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children,function(child){return child?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ModerationCard_SectionSeparator__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_4__BrandEngageCard_scss__["brandEngageCardSection"]},child)):null;})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_4__BrandEngageCard_scss__["brandEngageCardAside"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_4__BrandEngageCard_scss__["brandEngageCardSection"]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["p" /* RetailerAttribution */],{clientId:product.merchant.group_id,clientName:product.merchant.name,ugctype:getRetailerUgc(ugc).ugctype}),showDismissButton&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["c" /* Button */],{className:'w-100 white brandon mt3 f4',style:{backgroundColor:'#808284'},'data-test':'dismiss',onClick:onDismiss},dismissPending?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Common_Loader__["a" /* default */],{size:'1.5em',thickness:'0.15em'}):'Dismiss'),dismissRequestStatus instanceof Error&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_components__["a" /* AutoHide */],{delay:3000},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('br',null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_components_alerts__["a" /* Alert */],null,'Error dismissing content.'))))));}}]);return BrandEngageCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);// In some cases the primary ugc is not the retailer ugc
// For attribution we need to find the retailer ugc (which is the parent ugctype)
// i.e Review | Question
BrandEngageCard.defaultProps={product:new __WEBPACK_IMPORTED_MODULE_2_models__["f" /* Product */]()};function getRetailerUgc(primaryUgc){if(primaryUgc.ugctype==='BrandAnswer'){return primaryUgc.ugc_related_content.find(function(r){return r.ugctype==='Question';});}else if(primaryUgc.ugctype==='BrandMerchantResponse'){return primaryUgc.ugc_related_content.find(function(r){return r.ugc_archetype==='Review';});}return primaryUgc;}function shouldShowDismissButton(ugc,observations){var isDismissableUgcType=ugc.ugctype==='Question'||ugc.ugc_archetype==='Review';var isDismissed=observations.has(__WEBPACK_IMPORTED_MODULE_6__models_Observation__["a" /* default */].BrandEngaged);var hasBrandResponseOrAnswer=__WEBPACK_IMPORTED_MODULE_2_models__["j" /* UGC */].hasBrandResponseOrAnswer(ugc);return isDismissableUgcType&&!isDismissed&&!hasBrandResponseOrAnswer;}/* harmony default export */ __webpack_exports__["a"] = (BrandEngageCard);

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"c-overlay":"c-overlay","cOverlay":"c-overlay","BrandEngageCard__overlay":"BrandEngageCard__overlay","brandEngageCardOverlay":"BrandEngageCard__overlay","c-overlay--visible":"c-overlay--visible","cOverlayVisible":"c-overlay--visible","c-overlay--fullpage":"c-overlay--fullpage","cOverlayFullpage":"c-overlay--fullpage","c-overlay--transparent":"c-overlay--transparent","cOverlayTransparent":"c-overlay--transparent","c-overlay--dismissable":"c-overlay--dismissable","cOverlayDismissable":"c-overlay--dismissable","o-field":"o-field","oField":"o-field","c-field":"c-field","cField":"c-field","c-icon":"c-icon","cIcon":"c-icon","BrandEngageCard__response-field":"BrandEngageCard__response-field","brandEngageCardResponseField":"BrandEngageCard__response-field","BrandEngageCard__notes-field":"BrandEngageCard__notes-field","brandEngageCardNotesField":"BrandEngageCard__notes-field","o-field--icon-right":"o-field--icon-right","oFieldIconRight":"o-field--icon-right","o-field--icon-left":"o-field--icon-left","oFieldIconLeft":"o-field--icon-left","c-fieldset":"c-fieldset","cFieldset":"c-fieldset","c-list":"c-list","cList":"c-list","c-fieldset__legend":"c-fieldset__legend","cFieldsetLegend":"c-fieldset__legend","c-label":"c-label","cLabel":"c-label","c-field--label":"c-field--label","cFieldLabel":"c-field--label","c-field--error":"c-field--error","cFieldError":"c-field--error","c-field--success":"c-field--success","cFieldSuccess":"c-field--success","c-field--choice":"c-field--choice","cFieldChoice":"c-field--choice","c-fieldset--disabled":"c-fieldset--disabled","cFieldsetDisabled":"c-fieldset--disabled","c-field--disabled":"c-field--disabled","cFieldDisabled":"c-field--disabled","BrandEngageCard":"BrandEngageCard","brandEngageCard":"BrandEngageCard","BrandEngageCard__main":"BrandEngageCard__main","brandEngageCardMain":"BrandEngageCard__main","BrandEngageCard__aside":"BrandEngageCard__aside","brandEngageCardAside":"BrandEngageCard__aside","BrandEngageCard__aside__aside":"BrandEngageCard__aside__aside","brandEngageCardAsideAside":"BrandEngageCard__aside__aside","BrandEngageCard__section":"BrandEngageCard__section","brandEngageCardSection":"BrandEngageCard__section","BrandEngageCard__section__heading":"BrandEngageCard__section__heading","brandEngageCardSectionHeading":"BrandEngageCard__section__heading","BrandEngageCard__aside-button":"BrandEngageCard__aside-button","brandEngageCardAsideButton":"BrandEngageCard__aside-button","c-button--active":"c-button--active","cButtonActive":"c-button--active"};

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BrandEngageChannel__Card--Dismissed":"BrandEngageChannel__Card--Dismissed","brandEngageChannelCardDismissed":"BrandEngageChannel__Card--Dismissed"};

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__brandEngageActions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_models__ = __webpack_require__(5);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var defaultState={requestStatus:null,data:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),ugcIds:[],responseRequestStatus:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),dismissRequestStatus:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),dismissedUgcIds:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])()};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__brandEngageActions__["g" /* requestBrandEngageSearchResults */].toString(),function(state,action){return Object.assign({},state,{requestStatus:'pending'});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__brandEngageActions__["c" /* receiveBrandEngageSearchResults */].toString(),function(state,action){var error=action.error,payload=action.payload;if(error===true){return Object.assign({},state,{requestStatus:payload});}return Object.assign({},state,{requestStatus:'complete',data:payload[1],ugcIds:payload[0]});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__brandEngageActions__["e" /* requestBrandEngageAddResponse */].toString(),function(state,action){var parentUgcId=action.meta;return Object.assign({},state,{responseRequestStatus:state.responseRequestStatus.set(parentUgcId,'pending')});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__brandEngageActions__["a" /* receiveBrandEngageAddResponse */].toString(),function(state,action){if(action.error){return Object.assign({},state,{responseRequestStatus:state.responseRequestStatus.set(action.meta,action.payload)});}var parentUgcId=action.meta,childUgc=action.payload;var _state$data$get=state.data.get(parentUgcId),ugc=_state$data$get.ugc,rest=_objectWithoutProperties(_state$data$get,['ugc']);var updatedUgc=ugc.update('ugc_related_content',function(l){return l.push(childUgc);});return Object.assign({},state,{responseRequestStatus:state.responseRequestStatus.set(parentUgcId,'complete'),data:state.data.set(parentUgcId,Object.assign({},rest,{ugc:updatedUgc}))});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__brandEngageActions__["f" /* requestBrandEngageDismissContent */].toString(),function(state,action){var ugc_id=action.meta;return Object.assign({},state,{dismissRequestStatus:state.dismissRequestStatus.set(ugc_id,'pending')});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__brandEngageActions__["b" /* receiveBrandEngageDismissContent */].toString(),function(state,action){var ugc_id=action.meta,error=action.error;if(error===true){return Object.assign({},state,{dismissRequestStatus:state.dismissRequestStatus.set(ugc_id,action.payload)});}var _state$data$get2=state.data.get(ugc_id),prevObservations=_state$data$get2.observations,otherDataItems=_objectWithoutProperties(_state$data$get2,['observations']);var observations=prevObservations?prevObservations.add(__WEBPACK_IMPORTED_MODULE_3_models__["e" /* Observation */].BrandEngaged):Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])([__WEBPACK_IMPORTED_MODULE_3_models__["e" /* Observation */].BrandEngaged]);return Object.assign({},state,{data:state.data.set(ugc_id,Object.assign({},otherDataItems,{observations:observations})),dismissRequestStatus:state.dismissRequestStatus.remove(ugc_id),dismissedUgcIds:state.dismissedUgcIds.add(ugc_id)});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__brandEngageActions__["d" /* removeDismissedItem */].toString(),function(state,action){var ugc_id=action.payload;return Object.assign({},state,{data:state.data.remove(ugc_id),dismissedUgcIds:state.dismissedUgcIds.remove(ugc_id)});}),_handleActions),defaultState));

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export deleteDismissedContentTask */
/* unused harmony export dismissBrandEngageTask */
/* unused harmony export respondBrandEngageTask */
/* harmony export (immutable) */ __webpack_exports__["a"] = brandEngageSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__brandEngageSearchApi__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_models_Product__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_models_Ugc__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__brandEngageActions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ducks_coreDataApi__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_saga__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_immutable__);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteDismissedContentTask),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(dismissBrandEngageTask),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(respondBrandEngageTask),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(searchSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(brandEngageSaga);function deleteDismissedContentTask(action){var error,ugc_id;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteDismissedContentTask$(_context){while(1){switch(_context.prev=_context.next){case 0:error=action.error,ugc_id=action.meta;if(!(error===true)){_context.next=3;break;}return _context.abrupt('return');case 3:_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_8_redux_saga__["b" /* delay */],500);case 5:_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__brandEngageActions__["d" /* removeDismissedItem */])(ugc_id));case 7:case'end':return _context.stop();}}},_marked,this);}function dismissBrandEngageTask(action){var payload,token,startTs,actionToPut,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function dismissBrandEngageTask$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:payload=action.payload;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["c" /* selectToken */]);case 3:token=_context2.sent;startTs=Date.now();actionToPut=void 0;_context2.prev=6;_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_7_ducks_coreDataApi__["b" /* postObservations */],token,{ugcId:payload.ugc_id,body:payload.observationPayload,clientId:payload.clientId});case 9:response=_context2.sent;actionToPut=Object(__WEBPACK_IMPORTED_MODULE_6__brandEngageActions__["b" /* receiveBrandEngageDismissContent */])(response,payload.ugc_id);_context2.next=17;break;case 13:_context2.prev=13;_context2.t0=_context2['catch'](6);console.error(_context2.t0);actionToPut=Object(__WEBPACK_IMPORTED_MODULE_6__brandEngageActions__["b" /* receiveBrandEngageDismissContent */])(_context2.t0,payload.ugc_id);case 17:_context2.prev=17;_context2.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_8_redux_saga__["b" /* delay */],Object(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["a" /* boundedDelay */])(startTs));case 20:_context2.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(actionToPut);case 22:return _context2.finish(17);case 23:case'end':return _context2.stop();}}},_marked2,this,[[6,13,17,23]]);}function respondBrandEngageTask(action){var payload,token,startTs,actionToPut,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function respondBrandEngageTask$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:payload=action.payload;_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["c" /* selectToken */]);case 3:token=_context3.sent;startTs=Date.now();actionToPut=void 0;_context3.prev=6;_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_7_ducks_coreDataApi__["c" /* postResponse */],token,payload);case 9:response=_context3.sent;actionToPut=Object(__WEBPACK_IMPORTED_MODULE_6__brandEngageActions__["a" /* receiveBrandEngageAddResponse */])(__WEBPACK_IMPORTED_MODULE_5_models_Ugc__["a" /* default */].createWithData({ugc:response}),payload.parent_ugc_id);_context3.next=17;break;case 13:_context3.prev=13;_context3.t0=_context3['catch'](6);console.error(_context3.t0);actionToPut=Object(__WEBPACK_IMPORTED_MODULE_6__brandEngageActions__["a" /* receiveBrandEngageAddResponse */])(_context3.t0,payload.parent_ugc_id);case 17:_context3.prev=17;_context3.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_8_redux_saga__["b" /* delay */],Object(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["a" /* boundedDelay */])(startTs));case 20:_context3.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(actionToPut);case 22:return _context3.finish(17);case 23:case'end':return _context3.stop();}}},_marked3,this,[[6,13,17,23]]);}function searchSaga(action){var token,_action$payload,clientId,channelName,brandEngageType,rawResults,_rawResults$reduce,ids,itemsById;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function searchSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_3_ducks_SagaUtils__["c" /* selectToken */]);case 2:token=_context4.sent;_action$payload=action.payload,clientId=_action$payload.clientId,channelName=_action$payload.channelName,brandEngageType=_action$payload.brandEngageType;_context4.prev=4;_context4.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__brandEngageSearchApi__["a" /* default */],token,{brandEngageType:brandEngageType,clientId:clientId,channelName:channelName});case 7:rawResults=_context4.sent;_rawResults$reduce=rawResults.reduce(function(acc,item){var ugc=__WEBPACK_IMPORTED_MODULE_5_models_Ugc__["a" /* default */].createWithData(item);var ugcId=ugc.ugc_id;acc.ids.push(ugcId);acc.itemsById=acc.itemsById.set(ugcId,{subject:__WEBPACK_IMPORTED_MODULE_4_models_Product__["a" /* default */].createWithData(item),ugc:ugc,observations:Object(__WEBPACK_IMPORTED_MODULE_9_immutable__["Set"])(item.existing_observations.map(function(ob){return ob.observation_type_code;})),brand_catalog_id:item.brand_catalog.catalog_id});return acc;},{ids:[],itemsById:Object(__WEBPACK_IMPORTED_MODULE_9_immutable__["Map"])()}),ids=_rawResults$reduce.ids,itemsById=_rawResults$reduce.itemsById;_context4.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__brandEngageActions__["c" /* receiveBrandEngageSearchResults */])([ids,itemsById],action.payload));case 11:_context4.next=17;break;case 13:_context4.prev=13;_context4.t0=_context4['catch'](4);_context4.next=17;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__brandEngageActions__["c" /* receiveBrandEngageSearchResults */])(_context4.t0,action.payload));case 17:case'end':return _context4.stop();}}},_marked4,this,[[4,13]]);}function brandEngageSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function brandEngageSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__brandEngageActions__["g" /* requestBrandEngageSearchResults */],searchSaga);case 2:_context5.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_6__brandEngageActions__["e" /* requestBrandEngageAddResponse */],respondBrandEngageTask);case 4:_context5.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_6__brandEngageActions__["f" /* requestBrandEngageDismissContent */],dismissBrandEngageTask);case 6:_context5.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_6__brandEngageActions__["b" /* receiveBrandEngageDismissContent */],deleteDismissedContentTask);case 8:case'end':return _context5.stop();}}},_marked5,this);}

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var _removePIIFromUgc=function _removePIIFromUgc(ugc){if(ugc.ugctype==='BrandMerchantResponse'||ugc.ugctype==='BrandAnswer'||ugc.ugctype==='SeededQuestion'||ugc.ugctype==='SeededAnswer'){return ugc;}var location=ugc.location,author=ugc.author,rest=_objectWithoutProperties(ugc,['location','author']);return rest;};var removePIIFromUgc=function removePIIFromUgc(ugc){return Object.assign({},_removePIIFromUgc(ugc),{ugc_related_content:Array.isArray(ugc.ugc_related_content)?ugc.ugc_related_content.map(_removePIIFromUgc):ugc.ugc_related_content});};/* harmony default export */ __webpack_exports__["a"] = (removePIIFromUgc);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models_Observation__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_ClientCard__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__channelContentQueueActions__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__channelContentQueueSaga__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_HandleRequestError__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_components_ContentRequest__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EmptyChannelStates__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ducks_coreDataReducer__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}Object(__WEBPACK_IMPORTED_MODULE_10_store__["c" /* injectSaga */])(__WEBPACK_IMPORTED_MODULE_5__channelContentQueueSaga__["a" /* default */]);var ChannelContentQueue=function(_React$Component){_inherits(ChannelContentQueue,_React$Component);function ChannelContentQueue(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChannelContentQueue);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChannelContentQueue.__proto__||Object.getPrototypeOf(ChannelContentQueue)).call.apply(_ref,[this].concat(args))),_this),_this.state={isNextDisabled:true},_this.requestNextContent=function(){_this.props.requestContent();_this.setState({isNextDisabled:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChannelContentQueue,[{key:'componentDidMount',value:function componentDidMount(){this.props.requestContent();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _props=this.props,ugcAssignment=_props.ugcAssignment,observationsSaved=_props.observationsSaved,relatedContentOfSelectedUgc=_props.relatedContentOfSelectedUgc,selectedUgcId=_props.selectedUgcId;var ugcAssignmentChanged=prevProps.ugcAssignment.size===0&&ugcAssignment.size>0;var observationWasSaved=prevProps.observationsSaved!==observationsSaved&&observationsSaved===true;var wasResponseOrAnswerAdded=prevProps.relatedContentOfSelectedUgc!==relatedContentOfSelectedUgc&&prevProps.selectedUgcId===selectedUgcId;if(ugcAssignmentChanged||observationWasSaved||wasResponseOrAnswerAdded)this.setState({isNextDisabled:false});}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,datum=_props2.datum,clientId=_props2.clientId,requestStatus=_props2.contentRequestStatus,selectedUgcId=_props2.selectedUgcId,dispatch=_props2.dispatch;var isNextDisabled=this.state.isNextDisabled;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_containers_HandleRequestError__["a" /* default */],{requestStatus:requestStatus,match:function match(err){return typeof err.status==='number'&&err.status>=400;},render:__WEBPACK_IMPORTED_MODULE_8__EmptyChannelStates__["b" /* RequestErrorMessage */]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_pages_components_ContentRequest__["a" /* default */],{requestStatus:requestStatus,render:function render(){if(selectedUgcId===-1){return Object(__WEBPACK_IMPORTED_MODULE_8__EmptyChannelStates__["a" /* NoItemsMessage */])();}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'mv4 flex justify-end'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('button',{className:'SubmitButton f4 ph4',disabled:isNextDisabled,onClick:_this2.requestNextContent},'Next')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__containers_ClientCard__["a" /* default */],{datum:datum,dispatch:dispatch,clientId:clientId}));}}));}}]);return ChannelContentQueue;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){var session=state.channelContentQueue,coreData=state.coreData,ugcAssignment=state.ugcAssignment;var currentClient=ownProps.clientId;var ugcId=session.ugcId;var moderationStateOfUgcId=coreData.moderationStates.get(ugcId);var relatedContentOfSelectedUgc=coreData.ugcs.has(ugcId)?coreData.ugcs.get(ugcId).ugc_related_content:null;return{datum:__WEBPACK_IMPORTED_MODULE_9_ducks_coreDataReducer__["a" /* CoreDataState */].getTheThings(coreData,ugcId),contentRequestStatus:session.contentRequestStatus,observationsSaved:moderationStateOfUgcId&&moderationStateOfUgcId.currentObservations.has(currentClient)?moderationStateOfUgcId.currentObservations.get(currentClient).has(__WEBPACK_IMPORTED_MODULE_2_models_Observation__["a" /* default */].ClientModerationCode):false,selectedUgcId:ugcId,ugcAssignment:ugcAssignment,relatedContentOfSelectedUgc:relatedContentOfSelectedUgc};}var mergeProps=function mergeProps(stateProps,_ref2,ownProps){var dispatch=_ref2.dispatch;var clientId=ownProps.clientId,channelName=ownProps.parentChannelName;return Object.assign({},ownProps,stateProps,{dispatch:dispatch,requestContent:function requestContent(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__channelContentQueueActions__["c" /* requestClientQueueContent */])({clientId:clientId,channelName:channelName}));}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,undefined,mergeProps)(ChannelContentQueue));

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export requestModerateClientQueueContent */
/* harmony export (immutable) */ __webpack_exports__["a"] = clientQueueModerateSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getClientModerationContentApi__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channelContentQueueActions__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_coreDataSaga__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ducks_SagaUtils__ = __webpack_require__(24);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(requestModerateClientQueueContent),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(clientQueueModerateSaga);function requestModerateClientQueueContent(action){var token,_action$payload,clientId,channelName,data,ugc_id;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function requestModerateClientQueueContent$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6_ducks_SagaUtils__["c" /* selectToken */]);case 2:token=_context.sent;_action$payload=action.payload,clientId=_action$payload.clientId,channelName=_action$payload.channelName;_context.prev=4;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__getClientModerationContentApi__["a" /* default */],token,clientId,channelName);case 7:data=_context.sent;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_ducks_coreDataSaga__["a" /* addItemTask */],{data:data,clientId:clientId});case 10:ugc_id=_context.sent;_context.next=13;return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */].resolve(Object(__WEBPACK_IMPORTED_MODULE_3__channelContentQueueActions__["a" /* receiveClientQueueContent */])({ugc_id:ugc_id}));case 13:_context.next=19;break;case 15:_context.prev=15;_context.t0=_context['catch'](4);_context.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__channelContentQueueActions__["b" /* receiveClientQueueError */])(_context.t0));case 19:case'end':return _context.stop();}}},_marked,this,[[4,15]]);}function clientQueueModerateSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function clientQueueModerateSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__channelContentQueueActions__["c" /* requestClientQueueContent */],requestModerateClientQueueContent);case 2:case'end':return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
var getClientChannelQueueContent=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function getChannelContent(token,clientId,channelName){var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/moderate/content/client/'+clientId+'/channel/'+channelName+'/queue');var fetchOptions={headers:{Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){if(response.status===204){return[];}return response.json();}).then(function(json){return Array.isArray(json)?json:[json];});});/* harmony default export */ __webpack_exports__["a"] = (getClientChannelQueueContent);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_cache__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lru_cache__);
var cache=__WEBPACK_IMPORTED_MODULE_3_lru_cache___default()({max:5,maxAge:1000*60*5});// 5 mins max age
var getChannelContent=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function getChannelContent(token,_ref){var clientId=_ref.clientId,channelName=_ref.channelName,endDateTime=_ref.endDateTime;var queryString=endDateTime?'?end_date_time='+endDateTime:'';var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/moderate/content/client/'+clientId+'/channel/'+channelName+queryString);var fetchOptions={headers:{Authorization:token}};if(cache.has(fetchUrl)){var data=cache.get(fetchUrl);if(data){// this probably shouldn't be here
// we introduce a delay so the spinner shows up and the page
// looks less jerky
return new Promise(function(resolve){return setTimeout(resolve,10,data);});// return Promise.resolve(data);
}}return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){if(response.status===204){return[];}return response.json();}).then(function(json){return Array.isArray(json)?json:[json];}).then(function(response){cache.set(fetchUrl,response);return response;});});/* harmony default export */ __webpack_exports__["a"] = (getChannelContent);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channelStatsSaga__ = __webpack_require__(740);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(_callee);function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(__WEBPACK_IMPORTED_MODULE_2__channelStatsSaga__["a" /* default */]);case 2:case'end':return _context.stop();}}},_marked,this);}

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channelStatsActions__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channelStatsApi__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_SagaUtils__ = __webpack_require__(24);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchChannelStats),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchBrandEngageChannelStats),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(_callee);function fetchChannelStats(action){var token,_action$payload,clientId,channelName,worklist,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchChannelStats$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_4_ducks_SagaUtils__["c" /* selectToken */]);case 2:token=_context.sent;_action$payload=action.payload,clientId=_action$payload.clientId,channelName=_action$payload.channelName,worklist=_action$payload.worklist;_context.prev=4;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3__channelStatsApi__["a" /* getChannelStats */],token,clientId,channelName,worklist);case 7:response=_context.sent;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__channelStatsActions__["a" /* receiveChannelStats */])(response,action.payload));case 10:_context.next=16;break;case 12:_context.prev=12;_context.t0=_context['catch'](4);_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__channelStatsActions__["a" /* receiveChannelStats */])(_context.t0,action.payload));case 16:case'end':return _context.stop();}}},_marked,this,[[4,12]]);}function fetchBrandEngageChannelStats(action){var token,_action$payload2,clientId,channelName,brandEngageType,response,count;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchBrandEngageChannelStats$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_4_ducks_SagaUtils__["c" /* selectToken */]);case 2:token=_context2.sent;_action$payload2=action.payload,clientId=_action$payload2.clientId,channelName=_action$payload2.channelName,brandEngageType=_action$payload2.brandEngageType;_context2.prev=4;_context2.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3__channelStatsApi__["b" /* getbrandEngageChannelsStats */],token,brandEngageType,clientId,channelName);case 7:response=_context2.sent;count=_defineProperty({},channelName,+response);_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__channelStatsActions__["a" /* receiveChannelStats */])(count,action.payload));case 11:_context2.next=17;break;case 13:_context2.prev=13;_context2.t0=_context2['catch'](4);_context2.next=17;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__channelStatsActions__["a" /* receiveChannelStats */])(_context2.t0,action.payload));case 17:case'end':return _context2.stop();}}},_marked2,this,[[4,13]]);}function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__channelStatsActions__["c" /* requestChannelStats */],fetchChannelStats);case 2:_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__channelStatsActions__["b" /* requestBrandEngageChannelStats */],fetchBrandEngageChannelStats);case 4:case'end':return _context3.stop();}}},_marked3,this);}

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChannelStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getbrandEngageChannelsStats; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_cache__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lru_cache__);
var cache=__WEBPACK_IMPORTED_MODULE_3_lru_cache___default()({max:30});var getChannelStats=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function getChannelStats(token,clientId,channelName,worklist){var key=[clientId,channelName,worklist].join(':');if(cache.has(key)){var response=cache.get(key);if(response)return Promise.resolve(response);}var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/moderate/content/client/'+clientId+'/channelStats'+(worklist?'/queue':''));var fetchOptions={method:'POST',headers:{'Content-type':'application/json',Authorization:token},body:JSON.stringify([channelName])};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();}).then(function(response){cache.set(key,response);return response;});});var getbrandEngageChannelsStats=Object(__WEBPACK_IMPORTED_MODULE_2_api_wrapWithNetworkError__["a" /* default */])(function getBrandEngageChannelStats(token,brandEngageType,clientId,channelName){var key=[clientId,channelName,brandEngageType].join(':');if(cache.has(key)){var response=cache.get(key);if(response)return Promise.resolve(response);}var fetchUrl=Object(__WEBPACK_IMPORTED_MODULE_0_api_getEndpointUrl__["a" /* default */])('/brand-engage/'+brandEngageType+'/client/'+clientId+'/channel/'+channelName+'/stats');var fetchOptions={headers:{Authorization:token}};return fetch(fetchUrl,fetchOptions).then(function(response){return Object(__WEBPACK_IMPORTED_MODULE_1_api_checkIfResponseIsOK__["a" /* default */])(response);}).then(function(response){return response.json();}).then(function(response){cache.set(key,response);return response;});});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__channelStatsReducer__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channelContentQueueReducer__ = __webpack_require__(744);
/* harmony default export */ __webpack_exports__["a"] = ({channelStats:__WEBPACK_IMPORTED_MODULE_0__channelStatsReducer__["a" /* default */],channelContentQueue:__WEBPACK_IMPORTED_MODULE_1__channelContentQueueReducer__["a" /* default */]});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__channelStatsActions__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// type State = Map<string, Error | number>;
var defaultState={stats:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),worklistStats:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__channelStatsActions__["c" /* requestChannelStats */].toString(),function(state,action){return defaultState;}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__channelStatsActions__["a" /* receiveChannelStats */].toString(),function(state,action){if(action.error===true){var _action$meta=action.meta,channelName=_action$meta.channelName,worklist=_action$meta.worklist;if(worklist){return Object.assign({},state,{worklistStats:state.worklistStats.set(channelName,action.payload)});}else{return Object.assign({},state,{stats:state.stats.set(channelName,action.payload)});}}if(action.meta.worklist){return Object.assign({},state,{worklistStats:state.worklistStats.merge(action.payload)});}else{return Object.assign({},state,{stats:state.stats.merge(action.payload)});}}),_handleActions),defaultState));

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channelContentQueueActions__ = __webpack_require__(146);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultState={ugcId:null,contentRequestStatus:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__channelContentQueueActions__["c" /* requestClientQueueContent */].toString(),function(state,action){return Object.assign({},state,{contentRequestStatus:'pending'});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__channelContentQueueActions__["a" /* receiveClientQueueContent */].toString(),function(state,action){return Object.assign({},state,{ugcId:action.payload.ugc_id,contentRequestStatus:'complete'});}),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_1__channelContentQueueActions__["b" /* receiveClientQueueError */].toString(),function(state,action){return Object.assign({},state,{contentRequestStatus:action.payload.status});}),_handleActions),defaultState));

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ugcSearchPathname */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pages_components_LandingPage__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_search_Questions__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_search_NetworkQuestions__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_search_Answers__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers_channels_Channels__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_client_UgcAssignmentProvider__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_answer_editing_AnswerEditingContext__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_context_content_card_context__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_client_ClientProvider__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Commenting out until these ugc types are supported
// import {
//   QuestionSearch as PwrDistroQuestionSearch,
//   AnswerSearch as PwrDistroAnswerSearch,
// } from 'containers/search/PwrDistribution';
var QAChannels=function(_React$PureComponent){_inherits(QAChannels,_React$PureComponent);function QAChannels(){_classCallCheck(this,QAChannels);return _possibleConstructorReturn(this,(QAChannels.__proto__||Object.getPrototypeOf(QAChannels)).apply(this,arguments));}_createClass(QAChannels,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_containers_channels_Channels__["a" /* default */],Object.assign({ugctype:'Question'},this.props));}}]);return QAChannels;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);var channelsRoute={path:'channels',component:QAChannels,label:'Channels',navItem:true};var questionSearchRoute={exact:false,path:'questions',label:__WEBPACK_IMPORTED_MODULE_2_containers_search_Questions__["a" /* default */].label,component:__WEBPACK_IMPORTED_MODULE_2_containers_search_Questions__["a" /* default */],navItem:true};var networkQuestionSearchRoute={exact:false,path:'network-questions',label:__WEBPACK_IMPORTED_MODULE_3_containers_search_NetworkQuestions__["a" /* default */].label,component:__WEBPACK_IMPORTED_MODULE_3_containers_search_NetworkQuestions__["a" /* default */],navItem:true};var answerSearchRoute={exact:false,path:'answers',label:__WEBPACK_IMPORTED_MODULE_4_containers_search_Answers__["a" /* default */].label,component:__WEBPACK_IMPORTED_MODULE_4_containers_search_Answers__["a" /* default */],navItem:true};var pwrDistroSearchRoutes=[channelsRoute];var allRoutes=[channelsRoute,questionSearchRoute,networkQuestionSearchRoute,answerSearchRoute];var channelOnlySlice=[channelsRoute];var ugcSearchPathname=function ugcSearchPathname(ugc){if(ugc.ugc_archetype==='Question'){return questionSearchRoute.path;}if(ugc.ugc_archetype==='Answer'){return answerSearchRoute.path;}return null;};/* harmony default export */ __webpack_exports__["a"] = (function(props){var clientProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9_containers_client_ClientProvider__["a" /* ClientContext */]);var routes=void 0;if(clientProps&&(clientProps.clientId===164195141||clientProps.clientId===1986404165||clientProps.clientId===380979969||clientProps.clientId===12846||clientProps.clientId===1901388221)){routes=pwrDistroSearchRoutes;}else if(props.access.search){routes=allRoutes;}else{routes=channelOnlySlice;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_context_content_card_context__["a" /* ClientContentCardProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_containers_answer_editing_AnswerEditingContext__["a" /* AnswerEditingContext */].Provider,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_containers_client_UgcAssignmentProvider__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_pages_components_LandingPage__["a" /* default */],Object.assign({label:'Q&A',routes:routes,showMerchantGroupSelect:true,landingRoute:'channels'},props)))));});

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_socialcollection_WyngContent__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_socialcollection_GetAccess__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_components_LandingPage__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_client_ClientProvider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// $FlowIssue
var Campaigns=function(_React$PureComponent){_inherits(Campaigns,_React$PureComponent);function Campaigns(){_classCallCheck(this,Campaigns);return _possibleConstructorReturn(this,(Campaigns.__proto__||Object.getPrototypeOf(Campaigns)).apply(this,arguments));}_createClass(Campaigns,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_socialcollection_WyngContent__["a" /* default */],{title:'Campaigns',iframeSrc:Campaigns.iframeSrc});}}]);return Campaigns;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);Campaigns.iframeSrc=function(propertyId){return'https://wyng.com/dashboard/content-streams/'+propertyId+'/list';};var Content=function(_React$PureComponent2){_inherits(Content,_React$PureComponent2);function Content(){_classCallCheck(this,Content);return _possibleConstructorReturn(this,(Content.__proto__||Object.getPrototypeOf(Content)).apply(this,arguments));}_createClass(Content,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_containers_socialcollection_WyngContent__["a" /* default */],{title:'Content',iframeSrc:Content.iframeSrc});}}]);return Content;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);Content.iframeSrc=function(propertyId){return'https://wyng.com/curate/library/'+propertyId;};var accessRoutes=[{exact:false,path:'campaigns',component:Campaigns,label:'Campaigns',navItem:true},{exact:false,path:'content',label:'Content',component:Content,navItem:true}];var noAccessRoutes=[{exact:false,path:'getaccess',label:'Get Access',component:__WEBPACK_IMPORTED_MODULE_2_containers_socialcollection_GetAccess__["a" /* default */],navItem:true}];function useWyngDirectAccess(){var clientProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4_containers_client_ClientProvider__["a" /* ClientContext */]);var propertiesLoaded=clientProps!=null&&clientProps.properties instanceof __WEBPACK_IMPORTED_MODULE_5_immutable__["Map"];if(!propertiesLoaded)return null;return clientProps.properties.get('SOCIAL_COLLECTION_WYNG_DIRECT_ACCESS');}var SocialCollectionIndex=function SocialCollectionIndex(props){var socialCollectionAccess=props.access.socialcollection;var routes=socialCollectionAccess?accessRoutes:noAccessRoutes;var wyngDirectAccess=useWyngDirectAccess();Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(wyngDirectAccess===true){window.location.assign('https://wyng.com/dashboard/campaigns/');}},[wyngDirectAccess]);// do not render anything until we figure out if this user has direct access
if(wyngDirectAccess==null)return null;// render nothing since we will be redirecting the user
if(socialCollectionAccess&&wyngDirectAccess)return null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_pages_components_LandingPage__["a" /* default */],Object.assign({label:'Social Collection',routes:routes,landingRoute:routes[0].path},props));};/* harmony default export */ __webpack_exports__["a"] = (SocialCollectionIndex);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_client_ClientProvider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GetAccess__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SafariCookiePage__ = __webpack_require__(749);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IS_SAFARI=/^((?!chrome|android).)*safari/i.test(navigator.userAgent);var WyngView=function(_React$PureComponent){_inherits(WyngView,_React$PureComponent);function WyngView(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WyngView);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WyngView.__proto__||Object.getPrototypeOf(WyngView)).call.apply(_ref,[this].concat(args))),_this),_this.state={displayState:'LOADING'},_this.handleChange=function(selectedOption){selectedOption&&_this.props.selectClientCatalog(selectedOption.catalog_id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WyngView,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(IS_SAFARI){fetch('https://wyng.com/auth/set-test-cookie/',{credentials:'include'}).then(function(){return fetch('https://wyng.com/auth/test-cookie-worked/',{credentials:'include'});}).then(function(response){return response.json();}).then(function(response){_this2.setState({displayState:response&&response.successful?'PAGE_CONTENT':'SAFARI_COOKIE_SCREEN'});}).catch(function(){_this2.setState({displayState:'SAFARI_ERROR'});});}else{this.setState({displayState:'PAGE_CONTENT'});}}},{key:'render',value:function render(){var _props=this.props,title=_props.title,iframeSrc=_props.iframeSrc,options=_props.options,selectedOption=_props.selectedOption;var displayState=this.state.displayState;if(displayState==='LOADING'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components__["i" /* EmptyCard */],{message:'Loading Social Collection...'});}if(displayState==='SAFARI_COOKIE_SCREEN'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__SafariCookiePage__["a" /* default */],null);}if(displayState==='SAFARI_ERROR'){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components__["i" /* EmptyCard */],{title:'Social Collection in Safari',message:'It appears there was an error trying to open Social Collection in Safari. Please try using another browser.'});}if(options.length){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components__["q" /* Select */],{className:'mb3 mw5',clearable:false,value:selectedOption,options:options,onChange:this.handleChange}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('iframe',{name:'powerreviews',title:title,className:'w-100 shadow-1 bn vh-75 mb2',src:iframeSrc(selectedOption.value)}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{className:'gray'},'Powered by Wyng'));}else{return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__GetAccess__["a" /* default */],null);}}}]);return WyngView;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);var WyngContainer=function WyngContainer(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_containers_client_ClientProvider__["a" /* ClientContext */].Consumer,null,function(clientProps){if(!clientProps)return null;if(clientProps.catalogs instanceof Error){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_components__["i" /* EmptyCard */],{title:'No Catalogs',message:'Seems like we encountered an error loading the catalogs associated with the above client. Please contact PowerReviews Support for help.'});}if(!(clientProps.catalogs instanceof __WEBPACK_IMPORTED_MODULE_1_immutable__["List"]))return null;var options=clientProps.catalogs.filter(function(catalog){return catalog.social_collection_property_id;}).map(function(catalog){return{value:catalog.social_collection_property_id,label:catalog.name,catalog_id:catalog.catalog_id};}).toArray();var selectedOption=options.find(function(opt){return opt.catalog_id===clientProps.catalogId;})||options[0];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WyngView,{options:options,selectedOption:selectedOption,selectClientCatalog:clientProps.selectClientCatalog,title:props.title,iframeSrc:props.iframeSrc});});};/* harmony default export */ __webpack_exports__["a"] = (WyngContainer);

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SocialCollectionLandingPage.382f18a6.jpg";

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Card__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_SafariLandingPage_png__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_SafariLandingPage_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_SafariLandingPage_png__);
var WYNG_REDIRECT_URL='https://wyng.com/auth/fix-safari-3rd-party-cookie/';var SafariCookiePage=function SafariCookiePage(){var redirectWithReferrer=WYNG_REDIRECT_URL+'?referrer='+window.location.href;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'ph6 pv4 flex flex-column items-center'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img',{className:'w-75',src:__WEBPACK_IMPORTED_MODULE_2_assets_SafariLandingPage_png___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h1',{className:'tc b mt3 mb2 brandon',style:{fontSize:24}},'Using Safari? One quick step to get started.'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'tc fw1 mv2 lh-copy gray',style:{fontSize:16}},'To use Social Collection with Safari, we need to set a one-time cookie for your browser. Simply click the link below to continue.'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('a',{className:'link mv2',style:{fontSize:16},href:redirectWithReferrer},'Refresh and Get Started')));};/* harmony default export */ __webpack_exports__["a"] = (SafariCookiePage);

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SafariLandingPage.83b48ba7.png";

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RedirectToAuthService */
/* unused harmony export CheckAuthentication */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegenerateToken__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ducks_auth_context__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RedirectToAuthService=function(_React$Component){_inherits(RedirectToAuthService,_React$Component);function RedirectToAuthService(){_classCallCheck(this,RedirectToAuthService);return _possibleConstructorReturn(this,(RedirectToAuthService.__proto__||Object.getPrototypeOf(RedirectToAuthService)).apply(this,arguments));}_createClass(RedirectToAuthService,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_3_ducks_auth_context__["b" /* redirectToAuthService */])();}},{key:'render',value:function render(){return null;}}]);return RedirectToAuthService;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CheckAuthentication=function CheckAuthentication(props){var loginRequired=props.loginRequired,tokenRequired=props.tokenRequired,children=props.children;if(loginRequired===true){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RedirectToAuthService,null);}else if(tokenRequired===true){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__RegenerateToken__["a" /* default */],null);}return children;};var mapStateToProps=function mapStateToProps(state){var auth=state.auth;return{loginRequired:auth.needsLogin(),tokenRequired:auth.needsTokenRefresh()};};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(CheckAuthentication));

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RegenerateToken */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ducks_authActions__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegenerateToken=function(_React$PureComponent){_inherits(RegenerateToken,_React$PureComponent);function RegenerateToken(){_classCallCheck(this,RegenerateToken);return _possibleConstructorReturn(this,(RegenerateToken.__proto__||Object.getPrototypeOf(RegenerateToken)).apply(this,arguments));}_createClass(RegenerateToken,[{key:'componentDidMount',value:function componentDidMount(){this.props.regenerateToken();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */],{modal:true,message:'Authorizing...'});}}]);return RegenerateToken;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined,{regenerateToken:__WEBPACK_IMPORTED_MODULE_3_ducks_authActions__["d" /* regenerateToken */]})(RegenerateToken));

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CheckAuthorization */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckAuthorization=function(_React$Component){_inherits(CheckAuthorization,_React$Component);function CheckAuthorization(){_classCallCheck(this,CheckAuthorization);return _possibleConstructorReturn(this,(CheckAuthorization.__proto__||Object.getPrototypeOf(CheckAuthorization)).apply(this,arguments));}_createClass(CheckAuthorization,[{key:'render',value:function render(){var _props=this.props,authorized=_props.authorized,children=_props.children;return authorized===true?children:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */].Unauthorized,{modal:true});}}]);return CheckAuthorization;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CheckAuthorization);

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppReady */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AppReady=function(_React$PureComponent){_inherits(AppReady,_React$PureComponent);function AppReady(){_classCallCheck(this,AppReady);return _possibleConstructorReturn(this,(AppReady.__proto__||Object.getPrototypeOf(AppReady)).apply(this,arguments));}_createClass(AppReady,[{key:'render',value:function render(){var _props=this.props,ready=_props.ready,children=_props.children;return ready===true?children:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */],{modal:true,message:'Initializing'});}}]);return AppReady;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);function mapStateToProps(state){return{ready:state.appConfig.sagaReady};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,null)(AppReady));

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoadAppConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ducks_appConfigActions__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoadAppConfig=function(_React$PureComponent){_inherits(LoadAppConfig,_React$PureComponent);function LoadAppConfig(){_classCallCheck(this,LoadAppConfig);return _possibleConstructorReturn(this,(LoadAppConfig.__proto__||Object.getPrototypeOf(LoadAppConfig)).apply(this,arguments));}_createClass(LoadAppConfig,[{key:'componentDidMount',value:function componentDidMount(){this.props.requestAppConfig(this.props.token);}},{key:'render',value:function render(){var _props=this.props,status=_props.status,children=_props.children;if(status==='complete'){return children;}else if(status instanceof Error){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */],{message:'Failed to load Application Configuration'});}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */],{modal:true,message:'Loading Application Configuration...'});}}]);return LoadAppConfig;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);function mapStateToProps(state){return{ready:state.appConfig.sagaReady,status:state.appConfig.requestStatus,token:state.auth.token};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{requestAppConfig:__WEBPACK_IMPORTED_MODULE_3_ducks_appConfigActions__["b" /* requestAppConfig */]})(LoadAppConfig));

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserSatisfactionUtils */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserSatisfaction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_client_ClientProvider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_satismeter__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_appcues__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_churnzero__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lib_analytics__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserSatisfactionUtils=function(_React$Component){_inherits(UserSatisfactionUtils,_React$Component);function UserSatisfactionUtils(){_classCallCheck(this,UserSatisfactionUtils);return _possibleConstructorReturn(this,(UserSatisfactionUtils.__proto__||Object.getPrototypeOf(UserSatisfactionUtils)).apply(this,arguments));}_createClass(UserSatisfactionUtils,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _props,username,email,clientId,clientName,clientAccountId,page,internal,_ref2,appcuesLoaded,satismeterLoaded,churnzeroLoaded;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,username=_props.username,email=_props.email,clientId=_props.clientId,clientName=_props.clientName,clientAccountId=_props.clientAccountId,page=_props.page,internal=_props.internal;__WEBPACK_IMPORTED_MODULE_6_lib_analytics__["a" /* default */].pageview(page);if(internal){_context.next=13;break;}_ref2=[__WEBPACK_IMPORTED_MODULE_4_lib_appcues__["a" /* Appcues */].load(),__WEBPACK_IMPORTED_MODULE_3_lib_satismeter__["a" /* SatisMeter */].load(),__WEBPACK_IMPORTED_MODULE_5_lib_churnzero__["a" /* ChurnZero */].load()],appcuesLoaded=_ref2[0],satismeterLoaded=_ref2[1],churnzeroLoaded=_ref2[2];_context.next=6;return appcuesLoaded;case 6:__WEBPACK_IMPORTED_MODULE_4_lib_appcues__["a" /* Appcues */].identify(email,{name:username,email:email,clientId:clientId,clientName:clientName});_context.next=9;return satismeterLoaded;case 9:__WEBPACK_IMPORTED_MODULE_3_lib_satismeter__["a" /* SatisMeter */].showSurvey(this.props);_context.next=12;return churnzeroLoaded;case 12:__WEBPACK_IMPORTED_MODULE_5_lib_churnzero__["a" /* ChurnZero */].identify({email:email,accountId:clientAccountId});case 13:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.page!==prevProps.page){if(!this.props.internal){__WEBPACK_IMPORTED_MODULE_4_lib_appcues__["a" /* Appcues */].page();}__WEBPACK_IMPORTED_MODULE_6_lib_analytics__["a" /* default */].pageview(this.props.page);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_5_lib_churnzero__["a" /* ChurnZero */].stop();}},{key:'render',value:function render(){return null;}}]);return UserSatisfactionUtils;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var UserSatisfaction=function(_React$PureComponent){_inherits(UserSatisfaction,_React$PureComponent);function UserSatisfaction(){_classCallCheck(this,UserSatisfaction);return _possibleConstructorReturn(this,(UserSatisfaction.__proto__||Object.getPrototypeOf(UserSatisfaction)).apply(this,arguments));}_createClass(UserSatisfaction,[{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_containers_client_ClientProvider__["a" /* ClientContext */].Consumer,null,function(clientProps){if(!clientProps)return null;if(!__WEBPACK_IMPORTED_MODULE_7_immutable__["Map"].isMap(clientProps.properties))return null;var clientId=clientProps.clientId;var clientList=Array.isArray(clientProps.clients)?clientProps.clients:[];var currentClientInfo=clientList.find(function(client){return client.merchant_group_id===clientId;});var clientName=currentClientInfo?currentClientInfo.merchant_group_name:null;var clientAccountId=clientProps.properties.get('ss_account_information_id');return clientName?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](UserSatisfactionUtils,Object.assign({},_this3.props,{clientId:clientId,clientName:clientName,clientAccountId:clientAccountId})):null;});}}]);return UserSatisfaction;}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SatisMeter; });
window.satismeter=window.satismeter||function(){(window.satismeter.q=window.satismeter.q||[]).push(arguments);};window.satismeter.l=+new Date();var SatisMeter={load:function load(){return new Promise(function(resolve){var script=document.createElement('script');script.async=true;document.head&&document.head.appendChild(script);script.onload=resolve;script.onerror=function(){console.warn('Satismeter was not loaded');resolve();};script.src='https://app.satismeter.com/satismeter.js';});},showSurvey:function showSurvey(props){var email=props.email,username=props.username,clientId=props.clientId,clientName=props.clientName;window.satismeter({writeKey:'2E1t0tpRpqZD0QnW',userId:email,traits:{name:username,email:email,clientId:clientId,clientName:clientName}});}};

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Appcues; });
var Appcues={load:function load(){return new Promise(function(resolve,reject){var script=document.createElement('script');script.async=true;document.head&&document.head.appendChild(script);script.onload=resolve;script.onerror=function(){console.warn('Appcues was not loaded.');resolve();};script.src='//fast.appcues.com/39717.js';});},identify:function identify(){if(window.Appcues&&typeof window.Appcues.identify==='function'){var _window$Appcues;(_window$Appcues=window.Appcues).identify.apply(_window$Appcues,arguments);}},page:function page(){if(window.Appcues&&typeof window.Appcues.page==='function'){window.Appcues.page();}}};

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChurnZero; });
window.ChurnZero=window.ChurnZero||[];var envAppKey=function(){var devKey='D7EUh2aNF5QSfEMeG7BBr6tWw2we2Enw5ZahWUYRCoQ';var qaKey='fRuPAKoI_6GbqNA7pLdQE-yMJGKcahZx1v1SEqbmYT4';var prodKey='j6t4DTOWWGYxc5ot9qfCdAo4FFbUimTMx-OqUKZomQs';var buildEnv="prod";if(buildEnv==='prod')return prodKey;if(buildEnv==='qa')return qaKey;return devKey;}();var ChurnZero={load:function load(){return new Promise(function(resolve,reject){var script=document.createElement('script');script.async=true;document.head&&document.head.appendChild(script);script.onload=resolve;script.onerror=function(){console.warn('ChurnZero was not loaded.');resolve();};script.src='//analytics.churnzero.net/churnzero.js';});},identify:function identify(_ref){var email=_ref.email,accountId=_ref.accountId;window.ChurnZero.push(['setAppKey',envAppKey]);window.ChurnZero.push(['setContact',String(accountId),email]);window.ChurnZero.push(['setModule','Moderation']);},stop:function stop(){window.ChurnZero.push(['stop']);}};

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RedirectNotice=function(_React$PureComponent){_inherits(RedirectNotice,_React$PureComponent);function RedirectNotice(props){_classCallCheck(this,RedirectNotice);var _this=_possibleConstructorReturn(this,(RedirectNotice.__proto__||Object.getPrototypeOf(RedirectNotice)).call(this,props));_this.countdown=function(){_this.setState(function(_ref){var delay=_ref.delay;return{delay:delay-1};});};_this.state={delay:props.delay?props.delay:10};return _this;}_createClass(RedirectNotice,[{key:'componentDidMount',value:function componentDidMount(){this.intervalID=window.setInterval(this.countdown,1000);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.intervalID&&window.clearInterval(this.intervalID);}},{key:'render',value:function render(){var _this2=this;return this.state.delay<1?this.props.children():__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */].Title,null,'This Page has Moved.'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["i" /* EmptyCard */].Message,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,'You\'ll be automatically redirected in',' ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('strong',null,this.state.delay,'s'),'. Make sure to update your bookmarks.'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_components__["c" /* Button */].Primary,{onClick:function onClick(){return _this2.setState({delay:0});}},'Go to New Location Now')));}}]);return RedirectNotice;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (RedirectNotice);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WyngSingleSignOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(4);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();// $FlowIssue
function proxySAMLRequest(_ref){var SAMLRequest=_ref.SAMLRequest,RelayState=_ref.RelayState,token=_ref.token;return fetch('/socialcollection/generate-saml?SAMLRequest='+encodeURIComponent(SAMLRequest)+'&RelayState='+RelayState,{headers:{Authorization:token}}).then(function(response){if(response.status===200){return response.json();}else{throw new Error();}}).then(function(response){if(typeof response==='string'){return response;}else{throw new Error();}});}function WyngSingleSignOn(_ref2){var queryString=_ref2.queryString,token=_ref2.token;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){var _url$parse=__WEBPACK_IMPORTED_MODULE_1_url___default.a.parse(queryString,true),_url$parse$query=_url$parse.query;_url$parse$query=_url$parse$query===undefined?{}:_url$parse$query;var SAMLRequest=_url$parse$query.SAMLRequest,RelayState=_url$parse$query.RelayState;return{SAMLRequest:SAMLRequest,RelayState:RelayState};}),_useState2=_slicedToArray(_useState,1),_useState2$=_useState2[0],SAMLRequest=_useState2$.SAMLRequest,RelayState=_useState2$.RelayState;var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){if(!SAMLRequest||!RelayState){return true;}return false;}),_useState4=_slicedToArray(_useState3,2),error=_useState4[0],setError=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),_useState6=_slicedToArray(_useState5,2),SAMLResponse=_useState6[0],setSAMLResponse=_useState6[1];var formRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();console.log({queryString:queryString,SAMLRequest:SAMLRequest,RelayState:RelayState});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){proxySAMLRequest({SAMLRequest:SAMLRequest,RelayState:RelayState,token:token}).then(function(response){setSAMLResponse(response);}).catch(function(){setError(true);});},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){formRef.current&&formRef.current.submit();},[SAMLResponse]);if(error){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_components__["i" /* EmptyCard */],{title:'Social Collection',message:'There was an error logging you into Social Collection. If this error persists, contact PowerReviews Support.'});}if(RelayState&&SAMLResponse){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('form',{className:'dn',ref:formRef,method:'post',action:'https://wyng.com/auth/complete/saml/'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{type:'hidden',name:'RelayState',defaultValue:RelayState}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input',{type:'hidden',name:'SAMLResponse',defaultValue:SAMLResponse}));}return null;}

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserTranslation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_client_ClientProvider__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var UserTranslation=function UserTranslation(){var client=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_2_containers_client_ClientProvider__["a" /* ClientContext */]);var api_key="wg_3a3c94e641aaf99979e9565c889eccd91";var OCADO_PORTAL_LANGUAGES=client&&__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"].isMap(client.properties)&&client.properties.get('OCADO_PORTAL_LANGUAGES');__WEBPACK_IMPORTED_MODULE_1_react___default.a.useEffect(function(){var script=void 0;var loadWeglotScript=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt('return',new Promise(function(resolve,reject){script=document.createElement('script');script.async=true;script.onload=resolve;script.onerror=reject;var ref=document.getElementsByTagName('script')[0];ref?ref.parentNode.insertBefore(script,ref):document.head&&document.head.appendChild(script);script.src='https://cdn.weglot.com/weglot.min.js';}));case 1:case'end':return _context.stop();}}},_callee,_this);}));return function loadWeglotScript(){return _ref.apply(this,arguments);};}();var weglotContainer=document.querySelector('.weglot-container');if(OCADO_PORTAL_LANGUAGES){if(OCADO_PORTAL_LANGUAGES.length&&window.Weglot==null){var defaultLanguage='en';if(OCADO_PORTAL_LANGUAGES===defaultLanguage){return;}loadWeglotScript().then(function(){window.Weglot&&window.Weglot.initialize({api_key:api_key,cache:true,whitelist:[{value:'[data-translate="true"]'}],excluded_blocks:[{value:'[data-translate="false"]'}]});}).then(function(){window.Weglot.on('switchersReady',function(){var languageList=OCADO_PORTAL_LANGUAGES.split(/\s*,\s*/);var langOptions=document.querySelectorAll('.weglot-container li');if(!languageList.includes(defaultLanguage)){languageList.push(defaultLanguage);}for(var i=0;i<langOptions.length;i++){if(languageList.includes(langOptions[i].dataset.l))return;langOptions[i].style.display='none';}});}).catch(function(error){console.log(error);});}else{weglotContainer&&(weglotContainer.style.display='block');}}else{window.Weglot&&window.Weglot.switchTo('en');weglotContainer&&(weglotContainer.style.display='none');}return function(){if(script!=null)document.head.removeChild(script);};},[OCADO_PORTAL_LANGUAGES]);return null;};

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"__brandontext":"__brandontext","brandontext":"__brandontext"};

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"border-box":"border-box","borderBox":"border-box","cover":"cover","contain":"contain","bg-center":"bg-center","bgCenter":"bg-center","bg-top":"bg-top","bgTop":"bg-top","bg-right":"bg-right","bgRight":"bg-right","bg-bottom":"bg-bottom","bgBottom":"bg-bottom","bg-left":"bg-left","bgLeft":"bg-left","outline":"outline","outline-transparent":"outline-transparent","outlineTransparent":"outline-transparent","outline-0":"outline-0","outline0":"outline-0","ba":"ba","bt":"bt","br":"br","bb":"bb","bl":"bl","bn":"bn","b--black":"b--black","bBlack":"b--black","b--near-black":"b--near-black","bNearBlack":"b--near-black","b--dark-gray":"b--dark-gray","bDarkGray":"b--dark-gray","b--mid-gray":"b--mid-gray","bMidGray":"b--mid-gray","b--moon-gray":"b--moon-gray","bMoonGray":"b--moon-gray","b--gray":"b--gray","bGray":"b--gray","b--silver":"b--silver","bSilver":"b--silver","b--light-silver":"b--light-silver","bLightSilver":"b--light-silver","b--light-gray":"b--light-gray","bLightGray":"b--light-gray","b--near-white":"b--near-white","bNearWhite":"b--near-white","b--white":"b--white","bWhite":"b--white","b--white-90":"b--white-90","bWhite90":"b--white-90","b--white-80":"b--white-80","bWhite80":"b--white-80","b--white-70":"b--white-70","bWhite70":"b--white-70","b--white-60":"b--white-60","bWhite60":"b--white-60","b--white-50":"b--white-50","bWhite50":"b--white-50","b--white-40":"b--white-40","bWhite40":"b--white-40","b--white-30":"b--white-30","bWhite30":"b--white-30","b--white-20":"b--white-20","bWhite20":"b--white-20","b--white-10":"b--white-10","bWhite10":"b--white-10","b--white-05":"b--white-05","bWhite05":"b--white-05","b--white-025":"b--white-025","bWhite025":"b--white-025","b--white-0125":"b--white-0125","bWhite0125":"b--white-0125","b--black-90":"b--black-90","bBlack90":"b--black-90","b--black-80":"b--black-80","bBlack80":"b--black-80","b--black-70":"b--black-70","bBlack70":"b--black-70","b--black-60":"b--black-60","bBlack60":"b--black-60","b--black-50":"b--black-50","bBlack50":"b--black-50","b--black-40":"b--black-40","bBlack40":"b--black-40","b--black-30":"b--black-30","bBlack30":"b--black-30","b--black-20":"b--black-20","bBlack20":"b--black-20","b--black-10":"b--black-10","bBlack10":"b--black-10","b--black-05":"b--black-05","bBlack05":"b--black-05","b--black-025":"b--black-025","bBlack025":"b--black-025","b--black-0125":"b--black-0125","bBlack0125":"b--black-0125","b--dark-red":"b--dark-red","bDarkRed":"b--dark-red","b--red":"b--red","bRed":"b--red","b--light-red":"b--light-red","bLightRed":"b--light-red","b--orange":"b--orange","bOrange":"b--orange","b--gold":"b--gold","bGold":"b--gold","b--yellow":"b--yellow","bYellow":"b--yellow","b--light-yellow":"b--light-yellow","bLightYellow":"b--light-yellow","b--purple":"b--purple","bPurple":"b--purple","b--light-purple":"b--light-purple","bLightPurple":"b--light-purple","b--dark-pink":"b--dark-pink","bDarkPink":"b--dark-pink","b--hot-pink":"b--hot-pink","bHotPink":"b--hot-pink","b--pink":"b--pink","bPink":"b--pink","b--light-pink":"b--light-pink","bLightPink":"b--light-pink","b--dark-green":"b--dark-green","bDarkGreen":"b--dark-green","b--green":"b--green","bGreen":"b--green","b--light-green":"b--light-green","bLightGreen":"b--light-green","b--navy":"b--navy","bNavy":"b--navy","b--dark-blue":"b--dark-blue","bDarkBlue":"b--dark-blue","b--blue":"b--blue","bBlue":"b--blue","b--light-blue":"b--light-blue","bLightBlue":"b--light-blue","b--lightest-blue":"b--lightest-blue","bLightestBlue":"b--lightest-blue","b--washed-blue":"b--washed-blue","bWashedBlue":"b--washed-blue","b--washed-green":"b--washed-green","bWashedGreen":"b--washed-green","b--washed-yellow":"b--washed-yellow","bWashedYellow":"b--washed-yellow","b--washed-red":"b--washed-red","bWashedRed":"b--washed-red","b--transparent":"b--transparent","bTransparent":"b--transparent","br0":"br-0","br1":"br1","br2":"br2","br3":"br3","br4":"br4","br-100":"br-100","br100":"br-100","br-pill":"br-pill","brPill":"br-pill","br--bottom":"br--bottom","brBottom":"br--bottom","br--top":"br--top","brTop":"br--top","br--right":"br--right","brRight":"br--right","br--left":"br--left","brLeft":"br--left","b--dotted":"b--dotted","bDotted":"b--dotted","b--dashed":"b--dashed","bDashed":"b--dashed","b--solid":"b--solid","bSolid":"b--solid","b--none":"b--none","bNone":"b--none","bw0":"bw0","bw1":"bw1","bw2":"bw2","bw3":"bw3","bw4":"bw4","bw5":"bw5","bt-0":"bt-0","bt0":"bt-0","br-0":"br-0","bb-0":"bb-0","bb0":"bb-0","bl-0":"bl-0","bl0":"bl-0","shadow-1":"shadow-1","shadow1":"shadow-1","shadow-2":"shadow-2","shadow2":"shadow-2","shadow-3":"shadow-3","shadow3":"shadow-3","shadow-4":"shadow-4","shadow4":"shadow-4","shadow-5":"shadow-5","shadow5":"shadow-5","pre":"pre","top-0":"top-0","top0":"top-0","right-0":"right-0","right0":"right-0","bottom-0":"bottom-0","bottom0":"bottom-0","left-0":"left-0","left0":"left-0","top-1":"top-1","top1":"top--1","right-1":"right-1","right1":"right--1","bottom-1":"bottom-1","bottom1":"bottom--1","left-1":"left-1","left1":"left--1","top-2":"top-2","top2":"top--2","right-2":"right-2","right2":"right--2","bottom-2":"bottom-2","bottom2":"bottom--2","left-2":"left-2","left2":"left--2","top--1":"top--1","right--1":"right--1","bottom--1":"bottom--1","left--1":"left--1","top--2":"top--2","right--2":"right--2","bottom--2":"bottom--2","left--2":"left--2","absolute--fill":"absolute--fill","absoluteFill":"absolute--fill","cf":"cf","cl":"cl","cr":"cr","cb":"cb","cn":"cn","dn":"dn","di":"di","db":"db","dib":"dib","dit":"dit","dt":"dt","dtc":"dtc","dt-row":"dt-row","dtRow":"dt-row","dt-row-group":"dt-row-group","dtRowGroup":"dt-row-group","dt-column":"dt-column","dtColumn":"dt-column","dt-column-group":"dt-column-group","dtColumnGroup":"dt-column-group","dt--fixed":"dt--fixed","dtFixed":"dt--fixed","flex":"flex","inline-flex":"inline-flex","inlineFlex":"inline-flex","flex-auto":"flex-auto","flexAuto":"flex-auto","flex-none":"flex-none","flexNone":"flex-none","flex-column":"flex-column","flexColumn":"flex-column","flex-row":"flex-row","flexRow":"flex-row","flex-wrap":"flex-wrap","flexWrap":"flex-wrap","items-start":"items-start","itemsStart":"items-start","items-end":"items-end","itemsEnd":"items-end","items-center":"items-center","itemsCenter":"items-center","items-baseline":"items-baseline","itemsBaseline":"items-baseline","items-stretch":"items-stretch","itemsStretch":"items-stretch","self-start":"self-start","selfStart":"self-start","self-end":"self-end","selfEnd":"self-end","self-center":"self-center","selfCenter":"self-center","self-baseline":"self-baseline","selfBaseline":"self-baseline","self-stretch":"self-stretch","selfStretch":"self-stretch","justify-start":"justify-start","justifyStart":"justify-start","justify-end":"justify-end","justifyEnd":"justify-end","justify-center":"justify-center","justifyCenter":"justify-center","justify-between":"justify-between","justifyBetween":"justify-between","justify-around":"justify-around","justifyAround":"justify-around","content-start":"content-start","contentStart":"content-start","content-end":"content-end","contentEnd":"content-end","content-center":"content-center","contentCenter":"content-center","content-between":"content-between","contentBetween":"content-between","content-around":"content-around","contentAround":"content-around","content-stretch":"content-stretch","contentStretch":"content-stretch","order-0":"order-0","order0":"order-0","order-1":"order-1","order1":"order-1","order-2":"order-2","order2":"order-2","order-3":"order-3","order3":"order-3","order-4":"order-4","order4":"order-4","order-5":"order-5","order5":"order-5","order-6":"order-6","order6":"order-6","order-7":"order-7","order7":"order-7","order-8":"order-8","order8":"order-8","order-last":"order-last","orderLast":"order-last","fl":"fl","fr":"fr","fn":"fn","sans-serif":"sans-serif","sansSerif":"sans-serif","serif":"serif","system-sans-serif":"system-sans-serif","systemSansSerif":"system-sans-serif","system-serif":"system-serif","systemSerif":"system-serif","code":"code","courier":"courier","helvetica":"helvetica","avenir":"avenir","athelas":"athelas","georgia":"georgia","times":"times","bodoni":"bodoni","calisto":"calisto","garamond":"garamond","baskerville":"baskerville","i":"i","fs-normal":"fs-normal","fsNormal":"fs-normal","normal":"normal","b":"b","fw1":"fw1","fw2":"fw2","fw3":"fw3","fw4":"fw4","fw5":"fw5","fw6":"fw6","fw7":"fw7","fw8":"fw8","fw9":"fw9","input-reset":"input-reset","inputReset":"input-reset","button-reset":"button-reset","buttonReset":"button-reset","h1":"h1","h2":"h2","h3":"h3","h4":"h4","h5":"h5","h-25":"h-25","h25":"h-25","h-50":"h-50","h50":"h-50","h-75":"h-75","h75":"h-75","h-100":"h-100","h100":"h-100","min-h-100":"min-h-100","minH100":"min-h-100","vh-25":"vh-25","vh25":"vh-25","vh-50":"vh-50","vh50":"vh-50","vh-75":"vh-75","vh75":"vh-75","vh-100":"vh-100","vh100":"vh-100","min-vh-100":"min-vh-100","minVh100":"min-vh-100","h-auto":"h-auto","hAuto":"h-auto","h-inherit":"h-inherit","hInherit":"h-inherit","tracked":"tracked","tracked-tight":"tracked-tight","trackedTight":"tracked-tight","tracked-mega":"tracked-mega","trackedMega":"tracked-mega","lh-solid":"lh-solid","lhSolid":"lh-solid","lh-title":"lh-title","lhTitle":"lh-title","lh-copy":"lh-copy","lhCopy":"lh-copy","link":"link","list":"list","mw-100":"mw-100","mw100":"mw-100","mw1":"mw1","mw2":"mw2","mw3":"mw3","mw4":"mw4","mw5":"mw5","mw6":"mw6","mw7":"mw7","mw8":"mw8","mw9":"mw9","mw-none":"mw-none","mwNone":"mw-none","w1":"w1","w2":"w2","w3":"w3","w4":"w4","w5":"w5","w-10":"w-10","w10":"w-10","w-20":"w-20","w20":"w-20","w-25":"w-25","w25":"w-25","w-30":"w-30","w30":"w-30","w-33":"w-33","w33":"w-33","w-34":"w-34","w34":"w-34","w-40":"w-40","w40":"w-40","w-50":"w-50","w50":"w-50","w-60":"w-60","w60":"w-60","w-70":"w-70","w70":"w-70","w-75":"w-75","w75":"w-75","w-80":"w-80","w80":"w-80","w-90":"w-90","w90":"w-90","w-100":"w-100","w100":"w-100","w-third":"w-third","wThird":"w-third","w-two-thirds":"w-two-thirds","wTwoThirds":"w-two-thirds","w-auto":"w-auto","wAuto":"w-auto","overflow-visible":"overflow-visible","overflowVisible":"overflow-visible","overflow-hidden":"overflow-hidden","overflowHidden":"overflow-hidden","overflow-scroll":"overflow-scroll","overflowScroll":"overflow-scroll","overflow-auto":"overflow-auto","overflowAuto":"overflow-auto","overflow-x-visible":"overflow-x-visible","overflowXVisible":"overflow-x-visible","overflow-x-hidden":"overflow-x-hidden","overflowXHidden":"overflow-x-hidden","overflow-x-scroll":"overflow-x-scroll","overflowXScroll":"overflow-x-scroll","overflow-x-auto":"overflow-x-auto","overflowXAuto":"overflow-x-auto","overflow-y-visible":"overflow-y-visible","overflowYVisible":"overflow-y-visible","overflow-y-hidden":"overflow-y-hidden","overflowYHidden":"overflow-y-hidden","overflow-y-scroll":"overflow-y-scroll","overflowYScroll":"overflow-y-scroll","overflow-y-auto":"overflow-y-auto","overflowYAuto":"overflow-y-auto","static":"static","relative":"relative","absolute":"absolute","fixed":"fixed","o-100":"o-100","o100":"o-100","o-90":"o-90","o90":"o-90","o-80":"o-80","o80":"o-80","o-70":"o-70","o70":"o-70","o-60":"o-60","o60":"o-60","o-50":"o-50","o50":"o-50","o-40":"o-40","o40":"o-40","o-30":"o-30","o30":"o-30","o-20":"o-20","o20":"o-20","o-10":"o-10","o10":"o-10","o-05":"o-05","o05":"o-05","o-025":"o-025","o025":"o-025","o-0":"o-0","o0":"o-0","black-90":"black-90","black90":"black-90","black-80":"black-80","black80":"black-80","black-70":"black-70","black70":"black-70","black-60":"black-60","black60":"black-60","black-50":"black-50","black50":"black-50","black-40":"black-40","black40":"black-40","black-30":"black-30","black30":"black-30","black-20":"black-20","black20":"black-20","black-10":"black-10","black10":"black-10","black-05":"black-05","black05":"black-05","white-90":"white-90","white90":"white-90","white-80":"white-80","white80":"white-80","white-70":"white-70","white70":"white-70","white-60":"white-60","white60":"white-60","white-50":"white-50","white50":"white-50","white-40":"white-40","white40":"white-40","white-30":"white-30","white30":"white-30","white-20":"white-20","white20":"white-20","white-10":"white-10","white10":"white-10","black":"black","near-black":"near-black","nearBlack":"near-black","dark-gray":"dark-gray","darkGray":"dark-gray","mid-gray":"mid-gray","midGray":"mid-gray","gray":"gray","silver":"silver","light-silver":"light-silver","lightSilver":"light-silver","moon-gray":"moon-gray","moonGray":"moon-gray","light-gray":"light-gray","lightGray":"light-gray","near-white":"near-white","nearWhite":"near-white","white":"white","dark-red":"dark-red","darkRed":"dark-red","red":"red","light-red":"light-red","lightRed":"light-red","orange":"orange","gold":"gold","yellow":"yellow","light-yellow":"light-yellow","lightYellow":"light-yellow","purple":"purple","light-purple":"light-purple","lightPurple":"light-purple","dark-pink":"dark-pink","darkPink":"dark-pink","hot-pink":"hot-pink","hotPink":"hot-pink","pink":"pink","light-pink":"light-pink","lightPink":"light-pink","dark-green":"dark-green","darkGreen":"dark-green","green":"green","light-green":"light-green","lightGreen":"light-green","navy":"navy","dark-blue":"dark-blue","darkBlue":"dark-blue","blue":"blue","light-blue":"light-blue","lightBlue":"light-blue","lightest-blue":"lightest-blue","lightestBlue":"lightest-blue","washed-blue":"washed-blue","washedBlue":"washed-blue","washed-green":"washed-green","washedGreen":"washed-green","washed-yellow":"washed-yellow","washedYellow":"washed-yellow","washed-red":"washed-red","washedRed":"washed-red","bg-black-90":"bg-black-90","bgBlack90":"bg-black-90","bg-black-80":"bg-black-80","bgBlack80":"bg-black-80","bg-black-70":"bg-black-70","bgBlack70":"bg-black-70","bg-black-60":"bg-black-60","bgBlack60":"bg-black-60","bg-black-50":"bg-black-50","bgBlack50":"bg-black-50","bg-black-40":"bg-black-40","bgBlack40":"bg-black-40","bg-black-30":"bg-black-30","bgBlack30":"bg-black-30","bg-black-20":"bg-black-20","bgBlack20":"bg-black-20","bg-black-10":"bg-black-10","bgBlack10":"bg-black-10","bg-black-05":"bg-black-05","bgBlack05":"bg-black-05","bg-white-90":"bg-white-90","bgWhite90":"bg-white-90","bg-white-80":"bg-white-80","bgWhite80":"bg-white-80","bg-white-70":"bg-white-70","bgWhite70":"bg-white-70","bg-white-60":"bg-white-60","bgWhite60":"bg-white-60","bg-white-50":"bg-white-50","bgWhite50":"bg-white-50","bg-white-40":"bg-white-40","bgWhite40":"bg-white-40","bg-white-30":"bg-white-30","bgWhite30":"bg-white-30","bg-white-20":"bg-white-20","bgWhite20":"bg-white-20","bg-white-10":"bg-white-10","bgWhite10":"bg-white-10","bg-black":"bg-black","bgBlack":"bg-black","bg-near-black":"bg-near-black","bgNearBlack":"bg-near-black","bg-dark-gray":"bg-dark-gray","bgDarkGray":"bg-dark-gray","bg-mid-gray":"bg-mid-gray","bgMidGray":"bg-mid-gray","bg-gray":"bg-gray","bgGray":"bg-gray","bg-silver":"bg-silver","bgSilver":"bg-silver","bg-light-silver":"bg-light-silver","bgLightSilver":"bg-light-silver","bg-moon-gray":"bg-moon-gray","bgMoonGray":"bg-moon-gray","bg-light-gray":"bg-light-gray","bgLightGray":"bg-light-gray","bg-near-white":"bg-near-white","bgNearWhite":"bg-near-white","bg-white":"bg-white","bgWhite":"bg-white","bg-transparent":"bg-transparent","bgTransparent":"bg-transparent","bg-dark-red":"bg-dark-red","bgDarkRed":"bg-dark-red","bg-red":"bg-red","bgRed":"bg-red","bg-light-red":"bg-light-red","bgLightRed":"bg-light-red","bg-orange":"bg-orange","bgOrange":"bg-orange","bg-gold":"bg-gold","bgGold":"bg-gold","bg-yellow":"bg-yellow","bgYellow":"bg-yellow","bg-light-yellow":"bg-light-yellow","bgLightYellow":"bg-light-yellow","bg-purple":"bg-purple","bgPurple":"bg-purple","bg-light-purple":"bg-light-purple","bgLightPurple":"bg-light-purple","bg-dark-pink":"bg-dark-pink","bgDarkPink":"bg-dark-pink","bg-hot-pink":"bg-hot-pink","bgHotPink":"bg-hot-pink","bg-pink":"bg-pink","bgPink":"bg-pink","bg-light-pink":"bg-light-pink","bgLightPink":"bg-light-pink","bg-dark-green":"bg-dark-green","bgDarkGreen":"bg-dark-green","bg-green":"bg-green","bgGreen":"bg-green","bg-light-green":"bg-light-green","bgLightGreen":"bg-light-green","bg-navy":"bg-navy","bgNavy":"bg-navy","bg-dark-blue":"bg-dark-blue","bgDarkBlue":"bg-dark-blue","bg-blue":"bg-blue","bgBlue":"bg-blue","bg-light-blue":"bg-light-blue","bgLightBlue":"bg-light-blue","bg-lightest-blue":"bg-lightest-blue","bgLightestBlue":"bg-lightest-blue","bg-washed-blue":"bg-washed-blue","bgWashedBlue":"bg-washed-blue","bg-washed-green":"bg-washed-green","bgWashedGreen":"bg-washed-green","bg-washed-yellow":"bg-washed-yellow","bgWashedYellow":"bg-washed-yellow","bg-washed-red":"bg-washed-red","bgWashedRed":"bg-washed-red","bg-pwr-blue":"bg-pwr-blue","bgPwrBlue":"bg-pwr-blue","hover-black":"hover-black","hoverBlack":"hover-black","hover-near-black":"hover-near-black","hoverNearBlack":"hover-near-black","hover-dark-gray":"hover-dark-gray","hoverDarkGray":"hover-dark-gray","hover-mid-gray":"hover-mid-gray","hoverMidGray":"hover-mid-gray","hover-gray":"hover-gray","hoverGray":"hover-gray","hover-silver":"hover-silver","hoverSilver":"hover-silver","hover-light-silver":"hover-light-silver","hoverLightSilver":"hover-light-silver","hover-moon-gray":"hover-moon-gray","hoverMoonGray":"hover-moon-gray","hover-light-gray":"hover-light-gray","hoverLightGray":"hover-light-gray","hover-near-white":"hover-near-white","hoverNearWhite":"hover-near-white","hover-white":"hover-white","hoverWhite":"hover-white","hover-bg-black":"hover-bg-black","hoverBgBlack":"hover-bg-black","hover-bg-near-black":"hover-bg-near-black","hoverBgNearBlack":"hover-bg-near-black","hover-bg-dark-gray":"hover-bg-dark-gray","hoverBgDarkGray":"hover-bg-dark-gray","hover-bg-mid-gray":"hover-bg-mid-gray","hoverBgMidGray":"hover-bg-mid-gray","hover-bg-gray":"hover-bg-gray","hoverBgGray":"hover-bg-gray","hover-bg-silver":"hover-bg-silver","hoverBgSilver":"hover-bg-silver","hover-bg-light-silver":"hover-bg-light-silver","hoverBgLightSilver":"hover-bg-light-silver","hover-bg-moon-gray":"hover-bg-moon-gray","hoverBgMoonGray":"hover-bg-moon-gray","hover-bg-light-gray":"hover-bg-light-gray","hoverBgLightGray":"hover-bg-light-gray","hover-bg-near-white":"hover-bg-near-white","hoverBgNearWhite":"hover-bg-near-white","hover-bg-white":"hover-bg-white","hoverBgWhite":"hover-bg-white","hover-bg-transparent":"hover-bg-transparent","hoverBgTransparent":"hover-bg-transparent","hover-dark-red":"hover-dark-red","hoverDarkRed":"hover-dark-red","hover-red":"hover-red","hoverRed":"hover-red","hover-light-red":"hover-light-red","hoverLightRed":"hover-light-red","hover-orange":"hover-orange","hoverOrange":"hover-orange","hover-gold":"hover-gold","hoverGold":"hover-gold","hover-yellow":"hover-yellow","hoverYellow":"hover-yellow","hover-light-yellow":"hover-light-yellow","hoverLightYellow":"hover-light-yellow","hover-purple":"hover-purple","hoverPurple":"hover-purple","hover-light-purple":"hover-light-purple","hoverLightPurple":"hover-light-purple","hover-dark-pink":"hover-dark-pink","hoverDarkPink":"hover-dark-pink","hover-hot-pink":"hover-hot-pink","hoverHotPink":"hover-hot-pink","hover-pink":"hover-pink","hoverPink":"hover-pink","hover-light-pink":"hover-light-pink","hoverLightPink":"hover-light-pink","hover-dark-green":"hover-dark-green","hoverDarkGreen":"hover-dark-green","hover-green":"hover-green","hoverGreen":"hover-green","hover-light-green":"hover-light-green","hoverLightGreen":"hover-light-green","hover-navy":"hover-navy","hoverNavy":"hover-navy","hover-dark-blue":"hover-dark-blue","hoverDarkBlue":"hover-dark-blue","hover-blue":"hover-blue","hoverBlue":"hover-blue","hover-light-blue":"hover-light-blue","hoverLightBlue":"hover-light-blue","hover-lightest-blue":"hover-lightest-blue","hoverLightestBlue":"hover-lightest-blue","hover-washed-blue":"hover-washed-blue","hoverWashedBlue":"hover-washed-blue","hover-washed-green":"hover-washed-green","hoverWashedGreen":"hover-washed-green","hover-washed-yellow":"hover-washed-yellow","hoverWashedYellow":"hover-washed-yellow","hover-washed-red":"hover-washed-red","hoverWashedRed":"hover-washed-red","hover-bg-dark-red":"hover-bg-dark-red","hoverBgDarkRed":"hover-bg-dark-red","hover-bg-red":"hover-bg-red","hoverBgRed":"hover-bg-red","hover-bg-light-red":"hover-bg-light-red","hoverBgLightRed":"hover-bg-light-red","hover-bg-orange":"hover-bg-orange","hoverBgOrange":"hover-bg-orange","hover-bg-gold":"hover-bg-gold","hoverBgGold":"hover-bg-gold","hover-bg-yellow":"hover-bg-yellow","hoverBgYellow":"hover-bg-yellow","hover-bg-light-yellow":"hover-bg-light-yellow","hoverBgLightYellow":"hover-bg-light-yellow","hover-bg-purple":"hover-bg-purple","hoverBgPurple":"hover-bg-purple","hover-bg-light-purple":"hover-bg-light-purple","hoverBgLightPurple":"hover-bg-light-purple","hover-bg-dark-pink":"hover-bg-dark-pink","hoverBgDarkPink":"hover-bg-dark-pink","hover-bg-hot-pink":"hover-bg-hot-pink","hoverBgHotPink":"hover-bg-hot-pink","hover-bg-pink":"hover-bg-pink","hoverBgPink":"hover-bg-pink","hover-bg-light-pink":"hover-bg-light-pink","hoverBgLightPink":"hover-bg-light-pink","hover-bg-dark-green":"hover-bg-dark-green","hoverBgDarkGreen":"hover-bg-dark-green","hover-bg-green":"hover-bg-green","hoverBgGreen":"hover-bg-green","hover-bg-light-green":"hover-bg-light-green","hoverBgLightGreen":"hover-bg-light-green","hover-bg-navy":"hover-bg-navy","hoverBgNavy":"hover-bg-navy","hover-bg-dark-blue":"hover-bg-dark-blue","hoverBgDarkBlue":"hover-bg-dark-blue","hover-bg-blue":"hover-bg-blue","hoverBgBlue":"hover-bg-blue","hover-bg-light-blue":"hover-bg-light-blue","hoverBgLightBlue":"hover-bg-light-blue","hover-bg-lightest-blue":"hover-bg-lightest-blue","hoverBgLightestBlue":"hover-bg-lightest-blue","hover-bg-washed-blue":"hover-bg-washed-blue","hoverBgWashedBlue":"hover-bg-washed-blue","hover-bg-washed-green":"hover-bg-washed-green","hoverBgWashedGreen":"hover-bg-washed-green","hover-bg-washed-yellow":"hover-bg-washed-yellow","hoverBgWashedYellow":"hover-bg-washed-yellow","hover-bg-washed-red":"hover-bg-washed-red","hoverBgWashedRed":"hover-bg-washed-red","pa0":"pa0","pa1":"pa1","pa2":"pa2","pa3":"pa3","pa4":"pa4","pa5":"pa5","pa6":"pa6","pa7":"pa7","pl0":"pl0","pl1":"pl1","pl2":"pl2","pl3":"pl3","pl4":"pl4","pl5":"pl5","pl6":"pl6","pl7":"pl7","pr0":"pr0","pr1":"pr1","pr2":"pr2","pr3":"pr3","pr4":"pr4","pr5":"pr5","pr6":"pr6","pr7":"pr7","pb0":"pb0","pb1":"pb1","pb2":"pb2","pb3":"pb3","pb4":"pb4","pb5":"pb5","pb6":"pb6","pb7":"pb7","pt0":"pt0","pt1":"pt1","pt2":"pt2","pt3":"pt3","pt4":"pt4","pt5":"pt5","pt6":"pt6","pt7":"pt7","pv0":"pv0","pv1":"pv1","pv2":"pv2","pv3":"pv3","pv4":"pv4","pv5":"pv5","pv6":"pv6","pv7":"pv7","ph0":"ph0","ph1":"ph1","ph2":"ph2","ph3":"ph3","ph4":"ph4","ph5":"ph5","ph6":"ph6","ph7":"ph7","ma0":"ma0","ma1":"ma1","ma2":"ma2","ma3":"ma3","ma4":"ma4","ma5":"ma5","ma6":"ma6","ma7":"ma7","ml0":"ml0","ml1":"ml1","ml2":"ml2","ml3":"ml3","ml4":"ml4","ml5":"ml5","ml6":"ml6","ml7":"ml7","mr0":"mr0","mr1":"mr1","mr2":"mr2","mr3":"mr3","mr4":"mr4","mr5":"mr5","mr6":"mr6","mr7":"mr7","mb0":"mb0","mb1":"mb1","mb2":"mb2","mb3":"mb3","mb4":"mb4","mb5":"mb5","mb6":"mb6","mb7":"mb7","mt0":"mt0","mt1":"mt1","mt2":"mt2","mt3":"mt3","mt4":"mt4","mt5":"mt5","mt6":"mt6","mt7":"mt7","mv0":"mv0","mv1":"mv1","mv2":"mv2","mv3":"mv3","mv4":"mv4","mv5":"mv5","mv6":"mv6","mv7":"mv7","mh0":"mh0","mh1":"mh1","mh2":"mh2","mh3":"mh3","mh4":"mh4","mh5":"mh5","mh6":"mh6","mh7":"mh7","collapse":"collapse","striped--light-silver":"striped--light-silver","stripedLightSilver":"striped--light-silver","striped--moon-gray":"striped--moon-gray","stripedMoonGray":"striped--moon-gray","striped--light-gray":"striped--light-gray","stripedLightGray":"striped--light-gray","striped--near-white":"striped--near-white","stripedNearWhite":"striped--near-white","stripe-light":"stripe-light","stripeLight":"stripe-light","stripe-dark":"stripe-dark","stripeDark":"stripe-dark","strike":"strike","underline":"underline","no-underline":"no-underline","noUnderline":"no-underline","tl":"tl","tr":"tr","tc":"tc","ttc":"ttc","ttl":"ttl","ttu":"ttu","ttn":"ttn","f-6":"f-6","f6":"f6","f-headline":"f-headline","fHeadline":"f-headline","f-5":"f-5","f5":"f5","f-subheadline":"f-subheadline","fSubheadline":"f-subheadline","f1":"f1","f2":"f2","f3":"f3","f4":"f4","measure":"measure","measure-wide":"measure-wide","measureWide":"measure-wide","measure-narrow":"measure-narrow","measureNarrow":"measure-narrow","indent":"indent","small-caps":"small-caps","smallCaps":"small-caps","truncate":"truncate","aspect-ratio":"aspect-ratio","aspectRatio":"aspect-ratio","aspect-ratio--16x9":"aspect-ratio--16x9","aspectRatio16X9":"aspect-ratio--16x9","aspect-ratio--9x16":"aspect-ratio--9x16","aspectRatio9X16":"aspect-ratio--9x16","aspect-ratio--4x3":"aspect-ratio--4x3","aspectRatio4X3":"aspect-ratio--4x3","aspect-ratio--3x4":"aspect-ratio--3x4","aspectRatio3X4":"aspect-ratio--3x4","aspect-ratio--6x4":"aspect-ratio--6x4","aspectRatio6X4":"aspect-ratio--6x4","aspect-ratio--4x6":"aspect-ratio--4x6","aspectRatio4X6":"aspect-ratio--4x6","aspect-ratio--8x5":"aspect-ratio--8x5","aspectRatio8X5":"aspect-ratio--8x5","aspect-ratio--5x8":"aspect-ratio--5x8","aspectRatio5X8":"aspect-ratio--5x8","aspect-ratio--7x5":"aspect-ratio--7x5","aspectRatio7X5":"aspect-ratio--7x5","aspect-ratio--5x7":"aspect-ratio--5x7","aspectRatio5X7":"aspect-ratio--5x7","aspect-ratio--1x1":"aspect-ratio--1x1","aspectRatio1X1":"aspect-ratio--1x1","aspect-ratio--object":"aspect-ratio--object","aspectRatioObject":"aspect-ratio--object","overflow-container":"overflow-container","overflowContainer":"overflow-container","center":"center","clip":"clip","ws-normal":"ws-normal","wsNormal":"ws-normal","nowrap":"nowrap","v-base":"v-base","vBase":"v-base","v-mid":"v-mid","vMid":"v-mid","v-top":"v-top","vTop":"v-top","v-btm":"v-btm","vBtm":"v-btm","dim":"dim","hide-child":"hide-child","hideChild":"hide-child","child":"child","underline-hover":"underline-hover","underlineHover":"underline-hover","grow":"grow","grow-large":"grow-large","growLarge":"grow-large","pointer":"pointer","shadow-hover":"shadow-hover","shadowHover":"shadow-hover","bg-animate":"bg-animate","bgAnimate":"bg-animate","z-0":"z-0","z0":"z-0","z-1":"z-1","z1":"z-1","z-2":"z-2","z2":"z-2","z-3":"z-3","z3":"z-3","z-4":"z-4","z4":"z-4","z-5":"z-5","z5":"z-5","z-999":"z-999","z999":"z-999","z-9999":"z-9999","z9999":"z-9999","z-max":"z-max","zMax":"z-max","z-inherit":"z-inherit","zInherit":"z-inherit","z-initial":"z-initial","zInitial":"z-initial","z-unset":"z-unset","zUnset":"z-unset","debug":"debug","debug-white":"debug-white","debugWhite":"debug-white","debug-black":"debug-black","debugBlack":"debug-black","debug-grid":"debug-grid","debugGrid":"debug-grid","debug-grid-16":"debug-grid-16","debugGrid16":"debug-grid-16","debug-grid-8-solid":"debug-grid-8-solid","debugGrid8Solid":"debug-grid-8-solid","debug-grid-16-solid":"debug-grid-16-solid","debugGrid16Solid":"debug-grid-16-solid","cover-ns":"cover-ns","coverNs":"cover-ns","contain-ns":"contain-ns","containNs":"contain-ns","bg-center-ns":"bg-center-ns","bgCenterNs":"bg-center-ns","bg-top-ns":"bg-top-ns","bgTopNs":"bg-top-ns","bg-right-ns":"bg-right-ns","bgRightNs":"bg-right-ns","bg-bottom-ns":"bg-bottom-ns","bgBottomNs":"bg-bottom-ns","bg-left-ns":"bg-left-ns","bgLeftNs":"bg-left-ns","outline-ns":"outline-ns","outlineNs":"outline-ns","outline-transparent-ns":"outline-transparent-ns","outlineTransparentNs":"outline-transparent-ns","outline-0-ns":"outline-0-ns","outline0Ns":"outline-0-ns","ba-ns":"ba-ns","baNs":"ba-ns","bt-ns":"bt-ns","btNs":"bt-ns","br-ns":"br-ns","brNs":"br-ns","bb-ns":"bb-ns","bbNs":"bb-ns","bl-ns":"bl-ns","blNs":"bl-ns","bn-ns":"bn-ns","bnNs":"bn-ns","br0-ns":"br0-ns","br0Ns":"br-0-ns","br1-ns":"br1-ns","br1Ns":"br1-ns","br2-ns":"br2-ns","br2Ns":"br2-ns","br3-ns":"br3-ns","br3Ns":"br3-ns","br4-ns":"br4-ns","br4Ns":"br4-ns","br-100-ns":"br-100-ns","br100Ns":"br-100-ns","br-pill-ns":"br-pill-ns","brPillNs":"br-pill-ns","br--bottom-ns":"br--bottom-ns","brBottomNs":"br--bottom-ns","br--top-ns":"br--top-ns","brTopNs":"br--top-ns","br--right-ns":"br--right-ns","brRightNs":"br--right-ns","br--left-ns":"br--left-ns","brLeftNs":"br--left-ns","b--dotted-ns":"b--dotted-ns","bDottedNs":"b--dotted-ns","b--dashed-ns":"b--dashed-ns","bDashedNs":"b--dashed-ns","b--solid-ns":"b--solid-ns","bSolidNs":"b--solid-ns","b--none-ns":"b--none-ns","bNoneNs":"b--none-ns","bw0-ns":"bw0-ns","bw0Ns":"bw0-ns","bw1-ns":"bw1-ns","bw1Ns":"bw1-ns","bw2-ns":"bw2-ns","bw2Ns":"bw2-ns","bw3-ns":"bw3-ns","bw3Ns":"bw3-ns","bw4-ns":"bw4-ns","bw4Ns":"bw4-ns","bw5-ns":"bw5-ns","bw5Ns":"bw5-ns","bt-0-ns":"bt-0-ns","bt0Ns":"bt-0-ns","br-0-ns":"br-0-ns","bb-0-ns":"bb-0-ns","bb0Ns":"bb-0-ns","bl-0-ns":"bl-0-ns","bl0Ns":"bl-0-ns","shadow-1-ns":"shadow-1-ns","shadow1Ns":"shadow-1-ns","shadow-2-ns":"shadow-2-ns","shadow2Ns":"shadow-2-ns","shadow-3-ns":"shadow-3-ns","shadow3Ns":"shadow-3-ns","shadow-4-ns":"shadow-4-ns","shadow4Ns":"shadow-4-ns","shadow-5-ns":"shadow-5-ns","shadow5Ns":"shadow-5-ns","top-0-ns":"top-0-ns","top0Ns":"top-0-ns","left-0-ns":"left-0-ns","left0Ns":"left-0-ns","right-0-ns":"right-0-ns","right0Ns":"right-0-ns","bottom-0-ns":"bottom-0-ns","bottom0Ns":"bottom-0-ns","top-1-ns":"top-1-ns","top1Ns":"top--1-ns","left-1-ns":"left-1-ns","left1Ns":"left--1-ns","right-1-ns":"right-1-ns","right1Ns":"right--1-ns","bottom-1-ns":"bottom-1-ns","bottom1Ns":"bottom--1-ns","top-2-ns":"top-2-ns","top2Ns":"top--2-ns","left-2-ns":"left-2-ns","left2Ns":"left--2-ns","right-2-ns":"right-2-ns","right2Ns":"right--2-ns","bottom-2-ns":"bottom-2-ns","bottom2Ns":"bottom--2-ns","top--1-ns":"top--1-ns","right--1-ns":"right--1-ns","bottom--1-ns":"bottom--1-ns","left--1-ns":"left--1-ns","top--2-ns":"top--2-ns","right--2-ns":"right--2-ns","bottom--2-ns":"bottom--2-ns","left--2-ns":"left--2-ns","absolute--fill-ns":"absolute--fill-ns","absoluteFillNs":"absolute--fill-ns","cl-ns":"cl-ns","clNs":"cl-ns","cr-ns":"cr-ns","crNs":"cr-ns","cb-ns":"cb-ns","cbNs":"cb-ns","cn-ns":"cn-ns","cnNs":"cn-ns","dn-ns":"dn-ns","dnNs":"dn-ns","di-ns":"di-ns","diNs":"di-ns","db-ns":"db-ns","dbNs":"db-ns","dib-ns":"dib-ns","dibNs":"dib-ns","dit-ns":"dit-ns","ditNs":"dit-ns","dt-ns":"dt-ns","dtNs":"dt-ns","dtc-ns":"dtc-ns","dtcNs":"dtc-ns","dt-row-ns":"dt-row-ns","dtRowNs":"dt-row-ns","dt-row-group-ns":"dt-row-group-ns","dtRowGroupNs":"dt-row-group-ns","dt-column-ns":"dt-column-ns","dtColumnNs":"dt-column-ns","dt-column-group-ns":"dt-column-group-ns","dtColumnGroupNs":"dt-column-group-ns","dt--fixed-ns":"dt--fixed-ns","dtFixedNs":"dt--fixed-ns","flex-ns":"flex-ns","flexNs":"flex-ns","inline-flex-ns":"inline-flex-ns","inlineFlexNs":"inline-flex-ns","flex-auto-ns":"flex-auto-ns","flexAutoNs":"flex-auto-ns","flex-none-ns":"flex-none-ns","flexNoneNs":"flex-none-ns","flex-column-ns":"flex-column-ns","flexColumnNs":"flex-column-ns","flex-row-ns":"flex-row-ns","flexRowNs":"flex-row-ns","flex-wrap-ns":"flex-wrap-ns","flexWrapNs":"flex-wrap-ns","items-start-ns":"items-start-ns","itemsStartNs":"items-start-ns","items-end-ns":"items-end-ns","itemsEndNs":"items-end-ns","items-center-ns":"items-center-ns","itemsCenterNs":"items-center-ns","items-baseline-ns":"items-baseline-ns","itemsBaselineNs":"items-baseline-ns","items-stretch-ns":"items-stretch-ns","itemsStretchNs":"items-stretch-ns","self-start-ns":"self-start-ns","selfStartNs":"self-start-ns","self-end-ns":"self-end-ns","selfEndNs":"self-end-ns","self-center-ns":"self-center-ns","selfCenterNs":"self-center-ns","self-baseline-ns":"self-baseline-ns","selfBaselineNs":"self-baseline-ns","self-stretch-ns":"self-stretch-ns","selfStretchNs":"self-stretch-ns","justify-start-ns":"justify-start-ns","justifyStartNs":"justify-start-ns","justify-end-ns":"justify-end-ns","justifyEndNs":"justify-end-ns","justify-center-ns":"justify-center-ns","justifyCenterNs":"justify-center-ns","justify-between-ns":"justify-between-ns","justifyBetweenNs":"justify-between-ns","justify-around-ns":"justify-around-ns","justifyAroundNs":"justify-around-ns","content-start-ns":"content-start-ns","contentStartNs":"content-start-ns","content-end-ns":"content-end-ns","contentEndNs":"content-end-ns","content-center-ns":"content-center-ns","contentCenterNs":"content-center-ns","content-between-ns":"content-between-ns","contentBetweenNs":"content-between-ns","content-around-ns":"content-around-ns","contentAroundNs":"content-around-ns","content-stretch-ns":"content-stretch-ns","contentStretchNs":"content-stretch-ns","order-0-ns":"order-0-ns","order0Ns":"order-0-ns","order-1-ns":"order-1-ns","order1Ns":"order-1-ns","order-2-ns":"order-2-ns","order2Ns":"order-2-ns","order-3-ns":"order-3-ns","order3Ns":"order-3-ns","order-4-ns":"order-4-ns","order4Ns":"order-4-ns","order-5-ns":"order-5-ns","order5Ns":"order-5-ns","order-6-ns":"order-6-ns","order6Ns":"order-6-ns","order-7-ns":"order-7-ns","order7Ns":"order-7-ns","order-8-ns":"order-8-ns","order8Ns":"order-8-ns","order-last-ns":"order-last-ns","orderLastNs":"order-last-ns","fl-ns":"fl-ns","flNs":"fl-ns","fr-ns":"fr-ns","frNs":"fr-ns","fn-ns":"fn-ns","fnNs":"fn-ns","i-ns":"i-ns","iNs":"i-ns","fs-normal-ns":"fs-normal-ns","fsNormalNs":"fs-normal-ns","normal-ns":"normal-ns","normalNs":"normal-ns","b-ns":"b-ns","bNs":"b-ns","fw1-ns":"fw1-ns","fw1Ns":"fw1-ns","fw2-ns":"fw2-ns","fw2Ns":"fw2-ns","fw3-ns":"fw3-ns","fw3Ns":"fw3-ns","fw4-ns":"fw4-ns","fw4Ns":"fw4-ns","fw5-ns":"fw5-ns","fw5Ns":"fw5-ns","fw6-ns":"fw6-ns","fw6Ns":"fw6-ns","fw7-ns":"fw7-ns","fw7Ns":"fw7-ns","fw8-ns":"fw8-ns","fw8Ns":"fw8-ns","fw9-ns":"fw9-ns","fw9Ns":"fw9-ns","h1-ns":"h1-ns","h1Ns":"h1-ns","h2-ns":"h2-ns","h2Ns":"h2-ns","h3-ns":"h3-ns","h3Ns":"h3-ns","h4-ns":"h4-ns","h4Ns":"h4-ns","h5-ns":"h5-ns","h5Ns":"h5-ns","h-25-ns":"h-25-ns","h25Ns":"h-25-ns","h-50-ns":"h-50-ns","h50Ns":"h-50-ns","h-75-ns":"h-75-ns","h75Ns":"h-75-ns","h-100-ns":"h-100-ns","h100Ns":"h-100-ns","min-h-100-ns":"min-h-100-ns","minH100Ns":"min-h-100-ns","vh-25-ns":"vh-25-ns","vh25Ns":"vh-25-ns","vh-50-ns":"vh-50-ns","vh50Ns":"vh-50-ns","vh-75-ns":"vh-75-ns","vh75Ns":"vh-75-ns","vh-100-ns":"vh-100-ns","vh100Ns":"vh-100-ns","min-vh-100-ns":"min-vh-100-ns","minVh100Ns":"min-vh-100-ns","h-auto-ns":"h-auto-ns","hAutoNs":"h-auto-ns","h-inherit-ns":"h-inherit-ns","hInheritNs":"h-inherit-ns","tracked-ns":"tracked-ns","trackedNs":"tracked-ns","tracked-tight-ns":"tracked-tight-ns","trackedTightNs":"tracked-tight-ns","tracked-mega-ns":"tracked-mega-ns","trackedMegaNs":"tracked-mega-ns","lh-solid-ns":"lh-solid-ns","lhSolidNs":"lh-solid-ns","lh-title-ns":"lh-title-ns","lhTitleNs":"lh-title-ns","lh-copy-ns":"lh-copy-ns","lhCopyNs":"lh-copy-ns","mw-100-ns":"mw-100-ns","mw100Ns":"mw-100-ns","mw1-ns":"mw1-ns","mw1Ns":"mw1-ns","mw2-ns":"mw2-ns","mw2Ns":"mw2-ns","mw3-ns":"mw3-ns","mw3Ns":"mw3-ns","mw4-ns":"mw4-ns","mw4Ns":"mw4-ns","mw5-ns":"mw5-ns","mw5Ns":"mw5-ns","mw6-ns":"mw6-ns","mw6Ns":"mw6-ns","mw7-ns":"mw7-ns","mw7Ns":"mw7-ns","mw8-ns":"mw8-ns","mw8Ns":"mw8-ns","mw9-ns":"mw9-ns","mw9Ns":"mw9-ns","mw-none-ns":"mw-none-ns","mwNoneNs":"mw-none-ns","w1-ns":"w1-ns","w1Ns":"w1-ns","w2-ns":"w2-ns","w2Ns":"w2-ns","w3-ns":"w3-ns","w3Ns":"w3-ns","w4-ns":"w4-ns","w4Ns":"w4-ns","w5-ns":"w5-ns","w5Ns":"w5-ns","w-10-ns":"w-10-ns","w10Ns":"w-10-ns","w-20-ns":"w-20-ns","w20Ns":"w-20-ns","w-25-ns":"w-25-ns","w25Ns":"w-25-ns","w-30-ns":"w-30-ns","w30Ns":"w-30-ns","w-33-ns":"w-33-ns","w33Ns":"w-33-ns","w-34-ns":"w-34-ns","w34Ns":"w-34-ns","w-40-ns":"w-40-ns","w40Ns":"w-40-ns","w-50-ns":"w-50-ns","w50Ns":"w-50-ns","w-60-ns":"w-60-ns","w60Ns":"w-60-ns","w-70-ns":"w-70-ns","w70Ns":"w-70-ns","w-75-ns":"w-75-ns","w75Ns":"w-75-ns","w-80-ns":"w-80-ns","w80Ns":"w-80-ns","w-90-ns":"w-90-ns","w90Ns":"w-90-ns","w-100-ns":"w-100-ns","w100Ns":"w-100-ns","w-third-ns":"w-third-ns","wThirdNs":"w-third-ns","w-two-thirds-ns":"w-two-thirds-ns","wTwoThirdsNs":"w-two-thirds-ns","w-auto-ns":"w-auto-ns","wAutoNs":"w-auto-ns","overflow-visible-ns":"overflow-visible-ns","overflowVisibleNs":"overflow-visible-ns","overflow-hidden-ns":"overflow-hidden-ns","overflowHiddenNs":"overflow-hidden-ns","overflow-scroll-ns":"overflow-scroll-ns","overflowScrollNs":"overflow-scroll-ns","overflow-auto-ns":"overflow-auto-ns","overflowAutoNs":"overflow-auto-ns","overflow-x-visible-ns":"overflow-x-visible-ns","overflowXVisibleNs":"overflow-x-visible-ns","overflow-x-hidden-ns":"overflow-x-hidden-ns","overflowXHiddenNs":"overflow-x-hidden-ns","overflow-x-scroll-ns":"overflow-x-scroll-ns","overflowXScrollNs":"overflow-x-scroll-ns","overflow-x-auto-ns":"overflow-x-auto-ns","overflowXAutoNs":"overflow-x-auto-ns","overflow-y-visible-ns":"overflow-y-visible-ns","overflowYVisibleNs":"overflow-y-visible-ns","overflow-y-hidden-ns":"overflow-y-hidden-ns","overflowYHiddenNs":"overflow-y-hidden-ns","overflow-y-scroll-ns":"overflow-y-scroll-ns","overflowYScrollNs":"overflow-y-scroll-ns","overflow-y-auto-ns":"overflow-y-auto-ns","overflowYAutoNs":"overflow-y-auto-ns","static-ns":"static-ns","staticNs":"static-ns","relative-ns":"relative-ns","relativeNs":"relative-ns","absolute-ns":"absolute-ns","absoluteNs":"absolute-ns","fixed-ns":"fixed-ns","fixedNs":"fixed-ns","pa0-ns":"pa0-ns","pa0Ns":"pa0-ns","pa1-ns":"pa1-ns","pa1Ns":"pa1-ns","pa2-ns":"pa2-ns","pa2Ns":"pa2-ns","pa3-ns":"pa3-ns","pa3Ns":"pa3-ns","pa4-ns":"pa4-ns","pa4Ns":"pa4-ns","pa5-ns":"pa5-ns","pa5Ns":"pa5-ns","pa6-ns":"pa6-ns","pa6Ns":"pa6-ns","pa7-ns":"pa7-ns","pa7Ns":"pa7-ns","pl0-ns":"pl0-ns","pl0Ns":"pl0-ns","pl1-ns":"pl1-ns","pl1Ns":"pl1-ns","pl2-ns":"pl2-ns","pl2Ns":"pl2-ns","pl3-ns":"pl3-ns","pl3Ns":"pl3-ns","pl4-ns":"pl4-ns","pl4Ns":"pl4-ns","pl5-ns":"pl5-ns","pl5Ns":"pl5-ns","pl6-ns":"pl6-ns","pl6Ns":"pl6-ns","pl7-ns":"pl7-ns","pl7Ns":"pl7-ns","pr0-ns":"pr0-ns","pr0Ns":"pr0-ns","pr1-ns":"pr1-ns","pr1Ns":"pr1-ns","pr2-ns":"pr2-ns","pr2Ns":"pr2-ns","pr3-ns":"pr3-ns","pr3Ns":"pr3-ns","pr4-ns":"pr4-ns","pr4Ns":"pr4-ns","pr5-ns":"pr5-ns","pr5Ns":"pr5-ns","pr6-ns":"pr6-ns","pr6Ns":"pr6-ns","pr7-ns":"pr7-ns","pr7Ns":"pr7-ns","pb0-ns":"pb0-ns","pb0Ns":"pb0-ns","pb1-ns":"pb1-ns","pb1Ns":"pb1-ns","pb2-ns":"pb2-ns","pb2Ns":"pb2-ns","pb3-ns":"pb3-ns","pb3Ns":"pb3-ns","pb4-ns":"pb4-ns","pb4Ns":"pb4-ns","pb5-ns":"pb5-ns","pb5Ns":"pb5-ns","pb6-ns":"pb6-ns","pb6Ns":"pb6-ns","pb7-ns":"pb7-ns","pb7Ns":"pb7-ns","pt0-ns":"pt0-ns","pt0Ns":"pt0-ns","pt1-ns":"pt1-ns","pt1Ns":"pt1-ns","pt2-ns":"pt2-ns","pt2Ns":"pt2-ns","pt3-ns":"pt3-ns","pt3Ns":"pt3-ns","pt4-ns":"pt4-ns","pt4Ns":"pt4-ns","pt5-ns":"pt5-ns","pt5Ns":"pt5-ns","pt6-ns":"pt6-ns","pt6Ns":"pt6-ns","pt7-ns":"pt7-ns","pt7Ns":"pt7-ns","pv0-ns":"pv0-ns","pv0Ns":"pv0-ns","pv1-ns":"pv1-ns","pv1Ns":"pv1-ns","pv2-ns":"pv2-ns","pv2Ns":"pv2-ns","pv3-ns":"pv3-ns","pv3Ns":"pv3-ns","pv4-ns":"pv4-ns","pv4Ns":"pv4-ns","pv5-ns":"pv5-ns","pv5Ns":"pv5-ns","pv6-ns":"pv6-ns","pv6Ns":"pv6-ns","pv7-ns":"pv7-ns","pv7Ns":"pv7-ns","ph0-ns":"ph0-ns","ph0Ns":"ph0-ns","ph1-ns":"ph1-ns","ph1Ns":"ph1-ns","ph2-ns":"ph2-ns","ph2Ns":"ph2-ns","ph3-ns":"ph3-ns","ph3Ns":"ph3-ns","ph4-ns":"ph4-ns","ph4Ns":"ph4-ns","ph5-ns":"ph5-ns","ph5Ns":"ph5-ns","ph6-ns":"ph6-ns","ph6Ns":"ph6-ns","ph7-ns":"ph7-ns","ph7Ns":"ph7-ns","ma0-ns":"ma0-ns","ma0Ns":"ma0-ns","ma1-ns":"ma1-ns","ma1Ns":"ma1-ns","ma2-ns":"ma2-ns","ma2Ns":"ma2-ns","ma3-ns":"ma3-ns","ma3Ns":"ma3-ns","ma4-ns":"ma4-ns","ma4Ns":"ma4-ns","ma5-ns":"ma5-ns","ma5Ns":"ma5-ns","ma6-ns":"ma6-ns","ma6Ns":"ma6-ns","ma7-ns":"ma7-ns","ma7Ns":"ma7-ns","ml0-ns":"ml0-ns","ml0Ns":"ml0-ns","ml1-ns":"ml1-ns","ml1Ns":"ml1-ns","ml2-ns":"ml2-ns","ml2Ns":"ml2-ns","ml3-ns":"ml3-ns","ml3Ns":"ml3-ns","ml4-ns":"ml4-ns","ml4Ns":"ml4-ns","ml5-ns":"ml5-ns","ml5Ns":"ml5-ns","ml6-ns":"ml6-ns","ml6Ns":"ml6-ns","ml7-ns":"ml7-ns","ml7Ns":"ml7-ns","mr0-ns":"mr0-ns","mr0Ns":"mr0-ns","mr1-ns":"mr1-ns","mr1Ns":"mr1-ns","mr2-ns":"mr2-ns","mr2Ns":"mr2-ns","mr3-ns":"mr3-ns","mr3Ns":"mr3-ns","mr4-ns":"mr4-ns","mr4Ns":"mr4-ns","mr5-ns":"mr5-ns","mr5Ns":"mr5-ns","mr6-ns":"mr6-ns","mr6Ns":"mr6-ns","mr7-ns":"mr7-ns","mr7Ns":"mr7-ns","mb0-ns":"mb0-ns","mb0Ns":"mb0-ns","mb1-ns":"mb1-ns","mb1Ns":"mb1-ns","mb2-ns":"mb2-ns","mb2Ns":"mb2-ns","mb3-ns":"mb3-ns","mb3Ns":"mb3-ns","mb4-ns":"mb4-ns","mb4Ns":"mb4-ns","mb5-ns":"mb5-ns","mb5Ns":"mb5-ns","mb6-ns":"mb6-ns","mb6Ns":"mb6-ns","mb7-ns":"mb7-ns","mb7Ns":"mb7-ns","mt0-ns":"mt0-ns","mt0Ns":"mt0-ns","mt1-ns":"mt1-ns","mt1Ns":"mt1-ns","mt2-ns":"mt2-ns","mt2Ns":"mt2-ns","mt3-ns":"mt3-ns","mt3Ns":"mt3-ns","mt4-ns":"mt4-ns","mt4Ns":"mt4-ns","mt5-ns":"mt5-ns","mt5Ns":"mt5-ns","mt6-ns":"mt6-ns","mt6Ns":"mt6-ns","mt7-ns":"mt7-ns","mt7Ns":"mt7-ns","mv0-ns":"mv0-ns","mv0Ns":"mv0-ns","mv1-ns":"mv1-ns","mv1Ns":"mv1-ns","mv2-ns":"mv2-ns","mv2Ns":"mv2-ns","mv3-ns":"mv3-ns","mv3Ns":"mv3-ns","mv4-ns":"mv4-ns","mv4Ns":"mv4-ns","mv5-ns":"mv5-ns","mv5Ns":"mv5-ns","mv6-ns":"mv6-ns","mv6Ns":"mv6-ns","mv7-ns":"mv7-ns","mv7Ns":"mv7-ns","mh0-ns":"mh0-ns","mh0Ns":"mh0-ns","mh1-ns":"mh1-ns","mh1Ns":"mh1-ns","mh2-ns":"mh2-ns","mh2Ns":"mh2-ns","mh3-ns":"mh3-ns","mh3Ns":"mh3-ns","mh4-ns":"mh4-ns","mh4Ns":"mh4-ns","mh5-ns":"mh5-ns","mh5Ns":"mh5-ns","mh6-ns":"mh6-ns","mh6Ns":"mh6-ns","mh7-ns":"mh7-ns","mh7Ns":"mh7-ns","strike-ns":"strike-ns","strikeNs":"strike-ns","underline-ns":"underline-ns","underlineNs":"underline-ns","no-underline-ns":"no-underline-ns","noUnderlineNs":"no-underline-ns","tl-ns":"tl-ns","tlNs":"tl-ns","tr-ns":"tr-ns","trNs":"tr-ns","tc-ns":"tc-ns","tcNs":"tc-ns","ttc-ns":"ttc-ns","ttcNs":"ttc-ns","ttl-ns":"ttl-ns","ttlNs":"ttl-ns","ttu-ns":"ttu-ns","ttuNs":"ttu-ns","ttn-ns":"ttn-ns","ttnNs":"ttn-ns","f-6-ns":"f-6-ns","f6Ns":"f6-ns","f-headline-ns":"f-headline-ns","fHeadlineNs":"f-headline-ns","f-5-ns":"f-5-ns","f5Ns":"f5-ns","f-subheadline-ns":"f-subheadline-ns","fSubheadlineNs":"f-subheadline-ns","f1-ns":"f1-ns","f1Ns":"f1-ns","f2-ns":"f2-ns","f2Ns":"f2-ns","f3-ns":"f3-ns","f3Ns":"f3-ns","f4-ns":"f4-ns","f4Ns":"f4-ns","f5-ns":"f5-ns","f6-ns":"f6-ns","measure-ns":"measure-ns","measureNs":"measure-ns","measure-wide-ns":"measure-wide-ns","measureWideNs":"measure-wide-ns","measure-narrow-ns":"measure-narrow-ns","measureNarrowNs":"measure-narrow-ns","indent-ns":"indent-ns","indentNs":"indent-ns","small-caps-ns":"small-caps-ns","smallCapsNs":"small-caps-ns","truncate-ns":"truncate-ns","truncateNs":"truncate-ns","clip-ns":"clip-ns","clipNs":"clip-ns","ws-normal-ns":"ws-normal-ns","wsNormalNs":"ws-normal-ns","nowrap-ns":"nowrap-ns","nowrapNs":"nowrap-ns","pre-ns":"pre-ns","preNs":"pre-ns","v-base-ns":"v-base-ns","vBaseNs":"v-base-ns","v-mid-ns":"v-mid-ns","vMidNs":"v-mid-ns","v-top-ns":"v-top-ns","vTopNs":"v-top-ns","v-btm-ns":"v-btm-ns","vBtmNs":"v-btm-ns","cover-m":"cover-m","coverM":"cover-m","contain-m":"contain-m","containM":"contain-m","bg-center-m":"bg-center-m","bgCenterM":"bg-center-m","bg-top-m":"bg-top-m","bgTopM":"bg-top-m","bg-right-m":"bg-right-m","bgRightM":"bg-right-m","bg-bottom-m":"bg-bottom-m","bgBottomM":"bg-bottom-m","bg-left-m":"bg-left-m","bgLeftM":"bg-left-m","outline-m":"outline-m","outlineM":"outline-m","outline-transparent-m":"outline-transparent-m","outlineTransparentM":"outline-transparent-m","outline-0-m":"outline-0-m","outline0M":"outline-0-m","outline-l":"outline-l","outlineL":"outline-l","outline-transparent-l":"outline-transparent-l","outlineTransparentL":"outline-transparent-l","outline-0-l":"outline-0-l","outline0L":"outline-0-l","ba-m":"ba-m","baM":"ba-m","bt-m":"bt-m","btM":"bt-m","br-m":"br-m","brM":"br-m","bb-m":"bb-m","bbM":"bb-m","bl-m":"bl-m","blM":"bl-m","bn-m":"bn-m","bnM":"bn-m","br0-m":"br0-m","br0M":"br-0-m","br1-m":"br1-m","br1M":"br1-m","br2-m":"br2-m","br2M":"br2-m","br3-m":"br3-m","br3M":"br3-m","br4-m":"br4-m","br4M":"br4-m","br-100-m":"br-100-m","br100M":"br-100-m","br-pill-m":"br-pill-m","brPillM":"br-pill-m","br--bottom-m":"br--bottom-m","brBottomM":"br--bottom-m","br--top-m":"br--top-m","brTopM":"br--top-m","br--right-m":"br--right-m","brRightM":"br--right-m","br--left-m":"br--left-m","brLeftM":"br--left-m","b--dotted-m":"b--dotted-m","bDottedM":"b--dotted-m","b--dashed-m":"b--dashed-m","bDashedM":"b--dashed-m","b--solid-m":"b--solid-m","bSolidM":"b--solid-m","b--none-m":"b--none-m","bNoneM":"b--none-m","bw0-m":"bw0-m","bw0M":"bw0-m","bw1-m":"bw1-m","bw1M":"bw1-m","bw2-m":"bw2-m","bw2M":"bw2-m","bw3-m":"bw3-m","bw3M":"bw3-m","bw4-m":"bw4-m","bw4M":"bw4-m","bw5-m":"bw5-m","bw5M":"bw5-m","bt-0-m":"bt-0-m","bt0M":"bt-0-m","br-0-m":"br-0-m","bb-0-m":"bb-0-m","bb0M":"bb-0-m","bl-0-m":"bl-0-m","bl0M":"bl-0-m","shadow-1-m":"shadow-1-m","shadow1M":"shadow-1-m","shadow-2-m":"shadow-2-m","shadow2M":"shadow-2-m","shadow-3-m":"shadow-3-m","shadow3M":"shadow-3-m","shadow-4-m":"shadow-4-m","shadow4M":"shadow-4-m","shadow-5-m":"shadow-5-m","shadow5M":"shadow-5-m","top-0-m":"top-0-m","top0M":"top-0-m","left-0-m":"left-0-m","left0M":"left-0-m","right-0-m":"right-0-m","right0M":"right-0-m","bottom-0-m":"bottom-0-m","bottom0M":"bottom-0-m","top-1-m":"top-1-m","top1M":"top--1-m","left-1-m":"left-1-m","left1M":"left--1-m","right-1-m":"right-1-m","right1M":"right--1-m","bottom-1-m":"bottom-1-m","bottom1M":"bottom--1-m","top-2-m":"top-2-m","top2M":"top--2-m","left-2-m":"left-2-m","left2M":"left--2-m","right-2-m":"right-2-m","right2M":"right--2-m","bottom-2-m":"bottom-2-m","bottom2M":"bottom--2-m","top--1-m":"top--1-m","right--1-m":"right--1-m","bottom--1-m":"bottom--1-m","left--1-m":"left--1-m","top--2-m":"top--2-m","right--2-m":"right--2-m","bottom--2-m":"bottom--2-m","left--2-m":"left--2-m","absolute--fill-m":"absolute--fill-m","absoluteFillM":"absolute--fill-m","cl-m":"cl-m","clM":"cl-m","cr-m":"cr-m","crM":"cr-m","cb-m":"cb-m","cbM":"cb-m","cn-m":"cn-m","cnM":"cn-m","dn-m":"dn-m","dnM":"dn-m","di-m":"di-m","diM":"di-m","db-m":"db-m","dbM":"db-m","dib-m":"dib-m","dibM":"dib-m","dit-m":"dit-m","ditM":"dit-m","dt-m":"dt-m","dtM":"dt-m","dtc-m":"dtc-m","dtcM":"dtc-m","dt-row-m":"dt-row-m","dtRowM":"dt-row-m","dt-row-group-m":"dt-row-group-m","dtRowGroupM":"dt-row-group-m","dt-column-m":"dt-column-m","dtColumnM":"dt-column-m","dt-column-group-m":"dt-column-group-m","dtColumnGroupM":"dt-column-group-m","dt--fixed-m":"dt--fixed-m","dtFixedM":"dt--fixed-m","flex-m":"flex-m","flexM":"flex-m","inline-flex-m":"inline-flex-m","inlineFlexM":"inline-flex-m","flex-auto-m":"flex-auto-m","flexAutoM":"flex-auto-m","flex-none-m":"flex-none-m","flexNoneM":"flex-none-m","flex-column-m":"flex-column-m","flexColumnM":"flex-column-m","flex-row-m":"flex-row-m","flexRowM":"flex-row-m","flex-wrap-m":"flex-wrap-m","flexWrapM":"flex-wrap-m","items-start-m":"items-start-m","itemsStartM":"items-start-m","items-end-m":"items-end-m","itemsEndM":"items-end-m","items-center-m":"items-center-m","itemsCenterM":"items-center-m","items-baseline-m":"items-baseline-m","itemsBaselineM":"items-baseline-m","items-stretch-m":"items-stretch-m","itemsStretchM":"items-stretch-m","self-start-m":"self-start-m","selfStartM":"self-start-m","self-end-m":"self-end-m","selfEndM":"self-end-m","self-center-m":"self-center-m","selfCenterM":"self-center-m","self-baseline-m":"self-baseline-m","selfBaselineM":"self-baseline-m","self-stretch-m":"self-stretch-m","selfStretchM":"self-stretch-m","justify-start-m":"justify-start-m","justifyStartM":"justify-start-m","justify-end-m":"justify-end-m","justifyEndM":"justify-end-m","justify-center-m":"justify-center-m","justifyCenterM":"justify-center-m","justify-between-m":"justify-between-m","justifyBetweenM":"justify-between-m","justify-around-m":"justify-around-m","justifyAroundM":"justify-around-m","content-start-m":"content-start-m","contentStartM":"content-start-m","content-end-m":"content-end-m","contentEndM":"content-end-m","content-center-m":"content-center-m","contentCenterM":"content-center-m","content-between-m":"content-between-m","contentBetweenM":"content-between-m","content-around-m":"content-around-m","contentAroundM":"content-around-m","content-stretch-m":"content-stretch-m","contentStretchM":"content-stretch-m","order-0-m":"order-0-m","order0M":"order-0-m","order-1-m":"order-1-m","order1M":"order-1-m","order-2-m":"order-2-m","order2M":"order-2-m","order-3-m":"order-3-m","order3M":"order-3-m","order-4-m":"order-4-m","order4M":"order-4-m","order-5-m":"order-5-m","order5M":"order-5-m","order-6-m":"order-6-m","order6M":"order-6-m","order-7-m":"order-7-m","order7M":"order-7-m","order-8-m":"order-8-m","order8M":"order-8-m","order-last-m":"order-last-m","orderLastM":"order-last-m","fl-m":"fl-m","flM":"fl-m","fr-m":"fr-m","frM":"fr-m","fn-m":"fn-m","fnM":"fn-m","i-m":"i-m","iM":"i-m","fs-normal-m":"fs-normal-m","fsNormalM":"fs-normal-m","normal-m":"normal-m","normalM":"normal-m","b-m":"b-m","bM":"b-m","fw1-m":"fw1-m","fw1M":"fw1-m","fw2-m":"fw2-m","fw2M":"fw2-m","fw3-m":"fw3-m","fw3M":"fw3-m","fw4-m":"fw4-m","fw4M":"fw4-m","fw5-m":"fw5-m","fw5M":"fw5-m","fw6-m":"fw6-m","fw6M":"fw6-m","fw7-m":"fw7-m","fw7M":"fw7-m","fw8-m":"fw8-m","fw8M":"fw8-m","fw9-m":"fw9-m","fw9M":"fw9-m","h1-m":"h1-m","h1M":"h1-m","h2-m":"h2-m","h2M":"h2-m","h3-m":"h3-m","h3M":"h3-m","h4-m":"h4-m","h4M":"h4-m","h5-m":"h5-m","h5M":"h5-m","h-25-m":"h-25-m","h25M":"h-25-m","h-50-m":"h-50-m","h50M":"h-50-m","h-75-m":"h-75-m","h75M":"h-75-m","h-100-m":"h-100-m","h100M":"h-100-m","vh-25-m":"vh-25-m","vh25M":"vh-25-m","vh-50-m":"vh-50-m","vh50M":"vh-50-m","vh-75-m":"vh-75-m","vh75M":"vh-75-m","vh-100-m":"vh-100-m","vh100M":"vh-100-m","min-vh-100-m":"min-vh-100-m","minVh100M":"min-vh-100-m","h-auto-m":"h-auto-m","hAutoM":"h-auto-m","h-inherit-m":"h-inherit-m","hInheritM":"h-inherit-m","tracked-m":"tracked-m","trackedM":"tracked-m","tracked-tight-m":"tracked-tight-m","trackedTightM":"tracked-tight-m","tracked-mega-m":"tracked-mega-m","trackedMegaM":"tracked-mega-m","lh-solid-m":"lh-solid-m","lhSolidM":"lh-solid-m","lh-title-m":"lh-title-m","lhTitleM":"lh-title-m","lh-copy-m":"lh-copy-m","lhCopyM":"lh-copy-m","mw-100-m":"mw-100-m","mw100M":"mw-100-m","mw1-m":"mw1-m","mw1M":"mw1-m","mw2-m":"mw2-m","mw2M":"mw2-m","mw3-m":"mw3-m","mw3M":"mw3-m","mw4-m":"mw4-m","mw4M":"mw4-m","mw5-m":"mw5-m","mw5M":"mw5-m","mw6-m":"mw6-m","mw6M":"mw6-m","mw7-m":"mw7-m","mw7M":"mw7-m","mw8-m":"mw8-m","mw8M":"mw8-m","mw9-m":"mw9-m","mw9M":"mw9-m","mw-none-m":"mw-none-m","mwNoneM":"mw-none-m","w1-m":"w1-m","w1M":"w1-m","w2-m":"w2-m","w2M":"w2-m","w3-m":"w3-m","w3M":"w3-m","w4-m":"w4-m","w4M":"w4-m","w5-m":"w5-m","w5M":"w5-m","w-10-m":"w-10-m","w10M":"w-10-m","w-20-m":"w-20-m","w20M":"w-20-m","w-25-m":"w-25-m","w25M":"w-25-m","w-30-m":"w-30-m","w30M":"w-30-m","w-33-m":"w-33-m","w33M":"w-33-m","w-34-m":"w-34-m","w34M":"w-34-m","w-40-m":"w-40-m","w40M":"w-40-m","w-50-m":"w-50-m","w50M":"w-50-m","w-60-m":"w-60-m","w60M":"w-60-m","w-70-m":"w-70-m","w70M":"w-70-m","w-75-m":"w-75-m","w75M":"w-75-m","w-80-m":"w-80-m","w80M":"w-80-m","w-90-m":"w-90-m","w90M":"w-90-m","w-100-m":"w-100-m","w100M":"w-100-m","w-third-m":"w-third-m","wThirdM":"w-third-m","w-two-thirds-m":"w-two-thirds-m","wTwoThirdsM":"w-two-thirds-m","w-auto-m":"w-auto-m","wAutoM":"w-auto-m","overflow-visible-m":"overflow-visible-m","overflowVisibleM":"overflow-visible-m","overflow-hidden-m":"overflow-hidden-m","overflowHiddenM":"overflow-hidden-m","overflow-scroll-m":"overflow-scroll-m","overflowScrollM":"overflow-scroll-m","overflow-auto-m":"overflow-auto-m","overflowAutoM":"overflow-auto-m","overflow-x-visible-m":"overflow-x-visible-m","overflowXVisibleM":"overflow-x-visible-m","overflow-x-hidden-m":"overflow-x-hidden-m","overflowXHiddenM":"overflow-x-hidden-m","overflow-x-scroll-m":"overflow-x-scroll-m","overflowXScrollM":"overflow-x-scroll-m","overflow-x-auto-m":"overflow-x-auto-m","overflowXAutoM":"overflow-x-auto-m","overflow-y-visible-m":"overflow-y-visible-m","overflowYVisibleM":"overflow-y-visible-m","overflow-y-hidden-m":"overflow-y-hidden-m","overflowYHiddenM":"overflow-y-hidden-m","overflow-y-scroll-m":"overflow-y-scroll-m","overflowYScrollM":"overflow-y-scroll-m","overflow-y-auto-m":"overflow-y-auto-m","overflowYAutoM":"overflow-y-auto-m","static-m":"static-m","staticM":"static-m","relative-m":"relative-m","relativeM":"relative-m","absolute-m":"absolute-m","absoluteM":"absolute-m","fixed-m":"fixed-m","fixedM":"fixed-m","pa0-m":"pa0-m","pa0M":"pa0-m","pa1-m":"pa1-m","pa1M":"pa1-m","pa2-m":"pa2-m","pa2M":"pa2-m","pa3-m":"pa3-m","pa3M":"pa3-m","pa4-m":"pa4-m","pa4M":"pa4-m","pa5-m":"pa5-m","pa5M":"pa5-m","pa6-m":"pa6-m","pa6M":"pa6-m","pa7-m":"pa7-m","pa7M":"pa7-m","pl0-m":"pl0-m","pl0M":"pl0-m","pl1-m":"pl1-m","pl1M":"pl1-m","pl2-m":"pl2-m","pl2M":"pl2-m","pl3-m":"pl3-m","pl3M":"pl3-m","pl4-m":"pl4-m","pl4M":"pl4-m","pl5-m":"pl5-m","pl5M":"pl5-m","pl6-m":"pl6-m","pl6M":"pl6-m","pl7-m":"pl7-m","pl7M":"pl7-m","pr0-m":"pr0-m","pr0M":"pr0-m","pr1-m":"pr1-m","pr1M":"pr1-m","pr2-m":"pr2-m","pr2M":"pr2-m","pr3-m":"pr3-m","pr3M":"pr3-m","pr4-m":"pr4-m","pr4M":"pr4-m","pr5-m":"pr5-m","pr5M":"pr5-m","pr6-m":"pr6-m","pr6M":"pr6-m","pr7-m":"pr7-m","pr7M":"pr7-m","pb0-m":"pb0-m","pb0M":"pb0-m","pb1-m":"pb1-m","pb1M":"pb1-m","pb2-m":"pb2-m","pb2M":"pb2-m","pb3-m":"pb3-m","pb3M":"pb3-m","pb4-m":"pb4-m","pb4M":"pb4-m","pb5-m":"pb5-m","pb5M":"pb5-m","pb6-m":"pb6-m","pb6M":"pb6-m","pb7-m":"pb7-m","pb7M":"pb7-m","pt0-m":"pt0-m","pt0M":"pt0-m","pt1-m":"pt1-m","pt1M":"pt1-m","pt2-m":"pt2-m","pt2M":"pt2-m","pt3-m":"pt3-m","pt3M":"pt3-m","pt4-m":"pt4-m","pt4M":"pt4-m","pt5-m":"pt5-m","pt5M":"pt5-m","pt6-m":"pt6-m","pt6M":"pt6-m","pt7-m":"pt7-m","pt7M":"pt7-m","pv0-m":"pv0-m","pv0M":"pv0-m","pv1-m":"pv1-m","pv1M":"pv1-m","pv2-m":"pv2-m","pv2M":"pv2-m","pv3-m":"pv3-m","pv3M":"pv3-m","pv4-m":"pv4-m","pv4M":"pv4-m","pv5-m":"pv5-m","pv5M":"pv5-m","pv6-m":"pv6-m","pv6M":"pv6-m","pv7-m":"pv7-m","pv7M":"pv7-m","ph0-m":"ph0-m","ph0M":"ph0-m","ph1-m":"ph1-m","ph1M":"ph1-m","ph2-m":"ph2-m","ph2M":"ph2-m","ph3-m":"ph3-m","ph3M":"ph3-m","ph4-m":"ph4-m","ph4M":"ph4-m","ph5-m":"ph5-m","ph5M":"ph5-m","ph6-m":"ph6-m","ph6M":"ph6-m","ph7-m":"ph7-m","ph7M":"ph7-m","ma0-m":"ma0-m","ma0M":"ma0-m","ma1-m":"ma1-m","ma1M":"ma1-m","ma2-m":"ma2-m","ma2M":"ma2-m","ma3-m":"ma3-m","ma3M":"ma3-m","ma4-m":"ma4-m","ma4M":"ma4-m","ma5-m":"ma5-m","ma5M":"ma5-m","ma6-m":"ma6-m","ma6M":"ma6-m","ma7-m":"ma7-m","ma7M":"ma7-m","ml0-m":"ml0-m","ml0M":"ml0-m","ml1-m":"ml1-m","ml1M":"ml1-m","ml2-m":"ml2-m","ml2M":"ml2-m","ml3-m":"ml3-m","ml3M":"ml3-m","ml4-m":"ml4-m","ml4M":"ml4-m","ml5-m":"ml5-m","ml5M":"ml5-m","ml6-m":"ml6-m","ml6M":"ml6-m","ml7-m":"ml7-m","ml7M":"ml7-m","mr0-m":"mr0-m","mr0M":"mr0-m","mr1-m":"mr1-m","mr1M":"mr1-m","mr2-m":"mr2-m","mr2M":"mr2-m","mr3-m":"mr3-m","mr3M":"mr3-m","mr4-m":"mr4-m","mr4M":"mr4-m","mr5-m":"mr5-m","mr5M":"mr5-m","mr6-m":"mr6-m","mr6M":"mr6-m","mr7-m":"mr7-m","mr7M":"mr7-m","mb0-m":"mb0-m","mb0M":"mb0-m","mb1-m":"mb1-m","mb1M":"mb1-m","mb2-m":"mb2-m","mb2M":"mb2-m","mb3-m":"mb3-m","mb3M":"mb3-m","mb4-m":"mb4-m","mb4M":"mb4-m","mb5-m":"mb5-m","mb5M":"mb5-m","mb6-m":"mb6-m","mb6M":"mb6-m","mb7-m":"mb7-m","mb7M":"mb7-m","mt0-m":"mt0-m","mt0M":"mt0-m","mt1-m":"mt1-m","mt1M":"mt1-m","mt2-m":"mt2-m","mt2M":"mt2-m","mt3-m":"mt3-m","mt3M":"mt3-m","mt4-m":"mt4-m","mt4M":"mt4-m","mt5-m":"mt5-m","mt5M":"mt5-m","mt6-m":"mt6-m","mt6M":"mt6-m","mt7-m":"mt7-m","mt7M":"mt7-m","mv0-m":"mv0-m","mv0M":"mv0-m","mv1-m":"mv1-m","mv1M":"mv1-m","mv2-m":"mv2-m","mv2M":"mv2-m","mv3-m":"mv3-m","mv3M":"mv3-m","mv4-m":"mv4-m","mv4M":"mv4-m","mv5-m":"mv5-m","mv5M":"mv5-m","mv6-m":"mv6-m","mv6M":"mv6-m","mv7-m":"mv7-m","mv7M":"mv7-m","mh0-m":"mh0-m","mh0M":"mh0-m","mh1-m":"mh1-m","mh1M":"mh1-m","mh2-m":"mh2-m","mh2M":"mh2-m","mh3-m":"mh3-m","mh3M":"mh3-m","mh4-m":"mh4-m","mh4M":"mh4-m","mh5-m":"mh5-m","mh5M":"mh5-m","mh6-m":"mh6-m","mh6M":"mh6-m","mh7-m":"mh7-m","mh7M":"mh7-m","strike-m":"strike-m","strikeM":"strike-m","underline-m":"underline-m","underlineM":"underline-m","no-underline-m":"no-underline-m","noUnderlineM":"no-underline-m","tl-m":"tl-m","tlM":"tl-m","tr-m":"tr-m","trM":"tr-m","tc-m":"tc-m","tcM":"tc-m","ttc-m":"ttc-m","ttcM":"ttc-m","ttl-m":"ttl-m","ttlM":"ttl-m","ttu-m":"ttu-m","ttuM":"ttu-m","ttn-m":"ttn-m","ttnM":"ttn-m","f-6-m":"f-6-m","f6M":"f6-m","f-headline-m":"f-headline-m","fHeadlineM":"f-headline-m","f-5-m":"f-5-m","f5M":"f5-m","f-subheadline-m":"f-subheadline-m","fSubheadlineM":"f-subheadline-m","f1-m":"f1-m","f1M":"f1-m","f2-m":"f2-m","f2M":"f2-m","f3-m":"f3-m","f3M":"f3-m","f4-m":"f4-m","f4M":"f4-m","f5-m":"f5-m","f6-m":"f6-m","measure-m":"measure-m","measureM":"measure-m","measure-wide-m":"measure-wide-m","measureWideM":"measure-wide-m","measure-narrow-m":"measure-narrow-m","measureNarrowM":"measure-narrow-m","indent-m":"indent-m","indentM":"indent-m","small-caps-m":"small-caps-m","smallCapsM":"small-caps-m","truncate-m":"truncate-m","truncateM":"truncate-m","clip-m":"clip-m","clipM":"clip-m","ws-normal-m":"ws-normal-m","wsNormalM":"ws-normal-m","nowrap-m":"nowrap-m","nowrapM":"nowrap-m","pre-m":"pre-m","preM":"pre-m","v-base-m":"v-base-m","vBaseM":"v-base-m","v-mid-m":"v-mid-m","vMidM":"v-mid-m","v-top-m":"v-top-m","vTopM":"v-top-m","v-btm-m":"v-btm-m","vBtmM":"v-btm-m","cover-l":"cover-l","coverL":"cover-l","contain-l":"contain-l","containL":"contain-l","bg-center-l":"bg-center-l","bgCenterL":"bg-center-l","bg-top-l":"bg-top-l","bgTopL":"bg-top-l","bg-right-l":"bg-right-l","bgRightL":"bg-right-l","bg-bottom-l":"bg-bottom-l","bgBottomL":"bg-bottom-l","bg-left-l":"bg-left-l","bgLeftL":"bg-left-l","ba-l":"ba-l","baL":"ba-l","bt-l":"bt-l","btL":"bt-l","br-l":"br-l","brL":"br-l","bb-l":"bb-l","bbL":"bb-l","bl-l":"bl-l","blL":"bl-l","bn-l":"bn-l","bnL":"bn-l","br0-l":"br0-l","br0L":"br-0-l","br1-l":"br1-l","br1L":"br1-l","br2-l":"br2-l","br2L":"br2-l","br3-l":"br3-l","br3L":"br3-l","br4-l":"br4-l","br4L":"br4-l","br-100-l":"br-100-l","br100L":"br-100-l","br-pill-l":"br-pill-l","brPillL":"br-pill-l","br--bottom-l":"br--bottom-l","brBottomL":"br--bottom-l","br--top-l":"br--top-l","brTopL":"br--top-l","br--right-l":"br--right-l","brRightL":"br--right-l","br--left-l":"br--left-l","brLeftL":"br--left-l","b--dotted-l":"b--dotted-l","bDottedL":"b--dotted-l","b--dashed-l":"b--dashed-l","bDashedL":"b--dashed-l","b--solid-l":"b--solid-l","bSolidL":"b--solid-l","b--none-l":"b--none-l","bNoneL":"b--none-l","bw0-l":"bw0-l","bw0L":"bw0-l","bw1-l":"bw1-l","bw1L":"bw1-l","bw2-l":"bw2-l","bw2L":"bw2-l","bw3-l":"bw3-l","bw3L":"bw3-l","bw4-l":"bw4-l","bw4L":"bw4-l","bw5-l":"bw5-l","bw5L":"bw5-l","bt-0-l":"bt-0-l","bt0L":"bt-0-l","br-0-l":"br-0-l","bb-0-l":"bb-0-l","bb0L":"bb-0-l","bl-0-l":"bl-0-l","bl0L":"bl-0-l","shadow-1-l":"shadow-1-l","shadow1L":"shadow-1-l","shadow-2-l":"shadow-2-l","shadow2L":"shadow-2-l","shadow-3-l":"shadow-3-l","shadow3L":"shadow-3-l","shadow-4-l":"shadow-4-l","shadow4L":"shadow-4-l","shadow-5-l":"shadow-5-l","shadow5L":"shadow-5-l","top-0-l":"top-0-l","top0L":"top-0-l","left-0-l":"left-0-l","left0L":"left-0-l","right-0-l":"right-0-l","right0L":"right-0-l","bottom-0-l":"bottom-0-l","bottom0L":"bottom-0-l","top-1-l":"top-1-l","top1L":"top--1-l","left-1-l":"left-1-l","left1L":"left--1-l","right-1-l":"right-1-l","right1L":"right--1-l","bottom-1-l":"bottom-1-l","bottom1L":"bottom--1-l","top-2-l":"top-2-l","top2L":"top--2-l","left-2-l":"left-2-l","left2L":"left--2-l","right-2-l":"right-2-l","right2L":"right--2-l","bottom-2-l":"bottom-2-l","bottom2L":"bottom--2-l","top--1-l":"top--1-l","right--1-l":"right--1-l","bottom--1-l":"bottom--1-l","left--1-l":"left--1-l","top--2-l":"top--2-l","right--2-l":"right--2-l","bottom--2-l":"bottom--2-l","left--2-l":"left--2-l","absolute--fill-l":"absolute--fill-l","absoluteFillL":"absolute--fill-l","cl-l":"cl-l","clL":"cl-l","cr-l":"cr-l","crL":"cr-l","cb-l":"cb-l","cbL":"cb-l","cn-l":"cn-l","cnL":"cn-l","dn-l":"dn-l","dnL":"dn-l","di-l":"di-l","diL":"di-l","db-l":"db-l","dbL":"db-l","dib-l":"dib-l","dibL":"dib-l","dit-l":"dit-l","ditL":"dit-l","dt-l":"dt-l","dtL":"dt-l","dtc-l":"dtc-l","dtcL":"dtc-l","dt-row-l":"dt-row-l","dtRowL":"dt-row-l","dt-row-group-l":"dt-row-group-l","dtRowGroupL":"dt-row-group-l","dt-column-l":"dt-column-l","dtColumnL":"dt-column-l","dt-column-group-l":"dt-column-group-l","dtColumnGroupL":"dt-column-group-l","dt--fixed-l":"dt--fixed-l","dtFixedL":"dt--fixed-l","flex-l":"flex-l","flexL":"flex-l","inline-flex-l":"inline-flex-l","inlineFlexL":"inline-flex-l","flex-auto-l":"flex-auto-l","flexAutoL":"flex-auto-l","flex-none-l":"flex-none-l","flexNoneL":"flex-none-l","flex-column-l":"flex-column-l","flexColumnL":"flex-column-l","flex-row-l":"flex-row-l","flexRowL":"flex-row-l","flex-wrap-l":"flex-wrap-l","flexWrapL":"flex-wrap-l","items-start-l":"items-start-l","itemsStartL":"items-start-l","items-end-l":"items-end-l","itemsEndL":"items-end-l","items-center-l":"items-center-l","itemsCenterL":"items-center-l","items-baseline-l":"items-baseline-l","itemsBaselineL":"items-baseline-l","items-stretch-l":"items-stretch-l","itemsStretchL":"items-stretch-l","self-start-l":"self-start-l","selfStartL":"self-start-l","self-end-l":"self-end-l","selfEndL":"self-end-l","self-center-l":"self-center-l","selfCenterL":"self-center-l","self-baseline-l":"self-baseline-l","selfBaselineL":"self-baseline-l","self-stretch-l":"self-stretch-l","selfStretchL":"self-stretch-l","justify-start-l":"justify-start-l","justifyStartL":"justify-start-l","justify-end-l":"justify-end-l","justifyEndL":"justify-end-l","justify-center-l":"justify-center-l","justifyCenterL":"justify-center-l","justify-between-l":"justify-between-l","justifyBetweenL":"justify-between-l","justify-around-l":"justify-around-l","justifyAroundL":"justify-around-l","content-start-l":"content-start-l","contentStartL":"content-start-l","content-end-l":"content-end-l","contentEndL":"content-end-l","content-center-l":"content-center-l","contentCenterL":"content-center-l","content-between-l":"content-between-l","contentBetweenL":"content-between-l","content-around-l":"content-around-l","contentAroundL":"content-around-l","content-stretch-l":"content-stretch-l","contentStretchL":"content-stretch-l","order-0-l":"order-0-l","order0L":"order-0-l","order-1-l":"order-1-l","order1L":"order-1-l","order-2-l":"order-2-l","order2L":"order-2-l","order-3-l":"order-3-l","order3L":"order-3-l","order-4-l":"order-4-l","order4L":"order-4-l","order-5-l":"order-5-l","order5L":"order-5-l","order-6-l":"order-6-l","order6L":"order-6-l","order-7-l":"order-7-l","order7L":"order-7-l","order-8-l":"order-8-l","order8L":"order-8-l","order-last-l":"order-last-l","orderLastL":"order-last-l","fl-l":"fl-l","flL":"fl-l","fr-l":"fr-l","frL":"fr-l","fn-l":"fn-l","fnL":"fn-l","i-l":"i-l","iL":"i-l","fs-normal-l":"fs-normal-l","fsNormalL":"fs-normal-l","normal-l":"normal-l","normalL":"normal-l","b-l":"b-l","bL":"b-l","fw1-l":"fw1-l","fw1L":"fw1-l","fw2-l":"fw2-l","fw2L":"fw2-l","fw3-l":"fw3-l","fw3L":"fw3-l","fw4-l":"fw4-l","fw4L":"fw4-l","fw5-l":"fw5-l","fw5L":"fw5-l","fw6-l":"fw6-l","fw6L":"fw6-l","fw7-l":"fw7-l","fw7L":"fw7-l","fw8-l":"fw8-l","fw8L":"fw8-l","fw9-l":"fw9-l","fw9L":"fw9-l","h1-l":"h1-l","h1L":"h1-l","h2-l":"h2-l","h2L":"h2-l","h3-l":"h3-l","h3L":"h3-l","h4-l":"h4-l","h4L":"h4-l","h5-l":"h5-l","h5L":"h5-l","h-25-l":"h-25-l","h25L":"h-25-l","h-50-l":"h-50-l","h50L":"h-50-l","h-75-l":"h-75-l","h75L":"h-75-l","h-100-l":"h-100-l","h100L":"h-100-l","min-h-100-l":"min-h-100-l","minH100L":"min-h-100-l","vh-25-l":"vh-25-l","vh25L":"vh-25-l","vh-50-l":"vh-50-l","vh50L":"vh-50-l","vh-75-l":"vh-75-l","vh75L":"vh-75-l","vh-100-l":"vh-100-l","vh100L":"vh-100-l","h-auto-l":"h-auto-l","hAutoL":"h-auto-l","h-inherit-l":"h-inherit-l","hInheritL":"h-inherit-l","tracked-l":"tracked-l","trackedL":"tracked-l","tracked-tight-l":"tracked-tight-l","trackedTightL":"tracked-tight-l","tracked-mega-l":"tracked-mega-l","trackedMegaL":"tracked-mega-l","lh-solid-l":"lh-solid-l","lhSolidL":"lh-solid-l","lh-title-l":"lh-title-l","lhTitleL":"lh-title-l","lh-copy-l":"lh-copy-l","lhCopyL":"lh-copy-l","mw-100-l":"mw-100-l","mw100L":"mw-100-l","mw1-l":"mw1-l","mw1L":"mw1-l","mw2-l":"mw2-l","mw2L":"mw2-l","mw3-l":"mw3-l","mw3L":"mw3-l","mw4-l":"mw4-l","mw4L":"mw4-l","mw5-l":"mw5-l","mw5L":"mw5-l","mw6-l":"mw6-l","mw6L":"mw6-l","mw7-l":"mw7-l","mw7L":"mw7-l","mw8-l":"mw8-l","mw8L":"mw8-l","mw9-l":"mw9-l","mw9L":"mw9-l","mw-none-l":"mw-none-l","mwNoneL":"mw-none-l","w1-l":"w1-l","w1L":"w1-l","w2-l":"w2-l","w2L":"w2-l","w3-l":"w3-l","w3L":"w3-l","w4-l":"w4-l","w4L":"w4-l","w5-l":"w5-l","w5L":"w5-l","w-10-l":"w-10-l","w10L":"w-10-l","w-20-l":"w-20-l","w20L":"w-20-l","w-25-l":"w-25-l","w25L":"w-25-l","w-30-l":"w-30-l","w30L":"w-30-l","w-33-l":"w-33-l","w33L":"w-33-l","w-34-l":"w-34-l","w34L":"w-34-l","w-40-l":"w-40-l","w40L":"w-40-l","w-50-l":"w-50-l","w50L":"w-50-l","w-60-l":"w-60-l","w60L":"w-60-l","w-70-l":"w-70-l","w70L":"w-70-l","w-75-l":"w-75-l","w75L":"w-75-l","w-80-l":"w-80-l","w80L":"w-80-l","w-90-l":"w-90-l","w90L":"w-90-l","w-100-l":"w-100-l","w100L":"w-100-l","w-third-l":"w-third-l","wThirdL":"w-third-l","w-two-thirds-l":"w-two-thirds-l","wTwoThirdsL":"w-two-thirds-l","w-auto-l":"w-auto-l","wAutoL":"w-auto-l","overflow-visible-l":"overflow-visible-l","overflowVisibleL":"overflow-visible-l","overflow-hidden-l":"overflow-hidden-l","overflowHiddenL":"overflow-hidden-l","overflow-scroll-l":"overflow-scroll-l","overflowScrollL":"overflow-scroll-l","overflow-auto-l":"overflow-auto-l","overflowAutoL":"overflow-auto-l","overflow-x-visible-l":"overflow-x-visible-l","overflowXVisibleL":"overflow-x-visible-l","overflow-x-hidden-l":"overflow-x-hidden-l","overflowXHiddenL":"overflow-x-hidden-l","overflow-x-scroll-l":"overflow-x-scroll-l","overflowXScrollL":"overflow-x-scroll-l","overflow-x-auto-l":"overflow-x-auto-l","overflowXAutoL":"overflow-x-auto-l","overflow-y-visible-l":"overflow-y-visible-l","overflowYVisibleL":"overflow-y-visible-l","overflow-y-hidden-l":"overflow-y-hidden-l","overflowYHiddenL":"overflow-y-hidden-l","overflow-y-scroll-l":"overflow-y-scroll-l","overflowYScrollL":"overflow-y-scroll-l","overflow-y-auto-l":"overflow-y-auto-l","overflowYAutoL":"overflow-y-auto-l","static-l":"static-l","staticL":"static-l","relative-l":"relative-l","relativeL":"relative-l","absolute-l":"absolute-l","absoluteL":"absolute-l","fixed-l":"fixed-l","fixedL":"fixed-l","pa0-l":"pa0-l","pa0L":"pa0-l","pa1-l":"pa1-l","pa1L":"pa1-l","pa2-l":"pa2-l","pa2L":"pa2-l","pa3-l":"pa3-l","pa3L":"pa3-l","pa4-l":"pa4-l","pa4L":"pa4-l","pa5-l":"pa5-l","pa5L":"pa5-l","pa6-l":"pa6-l","pa6L":"pa6-l","pa7-l":"pa7-l","pa7L":"pa7-l","pl0-l":"pl0-l","pl0L":"pl0-l","pl1-l":"pl1-l","pl1L":"pl1-l","pl2-l":"pl2-l","pl2L":"pl2-l","pl3-l":"pl3-l","pl3L":"pl3-l","pl4-l":"pl4-l","pl4L":"pl4-l","pl5-l":"pl5-l","pl5L":"pl5-l","pl6-l":"pl6-l","pl6L":"pl6-l","pl7-l":"pl7-l","pl7L":"pl7-l","pr0-l":"pr0-l","pr0L":"pr0-l","pr1-l":"pr1-l","pr1L":"pr1-l","pr2-l":"pr2-l","pr2L":"pr2-l","pr3-l":"pr3-l","pr3L":"pr3-l","pr4-l":"pr4-l","pr4L":"pr4-l","pr5-l":"pr5-l","pr5L":"pr5-l","pr6-l":"pr6-l","pr6L":"pr6-l","pr7-l":"pr7-l","pr7L":"pr7-l","pb0-l":"pb0-l","pb0L":"pb0-l","pb1-l":"pb1-l","pb1L":"pb1-l","pb2-l":"pb2-l","pb2L":"pb2-l","pb3-l":"pb3-l","pb3L":"pb3-l","pb4-l":"pb4-l","pb4L":"pb4-l","pb5-l":"pb5-l","pb5L":"pb5-l","pb6-l":"pb6-l","pb6L":"pb6-l","pb7-l":"pb7-l","pb7L":"pb7-l","pt0-l":"pt0-l","pt0L":"pt0-l","pt1-l":"pt1-l","pt1L":"pt1-l","pt2-l":"pt2-l","pt2L":"pt2-l","pt3-l":"pt3-l","pt3L":"pt3-l","pt4-l":"pt4-l","pt4L":"pt4-l","pt5-l":"pt5-l","pt5L":"pt5-l","pt6-l":"pt6-l","pt6L":"pt6-l","pt7-l":"pt7-l","pt7L":"pt7-l","pv0-l":"pv0-l","pv0L":"pv0-l","pv1-l":"pv1-l","pv1L":"pv1-l","pv2-l":"pv2-l","pv2L":"pv2-l","pv3-l":"pv3-l","pv3L":"pv3-l","pv4-l":"pv4-l","pv4L":"pv4-l","pv5-l":"pv5-l","pv5L":"pv5-l","pv6-l":"pv6-l","pv6L":"pv6-l","pv7-l":"pv7-l","pv7L":"pv7-l","ph0-l":"ph0-l","ph0L":"ph0-l","ph1-l":"ph1-l","ph1L":"ph1-l","ph2-l":"ph2-l","ph2L":"ph2-l","ph3-l":"ph3-l","ph3L":"ph3-l","ph4-l":"ph4-l","ph4L":"ph4-l","ph5-l":"ph5-l","ph5L":"ph5-l","ph6-l":"ph6-l","ph6L":"ph6-l","ph7-l":"ph7-l","ph7L":"ph7-l","ma0-l":"ma0-l","ma0L":"ma0-l","ma1-l":"ma1-l","ma1L":"ma1-l","ma2-l":"ma2-l","ma2L":"ma2-l","ma3-l":"ma3-l","ma3L":"ma3-l","ma4-l":"ma4-l","ma4L":"ma4-l","ma5-l":"ma5-l","ma5L":"ma5-l","ma6-l":"ma6-l","ma6L":"ma6-l","ma7-l":"ma7-l","ma7L":"ma7-l","ml0-l":"ml0-l","ml0L":"ml0-l","ml1-l":"ml1-l","ml1L":"ml1-l","ml2-l":"ml2-l","ml2L":"ml2-l","ml3-l":"ml3-l","ml3L":"ml3-l","ml4-l":"ml4-l","ml4L":"ml4-l","ml5-l":"ml5-l","ml5L":"ml5-l","ml6-l":"ml6-l","ml6L":"ml6-l","ml7-l":"ml7-l","ml7L":"ml7-l","mr0-l":"mr0-l","mr0L":"mr0-l","mr1-l":"mr1-l","mr1L":"mr1-l","mr2-l":"mr2-l","mr2L":"mr2-l","mr3-l":"mr3-l","mr3L":"mr3-l","mr4-l":"mr4-l","mr4L":"mr4-l","mr5-l":"mr5-l","mr5L":"mr5-l","mr6-l":"mr6-l","mr6L":"mr6-l","mr7-l":"mr7-l","mr7L":"mr7-l","mb0-l":"mb0-l","mb0L":"mb0-l","mb1-l":"mb1-l","mb1L":"mb1-l","mb2-l":"mb2-l","mb2L":"mb2-l","mb3-l":"mb3-l","mb3L":"mb3-l","mb4-l":"mb4-l","mb4L":"mb4-l","mb5-l":"mb5-l","mb5L":"mb5-l","mb6-l":"mb6-l","mb6L":"mb6-l","mb7-l":"mb7-l","mb7L":"mb7-l","mt0-l":"mt0-l","mt0L":"mt0-l","mt1-l":"mt1-l","mt1L":"mt1-l","mt2-l":"mt2-l","mt2L":"mt2-l","mt3-l":"mt3-l","mt3L":"mt3-l","mt4-l":"mt4-l","mt4L":"mt4-l","mt5-l":"mt5-l","mt5L":"mt5-l","mt6-l":"mt6-l","mt6L":"mt6-l","mt7-l":"mt7-l","mt7L":"mt7-l","mv0-l":"mv0-l","mv0L":"mv0-l","mv1-l":"mv1-l","mv1L":"mv1-l","mv2-l":"mv2-l","mv2L":"mv2-l","mv3-l":"mv3-l","mv3L":"mv3-l","mv4-l":"mv4-l","mv4L":"mv4-l","mv5-l":"mv5-l","mv5L":"mv5-l","mv6-l":"mv6-l","mv6L":"mv6-l","mv7-l":"mv7-l","mv7L":"mv7-l","mh0-l":"mh0-l","mh0L":"mh0-l","mh1-l":"mh1-l","mh1L":"mh1-l","mh2-l":"mh2-l","mh2L":"mh2-l","mh3-l":"mh3-l","mh3L":"mh3-l","mh4-l":"mh4-l","mh4L":"mh4-l","mh5-l":"mh5-l","mh5L":"mh5-l","mh6-l":"mh6-l","mh6L":"mh6-l","mh7-l":"mh7-l","mh7L":"mh7-l","strike-l":"strike-l","strikeL":"strike-l","underline-l":"underline-l","underlineL":"underline-l","no-underline-l":"no-underline-l","noUnderlineL":"no-underline-l","tl-l":"tl-l","tlL":"tl-l","tr-l":"tr-l","trL":"tr-l","tc-l":"tc-l","tcL":"tc-l","ttc-l":"ttc-l","ttcL":"ttc-l","ttl-l":"ttl-l","ttlL":"ttl-l","ttu-l":"ttu-l","ttuL":"ttu-l","ttn-l":"ttn-l","ttnL":"ttn-l","f-6-l":"f-6-l","f6L":"f6-l","f-headline-l":"f-headline-l","fHeadlineL":"f-headline-l","f-5-l":"f-5-l","f5L":"f5-l","f-subheadline-l":"f-subheadline-l","fSubheadlineL":"f-subheadline-l","f1-l":"f1-l","f1L":"f1-l","f2-l":"f2-l","f2L":"f2-l","f3-l":"f3-l","f3L":"f3-l","f4-l":"f4-l","f4L":"f4-l","f5-l":"f5-l","f6-l":"f6-l","measure-l":"measure-l","measureL":"measure-l","measure-wide-l":"measure-wide-l","measureWideL":"measure-wide-l","measure-narrow-l":"measure-narrow-l","measureNarrowL":"measure-narrow-l","indent-l":"indent-l","indentL":"indent-l","small-caps-l":"small-caps-l","smallCapsL":"small-caps-l","truncate-l":"truncate-l","truncateL":"truncate-l","clip-l":"clip-l","clipL":"clip-l","ws-normal-l":"ws-normal-l","wsNormalL":"ws-normal-l","nowrap-l":"nowrap-l","nowrapL":"nowrap-l","pre-l":"pre-l","preL":"pre-l","v-base-l":"v-base-l","vBaseL":"v-base-l","v-mid-l":"v-mid-l","vMidL":"v-mid-l","v-top-l":"v-top-l","vTopL":"v-top-l","v-btm-l":"v-btm-l","vBtmL":"v-btm-l"};

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"brandon":"brandon","bg-squash":"bg-squash","bgSquash":"bg-squash","not-allowed":"not-allowed","notAllowed":"not-allowed","visibility-hidden":"visibility-hidden","visibilityHidden":"visibility-hidden","user-select-none":"user-select-none","userSelectNone":"user-select-none","shadow-pwr":"shadow-pwr","shadowPwr":"shadow-pwr","hover-shadow":"hover-shadow","hoverShadow":"hover-shadow","secondary-btn-gray":"secondary-btn-gray","secondaryBtnGray":"secondary-btn-gray","nps-Survey":"nps-Survey","npsSurvey":"nps-Survey","nps-Title":"nps-Title","npsTitle":"nps-Title","nps-Dialog":"nps-Dialog","npsDialog":"nps-Dialog","nps-Dialog--right":"nps-Dialog--right","npsDialogRight":"nps-Dialog--right","nps-Dialog--top":"nps-Dialog--top","npsDialogTop":"nps-Dialog--top","nps-Dialog--left":"nps-Dialog--left","npsDialogLeft":"nps-Dialog--left","nps-Dialog--bottom":"nps-Dialog--bottom","npsDialogBottom":"nps-Dialog--bottom","nps-Button--icon":"nps-Button--icon","npsButtonIcon":"nps-Button--icon"};

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fa":"fa","fa-lg":"fa-lg","faLg":"fa-lg","fa-2x":"fa-2x","fa2X":"fa-2x","fa-3x":"fa-3x","fa3X":"fa-3x","fa-4x":"fa-4x","fa4X":"fa-4x","fa-5x":"fa-5x","fa5X":"fa-5x","fa-fw":"fa-fw","faFw":"fa-fw","fa-ul":"fa-ul","faUl":"fa-ul","fa-li":"fa-li","faLi":"fa-li","fa-border":"fa-border","faBorder":"fa-border","fa-pull-left":"fa-pull-left","faPullLeft":"fa-pull-left","fa-pull-right":"fa-pull-right","faPullRight":"fa-pull-right","pull-right":"pull-right","pullRight":"pull-right","pull-left":"pull-left","pullLeft":"pull-left","fa-spin":"fa-spin","faSpin":"fa-spin","fa-pulse":"fa-pulse","faPulse":"fa-pulse","fa-rotate-90":"fa-rotate-90","faRotate90":"fa-rotate-90","fa-rotate-180":"fa-rotate-180","faRotate180":"fa-rotate-180","fa-rotate-270":"fa-rotate-270","faRotate270":"fa-rotate-270","fa-flip-horizontal":"fa-flip-horizontal","faFlipHorizontal":"fa-flip-horizontal","fa-flip-vertical":"fa-flip-vertical","faFlipVertical":"fa-flip-vertical","fa-stack":"fa-stack","faStack":"fa-stack","fa-stack-1x":"fa-stack-1x","faStack1X":"fa-stack-1x","fa-stack-2x":"fa-stack-2x","faStack2X":"fa-stack-2x","fa-inverse":"fa-inverse","faInverse":"fa-inverse","fa-glass":"fa-glass","faGlass":"fa-glass","fa-music":"fa-music","faMusic":"fa-music","fa-search":"fa-search","faSearch":"fa-search","fa-envelope-o":"fa-envelope-o","faEnvelopeO":"fa-envelope-o","fa-heart":"fa-heart","faHeart":"fa-heart","fa-star":"fa-star","faStar":"fa-star","fa-star-o":"fa-star-o","faStarO":"fa-star-o","fa-user":"fa-user","faUser":"fa-user","fa-film":"fa-film","faFilm":"fa-film","fa-th-large":"fa-th-large","faThLarge":"fa-th-large","fa-th":"fa-th","faTh":"fa-th","fa-th-list":"fa-th-list","faThList":"fa-th-list","fa-check":"fa-check","faCheck":"fa-check","fa-remove":"fa-remove","faRemove":"fa-remove","fa-close":"fa-close","faClose":"fa-close","fa-times":"fa-times","faTimes":"fa-times","fa-search-plus":"fa-search-plus","faSearchPlus":"fa-search-plus","fa-search-minus":"fa-search-minus","faSearchMinus":"fa-search-minus","fa-power-off":"fa-power-off","faPowerOff":"fa-power-off","fa-signal":"fa-signal","faSignal":"fa-signal","fa-gear":"fa-gear","faGear":"fa-gear","fa-cog":"fa-cog","faCog":"fa-cog","fa-trash-o":"fa-trash-o","faTrashO":"fa-trash-o","fa-home":"fa-home","faHome":"fa-home","fa-file-o":"fa-file-o","faFileO":"fa-file-o","fa-clock-o":"fa-clock-o","faClockO":"fa-clock-o","fa-road":"fa-road","faRoad":"fa-road","fa-download":"fa-download","faDownload":"fa-download","fa-arrow-circle-o-down":"fa-arrow-circle-o-down","faArrowCircleODown":"fa-arrow-circle-o-down","fa-arrow-circle-o-up":"fa-arrow-circle-o-up","faArrowCircleOUp":"fa-arrow-circle-o-up","fa-inbox":"fa-inbox","faInbox":"fa-inbox","fa-play-circle-o":"fa-play-circle-o","faPlayCircleO":"fa-play-circle-o","fa-rotate-right":"fa-rotate-right","faRotateRight":"fa-rotate-right","fa-repeat":"fa-repeat","faRepeat":"fa-repeat","fa-refresh":"fa-refresh","faRefresh":"fa-refresh","fa-list-alt":"fa-list-alt","faListAlt":"fa-list-alt","fa-lock":"fa-lock","faLock":"fa-lock","fa-flag":"fa-flag","faFlag":"fa-flag","fa-headphones":"fa-headphones","faHeadphones":"fa-headphones","fa-volume-off":"fa-volume-off","faVolumeOff":"fa-volume-off","fa-volume-down":"fa-volume-down","faVolumeDown":"fa-volume-down","fa-volume-up":"fa-volume-up","faVolumeUp":"fa-volume-up","fa-qrcode":"fa-qrcode","faQrcode":"fa-qrcode","fa-barcode":"fa-barcode","faBarcode":"fa-barcode","fa-tag":"fa-tag","faTag":"fa-tag","fa-tags":"fa-tags","faTags":"fa-tags","fa-book":"fa-book","faBook":"fa-book","fa-bookmark":"fa-bookmark","faBookmark":"fa-bookmark","fa-print":"fa-print","faPrint":"fa-print","fa-camera":"fa-camera","faCamera":"fa-camera","fa-font":"fa-font","faFont":"fa-font","fa-bold":"fa-bold","faBold":"fa-bold","fa-italic":"fa-italic","faItalic":"fa-italic","fa-text-height":"fa-text-height","faTextHeight":"fa-text-height","fa-text-width":"fa-text-width","faTextWidth":"fa-text-width","fa-align-left":"fa-align-left","faAlignLeft":"fa-align-left","fa-align-center":"fa-align-center","faAlignCenter":"fa-align-center","fa-align-right":"fa-align-right","faAlignRight":"fa-align-right","fa-align-justify":"fa-align-justify","faAlignJustify":"fa-align-justify","fa-list":"fa-list","faList":"fa-list","fa-dedent":"fa-dedent","faDedent":"fa-dedent","fa-outdent":"fa-outdent","faOutdent":"fa-outdent","fa-indent":"fa-indent","faIndent":"fa-indent","fa-video-camera":"fa-video-camera","faVideoCamera":"fa-video-camera","fa-photo":"fa-photo","faPhoto":"fa-photo","fa-image":"fa-image","faImage":"fa-image","fa-picture-o":"fa-picture-o","faPictureO":"fa-picture-o","fa-pencil":"fa-pencil","faPencil":"fa-pencil","fa-map-marker":"fa-map-marker","faMapMarker":"fa-map-marker","fa-adjust":"fa-adjust","faAdjust":"fa-adjust","fa-tint":"fa-tint","faTint":"fa-tint","fa-edit":"fa-edit","faEdit":"fa-edit","fa-pencil-square-o":"fa-pencil-square-o","faPencilSquareO":"fa-pencil-square-o","fa-share-square-o":"fa-share-square-o","faShareSquareO":"fa-share-square-o","fa-check-square-o":"fa-check-square-o","faCheckSquareO":"fa-check-square-o","fa-arrows":"fa-arrows","faArrows":"fa-arrows","fa-step-backward":"fa-step-backward","faStepBackward":"fa-step-backward","fa-fast-backward":"fa-fast-backward","faFastBackward":"fa-fast-backward","fa-backward":"fa-backward","faBackward":"fa-backward","fa-play":"fa-play","faPlay":"fa-play","fa-pause":"fa-pause","faPause":"fa-pause","fa-stop":"fa-stop","faStop":"fa-stop","fa-forward":"fa-forward","faForward":"fa-forward","fa-fast-forward":"fa-fast-forward","faFastForward":"fa-fast-forward","fa-step-forward":"fa-step-forward","faStepForward":"fa-step-forward","fa-eject":"fa-eject","faEject":"fa-eject","fa-chevron-left":"fa-chevron-left","faChevronLeft":"fa-chevron-left","fa-chevron-right":"fa-chevron-right","faChevronRight":"fa-chevron-right","fa-plus-circle":"fa-plus-circle","faPlusCircle":"fa-plus-circle","fa-minus-circle":"fa-minus-circle","faMinusCircle":"fa-minus-circle","fa-times-circle":"fa-times-circle","faTimesCircle":"fa-times-circle","fa-check-circle":"fa-check-circle","faCheckCircle":"fa-check-circle","fa-question-circle":"fa-question-circle","faQuestionCircle":"fa-question-circle","fa-info-circle":"fa-info-circle","faInfoCircle":"fa-info-circle","fa-crosshairs":"fa-crosshairs","faCrosshairs":"fa-crosshairs","fa-times-circle-o":"fa-times-circle-o","faTimesCircleO":"fa-times-circle-o","fa-check-circle-o":"fa-check-circle-o","faCheckCircleO":"fa-check-circle-o","fa-ban":"fa-ban","faBan":"fa-ban","fa-arrow-left":"fa-arrow-left","faArrowLeft":"fa-arrow-left","fa-arrow-right":"fa-arrow-right","faArrowRight":"fa-arrow-right","fa-arrow-up":"fa-arrow-up","faArrowUp":"fa-arrow-up","fa-arrow-down":"fa-arrow-down","faArrowDown":"fa-arrow-down","fa-mail-forward":"fa-mail-forward","faMailForward":"fa-mail-forward","fa-share":"fa-share","faShare":"fa-share","fa-expand":"fa-expand","faExpand":"fa-expand","fa-compress":"fa-compress","faCompress":"fa-compress","fa-plus":"fa-plus","faPlus":"fa-plus","fa-minus":"fa-minus","faMinus":"fa-minus","fa-asterisk":"fa-asterisk","faAsterisk":"fa-asterisk","fa-exclamation-circle":"fa-exclamation-circle","faExclamationCircle":"fa-exclamation-circle","fa-gift":"fa-gift","faGift":"fa-gift","fa-leaf":"fa-leaf","faLeaf":"fa-leaf","fa-fire":"fa-fire","faFire":"fa-fire","fa-eye":"fa-eye","faEye":"fa-eye","fa-eye-slash":"fa-eye-slash","faEyeSlash":"fa-eye-slash","fa-warning":"fa-warning","faWarning":"fa-warning","fa-exclamation-triangle":"fa-exclamation-triangle","faExclamationTriangle":"fa-exclamation-triangle","fa-plane":"fa-plane","faPlane":"fa-plane","fa-calendar":"fa-calendar","faCalendar":"fa-calendar","fa-random":"fa-random","faRandom":"fa-random","fa-comment":"fa-comment","faComment":"fa-comment","fa-magnet":"fa-magnet","faMagnet":"fa-magnet","fa-chevron-up":"fa-chevron-up","faChevronUp":"fa-chevron-up","fa-chevron-down":"fa-chevron-down","faChevronDown":"fa-chevron-down","fa-retweet":"fa-retweet","faRetweet":"fa-retweet","fa-shopping-cart":"fa-shopping-cart","faShoppingCart":"fa-shopping-cart","fa-folder":"fa-folder","faFolder":"fa-folder","fa-folder-open":"fa-folder-open","faFolderOpen":"fa-folder-open","fa-arrows-v":"fa-arrows-v","faArrowsV":"fa-arrows-v","fa-arrows-h":"fa-arrows-h","faArrowsH":"fa-arrows-h","fa-bar-chart-o":"fa-bar-chart-o","faBarChartO":"fa-bar-chart-o","fa-bar-chart":"fa-bar-chart","faBarChart":"fa-bar-chart","fa-twitter-square":"fa-twitter-square","faTwitterSquare":"fa-twitter-square","fa-facebook-square":"fa-facebook-square","faFacebookSquare":"fa-facebook-square","fa-camera-retro":"fa-camera-retro","faCameraRetro":"fa-camera-retro","fa-key":"fa-key","faKey":"fa-key","fa-gears":"fa-gears","faGears":"fa-gears","fa-cogs":"fa-cogs","faCogs":"fa-cogs","fa-comments":"fa-comments","faComments":"fa-comments","fa-thumbs-o-up":"fa-thumbs-o-up","faThumbsOUp":"fa-thumbs-o-up","fa-thumbs-o-down":"fa-thumbs-o-down","faThumbsODown":"fa-thumbs-o-down","fa-star-half":"fa-star-half","faStarHalf":"fa-star-half","fa-heart-o":"fa-heart-o","faHeartO":"fa-heart-o","fa-sign-out":"fa-sign-out","faSignOut":"fa-sign-out","fa-linkedin-square":"fa-linkedin-square","faLinkedinSquare":"fa-linkedin-square","fa-thumb-tack":"fa-thumb-tack","faThumbTack":"fa-thumb-tack","fa-external-link":"fa-external-link","faExternalLink":"fa-external-link","fa-sign-in":"fa-sign-in","faSignIn":"fa-sign-in","fa-trophy":"fa-trophy","faTrophy":"fa-trophy","fa-github-square":"fa-github-square","faGithubSquare":"fa-github-square","fa-upload":"fa-upload","faUpload":"fa-upload","fa-lemon-o":"fa-lemon-o","faLemonO":"fa-lemon-o","fa-phone":"fa-phone","faPhone":"fa-phone","fa-square-o":"fa-square-o","faSquareO":"fa-square-o","fa-bookmark-o":"fa-bookmark-o","faBookmarkO":"fa-bookmark-o","fa-phone-square":"fa-phone-square","faPhoneSquare":"fa-phone-square","fa-twitter":"fa-twitter","faTwitter":"fa-twitter","fa-facebook-f":"fa-facebook-f","faFacebookF":"fa-facebook-f","fa-facebook":"fa-facebook","faFacebook":"fa-facebook","fa-github":"fa-github","faGithub":"fa-github","fa-unlock":"fa-unlock","faUnlock":"fa-unlock","fa-credit-card":"fa-credit-card","faCreditCard":"fa-credit-card","fa-feed":"fa-feed","faFeed":"fa-feed","fa-rss":"fa-rss","faRss":"fa-rss","fa-hdd-o":"fa-hdd-o","faHddO":"fa-hdd-o","fa-bullhorn":"fa-bullhorn","faBullhorn":"fa-bullhorn","fa-bell":"fa-bell","faBell":"fa-bell","fa-certificate":"fa-certificate","faCertificate":"fa-certificate","fa-hand-o-right":"fa-hand-o-right","faHandORight":"fa-hand-o-right","fa-hand-o-left":"fa-hand-o-left","faHandOLeft":"fa-hand-o-left","fa-hand-o-up":"fa-hand-o-up","faHandOUp":"fa-hand-o-up","fa-hand-o-down":"fa-hand-o-down","faHandODown":"fa-hand-o-down","fa-arrow-circle-left":"fa-arrow-circle-left","faArrowCircleLeft":"fa-arrow-circle-left","fa-arrow-circle-right":"fa-arrow-circle-right","faArrowCircleRight":"fa-arrow-circle-right","fa-arrow-circle-up":"fa-arrow-circle-up","faArrowCircleUp":"fa-arrow-circle-up","fa-arrow-circle-down":"fa-arrow-circle-down","faArrowCircleDown":"fa-arrow-circle-down","fa-globe":"fa-globe","faGlobe":"fa-globe","fa-wrench":"fa-wrench","faWrench":"fa-wrench","fa-tasks":"fa-tasks","faTasks":"fa-tasks","fa-filter":"fa-filter","faFilter":"fa-filter","fa-briefcase":"fa-briefcase","faBriefcase":"fa-briefcase","fa-arrows-alt":"fa-arrows-alt","faArrowsAlt":"fa-arrows-alt","fa-group":"fa-group","faGroup":"fa-group","fa-users":"fa-users","faUsers":"fa-users","fa-chain":"fa-chain","faChain":"fa-chain","fa-link":"fa-link","faLink":"fa-link","fa-cloud":"fa-cloud","faCloud":"fa-cloud","fa-flask":"fa-flask","faFlask":"fa-flask","fa-cut":"fa-cut","faCut":"fa-cut","fa-scissors":"fa-scissors","faScissors":"fa-scissors","fa-copy":"fa-copy","faCopy":"fa-copy","fa-files-o":"fa-files-o","faFilesO":"fa-files-o","fa-paperclip":"fa-paperclip","faPaperclip":"fa-paperclip","fa-save":"fa-save","faSave":"fa-save","fa-floppy-o":"fa-floppy-o","faFloppyO":"fa-floppy-o","fa-square":"fa-square","faSquare":"fa-square","fa-navicon":"fa-navicon","faNavicon":"fa-navicon","fa-reorder":"fa-reorder","faReorder":"fa-reorder","fa-bars":"fa-bars","faBars":"fa-bars","fa-list-ul":"fa-list-ul","faListUl":"fa-list-ul","fa-list-ol":"fa-list-ol","faListOl":"fa-list-ol","fa-strikethrough":"fa-strikethrough","faStrikethrough":"fa-strikethrough","fa-underline":"fa-underline","faUnderline":"fa-underline","fa-table":"fa-table","faTable":"fa-table","fa-magic":"fa-magic","faMagic":"fa-magic","fa-truck":"fa-truck","faTruck":"fa-truck","fa-pinterest":"fa-pinterest","faPinterest":"fa-pinterest","fa-pinterest-square":"fa-pinterest-square","faPinterestSquare":"fa-pinterest-square","fa-google-plus-square":"fa-google-plus-square","faGooglePlusSquare":"fa-google-plus-square","fa-google-plus":"fa-google-plus","faGooglePlus":"fa-google-plus","fa-money":"fa-money","faMoney":"fa-money","fa-caret-down":"fa-caret-down","faCaretDown":"fa-caret-down","fa-caret-up":"fa-caret-up","faCaretUp":"fa-caret-up","fa-caret-left":"fa-caret-left","faCaretLeft":"fa-caret-left","fa-caret-right":"fa-caret-right","faCaretRight":"fa-caret-right","fa-columns":"fa-columns","faColumns":"fa-columns","fa-unsorted":"fa-unsorted","faUnsorted":"fa-unsorted","fa-sort":"fa-sort","faSort":"fa-sort","fa-sort-down":"fa-sort-down","faSortDown":"fa-sort-down","fa-sort-desc":"fa-sort-desc","faSortDesc":"fa-sort-desc","fa-sort-up":"fa-sort-up","faSortUp":"fa-sort-up","fa-sort-asc":"fa-sort-asc","faSortAsc":"fa-sort-asc","fa-envelope":"fa-envelope","faEnvelope":"fa-envelope","fa-linkedin":"fa-linkedin","faLinkedin":"fa-linkedin","fa-rotate-left":"fa-rotate-left","faRotateLeft":"fa-rotate-left","fa-undo":"fa-undo","faUndo":"fa-undo","fa-legal":"fa-legal","faLegal":"fa-legal","fa-gavel":"fa-gavel","faGavel":"fa-gavel","fa-dashboard":"fa-dashboard","faDashboard":"fa-dashboard","fa-tachometer":"fa-tachometer","faTachometer":"fa-tachometer","fa-comment-o":"fa-comment-o","faCommentO":"fa-comment-o","fa-comments-o":"fa-comments-o","faCommentsO":"fa-comments-o","fa-flash":"fa-flash","faFlash":"fa-flash","fa-bolt":"fa-bolt","faBolt":"fa-bolt","fa-sitemap":"fa-sitemap","faSitemap":"fa-sitemap","fa-umbrella":"fa-umbrella","faUmbrella":"fa-umbrella","fa-paste":"fa-paste","faPaste":"fa-paste","fa-clipboard":"fa-clipboard","faClipboard":"fa-clipboard","fa-lightbulb-o":"fa-lightbulb-o","faLightbulbO":"fa-lightbulb-o","fa-exchange":"fa-exchange","faExchange":"fa-exchange","fa-cloud-download":"fa-cloud-download","faCloudDownload":"fa-cloud-download","fa-cloud-upload":"fa-cloud-upload","faCloudUpload":"fa-cloud-upload","fa-user-md":"fa-user-md","faUserMd":"fa-user-md","fa-stethoscope":"fa-stethoscope","faStethoscope":"fa-stethoscope","fa-suitcase":"fa-suitcase","faSuitcase":"fa-suitcase","fa-bell-o":"fa-bell-o","faBellO":"fa-bell-o","fa-coffee":"fa-coffee","faCoffee":"fa-coffee","fa-cutlery":"fa-cutlery","faCutlery":"fa-cutlery","fa-file-text-o":"fa-file-text-o","faFileTextO":"fa-file-text-o","fa-building-o":"fa-building-o","faBuildingO":"fa-building-o","fa-hospital-o":"fa-hospital-o","faHospitalO":"fa-hospital-o","fa-ambulance":"fa-ambulance","faAmbulance":"fa-ambulance","fa-medkit":"fa-medkit","faMedkit":"fa-medkit","fa-fighter-jet":"fa-fighter-jet","faFighterJet":"fa-fighter-jet","fa-beer":"fa-beer","faBeer":"fa-beer","fa-h-square":"fa-h-square","faHSquare":"fa-h-square","fa-plus-square":"fa-plus-square","faPlusSquare":"fa-plus-square","fa-angle-double-left":"fa-angle-double-left","faAngleDoubleLeft":"fa-angle-double-left","fa-angle-double-right":"fa-angle-double-right","faAngleDoubleRight":"fa-angle-double-right","fa-angle-double-up":"fa-angle-double-up","faAngleDoubleUp":"fa-angle-double-up","fa-angle-double-down":"fa-angle-double-down","faAngleDoubleDown":"fa-angle-double-down","fa-angle-left":"fa-angle-left","faAngleLeft":"fa-angle-left","fa-angle-right":"fa-angle-right","faAngleRight":"fa-angle-right","fa-angle-up":"fa-angle-up","faAngleUp":"fa-angle-up","fa-angle-down":"fa-angle-down","faAngleDown":"fa-angle-down","fa-desktop":"fa-desktop","faDesktop":"fa-desktop","fa-laptop":"fa-laptop","faLaptop":"fa-laptop","fa-tablet":"fa-tablet","faTablet":"fa-tablet","fa-mobile-phone":"fa-mobile-phone","faMobilePhone":"fa-mobile-phone","fa-mobile":"fa-mobile","faMobile":"fa-mobile","fa-circle-o":"fa-circle-o","faCircleO":"fa-circle-o","fa-quote-left":"fa-quote-left","faQuoteLeft":"fa-quote-left","fa-quote-right":"fa-quote-right","faQuoteRight":"fa-quote-right","fa-spinner":"fa-spinner","faSpinner":"fa-spinner","fa-circle":"fa-circle","faCircle":"fa-circle","fa-mail-reply":"fa-mail-reply","faMailReply":"fa-mail-reply","fa-reply":"fa-reply","faReply":"fa-reply","fa-github-alt":"fa-github-alt","faGithubAlt":"fa-github-alt","fa-folder-o":"fa-folder-o","faFolderO":"fa-folder-o","fa-folder-open-o":"fa-folder-open-o","faFolderOpenO":"fa-folder-open-o","fa-smile-o":"fa-smile-o","faSmileO":"fa-smile-o","fa-frown-o":"fa-frown-o","faFrownO":"fa-frown-o","fa-meh-o":"fa-meh-o","faMehO":"fa-meh-o","fa-gamepad":"fa-gamepad","faGamepad":"fa-gamepad","fa-keyboard-o":"fa-keyboard-o","faKeyboardO":"fa-keyboard-o","fa-flag-o":"fa-flag-o","faFlagO":"fa-flag-o","fa-flag-checkered":"fa-flag-checkered","faFlagCheckered":"fa-flag-checkered","fa-terminal":"fa-terminal","faTerminal":"fa-terminal","fa-code":"fa-code","faCode":"fa-code","fa-mail-reply-all":"fa-mail-reply-all","faMailReplyAll":"fa-mail-reply-all","fa-reply-all":"fa-reply-all","faReplyAll":"fa-reply-all","fa-star-half-empty":"fa-star-half-empty","faStarHalfEmpty":"fa-star-half-empty","fa-star-half-full":"fa-star-half-full","faStarHalfFull":"fa-star-half-full","fa-star-half-o":"fa-star-half-o","faStarHalfO":"fa-star-half-o","fa-location-arrow":"fa-location-arrow","faLocationArrow":"fa-location-arrow","fa-crop":"fa-crop","faCrop":"fa-crop","fa-code-fork":"fa-code-fork","faCodeFork":"fa-code-fork","fa-unlink":"fa-unlink","faUnlink":"fa-unlink","fa-chain-broken":"fa-chain-broken","faChainBroken":"fa-chain-broken","fa-question":"fa-question","faQuestion":"fa-question","fa-info":"fa-info","faInfo":"fa-info","fa-exclamation":"fa-exclamation","faExclamation":"fa-exclamation","fa-superscript":"fa-superscript","faSuperscript":"fa-superscript","fa-subscript":"fa-subscript","faSubscript":"fa-subscript","fa-eraser":"fa-eraser","faEraser":"fa-eraser","fa-puzzle-piece":"fa-puzzle-piece","faPuzzlePiece":"fa-puzzle-piece","fa-microphone":"fa-microphone","faMicrophone":"fa-microphone","fa-microphone-slash":"fa-microphone-slash","faMicrophoneSlash":"fa-microphone-slash","fa-shield":"fa-shield","faShield":"fa-shield","fa-calendar-o":"fa-calendar-o","faCalendarO":"fa-calendar-o","fa-fire-extinguisher":"fa-fire-extinguisher","faFireExtinguisher":"fa-fire-extinguisher","fa-rocket":"fa-rocket","faRocket":"fa-rocket","fa-maxcdn":"fa-maxcdn","faMaxcdn":"fa-maxcdn","fa-chevron-circle-left":"fa-chevron-circle-left","faChevronCircleLeft":"fa-chevron-circle-left","fa-chevron-circle-right":"fa-chevron-circle-right","faChevronCircleRight":"fa-chevron-circle-right","fa-chevron-circle-up":"fa-chevron-circle-up","faChevronCircleUp":"fa-chevron-circle-up","fa-chevron-circle-down":"fa-chevron-circle-down","faChevronCircleDown":"fa-chevron-circle-down","fa-html5":"fa-html5","faHtml5":"fa-html5","fa-css3":"fa-css3","faCss3":"fa-css3","fa-anchor":"fa-anchor","faAnchor":"fa-anchor","fa-unlock-alt":"fa-unlock-alt","faUnlockAlt":"fa-unlock-alt","fa-bullseye":"fa-bullseye","faBullseye":"fa-bullseye","fa-ellipsis-h":"fa-ellipsis-h","faEllipsisH":"fa-ellipsis-h","fa-ellipsis-v":"fa-ellipsis-v","faEllipsisV":"fa-ellipsis-v","fa-rss-square":"fa-rss-square","faRssSquare":"fa-rss-square","fa-play-circle":"fa-play-circle","faPlayCircle":"fa-play-circle","fa-ticket":"fa-ticket","faTicket":"fa-ticket","fa-minus-square":"fa-minus-square","faMinusSquare":"fa-minus-square","fa-minus-square-o":"fa-minus-square-o","faMinusSquareO":"fa-minus-square-o","fa-level-up":"fa-level-up","faLevelUp":"fa-level-up","fa-level-down":"fa-level-down","faLevelDown":"fa-level-down","fa-check-square":"fa-check-square","faCheckSquare":"fa-check-square","fa-pencil-square":"fa-pencil-square","faPencilSquare":"fa-pencil-square","fa-external-link-square":"fa-external-link-square","faExternalLinkSquare":"fa-external-link-square","fa-share-square":"fa-share-square","faShareSquare":"fa-share-square","fa-compass":"fa-compass","faCompass":"fa-compass","fa-toggle-down":"fa-toggle-down","faToggleDown":"fa-toggle-down","fa-caret-square-o-down":"fa-caret-square-o-down","faCaretSquareODown":"fa-caret-square-o-down","fa-toggle-up":"fa-toggle-up","faToggleUp":"fa-toggle-up","fa-caret-square-o-up":"fa-caret-square-o-up","faCaretSquareOUp":"fa-caret-square-o-up","fa-toggle-right":"fa-toggle-right","faToggleRight":"fa-toggle-right","fa-caret-square-o-right":"fa-caret-square-o-right","faCaretSquareORight":"fa-caret-square-o-right","fa-euro":"fa-euro","faEuro":"fa-euro","fa-eur":"fa-eur","faEur":"fa-eur","fa-gbp":"fa-gbp","faGbp":"fa-gbp","fa-dollar":"fa-dollar","faDollar":"fa-dollar","fa-usd":"fa-usd","faUsd":"fa-usd","fa-rupee":"fa-rupee","faRupee":"fa-rupee","fa-inr":"fa-inr","faInr":"fa-inr","fa-cny":"fa-cny","faCny":"fa-cny","fa-rmb":"fa-rmb","faRmb":"fa-rmb","fa-yen":"fa-yen","faYen":"fa-yen","fa-jpy":"fa-jpy","faJpy":"fa-jpy","fa-ruble":"fa-ruble","faRuble":"fa-ruble","fa-rouble":"fa-rouble","faRouble":"fa-rouble","fa-rub":"fa-rub","faRub":"fa-rub","fa-won":"fa-won","faWon":"fa-won","fa-krw":"fa-krw","faKrw":"fa-krw","fa-bitcoin":"fa-bitcoin","faBitcoin":"fa-bitcoin","fa-btc":"fa-btc","faBtc":"fa-btc","fa-file":"fa-file","faFile":"fa-file","fa-file-text":"fa-file-text","faFileText":"fa-file-text","fa-sort-alpha-asc":"fa-sort-alpha-asc","faSortAlphaAsc":"fa-sort-alpha-asc","fa-sort-alpha-desc":"fa-sort-alpha-desc","faSortAlphaDesc":"fa-sort-alpha-desc","fa-sort-amount-asc":"fa-sort-amount-asc","faSortAmountAsc":"fa-sort-amount-asc","fa-sort-amount-desc":"fa-sort-amount-desc","faSortAmountDesc":"fa-sort-amount-desc","fa-sort-numeric-asc":"fa-sort-numeric-asc","faSortNumericAsc":"fa-sort-numeric-asc","fa-sort-numeric-desc":"fa-sort-numeric-desc","faSortNumericDesc":"fa-sort-numeric-desc","fa-thumbs-up":"fa-thumbs-up","faThumbsUp":"fa-thumbs-up","fa-thumbs-down":"fa-thumbs-down","faThumbsDown":"fa-thumbs-down","fa-youtube-square":"fa-youtube-square","faYoutubeSquare":"fa-youtube-square","fa-youtube":"fa-youtube","faYoutube":"fa-youtube","fa-xing":"fa-xing","faXing":"fa-xing","fa-xing-square":"fa-xing-square","faXingSquare":"fa-xing-square","fa-youtube-play":"fa-youtube-play","faYoutubePlay":"fa-youtube-play","fa-dropbox":"fa-dropbox","faDropbox":"fa-dropbox","fa-stack-overflow":"fa-stack-overflow","faStackOverflow":"fa-stack-overflow","fa-instagram":"fa-instagram","faInstagram":"fa-instagram","fa-flickr":"fa-flickr","faFlickr":"fa-flickr","fa-adn":"fa-adn","faAdn":"fa-adn","fa-bitbucket":"fa-bitbucket","faBitbucket":"fa-bitbucket","fa-bitbucket-square":"fa-bitbucket-square","faBitbucketSquare":"fa-bitbucket-square","fa-tumblr":"fa-tumblr","faTumblr":"fa-tumblr","fa-tumblr-square":"fa-tumblr-square","faTumblrSquare":"fa-tumblr-square","fa-long-arrow-down":"fa-long-arrow-down","faLongArrowDown":"fa-long-arrow-down","fa-long-arrow-up":"fa-long-arrow-up","faLongArrowUp":"fa-long-arrow-up","fa-long-arrow-left":"fa-long-arrow-left","faLongArrowLeft":"fa-long-arrow-left","fa-long-arrow-right":"fa-long-arrow-right","faLongArrowRight":"fa-long-arrow-right","fa-apple":"fa-apple","faApple":"fa-apple","fa-windows":"fa-windows","faWindows":"fa-windows","fa-android":"fa-android","faAndroid":"fa-android","fa-linux":"fa-linux","faLinux":"fa-linux","fa-dribbble":"fa-dribbble","faDribbble":"fa-dribbble","fa-skype":"fa-skype","faSkype":"fa-skype","fa-foursquare":"fa-foursquare","faFoursquare":"fa-foursquare","fa-trello":"fa-trello","faTrello":"fa-trello","fa-female":"fa-female","faFemale":"fa-female","fa-male":"fa-male","faMale":"fa-male","fa-gittip":"fa-gittip","faGittip":"fa-gittip","fa-gratipay":"fa-gratipay","faGratipay":"fa-gratipay","fa-sun-o":"fa-sun-o","faSunO":"fa-sun-o","fa-moon-o":"fa-moon-o","faMoonO":"fa-moon-o","fa-archive":"fa-archive","faArchive":"fa-archive","fa-bug":"fa-bug","faBug":"fa-bug","fa-vk":"fa-vk","faVk":"fa-vk","fa-weibo":"fa-weibo","faWeibo":"fa-weibo","fa-renren":"fa-renren","faRenren":"fa-renren","fa-pagelines":"fa-pagelines","faPagelines":"fa-pagelines","fa-stack-exchange":"fa-stack-exchange","faStackExchange":"fa-stack-exchange","fa-arrow-circle-o-right":"fa-arrow-circle-o-right","faArrowCircleORight":"fa-arrow-circle-o-right","fa-arrow-circle-o-left":"fa-arrow-circle-o-left","faArrowCircleOLeft":"fa-arrow-circle-o-left","fa-toggle-left":"fa-toggle-left","faToggleLeft":"fa-toggle-left","fa-caret-square-o-left":"fa-caret-square-o-left","faCaretSquareOLeft":"fa-caret-square-o-left","fa-dot-circle-o":"fa-dot-circle-o","faDotCircleO":"fa-dot-circle-o","fa-wheelchair":"fa-wheelchair","faWheelchair":"fa-wheelchair","fa-vimeo-square":"fa-vimeo-square","faVimeoSquare":"fa-vimeo-square","fa-turkish-lira":"fa-turkish-lira","faTurkishLira":"fa-turkish-lira","fa-try":"fa-try","faTry":"fa-try","fa-plus-square-o":"fa-plus-square-o","faPlusSquareO":"fa-plus-square-o","fa-space-shuttle":"fa-space-shuttle","faSpaceShuttle":"fa-space-shuttle","fa-slack":"fa-slack","faSlack":"fa-slack","fa-envelope-square":"fa-envelope-square","faEnvelopeSquare":"fa-envelope-square","fa-wordpress":"fa-wordpress","faWordpress":"fa-wordpress","fa-openid":"fa-openid","faOpenid":"fa-openid","fa-institution":"fa-institution","faInstitution":"fa-institution","fa-bank":"fa-bank","faBank":"fa-bank","fa-university":"fa-university","faUniversity":"fa-university","fa-mortar-board":"fa-mortar-board","faMortarBoard":"fa-mortar-board","fa-graduation-cap":"fa-graduation-cap","faGraduationCap":"fa-graduation-cap","fa-yahoo":"fa-yahoo","faYahoo":"fa-yahoo","fa-google":"fa-google","faGoogle":"fa-google","fa-reddit":"fa-reddit","faReddit":"fa-reddit","fa-reddit-square":"fa-reddit-square","faRedditSquare":"fa-reddit-square","fa-stumbleupon-circle":"fa-stumbleupon-circle","faStumbleuponCircle":"fa-stumbleupon-circle","fa-stumbleupon":"fa-stumbleupon","faStumbleupon":"fa-stumbleupon","fa-delicious":"fa-delicious","faDelicious":"fa-delicious","fa-digg":"fa-digg","faDigg":"fa-digg","fa-pied-piper-pp":"fa-pied-piper-pp","faPiedPiperPp":"fa-pied-piper-pp","fa-pied-piper-alt":"fa-pied-piper-alt","faPiedPiperAlt":"fa-pied-piper-alt","fa-drupal":"fa-drupal","faDrupal":"fa-drupal","fa-joomla":"fa-joomla","faJoomla":"fa-joomla","fa-language":"fa-language","faLanguage":"fa-language","fa-fax":"fa-fax","faFax":"fa-fax","fa-building":"fa-building","faBuilding":"fa-building","fa-child":"fa-child","faChild":"fa-child","fa-paw":"fa-paw","faPaw":"fa-paw","fa-spoon":"fa-spoon","faSpoon":"fa-spoon","fa-cube":"fa-cube","faCube":"fa-cube","fa-cubes":"fa-cubes","faCubes":"fa-cubes","fa-behance":"fa-behance","faBehance":"fa-behance","fa-behance-square":"fa-behance-square","faBehanceSquare":"fa-behance-square","fa-steam":"fa-steam","faSteam":"fa-steam","fa-steam-square":"fa-steam-square","faSteamSquare":"fa-steam-square","fa-recycle":"fa-recycle","faRecycle":"fa-recycle","fa-automobile":"fa-automobile","faAutomobile":"fa-automobile","fa-car":"fa-car","faCar":"fa-car","fa-cab":"fa-cab","faCab":"fa-cab","fa-taxi":"fa-taxi","faTaxi":"fa-taxi","fa-tree":"fa-tree","faTree":"fa-tree","fa-spotify":"fa-spotify","faSpotify":"fa-spotify","fa-deviantart":"fa-deviantart","faDeviantart":"fa-deviantart","fa-soundcloud":"fa-soundcloud","faSoundcloud":"fa-soundcloud","fa-database":"fa-database","faDatabase":"fa-database","fa-file-pdf-o":"fa-file-pdf-o","faFilePdfO":"fa-file-pdf-o","fa-file-word-o":"fa-file-word-o","faFileWordO":"fa-file-word-o","fa-file-excel-o":"fa-file-excel-o","faFileExcelO":"fa-file-excel-o","fa-file-powerpoint-o":"fa-file-powerpoint-o","faFilePowerpointO":"fa-file-powerpoint-o","fa-file-photo-o":"fa-file-photo-o","faFilePhotoO":"fa-file-photo-o","fa-file-picture-o":"fa-file-picture-o","faFilePictureO":"fa-file-picture-o","fa-file-image-o":"fa-file-image-o","faFileImageO":"fa-file-image-o","fa-file-zip-o":"fa-file-zip-o","faFileZipO":"fa-file-zip-o","fa-file-archive-o":"fa-file-archive-o","faFileArchiveO":"fa-file-archive-o","fa-file-sound-o":"fa-file-sound-o","faFileSoundO":"fa-file-sound-o","fa-file-audio-o":"fa-file-audio-o","faFileAudioO":"fa-file-audio-o","fa-file-movie-o":"fa-file-movie-o","faFileMovieO":"fa-file-movie-o","fa-file-video-o":"fa-file-video-o","faFileVideoO":"fa-file-video-o","fa-file-code-o":"fa-file-code-o","faFileCodeO":"fa-file-code-o","fa-vine":"fa-vine","faVine":"fa-vine","fa-codepen":"fa-codepen","faCodepen":"fa-codepen","fa-jsfiddle":"fa-jsfiddle","faJsfiddle":"fa-jsfiddle","fa-life-bouy":"fa-life-bouy","faLifeBouy":"fa-life-bouy","fa-life-buoy":"fa-life-buoy","faLifeBuoy":"fa-life-buoy","fa-life-saver":"fa-life-saver","faLifeSaver":"fa-life-saver","fa-support":"fa-support","faSupport":"fa-support","fa-life-ring":"fa-life-ring","faLifeRing":"fa-life-ring","fa-circle-o-notch":"fa-circle-o-notch","faCircleONotch":"fa-circle-o-notch","fa-ra":"fa-ra","faRa":"fa-ra","fa-resistance":"fa-resistance","faResistance":"fa-resistance","fa-rebel":"fa-rebel","faRebel":"fa-rebel","fa-ge":"fa-ge","faGe":"fa-ge","fa-empire":"fa-empire","faEmpire":"fa-empire","fa-git-square":"fa-git-square","faGitSquare":"fa-git-square","fa-git":"fa-git","faGit":"fa-git","fa-y-combinator-square":"fa-y-combinator-square","faYCombinatorSquare":"fa-y-combinator-square","fa-yc-square":"fa-yc-square","faYcSquare":"fa-yc-square","fa-hacker-news":"fa-hacker-news","faHackerNews":"fa-hacker-news","fa-tencent-weibo":"fa-tencent-weibo","faTencentWeibo":"fa-tencent-weibo","fa-qq":"fa-qq","faQq":"fa-qq","fa-wechat":"fa-wechat","faWechat":"fa-wechat","fa-weixin":"fa-weixin","faWeixin":"fa-weixin","fa-send":"fa-send","faSend":"fa-send","fa-paper-plane":"fa-paper-plane","faPaperPlane":"fa-paper-plane","fa-send-o":"fa-send-o","faSendO":"fa-send-o","fa-paper-plane-o":"fa-paper-plane-o","faPaperPlaneO":"fa-paper-plane-o","fa-history":"fa-history","faHistory":"fa-history","fa-circle-thin":"fa-circle-thin","faCircleThin":"fa-circle-thin","fa-header":"fa-header","faHeader":"fa-header","fa-paragraph":"fa-paragraph","faParagraph":"fa-paragraph","fa-sliders":"fa-sliders","faSliders":"fa-sliders","fa-share-alt":"fa-share-alt","faShareAlt":"fa-share-alt","fa-share-alt-square":"fa-share-alt-square","faShareAltSquare":"fa-share-alt-square","fa-bomb":"fa-bomb","faBomb":"fa-bomb","fa-soccer-ball-o":"fa-soccer-ball-o","faSoccerBallO":"fa-soccer-ball-o","fa-futbol-o":"fa-futbol-o","faFutbolO":"fa-futbol-o","fa-tty":"fa-tty","faTty":"fa-tty","fa-binoculars":"fa-binoculars","faBinoculars":"fa-binoculars","fa-plug":"fa-plug","faPlug":"fa-plug","fa-slideshare":"fa-slideshare","faSlideshare":"fa-slideshare","fa-twitch":"fa-twitch","faTwitch":"fa-twitch","fa-yelp":"fa-yelp","faYelp":"fa-yelp","fa-newspaper-o":"fa-newspaper-o","faNewspaperO":"fa-newspaper-o","fa-wifi":"fa-wifi","faWifi":"fa-wifi","fa-calculator":"fa-calculator","faCalculator":"fa-calculator","fa-paypal":"fa-paypal","faPaypal":"fa-paypal","fa-google-wallet":"fa-google-wallet","faGoogleWallet":"fa-google-wallet","fa-cc-visa":"fa-cc-visa","faCcVisa":"fa-cc-visa","fa-cc-mastercard":"fa-cc-mastercard","faCcMastercard":"fa-cc-mastercard","fa-cc-discover":"fa-cc-discover","faCcDiscover":"fa-cc-discover","fa-cc-amex":"fa-cc-amex","faCcAmex":"fa-cc-amex","fa-cc-paypal":"fa-cc-paypal","faCcPaypal":"fa-cc-paypal","fa-cc-stripe":"fa-cc-stripe","faCcStripe":"fa-cc-stripe","fa-bell-slash":"fa-bell-slash","faBellSlash":"fa-bell-slash","fa-bell-slash-o":"fa-bell-slash-o","faBellSlashO":"fa-bell-slash-o","fa-trash":"fa-trash","faTrash":"fa-trash","fa-copyright":"fa-copyright","faCopyright":"fa-copyright","fa-at":"fa-at","faAt":"fa-at","fa-eyedropper":"fa-eyedropper","faEyedropper":"fa-eyedropper","fa-paint-brush":"fa-paint-brush","faPaintBrush":"fa-paint-brush","fa-birthday-cake":"fa-birthday-cake","faBirthdayCake":"fa-birthday-cake","fa-area-chart":"fa-area-chart","faAreaChart":"fa-area-chart","fa-pie-chart":"fa-pie-chart","faPieChart":"fa-pie-chart","fa-line-chart":"fa-line-chart","faLineChart":"fa-line-chart","fa-lastfm":"fa-lastfm","faLastfm":"fa-lastfm","fa-lastfm-square":"fa-lastfm-square","faLastfmSquare":"fa-lastfm-square","fa-toggle-off":"fa-toggle-off","faToggleOff":"fa-toggle-off","fa-toggle-on":"fa-toggle-on","faToggleOn":"fa-toggle-on","fa-bicycle":"fa-bicycle","faBicycle":"fa-bicycle","fa-bus":"fa-bus","faBus":"fa-bus","fa-ioxhost":"fa-ioxhost","faIoxhost":"fa-ioxhost","fa-angellist":"fa-angellist","faAngellist":"fa-angellist","fa-cc":"fa-cc","faCc":"fa-cc","fa-shekel":"fa-shekel","faShekel":"fa-shekel","fa-sheqel":"fa-sheqel","faSheqel":"fa-sheqel","fa-ils":"fa-ils","faIls":"fa-ils","fa-meanpath":"fa-meanpath","faMeanpath":"fa-meanpath","fa-buysellads":"fa-buysellads","faBuysellads":"fa-buysellads","fa-connectdevelop":"fa-connectdevelop","faConnectdevelop":"fa-connectdevelop","fa-dashcube":"fa-dashcube","faDashcube":"fa-dashcube","fa-forumbee":"fa-forumbee","faForumbee":"fa-forumbee","fa-leanpub":"fa-leanpub","faLeanpub":"fa-leanpub","fa-sellsy":"fa-sellsy","faSellsy":"fa-sellsy","fa-shirtsinbulk":"fa-shirtsinbulk","faShirtsinbulk":"fa-shirtsinbulk","fa-simplybuilt":"fa-simplybuilt","faSimplybuilt":"fa-simplybuilt","fa-skyatlas":"fa-skyatlas","faSkyatlas":"fa-skyatlas","fa-cart-plus":"fa-cart-plus","faCartPlus":"fa-cart-plus","fa-cart-arrow-down":"fa-cart-arrow-down","faCartArrowDown":"fa-cart-arrow-down","fa-diamond":"fa-diamond","faDiamond":"fa-diamond","fa-ship":"fa-ship","faShip":"fa-ship","fa-user-secret":"fa-user-secret","faUserSecret":"fa-user-secret","fa-motorcycle":"fa-motorcycle","faMotorcycle":"fa-motorcycle","fa-street-view":"fa-street-view","faStreetView":"fa-street-view","fa-heartbeat":"fa-heartbeat","faHeartbeat":"fa-heartbeat","fa-venus":"fa-venus","faVenus":"fa-venus","fa-mars":"fa-mars","faMars":"fa-mars","fa-mercury":"fa-mercury","faMercury":"fa-mercury","fa-intersex":"fa-intersex","faIntersex":"fa-intersex","fa-transgender":"fa-transgender","faTransgender":"fa-transgender","fa-transgender-alt":"fa-transgender-alt","faTransgenderAlt":"fa-transgender-alt","fa-venus-double":"fa-venus-double","faVenusDouble":"fa-venus-double","fa-mars-double":"fa-mars-double","faMarsDouble":"fa-mars-double","fa-venus-mars":"fa-venus-mars","faVenusMars":"fa-venus-mars","fa-mars-stroke":"fa-mars-stroke","faMarsStroke":"fa-mars-stroke","fa-mars-stroke-v":"fa-mars-stroke-v","faMarsStrokeV":"fa-mars-stroke-v","fa-mars-stroke-h":"fa-mars-stroke-h","faMarsStrokeH":"fa-mars-stroke-h","fa-neuter":"fa-neuter","faNeuter":"fa-neuter","fa-genderless":"fa-genderless","faGenderless":"fa-genderless","fa-facebook-official":"fa-facebook-official","faFacebookOfficial":"fa-facebook-official","fa-pinterest-p":"fa-pinterest-p","faPinterestP":"fa-pinterest-p","fa-whatsapp":"fa-whatsapp","faWhatsapp":"fa-whatsapp","fa-server":"fa-server","faServer":"fa-server","fa-user-plus":"fa-user-plus","faUserPlus":"fa-user-plus","fa-user-times":"fa-user-times","faUserTimes":"fa-user-times","fa-hotel":"fa-hotel","faHotel":"fa-hotel","fa-bed":"fa-bed","faBed":"fa-bed","fa-viacoin":"fa-viacoin","faViacoin":"fa-viacoin","fa-train":"fa-train","faTrain":"fa-train","fa-subway":"fa-subway","faSubway":"fa-subway","fa-medium":"fa-medium","faMedium":"fa-medium","fa-yc":"fa-yc","faYc":"fa-yc","fa-y-combinator":"fa-y-combinator","faYCombinator":"fa-y-combinator","fa-optin-monster":"fa-optin-monster","faOptinMonster":"fa-optin-monster","fa-opencart":"fa-opencart","faOpencart":"fa-opencart","fa-expeditedssl":"fa-expeditedssl","faExpeditedssl":"fa-expeditedssl","fa-battery-4":"fa-battery-4","faBattery4":"fa-battery-4","fa-battery":"fa-battery","faBattery":"fa-battery","fa-battery-full":"fa-battery-full","faBatteryFull":"fa-battery-full","fa-battery-3":"fa-battery-3","faBattery3":"fa-battery-3","fa-battery-three-quarters":"fa-battery-three-quarters","faBatteryThreeQuarters":"fa-battery-three-quarters","fa-battery-2":"fa-battery-2","faBattery2":"fa-battery-2","fa-battery-half":"fa-battery-half","faBatteryHalf":"fa-battery-half","fa-battery-1":"fa-battery-1","faBattery1":"fa-battery-1","fa-battery-quarter":"fa-battery-quarter","faBatteryQuarter":"fa-battery-quarter","fa-battery-0":"fa-battery-0","faBattery0":"fa-battery-0","fa-battery-empty":"fa-battery-empty","faBatteryEmpty":"fa-battery-empty","fa-mouse-pointer":"fa-mouse-pointer","faMousePointer":"fa-mouse-pointer","fa-i-cursor":"fa-i-cursor","faICursor":"fa-i-cursor","fa-object-group":"fa-object-group","faObjectGroup":"fa-object-group","fa-object-ungroup":"fa-object-ungroup","faObjectUngroup":"fa-object-ungroup","fa-sticky-note":"fa-sticky-note","faStickyNote":"fa-sticky-note","fa-sticky-note-o":"fa-sticky-note-o","faStickyNoteO":"fa-sticky-note-o","fa-cc-jcb":"fa-cc-jcb","faCcJcb":"fa-cc-jcb","fa-cc-diners-club":"fa-cc-diners-club","faCcDinersClub":"fa-cc-diners-club","fa-clone":"fa-clone","faClone":"fa-clone","fa-balance-scale":"fa-balance-scale","faBalanceScale":"fa-balance-scale","fa-hourglass-o":"fa-hourglass-o","faHourglassO":"fa-hourglass-o","fa-hourglass-1":"fa-hourglass-1","faHourglass1":"fa-hourglass-1","fa-hourglass-start":"fa-hourglass-start","faHourglassStart":"fa-hourglass-start","fa-hourglass-2":"fa-hourglass-2","faHourglass2":"fa-hourglass-2","fa-hourglass-half":"fa-hourglass-half","faHourglassHalf":"fa-hourglass-half","fa-hourglass-3":"fa-hourglass-3","faHourglass3":"fa-hourglass-3","fa-hourglass-end":"fa-hourglass-end","faHourglassEnd":"fa-hourglass-end","fa-hourglass":"fa-hourglass","faHourglass":"fa-hourglass","fa-hand-grab-o":"fa-hand-grab-o","faHandGrabO":"fa-hand-grab-o","fa-hand-rock-o":"fa-hand-rock-o","faHandRockO":"fa-hand-rock-o","fa-hand-stop-o":"fa-hand-stop-o","faHandStopO":"fa-hand-stop-o","fa-hand-paper-o":"fa-hand-paper-o","faHandPaperO":"fa-hand-paper-o","fa-hand-scissors-o":"fa-hand-scissors-o","faHandScissorsO":"fa-hand-scissors-o","fa-hand-lizard-o":"fa-hand-lizard-o","faHandLizardO":"fa-hand-lizard-o","fa-hand-spock-o":"fa-hand-spock-o","faHandSpockO":"fa-hand-spock-o","fa-hand-pointer-o":"fa-hand-pointer-o","faHandPointerO":"fa-hand-pointer-o","fa-hand-peace-o":"fa-hand-peace-o","faHandPeaceO":"fa-hand-peace-o","fa-trademark":"fa-trademark","faTrademark":"fa-trademark","fa-registered":"fa-registered","faRegistered":"fa-registered","fa-creative-commons":"fa-creative-commons","faCreativeCommons":"fa-creative-commons","fa-gg":"fa-gg","faGg":"fa-gg","fa-gg-circle":"fa-gg-circle","faGgCircle":"fa-gg-circle","fa-tripadvisor":"fa-tripadvisor","faTripadvisor":"fa-tripadvisor","fa-odnoklassniki":"fa-odnoklassniki","faOdnoklassniki":"fa-odnoklassniki","fa-odnoklassniki-square":"fa-odnoklassniki-square","faOdnoklassnikiSquare":"fa-odnoklassniki-square","fa-get-pocket":"fa-get-pocket","faGetPocket":"fa-get-pocket","fa-wikipedia-w":"fa-wikipedia-w","faWikipediaW":"fa-wikipedia-w","fa-safari":"fa-safari","faSafari":"fa-safari","fa-chrome":"fa-chrome","faChrome":"fa-chrome","fa-firefox":"fa-firefox","faFirefox":"fa-firefox","fa-opera":"fa-opera","faOpera":"fa-opera","fa-internet-explorer":"fa-internet-explorer","faInternetExplorer":"fa-internet-explorer","fa-tv":"fa-tv","faTv":"fa-tv","fa-television":"fa-television","faTelevision":"fa-television","fa-contao":"fa-contao","faContao":"fa-contao","fa-500px":"fa-500px","fa500Px":"fa-500px","fa-amazon":"fa-amazon","faAmazon":"fa-amazon","fa-calendar-plus-o":"fa-calendar-plus-o","faCalendarPlusO":"fa-calendar-plus-o","fa-calendar-minus-o":"fa-calendar-minus-o","faCalendarMinusO":"fa-calendar-minus-o","fa-calendar-times-o":"fa-calendar-times-o","faCalendarTimesO":"fa-calendar-times-o","fa-calendar-check-o":"fa-calendar-check-o","faCalendarCheckO":"fa-calendar-check-o","fa-industry":"fa-industry","faIndustry":"fa-industry","fa-map-pin":"fa-map-pin","faMapPin":"fa-map-pin","fa-map-signs":"fa-map-signs","faMapSigns":"fa-map-signs","fa-map-o":"fa-map-o","faMapO":"fa-map-o","fa-map":"fa-map","faMap":"fa-map","fa-commenting":"fa-commenting","faCommenting":"fa-commenting","fa-commenting-o":"fa-commenting-o","faCommentingO":"fa-commenting-o","fa-houzz":"fa-houzz","faHouzz":"fa-houzz","fa-vimeo":"fa-vimeo","faVimeo":"fa-vimeo","fa-black-tie":"fa-black-tie","faBlackTie":"fa-black-tie","fa-fonticons":"fa-fonticons","faFonticons":"fa-fonticons","fa-reddit-alien":"fa-reddit-alien","faRedditAlien":"fa-reddit-alien","fa-edge":"fa-edge","faEdge":"fa-edge","fa-credit-card-alt":"fa-credit-card-alt","faCreditCardAlt":"fa-credit-card-alt","fa-codiepie":"fa-codiepie","faCodiepie":"fa-codiepie","fa-modx":"fa-modx","faModx":"fa-modx","fa-fort-awesome":"fa-fort-awesome","faFortAwesome":"fa-fort-awesome","fa-usb":"fa-usb","faUsb":"fa-usb","fa-product-hunt":"fa-product-hunt","faProductHunt":"fa-product-hunt","fa-mixcloud":"fa-mixcloud","faMixcloud":"fa-mixcloud","fa-scribd":"fa-scribd","faScribd":"fa-scribd","fa-pause-circle":"fa-pause-circle","faPauseCircle":"fa-pause-circle","fa-pause-circle-o":"fa-pause-circle-o","faPauseCircleO":"fa-pause-circle-o","fa-stop-circle":"fa-stop-circle","faStopCircle":"fa-stop-circle","fa-stop-circle-o":"fa-stop-circle-o","faStopCircleO":"fa-stop-circle-o","fa-shopping-bag":"fa-shopping-bag","faShoppingBag":"fa-shopping-bag","fa-shopping-basket":"fa-shopping-basket","faShoppingBasket":"fa-shopping-basket","fa-hashtag":"fa-hashtag","faHashtag":"fa-hashtag","fa-bluetooth":"fa-bluetooth","faBluetooth":"fa-bluetooth","fa-bluetooth-b":"fa-bluetooth-b","faBluetoothB":"fa-bluetooth-b","fa-percent":"fa-percent","faPercent":"fa-percent","fa-gitlab":"fa-gitlab","faGitlab":"fa-gitlab","fa-wpbeginner":"fa-wpbeginner","faWpbeginner":"fa-wpbeginner","fa-wpforms":"fa-wpforms","faWpforms":"fa-wpforms","fa-envira":"fa-envira","faEnvira":"fa-envira","fa-universal-access":"fa-universal-access","faUniversalAccess":"fa-universal-access","fa-wheelchair-alt":"fa-wheelchair-alt","faWheelchairAlt":"fa-wheelchair-alt","fa-question-circle-o":"fa-question-circle-o","faQuestionCircleO":"fa-question-circle-o","fa-blind":"fa-blind","faBlind":"fa-blind","fa-audio-description":"fa-audio-description","faAudioDescription":"fa-audio-description","fa-volume-control-phone":"fa-volume-control-phone","faVolumeControlPhone":"fa-volume-control-phone","fa-braille":"fa-braille","faBraille":"fa-braille","fa-assistive-listening-systems":"fa-assistive-listening-systems","faAssistiveListeningSystems":"fa-assistive-listening-systems","fa-asl-interpreting":"fa-asl-interpreting","faAslInterpreting":"fa-asl-interpreting","fa-american-sign-language-interpreting":"fa-american-sign-language-interpreting","faAmericanSignLanguageInterpreting":"fa-american-sign-language-interpreting","fa-deafness":"fa-deafness","faDeafness":"fa-deafness","fa-hard-of-hearing":"fa-hard-of-hearing","faHardOfHearing":"fa-hard-of-hearing","fa-deaf":"fa-deaf","faDeaf":"fa-deaf","fa-glide":"fa-glide","faGlide":"fa-glide","fa-glide-g":"fa-glide-g","faGlideG":"fa-glide-g","fa-signing":"fa-signing","faSigning":"fa-signing","fa-sign-language":"fa-sign-language","faSignLanguage":"fa-sign-language","fa-low-vision":"fa-low-vision","faLowVision":"fa-low-vision","fa-viadeo":"fa-viadeo","faViadeo":"fa-viadeo","fa-viadeo-square":"fa-viadeo-square","faViadeoSquare":"fa-viadeo-square","fa-snapchat":"fa-snapchat","faSnapchat":"fa-snapchat","fa-snapchat-ghost":"fa-snapchat-ghost","faSnapchatGhost":"fa-snapchat-ghost","fa-snapchat-square":"fa-snapchat-square","faSnapchatSquare":"fa-snapchat-square","fa-pied-piper":"fa-pied-piper","faPiedPiper":"fa-pied-piper","fa-first-order":"fa-first-order","faFirstOrder":"fa-first-order","fa-yoast":"fa-yoast","faYoast":"fa-yoast","fa-themeisle":"fa-themeisle","faThemeisle":"fa-themeisle","fa-google-plus-circle":"fa-google-plus-circle","faGooglePlusCircle":"fa-google-plus-circle","fa-google-plus-official":"fa-google-plus-official","faGooglePlusOfficial":"fa-google-plus-official","fa-fa":"fa-fa","faFa":"fa-fa","fa-font-awesome":"fa-font-awesome","faFontAwesome":"fa-font-awesome","fa-handshake-o":"fa-handshake-o","faHandshakeO":"fa-handshake-o","fa-envelope-open":"fa-envelope-open","faEnvelopeOpen":"fa-envelope-open","fa-envelope-open-o":"fa-envelope-open-o","faEnvelopeOpenO":"fa-envelope-open-o","fa-linode":"fa-linode","faLinode":"fa-linode","fa-address-book":"fa-address-book","faAddressBook":"fa-address-book","fa-address-book-o":"fa-address-book-o","faAddressBookO":"fa-address-book-o","fa-vcard":"fa-vcard","faVcard":"fa-vcard","fa-address-card":"fa-address-card","faAddressCard":"fa-address-card","fa-vcard-o":"fa-vcard-o","faVcardO":"fa-vcard-o","fa-address-card-o":"fa-address-card-o","faAddressCardO":"fa-address-card-o","fa-user-circle":"fa-user-circle","faUserCircle":"fa-user-circle","fa-user-circle-o":"fa-user-circle-o","faUserCircleO":"fa-user-circle-o","fa-user-o":"fa-user-o","faUserO":"fa-user-o","fa-id-badge":"fa-id-badge","faIdBadge":"fa-id-badge","fa-drivers-license":"fa-drivers-license","faDriversLicense":"fa-drivers-license","fa-id-card":"fa-id-card","faIdCard":"fa-id-card","fa-drivers-license-o":"fa-drivers-license-o","faDriversLicenseO":"fa-drivers-license-o","fa-id-card-o":"fa-id-card-o","faIdCardO":"fa-id-card-o","fa-quora":"fa-quora","faQuora":"fa-quora","fa-free-code-camp":"fa-free-code-camp","faFreeCodeCamp":"fa-free-code-camp","fa-telegram":"fa-telegram","faTelegram":"fa-telegram","fa-thermometer-4":"fa-thermometer-4","faThermometer4":"fa-thermometer-4","fa-thermometer":"fa-thermometer","faThermometer":"fa-thermometer","fa-thermometer-full":"fa-thermometer-full","faThermometerFull":"fa-thermometer-full","fa-thermometer-3":"fa-thermometer-3","faThermometer3":"fa-thermometer-3","fa-thermometer-three-quarters":"fa-thermometer-three-quarters","faThermometerThreeQuarters":"fa-thermometer-three-quarters","fa-thermometer-2":"fa-thermometer-2","faThermometer2":"fa-thermometer-2","fa-thermometer-half":"fa-thermometer-half","faThermometerHalf":"fa-thermometer-half","fa-thermometer-1":"fa-thermometer-1","faThermometer1":"fa-thermometer-1","fa-thermometer-quarter":"fa-thermometer-quarter","faThermometerQuarter":"fa-thermometer-quarter","fa-thermometer-0":"fa-thermometer-0","faThermometer0":"fa-thermometer-0","fa-thermometer-empty":"fa-thermometer-empty","faThermometerEmpty":"fa-thermometer-empty","fa-shower":"fa-shower","faShower":"fa-shower","fa-bathtub":"fa-bathtub","faBathtub":"fa-bathtub","fa-s15":"fa-s15","faS15":"fa-s15","fa-bath":"fa-bath","faBath":"fa-bath","fa-podcast":"fa-podcast","faPodcast":"fa-podcast","fa-window-maximize":"fa-window-maximize","faWindowMaximize":"fa-window-maximize","fa-window-minimize":"fa-window-minimize","faWindowMinimize":"fa-window-minimize","fa-window-restore":"fa-window-restore","faWindowRestore":"fa-window-restore","fa-times-rectangle":"fa-times-rectangle","faTimesRectangle":"fa-times-rectangle","fa-window-close":"fa-window-close","faWindowClose":"fa-window-close","fa-times-rectangle-o":"fa-times-rectangle-o","faTimesRectangleO":"fa-times-rectangle-o","fa-window-close-o":"fa-window-close-o","faWindowCloseO":"fa-window-close-o","fa-bandcamp":"fa-bandcamp","faBandcamp":"fa-bandcamp","fa-grav":"fa-grav","faGrav":"fa-grav","fa-etsy":"fa-etsy","faEtsy":"fa-etsy","fa-imdb":"fa-imdb","faImdb":"fa-imdb","fa-ravelry":"fa-ravelry","faRavelry":"fa-ravelry","fa-eercast":"fa-eercast","faEercast":"fa-eercast","fa-microchip":"fa-microchip","faMicrochip":"fa-microchip","fa-snowflake-o":"fa-snowflake-o","faSnowflakeO":"fa-snowflake-o","fa-superpowers":"fa-superpowers","faSuperpowers":"fa-superpowers","fa-wpexplorer":"fa-wpexplorer","faWpexplorer":"fa-wpexplorer","fa-meetup":"fa-meetup","faMeetup":"fa-meetup","sr-only":"sr-only","srOnly":"sr-only","sr-only-focusable":"sr-only-focusable","srOnlyFocusable":"sr-only-focusable"};

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"btn":"btn","btn--small":"btn--small","btnSmall":"btn--small","btn--primary":"btn--primary","btnPrimary":"btn--primary","btn--loading":"btn--loading","btnLoading":"btn--loading","buttons--loading":"buttons--loading","buttonsLoading":"buttons--loading","btn--secondary":"btn--secondary","btnSecondary":"btn--secondary","btn--negative":"btn--negative","btnNegative":"btn--negative","btn--link":"btn--link","btnLink":"btn--link","btn--tag":"btn--tag","btnTag":"btn--tag","btn--selected":"btn--selected","btnSelected":"btn--selected"};

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-group":"form-group","formGroup":"form-group","form-control":"form-control","formControl":"form-control","form-control--success":"form-control--success","formControlSuccess":"form-control--success","form-control--error":"form-control--error","formControlError":"form-control--error"};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.9c182c76.js